/**
 * @author son
 * created on 10.25.2019
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages', [
    'BlurAdmin.pages.home',
    'BlurAdmin.pages.checkreport',
    'BlurAdmin.pages.news',
    'BlurAdmin.pages.manual',
    'BlurAdmin.pages.password',
    'BlurAdmin.pages.user',
    'BlurAdmin.pages.checktarget',
    'BlurAdmin.pages.checklist',
    'BlurAdmin.pages.itemname',
    'BlurAdmin.pages.masterdata',
    'BlurAdmin.pages.manage',
    'BlurAdmin.pages.project',
    'BlurAdmin.pages.offline',
    'BlurAdmin.pages.back',
//    'BlurAdmin.pages.sensor',

  ])
      .config(routeConfig).directive('selectpicker', selectpicker).directive('stExportCsv', stExportCsv).directive('tableSize', tableSize)
      .directive('stExportCsvSjis', stExportCsvSjis).directive('choiceTicket', choiceTicket).directive('clickAndDisable', clickAndDisable).filter('customFilter', customFilter)
      .directive('choiceDchecksheet', choiceDchecksheet).directive('stFilteredCollection', stFilteredCollection);



  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider, stateServiceProvider) {

    var back = "auth.html";

    //-----------------トライアル-----------------

//    var schema = localStorage.schema
//    if (schema) {
//        if (schema != 'smartbee') {
//          back = "auth.html?key=" + localStorage.key1;
//          }
//      }

    //-----------------トライアル-----------------

      if (localStorage.token == null || localStorage.token=="") {
            window.location = back;
            return;
        }
        $.ajax({
            url : urlPrefix + "auth/token",
            type : "GET",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
                "schema" : localStorage.schema,
                "X-Client-AuthId" : localStorage.token,
                "timeout-min" : localStorage.timeoutMin
            },
            async : false,
            contentType : "application/json",
            success : function(data) {
                if (data.resultCd != "000000") {
                  window.location = back;
                  return;
                }
            },
            error : function(e) {
                //self.setError("", "サーバへの通信することができませんでした。");
            }
        });

    $urlRouterProvider.otherwise('/home');
  }


  /** @ngInject */
function selectpicker() {
  return {
    restrict: 'A',
    require: '?ngOptions',
    priority: 1500, // make priority bigger than ngOptions and ngRepeat
    link: {
      pre: function(scope, elem, attrs) {
        elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
      },
      post: function(scope, elem, attrs) {
        function refresh() {
          elem.selectpicker('refresh');
        }

        if (attrs.ngModel) {
          scope.$watch(attrs.ngModel, refresh);
        }

        if (attrs.ngDisabled) {
          scope.$watch(attrs.ngDisabled, refresh);
        }

        elem.selectpicker({ dropupAuto: false, hideDisabled: true });
      }
    }
  };
}

function customFilter($filter) {
    var filterFilter = $filter('filter');
    var standardComparator = function standardComparator(obj, text) {
      text = ('' + text).toLowerCase();
      return ('' + obj).toLowerCase().indexOf(text) > -1;
    };

    return function customFilter(array, expression) {
        function customComparator(actual, expected) {
          var str = ''+ expected;
          if (str.indexOf('|') > -1) {
              var excArray = str.split("|", -1);
              for (var i = 0; i < excArray.length; i++) {
                  if (excArray[i] == '') {
                      continue;
                  }
                  if (standardComparator(actual, excArray[i])) {
                      return true;
                  }
              }

          }

          return standardComparator(actual, expected);
        }

        var output = filterFilter(array, expression, customComparator);
        return output;
      };

}

function stExportCsv($window) {
    return {
        require : '^stTable',
        link : function(scope, element, attr, ctrl) {
            element.bind('click',function() {
                var start = new Date().getTime();
                                // データを用意する
                                var bom = new Uint8Array(
                                        [ 0xEF, 0xBB, 0xBF ]);
                                var content = new Array();
                                for (var i = 0; i < scope.csvTitle.length; i++) {
                                    content.push(scope.csvTitle[i]);
                                    content.push(",");
                                }
                                content.pop();
                                content.push("\n");

                                for (var i = 0; i < ctrl.getFilteredCollection().length; i++) {
                                    for (var j = 0; j < scope.csvColumn.length; j++) {
                                        content.push(ctrl.getFilteredCollection()[i][scope.csvColumn[j]]);
                                        content.push(",");
                                    }
                                    content.pop();
                                    content.push("\n");
                                }

                                var blob = new Blob([ bom, content.join('') ], {
                                    "type" : "text/csv"
                                });
                                var fileName = scope.csvFileName;
                                // 出力
                                if ($window.navigator.msSaveBlob) {
                                    // if browser is IE
                                    $window.navigator.msSaveBlob(blob,
                                            fileName);
                                } else {
                                    this.download=fileName;
                                    this.href = $window.URL
                                            .createObjectURL(blob);
                                }
                            })
        }
    };
}

function stExportCsvSjis($window) {
    return {
        require : '^stTable',
        link : function(scope, element, attr, ctrl) {
            element.bind('click',function() {
                var start = new Date().getTime();
                                // データを用意する
//                                var bom = new Uint8Array(
//                                        [ 0xEF, 0xBB, 0xBF ]);
                                var content = new Array();
                                for (var i = 0; i < scope.csvTitle.length; i++) {
                                    content.push(scope.csvTitle[i]);
                                    content.push(",");
                                }
                                content.pop();
                                content.push("\n");

                                for (var i = 0; i < ctrl.getFilteredCollection().length; i++) {
                                    for (var j = 0; j < scope.csvTitle.length; j++) {
                                        content.push(ctrl.getFilteredCollection()[i][scope.csvColumn[j]]);
                                        content.push(",");
                                    }

                                    content.pop();
                                    content.push("\n");
                                }

                                var contentStr = content.join('');
                                var str_array = Encoding.stringToCode(contentStr);
                                var sjis_array = Encoding.convert(str_array, "SJIS", "UNICODE");
                                var uint8_array = new Uint8Array(sjis_array);

                                var blob = new Blob([uint8_array], {
                                    "type" : "text/csv"
                                });
                                var fileName = scope.csvFileName;
                                // 出力
                                if ($window.navigator.msSaveBlob) {
                                    // if browser is IE
                                    $window.navigator.msSaveBlob(blob,
                                            fileName);
                                } else {
                                    this.download=fileName;
                                    this.href = $window.URL
                                            .createObjectURL(blob);
                                }
                            })
        }
    };
}


function choiceTicket() {
    return {
        require : '^stTable',
        link : function(scope, element, attr, ctrl) {
            element.bind('click',function() {
            	var ticketList = ctrl.pipe();
	          	  if (scope.allChoice == true) {
	          		  for (var i=0;i<ticketList.length;i++) {
	          			  scope.ticketChoice[ticketList[i].id] = true;
	          		  }
	          	  } else {
	          		for (var i=0;i<ticketList.length;i++) {
	          			  scope.ticketChoice[ticketList[i].id] = false;
	          		  }
	          	  }
	              scope.$apply();
            })
        }
    };
}

function choiceDchecksheet() {
    return {
        require : '^stTable',
        link : function(scope, element, attr, ctrl) {
            element.bind('click',function() {
            	var checksheetList = ctrl.pipe();
	          	  if (scope.allChoice == true) {
	          		  for (var i=0;i<checksheetList.length;i++) {
	          			  scope.checksheetChoice[checksheetList[i].checksheetId] = true;
	          		  }
	          	  } else {
	          		for (var i=0;i<checksheetList.length;i++) {
	          			  scope.checksheetChoice[checksheetList[i].checksheetId] = false;
	          		  }
	          	  }
	              scope.$apply();
            })
        }
    };
}


function tableSize() {
	return {
	      restrict: 'E',
	      require: '^stTable',
	      template: '{{size}}',
	      scope: {},
	      link: function (scope, element, attr, ctrl) {
	        scope.$watch(ctrl.getFilteredCollection, function  (val) {
	        scope.size = (val || []).length;
	      })
	     }
	    }
}

function clickAndDisable() {
    return {
    	scope: {
	      clickAndDisable: '&'
	    },
      link: function(scope, iElement, iAttrs) {
        iElement.bind('click', function() {
          iElement.prop('disabled',true);
          var rs = scope.clickAndDisable()
          if (rs) {
        	  iElement.prop('disabled',false);
          }
        });
      }
    };
}

function stFilteredCollection() {
	return {
	      restrict: 'A',
	      require: '^stTable',
	      scope: {
	        stFilteredCollection: '='
	      },
	      controller: 'stTableController',
	      link: function (scope, element, attr, ctrl) {
	        scope.$watch(function () {
	          return ctrl.getFilteredCollection();
	        }, function (newValue, oldValue) {
	          scope.stFilteredCollection = ctrl.getFilteredCollection();
	        });
	      }
	    };
}




})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var app = angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'angularSpectrumColorpicker',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs',
      'ui.select'
  ]);

  app.config(function($provide){
        $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function(taRegisterTool, taOptions){
            // $delegate is the taOptions we are decorating
            // register the tool with textAngular
            taRegisterTool('fontColor', {
                display:"<spectrum-colorpicker trigger-id='{{trigger}}' ng-model='color' on-change='!!color && action(color)' format='\"hex\"' options='options'></spectrum-colorpicker>",
                action: function (color) {
                    var me = this;
                    if (!this.$editor().wrapSelection) {
                        setTimeout(function () {
                            me.action(color);
                        }, 100)
                    } else {
                        return this.$editor().wrapSelection('foreColor', color);
                    }
                },
                options: {
                    showInput: true,
                    showPalette : true,
//                    showPaletteOnly: true,
                    togglePaletteOnly: true,
//                    togglePaletteMoreText: 'more',
//                    togglePaletteLessText: 'less',
                    palette: [
                        ["#000","#444","#666","#999","#ccc","#eee","#f3f3f3","#fff"],
                        ["#f00","#f90","#ff0","#0f0","#0ff","#00f","#90f","#f0f"],
                        ["#f4cccc","#fce5cd","#fff2cc","#d9ead3","#d0e0e3","#cfe2f3","#d9d2e9","#ead1dc"],
                        ["#ea9999","#f9cb9c","#ffe599","#b6d7a8","#a2c4c9","#9fc5e8","#b4a7d6","#d5a6bd"],
                        ["#e06666","#f6b26b","#ffd966","#93c47d","#76a5af","#6fa8dc","#8e7cc3","#c27ba0"],
                        ["#c00","#e69138","#f1c232","#6aa84f","#45818e","#3d85c6","#674ea7","#a64d79"],
                        ["#900","#b45f06","#bf9000","#38761d","#134f5c","#0b5394","#351c75","#741b47"],
                        ["#600","#783f04","#7f6000","#274e13","#0c343d","#073763","#20124d","#4c1130"]
                    ]
                },
                color: "#000"
            });

            // add the button to the default toolbar definition
            taOptions.toolbar[1].push('fontColor');
            return taOptions;
        }]);
    });

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.back', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

    if(! window.localStorage.hasProjects) {
      return;
    }

      $stateProvider
      .state('back', {
        url: '/project',
        title: '業務一覧',
        sidebarMeta: {
            icon: 'keyboard_backspace',
            order: 165,
          },
      });
  }

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.checklist', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

	var ua = navigator.userAgent.toLowerCase();
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    if (isMobile) {
    	if (ua.indexOf('mobile') == -1 || ua.indexOf('ipad') > 0){
    		if (window.localStorage.tabletMode == '1') {
    			isMobile = false;
    		}
    	}
    }
    if(isMobile) {
      return;
    }

//    if(localStorage.mngKbn == "0" || localStorage.mngKbn == "1") {
//      return;
//    }
      $stateProvider
      .state('checklist', {
        url: '/checklist',
        templateUrl: 'app/pages/checklist/checklist.html',
        title: 'チェック項目の設定',
        controller: 'ChecklistCtrl',
        sidebarMeta: {
            icon: 'check',
            order: 43,
          },
      });
  }

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.checkreport', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
      $stateProvider
      .state('checkreport', {
        url: '/checkreport',
        templateUrl: 'app/pages/checkreport/checkreport.html',
        title: 'チェックシート',
        controller: 'CheckreportListCtrl',
        sidebarMeta: {
            icon: 'assignment',
            order: 44,
          },
      });

      var url = window.location.href;
      var u = url.split("#")[1];
      if (u != null) {
        if (u.indexOf('/showReportDetail') == 0) {
          $stateProvider
            .state('showReportDetail', {
              url: '/showReportDetail',
              templateUrl: 'app/pages/checkreport/checkreportInfo.html',
              controller: 'CheckreportCtrl',
            });

          $stateProvider
          .state('showReportDetailSp', {
            url: '/showReportDetailSp',
            templateUrl: 'app/pages/checkreport/sp/checkreportSp.html',
            controller: 'CheckreportSpCtrl',
          });
        }
      }

  }


})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.checktarget', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

		var ua = navigator.userAgent.toLowerCase();
      var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
      if (isMobile) {
      	if (ua.indexOf('mobile') == -1 || ua.indexOf('ipad') > 0 ){
      		if (window.localStorage.tabletMode == '1') {
      			isMobile = false;
      		}
      	}
      }
      if(isMobile) {
        return;
      }

//      if(localStorage.mngKbn == "0" || localStorage.mngKbn == "1") {
//        return;
//      }

      $stateProvider
      .state('checktarget', {
        url: '/checktarget',
        templateUrl: 'app/pages/checktarget/checktarget.html',
        title: '対象工事',
        controller: 'ChecktargetCtrl',
        sidebarMeta: {
            icon: 'apartment',
            order: 41,
          },
      });
  }

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
//        if (localStorage.mngKbn == '3') {
//
//        }

      $stateProvider
      .state('home', {
        url: '/home',
        templateUrl: 'app/pages/home/home.html',
        title: 'トップページ',
        controller: 'HomeCtrl',
        sidebarMeta: {
            icon: 'home',
            order: 40,
          },
      });

  }

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.itemname', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

		var ua = navigator.userAgent.toLowerCase();
      var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
      if (isMobile) {
      	if (ua.indexOf('mobile') == -1 || ua.indexOf('ipad') > 0 ){
      		if (window.localStorage.tabletMode == '1') {
      			isMobile = false;
      		}
      	}
      }
      if(isMobile) {
        return;
      }

      if(localStorage.mngKbn == "0" || localStorage.mngKbn == "1") {
        return;
      }

/* 3.3.6から、不要になる
      $stateProvider
      .state('itemname', {
        url: '/itemname',
        templateUrl: 'app/pages/itemname/itemname.html',
        title: '画面項目',
        controller: 'ItemnameCtrl',
        sidebarMeta: {
            icon: 'desktop_windows',
            order: 60,
          },
      });
*/
  }

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.manage', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

		var ua = navigator.userAgent.toLowerCase();
      var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
      if (isMobile) {
      	if (ua.indexOf('mobile') == -1 || ua.indexOf('ipad') > 0 ){
      		if (window.localStorage.tabletMode == '1') {
      			isMobile = false;
      		}
      	}
      }
      if(isMobile) {
        return;
      }

      if(localStorage.mngKbn == "0" || localStorage.mngKbn == "1") {
        return;
      }

      $stateProvider
      .state('manage', {
        url: '/manage',
        templateUrl: 'app/pages/manage/manage.html',
        title: 'システム設定',
        controller: 'ManageCtrl',
        sidebarMeta: {
            icon: 'settings_applications',
            order: 62,
          },
      });
  }

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.manual', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
      $stateProvider
      .state('manual', {
        url: '/manual',
        templateUrl: 'app/pages/manual/manual.html',
        title: '共有データ',
//        oldTitle: '(旧:ドキュメント)',
        controller: 'ManualCtrl',
        sidebarMeta: {
            icon: 'description',
            order: 45,
          },
      });
  }

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.news', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
      $stateProvider
      .state('news', {
        url: '/news',
        templateUrl: 'app/pages/news/news.html',
        title: 'お知らせ',
        controller: 'NewsCtrl',
        sidebarMeta: {
            icon: 'announcement',
            order: 46,
          },
      });
  }

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.masterdata', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

		var ua = navigator.userAgent.toLowerCase();
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    if (isMobile) {
    	if (ua.indexOf('mobile') == -1 || ua.indexOf('ipad')  > 0){
    		if (window.localStorage.tabletMode == '1') {
    			isMobile = false;
    		}
    	}
    }
    if(isMobile) {
      return;
    }

//    if(localStorage.mngKbn == "0" || localStorage.mngKbn == "1") {
//      return;
//    }

      $stateProvider
      .state('masterdata', {
        url: '/masterdata',
        templateUrl: 'app/pages/masterdata/masterdata.html',
        title: 'マスタデータ',
        controller: 'MasterdataCtrl',
        sidebarMeta: {
            icon: 'storage',
            order: 42,
          },
      });
  }

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.offline', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

      $stateProvider
      .state('offline', {
        url: '/offline',
        title: 'ダウンロード',
        oldTitle: 'チェックシート',
        templateUrl: 'app/pages/offline/offline.html',
        controller: 'OfflineCtrl',
        sidebarMeta: {
            icon: 'system_update',
            order: 44,
          },
      });
  }

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.password', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
      $stateProvider
      .state('password', {
        url: '/password',
        templateUrl: 'app/pages/password/password.html',
        title: 'アカウント',
        controller: 'PasswordCtrl',
        sidebarMeta: {
            icon: 'account_circle',
            order: 53,
          },
      });
  }

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.sensor', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

		var ua = navigator.userAgent.toLowerCase();
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    if (isMobile) {
    	if (ua.indexOf('mobile') == -1 || ua.indexOf('ipad')  > 0){
    		if (window.localStorage.tabletMode == '1') {
    			isMobile = false;
    		}
    	}
    }
    if(isMobile) {
      return;
    }

      $stateProvider
      .state('sensor', {
        url: '/sensor',
        title: 'センサー',
        sidebarMeta: {
            icon: 'ion-radio-waves',
            order: 165,
          },
      });
  }

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.project', [
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
//        if (localStorage.mngKbn == '3') {
//
//        }
      $stateProvider
      .state('project', {
        url: '/project',
        templateUrl: 'app/pages/project/project.html',
        title: '業務',
        controller: 'ProjectCtrl',
      });

  }

})();

/**
 * @author h.son
 * created on 01.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.user', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

		var ua = navigator.userAgent.toLowerCase();
      var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
      if (isMobile) {
      	if (ua.indexOf('mobile') == -1 || ua.indexOf('ipad')  > 0){
      		if (window.localStorage.tabletMode == '1') {
      			isMobile = false;
      		}
      	}
      }
      if(isMobile) {
        return;
      }

      if(localStorage.mngKbn == "0" || localStorage.mngKbn == "1") {
        return;
      }

      $stateProvider
      .state('user', {
        url: '/user',
        templateUrl: 'app/pages/user/user.html',
        title: '技術者一覧',
        controller: 'UserCtrl',
        sidebarMeta: {
            icon: 'perm_identity',
            order: 54,
          },
      });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

'use strict';

angular.module('BlurAdmin', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',
  'BlurAdmin.ajaxService',
  'BlurAdmin.stateService',
  'BlurAdmin.theme',
  'BlurAdmin.pages',
  'ngFileUpload',
//  'ckeditor',
  'vjs.video',
  'angular-popups',
  'myApp'
]);

//ローカル
// var urlPrefix = "http://localhost:8080/SmartBee-API/";

//トライアル
var urlPrefix = "https://test.tn-japan.kantoku-support.com/api/";

//商用
// var urlPrefix = "https://tn-japan.kantoku-support.com/api/";


angular.module('BlurAdmin.stateService', []).provider('stateService', function() {
    var states = [];
    this.setState = function(state){
        states.push(state);
    }

    this.getFirstState = function(state){
        return states[0];
    }

    this.$get = function(){
        var self = this;
        return {
           getFirstState: function(){
             return self.states[0];
           },
        }
      }
});

//--------- PopUp Message Start------------------
var openedToasts = [];
var optionsError = {
           autoDismiss: false,
           positionClass: 'toast-top-right',
           type: 'error',
           timeOut: '5000',
           extendedTimeOut: '2000',
           allowHtml: false,
           closeButton: false,
           tapToDismiss: true,
           progressBar: false,
           newestOnTop: true,
           maxOpened: 0,
           preventDuplicates: false,
           preventOpenDuplicates: false,
           title: "",
           msg: ""
         };

var optionsMessage = {
        autoDismiss: false,
        positionClass: 'toast-top-right',
        type: 'info',
        timeOut: '5000',
        extendedTimeOut: '2000',
        allowHtml: false,
        closeButton: false,
        tapToDismiss: true,
        progressBar: false,
        newestOnTop: true,
        maxOpened: 0,
        preventDuplicates: false,
        preventOpenDuplicates: false,
        title: "",
        msg: ""
      };

var optionsInfo = {
        autoDismiss: false,
        positionClass: 'toast-top-right',
        type: 'info',
        timeOut: '5000',
        extendedTimeOut: '2000',
        allowHtml: false,
        closeButton: false,
        tapToDismiss: true,
        progressBar: false,
        newestOnTop: true,
        maxOpened: 0,
        preventDuplicates: false,
        preventOpenDuplicates: false,
        title: "",
        msg: ""
      };
//--------- PopUp Message Start------------------


var projectM = new Array();
Array.prototype.remove = function(val) {
  var index = this.indexOf(val);
  if (index > -1) {
  this.splice(index, 1);
  }
  };



var content = '';

angular.module('BlurAdmin.ajaxService', []).service('ajaxService', function() {
    var self = this;
    this.result = {};

    this.setSuccess = function() {
        self.result['resultCd'] = "000000";
        self.result['resultMsg'] = "";
    };

    this.setError = function(cd, message) {
        self.result['resultCd'] = cd;
        self.result['resultMsg'] = message;
    };

    // ---------------------- token関連　Start  --------------------
    this.tokenCheck = function() {
        $.ajax({
            url : urlPrefix + "auth/token",
            type : "GET",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
                "schema" : localStorage.schema,
                "X-Client-AuthId" : localStorage.token,
                "timeout-min" : localStorage.timeoutMin
            },
            async : false,
            contentType : "application/json",
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function(e) {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        if (self.result['resultCd'] != "000000") {
            window.location = "timeout.html";
            return false;
        } else {
            return true;
        }
    };
    // ---------------------- token関連　End  --------------------

    // ---------------------- project関連　Start  --------------------
    this.searchProjectList = function(regionCode) {
        var porjectList = [];
        $.ajax({
            url : urlPrefix + "project/getList",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "regionCode" : localStorage.regionCode,
                "loginId" : localStorage.userId
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                    porjectList = data.projectList;
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        return porjectList;
    };

    this.createProject = function(name) {
      var newProjectId = "";
        $.ajax({
            url : urlPrefix + "project/create",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId,
                "regionCode" : localStorage.regionCode,
                "projectName": name
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                    newProjectId = data.newProjectId;
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        return newProjectId;
    };

    this.modifyProject = function(id, name) {
        $.ajax({
            url : urlPrefix + "project/modify",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId,
                "regionCode" : localStorage.regionCode,
                "projectId" : id,
                "projectName": name
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
    };

    this.searchUserList = function(id, showSystemUserFlg) {
        var userList = [];
        $.ajax({
            url : urlPrefix + "project/getUserList",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId,
                "mngKbn" : localStorage.realMngKbn,
                "projectId": id,
                "showSystemUserFlg" : showSystemUserFlg
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                    userList = data.userList;
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        return userList;
    };

    this.searchAddUserList = function(id) {
        var userList = [];
        $.ajax({
            url : urlPrefix + "project/getUserListForProject",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId,
                "regionCode" : localStorage.regionCode,
                "projectId": id
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                    userList = data.userList;
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        return userList;
    };

    this.addUserToProject = function(projectId, userId) {
        $.ajax({
            url : urlPrefix + "project/addUserToProject",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId,
                "projectId": projectId,
                "userId": userId
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
    };

    this.removeUserFromProject = function(projectId, userId) {
        $.ajax({
            url : urlPrefix + "project/removeUserFromProject",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId,
                "projectId": projectId,
                "userId": userId
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
    };


    this.removeProject = function(projectId) {
        $.ajax({
            url : urlPrefix + "project/remove",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId,
                "projectId": projectId
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
    };

    this.getPasswordRule = function() {
      var rule;
        $.ajax({
            url : urlPrefix + "project/getPasswordRule",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                    rule = data;
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        return rule;
    };

    this.modifyPasswordRule = function(lock, pwdMaxErrNum, pwdPeriod, pwdPeriodNum, pwdRuleLength, pwdRuleUpper, pwdRuleLower, pwdRuleNum, pwdRuleSymbol, tabletMode) {
        $.ajax({
            url : urlPrefix + "project/modifyPasswordRule",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId,
                "lock": lock,
                "pwdMaxErrNum": pwdMaxErrNum,
                "pwdPeriod": pwdPeriod,
                "pwdPeriodNum": pwdPeriodNum,
                "pwdRuleLength": pwdRuleLength,
                "pwdRuleUpper": pwdRuleUpper,
                "pwdRuleLower": pwdRuleLower,
                "pwdRuleNum": pwdRuleNum,
                "pwdRuleSymbol": pwdRuleSymbol,
                "tabletMode": tabletMode
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
    };

    this.modifyMngCommon = function(projectId, sysNaviFlg, distance) {
        $.ajax({
            url : urlPrefix + "project/modifyMngCommon",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId,
                "projectId": projectId,
                "sysNaviFlg": sysNaviFlg,
                "distance": distance
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
    };



    this.modifyMngProperty = function(projectId, key, value) {
        $.ajax({
            url : urlPrefix + "project/modifyMngProperty",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId,
                "projectId": projectId,
                "key": key,
                "value": value
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
    };


    this.getMngCommon = function(projectId) {
      var mngCommon;
        $.ajax({
            url : urlPrefix + "project/getMngCommon",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId,
                "projectId" : projectId
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                    mngCommon = data;
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        return mngCommon;
    };

    this.getDiskSpace = function(projectId) {
      var diskSpace;
        $.ajax({
            url : urlPrefix + "project/getDiskSpace",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "loginId" : localStorage.userId,
                "schema" : localStorage.schema,
                "projectId" : projectId
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                    diskSpace = data.diskSpace;
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        return diskSpace;
    };

    this.getDiskSpaceHistory = function(projectId) {
      var diskSpaceList;
        $.ajax({
            url : urlPrefix + "project/getDiskSpaceHistory",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "loginId" : localStorage.userId,
                "schema" : localStorage.schema,
                "projectId" : projectId
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                    diskSpaceList = data.diskSpaceList;
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        return diskSpaceList;
    };

    this.getDiskSpaceHistoryAll = function() {
      var diskSpaceList;
        $.ajax({
            url : urlPrefix + "project/getDiskSpaceHistoryAll",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "loginId" : localStorage.userId,
                "schema" : localStorage.schema
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                    diskSpaceList = data.diskSpaceList;
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        return diskSpaceList;
    };



    this.updatePlanValue = function(planValue) {
        $.ajax({
            url : urlPrefix + "project/updatePlanValue",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId,
                "newPlan": planValue
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
    };


    this.getPlanHistory = function() {
      var lastestPlan;
        $.ajax({
            url : urlPrefix + "project/getPlanHistory",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "loginId" : localStorage.userId,
                "schema" : localStorage.schema
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                    lastestPlan = data.lastestPlan;
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        return lastestPlan;
    };

    this.getLogo = function(type) {
      var logo = [];
        $.ajax({
            url : urlPrefix + "project/getLogo",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "loginId" : localStorage.userId,
                "type" : type,
                "schema" : localStorage.schema
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                    logo.logoPath = data.logoPath;
                    logo.fileId = data.fileId;
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        return logo;
    };


    this.getUserImg = function(userId) {
      var fileId = 0;
        $.ajax({
            url : urlPrefix + "project/getUserImg",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "loginId" : userId,
                "schema" : localStorage.schema
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                    fileId = data.fileId;
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        return fileId;
    };

    this.deleteLogo = function(type) {
        $.ajax({
            url : urlPrefix + "project/deleteLogo",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "loginId" : localStorage.userId,
                "type" : type,
                "schema" : localStorage.schema
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
    };


    this.deleteUserImg = function() {
        $.ajax({
            url : urlPrefix + "project/deleteUserImg",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "loginId" : localStorage.userId,
                "schema" : localStorage.schema
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
    };

    this.searchAllUser = function() {
      var allUser;
        $.ajax({
            url : urlPrefix + "project/searchAllUser",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "loginId" : localStorage.userId,
                "regionCode" : localStorage.regionCode,
                "mngKbn" : localStorage.realMngKbn,
                "schema" : localStorage.schema
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                    allUser = data.userList;
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
        return allUser;
    };

    this.sendMailAlertDisk = function(rDisk, usedPlan, url, resourceKey) {
        $.ajax({
            url : urlPrefix + "project/sendMailAlertDisk",
            type : "POST",
            dataType : "json",
            headers : {
                "authorization" : localStorage.authId,
            },
            async : false,
            contentType : "application/json",
            data : JSON.stringify({
                "schema" : localStorage.schema,
                "remainDisk" : rDisk,
                "usedPlan": usedPlan,
                "url": url,
                "resourceKey": resourceKey
            }),
            success : function(data) {
                if (data.resultCd == "000000") {
                    self.setSuccess();
                } else {
                    self.setError(data.resultCd, data.resultMsg);
                }
            },
            error : function() {
                self.setError("", "サーバへの通信することができませんでした。");
            }
        });
    };


    // ---------------------- project関連　End  --------------------


    // ---------------------- ユーザ関連　Start  --------------------
    this.modifyPassword = function(oldP, newP) {
        $.ajax({
              url : urlPrefix + "user/modifyPassword",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                "schema" : localStorage.schema,
                "loginId" : localStorage.userId,
                "oldPassword" : oldP,
                "newPassword" : newP
              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function(err) {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
      };

      this.modifyUserTelEmail = function(tel, email) {
          $.ajax({
                url : urlPrefix + "user/modifyUserTelEmail",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "tel" : tel,
                  "mailAddr" : email
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function(err) {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

      this.modifyPasswordSystem = function(userId, userName, oldP, newP, tel, email, email2, email3, email4, email5) {
          $.ajax({
                url : urlPrefix + "user/modifyPasswordSystem",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "token" : localStorage.token,
                  "loginId" : localStorage.userId,
                  "userId" : userId,
                  "userName" : userName,
                  "oldPassword" : oldP,
                  "newPassword" : newP,
                  "tel" : tel,
                  "mailAddr" : email,
                  "mailAddr2" : email2,
                  "mailAddr3" : email3,
                  "mailAddr4" : email4,
                  "mailAddr5" : email5
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function(err) {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };


      this.selectGroupUserResourceListOrderByDis = function(projectId, targetLat, targetLng, groupIdList) {
          var beanlist;
          $.ajax({
              url : urlPrefix + "group/listOrderByDis",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "lat" : targetLat,
                  "lng" : targetLng,
                  "projectId" : projectId,
                  "groupIdList" : groupIdList
                }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      beanlist = data.beanList;
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function(error) {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return beanlist;
      };

      this.selectGroupUserResourceList = function(projectId) {
          var beanlist;
          $.ajax({
              url : urlPrefix + "group/list",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "projectId" : projectId
                }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      beanlist = data.beanList;
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function(error) {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return beanlist;
      };

      this.selectDefaultGroupList = function(projectId) {
          var beanlist;
          $.ajax({
              url : urlPrefix + "group/defaultList",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "projectId" : projectId
                }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      beanlist = data.beanList;
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function(error) {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return beanlist;
      };

      this.getStatusList = function(groupId) {
          var statuslist;
          $.ajax({
              url : urlPrefix + "group/getStatusList",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "groupId" : groupId
                }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                	  statuslist = data.statusList;
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function(error) {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return statuslist;
      };

      this.modifyStatusList = function(groupId,statusList) {
          $.ajax({
              url : urlPrefix + "group/modifyStatusList",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "groupId" : groupId,
                  "loginId" : localStorage.userId,
                  "statusList":statusList
              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
      };


      this.modifyDefaultGroup = function(projectId,groupIdList) {
          $.ajax({
              url : urlPrefix + "group/modifyDefaultList",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "projectId" : projectId,
                  "groupIdList":groupIdList
              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
      };

      this.selectUserListOrderByDis = function(projectId, targetLat, targetLng, groupIdList) {
          var userList = [];
          $.ajax({
              url : urlPrefix + "user/listOrderByDis",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "lat" : targetLat,
                  "lng" : targetLng,
                  "projectId" : projectId,
                  "groupIdList": groupIdList
                }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      userList = data.userList;
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return userList;
      };


      this.selectUserList = function(projectId) {
          var userList = [];
          $.ajax({
              url : urlPrefix + "user/list",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "mngFlg" : localStorage.realMngKbn,
                  "projectId" : projectId
                }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      userList = data.userList;
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return userList;
      };

      this.searchCompanyList = function() {
          var companyList = [];
          $.ajax({
              url : urlPrefix + "user/companyList",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "regionCode" : localStorage.regionCode,
                  "loginId" : localStorage.userId
                }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                    companyList = data.companyList;
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return companyList;
      };

      this.createCompany = function(company) {
          $.ajax({
              url : urlPrefix + "user/createCompany",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "fName" : company.fName,
                  "dName":company.dName,
                  "order":company.order,
                  "regionCode" : localStorage.regionCode
                }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
      };

      this.modifyCompany = function(company) {
          $.ajax({
              url : urlPrefix + "user/modifyCompany",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "fName" : company.fName,
                  "dName":company.dName,
                  "order":company.order,
                  "regionCode" : localStorage.regionCode,
                  "id":company.id
                }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
      };

      this.deleteCompany = function(id) {
          $.ajax({
              url : urlPrefix + "user/deleteCompany",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "id":id
                }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
      };

      this.createGroup = function(groupName, groupShowId, address, lat, lng, userIdList, projectId) {
    	  var groupId = 0;
          $.ajax({
              url : urlPrefix + "user/createGroup",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "groupName":groupName,
                  "groupId":groupShowId,
                  "address":address,
                  "lat":lat,
                  "lng":lng,
                  "userIdList":userIdList,
                  "projectId" : projectId
              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                      groupId = data.groupId;
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return groupId;
      };

      this.modifyGroup = function(groupId, groupName, groupIdShow, address, lat, lng, userIdList, projectId) {
          $.ajax({
              url : urlPrefix + "user/modifyGroup",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "groupId" : groupId,
                  "groupName":groupName,
                  "groupIdShow":groupIdShow,
                  "address":address,
                  "lat":lat,
                  "lng":lng,
                  "userIdList" :userIdList,
                  "projectId" : projectId
              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
      };

      this.removeGroup = function(groupId) {
          $.ajax({
              url : urlPrefix + "user/removeGroup",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "groupId" : groupId
              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
      };

      this.createUser = function(userId,userName,password,companyId,org,tel,mailAddr,address, lat,lng, mngFlg,groupIdList,projectId) {
          $.ajax({
              url : urlPrefix + "user/createUser",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "userId":userId,
                  "userName":userName,
                  "newPassword":password,
                  "companyId":companyId,
                  "organization":org,
                  "tel":tel,
                  "mailAddr":mailAddr,
                  "address":address,
                  "lat":lat,
                  "lng":lng,
                  "mngFlg":mngFlg,
                  "groupIdList":groupIdList,
                  "regionCode" : localStorage.regionCode,
                  "projectId" : projectId

              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
      };

      this.modifyUser = function(userId,userName,password,companyId,org,tel,mailAddr,address,lat,lng,mngFlg,groupIdList,accountLock, projectId) {
          $.ajax({
              url : urlPrefix + "user/modifyUser",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "projectId" : projectId,
                  "loginId" : localStorage.userId,
                  "userId":userId,
                  "userName":userName,
                  "newPassword":password,
                  "companyId":companyId,
                  "organization":org,
                  "tel":tel,
                  "mailAddr":mailAddr,
                  "address":address,
                  "lat":lat,
                  "lng":lng,
                  "mngFlg":mngFlg,
                  "groupIdList":groupIdList,
                  "accountLock":accountLock
              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
      };


      this.removeUser = function(userId) {
          $.ajax({
              url : urlPrefix + "user/removeUser",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "userId":userId
              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
      };

      this.searchUser = function(projectId, userId) {
          var userInfo = null;
          $.ajax({
              url : urlPrefix + "user/search",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "userId":userId,
                  "projectId":projectId
              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                      userInfo = data.user;
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return userInfo;
      };

      this.searchSystemUser = function() {
          var userInfo = null;
          $.ajax({
              url : urlPrefix + "user/searchSystemUser",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema
              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                      userInfo = data.user;
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return userInfo;
      };


      this.getListByGroupId = function(groupId) {
          var userList = [];
          $.ajax({
              url : urlPrefix + "user/getListByGroupId",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "groupId" : groupId
                }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      userList = data.userList;
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return userList;
      };


      this.getListByGroupIdList = function(groupIdList) {
          var userList = [];
          $.ajax({
              url : urlPrefix + "user/getListByGroupIdList",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "groupIdList" : groupIdList
                }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      userList = data.userList;
                      self.setSuccess();
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return userList;
      };


      // ---------------------- ユーザ関連　End  --------------------


      // ---------------------- 作業リスト　Start  --------------------
      this.searchChecksheetList = function(projectId, defaultFlg) {
          var checksheetList = [];
          $.ajax({
              url : urlPrefix + "checklist/getChecksheetList",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "projectId" : projectId,
                  "defaultFlg" : defaultFlg,
                  "parHash" : location.hash
              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                      checksheetList = data.checksheetList;
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return checksheetList;
      };

      this.searchChecklistList = function(checksheetId) {
          var checklistList = [];
          $.ajax({
              url : urlPrefix + "checklist/getCheckList",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "checksheetId" : checksheetId
              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                      checklistList = data.checklistList;
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return checklistList;
      };

      this.getCheckAllInfoList = function(checksheetId) {
          var checkAllList = [];
          $.ajax({
              url : urlPrefix + "checklist/getCheckAllInfoList",
              type : "POST",
              dataType : "json",
              headers : {
                  "authorization" : localStorage.authId,
              },
              async : false,
              contentType : "application/json",
              data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "checksheetId" : checksheetId
              }),
              success : function(data) {
                  if (data.resultCd == "000000") {
                      self.setSuccess();
                      checkAllList = data.checkInfoList;
                  } else {
                      self.setError(data.resultCd, data.resultMsg);
                  }
              },
              error : function() {
                  self.setError("", "サーバへの通信することができませんでした。");
              }
          });
          return checkAllList;
      };

      this.createChecksheet = function(projectResourceId, checksheetName, frequency, projectId) {
          var newChecksheetId = "";
          $.ajax({
                url : urlPrefix + "checklist/createChecksheet",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "projectId" : projectId,
                  "projectResourceId" : projectResourceId,
                  "frequency" : frequency,
                  "checksheetName" : checksheetName
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                      newChecksheetId = data.newChecksheetId;
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function(err) {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
          return newChecksheetId;
        };

        this.removeChecksheet = function(checksheetId, projectId) {
            $.ajax({
                url : urlPrefix + "checklist/removeChecksheet",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "checksheetId": checksheetId,
                    "projectId": projectId
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.copyChecksheet = function(checksheetId, projectResourceId, checksheetName, frequency, copyFromResourceId, projectId) {
            var newChecksheetId = "";
            $.ajax({
                  url : urlPrefix + "checklist/copyChecksheet",
                  type : "POST",
                  dataType : "json",
                  headers : {
                      "authorization" : localStorage.authId,
                  },
                  async : false,
                  contentType : "application/json",
                  data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "checksheetName" : checksheetName,
                    "projectResourceId" : projectResourceId,
                    "copyFromResourceId" : copyFromResourceId,
                    "frequency" : frequency,
                    "checksheetId" : checksheetId
                  }),
                  success : function(data) {
                      if (data.resultCd == "000000") {
                        newChecksheetId = data.newChecksheetId;
                        self.setSuccess();
                      } else {
                          self.setError(data.resultCd, data.resultMsg);
                      }
                  },
                  error : function(err) {
                      self.setError("", "サーバへの通信することができませんでした。");
                  }
              });
            return newChecksheetId;
          };


          this.copyDefaultChecksheet = function(item, projectId) {
              var newChecksheetId = "";
              $.ajax({
                    url : urlPrefix + "checklist/copyDefaultChecksheet",
                    type : "POST",
                    dataType : "json",
                    headers : {
                        "authorization" : localStorage.authId,
                    },
                    async : false,
                    contentType : "application/json",
                    data : JSON.stringify({
                      "schema" : localStorage.schema,
                      "loginId" : localStorage.userId,
                      "projectId" : projectId,
                      "checksheetName" : item.checksheetName,
                      "copyFromResourceId" : item.fourthId,
                      "frequency" : item.frequency,
                      "first" : item.first,
                      "second" : item.second,
                      "third" : item.third,
                      "fourth" : item.fourth,
                      "checksheetId" : item.checksheetId
                    }),
                    success : function(data) {
                        if (data.resultCd == "000000") {
                          newChecksheetId = data.newChecksheetId;
                          self.setSuccess();
                        } else {
                            self.setError(data.resultCd, data.resultMsg);
                        }
                    },
                    error : function(err) {
                        self.setError("", "サーバへの通信することができませんでした。");
                    }
                });
              return newChecksheetId;
            };

            this.copyOtherChecksheet = function(item, projectId) {
                var newChecksheetId = "";
                $.ajax({
                      url : urlPrefix + "checklist/copyOtherChecksheet",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                        "schema" : localStorage.schema,
                        "loginId" : localStorage.userId,
                        "projectId" : projectId,
                        "checksheetName" : item.checksheetName,
                        "copyFromResourceId" : item.fourthId,
                        "frequency" : item.frequency,
                        "first" : item.first,
                        "second" : item.second,
                        "third" : item.third,
                        "fourth" : item.fourth,
                        "checksheetId" : item.checksheetId
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                            newChecksheetId = data.newChecksheetId;
                            self.setSuccess();
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function(err) {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
                return newChecksheetId;
              };

        this.createChecklist = function(checksheetId, checklistName, sort) {
          var newChecklistId = "";
          $.ajax({
                url : urlPrefix + "checklist/createChecklist",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "checksheetId" : checksheetId,
                  "checklistName" : checklistName,
                  "sort" : sort
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                      newChecklistId = data.newChecklistId;
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function(err) {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
          return newChecklistId;
        };

        this.modifyChecksheet = function(checksheetId, frequency, projectId,releaseFlag) {
            $.ajax({
                url : urlPrefix + "checklist/modifyChecksheet",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "checksheetId": checksheetId,
                    "frequency": frequency,
                    "releaseFlag":releaseFlag
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.modifyChecklist = function(checklistBeanList) {
            $.ajax({
                url : urlPrefix + "checklist/modifyChecklist",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "checklistBeanList": checklistBeanList
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.removeChecklist = function(checklistIdList, projectId) {
            $.ajax({
                url : urlPrefix + "checklist/removeChecklist",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "checklistIdList": checklistIdList
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.searchCheckDetailList = function(checklistId) {
            var checkDetailList = [];
            $.ajax({
                url : urlPrefix + "checklist/getCheckDetailList",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "checklistId" : checklistId,
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        checkDetailList = data.checkDetailList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return checkDetailList;
        };

        this.searchCheckLimitList = function(checkdetailId) {
            var checkLimitList = [];
            $.ajax({
                url : urlPrefix + "checklist/getCheckLimitList",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "checkDetailId" : checkdetailId,
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        checkLimitList = data.checkLimitList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return checkLimitList;
        };


        this.removeCheckDetail = function(checkDetailIdList, projectId) {
            $.ajax({
                url : urlPrefix + "checklist/removeCheckDetail",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "checkDetailIdList": checkDetailIdList
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.saveCheckDetail = function(checklistId, detailBeanList, projectId) {
            $.ajax({
                url : urlPrefix + "checklist/saveCheckDetail",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "checklistId": checklistId,
                    "projectId" : projectId,
                    "detailBeanList": detailBeanList
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.saveCheckLimit = function(checkdetailId, limitBeanList) {
            $.ajax({
                url : urlPrefix + "checklist/saveCheckLimit",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "checkDetailId": checkdetailId,
                    "limitBeanList": limitBeanList
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.deleteLimit = function(checkdetailId) {
            $.ajax({
                url : urlPrefix + "checklist/deleteLimit",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "checkDetailId": checkdetailId
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };


        this.getFileList = function(checksheetId) {
            var fileList = [];
            $.ajax({
                url : urlPrefix + "checklist/getFileList",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "checksheetId" : checksheetId,
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        fileList = data.fileList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return fileList;
        };

           this.getFileDetailList = function(checkdetailId) {
            var fileList = [];
            $.ajax({
                url : urlPrefix + "checklist/getFileDetailList",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "checkDetailId" : checkdetailId
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        fileList = data.fileList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return fileList;
        };

        this.removeFile = function(projectId, checksheetId, fileId, external) {
            $.ajax({
                url : urlPrefix + "checklist/removeFile",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "checksheetId": checksheetId,
                    "fileId": fileId,
                    "external": external
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.removeDetailFile = function(projectId, checkDetailId, fileId, external) {
            $.ajax({
                url : urlPrefix + "checklist/removeDetailFile",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "checkDetailId": checkDetailId,
                    "fileId": fileId,
                    "external": external
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        //マニュアル用
        this.getFileListCommon = function(projectId) {
            var fileList = [];
            $.ajax({
                url : urlPrefix + "checklist/getFileListCommon",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        fileList = data.fileList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return fileList;
        };

        this.getFileListByName = function(fileName, projectId) {
            var fileList = [];
            $.ajax({
                url : urlPrefix + "checklist/getFileListByName",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "fileName" : fileName,
                    "projectId" : projectId,
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        fileList = data.fileList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return fileList;
        };

        this.removeFileCommon = function(projectId, fileId, external) {
            $.ajax({
                url : urlPrefix + "checklist/removeFileCommon",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "fileId": fileId,
                    "external": external
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.getDownloadSetting = function(checksheetId) {
        	var result = new Object();
            $.ajax({
                url : urlPrefix + "checklist/getDownloadSetting",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "checksheetId": checksheetId
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        result.ticketBean = data.ticketBean;
                        result.targetBean = data.targetBean;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return result;
        };

        this.getTempFile = function(checksheetId) {
        	var rs = new Object();
            $.ajax({
                url : urlPrefix + "checklist/getTempFile",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "checksheetId" : checksheetId,
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        rs.file = data.file;
                        rs.downloadFileName = data.downloadFileName;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return rs;
        };

        this.getCheckAllInfoListWithKey = function(checksheetId) {
            var checkAllList = [];
            $.ajax({
                url : urlPrefix + "checklist/getCheckAllInfoListWithKey",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "checksheetId" : checksheetId,
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        checkAllList = data.checkInfoList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return checkAllList;
        };

        this.saveDownloadSetting = function(ticketBean, targetBean, checkInfoList, fileName, checksheetId) {
            $.ajax({
                url : urlPrefix + "checklist/saveDownloadSetting",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "ticketBean" : ticketBean,
                    "targetBean" : targetBean,
                    "checkInfoList" : checkInfoList,
                    "fileName" : fileName,
                    "checksheetId": checksheetId
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.removeTempFile = function(projectId, checksheetId, fileId, external) {
            $.ajax({
                url : urlPrefix + "checklist/removeTempFile",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "checksheetId": checksheetId,
                    "fileId": fileId,
                    "external": external
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };


      // ---------------------- 作業リスト　End  --------------------



      // ---------------------- リソース関連　Start  --------------------
        this.searchResource = function(resourceGroup) {
            var resourceList = [];
            $.ajax({
                url : urlPrefix + "resource/getResourceList",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "resourceGroup" : resourceGroup,
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        resourceList = data.resourceList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return resourceList;
        };

        this.searchUserResource = function(projectId, kbn) {
            var resourceList = [];
            $.ajax({
                url : urlPrefix + "resource/getUserResourceList",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "kbn" : kbn
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        resourceList = data.resourceList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return resourceList;
        };

        this.saveUserResource = function(projectId, userResourceGroup, userResourceGroupName) {
          var newUserResourceGroup = "";
            $.ajax({
                url : urlPrefix + "resource/saveUserResource",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "userResourceGroup" : userResourceGroup,
                    "userResourceGroupName" : userResourceGroupName
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        newUserResourceGroup = data.newUserResourceGroup;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return newUserResourceGroup;
        };

        this.checkUserResource = function(urg) {
        	var rs = "";
            $.ajax({
                url : urlPrefix + "resource/checkUserResource",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "userResourceGroup" : urg
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        rs = data.rs;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return rs;
        };

        this.removeUserResource = function(urg) {
            $.ajax({
                url : urlPrefix + "resource/removeUserResource",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "userResourceGroup" : urg
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.searchUserResourceDetail = function(userResGroup) {
            var resourceList = [];
            $.ajax({
                url : urlPrefix + "resource/getUserResourceDetailList",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "userResourceGroup" : userResGroup
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        resourceList = data.resourceList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return resourceList;
        };


        this.removeUserResourceDetail = function(urdIdList, urg) {
        	var rs = "";
            $.ajax({
                url : urlPrefix + "resource/removeUserResourceDetail",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "userResourceGroup" : urg,
                    "urdIdList" : urdIdList
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        rs = data.rs;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return rs;
        };

        this.saveUserResourceDetail = function(userResourceGroup, urdBeanList) {
            $.ajax({
                url : urlPrefix + "resource/saveUserResourceDetail",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "userResourceGroup" : userResourceGroup,
                    "urdBeanList" : urdBeanList
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.getProjectResourceList = function(projectId, type, parent) {
            var resourceList = [];
            $.ajax({
                url : urlPrefix + "resource/getProjectResourceList",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "parent" : parent,
                    "type" : type
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        resourceList = data.resourceList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return resourceList;
        };

        this.createProjectResource = function(item, projectId, type, parent) {
            $.ajax({
                url : urlPrefix + "resource/createProjectResource",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "name" : item.label,
                    "sort" : item.sort,
                    "parent" : parent,
                    "type" : type
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.modifyProjectResource = function(item) {
            $.ajax({
                url : urlPrefix + "resource/modifyProjectResource",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "id" : item.id,
                    "name" : item.label,
                    "sort" : item.sort
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };


        this.checkUsedInTarget = function(kbn, id, projectId) {
            var isUsed = 0;
            $.ajax({
                url : urlPrefix + "resource/checkUsedInTarget",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "kbn" : kbn,
                    "id" : id
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        isUsed = data.count;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return isUsed;
        };

        this.checkUsedInCheckList = function(kbn, id) {
            var isUsed = 0;
            $.ajax({
                url : urlPrefix + "resource/checkUsedInCheckList",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "kbn" : kbn,
                    "id" : id
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        isUsed = data.count;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return isUsed;
        };

        this.deleteProjectResource = function(id) {
            $.ajax({
                url : urlPrefix + "resource/deleteProjectResource",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "id" : id
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };

        this.getMasterAllList = function(projectId) {
            var resourceList = [];
            $.ajax({
                url : urlPrefix + "resource/getProjectResourceAllList",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        resourceList = data.resourceList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return resourceList;
        };

        this.getMaster4CheckAllList = function(projectId) {
            var resourceList = [];
            $.ajax({
                url : urlPrefix + "resource/getProjectResource4CheckAllList",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        resourceList = data.resourceList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return resourceList;
        };


        this.countTargetUsedMaster = function(projectId) {
            var count = 0;
            $.ajax({
                url : urlPrefix + "resource/countTargetUsedMaster",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        count = data.count;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return count;
        };


      // ---------------------- リソース関連　End  --------------------

      // ---------------------- 画面項目　Start  --------------------
        this.searchItemNameList = function(type, projectId) {
            var itemNameList = [];
            $.ajax({
                url : urlPrefix + "itemName/getList",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "type" : type
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        itemNameList = data.itemNameList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return itemNameList;
        };

        this.modifyItemName = function(bean, projectId) {
            $.ajax({
                url : urlPrefix + "itemName/modify",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "itemNameBean": bean
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
        };


      // ---------------------- 画面項目　End  --------------------

      // ---------------------- 工事　Start  --------------------
        this.getTargetItemList = function(projectId) {
            var itemNameList = [];
            $.ajax({
                url : urlPrefix + "itemName/getTargetItemList",
                type : "POST",
                dataType : "json",
                headers : {
                    "authorization" : localStorage.authId,
                },
                async : false,
                contentType : "application/json",
                data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId
                }),
                success : function(data) {
                    if (data.resultCd == "000000") {
                        self.setSuccess();
                        itemNameList = data.itemNameList;
                    } else {
                        self.setError(data.resultCd, data.resultMsg);
                    }
                },
                error : function() {
                    self.setError("", "サーバへの通信することができませんでした。");
                }
            });
            return itemNameList;
        };

        this.createTarget = function(projectId, target) {
            $.ajax({
                  url : urlPrefix + "checktarget/create",
                  type : "POST",
                  dataType : "json",
                  headers : {
                      "authorization" : localStorage.authId,
                  },
                  async : false,
                  contentType : "application/json",
                  data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "target" : target
                  }),
                  success : function(data) {
                      if (data.resultCd == "000000") {
                          self.setSuccess();
                      } else {
                          self.setError(data.resultCd, data.resultMsg);
                      }
                  },
                  error : function(err) {
                      self.setError("", "サーバへの通信することができませんでした。");
                  }
              });
          };

          this.searchTargetList = function(projectId) {
              var targetList = [];
              $.ajax({
                  url : urlPrefix + "checktarget/getList",
                  type : "POST",
                  dataType : "json",
                  headers : {
                      "authorization" : localStorage.authId,
                  },
                  async : false,
                  contentType : "application/json",
                  data : JSON.stringify({
                      "schema" : localStorage.schema,
                      "loginId" : localStorage.userId,
                      "projectId" : projectId
                  }),
                  success : function(data) {
                      if (data.resultCd == "000000") {
                          self.setSuccess();
                          targetList = data.beanList;
                      } else {
                          self.setError(data.resultCd, data.resultMsg);
                      }
                  },
                  error : function() {
                      self.setError("", "サーバへの通信することができませんでした。");
                  }
              });
              return targetList;
          };

          this.searchTargetIdNameList = function(projectId) {
              var targetList = [];
              $.ajax({
                  url : urlPrefix + "checktarget/getIdNameList",
                  type : "POST",
                  dataType : "json",
                  headers : {
                      "authorization" : localStorage.authId,
                  },
                  async : false,
                  contentType : "application/json",
                  data : JSON.stringify({
                      "schema" : localStorage.schema,
                      "loginId" : localStorage.userId,
                      "projectId" : projectId
                  }),
                  success : function(data) {
                      if (data.resultCd == "000000") {
                          self.setSuccess();
                          targetList = data.beanList;
                      } else {
                          self.setError(data.resultCd, data.resultMsg);
                      }
                  },
                  error : function() {
                      self.setError("", "サーバへの通信することができませんでした。");
                  }
              });
              return targetList;
          };

          this.searchTarget = function(id) {
              var target = {};
              $.ajax({
                  url : urlPrefix + "checktarget/getTarget",
                  type : "POST",
                  dataType : "json",
                  headers : {
                      "authorization" : localStorage.authId,
                  },
                  async : false,
                  contentType : "application/json",
                  data : JSON.stringify({
                      "schema" : localStorage.schema,
                      "loginId" : localStorage.userId,
                      "id" : id
                  }),
                  success : function(data) {
                      if (data.resultCd == "000000") {
                          self.setSuccess();
                          target = data.target;
                      } else {
                          self.setError(data.resultCd, data.resultMsg);
                      }
                  },
                  error : function() {
                      self.setError("", "サーバへの通信することができませんでした。");
                  }
              });
              return target;
          };

          this.modifyTarget = function(target) {
              $.ajax({
                  url : urlPrefix + "checktarget/modify",
                  type : "POST",
                  dataType : "json",
                  headers : {
                      "authorization" : localStorage.authId,
                  },
                  async : false,
                  contentType : "application/json",
                  data : JSON.stringify({
                      "schema" : localStorage.schema,
                      "loginId" : localStorage.userId,
                      "target" : target
                  }),
                  success : function(data) {
                      if (data.resultCd == "000000") {
                          self.setSuccess();
                      } else {
                          self.setError(data.resultCd, data.resultMsg);
                      }
                  },
                  error : function() {
                      self.setError("", "サーバへの通信することができませんでした。");
                  }
              });
          };

          this.removeTarget = function(id, projectId) {
              $.ajax({
                  url : urlPrefix + "checktarget/remove",
                  type : "POST",
                  dataType : "json",
                  headers : {
                      "authorization" : localStorage.authId,
                  },
                  async : false,
                  contentType : "application/json",
                  data : JSON.stringify({
                      "schema" : localStorage.schema,
                      "loginId" : localStorage.userId,
                      "projectId" : projectId,
                      "id" : id
                  }),
                  success : function(data) {
                      if (data.resultCd == "000000") {
                          self.setSuccess();
                      } else {
                          self.setError(data.resultCd, data.resultMsg);
                      }
                  },
                  error : function() {
                      self.setError("", "サーバへの通信することができませんでした。");
                  }
              });
          };

          this.getFileListTarget = function(id) {
              var fileList = [];
              $.ajax({
                  url : urlPrefix + "checktarget/getFileList",
                  type : "POST",
                  dataType : "json",
                  headers : {
                      "authorization" : localStorage.authId,
                  },
                  async : false,
                  contentType : "application/json",
                  data : JSON.stringify({
                      "schema" : localStorage.schema,
                      "loginId" : localStorage.userId,
                      "id" : id,
                  }),
                  success : function(data) {
                      if (data.resultCd == "000000") {
                          self.setSuccess();
                          fileList = data.fileList;
                      } else {
                          self.setError(data.resultCd, data.resultMsg);
                      }
                  },
                  error : function() {
                      self.setError("", "サーバへの通信することができませんでした。");
                  }
              });
              return fileList;
          };

          this.removeFileTarget = function(projectId, targetId, fileId, external) {
              $.ajax({
                  url : urlPrefix + "checktarget/removeFile",
                  type : "POST",
                  dataType : "json",
                  headers : {
                      "authorization" : localStorage.authId,
                  },
                  async : false,
                  contentType : "application/json",
                  data : JSON.stringify({
                      "schema" : localStorage.schema,
                      "loginId" : localStorage.userId,
                      "projectId" : projectId,
                      "id": targetId,
                      "fileId": fileId,
                      "external": external
                  }),
                  success : function(data) {
                      if (data.resultCd == "000000") {
                          self.setSuccess();
                      } else {
                          self.setError(data.resultCd, data.resultMsg);
                      }
                  },
                  error : function() {
                      self.setError("", "サーバへの通信することができませんでした。");
                  }
              });
          };


      // ---------------------- 工事　End  --------------------


      // ---------------------- チケット　Start  --------------------
          this.createTicket = function(projectId, ticket, comment, url) {
            var ticketId = "";
            $.ajax({
                  url : urlPrefix + "checkreport/createTicket",
                  type : "POST",
                  dataType : "json",
                  headers : {
                      "authorization" : localStorage.authId,
                  },
                  async : false,
                  contentType : "application/json",
                  data : JSON.stringify({
                    "schema" : localStorage.schema,
                    "loginId" : localStorage.userId,
                    "projectId" : projectId,
                    "ticket" : ticket,
                    "url": url,
                    "loginUserName" : localStorage.userName,
                    "comment" : comment
                  }),
                  success : function(data) {
                      if (data.resultCd == "000000") {
                          self.setSuccess();
                          ticketId = data.ticketId;
                      } else {
                          self.setError(data.resultCd, data.resultMsg);
                      }
                  },
                  error : function(err) {
                      self.setError("", "サーバへの通信することができませんでした。");
                  }
              });
            return ticketId;
          };

          this.searchTicketList = function(projectId, groupIdList) {
              var ticketOb = {};
              $.ajax({
                    url : urlPrefix + "checkreport/getTicketList",
                    type : "POST",
                    dataType : "json",
                    headers : {
                        "authorization" : localStorage.authId,
                    },
                    async : false,
                    contentType : "application/json",
                    data : JSON.stringify({
                      "schema" : localStorage.schema,
                      "loginId" : localStorage.userId,
                      "projectId" : projectId,
                      "mngFlg" : localStorage.mngKbn,
                      "loginGroupIdList" : groupIdList
                    }),
                    success : function(data) {
                        if (data.resultCd == "000000") {
                            self.setSuccess();
                            ticketOb.ticketList = data.beanList;
                            ticketOb.flg = data.hasOpTicket;
                        } else {
                            self.setError(data.resultCd, data.resultMsg);
                        }
                    },
                    error : function(err) {
                        self.setError("", "サーバへの通信することができませんでした。");
                    }
                });
              return ticketOb;
            };

            this.searchTicketListByTargetId = function(projectId, groupIdList, targetId) {
                var ticketOb = {};
                $.ajax({
                      url : urlPrefix + "checkreport/getTicketList",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                        "schema" : localStorage.schema,
                        "loginId" : localStorage.userId,
                        "projectId" : projectId,
                        "targetId" : targetId,
                        "loginGroupIdList" : groupIdList
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                              ticketOb.ticketList = data.beanList;
                              ticketOb.flg = data.hasOpTicket;
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function(err) {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
                return ticketOb;
              };

            this.searchTicketListByDate = function(projectId, startScheduledDateS, startScheduledDateE, endScheduledDateS, endScheduledDateE, startDateS, startDateE, endDateS, endDateE, groupIdList) {
                var ticketOb = {};
                $.ajax({
                      url : urlPrefix + "checkreport/getTicketList",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                        "schema" : localStorage.schema,
                        "loginId" : localStorage.userId,
                        "projectId" : projectId,
                        "startScheduledDateS" : startScheduledDateS,
                        "startScheduledDateE" : startScheduledDateE,
                        "endScheduledDateS" : endScheduledDateS,
                        "endScheduledDateE" : endScheduledDateE,
                        "startDateS" : startDateS,
                        "startDateE" : startDateE,
                        "endDateS" : endDateS,
                        "endDateE" : endDateE,
                        "loginGroupIdList" : groupIdList
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                              ticketOb.ticketList = data.beanList;
                              ticketOb.flg = data.hasOpTicket;
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function(err) {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
                return ticketOb;
              };

            this.searchTicketListSp = function(projectId, conStartDate, conEndDate, statusList, targetId, targetName, checkSheet, responseUserName, groupIdList) {
                var ticketList = [];
                $.ajax({
                      url : urlPrefix + "checkreport/getTicketListSp",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                        "schema" : localStorage.schema,
                        "loginId" : localStorage.userId,
                        "projectId" : projectId,
                        "startScheduledDateS" : conStartDate,
                        "startScheduledDateE" : conEndDate,
                        "targetId" : targetId,
                        "targetName" : targetName,
                        "checkSheet" : checkSheet,
                        "responseUserName" : responseUserName,
                        "statusList" : statusList,
                        "mngFlg" : localStorage.mngKbn,
                        "loginGroupIdList" : groupIdList
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                              ticketList = data.beanList;
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function(err) {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
                return ticketList;
              };

            this.searchTicketInfo = function(projectId, ticketId) {
                var ticket = {};
                $.ajax({
                      url : urlPrefix + "checkreport/getTicketInfo",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                        "schema" : localStorage.schema,
                        "loginId" : localStorage.userId,
                        "projectId" : projectId,
                        "ticketId" : ticketId
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                              ticket = data.ticket;
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function(err) {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
                return ticket;
              };

              this.searchCheckResultList = function(ticketId) {
                  var checkResultList = [];
                  $.ajax({
                        url : urlPrefix + "checkreport/getCheckResultList",
                        type : "POST",
                        dataType : "json",
                        headers : {
                            "authorization" : localStorage.authId,
                        },
                        async : false,
                        contentType : "application/json",
                        data : JSON.stringify({
                          "loginId" : localStorage.userId,
                          "schema" : localStorage.schema,
                          "ticketId" : ticketId
                        }),
                        success : function(data) {
                            if (data.resultCd == "000000") {
                                self.setSuccess();
                                checkResultList = data.checkResultList;
                            } else {
                                self.setError(data.resultCd, data.resultMsg);
                            }
                        },
                        error : function(err) {
                            self.setError("", "サーバへの通信することができませんでした。");
                        }
                    });
                  return checkResultList;
                };

                this.modifyTicket = function(ticket, projectId) {
                	delete ticket.progress;
                    $.ajax({
                          url : urlPrefix + "checkreport/modifyTicket",
                          type : "POST",
                          dataType : "json",
                          headers : {
                              "authorization" : localStorage.authId,
                          },
                          async : false,
                          contentType : "application/json",
                          data : JSON.stringify({
                            "loginId" : localStorage.userId,
                            "schema" : localStorage.schema,
                            "projectId" : projectId,
                            "url" : window.location.href,
                            "loginUserName" : localStorage.userName,
                            "ticket" : ticket
                          }),
                          success : function(data) {
                              if (data.resultCd == "000000") {
                                  self.setSuccess();
                              } else {
                                  self.setError(data.resultCd, data.resultMsg);
                              }
                          },
                          error : function(err) {
                              self.setError("", "サーバへの通信することができませんでした。");
                          }
                      });
                  };

              this.searchCommentList = function(projectId, ticketId) {
                  var commentList = [];
                  $.ajax({
                        url : urlPrefix + "checkreport/getCommentList",
                        type : "POST",
                        dataType : "json",
                        headers : {
                            "authorization" : localStorage.authId,
                        },
                        async : false,
                        contentType : "application/json",
                        data : JSON.stringify({
                          "loginId" : localStorage.userId,
                          "schema" : localStorage.schema,
                          "projectId" : projectId,
                          "ticketId" : ticketId
                        }),
                        success : function(data) {
                            if (data.resultCd == "000000") {
                                self.setSuccess();
                                commentList = data.commentList;
                            } else {
                                self.setError(data.resultCd, data.resultMsg);
                            }
                        },
                        error : function(err) {
                            self.setError("", "サーバへの通信することができませんでした。");
                        }
                    });
                  return commentList;
                };

                this.searchResultDetailList = function(ticketId, checkListId) {
                    var resultDetailList = [];
                    $.ajax({
                          url : urlPrefix + "checkreport/getResultDetailList",
                          type : "POST",
                          dataType : "json",
                          headers : {
                              "authorization" : localStorage.authId,
                          },
                          async : false,
                          contentType : "application/json",
                          data : JSON.stringify({
                            "loginId" : localStorage.userId,
                            "schema" : localStorage.schema,
                            "ticketId" : ticketId,
                            "checkListId" : checkListId
                          }),
                          success : function(data) {
                              if (data.resultCd == "000000") {
                                  self.setSuccess();
                                  resultDetailList = data.resultDetailList;
                              } else {
                                  self.setError(data.resultCd, data.resultMsg);
                              }
                          },
                          error : function(err) {
                              self.setError("", "サーバへの通信することができませんでした。");
                          }
                      });
                    return resultDetailList;
                  };

                  this.searchImgBeanList = function(checkResultId) {
                      var imgList = [];
                      $.ajax({
                            url : urlPrefix + "checkreport/getImgIdList",
                            type : "POST",
                            dataType : "json",
                            headers : {
                                "authorization" : localStorage.authId,
                            },
                            async : false,
                            contentType : "application/json",
                            data : JSON.stringify({
                              "loginId" : localStorage.userId,
                              "schema" : localStorage.schema,
                              "checkResultId" : checkResultId
                            }),
                            success : function(data) {
                                if (data.resultCd == "000000") {
                                    self.setSuccess();
                                    imgList = data.fileList;
                                } else {
                                    self.setError(data.resultCd, data.resultMsg);
                                }
                            },
                            error : function(err) {
                                self.setError("", "サーバへの通信することができませんでした。");
                            }
                        });
                      return imgList;
                    };

                    this.getImgComment = function(fileId){
                        var imgComm ="";
                         $.ajax({
                                  url : urlPrefix + "checkreport/getImgComment",
                                  type : "POST",
                                  dataType : "json",
                                  headers : {
                                      "authorization" : localStorage.authId,
                                  },
                                  async : false,
                                  contentType : "application/json",
                                  data : JSON.stringify({
                                    "loginId" : localStorage.userId,
                                    "schema" : localStorage.schema,
                                    "fileId" : fileId
                                  }),
                                  success : function(data) {
                                      if (data.resultCd == "000000") {
                                          self.setSuccess();
                                          imgComm = data.imgComment;
                                      } else {
                                          self.setError(data.resultCd, data.resultMsg);
                                      }
                                  },
                                  error : function(err) {
                                      self.setError("", "サーバへの通信することができませんでした。");
                                  }
                              });
                            return imgComm;

                    }

                    this.removeFileCheckResult = function(fileId) {
                        $.ajax({
                              url : urlPrefix + "checkreport/removeFile",
                              type : "POST",
                              dataType : "json",
                              headers : {
                                  "authorization" : localStorage.authId,
                              },
                              async : false,
                              contentType : "application/json",
                              data : JSON.stringify({
                                "loginId" : localStorage.userId,
                                "schema" : localStorage.schema,
                                "fileId" : fileId
                              }),
                              success : function(data) {
                                  if (data.resultCd == "000000") {
                                      self.setSuccess();
                                  } else {
                                      self.setError(data.resultCd, data.resultMsg);
                                  }
                              },
                              error : function(err) {
                                  self.setError("", "サーバへの通信することができませんでした。");
                              }
                          });
                      };

                      this.modifyCheckResult = function(projectId, ticketId, resultList, lat, lgt) {
                          $.ajax({
                                url : urlPrefix + "checkreport/modifyCheckResult",
                                type : "POST",
                                dataType : "json",
                                headers : {
                                    "authorization" : localStorage.authId,
                                },
                                async : false,
                                contentType : "application/json",
                                data : JSON.stringify({
                                  "loginId" : localStorage.userId,
                                  "schema" : localStorage.schema,
                                  "projectId" : projectId,
                                  "ticketId" : ticketId,
                                  "lat" : lat,
                                  "lgt" : lgt,
                                  "resultList" : resultList
                                }),
                                success : function(data) {
                                    if (data.resultCd == "000000") {
                                        self.setSuccess();
                                    } else {
                                        self.setError(data.resultCd, data.resultMsg);
                                    }
                                },
                                error : function(err) {
                                    self.setError("", "サーバへの通信することができませんでした。");
                                }
                            });
                        };

                        this.modifyImgComment = function(commentList) {
                          $.ajax({
                                url : urlPrefix + "checkreport/modifyImgComment",
                                type : "POST",
                                dataType : "json",
                                headers : {
                                    "authorization" : localStorage.authId,
                                },
                                async : false,
                                contentType : "application/json",
                                data : JSON.stringify({
                                  "loginId" : localStorage.userId,
                                  "schema" : localStorage.schema,
                                  "imgCommentList" : commentList,
                                }),
                                success : function(data) {
                                    if (data.resultCd == "000000") {
                                        self.setSuccess();
                                    } else {
                                        self.setError(data.resultCd, data.resultMsg);
                                    }
                                },
                                error : function(err) {
                                    self.setError("", "サーバへの通信することができませんでした。");
                                }
                            });
                        };


                        this.getFileListTicket = function(id) {
                            var fileList = [];
                            $.ajax({
                                url : urlPrefix + "checkreport/getFileList",
                                type : "POST",
                                dataType : "json",
                                headers : {
                                    "authorization" : localStorage.authId,
                                },
                                async : false,
                                contentType : "application/json",
                                data : JSON.stringify({
                                    "loginId" : localStorage.userId,
                                    "schema" : localStorage.schema,
                                    "ticketId" : id,
                                }),
                                success : function(data) {
                                    if (data.resultCd == "000000") {
                                        self.setSuccess();
                                        fileList = data.fileList;
                                    } else {
                                        self.setError(data.resultCd, data.resultMsg);
                                    }
                                },
                                error : function() {
                                    self.setError("", "サーバへの通信することができませんでした。");
                                }
                            });
                            return fileList;
                        };

                        this.removeFileTicket = function(projectId, ticketId, fileId, external) {
                            $.ajax({
                                url : urlPrefix + "checkreport/removeFileTicket",
                                type : "POST",
                                dataType : "json",
                                headers : {
                                    "authorization" : localStorage.authId,
                                },
                                async : false,
                                contentType : "application/json",
                                data : JSON.stringify({
                                    "loginId" : localStorage.userId,
                                    "schema" : localStorage.schema,
                                    "projectId" : projectId,
                                    "ticketId": ticketId,
                                    "fileId": fileId,
                                    "external": external
                                }),
                                success : function(data) {
                                    if (data.resultCd == "000000") {
                                        self.setSuccess();
                                    } else {
                                        self.setError(data.resultCd, data.resultMsg);
                                    }
                                },
                                error : function() {
                                    self.setError("", "サーバへの通信することができませんでした。");
                                }
                            });
                        };

                        this.saveComment = function(ticketId, statusId, comment, projectId, url) {
                            $.ajax({
                                url : urlPrefix + "checkreport/saveComment",
                                type : "POST",
                                dataType : "json",
                                headers : {
                                    "authorization" : localStorage.authId,
                                },
                                async : false,
                                contentType : "application/json",
                                data : JSON.stringify({
                                    "loginId" : localStorage.userId,
                                    "loginUserName" : localStorage.userName,
                                    "schema" : localStorage.schema,
                                    "ticketId" : ticketId,
                                    "statusId": statusId,
                                    "projectId": projectId,
                                    "url": url,
                                    "comment": comment
                                }),
                                success : function(data) {
                                    if (data.resultCd == "000000") {
                                        self.setSuccess();
                                    } else {
                                        self.setError(data.resultCd, data.resultMsg);
                                    }
                                },
                                error : function() {
                                    self.setError("", "サーバへの通信することができませんでした。");
                                }
                            });
                        };

                        this.removeComment = function(id) {
                            $.ajax({
                                url : urlPrefix + "checkreport/removeComment",
                                type : "POST",
                                dataType : "json",
                                headers : {
                                    "authorization" : localStorage.authId,
                                },
                                async : false,
                                contentType : "application/json",
                                data : JSON.stringify({
                                    "loginId" : localStorage.userId,
                                    "schema" : localStorage.schema,
                                    "commentId" : id
                                }),
                                success : function(data) {
                                    if (data.resultCd == "000000") {
                                        self.setSuccess();
                                    } else {
                                        self.setError(data.resultCd, data.resultMsg);
                                    }
                                },
                                error : function() {
                                    self.setError("", "サーバへの通信することができませんでした。");
                                }
                            });
                        };


                        this.hasTicket = function(ticketId) {
                            var projectId = 0;
                            $.ajax({
                                  url : urlPrefix + "checkreport/hasTicket",
                                  type : "POST",
                                  dataType : "json",
                                  headers : {
                                      "authorization" : localStorage.authId,
                                  },
                                  async : false,
                                  contentType : "application/json",
                                  data : JSON.stringify({
                                    "loginId" : localStorage.userId,
                                    "schema" : localStorage.schema,
                                    "ticketId" : ticketId
                                  }),
                                  success : function(data) {
                                      if (data.resultCd == "000000") {
                                          self.setSuccess();
                                          projectId = data.projectId;
                                      } else {
                                          self.setError(data.resultCd, data.resultMsg);
                                      }
                                  },
                                  error : function(err) {
                                      self.setError("", "サーバへの通信することができませんでした。");
                                  }
                              });
                            return projectId;
                          };

                          this.removeTicket = function(projectId, ticketId) {
                              $.ajax({
                                  url : urlPrefix + "checkreport/removeTicket",
                                  type : "POST",
                                  dataType : "json",
                                  headers : {
                                      "authorization" : localStorage.authId,
                                  },
                                  async : false,
                                  contentType : "application/json",
                                  data : JSON.stringify({
                                      "loginId" : localStorage.userId,
                                      "schema" : localStorage.schema,
                                      "projectId" : projectId,
                                      "ticketId": ticketId
                                  }),
                                  success : function(data) {
                                      if (data.resultCd == "000000") {
                                          self.setSuccess();
                                      } else {
                                          self.setError(data.resultCd, data.resultMsg);
                                      }
                                  },
                                  error : function() {
                                      self.setError("", "サーバへの通信することができませんでした。");
                                  }
                              });
                          };

                          this.getSubTicketList = function(projectId, ticketId) {
                              var subTicketList = 0;
                              $.ajax({
                                    url : urlPrefix + "checkreport/getSubTicketList",
                                    type : "POST",
                                    dataType : "json",
                                    headers : {
                                        "authorization" : localStorage.authId,
                                    },
                                    async : false,
                                    contentType : "application/json",
                                    data : JSON.stringify({
                                      "loginId" : localStorage.userId,
                                      "schema" : localStorage.schema,
                                      "projectId" : projectId,
                                      "ticketId" : ticketId
                                    }),
                                    success : function(data) {
                                        if (data.resultCd == "000000") {
                                            self.setSuccess();
                                            subTicketList = data.beanList;
                                        } else {
                                            self.setError(data.resultCd, data.resultMsg);
                                        }
                                    },
                                    error : function(err) {
                                        self.setError("", "サーバへの通信することができませんでした。");
                                    }
                                });
                              return subTicketList;
                            };

                            this.getParentTicketList = function(ticketId) {
                                var parentTicketList = 0;
                                $.ajax({
                                      url : urlPrefix + "checkreport/getParentTicketList",
                                      type : "POST",
                                      dataType : "json",
                                      headers : {
                                          "authorization" : localStorage.authId,
                                      },
                                      async : false,
                                      contentType : "application/json",
                                      data : JSON.stringify({
                                        "loginId" : localStorage.userId,
                                        "schema" : localStorage.schema,
                                        "ticketId" : ticketId
                                      }),
                                      success : function(data) {
                                          if (data.resultCd == "000000") {
                                              self.setSuccess();
                                              parentTicketList = data.beanList;
                                          } else {
                                              self.setError(data.resultCd, data.resultMsg);
                                          }
                                      },
                                      error : function(err) {
                                          self.setError("", "サーバへの通信することができませんでした。");
                                      }
                                  });
                                return parentTicketList;
                              };



                            this.hasCheckResultFile = function(checkResultId) {
                              var r = 0;
                                $.ajax({
                                      url : urlPrefix + "checkreport/hasCheckResultFile",
                                      type : "POST",
                                      dataType : "json",
                                      headers : {
                                          "authorization" : localStorage.authId,
                                      },
                                      async : false,
                                      contentType : "application/json",
                                      data : JSON.stringify({
                                        "loginId" : localStorage.userId,
                                        "schema" : localStorage.schema,
                                        "checkResultId" : checkResultId
                                      }),
                                      success : function(data) {
                                          if (data.resultCd == "000000") {
                                              self.setSuccess();
                                              r = data.fileCount;
                                          } else {
                                              self.setError(data.resultCd, data.resultMsg);
                                          }
                                      },
                                      error : function(err) {
                                          self.setError("", "サーバへの通信することができませんでした。");
                                      }
                                  });
                                return r;
                              };

                              this.getReturnNum = function(projectId, groupList) {
                                var r = 0;
                                  $.ajax({
                                        url : urlPrefix + "checkreport/getReturnNum",
                                        type : "POST",
                                        dataType : "json",
                                        headers : {
                                            "authorization" : localStorage.authId,
                                        },
                                        async : false,
                                        contentType : "application/json",
                                        data : JSON.stringify({
                                          "loginId" : localStorage.userId,
                                          "schema" : localStorage.schema,
                                          "projectId" : projectId,
                                          "groupList" : groupList
                                        }),
                                        success : function(data) {
                                            if (data.resultCd == "000000") {
                                                self.setSuccess();
                                                r = data.returnNum;
                                            } else {
                                                self.setError(data.resultCd, data.resultMsg);
                                            }
                                        },
                                        error : function(err) {
                                            self.setError("", "サーバへの通信することができませんでした。");
                                        }
                                    });
                                  return r;
                                };

                                this.getOverStartDateNum = function(projectId, groupList) {
                                  var r = 0;
                                    $.ajax({
                                          url : urlPrefix + "checkreport/getOverStartDateNum",
                                          type : "POST",
                                          dataType : "json",
                                          headers : {
                                              "authorization" : localStorage.authId,
                                          },
                                          async : false,
                                          contentType : "application/json",
                                          data : JSON.stringify({
                                            "loginId" : localStorage.userId,
                                            "schema" : localStorage.schema,
                                            "projectId" : projectId,
                                            "groupList" : groupList
                                          }),
                                          success : function(data) {
                                              if (data.resultCd == "000000") {
                                                  self.setSuccess();
                                                  r = data.overStartDateNum;
                                              } else {
                                                  self.setError(data.resultCd, data.resultMsg);
                                              }
                                          },
                                          error : function(err) {
                                              self.setError("", "サーバへの通信することができませんでした。");
                                          }
                                      });
                                    return r;
                                  };

                                  this.getOverEndDateNum = function(projectId, groupList) {
                                    var r = 0;
                                      $.ajax({
                                            url : urlPrefix + "checkreport/getOverEndDateNum",
                                            type : "POST",
                                            dataType : "json",
                                            headers : {
                                                "authorization" : localStorage.authId,
                                            },
                                            async : false,
                                            contentType : "application/json",
                                            data : JSON.stringify({
                                              "loginId" : localStorage.userId,
                                              "schema" : localStorage.schema,
                                              "projectId" : projectId,
                                              "groupList" : groupList
                                            }),
                                            success : function(data) {
                                                if (data.resultCd == "000000") {
                                                    self.setSuccess();
                                                    r = data.overEndDateNum;
                                                } else {
                                                    self.setError(data.resultCd, data.resultMsg);
                                                }
                                            },
                                            error : function(err) {
                                                self.setError("", "サーバへの通信することができませんでした。");
                                            }
                                        });
                                      return r;
                                    };

                                    this.getErrorNum = function(projectId, groupList) {
                                      var r = 0;
                                        $.ajax({
                                              url : urlPrefix + "checkreport/getErrorNum",
                                              type : "POST",
                                              dataType : "json",
                                              headers : {
                                                  "authorization" : localStorage.authId,
                                              },
                                              async : false,
                                              contentType : "application/json",
                                              data : JSON.stringify({
                                                "loginId" : localStorage.userId,
                                                "schema" : localStorage.schema,
                                                "projectId" : projectId,
                                                "groupList" : groupList
                                              }),
                                              success : function(data) {
                                                  if (data.resultCd == "000000") {
                                                      self.setSuccess();
                                                      r = data.errorNum;
                                                  } else {
                                                      self.setError(data.resultCd, data.resultMsg);
                                                  }
                                              },
                                              error : function(err) {
                                                  self.setError("", "サーバへの通信することができませんでした。");
                                              }
                                          });
                                        return r;
                                      };

                                      this.getTicketTotalNum = function(projectId, groupList, paramDateStart, paramDateEnd, firstId, secondId, thirdId, responseGroupId, responseUserId, statusId) {
                                        var r = 0;
                                          $.ajax({
                                                url : urlPrefix + "checkreport/getTicketTotal",
                                                type : "POST",
                                                dataType : "json",
                                                headers : {
                                                    "authorization" : localStorage.authId,
                                                },
                                                async : false,
                                                contentType : "application/json",
                                                data : JSON.stringify({
                                                  "loginId" : localStorage.userId,
                                                  "schema" : localStorage.schema,
                                                  "projectId" : projectId,
                                                  "statusId" : statusId,
                                                  "paramDateStart" : paramDateStart,
                                                  "paramDateEnd" : paramDateEnd,
                                                  "firstId" : firstId,
                                                  "secondId" : secondId,
                                                  "thirdId" : thirdId,
                                                  "responseGroupId" : responseGroupId,
                                                  "responseUserId" : responseUserId,
                                                  "groupList" : groupList
                                                }),
                                                success : function(data) {
                                                    if (data.resultCd == "000000") {
                                                        self.setSuccess();
                                                        r = data.totalNum;
                                                    } else {
                                                        self.setError(data.resultCd, data.resultMsg);
                                                    }
                                                },
                                                error : function(err) {
                                                    self.setError("", "サーバへの通信することができませんでした。");
                                                }
                                            });
                                          return r;
                                        };


                                    this.getAlertTicketList = function(projectId, groupList, kbn) {
                                        var ticketOb = {};
                                        $.ajax({
                                              url : urlPrefix + "checkreport/getAlertTicketList",
                                              type : "POST",
                                              dataType : "json",
                                              headers : {
                                                  "authorization" : localStorage.authId,
                                              },
                                              async : false,
                                              contentType : "application/json",
                                              data : JSON.stringify({
                                                "loginId" : localStorage.userId,
                                                "schema" : localStorage.schema,
                                                "projectId" : projectId,
                                                "kbn" : kbn,
                                                "groupList" : groupList
                                              }),
                                              success : function(data) {
                                                  if (data.resultCd == "000000") {
                                                      self.setSuccess();
                                                      ticketOb.ticketList = data.beanList;
                                                      ticketOb.flg = data.hasOpTicket;
                                                  } else {
                                                      self.setError(data.resultCd, data.resultMsg);
                                                  }
                                              },
                                              error : function(err) {
                                                  self.setError("", "サーバへの通信することができませんでした。");
                                              }
                                          });
                                        return ticketOb;
                                      };

                                      this.getGraphTicketList = function(projectId, groupList, paramDateStart, paramDateEnd, firstId, secondId, thirdId, responseGroupId, responseUserId, statusId) {
                                          var ticketOb = {};
                                          $.ajax({
                                                url : urlPrefix + "checkreport/getGraphTicketList",
                                                type : "POST",
                                                dataType : "json",
                                                headers : {
                                                    "authorization" : localStorage.authId,
                                                },
                                                async : false,
                                                contentType : "application/json",
                                                data : JSON.stringify({
                                                  "loginId" : localStorage.userId,
                                                  "schema" : localStorage.schema,
                                                  "projectId" : projectId,
                                                  "statusId" : statusId,
                                                  "paramDateStart" : paramDateStart,
                                                  "paramDateEnd" : paramDateEnd,
                                                  "firstId" : firstId,
                                                  "secondId" : secondId,
                                                  "thirdId" : thirdId,
                                                  "responseGroupId" : responseGroupId,
                                                  "responseUserId" : responseUserId,
                                                  "groupList" : groupList
                                                }),
                                                success : function(data) {
                                                    if (data.resultCd == "000000") {
                                                        self.setSuccess();
                                                        ticketOb.ticketList = data.beanList;
                                                        ticketOb.flg = data.hasOpTicket;
                                                    } else {
                                                        self.setError(data.resultCd, data.resultMsg);
                                                    }
                                                },
                                                error : function(err) {
                                                    self.setError("", "サーバへの通信することができませんでした。");
                                                }
                                            });
                                          return ticketOb;
                                        };

                                        this.getCalendarTicketList = function(projectId, groupList, paramDateStart, paramDateEnd, firstId, secondId, thirdId, responseGroupId, responseUserId) {
                                            var ticketList = [];
                                            $.ajax({
                                                  url : urlPrefix + "checkreport/getCalendarTicketList",
                                                  type : "POST",
                                                  dataType : "json",
                                                  headers : {
                                                      "authorization" : localStorage.authId,
                                                  },
                                                  async : false,
                                                  contentType : "application/json",
                                                  data : JSON.stringify({
                                                    "loginId" : localStorage.userId,
                                                    "schema" : localStorage.schema,
                                                    "projectId" : projectId,
                                                    "paramDateStart" : paramDateStart,
                                                    "paramDateEnd" : paramDateEnd,
                                                    "firstId" : firstId,
                                                    "secondId" : secondId,
                                                    "thirdId" : thirdId,
                                                    "responseGroupId" : responseGroupId,
                                                    "responseUserId" : responseUserId,
                                                    "groupList" : groupList
                                                  }),
                                                  success : function(data) {
                                                      if (data.resultCd == "000000") {
                                                          self.setSuccess();
                                                          ticketList = data.beanList;
                                                      } else {
                                                          self.setError(data.resultCd, data.resultMsg);
                                                      }
                                                  },
                                                  error : function(err) {
                                                      self.setError("", "サーバへの通信することができませんでした。");
                                                  }
                                              });
                                            return ticketList;
                                          };


                                      this.getTicketNumByChecksheetId = function(checksheetId) {
                                          var count = 0;
                                          $.ajax({
                                                url : urlPrefix + "checkreport/getTicketNumByChecksheetId",
                                                type : "POST",
                                                dataType : "json",
                                                headers : {
                                                    "authorization" : localStorage.authId,
                                                },
                                                async : false,
                                                contentType : "application/json",
                                                data : JSON.stringify({
                                                  "loginId" : localStorage.userId,
                                                  "schema" : localStorage.schema,
                                                  "checksheetId" : checksheetId
                                                }),
                                                success : function(data) {
                                                    if (data.resultCd == "000000") {
                                                        self.setSuccess();
                                                        count = data.ticketCount;
                                                    } else {
                                                        self.setError(data.resultCd, data.resultMsg);
                                                    }
                                                },
                                                error : function(err) {
                                                    self.setError("", "サーバへの通信することができませんでした。");
                                                }
                                            });
                                          return count;
                                        };

                                        this.getTicketNumByTargetId = function(targetId) {
                                            var count = 0;
                                            $.ajax({
                                                  url : urlPrefix + "checkreport/getTicketNumByTargetId",
                                                  type : "POST",
                                                  dataType : "json",
                                                  headers : {
                                                      "authorization" : localStorage.authId,
                                                  },
                                                  async : false,
                                                  contentType : "application/json",
                                                  data : JSON.stringify({
                                                    "loginId" : localStorage.userId,
                                                    "schema" : localStorage.schema,
                                                    "targetId" : targetId
                                                  }),
                                                  success : function(data) {
                                                      if (data.resultCd == "000000") {
                                                          self.setSuccess();
                                                          count = data.ticketCount;
                                                      } else {
                                                          self.setError(data.resultCd, data.resultMsg);
                                                      }
                                                  },
                                                  error : function(err) {
                                                      self.setError("", "サーバへの通信することができませんでした。");
                                                  }
                                              });
                                            return count;
                                          };


                                          this.deleteTicketList = function(ticketIdList, projectId) {
                                              $.ajax({
                                                    url : urlPrefix + "checkreport/deleteTicketList",
                                                    type : "POST",
                                                    dataType : "json",
                                                    headers : {
                                                        "authorization" : localStorage.authId,
                                                    },
                                                    async : false,
                                                    contentType : "application/json",
                                                    data : JSON.stringify({
                                                      "loginId" : localStorage.userId,
                                                      "projectId" : projectId,
                                                      "schema" : localStorage.schema,
                                                      "ticketIdList" : ticketIdList
                                                    }),
                                                    success : function(data) {
                                                        if (data.resultCd == "000000") {
                                                            self.setSuccess();
                                                        } else {
                                                            self.setError(data.resultCd, data.resultMsg);
                                                        }
                                                    },
                                                    error : function(err) {
                                                        self.setError("", "サーバへの通信することができませんでした。");
                                                    }
                                                });
                                            };


                                            this.countUnConfirmComment = function(maxDate, projectId) {
                                                var count = 0;
                                                $.ajax({
                                                      url : urlPrefix + "checkreport/countUnConfirmComment",
                                                      type : "POST",
                                                      dataType : "json",
                                                      headers : {
                                                          "authorization" : localStorage.authId,
                                                      },
                                                      async : false,
                                                      contentType : "application/json",
                                                      data : JSON.stringify({
                                                        "loginId" : localStorage.userId,
                                                        "schema" : localStorage.schema,
                                                        "projectId" : projectId,
                                                        "maxDate" : maxDate
                                                      }),
                                                      success : function(data) {
                                                          if (data.resultCd == "000000") {
                                                              self.setSuccess();
                                                              count = data.unConfirmCommentNum;
                                                          } else {
                                                              self.setError(data.resultCd, data.resultMsg);
                                                          }
                                                      },
                                                      error : function(err) {
                                                          self.setError("", "サーバへの通信することができませんでした。");
                                                      }
                                                  });
                                                return count;
                                              };

                                              this.confirmComment = function(projectId) {
                                                  $.ajax({
                                                        url : urlPrefix + "checkreport/confirmComment",
                                                        type : "POST",
                                                        dataType : "json",
                                                        headers : {
                                                            "authorization" : localStorage.authId,
                                                        },
                                                        async : false,
                                                        contentType : "application/json",
                                                        data : JSON.stringify({
                                                          "loginId" : localStorage.userId,
                                                          "projectId" : projectId,
                                                          "schema" : localStorage.schema
                                                        }),
                                                        success : function(data) {
                                                            if (data.resultCd == "000000") {
                                                                self.setSuccess();
                                                            } else {
                                                                self.setError(data.resultCd, data.resultMsg);
                                                            }
                                                        },
                                                        error : function(err) {
                                                            self.setError("", "サーバへの通信することができませんでした。");
                                                        }
                                                    });
                                                };

                                                this.getUserCommentList = function(maxDate, projectId) {
                                                    var commentList = null;
                                                    $.ajax({
                                                          url : urlPrefix + "checkreport/getUserCommentList",
                                                          type : "POST",
                                                          dataType : "json",
                                                          headers : {
                                                              "authorization" : localStorage.authId,
                                                          },
                                                          async : false,
                                                          contentType : "application/json",
                                                          data : JSON.stringify({
                                                            "loginId" : localStorage.userId,
                                                            "schema" : localStorage.schema,
                                                            "maxDate" : maxDate,
                                                            "projectId" : projectId
                                                          }),
                                                          success : function(data) {
                                                              if (data.resultCd == "000000") {
                                                                  self.setSuccess();
                                                                  commentList = data.commentList;
                                                              } else {
                                                                  self.setError(data.resultCd, data.resultMsg);
                                                              }
                                                          },
                                                          error : function(err) {
                                                              self.setError("", "サーバへの通信することができませんでした。");
                                                          }
                                                      });
                                                    return commentList;
                                                  };

                                                  this.modifyImgOrder = function(checkResultId, fileId, order) {
                                                      $.ajax({
                                                            url : urlPrefix + "checkreport/modifyImgOrder",
                                                            type : "POST",
                                                            dataType : "json",
                                                            headers : {
                                                                "authorization" : localStorage.authId,
                                                            },
                                                            async : false,
                                                            contentType : "application/json",
                                                            data : JSON.stringify({
                                                              "loginId" : localStorage.userId,
                                                              "checkResultId" : checkResultId,
                                                              "fileId" : fileId,
                                                              "order" : order,
                                                              "schema" : localStorage.schema
                                                            }),
                                                            success : function(data) {
                                                                if (data.resultCd == "000000") {
                                                                    self.setSuccess();
                                                                } else {
                                                                    self.setError(data.resultCd, data.resultMsg);
                                                                }
                                                            },
                                                            error : function(err) {
                                                                self.setError("", "サーバへの通信することができませんでした。");
                                                            }
                                                        });
                                                    };




      // ---------------------- チケット　End  --------------------

      // ---------------------- お知らせ　Start  --------------------

        this.createNews = function(projectId, limitDay, title, comment, gourpIdList) {
            $.ajax({
                  url : urlPrefix + "news/create",
                  type : "POST",
                  dataType : "json",
                  headers : {
                      "authorization" : localStorage.authId,
                  },
                  async : false,
                  contentType : "application/json",
                  data : JSON.stringify({
                    "loginId" : localStorage.userId,
                    "schema" : localStorage.schema,
                    "projectId" : projectId,
                    "limitDay" : limitDay,
                    "title" : title,
                    "groupIdList" : gourpIdList,
                    "url" : window.location.href,
                    "comment" : comment
                  }),
                  success : function(data) {
                      if (data.resultCd == "000000") {
                          self.setSuccess();
                      } else {
                          self.setError(data.resultCd, data.resultMsg);
                      }
                  },
                  error : function(err) {
                      self.setError("", "サーバへの通信することができませんでした。");
                  }
              });
          };

          this.getNewsList = function(projectId) {
              var newsList = null;
              $.ajax({
                    url : urlPrefix + "news/getList",
                    type : "POST",
                    dataType : "json",
                    headers : {
                        "authorization" : localStorage.authId,
                    },
                    async : false,
                    contentType : "application/json",
                    data : JSON.stringify({
                      "projectId" : projectId,
                      "schema" : localStorage.schema,
                      "loginId" : localStorage.userId
                    }),
                    success : function(data) {
                        if (data.resultCd == "000000") {
                            self.setSuccess();
                            newsList = data.newsList;
                        } else {
                            self.setError(data.resultCd, data.resultMsg);
                        }
                    },
                    error : function(err) {
                        self.setError("", "サーバへの通信することができませんでした。");
                    }
                });
              return newsList;
            };

            this.getUnconfirmNewsList = function(projectId) {
                var newsList = null;
                $.ajax({
                      url : urlPrefix + "news/getUnconfirmList",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                        "projectId" : projectId,
                        "schema" : localStorage.schema,
                        "loginId" : localStorage.userId
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                              newsList = data.newsList;
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function(err) {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
                return newsList;
              };

            this.getNews = function(newsId) {
                var news = new Object();
                $.ajax({
                      url : urlPrefix + "news/getNews",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                        "newsId" : newsId,
                        "schema" : localStorage.schema,
                        "loginId" : localStorage.userId
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                              news = data.news;
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function(err) {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
                return news;
              };


              this.getFileListNews = function(newsId) {
                  var fileList = [];
                  $.ajax({
                      url : urlPrefix + "news/getFileList",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                          "loginId" : localStorage.userId,
                          "schema" : localStorage.schema,
                          "newsId" : newsId,
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                              fileList = data.fileList;
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function() {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
                  return fileList;
              };

              this.removeFileNews = function(projectId, newsId, fileId, external) {
                  $.ajax({
                      url : urlPrefix + "news/removeFile",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                          "loginId" : localStorage.userId,
                          "schema" : localStorage.schema,
                          "projectId" : projectId,
                          "newsId": newsId,
                          "fileId": fileId,
                          "external": external
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function() {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
              };

              this.confirmNews = function(newsId) {
                  $.ajax({
                      url : urlPrefix + "news/confirmNews",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                          "loginId" : localStorage.userId,
                          "schema" : localStorage.schema,
                          "newsId": newsId
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function() {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
              };


              this.confirmDocument = function(projectId) {
                  $.ajax({
                      url : urlPrefix + "news/confirmDocument",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                          "loginId" : localStorage.userId,
                          "schema" : localStorage.schema,
                          "projectId" : projectId
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function() {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
              };



              this.getUserConfirm = function(newsId) {
                  var newsList = null;
                  $.ajax({
                      url : urlPrefix + "news/getUserConfirm",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                          "loginId" : localStorage.userId,
                          "schema" : localStorage.schema,
                          "newsId": newsId
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                              newsList = data.newsList;
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function() {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
                  return newsList;
              };

              this.removeNews = function(newsId, projectId) {
                  $.ajax({
                      url : urlPrefix + "news/removeNews",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                          "loginId" : localStorage.userId,
                          "schema" : localStorage.schema,
                          "projectId" : projectId,
                          "newsId": newsId
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function() {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
              };

              this.getUnConfirmNum = function(projectId) {
                var num = 0;
                  $.ajax({
                      url : urlPrefix + "news/getUnConfirmNum",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                          "loginId" : localStorage.userId,
                          "schema" : localStorage.schema,
                          "projectId" : projectId
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                              num = data.unConfirmNum;
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function() {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
                  return num;
              };

              this.getUnConfirmNumDocument = function(projectId) {
                var num = 0;
                  $.ajax({
                      url : urlPrefix + "news/getUnConfirmNumDocument",
                      type : "POST",
                      dataType : "json",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      async : false,
                      contentType : "application/json",
                      data : JSON.stringify({
                          "loginId" : localStorage.userId,
                          "schema" : localStorage.schema,
                          "projectId" : projectId
                      }),
                      success : function(data) {
                          if (data.resultCd == "000000") {
                              self.setSuccess();
                              num = data.unConfirmNum;
                          } else {
                              self.setError(data.resultCd, data.resultMsg);
                          }
                      },
                      error : function() {
                          self.setError("", "サーバへの通信することができませんでした。");
                      }
                  });
                  return num;
              };



              //----------------------KCMEお知らせ---------------------
              this.selectKcmeNews = function() {
                  var news;
                    $.ajax({
                        url : urlPrefix + "news/getKcmeNews",
                        type : "POST",
                        dataType : "json",
                        headers : {
                            "authorization" : localStorage.authId,
                        },
                        async : false,
                        contentType : "application/json",
                        data : JSON.stringify({
                        }),
                        success : function(data) {
                            if (data.resultCd == "000000") {
                                self.setSuccess();
                                news = data.kcmeNewsList;
                            } else {
                                self.setError(data.resultCd, data.resultMsg);
                            }
                        },
                        error : function() {
                            self.setError("", "サーバへの通信することができませんでした。");
                        }
                    });
                    return news;
                };

                this.createKcmeNews = function(news, type) {
                      $.ajax({
                          url : urlPrefix + "news/createKcmeNews",
                          type : "POST",
                          dataType : "json",
                          headers : {
                              "authorization" : localStorage.authId,
                          },
                          async : false,
                          contentType : "application/json",
                          data : JSON.stringify({
                              "title" : type,
                              "comment" : news
                          }),
                          success : function(data) {
                              if (data.resultCd == "000000") {
                                  self.setSuccess();
                              } else {
                                  self.setError(data.resultCd, data.resultMsg);
                              }
                          },
                          error : function() {
                              self.setError("", "サーバへの通信することができませんでした。");
                          }
                      });
                  };

                  this.deleteKcmeNews = function(id) {
                        $.ajax({
                            url : urlPrefix + "news/deleteKcmeNews",
                            type : "POST",
                            dataType : "json",
                            headers : {
                                "authorization" : localStorage.authId,
                            },
                            async : false,
                            contentType : "application/json",
                            data : JSON.stringify({
                                "newsId" : id
                            }),
                            success : function(data) {
                                if (data.resultCd == "000000") {
                                    self.setSuccess();
                                } else {
                                    self.setError(data.resultCd, data.resultMsg);
                                }
                            },
                            error : function() {
                                self.setError("", "サーバへの通信することができませんでした。");
                            }
                        });
                    };

              //-------------------KCMEお知らせ---------------------

      // ---------------------- お知らせ　End  --------------------



});

//----------------- 他言語対応 Start------------------------------
var app = angular.module('myApp', ['pascalprecht.translate'])
.config(['$translateProvider',function($translateProvider){
       /* var lang = window.localStorage.lang;
        if (lang == null || lang =="") {
          lang = "ja";
        }
        if (lang != "ja" && lang != "en" && lang != "ko") {
          lang = "ja";
        }*/
    var lang = "ja";
    $translateProvider.preferredLanguage(lang);
    $translateProvider.useStaticFilesLoader({
        prefix: '/i18n/',
        suffix: '.json'
    });
}]);

angular.module('myApp').controller('LanguageSwitchingCtrl', ['$scope', '$translate', function (scope, $translate) {
    scope.switching = function(lang){
        $translate.use(lang);
        window.localStorage.lang = lang;
        window.location.reload();
    };
    scope.cur_lang = $translate.use();
}]);

angular.module("myApp").filter("T", ['$translate', function($translate) {
    return function(key) {
        if(key){
            return $translate.instant(key);
        }
    };
}]);


//----------------- 他言語対応 End------------------------------

angular.module("myApp").filter('unique', function() {
    return function (arr, field) {
    	if (!arr) {
    		return [];
    	}
        var o = {}, i, l = arr.length, r = [];
        for(i=0; i<l;i+=1) {
            o[arr[i][field]] = arr[i];
        }
        for(i in o) {
            r.push(o[i]);
        }
        return r;
    };
  });

angular.module("myApp").filter('myStrictFilter', function($filter){
    return function(input, predicate){
        return $filter('filter')(input, predicate, true);
    }
});

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, $interval, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings, toastrConfig, toastr, $http, $window, ajaxService, $uibModal) {

//    if (!ajaxService.tokenCheck()) {
//          return;
//        };

    var whatToWait = [
      //preloader.loadAmCharts(),
      $timeout(1)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;

    $rootScope.showInfoMessage = function (msg) {
      angular.extend(toastrConfig, optionsMessage);
      openedToasts.push(toastr[optionsMessage.type](msg, optionsMessage.title));
    };

    $rootScope.showErrorMessage = function (msg) {
      angular.extend(toastrConfig, optionsError);
      openedToasts.push(toastr[optionsError.type](msg, optionsError.title));
    };

    $rootScope.showComment = function (msg) {
      angular.extend(toastrConfig, optionsInfo);
      openedToasts.push(toastr[optionsInfo.type](msg, optionsInfo.title));
    };

    $rootScope.showErrorMessage5Sec = function (msg) {
      angular.extend(toastrConfig, optionsError);
      openedToasts.push(toastr[optionsError.type](msg, optionsError.title, {"extendedTimeOut":"5500"}));
    };


    $rootScope.headerImg = "";

    $rootScope.getHeaderImg = function () {
    	var logo = ajaxService.getLogo("2");
		var path = logo.logoPath;
		if (path && path != '') {
			$rootScope.headerImg = urlPrefix + "project/showLogo/2/"+ logo.fileId +"/"+localStorage.schema;
		}
    };
    $rootScope.getHeaderImg();


    $rootScope.bookMarkImg = "";

    $rootScope.getBookMarkImg = function () {
    	var logo = ajaxService.getLogo("3");
		var path = logo.logoPath;
		if (path && path != '') {
			$rootScope.bookMarkImg = urlPrefix + "project/showLogo/3/"+ logo.fileId +"/"+localStorage.schema;
		}
    };
    $rootScope.getBookMarkImg();


    $rootScope.loginUserImg = "assets/img/app/profile/defaultUser.png";

    var url = window.location.href;
    if (url.indexOf('/project') == -1) {
    	if (! $rootScope.projectId) {
            window.location = "auth.html";
        }
    }


    $rootScope.getLoginUserImg = function () {
		var fileId = ajaxService.getUserImg(localStorage.userId);
  		if (fileId != 0) {
  			$rootScope.loginUserImg = urlPrefix + "project/showUserImg/"+ fileId +"/"+localStorage.schema;
  		}
    };

    $rootScope.getLoginUserImg();


    $rootScope.getUserImg = function (userId) {
    	var fileId = ajaxService.getUserImg(userId);
  		if (fileId != 0) {
  			return urlPrefix + "project/showUserImg/"+ fileId +"/"+localStorage.schema;
  		} else {
  			return "assets/img/app/profile/defaultUser.png";
  		}
    }


    $rootScope.getFileSize = function(size) {
      var sizes =[' B', ' KB', ' MB', ' GB', ' TB', ' PB', ' EB'];
        var ext = sizes[0];
        if (size === "") {
          return "";
        }
        size = Number(size);
        if(typeof size==='number'){
            for (var i=1;i< sizes.length;i+=1){
                if(size>= 1024){
                    size = size / 1024;
                    ext = sizes[i];
                }
            }
        }

      return $rootScope.round(size, 2).toFixed(2)+ext;
    };

    $rootScope.changeYYYYMM = function(str){
    	var year = str.substring(0, 4);
    	var month = str.substring(4, 6);
    	return year + "年" + month + "月";
    };

    $rootScope.changeTimestampToStr = function(time){
    	var d = new Date( time );
    	var year  = d.getFullYear();
    	var month = d.getMonth() + 1;
    	var day  = d.getDate();
    	var hour = ( d.getHours()   < 10 ) ? '0' + d.getHours()   : d.getHours();
    	var min  = ( d.getMinutes() < 10 ) ? '0' + d.getMinutes() : d.getMinutes();
    	var sec   = ( d.getSeconds() < 10 ) ? '0' + d.getSeconds() : d.getSeconds();
    	var str = year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec ;
        return str;
    };

    $rootScope.fromNow = function(time){
    	moment.locale('ja');
    	return moment($rootScope.changeTimestampToStr(time)).fromNow();
    };

    $rootScope.round = function(value, precision, mode) {
      var m, f, isHalf, sgn; // helper variables
      precision |= 0; // making sure precision is integer
      m = Math.pow(10, precision);
      value *= m;
      sgn = (value > 0) | -(value < 0); // sign of the number
      isHalf = value % 1 === 0.5 * sgn;
      f = Math.floor(value);

      if (isHalf) {
        switch (mode) {
        case 'PHP_ROUND_HALF_DOWN':
          value = f + (sgn < 0); // rounds .5 toward zero
          break;
        case 'PHP_ROUND_HALF_EVEN':
          value = f + (f % 2 * sgn); // rouds .5 towards the next even integer
          break;
        case 'PHP_ROUND_HALF_ODD':
          value = f + !(f % 2); // rounds .5 towards the next odd integer
          break;
        default:
          value = f + (sgn > 0); // rounds .5 away from zero
        }
      }

      return (isHalf ? value : Math.round(value)) / m;
    };

    $rootScope.downLoadFile = function (item) {

    	if (item.lastVer == 0 || !item.lastVer){
    		item.lastVer = 1;
    	}
        var ostest = $window.navigator.userAgent.toLowerCase();
        var isiOS = false;

        if ( ostest.indexOf("iphone") !== -1 || ostest.indexOf("ipad") !== -1 || ostest.indexOf("mac os x") !== -1) {
            isiOS = true;
        }

        $http.get(urlPrefix + "checklist/downLoadFile/" + item.id + "/" + item.lastVer + "/" + localStorage.schema , { responseType: "arraybuffer" }).then(
            function (response, status, headers) {
              var fileName = item.fileName.toLowerCase();
                var blob;


                if (fileName.indexOf(".pdf") != -1) {
                  blob = new Blob([response.data], { type: "application/pdf" });
                } else if (fileName.indexOf(".xls") != -1 && fileName.indexOf(".xlsx") == -1) {
                  blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
                } else if (fileName.indexOf(".xlsx") != -1) {
                  blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                } else if (fileName.indexOf(".png") != -1) {
                  blob = new Blob([response.data], { type: "image/png" });
                } else if (fileName.indexOf(".jpg") != -1 || fileName.indexOf(".jpeg") != -1) {
                  blob = new Blob([response.data], { type: "image/jpeg" });
                } else if (fileName.indexOf(".mp4") != -1) {
                  blob = new Blob([response.data], { type: "video/mpeg4" });
                } else if (fileName.indexOf(".mp3") != -1) {
                  blob = new Blob([response.data], { type: "audio/mp3" });
                } else if (fileName.indexOf(".mov") != -1) {
                  blob = new Blob([response.data], { type: "video/quicktime" });
                } else if (fileName.indexOf(".m4a") != -1) {
                  blob = new Blob([response.data], { type: "audio/aac" });
                } else {
                  blob = new Blob([response.data], { type: "" })	;
                }

                if(isiOS){
                    var reader = new FileReader();
                      reader.onload =function(e) {
                        window.open(reader.result);
                      }
                      reader.readAsDataURL(blob);
                  }else{
                    if ($window.navigator.msSaveBlob) {
                          $window.navigator.msSaveBlob(blob, item.fileName);
                      } else {
                          var downloadLink = $('<a></a>');
                          downloadLink.attr('href', $window.URL.createObjectURL(blob));
                          downloadLink.attr('download', fileName);
                          downloadLink.attr('target', '_blank');
                          $('body').append(downloadLink);
                          downloadLink[0].click();
                          downloadLink.remove();
                      }
                  }

            }, function (response, data, status) {
                if (response.status == '304') {
                  $rootScope.showErrorMessage("ファイルが削除されました。");
                }
                if (response.status == '500') {
                    $rootScope.showErrorMessage("システムエラーが発生しました。システム管理者にご連絡ください。");
                  }
                return ;
              });
    };

    $rootScope.isImg = function(fileName) {
        if (! fileName) {
          return false;
        }

        var strs = fileName.split(".");
        var index = strs.length;
        if (index > 0) {
          if (strs[1] == "jpg" || strs[1] == "JPG" || strs[1] == "png"
                || strs[1] == "PNG" || strs[1] == "jpeg"
                || strs[1] == "JPEG" || strs[1] == "ico"
                    || strs[1] == "ICO") {
              return true
            }
        } else {
          return false;
        }
      };

      $rootScope.isVideo = function(fileName) {
          if (! fileName) {
            return false;
          }

          var strs = fileName.split(".");
          var index = strs.length;
          if (index > 0) {
            if (strs[1] == "MOV" || strs[1] == "mov" || strs[1] == "MP4"
                  || strs[1] == "mp4") {
                return true
              }
          } else {
            return false;
          }
        };


        $rootScope.isRadio = function(fileName) {
            if (! fileName) {
              return false;
            }

            var strs = fileName.split(".");
            var index = strs.length;
            if (index > 0) {
              if (strs[1] == "WAV" || strs[1] == "wav" || strs[1] == "MP3"
            	  || strs[1] == "M4A" || strs[1] == "m4a"
                    || strs[1] == "mp3") {
                  return true
                }
            } else {
              return false;
            }
          };

      $rootScope.base64ToArrayBuffer = function(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        return bytes;
      };

      $rootScope.previewImage = function(item){
      var fileName = item.fileName;
        var ul = $('<ul></ul>');
        var li = $('<li></li>');

        $.ajax({
          url : urlPrefix + "checklist/selectImageFile",
          type : "POST",
          dataType : "json",
          headers : {
            "authorization" : localStorage.authId,
          },
          async : false,
          contentType : "application/json",
          data : JSON.stringify({
            "schema" : localStorage.schema,
            "fileId" : item.id,
            "version" : item.lastVer
          }),
          success : function(data) {
            if (data.resultCd == "000000") {
              var image0 = $('<img></img>');
              var sampleArr = $rootScope.base64ToArrayBuffer(data.imgFileByte);
              var blob = new Blob([ sampleArr ]);
              image0.attr('data-original', $window.URL
                          .createObjectURL(blob));
                      li[0].appendChild(image0[0]);
                      ul[0].appendChild(li[0]);

              var viewer = new Viewer(ul[0], {
                  url : 'data-original',
                });
              image0[0].click();
            } else {
              $rootScope.showErrorMessage("ファイルが削除されました。");
            }
          },
          error : function(error) {
            $rootScope.showErrorMessage("サーバへの通信することができませんでした。");
          }
        });
    };

    $rootScope.isPdf = function(item) {
      var strs = item.fileName.split(".");
      var index = strs.length;
      if (index > 0) {
          if (strs[index -1] == "pdf" || strs[index -1] == "PDF") {
              return true
            }
      } else {
        return false;
      }
    };

    $rootScope.previewPdf = function(item){
        var ostest = $window.navigator.userAgent.toLowerCase();
        var isiOS = false;
        if ( ostest.indexOf("iphone") !== -1 || ostest.indexOf("ipad") !== -1 || ostest.indexOf("mac os x") !== -1) {
            isiOS = true;
        }

        $http.get(urlPrefix + "checklist/downLoadFile/" + item.id + "/" + item.lastVer + "/" + localStorage.schema , { responseType: "arraybuffer" }).then(
            function (response, status, headers) {
                var blob;
                blob = new Blob([response.data],{ type: "application/pdf" });

                if(isiOS){
                  var reader = new FileReader();
                    reader.onload =function(e) {
                      window.open(reader.result);
                    }
                    reader.readAsDataURL(blob);
                }else{
                  window.open($window.URL.createObjectURL(blob));
                }
            }, function (response, data, status) {
            	if (response.status == '304') {
                    $rootScope.showErrorMessage("ファイルが削除されました。");
                  }
                  if (response.status == '500') {
                      $rootScope.showErrorMessage("システムエラーが発生しました。システム管理者にご連絡ください。");
                    }
                  return ;
              });
    };

    $rootScope.formatDate = function (date, format) {
      if (!date) {
        return "";
      }
      if (!format) format = 'YYYY/MM/DD hh:mm:ss.SSS';
        format = format.replace(/YYYY/g, date.getFullYear());
        format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
        format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
        format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
        format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
        format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
      if (format.match(/S/g)) {
          var milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
          var length = format.match(/S/g).length;
          for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1));
      }
        return format;
    };

    $rootScope.padLeft = function (str,lenght){
      if (!str) {
        return "";
      }
      if(str.length >= lenght)
      return str;
      else
      return $rootScope.padLeft("0" +str,lenght);
    };

    $rootScope.regionList = [
                         {label: '----', value: ""},
                         {label: '北海道', value: "1"},
                         {label: '東北', value: "2"},
                         {label: '関東', value: "3"},
                         {label: '中部', value: "4"},
                         {label: '近畿', value: "5"},
                         {label: '中国', value: "6"},
                         {label: '四国', value: "7"},
                         {label: '九州', value: "8"}
                       ];

    $rootScope.prefList = [
                       {label: '----', value: ""},
                       {label: '北海道', value: "01"},
                       {label: '青森県', value: "02"},
                       {label: '岩手県', value: "03"},
                       {label: '宮城県', value: "04"},
                       {label: '秋田県', value: "05"},
                       {label: '山形県', value: "06"},
                       {label: '福島県', value: "07"},
                       {label: '茨城県', value: "08"},
                       {label: '栃木県', value: "09"},
                       {label: '群馬県', value: "10"},
                       {label: '埼玉県', value: "11"},
                       {label: '千葉県', value: "12"},
                       {label: '東京都', value: "13"},
                       {label: '神奈川県', value: "14"},
                       {label: '新潟県', value: "15"},
                       {label: '富山県', value: "16"},
                       {label: '石川県', value: "17"},
                       {label: '福井県', value: "18"},
                       {label: '山梨県', value: "19"},
                       {label: '長野県', value: "20"},
                       {label: '岐阜県', value: "21"},
                       {label: '静岡県', value: "22"},
                       {label: '愛知県', value: "23"},
                       {label: '三重県', value: "24"},
                       {label: '滋賀県', value: "25"},
                       {label: '京都府', value: "26"},
                       {label: '大阪府', value: "27"},
                       {label: '兵庫県', value: "28"},
                       {label: '奈良県', value: "29"},
                       {label: '和歌山県', value: "30"},
                       {label: '鳥取県', value: "31"},
                       {label: '島根県', value: "32"},
                       {label: '岡山県', value: "33"},
                       {label: '広島県', value: "34"},
                       {label: '山口県', value: "35"},
                       {label: '徳島県', value: "36"},
                       {label: '香川県', value: "37"},
                       {label: '愛媛県', value: "38"},
                       {label: '高知県', value: "39"},
                       {label: '福岡県', value: "40"},
                       {label: '佐賀県', value: "41"},
                       {label: '長崎県', value: "42"},
                       {label: '熊本県', value: "43"},
                       {label: '大分県', value: "44"},
                       {label: '宮崎県', value: "45"},
                       {label: '鹿児島県', value: "46"},
                       {label: '沖縄県', value: "47"}
                       ];

    $rootScope.getPrefOb = function (prefCd) {
      for (var i = 0; i < $rootScope.prefList.length; i++) {
        if (prefCd == $rootScope.prefList[i].value) {
          return $rootScope.prefList[i];
        }
      }
    };

    $rootScope.getRegionOb = function (regionCd) {
      for (var i = 0; i < $rootScope.regionList.length; i++) {
        if (regionCd == $rootScope.regionList[i].value) {
          return $rootScope.regionList[i];
        }
      }
    };


    var itemStatusList = ajaxService.searchItemNameList("1", $rootScope.projectId);
	$rootScope.statusList = [];
	for (var i = 0; i < itemStatusList.length; i++) {
		var sOb = new Object();
		sOb.label = itemStatusList[i].showName;
		sOb.value = itemStatusList[i].fieldName;
		$rootScope.statusList.push(sOb);
	}

//    if (localStorage.mngKbn == '0'){
//      $rootScope.statusList = [
//                               {label: '作業前', value: "01"},
//                               {label: '作業中', value: "02"},
//                               {label: '作業完了', value: "03"}
//                             ];
//    } else if (localStorage.mngKbn == '1') {
//      $rootScope.statusList = [
//                               {label: '作業前', value: "01"},
//                               {label: '作業中', value: "02"},
//                               {label: '作業完了', value: "03"},
//                               {label: '承認済', value: "04"},
//                               {label: '差戻し', value: "99"}
//                             ];
//    }

	$rootScope.getStatusShowName = function (value) {

		if (! $rootScope.statusList || $rootScope.statusList.length == 0) {
			var itemStatusList = ajaxService.searchItemNameList("1", $rootScope.projectId);
			$rootScope.statusList = [];
			for (var i = 0; i < itemStatusList.length; i++) {
				var sOb = new Object();
				sOb.label = itemStatusList[i].showName;
				sOb.value = itemStatusList[i].fieldName;
				$rootScope.statusList.push(sOb);
			}
		}
        for (var i = 0; i < $rootScope.statusList.length; i++) {
          if (value == $rootScope.statusList[i].value) {
            return $rootScope.statusList[i].label;
          }
        }
      };

    $rootScope.getStatusOb = function (statusId) {
        for (var i = 0; i < $rootScope.statusList.length; i++) {
          if (statusId == $rootScope.statusList[i].value) {
            return $rootScope.statusList[i];
          }
        }
      };


      /**
      * caculate the great circle distance
      * @param {Object} lat1
      * @param {Object} lng1
      * @param {Object} lat2
      * @param {Object} lng2
      */
      $rootScope.getGreatCircleDistance = function (lat1,lng1,lat2,lng2) {

        var EARTH_RADIUS = 6378137.0; //単位 M
        var PI = Math.PI;

        var radLat1 = lat1*PI/180.0;
        var radLat2 = lat2*PI/180.0;

        var a = radLat1 - radLat2;
        var b = lng1*PI/180.0 - lng2*PI/180.0;

        var s = 2*Math.asin(Math.sqrt(Math.pow(Math.sin(a/2),2) + Math.cos(radLat1)*Math.cos(radLat2)*Math.pow(Math.sin(b/2),2)));
        s = s*EARTH_RADIUS;
        s = Math.round(s*10000)/10000.0;

        return s;
      };

      $rootScope.listContains = function (list, str) {
    	  if (!list) {
    		  return false;
    	  }
    	  if (!str) {
    		  return false;
    	  }
    	  for (var i=0;i<list.length;i++) {
    		  if (str == list[i]) {
    			  return true;
    		  }
    	  }
    	  return false;
      };

      $rootScope.getRemainDisk = function () {
    	  var usedPlanList = ajaxService.searchResource("USED_PLAN");
    	  var usedPlan = usedPlanList[0];
    	  var projectList = ajaxService.searchProjectList();

    	  var total = 0;
	  	  for(var i = 0; i < projectList.length; i++){
	  	      var project = projectList[i];
	  	      total += project.diskSpace;
	  	  }

	  	  var diskInfo = new Object();
	  	  diskInfo.remainDisk = usedPlan.value * 1024 * 1024 * 1024 - total;
	  	  diskInfo.usedPlan = usedPlan.value;
	  	  return diskInfo;
      };

      var url = window.location.href;
      var ulList = url.split("#");
      if (ulList.length >= 2) {
        var u = url.split("#")[1];
          if (u.indexOf('/showReportDetail') == 0) {
            $rootScope.$isCheckSheet = true;
          } else {
            $rootScope.$isCheckSheet = false;
          }

          if (u.indexOf('/home') == 0 ) {
              $rootScope.isHome = true;
            } else {
              $rootScope.isHome = false;
            }

          if (u.indexOf('/project') == 0) {
              $rootScope.isProject = true;
            } else {
              $rootScope.isProject = false;
            }
      }


      if (! localStorage.hasKcmeNews || localStorage.hasKcmeNews == true) {
          $rootScope.kcmeNews = ajaxService.selectKcmeNews();
          if ($rootScope.kcmeNews.length != 0) {
              $rootScope.hasKcmeNews = true;
          }
      }

      $rootScope.closeKcmeNews = function () {
    	  $rootScope.hasKcmeNews = false;
    	  localStorage.hasKcmeNews = false;
      };



      var indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB;
      $rootScope.unableOffLine = false;
	  if(!indexedDB)
	  	{
	  	    console.log("ブラウザの問題で、indexdbをサポートしません。");
	  	    $rootScope.unableOffLine = true;
	  	}

	    //チケットindexedDB
	  	$rootScope.request = indexedDB.open("tnjdb", 1);

	  	$rootScope.request.onsuccess = function (event) {
			  $rootScope.db = $rootScope.request.result;
			  $rootScope.objectStore;
			  if (!$rootScope.db.objectStoreNames.contains('ticket')) {
				  $rootScope.objectStore = $rootScope.db.createObjectStore('ticket', { keyPath: 'id' });
			  }
			};

	  	$rootScope.request.onupgradeneeded = function (event) {
	  	  $rootScope.db = event.target.result;
	  	  $rootScope.objectStore;
			  if (!$rootScope.db.objectStoreNames.contains('ticket')) {
				  $rootScope.objectStore = $rootScope.db.createObjectStore('ticket', { keyPath: 'id' });
			  }
			};

			$rootScope.addTicketIndexDb = function (ticket) {
				  var request = $rootScope.db.transaction(['ticket'], 'readwrite')
				    .objectStore('ticket')
				    .add(ticket);

				  request.onsuccess = function (event) {
				    console.log('チェックシートをダウンロードしました。');
				  };

				  request.onerror = function (event) {
					  console.error(event.currentTarget.error.message);
					  $rootScope.offLineRs = false;
				  }
		    };

			$rootScope.removeTicketIndexDb = function (key) {
				var request = $rootScope.db.transaction(['ticket'], 'readwrite')
			    .objectStore('ticket')
			    .delete(key);

			  request.onsuccess = function (event) {
			  };
			};

			$rootScope.selectTicketIndexDb = function (key) {
				var transaction = $rootScope.db.transaction(['ticket'],"readwrite");
				var store = transaction.objectStore('ticket');
				if (key) {
					var request = store.get(key);
				} else {
					var request = store.getAll();
				}
				request.onsuccess = function () {
					console.log(request.result);
					$rootScope.ticketList = request.result;
				}
			};


		//作業結果indexedDB
	  	$rootScope.request2 = indexedDB.open("tnjdb2", 2);

	  	$rootScope.request2.onsuccess = function (event) {
			  $rootScope.db2 = $rootScope.request2.result;
			  $rootScope.objectStore2;
			  if (!$rootScope.db2.objectStoreNames.contains('result')) {
				  $rootScope.objectStore2 = $rootScope.db2.createObjectStore('result', { keyPath: 'tCheckId' });
			  }
			};

	  	$rootScope.request2.onupgradeneeded = function (event) {
	  	  $rootScope.db2 = event.target.result;
	  	  $rootScope.objectStore2;
			  if (!$rootScope.db2.objectStoreNames.contains('result')) {
				  $rootScope.objectStore2 = $rootScope.db2.createObjectStore('result', { keyPath: 'tCheckId' });
			  }
			};

			$rootScope.addResultIndexDb = function (result) {
				  var request = $rootScope.db2.transaction(['result'], 'readwrite')
				    .objectStore('result')
				    .add(result);

				  request.onsuccess = function (event) {
				    console.log('チェックシートをダウンロードしました。');
				  };

				  request.onerror = function (event) {
					  console.error(event.currentTarget.error.message);
					  $rootScope.offLineRs = false;
				  }
		    };

			$rootScope.removeResultIndexDb = function (key) {
				var request = $rootScope.db2.transaction(['result'], 'readwrite')
			    .objectStore('result')
			    .delete(key);

			  request.onsuccess = function (event) {
			  };
			};

		//ファイルindexedDB
	  	$rootScope.request3 = indexedDB.open("tnjdb3", 3);

	  	$rootScope.request3.onsuccess = function (event) {
			  $rootScope.db3 = $rootScope.request3.result;
			  $rootScope.objectStore3;
			  if (!$rootScope.db3.objectStoreNames.contains('file')) {
				  $rootScope.objectStore3 = $rootScope.db3.createObjectStore('file', { keyPath: 'tRsFileId' });
			  }
			};

	  	$rootScope.request3.onupgradeneeded = function (event) {
	  	  $rootScope.db3 = event.target.result;
	  	  $rootScope.objectStore3;
			  if (!$rootScope.db3.objectStoreNames.contains('file')) {
				  $rootScope.objectStore3 = $rootScope.db3.createObjectStore('file', { keyPath: 'tRsFileId' });
			  }
			};

			$rootScope.addFileIndexDb = function (fileOb) {
				  var request = $rootScope.db3.transaction(['file'], 'readwrite')
				    .objectStore('file')
				    .add(fileOb);

				  request.onsuccess = function (event) {
				    console.log('チェックシートをダウンロードしました。');
				  };

				  request.onerror = function (event) {
					  console.error(event.currentTarget.error.message);
					  $rootScope.offLineRs = false;
				  }
		    };

			$rootScope.removeFileIndexDb = function (key) {
				var request = $rootScope.db3.transaction(['file'], 'readwrite')
			    .objectStore('file')
			    .delete(key);

			  request.onsuccess = function (event) {
			  };
			};

        //マスタデータindexedDB
	  	$rootScope.request4 = indexedDB.open("tnjdb4", 4);

	  	$rootScope.request4.onsuccess = function (event) {
			  $rootScope.db4 = $rootScope.request4.result;
			  $rootScope.objectStore4;
			  if (!$rootScope.db4.objectStoreNames.contains('master')) {
				  $rootScope.objectStore4 = $rootScope.db4.createObjectStore('master', { keyPath: 'userResourceId' });
			  }
			};

	  	$rootScope.request4.onupgradeneeded = function (event) {
	  	  $rootScope.db4 = event.target.result;
	  	  $rootScope.objectStore4;
			  if (!$rootScope.db4.objectStoreNames.contains('master')) {
				  $rootScope.objectStore4 = $rootScope.db4.createObjectStore('master', { keyPath: 'userResourceId' });
			  }
			};

			$rootScope.addMasterIndexDb = function (masterOb) {
				  var request = $rootScope.db4.transaction(['master'], 'readwrite')
				    .objectStore('master')
				    .add(masterOb);

				  request.onsuccess = function (event) {
				    console.log('チェックシートをダウンロードしました。');
				  };

				  request.onerror = function (event) {
					  console.error(event.currentTarget.error.message);
					  $rootScope.offLineRs = false;
				  }
		    };

			$rootScope.removeMasterIndexDb = function (key) {
				var request = $rootScope.db4.transaction(['master'], 'readwrite')
			    .objectStore('master')
			    .delete(key);

			  request.onsuccess = function (event) {
			  };
			};


			//コメントindexedDB
			$rootScope.request5 = indexedDB.open("tnjdb5", 5);

		  	$rootScope.request5.onsuccess = function (event) {
				  $rootScope.db5 = $rootScope.request5.result;
				  $rootScope.objectStore5;
				  if (!$rootScope.db5.objectStoreNames.contains('comment')) {
					  $rootScope.objectStore5 = $rootScope.db5.createObjectStore('comment', { keyPath: 'ticketId' });
				  }
				};

		  	$rootScope.request5.onupgradeneeded = function (event) {
		  	  $rootScope.db5 = event.target.result;
		  	  $rootScope.objectStore5;
				  if (!$rootScope.db5.objectStoreNames.contains('comment')) {
					  $rootScope.objectStore5 = $rootScope.db5.createObjectStore('comment', { keyPath: 'ticketId' });
				  }
				};

				$rootScope.addCommentIndexDb = function (commentOb) {
					  var request = $rootScope.db5.transaction(['comment'], 'readwrite')
					    .objectStore('comment')
					    .add(commentOb);

					  request.onsuccess = function (event) {
					    console.log('チェックシートをダウンロードしました。');
					  };

					  request.onerror = function (event) {
						  console.error(event.currentTarget.error.message);
						  $rootScope.offLineRs = false;
					  }
			    };

				$rootScope.removeCommentIndexDb = function (key) {
					var request = $rootScope.db5.transaction(['comment'], 'readwrite')
				    .objectStore('comment')
				    .delete(key);

				  request.onsuccess = function (event) {
				  };
				};

            //工事indexedDB
			$rootScope.request6 = indexedDB.open("tnjdb6", 6);

		  	$rootScope.request6.onsuccess = function (event) {
				  $rootScope.db6 = $rootScope.request6.result;
				  $rootScope.objectStore6;
				  if (!$rootScope.db6.objectStoreNames.contains('target')) {
					  $rootScope.objectStore6 = $rootScope.db6.createObjectStore('target', { keyPath: 'targetId' });
				  }
				};

		  	$rootScope.request6.onupgradeneeded = function (event) {
		  	  $rootScope.db6 = event.target.result;
		  	  $rootScope.objectStore6;
				  if (!$rootScope.db6.objectStoreNames.contains('target')) {
					  $rootScope.objectStore6 = $rootScope.db6.createObjectStore('target', { keyPath: 'targetId' });
				  }
				};

				$rootScope.addTargetIndexDb = function (targetOb) {
					  var request = $rootScope.db6.transaction(['target'], 'readwrite')
					    .objectStore('target')
					    .add(targetOb);

					  request.onsuccess = function (event) {
					    console.log('チェックシートをダウンロードしました。');
					  };

					  request.onerror = function (event) {
						  console.error(event.currentTarget.error.message);
						  $rootScope.offLineRs = false;
					  }
			    };

				$rootScope.removeTargetIndexDb = function (key) {
					var request = $rootScope.db6.transaction(['target'], 'readwrite')
				    .objectStore('target')
				    .delete(key);

				  request.onsuccess = function (event) {
				  };
				};
















			$rootScope.isExcel = function(fileName) {
	          if (! fileName) {
	            return false;
	          }

	          var strs = fileName.split(".");
	          var index = strs.length;
	          if (index > 0) {
	            if (strs[1] == "xls" || strs[1] == "XLS" || strs[1] == "xlsx" || strs[1] == "XLSX") {
	                return true
	              }
	          } else {
	            return false;
	          }
	        };

			//1秒ごとに、オンライン状態を確認する
			if(window.navigator.onLine){
				$rootScope.isOnLine = true;
			  } else {
				$rootScope.isOnLine = false;
			  }


			$interval(function() {

				var transaction = $rootScope.db.transaction(['ticket'],"readwrite");
				var store = transaction.objectStore('ticket');
				var request = store.count();
				request.onsuccess = function () {
					$rootScope.offTicketSize = request.result;
				}

				if(window.navigator.onLine){
					$rootScope.isOnLine = true;
					if (! $rootScope.isOnLine) {
						//　Offline→Onlineに切り替え
						window.location.reload();
					}
				  } else {
					  if ($rootScope.isOnLine) {
						  //　Online→Offlineに切り替え
						  if ($rootScope.offTicketSize > 0 && $rootScope.projectId) {
							  var modalInstance = $uibModal.open({
						            animation : true,
						            templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
						            controller : 'confirmDialogCtrl',
						            backdrop : "static",
						            resolve : {
						                message : function() {
						                    return {
						                        message : "ダウンロードチェックシート一覧に移動しますか？",
						                        flg : '3'
						                    };
						                }
						            }
						        });
						        modalInstance.result.then(function() {
						        	window.location.href = "#/offline";
						        });
						  }
					  }
					$rootScope.isOnLine = false;
				  }

        	}, 1000);




  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig, $rootScope) {

	var ua = navigator.userAgent.toLowerCase();
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(ua);
    if (isMobile) {
    	if (ua.indexOf('mobile') == -1 || ua.indexOf('ipad') > 0 ){
    		if (window.localStorage.tabletMode == '1') {
    			isMobile = false;
    		}
    	}
    }

    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);
    $rootScope.isMoblie = isMobile;

    $rootScope.projectId = window.localStorage.projectId;
    $rootScope.projectName = window.localStorage.projectName;

    $rootScope.key = ""
    if (window.localStorage.key1) {
      $rootScope.key = window.localStorage.key1;
    }

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.checklist').controller('ChecklistCtrl', ChecklistCtrl);

    /** @ngInject */
    function ChecklistCtrl($scope, $filter, editableOptions, editableThemes, toastr, baProgressModal, $http,
              toastrConfig, ajaxService, $state, $location, $window, $timeout, $uibModal, $rootScope, tr) {

    	if(! window.navigator.onLine){
    		//オフラインの場合、ダウンロードチケットへ遷移
    		window.location.href = "#/offline";
    		return;
    	}

      $scope.ctrl = $scope;
      $scope.smartTablePageSize = 20;
      $scope.defaultListPageSize = 200;
      $scope.selectedCheckSheet = null;

      $rootScope.isHome = false;
      $rootScope.isProject = false;

      if (!ajaxService.tokenCheck()) {
          return;
        };
      $scope.checksheetList = ajaxService.searchChecksheetList($rootScope.projectId, "0");
      console.log($scope.checksheetList);

      $scope.showChecklistCreate = function () {

          $scope.isCopy = false;
          //初期化
	      $scope.firstList = ajaxService.getProjectResourceList($rootScope.projectId, '91', 0);
	      $scope.firstList.unshift({label:" ", id:null})
	      $scope.secondList = [{label:"マスタデータがありません", id:null}];
	      $scope.thirdList = [{label:"マスタデータがありません", id:null}];
	      $scope.fourthList = [{label:"マスタデータがありません", id:null}];

	      $scope.first = $scope.firstList[0];
	      $scope.second = $scope.secondList[0];
	      $scope.third = $scope.thirdList[0];
	      $scope.fourth = $scope.fourthList[0];

	      $scope.firstDisable = false;
	      $scope.secondDisable = true;
	      $scope.thirdDisable = true;
	      $scope.fourthDisable = true;

	      $scope.frequency = "";

        $uibModal.open({
            animation : true,
            templateUrl : 'app/pages/checklist/newList.html',
            scope : $scope,
            size: 'lg',
            backdrop : "static",
            resolve : {
                message : function() {
                    return {
                    };
                }
            }
        });
      };

      $scope.changeFirst = function () {
      	$scope.secondList = ajaxService.getProjectResourceList($rootScope.projectId, '92', $scope.first.id);
          if ($scope.secondList.length == 0) {
            $scope.secondList.push({label:"マスタデータがありません", id:0});
              $scope.secondDisable = true;
          } else {
              $scope.secondDisable = false;
          }
          $scope.second = $scope.secondList[0];
          $scope.changeSecond();
      };

      $scope.changeSecond = function () {
          $scope.thirdList = ajaxService.getProjectResourceList($rootScope.projectId, '93', $scope.second.id);
	        if ($scope.thirdList.length == 0) {
	          $scope.thirdList.push({label:"マスタデータがありません", id:0});
	            $scope.thirdDisable = true;
	        } else {
	            $scope.thirdDisable = false;
	        }
	        $scope.third = $scope.thirdList[0];
	        $scope.changeThird();
      };

      $scope.changeThird = function () {
          $scope.fourthList = ajaxService.getProjectResourceList($rootScope.projectId, '94', $scope.third.id);

        //コピー時、コピー元を選択させない。
          var j = -1;
          if ($scope.fourthList.length != 0 && $scope.isCopy) {
          	for (var i = 0; i<$scope.fourthList.length; i ++) {
          		if ($scope.fourthList[i].id == $scope.copyMoto.fourthId) {
          			j = i;
          		}
          	}
          }
          if (j >= 0) {
          	$scope.fourthList.splice(j, 1);
          }

	        if ($scope.fourthList.length == 0) {
	          $scope.fourthList.push({label:"マスタデータがありません", id:0});
	            $scope.fourthDisable = true;
	        } else {
	            $scope.fourthDisable = false;
	        }
	        $scope.fourth = $scope.fourthList[0];
      };


      $scope.createCheckSheet = function () {


    	if (!$scope.fourth.id || $scope.fourth.id == 0 ) {
          $rootScope.showErrorMessage("小項目までを選択してください。マスタデータがない場合、マスタデータを登録してからやり直してください。");
          return true;
    	}

    	var checklistName = $scope.first.label + '⇒' + $scope.second.label + '⇒' + $scope.third.label + '⇒' + $scope.fourth.label;

        $scope.checksheetId = ajaxService.createChecksheet($scope.fourth.id, checklistName, $scope.frequency, $rootScope.projectId);

        if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            return true;
        }
        $rootScope.showInfoMessage("チェックを新規作成しました。");
        $scope.$$childTail.$dismiss();
        $scope.checksheetList = ajaxService.searchChecksheetList($rootScope.projectId, "0");

        $scope.showChecklistDetail($scope.checksheetList[0]);
      };


      $scope.searchFileList = function () {
        $scope.fileList = ajaxService.getFileList($rootScope.selectedChecksheetId);
      };


      $scope.showChecklistDetail = function(item) {

        $rootScope.selectedChecksheetId = item.checksheetId;

        $scope.selectedCheckSheet = item;
        $scope.$$childTail.$$prevSibling.$$prevSibling.$$prevSibling.getCheckList();
        $scope.$$childTail.$$prevSibling.$$prevSibling.$$prevSibling.init();

        $scope.searchFileList();

        $scope.isUsedByTicket = false;
        var ticketNum = ajaxService.getTicketNumByChecksheetId($rootScope.selectedChecksheetId);
        if (ticketNum != 0) {
        	$scope.isUsedByTicket = true;
        }

        $("#listDetail").css({
          'display' : 'block'
        });

        $("#fileList").css({
          'display' : 'block'
        });

        $("body,html").animate({
            scrollTop : $("#listDetail").offset().top - 100
        }, 1000);

      };

      $scope.showChecklistDetail2 = function(item) {

          $rootScope.selectedChecksheetId = item.checksheetId;

          $scope.selectedCheckSheet = item;
          $scope.$$childTail.$$prevSibling.$$prevSibling.getCheckList();
          $scope.$$childTail.$$prevSibling.$$prevSibling.init();

          $scope.searchFileList();
          $scope.isUsedByTicket = false;
          var ticketNum = ajaxService.getTicketNumByChecksheetId($rootScope.selectedChecksheetId);
          if (ticketNum != 0) {
          	$scope.isUsedByTicket = true;
          }

          $("#listDetail").css({
            'display' : 'block'
          });

          $("#fileList").css({
            'display' : 'block'
          });

          $("body,html").animate({
              scrollTop : $("#listDetail").offset().top - 100
          }, 1000);

        };

      $scope.showCopyChecksheet = function(item) {

        $scope.isCopy = true;

        $scope.ctrl = $scope;
          //初期化
	      $scope.firstList = ajaxService.getProjectResourceList($rootScope.projectId, '91', 0);
	      $scope.firstList.unshift({label:" ", id:null})
	      $scope.secondList = [{label:"マスタデータがありません", id:null}];
	      $scope.thirdList = [{label:"マスタデータがありません", id:null}];
	      $scope.fourthList = [{label:"マスタデータがありません", id:null}];

	      $scope.first = $scope.firstList[0];
	      $scope.second = $scope.secondList[0];
	      $scope.third = $scope.thirdList[0];
	      $scope.fourth = $scope.fourthList[0];

	      $scope.firstDisable = false;
	      $scope.secondDisable = true;
	      $scope.thirdDisable = true;
	      $scope.fourthDisable = true;

          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/newList.html',
              scope : $scope,
              size: 'lg',
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                      };
                  }
              }
          });


        $scope.copyMoto = item;
        $scope.frequency = $scope.copyMoto.frequency;

        };

        $scope.copyCheckSheet = function() {

	    	if (!$scope.fourth.id || $scope.fourth.id == 0 ) {
	              $rootScope.showErrorMessage("小項目までを選択してください。マスタデータがない場合、マスタデータを登録してからやり直してください。");
	              return true;
            }

	        var checklistName = $scope.first.label + '⇒' + $scope.second.label + '⇒' + $scope.third.label + '⇒' + $scope.fourth.label;

            $scope.checksheetId = ajaxService.copyChecksheet($scope.copyMoto.checksheetId, $scope.fourth.id, checklistName, $scope.frequency, $scope.copyMoto.fourthId, $rootScope.projectId);
            $scope.checksheetList = ajaxService.searchChecksheetList($rootScope.projectId, "0");
            $scope.showChecklistDetail($scope.checksheetList[0]);
            $rootScope.showInfoMessage("チェックをコピーしました。");
            $scope.$$childTail.$dismiss();

        };


      $scope.getNewChecksheetName = function (name) {
        for (var i=0; i<$scope.checksheetList.length; i++) {
          if (name == $scope.checksheetList[i].checksheetName) {
           return $scope.getNewChecksheetName(name + "-コピー");
          }
        }
        return name;
      };

      $scope.deleteChecksheet = function () {

        var ticketNum = ajaxService.getTicketNumByChecksheetId($rootScope.selectedChecksheetId);
        if (ticketNum !=0) {
          $rootScope.showErrorMessage("該当チェックを使用されているため、削除できません。");
          return "";
        }

        var msg = "現在のバージョン削除してもよろしいですか？";
        if ($scope.selectedCheckSheet.version == 1) {
        	msg = "削除してもよろしいですか？";
        }

        var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : msg
                      };
                  }
              }
          });
          modalInstance.result.then(function() {
            ajaxService.removeChecksheet($rootScope.selectedChecksheetId, $rootScope.projectId);
            if (ajaxService.result['resultCd'] != "000000") {
              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            } else {
              $rootScope.showInfoMessage("チェックを削除しました。");
              $scope.checksheetList = ajaxService.searchChecksheetList($rootScope.projectId, "0");
              $("#listDetail").css({
                  'display' : 'none'
                });
              $("#fileList").css({
                  'display' : 'none'
                });
            }
          });
      };

      $scope.versionUp = function() {
    	  //バージョンアップ：自身コピー
      	  var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : "チェックのバージョンをアップしてもよろしですか？"
                      };
                  }
              }
          });

      	  modalInstance.result.then(function() {
      		$scope.checksheetId = ajaxService.copyChecksheet($scope.selectedCheckSheet.checksheetId, $scope.selectedCheckSheet.fourthId, $scope.selectedCheckSheet.checksheetName, $scope.selectedCheckSheet.frequency, $scope.selectedCheckSheet.fourthId, $rootScope.projectId);
      		$scope.checksheetList = ajaxService.searchChecksheetList($rootScope.projectId, "0");
            $scope.showChecklistDetail($scope.checksheetList[0]);
            $rootScope.showInfoMessage("チェックのバージョンをアップしました。");
      	  });

    	  }

      $scope.saveList = function() {

        if (!$scope.selectedCheckSheet.checksheetName) {
          $rootScope.showErrorMessage("チェック名を入力してください。");
          return "";
        }

        var ticketNum = ajaxService.getTicketNumByChecksheetId($rootScope.selectedChecksheetId);
        if (ticketNum !=0) {
        	//チェックを利用されているので、バージョンをアップします。
          $rootScope.showErrorMessage("チェックバージョンをアップしてからやり直してください。");
          return "";
        }

        var modalInstance = $uibModal.open({
            animation : true,
            templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
            controller : 'confirmDialogCtrl',
            scope : $scope,
            backdrop : "static",
            resolve : {
                message : function() {
                    return {
                        message : "保存してもよろしいですか？"
                    };
                }
            }
        });
        modalInstance.result.then(function() {
          var clcScope = $scope.$$childHead.$$nextSibling;

          ajaxService.modifyChecksheet($rootScope.selectedChecksheetId, $scope.selectedCheckSheet.frequency, $rootScope.projectId, $scope.selectedCheckSheet.releaseFlag);
          if (ajaxService.result['resultCd'] != "000000") {
              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              return "";
          }

          if (clcScope.removeIdList.length != 0) {
            ajaxService.removeChecklist(clcScope.removeIdList, $rootScope.projectId);
            if (ajaxService.result['resultCd'] == "000000") {
              clcScope.removeIdList = new Array();
            }
          }

          for (var i=0; i<clcScope.todoList.length; i++) {
            var downloadF = "1";
              if (! $("#downloadFlg"+i).prop("checked")) {
                downloadF = "0";
              }
              clcScope.todoList[i].downloadFlgStr = downloadF;
              clcScope.todoList[i].sort = i + 1;
          }

          ajaxService.modifyChecklist(clcScope.todoList);

          $rootScope.showInfoMessage("チェックを更新しました。");
          $scope.checksheetList = ajaxService.searchChecksheetList($rootScope.projectId, "0");
          $scope.$$childTail.newTodoText = '';
        });

        return "";
      };


      $scope.openDetail = function (page, info) {
        $uibModal.open({
          animation: true,
          templateUrl: page,
          controller: 'DetailCtrl',
          size: 'lg',
          backdrop : "static",
          scope : $scope,
          resolve: {
              checklistInfo: function () {
                  return {
                    checklistId : info.checklistId,
                    checklistName : info.checklistName,
                    checklistContent : info.checklistContent
                  };
            }
          }
        });
      };

      /* Jiwon ： 異常値設定のモダール　 */
        $scope.openLimit = function (page, info) {
        $uibModal.open({
          animation: true,
          templateUrl: page,
          controller: 'LimitCtrl',
          backdrop : "static",
          scope : $scope,
          resolve: {
              checkdetailInfo: function () {
                  return {
                    title: info.title,
                    id : info.id,

                  };
            }
          }
        });
      };

           /* Jiwon  */
        $scope.openFileModal = function (page, info) {
        $uibModal.open({
          animation: true,
          templateUrl: page,
          controller: 'AddFileInDetailCtrl',
          backdrop : "static",
          scope : $scope,
          resolve: {
              openFlag : function() {
                      return {
                          'flag' : 'New',
                          'kbn' : 'Checksheet',
                          'id': $rootScope.selectedChecksheetId,
                          'detailId': info.id
                      };
                  }
          }
        });
      };

      $scope.openUploadDialog = function() {
          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/fileUploadModal.html',
              controller : 'FileUploadCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  openFlag : function() {
                      return {
                          'flag' : 'New',
                          'kbn' : 'Checksheet',
                          'id': $rootScope.selectedChecksheetId
                      };
                  }
              }
          });
      };

      $scope.delFile = function (fileBean) {
        var modalInstance = $uibModal.open({
            animation : true,
            templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
            controller : 'confirmDialogCtrl',
            scope : $scope,
            backdrop : "static",
            resolve : {
                message : function() {
                    return {
                        message : "該当ファイルを削除してもよろしいですか？"
                    };
                }
            }
        });

        modalInstance.result.then(function() {
          ajaxService.removeFile($rootScope.projectId, $rootScope.selectedChecksheetId, fileBean.id, fileBean.fileExternal);
          if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
          } else {
            $rootScope.showInfoMessage("該当ファイルを削除しました。");
            $scope.searchFileList();
          }
        });
      };



      $scope.showCheckAllInfo = function(checksheetId, checksheetName) {

    	  //チェック全体を取得する
          $scope.checkAllList = ajaxService.getCheckAllInfoList(checksheetId);

    	  var listId = 0;
    	  var j = 0;
    	  for (var i=0; i< $scope.checkAllList.length; i++) {
    		  if (listId == $scope.checkAllList[i].checklistId) {
    			  $scope.checkAllList[i].checklistName = "";
    			  $scope.checkAllList[j].togoNum = $scope.checkAllList[j].togoNum + 1;
    		  } else {
    			  j = i;
    			  listId = $scope.checkAllList[i].checklistId;
    			  $scope.checkAllList[j].togoNum = 1;
    		  }
    	  }

    	  $scope.checksheetName = checksheetName;

    	  $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/checkAll.html',
              scope : $scope,
              size: 'lg',
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                        type : ""
                      };
                  }
              }
          });
      };

      $scope.showCheckAllInfoAtDetail = function(){
    	  $scope.showCheckAllInfo($scope.selectedCheckSheet.checksheetId, $scope.selectedCheckSheet.checksheetName);
      }

      $scope.allChoice = false;
      $scope.checksheetChoice = [];

      $scope.resetPage = function() {
          $scope.allChoice = false;
          $scope.checksheetChoice = [];
      };

      $scope.showDefaultChecklist = function(){

    	  $scope.defaultChecksheetList = ajaxService.searchChecksheetList('0', "0");

    	  $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/defaultChecksheetList.html',
              scope : $scope,
              size: 'lg',
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                        type : ""
                      };
                  }
              }
          });
      };


      $scope.copyDefaultChecksheet = function(item){

    	  console.log(item);
    	  $scope.checksheetId = ajaxService.copyDefaultChecksheet(item, $rootScope.projectId);

          if (ajaxService.result['resultCd'] != "000000") {
              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              return;
          }
          $rootScope.showInfoMessage("デフォルトチェックをコピーしました。");
          $scope.checksheetList = ajaxService.searchChecksheetList($rootScope.projectId, "0");


          $("#listDetail").css({
            'display' : 'none'
          });

          $("#fileList").css({
            'display' : 'none'
          });

      };


      $scope.copyDefaultChecksheetList  = function(){
    	  console.log($scope.checksheetChoice);

    	  if ($scope.checksheetChoice.length == 0) {
    		  $rootScope.showErrorMessage("デフォルトチェックを選択してください。");
    		  return true;
    	  }

    	  $scope.copyList = [];
    	  $scope.complete = 0;

    	  for (var i = 0; i < $scope.checksheetChoice.length; i ++) {
    		  for (var j = 0; j < $scope.defaultChecksheetList.length; j ++) {
    			  if ($scope.checksheetChoice[i]) {
    				  if (i == $scope.defaultChecksheetList[j].checksheetId) {
    					  $scope.copyList.push($scope.defaultChecksheetList[j]);
        			  }
    			  }

    		  }
    	  }

    	  baProgressModal.open('app/pages/checklist/progressModalProcessing.html',$scope);

    	  $scope.doCopyList();

      };

      $scope.doCopyList = function() {

    	  var i = $scope.complete;

    	  var item = $scope.copyList[i];

		  $http({
              url : urlPrefix + "checklist/copyDefaultChecksheet",
        	  method: "POST",
        	  data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "projectId" : $rootScope.projectId,
                  "checksheetName" : item.checksheetName,
                  "copyFromResourceId" : item.fourthId,
                  "frequency" : item.frequency,
                  "first" : item.first,
                  "second" : item.second,
                  "third" : item.third,
                  "fourth" : item.fourth,
                  "checksheetId" : item.checksheetId
                          }), //this is your json data string
              headers: {
            	 "authorization" : localStorage.authId,
                 'Content-type': 'application/json'
              },
              responseType: 'arraybuffer'

          }).success(function (data, status, headers, config) {

        	  i++;
              $scope.complete = i;

              if (i < $scope.copyList.length) {
                  $timeout($scope.doCopyList, 100);
                } else {
                	$rootScope.showInfoMessage("デフォルトチェックを"+$scope.complete+"件コピーしました。");
                    $scope.checksheetList = ajaxService.searchChecksheetList($rootScope.projectId, "0");

                    baProgressModal.close();

                    $scope.resetPage();

                    $("#listDetail").css({
                      'display' : 'none'
                    });

                    $("#fileList").css({
                      'display' : 'none'
                    });
                }


          }).error(function (data, status, headers, config) {
        	  $rootScope.showErrorMessage("システムエラーが発生しました。システム管理者にご連絡ください。");
        	  baProgressModal.close();
              $scope.resetPage();
          });

      };


	  $scope.projectList = ajaxService.searchProjectList(window.localStorage.regionCode);
	  for (var i = 0; i < $scope.projectList.length; i++) {
		  if ($scope.projectList[i].projectId == $rootScope.projectId) {
			  $scope.projectList.splice(i, 1);
			  break;
		  }
	  }

      $scope.showOtherProjectList = function(){

    	  $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/projectList.html',
              scope : $scope,
              size: 'lg',
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                        type : ""
                      };
                  }
              }
          });
      };

      $scope.showOtherChecklist = function(otherProjectId, otherProjectName){

    	  $scope.otherChecksheetList = ajaxService.searchChecksheetList(otherProjectId, "1");
    	  $scope.otherProjectName = otherProjectName;

    	  console.log($scope.otherChecksheetList);

    	  $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/otherChecksheetList.html',
              scope : $scope,
              size: 'lg',
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                        type : ""
                      };
                  }
              }
          });
      };



      $scope.copyOtherChecksheet = function(item){

    	  ajaxService.copyOtherChecksheet(item, $rootScope.projectId);

          if (ajaxService.result['resultCd'] != "000000") {
              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              return;
          }
          $rootScope.showInfoMessage("チェックをコピーしました。");
          $scope.checksheetList = ajaxService.searchChecksheetList($rootScope.projectId, "0");

          $("#listDetail").css({
            'display' : 'none'
          });

          $("#fileList").css({
            'display' : 'none'
          });

      };


      $scope.copyOtherChecksheetList  = function(){
    	  console.log($scope.checksheetChoice);

    	  if ($scope.checksheetChoice.length == 0) {
    		  $rootScope.showErrorMessage("チェックを選択してください。");
    		  return true;
    	  }

    	  $scope.copyList = [];
    	  $scope.complete = 0;

    	  for (var i = 0; i < $scope.checksheetChoice.length; i ++) {
    		  for (var j = 0; j < $scope.otherChecksheetList.length; j ++) {
    			  if ($scope.checksheetChoice[i]) {
    				  if (i == $scope.otherChecksheetList[j].checksheetId) {
    					  $scope.copyList.push($scope.otherChecksheetList[j]);
        			  }
    			  }

    		  }
    	  }

    	  baProgressModal.open('app/pages/checklist/progressModalProcessing.html',$scope);

    	  $scope.doOtherCopyList();

      };


      $scope.doOtherCopyList = function() {

    	  var i = $scope.complete;

    	  var item = $scope.copyList[i];

		  $http({
              url : urlPrefix + "checklist/copyOtherChecksheet",
        	  method: "POST",
        	  data : JSON.stringify({
                  "schema" : localStorage.schema,
                  "loginId" : localStorage.userId,
                  "projectId" : $rootScope.projectId,
                  "checksheetName" : item.checksheetName,
                  "copyFromResourceId" : item.fourthId,
                  "frequency" : item.frequency,
                  "first" : item.first,
                  "second" : item.second,
                  "third" : item.third,
                  "fourth" : item.fourth,
                  "checksheetId" : item.checksheetId
                          }), //this is your json data string
              headers: {
            	 "authorization" : localStorage.authId,
                 'Content-type': 'application/json'
              },
              responseType: 'arraybuffer'

          }).success(function (data, status, headers, config) {

        	  i++;
              $scope.complete = i;

              if (i < $scope.copyList.length) {
                  $timeout($scope.doOtherCopyList, 100);
                } else {
                	$rootScope.showInfoMessage("チェックを"+$scope.complete+"件コピーしました。");
                    $scope.checksheetList = ajaxService.searchChecksheetList($rootScope.projectId, "0");

                    baProgressModal.close();

                    $scope.resetPage();

                    $("#listDetail").css({
                      'display' : 'none'
                    });

                    $("#fileList").css({
                      'display' : 'none'
                    });
                }


          }).error(function (data, status, headers, config) {
        	  $rootScope.showErrorMessage("システムエラーが発生しました。システム管理者にご連絡ください。");
        	  baProgressModal.close();
              $scope.resetPage();
          });

      };

        //報告書設定
	    $scope.showDownloadInfo = function(checksheetId, checksheetName){


	    	  var chId = checksheetId;
	    	  var chName = checksheetName;

	    	  if (! chId) {
	    		  chId = $scope.selectedCheckSheet.checksheetId;
	    	  }
	    	  if (! chName) {
	    		  chName = $scope.selectedCheckSheet.checksheetName;
	    	  }

	    	  $uibModal.open({
	              animation : true,
	              templateUrl : 'app/pages/checklist/downloadSetting.html',
	              scope : $scope,
	              controller : 'DownloadSettingCtrl',
	              size: 'lg',
	              backdrop : "static",
	              resolve : {
	            	  checksheetInfo : function() {
	                      return {
	                        checksheetId : chId,
	                        checksheetName : chName,
	                      };
	                  }
	              }
	          });
	      };

    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.checklist')
      .controller('DownloadSettingCtrl', DownloadSettingCtrl);

  /** @ngInject */
  function DownloadSettingCtrl($scope, $rootScope, baConfig, $timeout, ajaxService, $uibModal, tr, checksheetInfo, $sce) {

    if (!ajaxService.tokenCheck()) {
          return;
        };


    $scope.defaultFileName =  "報告書({{物件名}}_{{チェック名}})_{{チェックシートID}}";

    $scope.fileNameTooltip = $sce.trustAsHtml('<div style="text-align:left">指定できるキーワードは{{物件ID}}、{{物件名}}、{{チェック名}}、{{チェックシートID}}、{{ステータス}}、{{完了日(実績)}}、{{担当者}}、{{担当グループ}}、{{出力日付}}、{{出力時刻}}です。</div>');
    $scope.imgTooltip = $sce.trustAsHtml('<div style="text-align:left">セル数は縦横それぞれ35以上を推奨します。また、報告書テンプレートと合せる必要があります。</div>');
    $scope.signTooltip = $sce.trustAsHtml('<div style="text-align:left">報告書テンプレート上で手書きエリアは正方形にして下さい。セル数は30以上を指定して下さい。</div>');
    $scope.checksheetId =checksheetInfo.checksheetId;
    $scope.checksheetName =checksheetInfo.checksheetName;

    $scope.initTicketAndTarget = function () {
    	$scope.ticketAndTargetInfo = ajaxService.getDownloadSetting($scope.checksheetId);
    	if ($scope.ticketAndTargetInfo.ticketBean) {
    		//チェックシートのキー初期化
    		var ticketB = $scope.ticketAndTargetInfo.ticketBean;
    		$scope.ticketIdKey = ticketB.ticketIdKey;
    		if (!$scope.ticketIdKey) {
    			$scope.ticketIdKey = "[[チェックシートID]]";
    		}
    		$scope.ticketStatusKey = ticketB.ticketStatusKey;
    		if (!$scope.ticketStatusKey) {
    			$scope.ticketStatusKey = "[[ステータス]]";
    		}
    		$scope.startScheduledDateKey = ticketB.startScheduledDateKey;
    		if (!$scope.startScheduledDateKey) {
    			$scope.startScheduledDateKey = "[[開始日(予定)]]";
    		}
    		$scope.endScheduledDateKey = ticketB.endScheduledDateKey;
    		if (!$scope.endScheduledDateKey) {
    			$scope.endScheduledDateKey = "[[完了日(予定)]]";
    		}
    		$scope.startDateKey = ticketB.startDateKey;
    		if (!$scope.startDateKey) {
    			$scope.startDateKey = "[[開始日(実績)]]";
    		}
    		$scope.endDateKey = ticketB.endDateKey;
    		if (!$scope.endDateKey) {
    			$scope.endDateKey = "[[完了日(実績)]]";
    		}
    		$scope.requestUserKey = ticketB.requestUserKey;
    		if (!$scope.requestUserKey) {
    			$scope.requestUserKey = "[[管理技術者]]";
    		}
    		$scope.requestGroupKey = ticketB.requestGroupKey;
    		if (!$scope.requestGroupKey) {
    			$scope.requestGroupKey = "[[指示グループ]]";
    		}
    		$scope.responseUserKey = ticketB.responseUserKey;
    		if (!$scope.responseUserKey) {
    			$scope.responseUserKey = "[[担当技術者]]";
    		}
    		$scope.responseGroupKey = ticketB.responseGroupKey;
    		if (!$scope.responseGroupKey) {
    			$scope.responseGroupKey = "[[担当技術者グループ]]";
    		}
    		$scope.readingGroupKey = ticketB.readingGroupKey;
    		if (!$scope.readingGroupKey) {
    			$scope.readingGroupKey = "[[閲覧グループ]]";
    		}
    		$scope.statusDetailKey = ticketB.statusDetailKey;
    		if (!$scope.statusDetailKey) {
    			$scope.statusDetailKey = "[[チェックシート区分1]]";
    		}
    		$scope.ticketKbn2Key = ticketB.ticketKbn2Key;
    		if (!$scope.ticketKbn2Key) {
    			$scope.ticketKbn2Key = "[[チェックシート区分2]]";
    		}
    		$scope.ticketKbn3Key = ticketB.ticketKbn3Key;
    		if (!$scope.ticketKbn3Key) {
    			$scope.ticketKbn3Key = "[[チェックシート区分3]]";
    		}
    		$scope.ticketKbn4Key = ticketB.ticketKbn4Key;
    		if (!$scope.ticketKbn4Key) {
    			$scope.ticketKbn4Key = "[[チェックシート区分4]]";
    		}
    		$scope.ticketKbn5Key = ticketB.ticketKbn5Key;
    		if (!$scope.ticketKbn5Key) {
    			$scope.ticketKbn5Key = "[[チェックシート区分5]]";
    		}
    		$scope.ticketItem1Key = ticketB.ticketItem1Key;
    		if (!$scope.ticketItem1Key) {
    			$scope.ticketItem1Key = "[[チェックシート属性1]]";
    		}
    		$scope.ticketItem2Key = ticketB.ticketItem2Key;
    		if (!$scope.ticketItem2Key) {
    			$scope.ticketItem2Key = "[[チェックシート属性2]]";
    		}
    		$scope.ticketItem3Key = ticketB.ticketItem3Key;
    		if (!$scope.ticketItem3Key) {
    			$scope.ticketItem3Key = "[[チェックシート属性3]]";
    		}
    		$scope.ticketItem4Key = ticketB.ticketItem4Key;
    		if (!$scope.ticketItem4Key) {
    			$scope.ticketItem4Key = "[[チェックシート属性4]]";
    		}
    		$scope.ticketItem5Key = ticketB.ticketItem5Key;
    		if (!$scope.ticketItem5Key) {
    			$scope.ticketItem5Key = "[[チェックシート属性5]]";
    		}
    	} else {
			$scope.ticketIdKey = "[[チェックシートID]]";
    		$scope.ticketStatusKey = "[[ステータス]]";
			$scope.startScheduledDateKey = "[[開始日(予定)]]";
    		$scope.endScheduledDateKey = "[[完了日(予定)]]";
    		$scope.startDateKey = "[[開始日(実績)]]";
			$scope.endDateKey = "[[完了日(実績)]]";
			$scope.requestUserKey = "[[管理技術者]]";
			$scope.requestGroupKey = "[[指示グループ]]";
			$scope.responseUserKey = "[[担当技術者]]";
			$scope.responseGroupKey = "[[担当技術者グループ]]";
			$scope.readingGroupKey = "[[閲覧グループ]]";
			$scope.statusDetailKey = "[[チェックシート区分1]]";
			$scope.ticketKbn2Key = "[[チェックシート区分2]]";
			$scope.ticketKbn3Key = "[[チェックシート区分3]]";
			$scope.ticketKbn4Key = "[[チェックシート区分4]]";
			$scope.ticketKbn5Key = "[[チェックシート区分5]]";
			$scope.ticketItem1Key = "[[チェックシート属性1]]";
			$scope.ticketItem2Key = "[[チェックシート属性2]]";
			$scope.ticketItem3Key = "[[チェックシート属性3]]";
			$scope.ticketItem4Key = "[[チェックシート属性4]]";
			$scope.ticketItem5Key = "[[チェックシート属性5]]";
    	}

    	if ($scope.ticketAndTargetInfo.targetBean) {
    		//物件のキー初期化
    		var targetB = $scope.ticketAndTargetInfo.targetBean;
    		$scope.targetIdKey = targetB.targetIdKey;
    		if (!$scope.targetIdKey) {
    			$scope.targetIdKey = "[[工事ID]]";
    		}
    		$scope.targetNameKey = targetB.targetNameKey;
    		if (!$scope.targetNameKey) {
    			$scope.targetNameKey = "[[工事名]]";
    		}
    		$scope.firstKey = targetB.firstKey;
    		if (!$scope.firstKey) {
    			$scope.firstKey = "[[カテゴリ（大）]]";
    		}
    		$scope.secondKey = targetB.secondKey;
    		if (!$scope.secondKey) {
    			$scope.secondKey = "[[カテゴリ（中）]]";
    		}
    		$scope.thirdKey = targetB.thirdKey;
    		if (!$scope.thirdKey) {
    			$scope.thirdKey = "[[カテゴリ（小）]]";
    		}
    		$scope.addressKey = targetB.addressKey;
    		if (!$scope.addressKey) {
    			$scope.addressKey = "[[住所]]";
    		}
    		$scope.latKey = targetB.latKey;
    		if (!$scope.latKey) {
    			$scope.latKey = "[[緯度]]";
    		}
    		$scope.lonKey = targetB.lonKey;
    		if (!$scope.lonKey) {
    			$scope.lonKey = "[[経度]]";
    		}
    		$scope.kbn1Key = targetB.kbn1Key;
    		if (!$scope.kbn1Key) {
    			$scope.kbn1Key = "[[物件区分1]]";
    		}
    		$scope.kbn2Key = targetB.kbn2Key;
    		if (!$scope.kbn2Key) {
    			$scope.kbn2Key = "[[物件区分2]]";
    		}
    		$scope.kbn3Key = targetB.kbn3Key;
    		if (!$scope.kbn3Key) {
    			$scope.kbn3Key = "[[物件区分3]]";
    		}
    		$scope.kbn4Key = targetB.kbn4Key;
    		if (!$scope.kbn4Key) {
    			$scope.kbn4Key = "[[物件区分4]]";
    		}
    		$scope.kbn5Key = targetB.kbn5Key;
    		if (!$scope.kbn5Key) {
    			$scope.kbn5Key = "[[物件区分5]]";
    		}
    		$scope.item1Key = targetB.item1Key;
    		if (!$scope.item1Key) {
    			$scope.item1Key = "[[属性1]]";
    		}
    		$scope.item2Key = targetB.item2Key;
    		if (!$scope.item2Key) {
    			$scope.item2Key = "[[属性2]]";
    		}
    		$scope.item3Key = targetB.item3Key;
    		if (!$scope.item3Key) {
    			$scope.item3Key = "[[属性3]]";
    		}
    		$scope.item4Key = targetB.item4Key;
    		if (!$scope.item4Key) {
    			$scope.item4Key = "[[属性4]]";
    		}
    		$scope.item5Key = targetB.item5Key;
    		if (!$scope.item5Key) {
    			$scope.item5Key = "[[属性5]]";
    		}
    		$scope.item6Key = targetB.item6Key;
    		if (!$scope.item6Key) {
    			$scope.item1Key = "[[属性6]]";
    		}
    		$scope.item7Key = targetB.item7Key;
    		if (!$scope.item7Key) {
    			$scope.item7Key = "[[属性7]]";
    		}
    		$scope.item8Key = targetB.item8Key;
    		if (!$scope.item8Key) {
    			$scope.item8Key = "[[属性8]]";
    		}
    		$scope.item9Key = targetB.item9Key;
    		if (!$scope.item9Key) {
    			$scope.item9Key = "[[属性9]]";
    		}
    		$scope.item10Key = targetB.item10Key;
    		if (!$scope.item10Key) {
    			$scope.item10Key = "[[属性10]]";
    		}
    		$scope.item11Key = targetB.item11Key;
    		if (!$scope.item11Key) {
    			$scope.item11Key = "[[属性11]]";
    		}
    		$scope.item12Key = targetB.item12Key;
    		if (!$scope.item12Key) {
    			$scope.item12Key = "[[属性12]]";
    		}
    		$scope.item13Key = targetB.item13Key;
    		if (!$scope.item13Key) {
    			$scope.item13Key = "[[属性13]]";
    		}
    		$scope.item14Key = targetB.item14Key;
    		if (!$scope.item14Key) {
    			$scope.item14Key = "[[属性14]]";
    		}
    		$scope.item15Key = targetB.item15Key;
    		if (!$scope.item15Key) {
    			$scope.item15Key = "[[属性15]]";
    		}
    		$scope.item16Key = targetB.item16Key;
    		if (!$scope.item16Key) {
    			$scope.item16Key = "[[属性16]]";
    		}
    		$scope.item17Key = targetB.item17Key;
    		if (!$scope.item17Key) {
    			$scope.item17Key = "[[属性17]]";
    		}
    		$scope.item18Key = targetB.item18Key;
    		if (!$scope.item18Key) {
    			$scope.item18Key = "[[属性18]]";
    		}
    		$scope.item19Key = targetB.item19Key;
    		if (!$scope.item19Key) {
    			$scope.item19Key = "[[属性19]]";
    		}
    		$scope.item20Key = targetB.item20Key;
    		if (!$scope.item20Key) {
    			$scope.item20Key = "[[属性20]]";
    		}
    	} else {
			$scope.targetIdKey = "[[物件ID]]";
			$scope.targetNameKey = "[[物件名]]";
			$scope.firstKey = "[[カテゴリ（大）]]";
			$scope.secondKey = "[[カテゴリ（中）]]";
			$scope.thirdKey = "[[カテゴリ（小）]]";
			$scope.addressKey = "[[住所]]";
			$scope.latKey = "[[緯度]]";
			$scope.lonKey = "[[経度]]";
			$scope.kbn1Key = "[[物件区分1]]";
			$scope.kbn2Key = "[[物件区分2]]";
			$scope.kbn3Key = "[[物件区分3]]";
			$scope.kbn4Key = "[[物件区分4]]";
			$scope.kbn5Key = "[[物件区分5]]";
			$scope.item1Key = "[[属性1]]";
			$scope.item2Key = "[[属性2]]";
			$scope.item3Key = "[[属性3]]";
			$scope.item4Key = "[[属性4]]";
			$scope.item5Key = "[[属性5]]";
			$scope.item6Key = "[[属性6]]";
			$scope.item7Key = "[[属性7]]";
			$scope.item8Key = "[[属性8]]";
			$scope.item9Key = "[[属性9]]";
			$scope.item10Key = "[[属性10]]";
			$scope.item11Key = "[[属性11]]";
			$scope.item12Key = "[[属性12]]";
			$scope.item13Key = "[[属性13]]";
			$scope.item14Key = "[[属性14]]";
			$scope.item15Key = "[[属性15]]";
			$scope.item16Key = "[[属性16]]";
			$scope.item17Key = "[[属性17]]";
			$scope.item18Key = "[[属性18]]";
			$scope.item19Key = "[[属性19]]";
			$scope.item20Key = "[[属性20]]";
    	}
    }

    $scope.initTicketAndTarget();

    $scope.getTempFile = function () {
        var rs = ajaxService.getTempFile($scope.checksheetId);
        if (rs) {
        	$scope.file = rs.file;
        	$scope.downloadFileName = rs.downloadFileName;
        }
    };

    $scope.getTempFile();


    $scope.saveDownloadFile = function () {
    	$uibModal.open({
            animation : true,
            templateUrl : 'app/pages/checklist/fileUploadModal.html',
            controller : 'FileUploadCtrl',
            scope : $scope,
            backdrop : "static",
            resolve : {
                openFlag : function() {
                    return {
                        'flag' : 'New',
                        'kbn' : 'DownloadSetting',
                        'id': $scope.checksheetId
                    };
                }
            }
        });

    };

    $scope.saveExcelFile = function () {
    	$uibModal.open({
            animation : true,
            templateUrl : 'app/pages/checklist/excelUploadModal.html',
            controller : 'FileUploadCtrl',
            scope : $scope,
            backdrop : "static",
            resolve : {
                openFlag : function() {
                    return {
                        'flag' : 'New',
                        'kbn' : 'DownloadSetting',
                        'id': $scope.checksheetId
                    };
                }
            }
        });

    };

    $scope.removeDownloadSetting = function () {
    	var modalInstance = $uibModal.open({
            animation : true,
            templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
            controller : 'confirmDialogCtrl',
            scope : $scope,
            backdrop : "static",
            resolve : {
                message : function() {
                    return {
                        message : "テンプレートファイルを削除してもよろしいですか？"
                    };
                }
            }
        });
        modalInstance.result.then(function() {
          ajaxService.removeTempFile($rootScope.projectId, $scope.checksheetId, $scope.file.id, $scope.file.fileExternal);
          if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
          } else {
            $rootScope.showInfoMessage("テンプレートファイルを削除しました。");
            $scope.getTempFile();
          }
        });
    };

    $scope.getTicketItem = function () {
    	$scope.itemTicketList = ajaxService.searchItemNameList('3', $rootScope.projectId);
		$scope.showStatusDetail = false;
        $scope.showTicketKbn2 = false;
        $scope.showTicketKbn3 = false;
        $scope.showTicketKbn4 = false;
        $scope.showTicketKbn5 = false;
        $scope.showTicketItem1 = false;
        $scope.showTicketItem2 = false;
        $scope.showTicketItem3 = false;
        $scope.showTicketItem4 = false;
        $scope.showTicketItem5 = false;

        for (var i=0; i<$scope.itemTicketList.length; i++) {
            var field = $scope.itemTicketList[i].fieldName;
            if (field == "statusDetail") {
              $scope.statusDetailItemName = $scope.itemTicketList[i].showName;
              if ($scope.itemTicketList[i].isShow != '1') {
                  $scope.showStatusDetail = true;
              }
            }
            if (field == "kbn2") {
                $scope.kbn2ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showTicketKbn2 = true;
                }
              }
            if (field == "kbn3") {
                $scope.kbn3ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showTicketKbn3 = true;
                }
              }
            if (field == "kbn4") {
                $scope.kbn4ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showTicketKbn4 = true;
                }
              }
            if (field == "kbn5") {
                $scope.kbn5ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showTicketKbn5 = true;
                }
              }
            if (field == "item1") {
                $scope.item1ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showTicketItem1 = true;
                }
              }
            if (field == "item2") {
                $scope.item2ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showTicketItem2 = true;
                }
              }
            if (field == "item3") {
                $scope.item3ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showTicketItem3 = true;
                }
              }
            if (field == "item4") {
                $scope.item4ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showTicketItem4 = true;
                }
              }
            if (field == "item5") {
                $scope.item5ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showTicketItem5 = true;
                }
              }
 		 }
    };

    $scope.getTicketItem();


    $scope.getTargetItem = function () {
        $scope.itemNameList = ajaxService.getTargetItemList($rootScope.projectId);

        $scope.showTargetId = false;
        $scope.showTargetName = false;
        $scope.showFirst = false;
        $scope.showSecond = false;
        $scope.showThird = false;
        $scope.showObjType = false;
        $scope.showRegion = false;
        $scope.showPref = false;
        $scope.showMuniName = false;
        $scope.showAddress = false;
        $scope.showLatitude = false;
        $scope.showLongitude = false;
        $scope.showKbn1 = false;
        $scope.showKbn2 = false;
        $scope.showKbn3 = false;
        $scope.showKbn4 = false;
        $scope.showKbn5 = false;
        $scope.showItem1 = false;
        $scope.showItem2 = false;
        $scope.showItem3 = false;
        $scope.showItem4 = false;
        $scope.showItem5 = false;
        $scope.showItem6 = false;
        $scope.showItem7 = false;
        $scope.showItem8 = false;
        $scope.showItem9 = false;
        $scope.showItem10 = false;
        $scope.showItem11 = false;
        $scope.showItem12 = false;
        $scope.showItem13 = false;
        $scope.showItem14 = false;
        $scope.showItem15 = false;
        $scope.showItem16 = false;
        $scope.showItem17 = false;
        $scope.showItem18 = false;
        $scope.showItem19 = false;
        $scope.showItem20 = false;

        if ($rootScope.projectId == 0) {
        	$scope.showTargetName = true;
            $scope.itemTargetName = "対象工事名";
        }

        for (var i=0; i<$scope.itemNameList.length; i++) {
            if ($scope.itemNameList[i].fieldName == 'targetId') {
                $scope.showTargetId = true;
                $scope.itemTargetId = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'targetName') {
                $scope.showTargetName = true;
                $scope.itemTargetName = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'first') {
                $scope.showFirst = true;
                $scope.itemFirst = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'second') {
                $scope.showSecond = true;
                $scope.itemSecond = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'third') {
                $scope.showThird = true;
                $scope.itemThird = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'objType') {
                $scope.showObjType = true;
                $scope.itemObjType = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'region') {
                $scope.showRegion = true;
                $scope.itemRegion = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'prefCd') {
                $scope.showPref = true;
                $scope.itemPref = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'muniName') {
                $scope.showMuniName = true;
                $scope.itemMuniName = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'address') {
                $scope.showAddress = true;
                $scope.itemAddress = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'latitude') {
                $scope.showLatitude = true;
                $scope.itemLatitude = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'longitude') {
                $scope.showLongitude = true;
                $scope.itemLongitude = $scope.itemNameList[i].showName;
            }

            if ($scope.itemNameList[i].fieldName == "kbn1") {
            	$scope.showKbn1 = true;
                $scope.itemKbn1 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == "kbn2") {
            	$scope.showKbn2 = true;
                $scope.itemKbn2 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == "kbn3") {
            	$scope.showKbn3 = true;
                $scope.itemKbn3 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == "kbn4") {
            	$scope.showKbn4 = true;
                $scope.itemKbn4 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == "kbn5") {
            	$scope.showKbn5 = true;
                $scope.itemKbn5 = $scope.itemNameList[i].showName;
            }

            if ($scope.itemNameList[i].fieldName == 'remarks1') {
                $scope.showItem1 = true;
                $scope.itemItem1 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks2') {
                $scope.showItem2 = true;
                $scope.itemItem2 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks3') {
                $scope.showItem3 = true;
                $scope.itemItem3 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks4') {
                $scope.showItem4 = true;
                $scope.itemItem4 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks5') {
                $scope.showItem5 = true;
                $scope.itemItem5 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks6') {
                $scope.showItem6 = true;
                $scope.itemItem6 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks7') {
                $scope.showItem7 = true;
                $scope.itemItem7 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks8') {
                $scope.showItem8 = true;
                $scope.itemItem8 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks9') {
                $scope.showItem9 = true;
                $scope.itemItem9 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks10') {
                $scope.showItem10 = true;
                $scope.itemItem10 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks11') {
                $scope.showItem11 = true;
                $scope.itemItem11 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks12') {
                $scope.showItem12 = true;
                $scope.itemItem12 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks13') {
                $scope.showItem13 = true;
                $scope.itemItem13 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks14') {
                $scope.showItem14 = true;
                $scope.itemItem14 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks15') {
                $scope.showItem15 = true;
                $scope.itemItem15 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks16') {
                $scope.showItem16 = true;
                $scope.itemItem16 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks17') {
                $scope.showItem17 = true;
                $scope.itemItem17 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks18') {
                $scope.showItem18 = true;
                $scope.itemItem18 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks19') {
                $scope.showItem19 = true;
                $scope.itemItem19 = $scope.itemNameList[i].showName;
            }
            if ($scope.itemNameList[i].fieldName == 'remarks20') {
                $scope.showItem20 = true;
                $scope.itemItem20 = $scope.itemNameList[i].showName;
            }
        }
    };

    $scope.getTargetItem();

    $scope.showCheckAllInfo = function() {
        $scope.checkAllList = ajaxService.getCheckAllInfoListWithKey($scope.checksheetId);

  	    var listId = 0;
  	    var j = 0;
  	    for (var i=0; i< $scope.checkAllList.length; i++) {

  	      var checkListNm = "";
  	      if ($scope.checkAllList[i].checklistName) {
  	    	checkListNm =$scope.checkAllList[i].checklistName;
  	      }

  	      if (! $scope.checkAllList[i].key) {
  	    	$scope.checkAllList[i].key = "[[" + checkListNm + " " + $scope.checkAllList[i].checkDetailName + "]]";
  	      }

  	      if ($scope.checkAllList[i].inputTypeId == 7 && ($scope.checkAllList[i].outNum == null || $scope.checkAllList[i].outNum == "")) {
  	    	  //写真
  	    	  $scope.checkAllList[i].outNum = "1";
  	    	  $scope.checkAllList[i].maxNumInLine = 1;
  	    	  $scope.checkAllList[i].cellNum = 30;
  	    	  $scope.checkAllList[i].cellNumCol = 30;
  	    	  $scope.checkAllList[i].commentCellNum = 3;
  	      }

  	      if ($scope.checkAllList[i].inputTypeId == 10 && ($scope.checkAllList[i].cellNum == null || $scope.checkAllList[i].cellNum == 0)) {
  	    	  $scope.checkAllList[i].cellNum = 30;
  	      }

  	      if ($scope.checkAllList[i].dlErea == 'true') {
  	    	  $scope.checkAllList[i].dlErea = true;
  	      } else {
  	    	  $scope.checkAllList[i].dlErea = false;
  	      }

  		  if (listId == $scope.checkAllList[i].checklistId) {
  			  $scope.checkAllList[i].checklistName = "";
  			  $scope.checkAllList[j].togoNum = $scope.checkAllList[j].togoNum + 1;
  		  } else {
  			  j = i;
  			  listId = $scope.checkAllList[i].checklistId;
  			  $scope.checkAllList[j].togoNum = 1;
  		  }
  	    }
    };

    $scope.showCheckAllInfo();

    $scope.addMark = function (ob, value) {

    	if (ob[value]){
        	ob[value] = ob[value].trim();
    		if (ob[value].startsWith("[[") && ob[value].endsWith("]]")) {
    			return;
    		} else {
    			ob[value] = "[[" + ob[value] + "]]";
    		}
    	}
    };


    $scope.addMarkCheckList = function (item) {

    	if (item.key){
        	item.key = item.key.trim();
    		if (item.key.startsWith("[[") && item.key.endsWith("]]")) {
    			return;
    		} else {
    			item.key = "[[" + item.key + "]]";
    		}
    	}

    }

    $scope.saveDownloadSetting = function () {

    	var keyList = new Array();

    	//チェックシートキーワード
    	var ticketKeyInfo = new Object();
    	//var ticketScope = $scope.$$childHead.$$nextSibling.$$childHead.$$childTail;
    	var ticketScope = $scope.$$childHead.$$nextSibling.$$nextSibling.$$childHead.$$childTail;
    	ticketKeyInfo.ticketIdKey = ticketScope.ticketIdKey;
    	if (ticketKeyInfo.ticketIdKey) {
    		keyList.push(ticketKeyInfo.ticketIdKey);
    	}

    	ticketKeyInfo.ticketStatusKey = ticketScope.ticketStatusKey;
    	if (ticketKeyInfo.ticketStatusKey) {
    		if (keyList.indexOf(ticketKeyInfo.ticketStatusKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.ticketStatusKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.ticketStatusKey);
    		}
    	}
    	ticketKeyInfo.startScheduledDateKey = ticketScope.startScheduledDateKey;
    	if (ticketKeyInfo.startScheduledDateKey) {
    		if (keyList.indexOf(ticketKeyInfo.startScheduledDateKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.startScheduledDateKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.startScheduledDateKey);
    		}
    	}
    	ticketKeyInfo.endScheduledDateKey = ticketScope.endScheduledDateKey;
    	if (ticketKeyInfo.endScheduledDateKey) {
    		if (keyList.indexOf(ticketKeyInfo.endScheduledDateKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.endScheduledDateKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.endScheduledDateKey);
    		}
    	}
    	ticketKeyInfo.startDateKey = ticketScope.startDateKey;
    	if (ticketKeyInfo.startDateKey) {
    		if (keyList.indexOf(ticketKeyInfo.startDateKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.startDateKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.startDateKey);
    		}
    	}
    	ticketKeyInfo.endDateKey = ticketScope.endDateKey;
    	if (ticketKeyInfo.endDateKey) {
    		if (keyList.indexOf(ticketKeyInfo.endDateKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.endDateKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.endDateKey);
    		}
    	}
    	ticketKeyInfo.requestUserKey = ticketScope.requestUserKey;
    	if (ticketKeyInfo.requestUserKey) {
    		if (keyList.indexOf(ticketKeyInfo.requestUserKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.requestUserKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.requestUserKey);
    		}
    	}
    	ticketKeyInfo.requestGroupKey = ticketScope.requestGroupKey;
    	if (ticketKeyInfo.requestGroupKey) {
    		if (keyList.indexOf(ticketKeyInfo.requestGroupKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.requestGroupKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.requestGroupKey);
    		}
    	}
    	ticketKeyInfo.responseUserKey = ticketScope.responseUserKey;
    	if (ticketKeyInfo.responseUserKey) {
    		if (keyList.indexOf(ticketKeyInfo.responseUserKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.responseUserKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.responseUserKey);
    		}
    	}
    	ticketKeyInfo.responseGroupKey = ticketScope.responseGroupKey;
    	if (ticketKeyInfo.responseGroupKey) {
    		if (keyList.indexOf(ticketKeyInfo.responseGroupKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.responseGroupKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.responseGroupKey);
    		}
    	}
    	ticketKeyInfo.readingGroupKey = ticketScope.readingGroupKey;
    	if (ticketKeyInfo.readingGroupKey) {
    		if (keyList.indexOf(ticketKeyInfo.readingGroupKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.readingGroupKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.readingGroupKey);
    		}
    	}
    	ticketKeyInfo.statusDetailKey = ticketScope.statusDetailKey;
    	if (ticketKeyInfo.statusDetailKey) {
    		if (keyList.indexOf(ticketKeyInfo.statusDetailKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.statusDetailKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.statusDetailKey);
    		}
    	}
    	ticketKeyInfo.ticketKbn2Key = ticketScope.ticketKbn2Key;
    	if (ticketKeyInfo.ticketKbn2Key) {
    		if (keyList.indexOf(ticketKeyInfo.ticketKbn2Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.ticketKbn2Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.ticketKbn2Key);
    		}
    	}
    	ticketKeyInfo.ticketKbn3Key = ticketScope.ticketKbn3Key;
    	if (ticketKeyInfo.ticketKbn3Key) {
    		if (keyList.indexOf(ticketKeyInfo.ticketKbn3Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.ticketKbn3Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.ticketKbn3Key);
    		}
    	}
    	ticketKeyInfo.ticketKbn4Key = ticketScope.ticketKbn4Key;
    	if (ticketKeyInfo.ticketKbn4Key) {
    		if (keyList.indexOf(ticketKeyInfo.ticketKbn4Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.ticketKbn4Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.ticketKbn4Key);
    		}
    	}
    	ticketKeyInfo.ticketKbn5Key = ticketScope.ticketKbn5Key;
    	if (ticketKeyInfo.ticketKbn5Key) {
    		if (keyList.indexOf(ticketKeyInfo.ticketKbn5Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.ticketKbn5Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.ticketKbn5Key);
    		}
    	}
    	ticketKeyInfo.ticketItem1Key = ticketScope.ticketItem1Key;
    	if (ticketKeyInfo.ticketItem1Key) {
    		if (keyList.indexOf(ticketKeyInfo.ticketItem1Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.ticketItem1Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.ticketItem1Key);
    		}
    	}
    	ticketKeyInfo.ticketItem2Key = ticketScope.ticketItem2Key;
    	if (ticketKeyInfo.ticketItem2Key) {
    		if (keyList.indexOf(ticketKeyInfo.ticketItem2Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.ticketItem2Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.ticketItem2Key);
    		}
    	}
    	ticketKeyInfo.ticketItem3Key = ticketScope.ticketItem3Key;
    	if (ticketKeyInfo.ticketItem3Key) {
    		if (keyList.indexOf(ticketKeyInfo.ticketItem3Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.ticketItem3Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.ticketItem3Key);
    		}
    	}
    	ticketKeyInfo.ticketItem4Key = ticketScope.ticketItem4Key;
    	if (ticketKeyInfo.ticketItem4Key) {
    		if (keyList.indexOf(ticketKeyInfo.ticketItem4Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.ticketItem4Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.ticketItem4Key);
    		}
    	}
    	ticketKeyInfo.ticketItem5Key = ticketScope.ticketItem5Key;
    	if (ticketKeyInfo.ticketItem5Key) {
    		if (keyList.indexOf(ticketKeyInfo.ticketItem5Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+ticketKeyInfo.ticketItem5Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(ticketKeyInfo.ticketItem5Key);
    		}
    	}

    	//物件キーワード
    	var targetKeyInfo = new Object();
    	var targetScope = $scope.$$childHead.$$nextSibling.$$nextSibling.$$nextSibling.$$childHead.$$childTail;
    	targetKeyInfo.targetIdKey = targetScope.targetIdKey;
    	if (targetKeyInfo.targetIdKey) {
    		if (keyList.indexOf(targetKeyInfo.targetIdKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.targetIdKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.targetIdKey);
    		}
    	}
    	targetKeyInfo.targetNameKey = targetScope.targetNameKey;
    	if (targetKeyInfo.targetNameKey) {
    		if (keyList.indexOf(targetKeyInfo.targetNameKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.targetNameKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.targetNameKey);
    		}
    	}
    	targetKeyInfo.firstKey = targetScope.firstKey;
    	if (targetKeyInfo.firstKey) {
    		if (keyList.indexOf(targetKeyInfo.firstKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.firstKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.firstKey);
    		}
    	}
    	targetKeyInfo.secondKey = targetScope.secondKey;
    	if (targetKeyInfo.secondKey) {
    		if (keyList.indexOf(targetKeyInfo.secondKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.secondKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.secondKey);
    		}
    	}
    	targetKeyInfo.thirdKey = targetScope.thirdKey;
    	if (targetKeyInfo.thirdKey) {
    		if (keyList.indexOf(targetKeyInfo.thirdKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.thirdKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.thirdKey);
    		}
    	}
    	targetKeyInfo.addressKey = targetScope.addressKey;
    	if (targetKeyInfo.addressKey) {
    		if (keyList.indexOf(targetKeyInfo.addressKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.addressKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.addressKey);
    		}
    	}
    	targetKeyInfo.latKey = targetScope.latKey;
    	if (targetKeyInfo.latKey) {
    		if (keyList.indexOf(targetKeyInfo.latKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.latKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.latKey);
    		}
    	}
    	targetKeyInfo.lonKey = targetScope.lonKey;
    	if (targetKeyInfo.lonKey) {
    		if (keyList.indexOf(targetKeyInfo.lonKey) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.lonKey+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.lonKey);
    		}
    	}
    	targetKeyInfo.kbn1Key = targetScope.kbn1Key;
    	if (targetKeyInfo.kbn1Key) {
    		if (keyList.indexOf(targetKeyInfo.kbn1Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.kbn1Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.kbn1Key);
    		}
    	}
    	targetKeyInfo.kbn2Key = targetScope.kbn2Key;
    	if (targetKeyInfo.kbn2Key) {
    		if (keyList.indexOf(targetKeyInfo.kbn2Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.kbn2Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.kbn2Key);
    		}
    	}
    	targetKeyInfo.kbn3Key = targetScope.kbn3Key;
    	if (targetKeyInfo.kbn3Key) {
    		if (keyList.indexOf(targetKeyInfo.kbn3Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.kbn3Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.kbn3Key);
    		}
    	}
    	targetKeyInfo.kbn4Key = targetScope.kbn4Key;
    	if (targetKeyInfo.kbn4Key) {
    		if (keyList.indexOf(targetKeyInfo.kbn4Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.kbn4Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.kbn4Key);
    		}
    	}
    	targetKeyInfo.kbn5Key = targetScope.kbn5Key;
    	if (targetKeyInfo.kbn5Key) {
    		if (keyList.indexOf(targetKeyInfo.kbn5Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.kbn5Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.kbn5Key);
    		}
    	}
    	targetKeyInfo.item1Key = targetScope.item1Key;
    	if (targetKeyInfo.item1Key) {
    		if (keyList.indexOf(targetKeyInfo.item1Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item1Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item1Key);
    		}
    	}
    	targetKeyInfo.item2Key = targetScope.item2Key;
    	if (targetKeyInfo.item2Key) {
    		if (keyList.indexOf(targetKeyInfo.item2Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item2Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item2Key);
    		}
    	}
    	targetKeyInfo.item3Key = targetScope.item3Key;
    	if (targetKeyInfo.item3Key) {
    		if (keyList.indexOf(targetKeyInfo.item3Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item3Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item3Key);
    		}
    	}
    	targetKeyInfo.item4Key = targetScope.item4Key;
    	if (targetKeyInfo.item4Key) {
    		if (keyList.indexOf(targetKeyInfo.item4Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item4Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item4Key);
    		}
    	}
    	targetKeyInfo.item5Key = targetScope.item5Key;
    	if (targetKeyInfo.item5Key) {
    		if (keyList.indexOf(targetKeyInfo.item5Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item5Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item5Key);
    		}
    	}
    	targetKeyInfo.item6Key = targetScope.item6Key;
    	if (targetKeyInfo.item6Key) {
    		if (keyList.indexOf(targetKeyInfo.item6Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item6Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item6Key);
    		}
    	}
    	targetKeyInfo.item7Key = targetScope.item7Key;
    	if (targetKeyInfo.item7Key) {
    		if (keyList.indexOf(targetKeyInfo.item7Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item7Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item7Key);
    		}
    	}
    	targetKeyInfo.item8Key = targetScope.item8Key;
    	if (targetKeyInfo.item8Key) {
    		if (keyList.indexOf(targetKeyInfo.item8Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item8Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item8Key);
    		}
    	}
    	targetKeyInfo.item9Key = targetScope.item9Key;
    	if (targetKeyInfo.item9Key) {
    		if (keyList.indexOf(targetKeyInfo.item9Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item9Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item9Key);
    		}
    	}
    	targetKeyInfo.item10Key = targetScope.item10Key;
    	if (targetKeyInfo.item10Key) {
    		if (keyList.indexOf(targetKeyInfo.item10Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item10Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item10Key);
    		}
    	}
    	targetKeyInfo.item11Key = targetScope.item11Key;
    	if (targetKeyInfo.item11Key) {
    		if (keyList.indexOf(targetKeyInfo.item11Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item11Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item11Key);
    		}
    	}
    	targetKeyInfo.item12Key = targetScope.item12Key;
    	if (targetKeyInfo.item12Key) {
    		if (keyList.indexOf(targetKeyInfo.item12Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item12Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item12Key);
    		}
    	}
    	targetKeyInfo.item13Key = targetScope.item13Key;
    	if (targetKeyInfo.item13Key) {
    		if (keyList.indexOf(targetKeyInfo.item13Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item13Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item13Key);
    		}
    	}
    	targetKeyInfo.item14Key = targetScope.item14Key;
    	if (targetKeyInfo.item14Key) {
    		if (keyList.indexOf(targetKeyInfo.item14Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item14Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item14Key);
    		}
    	}
    	targetKeyInfo.item15Key = targetScope.item15Key;
    	if (targetKeyInfo.item15Key) {
    		if (keyList.indexOf(targetKeyInfo.item15Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item15Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item15Key);
    		}
    	}
    	targetKeyInfo.item16Key = targetScope.item16Key;
    	if (targetKeyInfo.item16Key) {
    		if (keyList.indexOf(targetKeyInfo.item16Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item16Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item16Key);
    		}
    	}
    	targetKeyInfo.item17Key = targetScope.item17Key;
    	if (targetKeyInfo.item17Key) {
    		if (keyList.indexOf(targetKeyInfo.item17Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item17Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item17Key);
    		}
    	}
    	targetKeyInfo.item18Key = targetScope.item18Key;
    	if (targetKeyInfo.item18Key) {
    		if (keyList.indexOf(targetKeyInfo.item18Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item18Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item18Key);
    		}
    	}
    	targetKeyInfo.item19Key = targetScope.item19Key;
    	if (targetKeyInfo.item19Key) {
    		if (keyList.indexOf(targetKeyInfo.item19Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item19Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item19Key);
    		}
    	}
    	targetKeyInfo.item20Key = targetScope.item20Key;
    	if (targetKeyInfo.item20Key) {
    		if (keyList.indexOf(targetKeyInfo.item20Key) >= 0) {
                $rootScope.showErrorMessage("キーワード"+targetKeyInfo.item20Key+"が重複しています。ご確認ください。");
                return ;
    		} else {
        		keyList.push(targetKeyInfo.item20Key);
    		}
    	}

    	var checkInfoList = new Array();
    	var posPattern = /^\d+$/;
    	for (var i = 0; i<$scope.checkAllList.length; i++) {
    		if ($scope.checkAllList[i].key) {
        		if (keyList.indexOf($scope.checkAllList[i].key) >= 0) {
                    $rootScope.showErrorMessage("キーワード"+$scope.checkAllList[i].key+"が重複しています。ご確認ください。");
                    return ;
        		} else {
            		keyList.push($scope.checkAllList[i].key);
        		}
        	}
    		if (($scope.checkAllList[i].inputTypeId != "0" && $scope.checkAllList[i].inputTypeId != "8" && $scope.checkAllList[i].inputTypeId != "9" &&
    			$scope.checkAllList[i].inputTypeId != "11" && $scope.checkAllList[i].inputTypeId != "13") || $scope.checkAllList[i].checkDetailId == 0) {
    			var checkInfo = new Object();
    			checkInfo.checklistId = $scope.checkAllList[i].checklistId;
    			checkInfo.checkDetailId = $scope.checkAllList[i].checkDetailId;
    			checkInfo.inputTypeId = $scope.checkAllList[i].inputTypeId;
    			checkInfo.key = $scope.checkAllList[i].key;
    			checkInfo.outNum = $scope.checkAllList[i].outNum;
    			checkInfo.dlErea = "";

    			checkInfo.maxNumInLine = $scope.checkAllList[i].maxNumInLine;
    			if ($scope.checkAllList[i].inputTypeId == "7") {
    				if ($scope.checkAllList[i].cellNum == 0 || $scope.checkAllList[i].cellNum == "" || $scope.checkAllList[i].cellNum < 1 || $scope.checkAllList[i].cellNum > 99 || !posPattern.test($scope.checkAllList[i].cellNum)) {
        				$rootScope.showErrorMessage("1枚写真エリアのセル数は1～99の整数を入力してください。");
                        return ;
        			}
    				if ($scope.checkAllList[i].cellNumCol == 0 || $scope.checkAllList[i].cellNumCol == "" || $scope.checkAllList[i].cellNumCol < 1 || $scope.checkAllList[i].cellNumCol > 99 || !posPattern.test($scope.checkAllList[i].cellNumCol)) {
        				$rootScope.showErrorMessage("1枚写真エリアのセル数は1～99の整数を入力してください。");
                        return ;
        			}
    				if ($scope.checkAllList[i].commentCellNum == 0 || $scope.checkAllList[i].commentCellNum == "" || $scope.checkAllList[i].commentCellNum < 1 || $scope.checkAllList[i].commentCellNum > 99 || !posPattern.test($scope.checkAllList[i].commentCellNum)) {
        				$rootScope.showErrorMessage("写真コメントの行数は1～99の整数を入力してください。");
                        return ;
        			}

    				if ($scope.checkAllList[i].dlErea == '1' || $scope.checkAllList[i].dlErea == true) {
            			checkInfo.dlErea = "true";
    				} else {
    					checkInfo.dlErea = "false";
    				}
    			}
    			if ($scope.checkAllList[i].inputTypeId == "10") {
    				if ($scope.checkAllList[i].cellNum == 0 || $scope.checkAllList[i].cellNum == "" || $scope.checkAllList[i].cellNum < 30 || $scope.checkAllList[i].cellNum > 99 || !posPattern.test($scope.checkAllList[i].cellNum)) {
        				$rootScope.showErrorMessage("手書きエリアのセル数は30～99の整数を入力してください。");
                        return ;
        			}
    			}
    			checkInfo.cellNum = $scope.checkAllList[i].cellNum;
    			checkInfo.cellNumCol = $scope.checkAllList[i].cellNumCol;
    			checkInfo.commentCellNum = $scope.checkAllList[i].commentCellNum;
    			checkInfo.type = $scope.checkAllList[i].type;
    			checkInfoList.push(checkInfo);
    		}
    	}

    	ajaxService.saveDownloadSetting(ticketKeyInfo, targetKeyInfo, checkInfoList, $scope.downloadFileName, $scope.checksheetId);
        if (ajaxService.result['resultCd'] != "000000") {
          $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        } else {
          $rootScope.showInfoMessage("保存しました。");
        }

    };




  }
})();
/**
 * @author v.lugovsky created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.checklist').controller('FileUploadCtrl',
        FileUploadCtrl);

    /** @ngInject */
    function FileUploadCtrl($scope, $rootScope, $state, $uibModal, Upload, openFlag, $timeout, ajaxService, tr) {
//      if (!ajaxService.tokenCheck()) {
//            return;
//          };

        $scope.files = [];
        $scope.progressRate = 0;
        $scope.allProgressRate = 0;
        $scope.complete = 0;
        $scope.fileName = '';
        $scope.uploadId = openFlag.id;
        $scope.ticketId = openFlag.ticketId;
        var kbn = openFlag.kbn;
        $scope.typeKbn = openFlag.typeKbn;
        var checklistId = openFlag.checklistId;
        $scope.rdOb = openFlag.rdOb;


        $scope.getFileList = function () {
        	$scope.files.sort(function(a,b){
                return b.lastModified-a.lastModified});
        	return $scope.files;
        }

        $scope.upload = function () {
            var files = $scope.files;
            if (files && files.length > 0) {
                if (openFlag.flag == 'History') {
                  /*  if (files.length > 1) {
                        $scope.open('app/pages/switching/dangerModal.html','Can not Upload more than 1 file!')
                    } else {
                        Upload.upload({
                            url : urlPrefix + "ticket/uploadHistory4Ticket",
                            type : "POST",
                            headers : {
                                "authorization" : localStorage.authId,
                            },
                            dataType : "multipart/form-data",
                            data : {file: files[0], 'user':localStorage.userName,'fileId':$scope.$parent.currentFileInfo.fileId, 'checksheetId': $scope.uploadId}
                        }).then(function(response) {
                            var name = response.config.data.file.name;
                            if (response.data.resultCd == "000000") {
                                $scope.$parent.refreshHistory($scope.ticketId);
                                $scope.open('app/pages/switching/successModal.html', 'Your file has been saved successfully');
                                $scope.$dismiss();
                            } else {
                                $scope.open('app/pages/switching/dangerModal.html',response.data.resultMsg )
                                return;
                            }
                        }, function(response) {
                            if (response.status > 0)
                                $scope.errorMsg = response.status + ': '
                                        + response.data;
                        }, function(evt, response) {
                          if (response.data.resultCd == "000000") {
                                var progressPercentage = parseInt(100.0 *
                                        evt.loaded / evt.total);
                                $scope.progressRate = progressPercentage;
                          }
                        });
                    } */
                } else {
                  if (kbn == "Checksheet") {
                    uploadFile();
                  } else if (kbn == "DownloadSetting") {
                	  for (var i =0; i<files.length; i++) {
                          if(! $rootScope.isExcel(files[i].name)) {
                            $rootScope.showErrorMessage("EXCELファイルをアップロードしてください。");
                            return;
                          }
                        }
                	uploadFileDownloadSetting();
                  } else if (kbn == "Checktarget") {
                    uploadFileTarget();
                  } else if (kbn == "CheckResult") {
                    if ($scope.typeKbn == "Image") {
                      for (var i =0; i<files.length; i++) {
                          if(! $rootScope.isImg(files[i].name)) {
                            $rootScope.showErrorMessage("画像以外のファイルがアップロードできません。");
                            return;
                          }
                        }
                    } else if ($scope.typeKbn == "Radio") {
                      for (var i =0; i<files.length; i++) {
                            if(! $rootScope.isRadio(files[i].name)) {
                              $rootScope.showErrorMessage("wav、mp3、m4a形式以外のファイルがアップロードできません。");
                              return;
                            }
                          }
                    } else if ($scope.typeKbn == "Video") {
                      for (var i =0; i<files.length; i++) {
                            if(! $rootScope.isVideo(files[i].name)) {
                              $rootScope.showErrorMessage("mov、mp4形式以外のファイルがアップロードできません。");
                              return;
                            }
                          }
                    }
                    uploadFileCheckResult();
                  } else if (kbn == "ticket") {
                    uploadFileTicket();
                  } else if (kbn == "Common") {
                    uploadFileCommon();
                  } else if (kbn == "News") {
                    uploadFileNews();
                  } else if (kbn == "Checkdetail") {
                    uploadFileCheckdetail();
                  } else if (kbn == "offline") {
                      if ($scope.typeKbn == "Image") {
                          for (var i =0; i<files.length; i++) {
                              if(! $rootScope.isImg(files[i].name)) {
                                $rootScope.showErrorMessage("画像以外のファイルがアップロードできません。");
                                return;
                              }
                            }
                        } else if ($scope.typeKbn == "Radio") {
                          for (var i =0; i<files.length; i++) {
                                if(! $rootScope.isRadio(files[i].name)) {
                                  $rootScope.showErrorMessage("wav、mp3、m4a形式以外のファイルがアップロードできません。");
                                  return;
                                }
                              }
                        } else if ($scope.typeKbn == "Video") {
                          for (var i =0; i<files.length; i++) {
                                if(! $rootScope.isVideo(files[i].name)) {
                                  $rootScope.showErrorMessage("mov、mp4形式以外のファイルがアップロードできません。");
                                  return;
                                }
                              }
                        }
                        uploadFileOffline();
                      }

                }
            } else {
              $rootScope.showErrorMessage("ファイルを選択してください。");
            }
        };

        function uploadFile() {
            var i = $scope.complete;
            $scope.fileName = $scope.files[i].name;

            var projectId = '0';
            if ($rootScope.projectId) {
            	projectId = $rootScope.projectId;
            }
            Upload.upload({
                url : urlPrefix + "checklist/uploadFile",
                type : "POST",
                headers : {
                    "authorization" : localStorage.authId,
                },
                dataType : "multipart/form-data",
                data : {file: $scope.files[i], 'userName':localStorage.userName, 'loginId':localStorage.userId, 'checksheetId': $scope.uploadId, 'projectId': projectId, "schema" : localStorage.schema}
            }).progress(function (evt) {
                //progress
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                $scope.progressRate = progressPercentage;
            }).then(function(response) {
            	if (response.data.resultCd != '000000') {
            		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
            		return ;
            	}

                var name = response.config.data.file.name;
                $rootScope.showInfoMessage("ファイル："+name+"をアップロードしました。");

                var progressPercentage = parseInt(100.0 * (i+1) / $scope.files.length);
                $scope.allProgressRate = progressPercentage;
                i++;
                $scope.complete = i;
                if (i < $scope.files.length) {
                  $scope.progressRate = 0;
                  $timeout(uploadFile, 100);
                } else {
                    //$rootScope.showInfoMessage("全てのファイルをアップロードしました。");
                	if (projectId != '0') {
                		$scope.$parent.searchFileList();
                        $scope.$dismiss();
                	} else {
                		$scope.$parent.searchFileList();
                        $scope.$dismiss();
                	}
                }

            }, function(response) {
              $rootScope.showErrorMessage(tr.T(response.data.resultCd));
            });
        };

        function uploadFileTarget() {
            var i = $scope.complete;
            $scope.fileName = $scope.files[i].name;
            Upload.upload({
                url : urlPrefix + "checktarget/uploadFile",
                type : "POST",
                headers : {
                    "authorization" : localStorage.authId,
                },
                dataType : "multipart/form-data",
                data : {file: $scope.files[i], 'userName':localStorage.userName, 'loginId':localStorage.userId, 'checktargetId': $scope.uploadId, 'projectId': $rootScope.projectId, "schema" : localStorage.schema}
            }).progress(function (evt) {
                //progress
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                $scope.progressRate = progressPercentage;
            }).then(function(response) {
            	if (response.data.resultCd != '000000') {
            		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
            		return ;
            	}

                var name = response.config.data.file.name;
                $rootScope.showInfoMessage("ファイル："+name+"をアップロードしました。");

                var progressPercentage = parseInt(100.0 * (i+1) / $scope.files.length);
                $scope.allProgressRate = progressPercentage;
                i++;
                $scope.complete = i;
                if (i < $scope.files.length) {
                  $scope.progressRate = 0;
                  $timeout(uploadFileTarget, 100);
                } else {
                    //$rootScope.showInfoMessage("全てのファイルをアップロードしました。");
                    $scope.$parent.searchFileList();
                    $scope.$dismiss();
                }

            }, function(response) {
              $rootScope.showErrorMessage(tr.T(response.data.resultCd));
            });
        };

        function uploadFileCheckResult() {
            var i = $scope.complete;
            $scope.fileName = $scope.files[i].name;
            Upload.upload({
                url : urlPrefix + "checkreport/uploadCheckResultFile",
                type : "POST",
                headers : {
                    "authorization" : localStorage.authId,
                },
                dataType : "multipart/form-data",
                data : {file: $scope.files[i], 'userName':localStorage.userName, 'loginId':localStorage.userId, 'checkResultId': $scope.uploadId, 'projectId': $rootScope.projectId, 'ticketId':$scope.ticketId, 'typeKbn':$scope.typeKbn, "schema" : localStorage.schema}
            }).progress(function (evt) {
                //progress
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                $scope.progressRate = progressPercentage;
            }).then(function(response) {
            	if (response.data.resultCd != '000000') {
            		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
            		return ;
            	}

                var name = response.config.data.file.name;
                $rootScope.showInfoMessage("ファイル："+name+"をアップロードしました。");

                var progressPercentage = parseInt(100.0 * (i+1) / $scope.files.length);
                $scope.allProgressRate = progressPercentage;
                i++;
                $scope.complete = i;
                if (i < $scope.files.length) {
                  $scope.progressRate = 0;
                  $timeout(uploadFileCheckResult, 100);
                } else {
                    //$rootScope.showInfoMessage("全てのファイルをアップロードしました。");
                    //写真取得
                    if ($scope.typeKbn == "Image") {
                      if (! $rootScope.isMoblie) {
                          $scope.$parent.getImgList ($scope.ticketId, $scope.uploadId);
                          $scope.$parent.$parent.getCheckreportList($scope.ticketId);
                      } else {
//                        $scope.$parent.getResultInfoSp($scope.ticketId, checklistId);
                        $scope.$parent.getImgResultListSp($scope.ticketId, checklistId);

                        $("body,html").animate({
                            scrollTop : $("#slider"+$scope.uploadId).offset().top - 100
                        }, 1000);
                      }
                    } else if ($scope.typeKbn == "Radio") {
                      $scope.$parent.getRadioList ($scope.ticketId, $scope.uploadId);
                    } else if ($scope.typeKbn == "Video") {
                        $scope.$parent.getVideoList ($scope.ticketId, $scope.uploadId);
                    } else if ($scope.typeKbn == "File") {
                        $scope.$parent.getResultFileList ($scope.ticketId, $scope.uploadId);
                    }

                    $scope.$dismiss();
                }
            }, function(response) {
              $rootScope.showErrorMessage(tr.T(response.data.resultCd));
            });
        };

        function uploadFileTicket() {
            var i = $scope.complete;
            $scope.fileName = $scope.files[i].name;
            Upload.upload({
                url : urlPrefix + "checkreport/uploadFile",
                type : "POST",
                headers : {
                    "authorization" : localStorage.authId,
                },
                dataType : "multipart/form-data",
                data : {file: $scope.files[i], 'userName':localStorage.userName, 'loginId':localStorage.userId, 'ticketId': $scope.uploadId, 'projectId': $rootScope.projectId, "schema" : localStorage.schema}
            }).progress(function (evt) {
                //progress
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                $scope.progressRate = progressPercentage;
            }).then(function(response) {
            	if (response.data.resultCd != '000000') {
            		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
            		return ;
            	}

                var name = response.config.data.file.name;
                $rootScope.showInfoMessage("ファイル："+name+"をアップロードしました。");

                var progressPercentage = parseInt(100.0 * (i+1) / $scope.files.length);
                $scope.allProgressRate = progressPercentage;
                i++;
                $scope.complete = i;
                if (i < $scope.files.length) {
                  $scope.progressRate = 0;
                  $timeout(uploadFileTicket, 100);
                } else {
                    //$rootScope.showInfoMessage("全てのファイルをアップロードしました。");
                    $scope.$parent.searchFileList($scope.uploadId);
                    $scope.$dismiss();
                }

            }, function(response) {
              $rootScope.showErrorMessage(tr.T(response.data.resultCd));
            });
        };


        function uploadFileCommon() {
            var i = $scope.complete;
            $scope.fileName = $scope.files[i].name;
            Upload.upload({
                url : urlPrefix + "checklist/uploadFileCommon",
                type : "POST",
                headers : {
                    "authorization" : localStorage.authId,
                },
                dataType : "multipart/form-data",
                data : {file: $scope.files[i], 'userName':localStorage.userName, 'loginId':localStorage.userId, 'projectId': $rootScope.projectId, "schema" : localStorage.schema}
            }).progress(function (evt) {
                //progress
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                $scope.progressRate = progressPercentage;
            }).then(function(response) {
            	if (response.data.resultCd != '000000') {
            		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
            		return ;
            	}

                var name = response.config.data.file.name;
                $rootScope.showInfoMessage("ファイル："+name+"をアップロードしました。");

                var progressPercentage = parseInt(100.0 * (i+1) / $scope.files.length);
                $scope.allProgressRate = progressPercentage;
                i++;
                $scope.complete = i;
                if (i < $scope.files.length) {
                  $scope.progressRate = 0;
                  $timeout(uploadFileCommon, 100);
                } else {
                    //$rootScope.showInfoMessage("全てのファイルをアップロードしました。");
                    $scope.$parent.getManualList();
                    $scope.$dismiss();
                }

            }, function(response) {
              $rootScope.showErrorMessage(tr.T(response.data.resultCd));
            });
        };

        function uploadFileNews() {
            var i = $scope.complete;
            $scope.fileName = $scope.files[i].name;
            Upload.upload({
                url : urlPrefix + "news/uploadFile",
                type : "POST",
                headers : {
                    "authorization" : localStorage.authId,
                },
                dataType : "multipart/form-data",
                data : {file: $scope.files[i], 'userName':localStorage.userName, 'loginId':localStorage.userId, 'newsId': $scope.uploadId, 'projectId': $rootScope.projectId, "schema" : localStorage.schema}
            }).progress(function (evt) {
                //progress
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                $scope.progressRate = progressPercentage;
            }).then(function(response) {
            	if (response.data.resultCd != '000000') {
            		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
            		return ;
            	}

                var name = response.config.data.file.name;
                $rootScope.showInfoMessage("ファイル："+name+"をアップロードしました。");

                var progressPercentage = parseInt(100.0 * (i+1) / $scope.files.length);
                $scope.allProgressRate = progressPercentage;
                i++;
                $scope.complete = i;
                if (i < $scope.files.length) {
                  $scope.progressRate = 0;
                  $timeout(uploadFileNews, 100);
                } else {
                    //$rootScope.showInfoMessage("全てのファイルをアップロードしました。");
                    $scope.$parent.searchFileList($scope.uploadId);
                    $scope.$dismiss();
                }

            }, function(response) {
              $rootScope.showErrorMessage(tr.T(response.data.resultCd));
            });
        };

        function uploadFileDownloadSetting() {

        	if ($scope.complete == $scope.files.length) {
        		$scope.$parent.getTempFile();
                $scope.$dismiss();
                return;
        	}

            var i = $scope.complete;
            $scope.fileName = $scope.files[i].name;
            Upload.upload({
                url : urlPrefix + "checklist/uploadTemplate",
                type : "POST",
                headers : {
                    "authorization" : localStorage.authId,
                },
                dataType : "multipart/form-data",
                data : {file: $scope.files[i], 'userName':localStorage.userName, 'loginId':localStorage.userId, 'checksheetId': $scope.uploadId, 'projectId': $rootScope.projectId, "schema" : localStorage.schema}
            }).progress(function (evt) {
                //progress
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                $scope.progressRate = progressPercentage;
            }).then(function(response) {
            	if (response.data.resultCd != '000000') {
            		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
            		return ;
            	}

                var name = response.config.data.file.name;
                $rootScope.showInfoMessage("ファイル："+name+"をアップロードしました。");

                var progressPercentage = parseInt(100.0 * (i+1) / $scope.files.length);
                $scope.allProgressRate = progressPercentage;
                i++;
                $scope.complete = i;
                if (i < $scope.files.length) {
                  $scope.progressRate = 0;
                  $timeout(uploadFileDownloadSetting, 100);
                } else {
                    $scope.progressRate = 100;
                    $timeout(uploadFileDownloadSetting, 100);
                }

            }, function(response) {
              $rootScope.showErrorMessage(tr.T(response.data.resultCd));
            });
        };


        function uploadFileCheckdetail() {

        	var projectId = '0';
            if ($rootScope.projectId) {
            	projectId = $rootScope.projectId;
            }

            var i = $scope.complete;
            $scope.fileName = $scope.files[i].name;
            Upload.upload({
                url : urlPrefix + "checklist/uploadFileDetail",
                type : "POST",
                headers : {
                    "authorization" : localStorage.authId,
                },
                dataType : "multipart/form-data",
                data : {file: $scope.files[i], 'userName':localStorage.userName, 'loginId':localStorage.userId, 'checkdetailId': $scope.uploadId, 'projectId': projectId, "schema" : localStorage.schema}
            }).progress(function (evt) {
                //progress
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                $scope.progressRate = progressPercentage;
            }).then(function(response) {
            	if (response.data.resultCd != '000000') {
            		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
            		return ;
            	}

                var name = response.config.data.file.name;
                $rootScope.showInfoMessage("ファイル："+name+"をアップロードしました。");

                var progressPercentage = parseInt(100.0 * (i+1) / $scope.files.length);
                $scope.allProgressRate = progressPercentage;
                i++;
                $scope.complete = i;
                if (i < $scope.files.length) {
                  $scope.progressRate = 0;
                  $timeout(uploadFileCheckdetail, 100);
                } else {
                    //$rootScope.showInfoMessage("全てのファイルをアップロードしました。");
                    $scope.$parent.searchFileList($scope.uploadId);
                    $scope.$dismiss();
                }
            }, function(response) {
              $rootScope.showErrorMessage(tr.T(response.data.resultCd));
            });
        };


        $scope.open = function (page, message) {
            $uibModal.open({
              animation: true,
              templateUrl: page,
              backdrop : "static",
              controller: 'ModalCtrl',
              resolve: {
                  myMessage: function () {
                      return {'mes':message,
                          };
                }
              }
            });
          };


      function uploadFileOffline() {
          var i = $scope.complete;
          var fileName = $scope.files[i].name;

          console.log($scope.rdOb);
          var tRsFileId = $scope.ticketId + '-' + $scope.uploadId + '-n' + ($scope.rdOb.offImgSize + i);
          var fileOb = {'tRsFileId' : tRsFileId, 'file':$scope.files[i], 'imgComment': ""};
          $rootScope.removeFileIndexDb(tRsFileId);
          $rootScope.addFileIndexDb(fileOb);

          $scope.progressRate = 100;

          $rootScope.showInfoMessage("ファイル："+fileName+"をアップロードしました。");

          var progressPercentage = parseInt(100.0 * (i+1) / $scope.files.length);
          $scope.allProgressRate = progressPercentage;

          i++;
          $scope.complete = i;
          if (i < $scope.files.length) {
            $scope.progressRate = 0;
            $timeout(uploadFileOffline, 100);
          } else {
        	  $scope.$dismiss();
              //写真取得
              if ($scope.typeKbn == "Image") {
//                  $scope.$parent.getImgList($scope.rdOb);
                  $scope.$parent.reflesh();
                  $("body,html").animate({
                      scrollTop : $("#slider"+$scope.uploadId).offset().top - 100
                  }, 1000);
              } else if ($scope.typeKbn == "Radio") {
                $scope.$parent.getRadioList ($scope.ticketId, $scope.uploadId);
              } else if ($scope.typeKbn == "Video") {
                  $scope.$parent.getVideoList ($scope.ticketId, $scope.uploadId);
              } else if ($scope.typeKbn == "File") {
                  $scope.$parent.getResultFileList ($scope.ticketId, $scope.uploadId);
              }


          }
      };



    }
})();
/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.checkreport').controller('CheckreportCtrl', CheckreportCtrl);

    /** @ngInject */
    function CheckreportCtrl($scope, $filter, editableOptions, editableThemes, toastr, $timeout,baProgressModal,
            toastrConfig, ajaxService, $state, $uibModal, $location, $window, themeLayoutSettings, Upload, $http, $rootScope, tr) {
      $scope.smartTablePageSize = 20;
      var theme = themeLayoutSettings;

      $scope.mngFlg = localStorage.mngKbn;

      $scope.loginUserId = localStorage.userId


      if ('serviceWorker' in navigator) {
    	  navigator.serviceWorker.register('serviceWorker.js')
    	  .then(function(registration){
    		  console.log('Registered events at scope:', registration.scope);
    	  });
      }



      if (!ajaxService.tokenCheck()) {
          return;
        };

      $scope.ctrl = $scope;
      //CKEditor
//      $scope.options = {
//        language: 'ja',
//        extraPlugins: 'colorbutton',
//        allowedContent: true,
//        entities: false
//      }
//      $scope.onReady = function () {
//      };

      $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);
      // userOrder : 1,工事との距離順
      $scope.userOrder = $scope.mngCommon.userOrder;
      $scope.showResult = $scope.mngCommon.showResult;
      $scope.adminMng = $scope.mngCommon.adminMng;
      $scope.finalApproval = $scope.mngCommon.finalApproval;
      $scope.commentWithMail = $scope.mngCommon.commentWithMail;

      $scope.parentTicket = $scope.mngCommon.parentTicketType;

      $scope.showCheckreportDetail = function(id) {
          if(ajaxService.hasTicket(id) == 0) {
            $rootScope.showErrorMessage("該当チェックシートが削除されました。");
            return ;
          }
             var url = window.location.href;
             var u = url.split("#")[0];
             window.open(u + "#/showReportDetail?id=" + id );
         };

		 $scope.itemTicketList = ajaxService.searchItemNameList('3', $rootScope.projectId);
		 $scope.showStatusDetail = false;
         $scope.showKbn2 = false;
         $scope.showKbn3 = false;
         $scope.showKbn4 = false;
         $scope.showKbn5 = false;
         $scope.showItem1 = false;
         $scope.showItem2 = false;
         $scope.showItem3 = false;
         $scope.showItem4 = false;
         $scope.showItem5 = false;

		 $scope.mustStatusDetail = false;
         $scope.mustKbn2 = false;
         $scope.mustKbn3 = false;
         $scope.mustKbn4 = false;
         $scope.mustKbn5 = false;
         $scope.mustItem1 = false;
         $scope.mustItem2 = false;
         $scope.mustItem3 = false;
         $scope.mustItem4 = false;
         $scope.mustItem5 = false;

         $scope.numOfShow = 0;
         $scope.ticketItemShow = [];

		 for (var i=0; i<$scope.itemTicketList.length; i++) {
           var field = $scope.itemTicketList[i].fieldName;
           if (field == "statusDetail") {
             $scope.statusDetailItemName = $scope.itemTicketList[i].showName;
             if ($scope.itemTicketList[i].isShow != '1') {
                 $scope.showStatusDetail = true;
                 $scope.numOfShow = $scope.numOfShow + 1;
                 $scope.ticketItemShow.push($scope.itemTicketList[i]);
                 if ($scope.itemTicketList[i].isShow == '3') {
            		 $scope.mustStatusDetail = true;
                 }
             }
           }
           if (field == "kbn2") {
               $scope.kbn2ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showKbn2 = true;
                   $scope.numOfShow = $scope.numOfShow + 1;
                   $scope.ticketItemShow.push($scope.itemTicketList[i]);
                   if ($scope.itemTicketList[i].isShow == '3') {
              		 $scope.mustKbn2 = true;
                   }
               }
             }
           if (field == "kbn3") {
               $scope.kbn3ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showKbn3 = true;
                   $scope.numOfShow = $scope.numOfShow + 1;
                   $scope.ticketItemShow.push($scope.itemTicketList[i]);
                   if ($scope.itemTicketList[i].isShow == '3') {
                		 $scope.mustKbn3 = true;
                     }
               }
             }
           if (field == "kbn4") {
               $scope.kbn4ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showKbn4 = true;
                   $scope.numOfShow = $scope.numOfShow + 1;
                   $scope.ticketItemShow.push($scope.itemTicketList[i]);
                   if ($scope.itemTicketList[i].isShow == '3') {
                		 $scope.mustKbn4 = true;
                     }
               }
             }
           if (field == "kbn5") {
               $scope.kbn5ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showKbn5 = true;
                   $scope.numOfShow = $scope.numOfShow + 1;
                   $scope.ticketItemShow.push($scope.itemTicketList[i]);
                   if ($scope.itemTicketList[i].isShow == '3') {
                		 $scope.mustKbn5 = true;
                     }
               }
             }
           if (field == "item1") {
               $scope.item1ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showItem1 = true;
                   $scope.numOfShow = $scope.numOfShow + 1;
                   $scope.ticketItemShow.push($scope.itemTicketList[i]);
                   if ($scope.itemTicketList[i].isShow == '3') {
                		 $scope.mustItem1 = true;
                     }
               }
             }
           if (field == "item2") {
               $scope.item2ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showItem2 = true;
                   $scope.numOfShow = $scope.numOfShow + 1;
                   $scope.ticketItemShow.push($scope.itemTicketList[i]);
                   if ($scope.itemTicketList[i].isShow == '3') {
              		 $scope.mustItem2 = true;
                   }
               }
             }
           if (field == "item3") {
               $scope.item3ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showItem3 = true;
                   $scope.numOfShow = $scope.numOfShow + 1;
                   $scope.ticketItemShow.push($scope.itemTicketList[i]);
                   if ($scope.itemTicketList[i].isShow == '3') {
              		 $scope.mustItem3 = true;
                   }
               }
             }
           if (field == "item4") {
               $scope.item4ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showItem4 = true;
                   $scope.numOfShow = $scope.numOfShow + 1;
                   $scope.ticketItemShow.push($scope.itemTicketList[i]);
                   if ($scope.itemTicketList[i].isShow == '3') {
              		 $scope.mustItem4 = true;
                   }
               }
             }
           if (field == "item5") {
               $scope.item5ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showItem5 = true;
                   $scope.numOfShow = $scope.numOfShow + 1;
                   $scope.ticketItemShow.push($scope.itemTicketList[i]);
                   if ($scope.itemTicketList[i].isShow == '3') {
              		 $scope.mustItem5 = true;
                   }
               }
             }
		 }

		 $scope.ticketItemList=[];
		 if ($scope.numOfShow > 1) {
			 if ($scope.parentTicket == '1') {
				 $scope.ticketItemShow.shift();
			 }
			 for (var i=0; i<$scope.ticketItemShow.length; i++) {
	           if (i % 2 == 0) {
	             var obj = {"left":null, "right": null};
	               obj["left"] = $scope.ticketItemShow[i];
	               if (i == $scope.ticketItemShow.length - 1) {
	                 $scope.ticketItemList.push(obj);
	               }
	           } else {
	             obj["right"] = $scope.ticketItemShow[i];
	             $scope.ticketItemList.push(obj);
	           }
	         }
		 }

		 $scope.statusDetailList = [];
		 if ($scope.showStatusDetail) {
			 $scope.statusDetailList = ajaxService.getProjectResourceList($rootScope.projectId, '4', 0);
			 $scope.statusDetailList.unshift({label:" ", id:null});
		 }
		 $scope.kbn2List = [];
		 if ($scope.showKbn2) {
			 $scope.kbn2List = ajaxService.getProjectResourceList($rootScope.projectId, '5', 0);
			 $scope.kbn2List.unshift({label:" ", id:null});
		 }
		 $scope.kbn3List = [];
		 if ($scope.showKbn3) {
			 $scope.kbn3List = ajaxService.getProjectResourceList($rootScope.projectId, '6', 0);
			 $scope.kbn3List.unshift({label:" ", id:null});
		 }
		 $scope.kbn4List = [];
		 if ($scope.showKbn4) {
			 $scope.kbn4List = ajaxService.getProjectResourceList($rootScope.projectId, '7', 0);
			 $scope.kbn4List.unshift({label:" ", id:null});
		 }
		 $scope.kbn5List = [];
		 if ($scope.showKbn5) {
			 $scope.kbn5List = ajaxService.getProjectResourceList($rootScope.projectId, '8', 0);
			 $scope.kbn5List.unshift({label:" ", id:null});
		 }

	      $scope.getStatusDetailOb = function (value) {
	        for (var i = 0; i < $scope.statusDetailList.length; i++) {
	          if (value == $scope.statusDetailList[i].id) {
	            return $scope.statusDetailList[i];
	          }
	        }
	        return new Object();
	      };
	      $scope.getKbn2Ob = function (value) {
	        for (var i = 0; i < $scope.kbn2List.length; i++) {
	          if (value == $scope.kbn2List[i].id) {
	            return $scope.kbn2List[i];
	          }
	        }
	        return new Object();
	      };
	      $scope.getKbn3Ob = function (value) {
	        for (var i = 0; i < $scope.kbn3List.length; i++) {
	          if (value == $scope.kbn3List[i].id) {
	            return $scope.kbn3List[i];
	          }
	        }
	        return new Object();
	      };
	      $scope.getKbn4Ob = function (value) {
	        for (var i = 0; i < $scope.kbn4List.length; i++) {
	          if (value == $scope.kbn4List[i].id) {
	            return $scope.kbn4List[i];
	          }
	        }
	        return new Object();
	      };
	      $scope.getKbn5Ob = function (value) {
	        for (var i = 0; i < $scope.kbn5List.length; i++) {
	          if (value == $scope.kbn5List[i].id) {
	            return $scope.kbn5List[i];
	          }
	        }
	        return new Object();
	      };


      $scope.itemNameList = ajaxService.getTargetItemList($rootScope.projectId);
      for (var i=0; i<$scope.itemNameList.length; i++) {
        var field = $scope.itemNameList[i].fieldName;
        if (field == "targetId") {
          $scope.targetIdItemName = $scope.itemNameList[i].showName;
        }
        if (field == "targetName") {
          $scope.targetNameItemName = $scope.itemNameList[i].showName;
        }
      }

      $scope.firstItemList = ajaxService.getProjectResourceList($rootScope.projectId, '1');
      $scope.secondItemList = ajaxService.getProjectResourceList($rootScope.projectId, '2');
      $scope.thirdItemList = ajaxService.getProjectResourceList($rootScope.projectId, '3');
      $scope.getFirstItemOb = function (value) {
        for (var i = 0; i < $scope.firstItemList.length; i++) {
          if (value == $scope.firstItemList[i].id) {
            return $scope.firstItemList[i];
          }
        }
        return new Object();
      };
      $scope.getSecondItemOb = function (value) {
        for (var i = 0; i < $scope.secondItemList.length; i++) {
          if (value == $scope.secondItemList[i].id) {
            return $scope.secondItemList[i];
          }
        }
        return new Object();
      };
      $scope.getThirdItemOb = function (value) {
        for (var i = 0; i < $scope.thirdItemList.length; i++) {
          if (value == $scope.thirdItemList[i].id) {
            return $scope.thirdItemList[i];
          }
        }
        return new Object();
      };

      if (! $scope.userList) {
          $scope.userList = ajaxService.selectUserList($rootScope.projectId);
          $scope.userList.unshift({userName:" ", userId:null});
        }
      for (var i=0; i<$scope.userList.length; i++) {
          if (localStorage.userId == $scope.userList[i].userId) {
            $scope.loginUser = $scope.userList[i];
            break;
          }
        }

      if ($scope.adminMng != '1') {

    	  $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);

//    	  if (localStorage.mngKbn != '0') {
//	        $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
//	      } else {
//	    	  $scope.groupList = angular.copy($scope.loginUser.groupList);
//
//	        //チェック者の場合、技術者リストに所属しているグループの技術者のみが見える
//	        if ($scope.groupList.length == 0) {
//          	  $scope.userList = [];
//          	  $scope.userList.push($scope.loginUser);
//            } else {
//          	  var groupIdList = [];
//          	  for (var i = 0; i < $scope.groupList.length; i++) {
//          		  groupIdList.push($scope.groupList[i].groupId);
//          	  }
//                $scope.userList = ajaxService.getListByGroupIdList(groupIdList);
//            }
//            $scope.userList.unshift({userName:" ", userId:''});
//	      }
      } else {
    	  if (localStorage.mngKbn == '2') {
              $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
            } else {
              $scope.groupList = angular.copy($scope.loginUser.groupList);
              //指示者、チェック者は自分所属しているグループ内の技術者のみが見れる。
              if ($scope.groupList.length == 0) {
            	  $scope.userList = [];
            	  $scope.userList.push($scope.loginUser);
              } else {
            	  var groupIdList = [];
            	  for (var i = 0; i < $scope.groupList.length; i++) {
            		  groupIdList.push($scope.groupList[i].groupId);
            	  }
                  $scope.userList = ajaxService.getListByGroupIdList(groupIdList);
              }
              $scope.userList.unshift({userName:" ", userId:''});
            }
      }

      $scope.groupList.unshift({groupName:" ", groupId:null});


      $scope.getGroupOb = function (value) {
        for (var i = 0; i < $scope.groupList.length; i++) {
          if (value == $scope.groupList[i].groupId) {
            return $scope.groupList[i];
          }
        }
      };

      $scope.getTargetList = function () {
        $scope.targetList = ajaxService.searchTargetIdNameList($rootScope.projectId);
      };

      $scope.searchFileList = function (ticketId) {
          $scope.fileList = ajaxService.getFileListTicket(ticketId);
      };

        $scope.getCheckreportList = function(ticketId) {
          $scope.isFinsh = true;
          $scope.checkresultList = ajaxService.searchCheckResultList(ticketId);
          $scope.resultOkNum = 0;
          $scope.resultNgNum = 0;
          $scope.resultKeepNum = 0;
          $scope.resultOtherNum = 0;

          for (var i = 0; i < $scope.checkresultList.length; i++) {
            var content = $scope.checkresultList[i].checklistContent;
            if (content) {
              var urlStartIndex = content.indexOf("[[");
              var urlEndIndex = content.indexOf("]]");
              if (urlStartIndex != -1 && urlEndIndex != -1) {
                var urlStr = content.substring(urlStartIndex, urlEndIndex + 2);
                var link = content.substring(urlStartIndex + 2, urlEndIndex);
                var url = "<a href = '"+ link +"' target = '_blank'>"+link+"</a>";
                $scope.checkresultList[i].checklistContent = content.replace(urlStr, url);
              }
            }


            if ($scope.checkresultList[i].checkResult == "1") {
              $scope.resultOkNum++;
              $scope.checkresultList[i].checkResultName = "正常";
            } else if ($scope.checkresultList[i].checkResult == "2") {
              $scope.resultNgNum++;
              $scope.checkresultList[i].checkResultName = "異常";
            } else if ($scope.checkresultList[i].checkResult == "3") {
              $scope.resultKeepNum++;
              $scope.checkresultList[i].checkResultName = "保留";
              $scope.isFinsh = false;
            } else if ($scope.checkresultList[i].checkResult == "4") {
              $scope.resultOtherNum++;
              $scope.checkresultList[i].checkResultName = "対象外";
            } else {
                $scope.isFinsh = false;
            }

            if ($scope.checkresultList[i].imgNum != 0) {
              for (var j = 0; j < $scope.checkresultList[i].imgInfo.length; j++) {
                if ($scope.checkresultList[i].imgInfo[j].fileType == '7') {
                  $scope.checkresultList[i].imgInfo[j].url = urlPrefix + "checkreport/getCheckResultFile/"+localStorage.schema+"/"+$scope.checkresultList[i].imgInfo[j].resultDetailId+"/"+localStorage.authId+"/"+$scope.checkresultList[i].imgInfo[j].id+"/null";
                } else {
                  $scope.checkresultList[i].imgInfo[j].url = urlPrefix + "checkreport/getCheckResultFile/"+localStorage.schema+"/"+$scope.checkresultList[i].imgInfo[j].resultDetailId+"/"+localStorage.authId+"/"+$scope.checkresultList[i].imgInfo[j].id+"/th";
                }

              }
            }
          }
          $scope.checkListFileList = ajaxService.getFileList($scope.ticket.checksheetId);

       };

       $scope.getSubTicketList = function(ticketId) {
         $scope.subTicketList = ajaxService.getSubTicketList($rootScope.projectId, ticketId);
       };


       $scope.getCommentList = function(ticketId) {
           $scope.statusHistoryList = ajaxService.searchCommentList($rootScope.projectId, ticketId);
           for (var i = 0; i< $scope.statusHistoryList.length; i++) {
        	   var his = $scope.statusHistoryList[i];
        	   his.img = $rootScope.getUserImg(his.userId);
           }
       };

       $scope.getTicketInfo = function (ticketId) {
         $scope.ticket = ajaxService.searchTicketInfo($rootScope.projectId, ticketId);
         $scope.statusOb = $rootScope.getStatusOb($scope.ticket.statusId);
         $scope.firstItem = $scope.getFirstItemOb($scope.ticket.firstItemId);
         $scope.secondItem = $scope.getSecondItemOb($scope.ticket.secondItemId);
         $scope.thirdItem = $scope.getThirdItemOb($scope.ticket.thirdItemId);
         $scope.responseGroup = $scope.getGroupOb($scope.ticket.responseGroupId);
         $scope.requestGroup = $scope.getGroupOb($scope.ticket.requestGroupId);

         if ($scope.showStatusDetail) {
        	 $scope.statusDetailOb = $scope.getStatusDetailOb($scope.ticket.statusDetailId);
         }
         if ($scope.showKbn2) {
        	 $scope.kbn2Ob = $scope.getKbn2Ob($scope.ticket.kbn2Id);
         }
         if ($scope.showKbn3) {
        	 $scope.kbn3Ob = $scope.getKbn3Ob($scope.ticket.kbn3Id);
         }
         if ($scope.showKbn4) {
        	 $scope.kbn4Ob = $scope.getKbn4Ob($scope.ticket.kbn4Id);
         }
         if ($scope.showKbn5) {
        	 $scope.kbn5Ob = $scope.getKbn5Ob($scope.ticket.kbn5Id);
         }

         $scope.item1 = $scope.ticket.item1;
         $scope.item2 = $scope.ticket.item2;
         $scope.item3 = $scope.ticket.item3;
         $scope.item4 = $scope.ticket.item4;
         $scope.item5 = $scope.ticket.item5;

         $scope.responseGroups = {selected:$scope.ticket.responseGrouplist};
         $scope.readingGroups = {selected:$scope.ticket.readingGrouplist};

         if ($scope.ticket.startScheduledDate == null || $scope.ticket.startScheduledDate == "") {
           $scope.startScheduledDate = null;
         } else {
           $scope.startScheduledDate = new Date($scope.ticket.startScheduledDate);
         }
         if ($scope.ticket.endScheduledDate == null || $scope.ticket.endScheduledDate == "") {
             $scope.endScheduledDate = null;
           } else {
             $scope.endScheduledDate = new Date($scope.ticket.endScheduledDate);
           }
         if ($scope.ticket.startDate == null || $scope.ticket.startDate == "") {
           $scope.startDate = null;
         } else {
           $scope.startDate = new Date($scope.ticket.startDate);
         }
         if ($scope.ticket.endDate == null || $scope.ticket.endDate == "") {
           $scope.endDate = null;
         } else {
           $scope.endDate = new Date($scope.ticket.endDate);
         }

         for (var i=0; i<$scope.userList.length; i++) {
           if ($scope.ticket.requestUserId == $scope.userList[i].userId) {
             $scope.requestUser = $scope.userList[i];
           }
           if ($scope.ticket.responseUserId == $scope.userList[i].userId) {
             $scope.responseUser = $scope.userList[i];
           }
         }

         if ($scope.ticket.requestUserId && !$scope.requestUser) {
        	 $scope.requestUser = {userName:$scope.ticket.requestUserName, userId:$scope.ticket.requestUserId};
         }

         if ($scope.ticket.responseUserId && !$scope.responseUser) {
        	 $scope.responseUser = {userName:$scope.ticket.responseUserName, userId:$scope.ticket.responseUserId};
         }

       };

       $scope.createRole = function () {
         $scope.isResponser = false;
         $scope.isRequester = false;
         $scope.isEditer = false;
           $scope.isVisitor = false;

           if (localStorage.mngKbn == '2') {
               $scope.isResponser = true;
               $scope.isRequester = true;
               $scope.isEditer = true;
                 $scope.isEditable = true;
                 if ($scope.ticket.statusId == '03' || $scope.ticket.statusId == '04' || $scope.ticket.statusId == '05') {
                     $scope.isEditable = false;
                   }
                 return;
           }


           for (var j=0; j<$scope.loginUser.groupList.length; j++) {
             if ($scope.loginUser.groupList[j].groupId == $scope.ticket.responseGroupId && $scope.ticket.responseGroupId) {
               $scope.isEditer = true;
               $scope.isResponser = true;
             }
             if ($scope.ticket.requestGroupId) {
            	 if ($scope.loginUser.groupList[j].groupId == $scope.ticket.requestGroupId && $scope.ticket.requestGroupId) {
                     $scope.isEditer = true;
                     $scope.isRequester = true;
                   }
             }
           }

//           if (! $scope.ticket.responseGroupId && ! $scope.ticket.responseUserId) {
//             $scope.isEditer = true;
//             $scope.isResponser = true;
//           }

           if (localStorage.userId == $scope.ticket.responseUserId) {
             $scope.isEditer = true;
             $scope.isResponser = true;
           }

           if (localStorage.userId == $scope.ticket.requestUserId) {
             $scope.isEditer = true;
             $scope.isRequester = true;
           }

           if (! $scope.isEditer) {
             outer2 : for (var i=0; i<$scope.ticket.readingGrouplist.length; i++) {
                   for (var j=0; j<$scope.loginUser.groupList.length; j++) {
                     if ($scope.loginUser.groupList[j].groupId == $scope.ticket.readingGrouplist[i].groupId) {
                       $scope.isVisitor = true;
                       break outer2;
                     }
                   }
               }
           }
           if (! $scope.isEditer && ! $scope.isVisitor) {
             window.close();
           } else {
             $scope.isEditable = true;
             if ($scope.ticket.statusId == '03' || $scope.ticket.statusId == '04' || $scope.ticket.statusId == '05') {
               $scope.isEditable = false;
             }
           }

       }


       $scope.init = function () {

         var u =window.location.hash;
         var par = u.split("&");
         if (par.length == 1) {
           $scope.ticketId = u.split("=")[1];
           if ($scope.ticketId.indexOf("#") > -1) {
        	   $scope.ticketId = $scope.ticketId.split("#")[0];
           }
         } else if (par.length == 3) {
           $scope.parentId = par[0].split("=")[1];
           $scope.parentTargetId = par[1].split("=")[1];
           $scope.ticketId = par[2].split("=")[1];
         }

           if ($scope.ticketId) {
             //チェックシート詳細表示
             //チェックシート情報
//             $scope.userList = ajaxService.searchUserList($rootScope.projectId, "1");

        	   var projectIdByTicketId = ajaxService.hasTicket($scope.ticketId);
        	   if(projectIdByTicketId == 0) {
                   alert("該当チェックシートが存在しません。");
                   window.close();
                   return ;
                 }

        	   if (projectIdByTicketId != $rootScope.projectId) {
                   alert("該当チェックシートが存在しません。");
                   window.close();
                   return ;
        	   }

        	   var showId = $rootScope.padLeft($scope.ticketId, 8);
        	   var msg = "SmartBee(ID=" + showId + ")";
        	 $(document).attr("title",msg);

             $scope.getTicketInfo($scope.ticketId);

             //チェック情報
             $scope.getCheckreportList($scope.ticketId);

             //履歴リスト情報
             $scope.getCommentList($scope.ticketId);

             //ファイル情報
             $scope.searchFileList($scope.ticketId);

             //サブチェックシート情報
             $scope.getSubTicketList($scope.ticketId);

             $scope.createRole();

             $("#checkreportCreater").css({
                   'display' : 'none'
             });
             $("#checkreportDetail").css({
                 'display' : 'block'
             });
             $("#checkResultList").css({
                 'display' : 'block'
             });
             $("#comments").css({
                 'display' : 'block'
             });
             $("#fileList").css({
                 'display' : 'block'
             });
             /*
             $("body,html").animate({
                 scrollTop : $("#checkreportDetail").offset().top - 100
             }, 1000);
             */

           } else {
             //チェックシート新規
             $scope.firstItem = new Object();
             $scope.secondItem = new Object();
             $scope.thirdItem = new Object();

             $scope.statusDetailOb = new Object();
             $scope.kbn2Ob = new Object();
             $scope.kbn3Ob = new Object();
             $scope.kbn4Ob = new Object();
             $scope.kbn5Ob = new Object();

//             $scope.userList = ajaxService.searchUserList($rootScope.projectId, "1");
             if (! $scope.userList) {
               $scope.userList = ajaxService.selectUserList($rootScope.projectId);
               $scope.userList.unshift({userName:" ", userId:null});
             }
             for (var i=0; i<$scope.userList.length; i++) {
               if (localStorage.userId == $scope.userList[i].userId) {
                 $scope.requestUser = $scope.userList[i];
               }
             }

             $scope.responseUser = $scope.userList[0];

             $scope.responseGroup = new Object();
             $scope.requestGroup = new Object();

             $scope.responseGroups = {selected:[]};

             $scope.defaultGroupList = ajaxService.selectDefaultGroupList($rootScope.projectId);
             $scope.readingGroups = {selected:$scope.defaultGroupList};

	   	      $scope.firstList = ajaxService.getProjectResourceList($rootScope.projectId, '91', 0);
	   	      $scope.firstList.unshift({label:" ", id:null})
	   	      $scope.secondList = [{label:"マスタデータがありません", id:null}];
	   	      $scope.thirdList = [{label:"マスタデータがありません", id:null}];
	   	      $scope.fourthList = [{label:"マスタデータがありません", id:null}];

	   	      $scope.first = $scope.firstList[0];
	   	      $scope.second = $scope.secondList[0];
	   	      $scope.third = $scope.thirdList[0];
	   	      $scope.fourth = $scope.fourthList[0];

	   	      $scope.firstDisable = false;
	   	      $scope.secondDisable = true;
	   	      $scope.thirdDisable = true;
	   	      $scope.fourthDisable = true;

	   	      $scope.changeFirst = function () {
	   	      	$scope.secondList = ajaxService.getProjectResourceList($rootScope.projectId, '92', $scope.first.id);
	   	          if ($scope.secondList.length == 0) {
	   	            $scope.secondList.push({label:"マスタデータがありません", id:0});
	   	              $scope.secondDisable = true;
	   	          } else {
	   	              $scope.secondDisable = false;
	   	          }
	   	          $scope.second = $scope.secondList[0];
	   	          $scope.changeSecond();
	   	      };

	   	      $scope.changeSecond = function () {
	   	          $scope.thirdList = ajaxService.getProjectResourceList($rootScope.projectId, '93', $scope.second.id);
	   		        if ($scope.thirdList.length == 0) {
	   		          $scope.thirdList.push({label:"マスタデータがありません", id:0});
	   		            $scope.thirdDisable = true;
	   		        } else {
	   		            $scope.thirdDisable = false;
	   		        }
	   		        $scope.third = $scope.thirdList[0];
	   		        $scope.changeThird();
	   	      };

	   	      $scope.changeThird = function () {
	   	          $scope.fourthList = ajaxService.getProjectResourceList($rootScope.projectId, '94', $scope.third.id);
	   		        if ($scope.fourthList.length == 0) {
	   		          $scope.fourthList.push({label:"マスタデータがありません", id:0});
	   		            $scope.fourthDisable = true;
	   		        } else {
	   		            $scope.fourthDisable = false;
	   		        }
	   		        $scope.fourth = $scope.fourthList[0];
	   	      };

             $scope.getTargetList();
             if ($scope.parentTargetId) {
            	 for (var i=0; i< $scope.targetList.length;i++) {
            		 if($scope.parentTargetId == $scope.targetList[i].id){
            			 $scope.target = $scope.targetList[i];
            			 break;
            		 }
            	 }
             } else {
                 $scope.target = {};
             }

             $("#checkreportCreater").css({
                   'display' : 'block'
             });
             $("#checkreportDetail").css({
                 'display' : 'none'
             });
             $("#checkResultList").css({
                 'display' : 'none'
             });
             $("#comments").css({
                 'display' : 'none'
             });
             $("#fileList").css({
                 'display' : 'none'
             });

             //window.location.href = window.location.href + "aaaa";
           }
       };
       $scope.init();


       $scope.showCreateTarget = function() {
         //工事項目リストを取得
         $scope.targetItemList = new Array();
         for (var i=0; i<$scope.itemNameList.length; i++) {
           if (i % 2 == 0) {
             var obj = {"left":null, "right": null};
               obj["left"] = $scope.itemNameList[i];
               if (i == $scope.itemNameList.length - 1) {
                 $scope.targetItemList.push(obj);
               }
           } else {
             obj["right"] = $scope.itemNameList[i];
             $scope.targetItemList.push(obj);
           }
         }
           var modalInstance = $uibModal.open({
               animation : true,
               templateUrl : 'app/pages/checktarget/newCheckTarget.html',
               controller : 'ChecktargetCtrl',
               scope : $scope,
               backdrop : "static",
               size: 'lg',
               resolve : {
                 message : function() {
                     return {
                           type : "ticket"
                       };
                   }
               }
           });

           modalInstance.result.then(function() {
             $scope.getTargetList();
             $scope.target = $scope.targetList[$scope.targetList.length-1];
           });
       };

       $scope.createTicket = function() {

         if (!$scope.fourth.id || $scope.fourth.id == 0 ) {
             $rootScope.showErrorMessage("小項目までを選択してください。");
             return;
       	 }

         $scope.checklistList = ajaxService.searchChecksheetList($rootScope.projectId, "0");
         console.log($scope.checklistList);

         var checksheetId = "0";

         for (var i = 0; i < $scope.checklistList.length; i ++) {
        	 if ($scope.fourth.id == $scope.checklistList[i].fourthId) {
        		 checksheetId = $scope.checklistList[i].checksheetId;
        		 break;
        	 }
         }

         if (checksheetId == "0") {
             $rootScope.showErrorMessage("選択された小項目に関連するチェックが存在しません。");
             return;
         }

         if (! $scope.target.id) {
           $rootScope.showErrorMessage("対象工事を選択してください。");
           return;
         }

         if ((!$scope.requestUser.userId || $scope.requestUser.userId == "") && (!$scope.requestGroup.groupId || $scope.requestGroup.groupId == "")) {
             $rootScope.showErrorMessage("管理技術者または指示グループを選択してください。");
             return;
         }

         if ($scope.mustStatusDetail && $scope.statusDetailOb.id == null) {
        	 $rootScope.showErrorMessage($scope.statusDetailItemName + "を選択してください。");
             return;
         }
         if ($scope.mustKbn2 && $scope.kbn2Ob.id == null) {
        	 $rootScope.showErrorMessage($scope.kbn2ItemName + "を選択してください。");
             return;
         }
         if ($scope.mustKbn3 && $scope.kbn3Ob.id == null) {
        	 $rootScope.showErrorMessage($scope.kbn3ItemName + "を選択してください。");
             return;
         }
         if ($scope.mustKbn4 && $scope.kbn4Ob.id == null) {
        	 $rootScope.showErrorMessage($scope.kbn4ItemName + "を選択してください。");
             return;
         }
         if ($scope.mustKbn5 && $scope.kbn5Ob.id == null) {
        	 $rootScope.showErrorMessage($scope.kbn5ItemName + "を選択してください。");
             return;
         }
         if ($scope.mustItem1 && ! $scope.item1) {
        	 $rootScope.showErrorMessage($scope.item1ItemName + "を入力してください。");
             return;
         }
         if ($scope.mustItem2 && ! $scope.item2) {
        	 $rootScope.showErrorMessage($scope.item2ItemName + "を入力してください。");
             return;
         }
         if ($scope.mustItem3 && ! $scope.item3) {
        	 $rootScope.showErrorMessage($scope.item3ItemName + "を入力してください。");
             return;
         }
         if ($scope.mustItem4 && ! $scope.item4) {
        	 $rootScope.showErrorMessage($scope.item4ItemName + "を入力してください。");
             return;
         }
         if ($scope.mustItem5 && ! $scope.item5) {
        	 $rootScope.showErrorMessage($scope.item5ItemName + "を入力してください。");
             return;
         }


         var responseGroupIdlist = [];
         for (var i =0; i< $scope.responseGroups.selected.length; i++) {
           responseGroupIdlist.push($scope.responseGroups.selected[i].groupId);
         }
         var readingGroupIdlist = [];
         for (var i =0; i< $scope.readingGroups.selected.length; i++) {
        	 if ($rootScope.listContains(readingGroupIdlist, $scope.readingGroups.selected[i].groupId) || $scope.readingGroups.selected[i].groupId == null){
        		 continue;
        	 }
           readingGroupIdlist.push($scope.readingGroups.selected[i].groupId);
         }

         var ticket = new Object();
         ticket.targetId = $scope.target.id;
         ticket.checksheetId = checksheetId;
         ticket.firstItemId = $scope.firstItem.id;
         ticket.secondItemId = $scope.secondItem.id;
         ticket.thirdItemId = $scope.thirdItem.id;
         ticket.startScheduledDate = $rootScope.formatDate($scope.startScheduledDate, "YYYY/MM/DD");
         ticket.endScheduledDate = $rootScope.formatDate($scope.endScheduledDate, "YYYY/MM/DD");
         ticket.startDate = $rootScope.formatDate($scope.startDate, "YYYY/MM/DD");
         ticket.endDate = $rootScope.formatDate($scope.endDate, "YYYY/MM/DD");
         ticket.requestUserId = $scope.requestUser.userId;
         ticket.responseGroupId = $scope.responseGroup.groupId;
         ticket.responseUserId = $scope.responseUser.userId;
         ticket.requestGroupId = $scope.requestGroup.groupId;

         ticket.statusDetailId = $scope.statusDetailOb.id;
         ticket.kbn2Id = $scope.kbn2Ob.id;
         ticket.kbn3Id = $scope.kbn3Ob.id;
         ticket.kbn4Id = $scope.kbn4Ob.id;
         ticket.kbn5Id = $scope.kbn5Ob.id;
         ticket.item1 = $scope.item1;
         ticket.item2 = $scope.item2;
         ticket.item3 = $scope.item3;
         ticket.item4 = $scope.item4;
         ticket.item5 = $scope.item5;

         ticket.responseGroupIdlist = responseGroupIdlist;
         ticket.readingGroupIdlist = readingGroupIdlist;

         if ($scope.parentId) {
           ticket.parentId = $scope.parentId;
         } else {
           ticket.parentId = 0;
         }
         //ステータス：チェック前("01")
         ticket.statusId = "01";
         var url = window.location.href;
         var newTicketId = ajaxService.createTicket($rootScope.projectId, ticket, "チェックシートが新規作成されました。", url)
         if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
         } else {
            $rootScope.showInfoMessage("チェックシートが新規作成されました。");
            window.location.href = window.location.href+newTicketId;
            $scope.init();
         }
       };

      $scope.scrollToCheckList  = function(checkreportId) {
          $("body,html").animate({
              scrollTop : $("#checkResultList").offset().top - 100
          }, 1000);
      };



      $scope.modifyTicket  = function() {


          if ($scope.mustStatusDetail && $scope.statusDetailOb.id == null) {
         	 $rootScope.showErrorMessage($scope.statusDetailItemName + "を選択してください。");
              return "";
          }
          if ($scope.mustKbn2 && $scope.kbn2Ob.id == null) {
         	 $rootScope.showErrorMessage($scope.kbn2ItemName + "を選択してください。");
              return "";
          }
          if ($scope.mustKbn3 && $scope.kbn3Ob.id == null) {
         	 $rootScope.showErrorMessage($scope.kbn3ItemName + "を選択してください。");
              return "";
          }
          if ($scope.mustKbn4 && $scope.kbn4Ob.id == null) {
         	 $rootScope.showErrorMessage($scope.kbn4ItemName + "を選択してください。");
              return "";
          }
          if ($scope.mustKbn5 && $scope.kbn5Ob.id == null) {
         	 $rootScope.showErrorMessage($scope.kbn5ItemName + "を選択してください。");
              return "";
          }
          if ($scope.mustItem1 && ! $scope.item1) {
         	 $rootScope.showErrorMessage($scope.item1ItemName + "を入力してください。");
              return "";
          }
          if ($scope.mustItem2 && ! $scope.item2) {
         	 $rootScope.showErrorMessage($scope.item2ItemName + "を入力してください。");
              return "";
          }
          if ($scope.mustItem3 && ! $scope.item3) {
         	 $rootScope.showErrorMessage($scope.item3ItemName + "を入力してください。");
              return "";
          }
          if ($scope.mustItem4 && ! $scope.item4) {
         	 $rootScope.showErrorMessage($scope.item4ItemName + "を入力してください。");
              return "";
          }
          if ($scope.mustItem5 && ! $scope.item5) {
         	 $rootScope.showErrorMessage($scope.item5ItemName + "を入力してください。");
              return "";
          }

		  if ((!$scope.requestUser.userId || $scope.requestUser.userId == "") && (!$scope.requestGroup.groupId || $scope.requestGroup.groupId == "")) {
	          $rootScope.showErrorMessage("管理技術者または指示グループを選択してください。");
	          return "";
	      }
/*
        if (! $scope.isFinsh && ($scope.statusOb.value == '03' || $scope.statusOb.value == '04' || $scope.statusOb.value == '05')) {
          $rootScope.showErrorMessage("未完了のチェック項目があるため、ステータスの更新ができません。");
          return "";
        }

        if (localStorage.mngKbn == '0' && ($scope.statusOb.value == '99' || $scope.statusOb.value == '04' || $scope.statusOb.value == '05')) {
          $rootScope.showErrorMessage($scope.statusOb.label + "を指定する権限がありません。");
            return "";
        }

        if (localStorage.mngKbn == '1' && $scope.statusOb.value == '05') {
          $rootScope.showErrorMessage($scope.statusOb.label + "を指定する権限がありません。");
            return "";
        }

        if ($scope.statusOb.value == '99' || $scope.statusOb.value == '04' || $scope.statusOb.value == '05') {
          if (localStorage.userId != $scope.ticket.requestUserId) {
            var isRequestGroupUser = false
            for (var j=0; j<$scope.loginUser.groupList.length; j++) {
              if ($scope.loginUser.groupList[j].groupId == $scope.ticket.requestGroupId) {
                isRequestGroupUser = true;
                break;
              }
            }
            if (! isRequestGroupUser) {
              $rootScope.showErrorMessage($scope.statusOb.label + "を指定する権限がありません。");
                return "";
            }
          }
        }
*/

        $scope.ticket.statusId = $scope.statusOb.value;
        $scope.ticket.firstItemId = $scope.firstItem.id;
        $scope.ticket.secondItemId = $scope.secondItem.id;
        $scope.ticket.thirdItemId = $scope.thirdItem.id;

        if ($scope.showStatusDetail) {
        	$scope.ticket.statusDetailId = $scope.statusDetailOb.id;
        }
        if ($scope.showKbn2) {
        	$scope.ticket.kbn2Id = $scope.kbn2Ob.id;
        	$scope.ticket.kbn2 = $scope.kbn2Ob.label;

        }
        if ($scope.showKbn3) {
        	$scope.ticket.kbn3Id = $scope.kbn3Ob.id;
        	$scope.ticket.kbn3 = $scope.kbn3Ob.label;
        }
        if ($scope.showKbn4) {
        	$scope.ticket.kbn4Id = $scope.kbn4Ob.id;
        	$scope.ticket.kbn4 = $scope.kbn4Ob.label;
        }
        if ($scope.showKbn5) {
        	$scope.ticket.kbn5Id = $scope.kbn5Ob.id;
        	$scope.ticket.kbn5 = $scope.kbn5Ob.label;
        }
        if ($scope.showItem1) {
        	$scope.ticket.item1 = $scope.item1;
        }
        if ($scope.showItem2) {
        	$scope.ticket.item2 = $scope.item2;
        }
        if ($scope.showItem3) {
        	$scope.ticket.item3 = $scope.item3;
        }
        if ($scope.showItem4) {
        	$scope.ticket.item4 = $scope.item4;
        }
        if ($scope.showItem5) {
        	$scope.ticket.item5 = $scope.item5;
        }

        $scope.ticket.startScheduledDate = $rootScope.formatDate($scope.startScheduledDate, "YYYY/MM/DD");
        $scope.ticket.endScheduledDate = $rootScope.formatDate($scope.endScheduledDate, "YYYY/MM/DD");
        $scope.ticket.startDate = $rootScope.formatDate($scope.startDate, "YYYY/MM/DD");
        $scope.ticket.endDate = $rootScope.formatDate($scope.endDate, "YYYY/MM/DD");

        if ($scope.requestUser) {
        	$scope.ticket.requestUserId = $scope.requestUser.userId;
            $scope.ticket.requestUserName = $scope.requestUser.userName;
        }

        if ($scope.responseGroup) {
          $scope.ticket.responseGroupId = $scope.responseGroup.groupId;
          $scope.ticket.responseGroupName = $scope.responseGroup.groupName;
        }
        if ($scope.responseUser) {
          $scope.ticket.responseUserId = $scope.responseUser.userId;
          $scope.ticket.responseUserName = $scope.responseUser.userName;
        }
        if ($scope.requestGroup) {
          $scope.ticket.requestGroupId = $scope.requestGroup.groupId;
          $scope.ticket.requestGroupName = $scope.requestGroup.groupName;
        }
//        $scope.ticket.responseGroupId = $scope.responseGroup.groupId;
//        $scope.ticket.responseUserId = $scope.responseUser.userId;
//        $scope.ticket.readingGroupId = $scope.readingGroup.groupId;

//        var responseGroupIdlist = [];
//        for (var i =0; i< $scope.responseGroups.selected.length; i++) {
//          responseGroupIdlist.push($scope.responseGroups.selected[i].groupId);
//        }

        var readingGroupIdlist = [];
        for (var i =0; i< $scope.readingGroups.selected.length; i++) {
         if ($rootScope.listContains(readingGroupIdlist, $scope.readingGroups.selected[i].groupId) || $scope.readingGroups.selected[i].groupId == null){
       		 continue;
       	 }
          readingGroupIdlist.push($scope.readingGroups.selected[i].groupId);
        }

//        $scope.ticket.responseGroupIdlist = responseGroupIdlist;
        $scope.ticket.readingGroupIdlist = readingGroupIdlist;
        ajaxService.modifyTicket($scope.ticket, $rootScope.projectId);
        if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
         } else {
            $rootScope.showInfoMessage("チェックシートを更新しました。");
            $scope.getTicketInfo($scope.ticket.id);
            $scope.getCommentList($scope.ticket.id);
            $scope.createRole();
         }
      };

      $scope.modifyStatus = function(statusId) {
        if (! $scope.isFinsh && (statusId == '03' || statusId == '04' || statusId == '05')) {
            $rootScope.showErrorMessage("未完了のチェック項目があるため、ステータスの更新ができません。");
            return "";
        }

        if (statusId == '03') {
          //サブチェックシートのステータスを確認
          $scope.subTicketList = ajaxService.getSubTicketList($rootScope.projectId, $scope.ticket.id);

          for (var i=0; i<$scope.subTicketList.length; i++) {
            var subTicket = $scope.subTicketList[i];
            if (subTicket.statusId == '01' || subTicket.statusId == '02' || subTicket.statusId == '99') {
              $rootScope.showErrorMessage("未完了のサブチェックシートがあるため、チェック完了ができません。");
              return "";
            }
          }
          //報告書メールのフラグ
          if ($scope.commentWithMail != '1') {
        	  $scope.ticket.sendReportFlag = false;
          } else {
        	  var sendReportFlag = document.sendReportFlag.reportSend;
              $scope.ticket.sendReportFlag = sendReportFlag.checked;
          }

        } else if (statusId == '04') {

          $scope.subTicketList = ajaxService.getSubTicketList($rootScope.projectId, $scope.ticket.id);
            for (var i=0; i<$scope.subTicketList.length; i++) {
              var subTicket = $scope.subTicketList[i];
              if (subTicket.statusId == '01' || subTicket.statusId == '02' || subTicket.statusId == '99' || subTicket.statusId == '03') {
                $rootScope.showErrorMessage("未承認のサブチェックシートがあるため、承認ができません。");
                return "";
              }
            }

        } else if (statusId == '05') {
          $scope.subTicketList = ajaxService.getSubTicketList($rootScope.projectId, $scope.ticket.id);
            for (var i=0; i<$scope.subTicketList.length; i++) {
              var subTicket = $scope.subTicketList[i];
              if (subTicket.statusId == '01' || subTicket.statusId == '02' || subTicket.statusId == '99' || subTicket.statusId == '04' || subTicket.statusId == '03') {
                $rootScope.showErrorMessage("未最終承認のサブチェックシートがあるため、最終承認ができません。");
                return "";
              }
            }
        }

        if (statusId == '02') {
          //引戻し
          if ($scope.ticket.parentId && $scope.ticket.parentId != 0) {
            var parent = ajaxService.searchTicketInfo($rootScope.projectId, $scope.ticket.parentId);
              while (parent && parent.statusId == '03') {
                parent.statusId = '02';
                ajaxService.modifyTicket(parent, $rootScope.projectId);
                if (parent.parentId && parent.parentId != 0) {
                    parent = ajaxService.searchTicketInfo($rootScope.projectId, parent.parentId);
                } else {
                    break;
                }
              }
          }
        }

        if (statusId == '99') {
          //差戻し
          if ($scope.ticket.parentId && $scope.ticket.parentId != 0) {
            var parent = ajaxService.searchTicketInfo($rootScope.projectId, $scope.ticket.parentId);
              while (parent && (parent.statusId == '03' || parent.statusId == '04' || parent.statusId == '05')) {
                parent.statusId = '99';
                ajaxService.modifyTicket(parent, $rootScope.projectId);
                if (parent.parentId && parent.parentId != 0) {
                    parent = ajaxService.searchTicketInfo($rootScope.projectId, parent.parentId);
                } else {
                    break;
                }
              }
          }
        }


          $scope.ticket.statusId = statusId;
          var readingGroupIdlist = [];
          for (var i =0; i< $scope.ticket.readingGrouplist.length; i++) {
            readingGroupIdlist.push($scope.ticket.readingGrouplist[i].groupId);
          }

          $scope.ticket.readingGroupIdlist = readingGroupIdlist;

          ajaxService.modifyTicket($scope.ticket, $rootScope.projectId);
          if (ajaxService.result['resultCd'] != "000000") {
              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
           } else {
              $rootScope.showInfoMessage("更新しました。");
              $scope.getTicketInfo($scope.ticket.id);
              $scope.getCommentList($scope.ticket.id);
              $scope.createRole();
           }
        };

      $scope.showTargetInfo = function (targetId) {
        $uibModal.open({
          animation: true,
          templateUrl: "app/pages/checkreport/checkreportTargetInfo.html",
          controller: 'CheckreportCtrl',
          size: 'lg',
          backdrop : "static",
          scope : $scope,
          resolve: {
              openFlag: function () {
                  return {};
            }
          }
        });

        // 工事検索
        $scope.selectedTarget = ajaxService.searchTarget(targetId);

        $scope.selectedTar = {};
        $scope.selectedTar.pref = $rootScope.getPrefOb($scope.selectedTarget.prefCd);
        $scope.selectedTar.reg = $rootScope.getRegionOb($scope.selectedTarget.region);

        $scope.targetItemList = new Array();
        $scope.show = {};
        for (var i=0; i<$scope.itemNameList.length; i++) {
          var field = $scope.itemNameList[i].fieldName;
          $scope.show[field] = $scope.itemNameList[i].showName;
          if (i % 2 == 0) {
            var obj = {"left":null, "right": null};
              obj["left"] = $scope.itemNameList[i];
              if (i == $scope.itemNameList.length - 1) {
                $scope.targetItemList.push(obj);
              }
          } else {
            obj["right"] = $scope.itemNameList[i];
            $scope.targetItemList.push(obj);
          }
        }

        $scope.targetFileList = ajaxService.getFileListTarget(targetId);

      };

      $scope.showCheckResultDetail = function (checkListInfo) {
          $uibModal.open({
            animation: true,
            templateUrl: "app/pages/checkreport/checkResultDetail.html",
            controller: 'CheckResultCtrl',
            scope : $scope,
            backdrop : "static",
            size: 'lg',
            resolve: {
                openFlag: function () {
                    return {
                      "ticketId":$scope.ticketId,
                      "checkList":checkListInfo,
                      "checkListBeanList":$scope.checkresultList
                    };
              }
            }
          });
        };

        $scope.openUploadDialog = function() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/checklist/fileUploadModal.html',
                controller : 'FileUploadCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    openFlag : function() {
                        return {
                            'flag' : 'New',
                            'kbn' : 'ticket',
                            'id': $scope.ticketId
                        };
                    }
                }
            });
        };

        $scope.delFile = function (fileBean) {
            var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "該当ファイルを削除してもよろしいですか？"
                        };
                    }
                }
            });
            modalInstance.result.then(function() {
              ajaxService.removeFileTicket($rootScope.projectId, $scope.ticketId, fileBean.id, fileBean.fileExternal);
              if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              } else {
                $rootScope.showInfoMessage("該当ファイルを削除しました。");
                $scope.searchFileList($scope.ticketId);
              }
            });
          };

          $scope.saveComment = function () {
//            var content = $scope.$$childHead.content;
            var content = $scope.ctrl.content;
            if (! content) {
              $rootScope.showErrorMessage("コメントを入力してください。");
              return;
            }

            var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "コメントを登録してもよろしいですか？"
                        };
                    }
                }
            });

            modalInstance.result.then(function() {
                var url = window.location.href;
            	ajaxService.saveComment($scope.ticketId, $scope.ticket.statusId, content, $rootScope.projectId, url);
                if (ajaxService.result['resultCd'] != "000000") {
                    $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                  } else {
                    $rootScope.showInfoMessage("コメントを保存しました。");
                    $scope.getCommentList($scope.ticketId);
                    $scope.ctrl.content = "";
                  }
            });
          };

          $scope.deleteComment = function (id) {
            var modalInstance = $uibModal.open({
                  animation : true,
                  templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                  controller : 'confirmDialogCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                              message : "該当コメントを削除してもよろしいですか？"
                          };
                      }
                  }
              });
              modalInstance.result.then(function() {
                ajaxService.removeComment(id);
                if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                } else {
                  $rootScope.showInfoMessage("該当コメントを削除しました。");
                  $scope.getCommentList($scope.ticketId);
                }
              });
          };

          $scope.CheckreportDelete = function () {
            var modalInstance = $uibModal.open({
                  animation : true,
                  templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                  controller : 'confirmDialogCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                              message : "チェックシートを削除してもよろしいですか？"
                          };
                      }
                  }
              });
            modalInstance.result.then(function() {
                ajaxService.removeTicket($rootScope.projectId, $scope.ticketId);
                if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                } else {
                  $rootScope.showInfoMessage("チェックシートを削除しました。");
                  $timeout(function() {
                      window.close()
                    }, 1000);
                }
              });
          };

          $scope.showCreateSubTicket = function () {
            var url = window.location.href;
              var u = url.split("#")[0];
              window.open(u + "#/showReportDetail?parent=" + $scope.ticketId + "&targetId="+ $scope.ticket.targetId + "&id=");
          };

          $scope.showParentTicketDetail = function () {
              var url = window.location.href;
              var u = url.split("#")[0];
//              window.location.href = u + "#/showReportDetail?id=" + $scope.ticket.parentId;
//              window.location.reload();

              window.open(u + "#/showReportDetail?id=" + $scope.ticket.parentId);
          };

          $scope.showSubTicketDetail = function (ticketId) {
            var url = window.location.href;
              var u = url.split("#")[0];
//              window.location.href = u + "#/showReportDetail?id=" + ticketId;
//              window.location.reload();

              window.open(u + "#/showReportDetail?id=" + ticketId);
          };

          $scope.downloadTicket  = function(emptyFlg) {

        	  baProgressModal.open('app/pages/checkreport/progressModal.html',$scope);
        	  $http({

                  url: urlPrefix + "checkreport/downloadTicket/",
	        	  method: "POST",
	              data: JSON.stringify(
	                      {"ticketId":$scope.ticket.id,
	                          "schema" : localStorage.schema,
	                          "projectId" : $rootScope.projectId,
	                          "emptyFlg" : emptyFlg
	                          }), //this is your json data string
	              headers: {
	                 'Content-type': 'application/json'
	              },
	              responseType: 'arraybuffer'

              }).success(function (data, status, headers, config) {

            	  var checksheetName = decodeURI(headers()["checksheetname"]);
            	  var blob = new Blob([data], { type: "application/vnd.ms-excel" });

            	  var fileName = checksheetName;
//                  var fileName = "チェック報告書(" + $scope.ticket.targetName+"_"  + $scope.ticket.checksheetName+")_" +$rootScope.padLeft($scope.ticket.id, 8)+".xls";

                  var ostest = $window.navigator.userAgent.toLowerCase();
                  var isiOS = false;

                  if ( ostest.indexOf("iphone") !== -1 || ostest.indexOf("ipad") !== -1 || ostest.indexOf("mac os x") !== -1) {
                      isiOS = true;
                  }

                  if (isiOS) {
                	  var reader = new FileReader();
                      reader.onload =function(e) {
                        window.open(reader.result);
                      }
                      reader.readAsDataURL(blob);
                  } else {
                	  if ($window.navigator.msSaveBlob) {
                          $window.navigator.msSaveBlob(blob, fileName);
                      } else {
                          var downloadLink = $('<a></a>');
                          downloadLink.attr('href', $window.URL.createObjectURL(blob));
                          downloadLink.attr('download', fileName);
                          downloadLink.attr('target', '_blank');
                          $('body').append(downloadLink);
                          downloadLink[0].click();
                          downloadLink.remove();
                      }
                  }

                  baProgressModal.close();
              }).error(function (data, status, headers, config) {
            	  $rootScope.showErrorMessage("システムエラーが発生しました。システム管理者にご連絡ください。");
                  baProgressModal.close();
              });

          };

          $scope.showUserInfo  = function(userId) {

              $scope.userInfo = ajaxService.searchUser($rootScope.projectId, userId);

              if ($scope.userInfo == null) {
            	  $rootScope.showErrorMessage("該当技術者が業務から外されたため、技術者情報が参照できません。");
            	  return;
              }

            $uibModal.open({
              animation: true,
              templateUrl: "app/pages/checkreport/userInfo.html",
              scope : $scope,
              backdrop : "static",
              resolve: {
                  openFlag: function () {
                      return {};
                }
              }
            });

          };


          $scope.showGroupUserList  = function(groupId) {
            $uibModal.open({
              animation: true,
              size: 'lg',
              templateUrl: "app/pages/checkreport/groupUserList.html",
              scope : $scope,
              backdrop : "static",
              resolve: {
                  openFlag: function () {
                      return {};
                }
              }
            });

            $scope.groupUserList = ajaxService.getListByGroupId(groupId);
          };

          $scope.scrollToBottom  = function(div) {
        	  setTimeout(function () {
        		  var objDiv = document.getElementById(div);
        		  objDiv.scrollTop = 150;
              }, 110)
          };


          $scope.changeTarget  = function() {
        	  if ($scope.target.latitude && $scope.target.longitude) {
        		  if ($scope.userOrder == '1') {
        		      if ($scope.adminMng != '1') {

    		    		  $scope.getUserGroupSortWithTarget();

//        		    	  if (localStorage.mngKbn != '0') {
//        		    		  $scope.getUserGroupSortWithTarget();
//        		    	  } else {
//        		    		  $scope.groupList = angular.copy($scope.loginUser.groupList);
//        		              //チェック者は自分所属しているグループ内の技術者のみが見れる。
//        		              if ($scope.groupList.length == 0) {
//        		            	  $scope.userList = [];
//        		            	  $scope.userList.push($scope.loginUser);
//        		              } else {
//        		            	  var groupIdList = [];
//        		            	  for (var i = 0; i < $scope.groupList.length; i++) {
//        		            		  if ($scope.groupList[i].groupId) {
//            		            		  groupIdList.push($scope.groupList[i].groupId);
//        		            		  }
//        		            	  }
//        		                  $scope.userList = ajaxService.selectUserListOrderByDis($rootScope.projectId, $scope.target.latitude, $scope.target.longitude, groupIdList);
//        		              }
//        		              $scope.userList.unshift({userName:" ", userId:''});
//        		              for (var i=0; i<$scope.userList.length; i++) {
//        	                      if (localStorage.userId == $scope.userList[i].userId) {
//        	                        $scope.requestUser = $scope.userList[i];
//        	                      }
//        	                    }
//
//        	                  $scope.responseUser = $scope.userList[0];
//
//        	                  var groups = ajaxService.selectGroupUserResourceListOrderByDis($rootScope.projectId, $scope.target.latitude, $scope.target.longitude, groupIdList);
//        				      if (ajaxService.result['resultCd'] == "000000") {
//        				    	  $scope.groupList = groups;
//        				          $scope.groupList.unshift({groupName:" ", groupId:null});
//        				          $scope.responseGroup = $scope.groupList[0];
//        				          $scope.requestGroup = $scope.groupList[0];
//        				      }
//        		    	  }
        		      } else {
        		    	  if (localStorage.mngKbn == '2') {
            		    	  $scope.getUserGroupSortWithTarget();
        		    	  } else {
        		    		  $scope.groupList = angular.copy($scope.loginUser.groupList);
        		              //指示者、チェック者は自分所属しているグループ内の技術者のみが見れる。
        		              if ($scope.groupList.length == 0) {
        		            	  $scope.userList = [];
        		            	  $scope.userList.push($scope.loginUser);
        		              } else {
        		            	  var groupIdList = [];
        		            	  for (var i = 0; i < $scope.groupList.length; i++) {
        		            		  if ($scope.groupList[i].groupId) {
            		            		  groupIdList.push($scope.groupList[i].groupId);
        		            		  }
        		            	  }
        		                  $scope.userList = ajaxService.selectUserListOrderByDis($rootScope.projectId, $scope.target.latitude, $scope.target.longitude, groupIdList);
        		              }
        		              $scope.userList.unshift({userName:" ", userId:''});
        		              for (var i=0; i<$scope.userList.length; i++) {
        	                      if (localStorage.userId == $scope.userList[i].userId) {
        	                        $scope.requestUser = $scope.userList[i];
        	                      }
        	                    }

        	                  $scope.responseUser = $scope.userList[0];

        	                  var groups = ajaxService.selectGroupUserResourceListOrderByDis($rootScope.projectId, $scope.target.latitude, $scope.target.longitude, groupIdList);
        				      if (ajaxService.result['resultCd'] == "000000") {
        				    	  $scope.groupList = groups;
        				          $scope.groupList.unshift({groupName:" ", groupId:null});
        				          $scope.responseGroup = $scope.groupList[0];
        				          $scope.requestGroup = $scope.groupList[0];
        				      }
        		    	  }
        		      }

        		  }
        	  }
          };

          $scope.getUserGroupSortWithTarget  = function() {
        	  var uses = ajaxService.selectUserListOrderByDis($rootScope.projectId, $scope.target.latitude, $scope.target.longitude, new Array());
			  if (ajaxService.result['resultCd'] == "000000") {
				  $scope.userList = uses;
                  $scope.userList.unshift({userName:" ", userId:null});
                  for (var i=0; i<$scope.userList.length; i++) {
                      if (localStorage.userId == $scope.userList[i].userId) {
                        $scope.requestUser = $scope.userList[i];
                      }
                    }

                    $scope.responseUser = $scope.userList[0];
			  }

			  if (localStorage.mngKbn != '0') {
			      var groups = ajaxService.selectGroupUserResourceListOrderByDis($rootScope.projectId, $scope.target.latitude, $scope.target.longitude, new Array());
			      if (ajaxService.result['resultCd'] == "000000") {
			    	  $scope.groupList = groups;
			          $scope.groupList.unshift({groupName:" ", groupId:null});
			          $scope.responseGroup = $scope.groupList[0];
			          $scope.requestGroup = $scope.groupList[0];
			      }

			  }
          }


          $scope.downloadContent = function() {

        	  baProgressModal.open('app/pages/checkreport/progressModal.html',$scope);

        	  $http({
                  url: urlPrefix + "checkreport/downloadContent/",
                  method: "POST",
                  data: JSON.stringify(
                          {"ticketId":$scope.ticket.id,
                              "schema" : localStorage.schema,
	                          "projectId" : $rootScope.projectId,
                              "loginId" : localStorage.userId
                              }), //this is your json data string
                  headers: {
                     'Content-type': 'application/json'
                  },
                  responseType: 'arraybuffer'
              }).success(function (data, status, headers, config) {
            	  if (status == 202) {
                      baProgressModal.close();
            		  $rootScope.showErrorMessage("写真がありません。");
            		  return;
            	  }

                  var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

                  var fileName = "写真.zip";

                  if ($window.navigator.msSaveBlob) {
                      $window.navigator.msSaveBlob(blob, fileName);
                  } else {
                      var downloadLink = $('<a></a>');
                      downloadLink.attr('href', $window.URL.createObjectURL(blob));
                      downloadLink.attr('download', fileName);
                      downloadLink.attr('target', '_blank');
                      $('body').append(downloadLink);
                      downloadLink[0].click();
                      downloadLink.remove();
                  }
                  baProgressModal.close();
              }).error(function (data, status, headers, config) {
            	  $rootScope.showErrorMessage("システムエラーが発生しました。システム管理者にご連絡ください。");
                  baProgressModal.close();
              });
          };

          $scope.copyTicket = function () {
        	var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "このチェックシートをコピーして登録しますが、よろしいですか？"
                        };
                    }
                }
            });
            modalInstance.result.then(function() {
	          	var ticket = new Object();
	            ticket.targetId = $scope.ticket.targetId;
	            ticket.checksheetId = $scope.ticket.checksheetId;
	            ticket.firstItemId = $scope.ticket.firstItemId;
	            ticket.secondItemId = $scope.ticket.secondItemId;
	            ticket.thirdItemId = $scope.ticket.thirdItemId;
	            ticket.startScheduledDate = $scope.ticket.startScheduledDate;
	            ticket.endScheduledDate = $scope.ticket.endScheduledDate;
	            ticket.startDate = "";
	            ticket.endDate = "";
	            ticket.requestUserId = $scope.ticket.requestUserId;
	            ticket.responseGroupId = $scope.ticket.responseGroupId;
	            ticket.responseUserId = $scope.ticket.responseUserId;
	            ticket.requestGroupId = $scope.ticket.requestGroupId;

	            ticket.statusDetailId = $scope.ticket.statusDetailId;
	            ticket.kbn2Id = $scope.ticket.kbn2Id;
	            ticket.kbn3Id = $scope.ticket.kbn3Id;
	            ticket.kbn4Id = $scope.ticket.kbn4Id;
	            ticket.kbn5Id = $scope.ticket.kbn5Id;
	            ticket.item1 = $scope.ticket.item1;
	            ticket.item2 = $scope.ticket.item2;
	            ticket.item3 = $scope.ticket.item3;
	            ticket.item4 = $scope.ticket.item4;
	            ticket.item5 = $scope.ticket.item5;

	            var readingGroupIdlist = [];
	            for (var i =0; i< $scope.ticket.readingGrouplist.length; i++) {
	              readingGroupIdlist.push($scope.ticket.readingGrouplist[i].groupId);
	            }
	            ticket.readingGroupIdlist = readingGroupIdlist;

	            ticket.parentId = 0;
	            //ステータス：チェック前("01")
	            ticket.statusId = "01";
	            var url = window.location.href;
	            var newTicketId = ajaxService.createTicket($rootScope.projectId, ticket, "チェックシートがコピーされました。コピー元のチェックシートIDは" + $scope.ticket.id + "です。", url)
	            if (ajaxService.result['resultCd'] != "000000") {
	               $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
	            } else {
	               $rootScope.showInfoMessage("チェックシートがコピー作成されました。");
	               var url = window.location.href;
	               var u = url.split("#")[0];
	               window.open(u + "#/showReportDetail?id=" + newTicketId );

	            }
            });
          };

    }

})();



/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.checkreport').controller('CheckreportListCtrl', CheckreportListCtrl);

    /** @ngInject */
    function CheckreportListCtrl($scope, $filter, editableOptions, editableThemes, toastr, $sce,baProgressModal, $timeout, $interval,
            toastrConfig, ajaxService, $state, $uibModal, $location, $window, themeLayoutSettings, Upload, $http, $rootScope, tr) {

    	if(! window.navigator.onLine){
    		//オフラインの場合、ダウンロードチケットへ遷移
    		window.location.href = "#/offline";
    		return;
    	}

      $scope.smartTablePageSize = 20;
      $scope.ctrl = $scope;
      var theme = themeLayoutSettings;

      var choiceMaxTicketNum = 200;

      $scope.mngFlg = localStorage.mngKbn;

      $scope.opFlg = 1;

      $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);
      $scope.showResult = $scope.mngCommon.showResult;

      $scope.autoReload = $scope.mngCommon.autoReload;
      $scope.reloadTime = $scope.mngCommon.reloadTime;

      $scope.parentTicket = $scope.mngCommon.parentTicketType;
      $scope.progressFlg = $scope.mngCommon.progress;

      $scope.adminMng = $scope.mngCommon.adminMng;

      if (window.localStorage.groupIdList == "") {
    	  $scope.loginGroupIdList = [];
      } else {
          $scope.loginGroupIdList = window.localStorage.groupIdList.split(",");
      }

      $rootScope.isHome = false;
      $rootScope.isProject = false;

      $scope.allChoice = false;
      $scope.ticketChoice = [];

      if (!ajaxService.tokenCheck()) {
          return;
        };

      $scope.showCheckreportList = function() {

        $scope.showCondition = true;
        $scope.showCondition2 = false;

          if (! theme.mobile) {
            $scope.sScheduledDateF = null;
              $scope.sScheduledDateT = null;
              $scope.eScheduledDateF = null;
              $scope.eScheduledDateT = null;
              $scope.sDateF = null;
              $scope.sDateT = null;
              $scope.eDateF = null;
              $scope.eDateT = null;
              var ticketOb = $scope.checkreportList = ajaxService.searchTicketList($rootScope.projectId, $scope.loginGroupIdList);
              $scope.checkreportList = ticketOb.ticketList;
              $scope.opFlg = ticketOb.flg;
              $scope.resetPage();

          } else {
            $scope.sScheduledDateS = null;
            $scope.sScheduledDateE = null;
            $scope.status01 = true;
            $scope.status02 = true;
            $scope.status99 = true;
            $scope.getCheckreportListSp();
          }

          if ($scope.autoReload == '1') {
        	  if ($scope.timer == null) {
        		  var tm = $scope.reloadTime*1000;
            	  $scope.timer = $interval(function() {
            		$scope.showCheckreportList();
            	  }, tm);
        	  }
          }

      };

      $scope.openSearchCon = function() {
        $scope.showCondition2 = true;
      };

      $scope.closeSearchCon = function() {
        $scope.showCondition2 = false;
      };

      $scope.clearCondition = function() {
        $scope.sScheduledDateF = null;
        $scope.sScheduledDateT = null;
        $scope.eScheduledDateF = null;
        $scope.eScheduledDateT = null;
        $scope.sDateF = null;
        $scope.sDateT = null;
        $scope.eDateF = null;
        $scope.eDateT = null;
      }



      $scope.getCheckreportList = function() {
      //工事項目リストを取得
          $scope.itemNameList = ajaxService.getTargetItemList($rootScope.projectId);
          $scope.showFist = false;
          $scope.showSecond = false;
          $scope.showThird = false;
          for (var i=0; i<$scope.itemNameList.length; i++) {
            var field = $scope.itemNameList[i].fieldName;
            if (field == "targetId") {
              $scope.targetIdItemName = $scope.itemNameList[i].showName;
            }
            if (field == "targetName") {
              $scope.targetNameItemName = $scope.itemNameList[i].showName;
            }
            if (field == "first") {
              $scope.showFist = true;
              $scope.targetFirstItemName = $scope.itemNameList[i].showName;
            }
            if (field == "second") {
                $scope.showSecond = true;
                $scope.targetSecondItemName = $scope.itemNameList[i].showName;
              }
            if (field == "third") {
                $scope.showThird = true;
                $scope.targetThirdItemName = $scope.itemNameList[i].showName;
              }
          }

          $scope.itemTicketList = ajaxService.searchItemNameList('3', $rootScope.projectId);
          $scope.showStatusDetail = false;
          $scope.showKbn2 = false;
          $scope.showKbn3 = false;
          $scope.showKbn4 = false;
          $scope.showKbn5 = false;
          $scope.showItem1 = false;
          $scope.showItem2 = false;
          $scope.showItem3 = false;
          $scope.showItem4 = false;
          $scope.showItem5 = false;

 		  $scope.mustStatusDetail = false;
          $scope.mustKbn2 = false;
          $scope.mustKbn3 = false;
          $scope.mustKbn4 = false;
          $scope.mustKbn5 = false;
          $scope.mustItem1 = false;
          $scope.mustItem2 = false;
          $scope.mustItem3 = false;
          $scope.mustItem4 = false;
          $scope.mustItem5 = false;

          for (var i=0; i<$scope.itemTicketList.length; i++) {
            var field = $scope.itemTicketList[i].fieldName;
            if (field == "statusDetail") {
              $scope.statusDetailItemName = $scope.itemTicketList[i].showName;
              if ($scope.itemTicketList[i].isShow != '1') {
                  $scope.showStatusDetail = true;
                  if ($scope.itemTicketList[i].isShow == '3') {
             		 $scope.mustStatusDetail = true;
                  }
              }
            }
            if (field == "kbn2") {
                $scope.kbn2ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showKbn2 = true;
                    if ($scope.itemTicketList[i].isShow == '3') {
               		 $scope.mustKbn2 = true;
                    }
                }
              }
            if (field == "kbn3") {
                $scope.kbn3ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showKbn3 = true;
                    if ($scope.itemTicketList[i].isShow == '3') {
                 		 $scope.mustKbn3 = true;
                      }
                }
              }
            if (field == "kbn4") {
                $scope.kbn4ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showKbn4 = true;
                    if ($scope.itemTicketList[i].isShow == '3') {
                 		 $scope.mustKbn4 = true;
                      }
                }
              }
            if (field == "kbn5") {
                $scope.kbn5ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showKbn5 = true;
                    if ($scope.itemTicketList[i].isShow == '3') {
                 		 $scope.mustKbn5 = true;
                      }
                }
              }
            if (field == "item1") {
                $scope.item1ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showItem1 = true;
                    if ($scope.itemTicketList[i].isShow == '3') {
                 		 $scope.mustItem1 = true;
                      }
                }
              }
            if (field == "item2") {
                $scope.item2ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showItem2 = true;
                    if ($scope.itemTicketList[i].isShow == '3') {
                		 $scope.mustItem2 = true;
                     }
                }
              }
            if (field == "item3") {
                $scope.item3ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showItem3 = true;
                    if ($scope.itemTicketList[i].isShow == '3') {
                		 $scope.mustItem3 = true;
                     }
                }
              }
            if (field == "item4") {
                $scope.item4ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showItem4 = true;
                    if ($scope.itemTicketList[i].isShow == '3') {
                		 $scope.mustItem4 = true;
                     }
                }
              }
            if (field == "item5") {
                $scope.item5ItemName = $scope.itemTicketList[i].showName;
                if ($scope.itemTicketList[i].isShow != '1') {
                    $scope.showItem5 = true;
                    if ($scope.itemTicketList[i].isShow == '3') {
                		 $scope.mustItem5 = true;
                     }
                }
              }
          }

          $scope.csvTitle = [];
          $scope.csvTitle.push("チェックシートID");
          if ($scope.progressFlg == "1") {
              $scope.csvTitle.push("進捗");
          }

          $scope.csvTitle.push($scope.targetIdItemName);
          $scope.csvTitle.push($scope.targetNameItemName);
          $scope.csvTitle.push("ステータス");
          if ($scope.showStatusDetail) {
        	  $scope.csvTitle.push($scope.statusDetailItemName);
          }
          if ($scope.showKbn2) {
        	  $scope.csvTitle.push($scope.kbn2ItemName);
          }
          if ($scope.showKbn3) {
        	  $scope.csvTitle.push($scope.kbn3ItemName);
          }
          if ($scope.showKbn4) {
        	  $scope.csvTitle.push($scope.kbn4ItemName);
          }
          if ($scope.showKbn5) {
        	  $scope.csvTitle.push($scope.kbn5ItemName);
          }
          if ($scope.showItem1) {
        	  $scope.csvTitle.push($scope.item1ItemName);
          }
          if ($scope.showItem2) {
        	  $scope.csvTitle.push($scope.item2ItemName);
          }
          if ($scope.showItem3) {
        	  $scope.csvTitle.push($scope.item3ItemName);
          }
          if ($scope.showItem4) {
        	  $scope.csvTitle.push($scope.item4ItemName);
          }
          if ($scope.showItem5) {
        	  $scope.csvTitle.push($scope.item5ItemName);
          }
          $scope.csvTitle.push("区分");
          $scope.csvTitle.push("大項目");
          $scope.csvTitle.push("中項目");
          $scope.csvTitle.push("小項目");

          if ($scope.showResult != '1') {
        	  $scope.csvTitle.push("異常");
          }

          if ($scope.showFist) {
        	  $scope.csvTitle.push($scope.targetFirstItemName);
          }
          if ($scope.showSecond) {
        	  $scope.csvTitle.push($scope.targetSecondItemName);
          }
          if ($scope.showThird) {
        	  $scope.csvTitle.push($scope.targetThirdItemName);
          }
          $scope.csvTitle.push("開始日(予定)");
          $scope.csvTitle.push("完了日(予定)");
          $scope.csvTitle.push("開始日(実績)");
          $scope.csvTitle.push("完了日(実績)");
          $scope.csvTitle.push("管理技術者ID");
          $scope.csvTitle.push("管理技術者名");
          $scope.csvTitle.push("指示グループ");
          $scope.csvTitle.push("担当技術者ID");
          $scope.csvTitle.push("担当技術者名");
          $scope.csvTitle.push("担当技術者グループ");
          $scope.csvTitle.push("閲覧グループ");

          if ($scope.parentTicket == '1') {
              $scope.csvTitle.push("親チェックシートID");
          }
          $scope.csvTitle.push("操作区分(1:追加 2:変更 3:削除)");


          $scope.csvColumn = [];
          $scope.csvColumn.push("id");
          if ($scope.progressFlg == "1") {
              $scope.csvColumn.push("progress");
          }
          $scope.csvColumn.push("targetIdShow");
          $scope.csvColumn.push("targetName");
          $scope.csvColumn.push("statusName");
          if ($scope.showStatusDetail) {
        	  $scope.csvColumn.push("statusDetail");
          }
          if ($scope.showKbn2) {
        	  $scope.csvColumn.push("kbn2");
          }
          if ($scope.showKbn3) {
        	  $scope.csvColumn.push("kbn3");
          }
          if ($scope.showKbn4) {
        	  $scope.csvColumn.push("kbn4");
          }
          if ($scope.showKbn5) {
        	  $scope.csvColumn.push("kbn5");
          }
          if ($scope.showItem1) {
        	  $scope.csvColumn.push("item1");
          }
          if ($scope.showItem2) {
        	  $scope.csvColumn.push("item2");
          }
          if ($scope.showItem3) {
        	  $scope.csvColumn.push("item3");
          }
          if ($scope.showItem4) {
        	  $scope.csvColumn.push("item4");
          }
          if ($scope.showItem5) {
        	  $scope.csvColumn.push("item5");
          }
          $scope.csvColumn.push("first");
          $scope.csvColumn.push("second");
          $scope.csvColumn.push("third");
          $scope.csvColumn.push("fourth");

          if ($scope.showResult != '1') {
              $scope.csvColumn.push("errNum");
          }

          if ($scope.showFist) {
        	  $scope.csvColumn.push("targetFirstName");
          }
          if ($scope.showSecond) {
        	  $scope.csvColumn.push("targetSecondName");
          }
          if ($scope.showThird) {
        	  $scope.csvColumn.push("targetThirdName");
          }
          $scope.csvColumn.push("startScheduledDate");
          $scope.csvColumn.push("endScheduledDate");
          $scope.csvColumn.push("startDate");
          $scope.csvColumn.push("endDate");
          $scope.csvColumn.push("requestUserId");
          $scope.csvColumn.push("requestUserName");
          $scope.csvColumn.push("requestGroupName");
          $scope.csvColumn.push("responseUserId");
          $scope.csvColumn.push("responseUserName");
          $scope.csvColumn.push("responseGroupName");
          $scope.csvColumn.push("readingGroupName");

          if ($scope.parentTicket == '1') {
              $scope.csvColumn.push("parentId");
          }

          $scope.csvFileName = "チェックシート.csv";


          var u =window.location.hash;
          var par = u.split("=");

          if (par[0].indexOf("checkreport") == -1 || par.length == 1) {
              $scope.showCondition = true;

            if (! theme.mobile) {
            	if ($rootScope.targetIdForTicket) {
            		var ticketOb = ajaxService.searchTicketListByTargetId($rootScope.projectId, $scope.loginGroupIdList, $rootScope.targetIdForTicket);
                    $scope.checkreportList = ticketOb.ticketList;
                    $scope.opFlg = ticketOb.flg;
            	} else {
                    var ticketOb = ajaxService.searchTicketList($rootScope.projectId, $scope.loginGroupIdList);
                    $scope.checkreportList = ticketOb.ticketList;
                    $scope.opFlg = ticketOb.flg;
            	}


            } else {
              $scope.sScheduledDateS = null;
              $scope.sScheduledDateE = null;
              $scope.status01 = true;
              $scope.status02 = true;
              $scope.status99 = true;
              $scope.targetIdCondi = "";
              $scope.targetNameCondi = "";
              $scope.checkSheetCondi = "";
              $scope.responseUserCondi = "";

              $scope.getCheckreportListSp();
            }

            if ($scope.autoReload == '1') {
            	var tm = $scope.reloadTime*1000;
          	  $scope.timer = $interval(function() {
          		$scope.showCheckreportList();
          	  }, tm);
            }
          } else {
            $scope.showCondition = false;
            if (! $scope.userList) {
                $scope.userList = ajaxService.selectUserList($rootScope.projectId);
                $scope.userList.unshift({userName:" ", userId:null});
              }
            for (var i=0; i<$scope.userList.length; i++) {
                if (localStorage.userId == $scope.userList[i].userId) {
                  $scope.loginUser = $scope.userList[i];
                  break;
                }
              }
            var groupIdList = [];
            if (localStorage.mngKbn != '2') {
        	   for (var j=0; j<$scope.loginUser.groupList.length; j++) {
     	         groupIdList.push($scope.loginUser.groupList[j].groupId);
     	       }
            } else {
        	   var groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
        	   for (var j=0; j<groupList.length; j++) {
      	         groupIdList.push(groupList[j].groupId);
      	       }
            }

            var str = u.split("?");
            var params = str[str.length-1];
            var param = params.split("&");
            if (param.length == 1) {
              var kbn = par[1];
              if (kbn) {
                  var ticketOb = ajaxService.getAlertTicketList($rootScope.projectId, groupIdList, kbn);
                  $scope.checkreportList = ticketOb.ticketList;
                  $scope.opFlg = ticketOb.flg;
              }
            } else {
               var statusId = param[1].split("=")[1];
               var sEnd = param[2].split("=")[1].replace("%2F", "/").replace("%2F", "/");
               var eEnd = param[3].split("=")[1].replace("%2F", "/").replace("%2F", "/");
               var first = param[4].split("=")[1];
               var second = param[5].split("=")[1];
               var third = param[6].split("=")[1];
               var resGroupId = param[7].split("=")[1];
               var resUserId = param[8].split("=")[1];

               var ticketOb = ajaxService.getGraphTicketList($rootScope.projectId, groupIdList, sEnd, eEnd, first, second, third, resGroupId, resUserId, statusId);
               $scope.checkreportList = ticketOb.ticketList;
               $scope.opFlg = ticketOb.flg;
            }
          }
      };

      $scope.getListByDate = function() {

    	  if ($scope.timer){
    		  $interval.cancel($scope.timer);
    		  $scope.timer = null;
    	  }

          var sScheduledDateF = $rootScope.formatDate($scope.sScheduledDateF, "YYYY/MM/DD");
          var sScheduledDateT = $rootScope.formatDate($scope.sScheduledDateT, "YYYY/MM/DD");
          var eScheduledDateF = $rootScope.formatDate($scope.eScheduledDateF, "YYYY/MM/DD");
          var eScheduledDateT = $rootScope.formatDate($scope.eScheduledDateT, "YYYY/MM/DD");
          var sDateF = $rootScope.formatDate($scope.sDateF, "YYYY/MM/DD");
          var sDateT = $rootScope.formatDate($scope.sDateT, "YYYY/MM/DD");
          var eDateF = $rootScope.formatDate($scope.eDateF, "YYYY/MM/DD");
          var eDateT = $rootScope.formatDate($scope.eDateT, "YYYY/MM/DD");

          var ticketOb = ajaxService.searchTicketListByDate($rootScope.projectId, sScheduledDateF, sScheduledDateT, eScheduledDateF, eScheduledDateT, sDateF, sDateT, eDateF, eDateT, $scope.loginGroupIdList);
          $scope.checkreportList = ticketOb.ticketList;
          $scope.opFlg = ticketOb.flg;
          $scope.resetPage();
      };

      $scope.getCheckreportListSp = function() {
        var constatusList = [];
        if ($scope.status01) {
          constatusList.push("01");
        }
        if ($scope.status02) {
          constatusList.push("02");
        }
        if ($scope.status03) {
          constatusList.push("03");
        }
        if ($scope.status04) {
          constatusList.push("04");
        }
        if ($scope.status05) {
          constatusList.push("05");
        }
        if ($scope.status99) {
          constatusList.push("99");
        }
        var sScheduledDateS = $rootScope.formatDate($scope.sScheduledDateS, "YYYY/MM/DD");
        var sScheduledDateE = $rootScope.formatDate($scope.sScheduledDateE, "YYYY/MM/DD");

        $scope.checkreportList = ajaxService.searchTicketListSp($rootScope.projectId, sScheduledDateS, sScheduledDateE, constatusList, $scope.targetIdCondi, $scope.targetNameCondi, $scope.checkSheetCondi, $scope.responseUserCondi, $scope.loginGroupIdList);
      };

      $scope.getCheckreportListSp2 = function() {
          var constatusList = [];
          if ($scope.status01) {
            constatusList.push("01");
          }
          if ($scope.status02) {
            constatusList.push("02");
          }
          if ($scope.status03) {
            constatusList.push("03");
          }
          if ($scope.status04) {
            constatusList.push("04");
          }
          if ($scope.status05) {
            constatusList.push("05");
          }
          if ($scope.status99) {
            constatusList.push("99");
          }
          var sScheduledDateS = $rootScope.formatDate($scope.sScheduledDateS, "YYYY/MM/DD");
          var sScheduledDateE = $rootScope.formatDate($scope.sScheduledDateE, "YYYY/MM/DD");

          $scope.checkreportList = ajaxService.searchTicketListSp($rootScope.projectId, sScheduledDateS, sScheduledDateE, constatusList, $scope.targetIdCondi, $scope.targetNameCondi, $scope.checkSheetCondi, $scope.responseUserCondi, $scope.loginGroupIdList);

          if ($scope.timer){
    		  $interval.cancel($scope.timer);
    		  $scope.timer = null;
    	    }

      };

      $scope.clearConditionSp = function () {
    	  $scope.sScheduledDateS = null;
          $scope.sScheduledDateE = null;
          $scope.status03 = false;
          $scope.status04 = false;
          $scope.status05 = false;
          $scope.status01 = false;
          $scope.status02 = false;
          $scope.status99 = false;
          $scope.targetIdCondi = "";
          $scope.targetNameCondi = "";
          $scope.checkSheetCondi = "";
          $scope.responseUserCondi = "";
      };


      $scope.resetPage = function() {
    	  $scope.ticketChoice = [];
    	  $scope.allChoice = false;
      };


      $scope.getCheckreportList();

      $scope.showCheckreportCreate = function() {
        //トークン確認
//        if (!ajaxService.tokenCheck()) {
//            return;
//        };
//        $uibModal.open({
//          animation: true,
//          templateUrl: "app/pages/checkreport/checkreportCreate.html",
//          controller: 'CheckreportCtrl',
//          size :'lg',
//          scope : $scope,
//          resolve: {
//              openFlag: function () {
//                  return {};
//            }
//          }
//        });
        var url = window.location.href;
        var u = url.split("#")[0];
        window.open(u + "#/showReportDetail?id=");

      };


      $scope.showCheckreportDetail = function(id) {
       if(ajaxService.hasTicket(id) == 0) {
         $rootScope.showErrorMessage("該当チェックシートが削除されました。");
         $scope.getCheckreportList();
         return ;
       }
          var url = window.location.href;
          var u = url.split("#")[0];
          window.open(u + "#/showReportDetail?id=" + id );
      };

      $scope.uploadFiles = function(file) {
    	  if (file == null) {
    	      return;
    	  }
          var name = file.name;
          if (name.toLowerCase().indexOf(".csv") == -1) {
            $rootScope.showErrorMessage("csvファイルをアップロードしてください。");
            return;
          }

          var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : "アップロードを実施してもよろしいですか？"
                      };
                  }
              }
          });

          modalInstance.result.then(function() {
        	  if (file) {
        		  baProgressModal.open('app/pages/checkreport/progressModalUpload.html',$scope);
                  Upload.upload({
                      url : urlPrefix + "checkreport/uploadTicket",
                      type : "POST",
                      headers : {
                          "authorization" : localStorage.authId,
                      },
                      dataType : "multipart/form-data",
                      data : {
                          'projectId': $rootScope.projectId, 'url':window.location.href, "loginUserName" : localStorage.userName, "schema" : localStorage.schema, 'loginId':localStorage.userId, file : file
                      }
                  }).progress(function (evt) {
                      //progress
                      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                      if (progressPercentage != 100) {
                        $rootScope.showInfoMessage("アップロード中：" + progressPercentage + "%");
                      }
                  }).then(function(response) {
                      var name = response.config.data.file.name;
                      if (response.data.resultCd == "000000") {
                          $scope.update = response.data.updateCount;
                          $scope.skipUpdate = response.data.skipUpdate;
                          if ($scope.update > 0) {
                            $scope.showCheckreportList();
                          }
                          // errorFile
                          if (response.data.skipUpdate > 0) {
                               // データを用意する
                              var bom = new Uint8Array(
                                      [ 0xEF, 0xBB, 0xBF ]);
                              var content = "行番, エラーメッセージ";
                              content = content + "\n";
                              for (var i=0; i<response.data.skipUpdateInfo.length; i++) {
                                  content = content + response.data.skipUpdateInfo[i] + "\n";
                              }
                              var blob = new Blob([ bom, content ], {
                                  "type" : "text/csv"
                              });

                              // 出力
                              if ($window.navigator.msSaveBlob) {
                                  $window.navigator.msSaveBlob(blob, "アップロード結果.csv");
                              } else {
                                  var downloadLink = $('<a></a>');
                                  downloadLink.attr('href', $window.URL.createObjectURL(blob));
                                  downloadLink.attr('download', "アップロード結果.csv");
                                  downloadLink.attr('target', '_blank');
                                  $('body').append(downloadLink);
                                  downloadLink[0].click();
                                  downloadLink.remove();
                              }
                              $rootScope.showErrorMessage("エラーにより一部のデータが取り込まれていません。詳しくは出力した「アップロード結果.csv」ファイルを参照してください。");
                          } else {
                              $rootScope.showInfoMessage("アップロードが完了しました。");
                          }
                          baProgressModal.close();
                      } else {
                        $rootScope.showErrorMessage(tr.T(response.data.resultCd));
                        baProgressModal.close();
                      }
                  }, function(response) {
                      if (response.status > 0)
                      $rootScope.showErrorMessage(response.status + ': ' + response.data);
                      baProgressModal.close();
                  }, function(evt) {
                  });
              }
          });
      };


//      $scope.changeAllChoice = function() {
//		  $scope.ticketChoice = [];
//    	  if ($scope.allChoice == true) {
//    		  for (var i=0;i<$scope.checkreportList.length;i++) {
//    			  $scope.ticketChoice[$scope.checkreportList[i].id] = true;
//    		  }
//    	  }
//      };


      $scope.downloadTicketCsv = function() {
    	  var ticketIdList = [];
    	  for (var i=0; i<$scope.ticketChoice.length; i++){
    		  if ($scope.ticketChoice[i]) {
    			  ticketIdList.push(i);
    		  }
    	  }
    	  if (ticketIdList.length==0) {
    		  $rootScope.showErrorMessage("チェックシートを選択してください。");
    		  return;
    	  }

    	  var content = new Array();
          for (var i = 0; i < $scope.csvTitle.length; i++) {
              content.push($scope.csvTitle[i]);
              content.push(",");
          }
          content.pop();
          content.push("\n");

          for (var i = 0; i < $scope.checkreportList.length; i++) {
        	  var isCsvTicket = false;
        	  for (var k=0;k<ticketIdList.length;k++) {
        		  if ($scope.checkreportList[i].id == ticketIdList[k]) {
        			  isCsvTicket = true;
        			  break;
        		  }
        	  }
        	  if (isCsvTicket) {
        		  for (var j = 0; j < $scope.csvTitle.length; j++) {
        			  if ($scope.csvColumn[j] == 'progress') {
                          content.push($scope.checkreportList[i][$scope.csvColumn[j]] + '%');
        			  } else {
                          content.push($scope.checkreportList[i][$scope.csvColumn[j]]);
        			  }
                      content.push(",");
                  }
        		  content.pop();
                  content.push("\n");
        	  }
          }

          var contentStr = content.join('');
          var str_array = Encoding.stringToCode(contentStr);
          var sjis_array = Encoding.convert(str_array, "SJIS", "UNICODE");
          var uint8_array = new Uint8Array(sjis_array);

          var blob = new Blob([uint8_array], {
              "type" : "text/csv"
          });
          var fileName = $scope.csvFileName;
          // 出力
          if ($window.navigator.msSaveBlob) {
              // if browser is IE
              $window.navigator.msSaveBlob(blob,
                      fileName);
          } else {
              var downloadLink = $('<a></a>');
              downloadLink.attr('href', $window.URL.createObjectURL(blob));
              downloadLink.attr('download', fileName);
              downloadLink.attr('target', '_blank');
              $('body').append(downloadLink);
              downloadLink[0].click();
              downloadLink.remove();
          }
      };

      $scope.deleteTicketList = function() {
    	  var ticketIdList = [];
    	  var unDelIdList = [];
    	  for (var i=0; i<$scope.ticketChoice.length; i++){
    		  if ($scope.ticketChoice[i]) {

    			  for (var j=0; j<$scope.checkreportList.length; j++) {
    				  if (i == $scope.checkreportList[j].id) {
    					  if ($scope.checkreportList[j].flg == 0) {
    						  //削除権限ないチェックシート
    						  unDelIdList.push(i);
    					  } else {
    						  ticketIdList.push(i);
    					  }
    				  }
    			  }
    		  }
    	  }
    	  if (ticketIdList.length==0 && unDelIdList.length == 0) {
    		  $rootScope.showErrorMessage("チェックシートを選択してください。");
    		  return;
    	  }
    	  var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : "選択された"+(ticketIdList.length + unDelIdList.length)+"件のチェックシートを削除してもよろしいですか？"
                      };
                  }
              }
          });
          modalInstance.result.then(function() {

        	  ajaxService.deleteTicketList(ticketIdList, $rootScope.projectId);
        	  if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                } else {
                  if (unDelIdList.length == 0) {
                      $rootScope.showInfoMessage("チェックシートを削除しました。");
                  } else {
                	  var bom = new Uint8Array(
                              [ 0xEF, 0xBB, 0xBF ]);
                      var content = "チェックシートID, エラーメッセージ";
                      content = content + "\n";
                      for (var i=0; i<unDelIdList.length; i++) {
                          content = content + $rootScope.padLeft(unDelIdList[i], 8) + ",該当チェックシートを削除する権限がありません。\n";
                      }
                      var blob = new Blob([ bom, content ], {
                          "type" : "text/csv"
                      });

                      // 出力
                      if ($window.navigator.msSaveBlob) {
                          $window.navigator.msSaveBlob(blob, "削除結果.csv");
                      } else {
                          var downloadLink = $('<a></a>');
                          downloadLink.attr('href', $window.URL.createObjectURL(blob));
                          downloadLink.attr('download', "削除結果.csv");
                          downloadLink.attr('target', '_blank');
                          $('body').append(downloadLink);
                          downloadLink[0].click();
                          downloadLink.remove();
                      }
                      $rootScope.showErrorMessage("エラーにより一部のチェックシートが削除されていません。詳しくは出力した「削除結果.csv」ファイルを参照してください。");
                  }
                  $scope.showCheckreportList();
                }
        	  $scope.ticketChoice = [];
        	  $scope.allChoice = false;
          });
      };


      $scope.ticketListZipDownload = function() {
    	  var length = $scope.ticketIdZipList.length;

    	  if (baProgressModal.getProgress() >= 100) {
    		  $scope.zipTicketList.generateAsync({type:"blob", encodeFileName:function(string){
    			  var str_array = Encoding.stringToCode(string);
                  var sjis_array = Encoding.convert(str_array, "SJIS", "UNICODE");
                  var uint8_array = new Uint8Array(sjis_array);
                  return uint8_array;
    		  }  }).then(function(content) {
    		        saveAs(content, "報告書.zip");
    		    });
              baProgressModal.close();
          } else {

        	  var ticketId = $scope.ticketIdZipList[0];

    		  $http({

                  url: urlPrefix + "checkreport/downloadTicket/",
	        	  method: "POST",
	              data: JSON.stringify(
	                      {"ticketId":ticketId,
	                          "schema" : localStorage.schema,
	                          "projectId" : $rootScope.projectId,
	                          "emptyFlg" : '0'
	                          }), //this is your json data string
	              headers: {
	                 'Content-type': 'application/json'
	              },
	              responseType: 'arraybuffer'

              }).success(function (data, status, headers, config) {
            	  var checksheetName = decodeURI(headers()["checksheetname"]);
            	  var targetName = decodeURI(headers()["targetname"]);
            	  var blob = new Blob([data], { type: "application/vnd.ms-excel" });

            	  var fileName = "チェック報告書(" + targetName + "_" + checksheetName +")_" +$rootScope.padLeft(ticketId, 8)+".xls";

            	  var currDate = new Date()
            	  var dateWithOffset = new Date(currDate.getTime() - currDate.getTimezoneOffset() * 60000);

        		  $scope.zipTicketList.file(fileName, blob, { date:dateWithOffset });
            	  $scope.ticketIdZipList.shift();
            	  baProgressModal.setProgress(parseInt((1-$scope.ticketIdZipList.length/$scope.ticketIdZipListAllNum) * 100));
            	  $timeout($scope.ticketListZipDownload, 1);

              }).error(function (data, status, headers, config) {
            	  $rootScope.showErrorMessage("システムエラーが発生しました。システム管理者にご連絡ください。");
            	  baProgressModal.close();
              });

          }

      };

      $scope.ticketListZip = function() {
    	  $scope.zipTicketList = new JSZip();
    	  $scope.ticketIdZipList = [];
    	  $scope.ticketIdZipListAllNum = 0;
    	  for (var i=0; i<$scope.ticketChoice.length; i++){
    		  if ($scope.ticketChoice[i]) {
    			  $scope.ticketIdZipList.push(i);
    			  $scope.ticketIdZipListAllNum = $scope.ticketIdZipListAllNum + 1;
    		  }
    	  }
    	  if ($scope.ticketIdZipList.length==0) {
    		  $rootScope.showErrorMessage("チェックシートを選択してください。");
    		  return;
    	  } else if ($scope.ticketIdZipList.length > choiceMaxTicketNum) {
    		  $rootScope.showErrorMessage("一回出力する報告書数は"+choiceMaxTicketNum+"件までです。");
    		  return;
    	  }

    	  //3.2.3
    	  baProgressModal.open('app/pages/checkreport/progressModalDownload.html',$scope);

          baProgressModal.setProgress(0);
          $scope.ticketListZipDownload();



/** 3.2.2
    	  baProgressModal.open('app/pages/checkreport/progressModal.html',$scope);
    	  $http({
              url: urlPrefix + "checkreport/downloadTicketListZip/",
              method: "POST",
              data: JSON.stringify(
                      {"ticketIdList":ticketIdList,
                          "schema" : localStorage.schema,
                          "projectId" : $rootScope.projectId,
                          "loginId" : localStorage.userId
                          }), //this is your json data string
              headers: {
                 'Content-type': 'application/json'
              },
              responseType: 'arraybuffer'
          }).success(function (data, status, headers, config) {
              var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
              var fileName = "報告書.zip";

              if ($window.navigator.msSaveBlob) {
                  $window.navigator.msSaveBlob(blob, fileName);
              } else {
                  var downloadLink = $('<a></a>');
                  downloadLink.attr('href', $window.URL.createObjectURL(blob));
                  downloadLink.attr('download', fileName);
                  downloadLink.attr('target', '_blank');
                  $('body').append(downloadLink);
                  downloadLink[0].click();
                  downloadLink.remove();
              }
              baProgressModal.close();
          }).error(function (data, status, headers, config) {
              baProgressModal.close();
              $rootScope.showErrorMessage("システムエラー発生しました。");
          });

    	  //臨時ファイルを削除
    	  $http({
              url: urlPrefix + "checkreport/deleteTicketZipTemp/",
              method: "POST",
              data: JSON.stringify(
                      {
                          "loginId" : localStorage.userId
                          }), //this is your json data string
              headers: {
                 'Content-type': 'application/json'
              },
              responseType: 'arraybuffer'
          }).success(function (data, status, headers, config) {

          }).error(function (data, status, headers, config) {
        	  $rootScope.showErrorMessage("システムエラー発生しました。");
          });

**/
      };


      $scope.ticketContentListZipDownload = function() {
    	  var length = $scope.ticketIdContentZipList.length;

    	  if (baProgressModal.getProgress() >= 100) {
    		  $scope.zipTicketContentList.generateAsync({type:"blob", encodeFileName:function(string){
    			  var str_array = Encoding.stringToCode(string);
                  var sjis_array = Encoding.convert(str_array, "SJIS", "UNICODE");
                  var uint8_array = new Uint8Array(sjis_array);
                  return uint8_array;
    		  }}).then(function(content) {
    		        saveAs(content, "写真.zip");
    		    });
              baProgressModal.close();
          } else {

        	  var ticketId = $scope.ticketIdContentZipList[0];

        	  $http({
                  url: urlPrefix + "checkreport/downloadContent/",
                  method: "POST",
                  data: JSON.stringify(
                          {"ticketId":ticketId,
                              "schema" : localStorage.schema,
	                          "projectId" : $rootScope.projectId,
                              "loginId" : localStorage.userId
                              }), //this is your json data string
                  headers: {
                     'Content-type': 'application/json'
                  },
                  responseType: 'arraybuffer'
              }).success(function (data, status, headers, config) {
            	  if (status == 202) {
            		  var fileName = $rootScope.padLeft(ticketId, 8)+"コンテンツがありません.txt";
            		  $scope.zipTicketContentList.file(fileName, "");
            	  } else {
            		  var blob = new Blob([data], { type: "application/vnd.ms-excel" });
                	  var fileName = $rootScope.padLeft(ticketId, 8)+"コンテンツ.zip";
            		  $scope.zipTicketContentList.file(fileName, blob);
                  }
            	  $scope.ticketIdContentZipList.shift();
            	  baProgressModal.setProgress(parseInt((1-$scope.ticketIdContentZipList.length/$scope.ticketIdContentZipListAllNum) * 100));
            	  $timeout($scope.ticketContentListZipDownload, 1);

              }).error(function (data, status, headers, config) {
            	  $rootScope.showErrorMessage("システムエラーが発生しました。システム管理者にご連絡ください。");
                  baProgressModal.close();
              });
          }
      };


      $scope.ticketContentListZip = function() {

    	  $scope.zipTicketContentList = new JSZip();

    	  $scope.ticketIdContentZipList = [];
    	  $scope.ticketIdContentZipListAllNum = 0;
    	  for (var i=0; i<$scope.ticketChoice.length; i++){
    		  if ($scope.ticketChoice[i]) {
    			  $scope.ticketIdContentZipList.push(i);
    			  $scope.ticketIdContentZipListAllNum = $scope.ticketIdContentZipListAllNum + 1;
    		  }
    	  }
    	  if ($scope.ticketIdContentZipList.length==0) {
    		  $rootScope.showErrorMessage("チェックシートを選択してください。");
    		  return;
    	  } else if ($scope.ticketIdContentZipList.length > choiceMaxTicketNum) {
    		  $rootScope.showErrorMessage("一回出力するチェックシート数は"+choiceMaxTicketNum+"件までです。");
    		  return;
    	  }

    	  //3.2.3
    	  baProgressModal.open('app/pages/checkreport/progressModalDownload.html',$scope);

          baProgressModal.setProgress(0);
          $scope.ticketContentListZipDownload();



    	  /** 3.2.2
    	  baProgressModal.open('app/pages/checkreport/progressModal.html',$scope);
    	  $http({
              url: urlPrefix + "checkreport/downloadTicketContentListZip/",
              method: "POST",
              data: JSON.stringify(
                      {"ticketIdList":ticketIdList,
                          "schema" : localStorage.schema,
                          "projectId" : $rootScope.projectId,
                          "loginId" : localStorage.userId
                          }), //this is your json data string
              headers: {
                 'Content-type': 'application/json'
              },
              responseType: 'arraybuffer'
          }).success(function (data, status, headers, config) {
              var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
              var fileName = "写真.zip";

              if ($window.navigator.msSaveBlob) {
                  $window.navigator.msSaveBlob(blob, fileName);
              } else {
                  var downloadLink = $('<a></a>');
                  downloadLink.attr('href', $window.URL.createObjectURL(blob));
                  downloadLink.attr('download', fileName);
                  downloadLink.attr('target', '_blank');
                  $('body').append(downloadLink);
                  downloadLink[0].click();
                  downloadLink.remove();
              }
              baProgressModal.close();
          }).error(function (data, status, headers, config) {
              baProgressModal.close();
              $rootScope.showErrorMessage("システムエラー発生しました。");
          });

    	  //臨時ファイルを削除
    	  $http({
              url: urlPrefix + "checkreport/deleteTicketZipTemp/",
              method: "POST",
              data: JSON.stringify(
                      {
                          "loginId" : localStorage.userId
                          }), //this is your json data string
              headers: {
                 'Content-type': 'application/json'
              },
              responseType: 'arraybuffer'
          }).success(function (data, status, headers, config) {

          }).error(function (data, status, headers, config) {
        	  $rootScope.showErrorMessage("システムエラー発生しました。");
          });
**/
      };


      $scope.downloadCheckResultCsv = function() {
    	  var ticketIdList = [];
    	  for (var i=0; i<$scope.ticketChoice.length; i++){
    		  if ($scope.ticketChoice[i]) {
    			  ticketIdList.push(i);
    		  }
    	  }
    	  if (ticketIdList.length==0) {
    		  $rootScope.showErrorMessage("チェックシートを選択してください。");
    		  return;
    	  }

    	  baProgressModal.open('app/pages/checkreport/progressModal.html',$scope);
    	  $http({
              url: urlPrefix + "checkreport/downloadCheckResultCsv/",
              method: "POST",
              data: JSON.stringify(
                      {"ticketIdList":ticketIdList,
                          "schema" : localStorage.schema,
                          "projectId" : $rootScope.projectId,
                          "loginId" : localStorage.userId
                          }), //this is your json data string
              headers: {
                 'Content-type': 'application/json'
              },
              responseType: 'arraybuffer'
          }).success(function (data, status, headers, config) {
              var blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
              var fileName = "作業結果.csv";

              if ($window.navigator.msSaveBlob) {
                  $window.navigator.msSaveBlob(blob, fileName);
              } else {
                  var downloadLink = $('<a></a>');
                  downloadLink.attr('href', $window.URL.createObjectURL(blob));
                  downloadLink.attr('download', fileName);
                  downloadLink.attr('target', '_blank');
                  $('body').append(downloadLink);
                  downloadLink[0].click();
                  downloadLink.remove();
              }

              baProgressModal.close();
          }).error(function (data, status, headers, config) {
              baProgressModal.close();
              if (status == 400) {
                  $rootScope.showErrorMessage("同じ作業のチェックシートを選択してください。");
              } else {
                  $rootScope.showErrorMessage("システムエラー発生しました。");
              }
          });

      };









        //############################## SP ##############################
  if (theme.mobile) {

      $scope.lat = null;
      $scope.lgt = null;
      if(!navigator.geolocation){ alert('位置情報を共有してください。'); return; }
      navigator.geolocation.getCurrentPosition(
      function(position){
        $scope.lat = position.coords.latitude;
        $scope.lgt = position.coords.longitude;
        } ,
        function(){
          //alert('位置情報取得失敗！');
        }
      );

//      $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);

      $scope.showCheckreportDetailSpWindow = function(ticket) {
        if(ajaxService.hasTicket(ticket.id) == 0) {
           $rootScope.showErrorMessage("該当チェックシートが削除されました。");
           $scope.getCheckreportListSp();
           return ;
         }


          var isEditer = false;
          var isVisitor = false;
          for (var j=1; j<$scope.loginUser.groupList.length; j++) {
            if ($scope.loginUser.groupList[j].groupId == ticket.responseGroupId) {
              isEditer = true;
              break;
            }
            if ($scope.loginUser.groupList[j].groupId == ticket.requestGroupId) {
                isEditer = true;
                break;
              }
          }

          if (! ticket.responseGroupId && ! ticket.responseUserId) {
            isEditer = true;
          }

          if (localStorage.userId == ticket.responseUserId) {
            isEditer = true;
          }

          if (localStorage.userId == ticket.requestUserId) {
            isEditer = true;
          }

          if (localStorage.mngKbn == '2') {
              $scope.isEditer = true;
          }

          if (! isEditer) {
            outer2 : for (var i=0; i<ticket.readingGrouplist.length; i++) {
                  for (var j=1; j<$scope.loginUser.groupList.length; j++) {
                    if ($scope.loginUser.groupList[j].groupId == ticket.readingGrouplist[i].groupId) {
                      isVisitor = true;
                      break outer2;
                    }
                  }
              }
          }

          if (isVisitor) {
        	  var url = window.location.href;
              var u = url.split("#")[0];
              window.open(u + "#/showReportDetailSp?id=" + ticket.id );
              return;
          }


        var isInPosition = false;
        if ($scope.mngCommon) {
          if ($scope.mngCommon.sysNaviFlg == '1') {

            if (! $scope.lat) {
              isInPosition = true;
            }

            if (! ticket.latitude || !ticket.longitude) {
              isInPosition = true;
            }

            if (! isInPosition) {
              var diffDis = $rootScope.getGreatCircleDistance(ticket.latitude, ticket.longitude, $scope.lat, $scope.lgt);
              if (diffDis <= $scope.mngCommon.distance*1000) {
                isInPosition = true;
              }
            }

            if (! isInPosition) {
              var modalInstance = $uibModal.open({
                        animation : true,
                        templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                        controller : 'confirmDialogCtrl',
                        scope : $scope,
                        backdrop : "static",
                        resolve : {
                            message : function() {
                                return {
                                    message : "現在地が選択したチェックシートの対象工事から離れています！作業を続けますか？"
                                };
                            }
                        }
                    });
                  modalInstance.result.then(function() {
                    var url = window.location.href;
                      var u = url.split("#")[0];
                      window.open(u + "#/showReportDetailSp?id=" + ticket.id );
                  });
            }
          } else {
            isInPosition = true;
          }
        } else {
          isInPosition = true;
        }

        if (isInPosition) {
           var url = window.location.href;
             var u = url.split("#")[0];
             window.open(u + "#/showReportDetailSp?id=" + ticket.id );
        }
      };

      $scope.firstItemList = ajaxService.getProjectResourceList($rootScope.projectId, '1');
      $scope.secondItemList = ajaxService.getProjectResourceList($rootScope.projectId, '2');
      $scope.thirdItemList = ajaxService.getProjectResourceList($rootScope.projectId, '3');

      $scope.getFirstItemOb = function (value) {
        for (var i = 0; i < $scope.firstItemList.length; i++) {
          if (value == $scope.firstItemList[i].id) {
            return $scope.firstItemList[i];
          }
        }
      };
      $scope.getSecondItemOb = function (value) {
        for (var i = 0; i < $scope.secondItemList.length; i++) {
          if (value == $scope.secondItemList[i].id) {
            return $scope.secondItemList[i];
          }
        }
      };
      $scope.getThirdItemOb = function (value) {
        for (var i = 0; i < $scope.thirdItemList.length; i++) {
          if (value == $scope.thirdItemList[i].id) {
            return $scope.thirdItemList[i];
          }
        }
      };

      $scope.userList = ajaxService.selectUserList($rootScope.projectId);
      $scope.userList.unshift({userName:" ", userId:null});
      for (var i=0; i<$scope.userList.length; i++) {
          if (localStorage.userId == $scope.userList[i].userId) {
            $scope.loginUser = $scope.userList[i];
          }
        }

      if ($scope.adminMng != '1') {

	        $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);

//    	  if (localStorage.mngKbn != '0') {
//	        $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
//	      } else {
//	        $scope.groupList = angular.copy($scope.loginUser.groupList);
//            //指示者、作業者は自分所属しているグループ内のユーザのみが見れる。
//            if ($scope.groupList.length == 0) {
//          	  $scope.userList = [];
//          	  $scope.userList.push($scope.loginUser);
//            } else {
//          	  var groupIdList = [];
//          	  for (var i = 0; i < $scope.groupList.length; i++) {
//          		  groupIdList.push($scope.groupList[i].groupId);
//          	  }
//                $scope.userList = ajaxService.getListByGroupIdList(groupIdList);
//            }
//            $scope.userList.unshift({userName:" ", userId:''});
//	      }
      } else {
    	  if (localStorage.mngKbn == '2') {
              $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
            } else {
              $scope.groupList = angular.copy($scope.loginUser.groupList);
              //指示者、作業者は自分所属しているグループ内のユーザのみが見れる。
              if ($scope.groupList.length == 0) {
            	  $scope.userList = [];
            	  $scope.userList.push($scope.loginUser);
              } else {
            	  var groupIdList = [];
            	  for (var i = 0; i < $scope.groupList.length; i++) {
            		  groupIdList.push($scope.groupList[i].groupId);
            	  }
                  $scope.userList = ajaxService.getListByGroupIdList(groupIdList);
              }
              $scope.userList.unshift({userName:" ", userId:''});
            }
      }

      $scope.groupList.unshift({groupName:" ", groupId:null});


      $scope.getGroupOb = function (value) {
          for (var i = 0; i < $scope.groupList.length; i++) {
            if (value == $scope.groupList[i].groupId) {
              return $scope.groupList[i];
            }
          }
        };


      $scope.getTargetList = function () {
        $scope.targetList = ajaxService.searchTargetIdNameList($rootScope.projectId);
      };

      $scope.showCheckreportCreateSp = function(parentId) {
        if (parentId) {
          $scope.parentId = parentId;
        }

        $scope.firstItem = new Object();
        $scope.secondItem = new Object();
        $scope.thirdItem = new Object();

//        $scope.userList = ajaxService.searchUserList($rootScope.projectId, "1");
        if (! $scope.userList) {
          $scope.userList = ajaxService.selectUserList($rootScope.projectId);
          $scope.userList.unshift({userName:" ", userId:null});
        }

        for (var i=0; i<$scope.userList.length; i++) {
          if (localStorage.userId == $scope.userList[i].userId) {
            $scope.requestUser = $scope.userList[i];
          }
        }

        $scope.startScheduledDate = null;
        $scope.endScheduledDate = null;

        $scope.responseUser = new Object();

        $scope.responseGroup = new Object();
        $scope.requestGroup = new Object();

        $scope.responseGroups = {selected:[]};

        $scope.defaultGroupList = ajaxService.selectDefaultGroupList($rootScope.projectId);
        $scope.readingGroups = {selected:$scope.defaultGroupList};

        $scope.firstList = ajaxService.getProjectResourceList($rootScope.projectId, '91', 0);
 	      $scope.firstList.unshift({label:" ", id:null})
 	      $scope.secondList = [{label:"マスタデータがありません", id:null}];
 	      $scope.thirdList = [{label:"マスタデータがありません", id:null}];
 	      $scope.fourthList = [{label:"マスタデータがありません", id:null}];

 	      $scope.first = $scope.firstList[0];
 	      $scope.second = $scope.secondList[0];
 	      $scope.third = $scope.thirdList[0];
 	      $scope.fourth = $scope.fourthList[0];

 	      $scope.firstDisable = false;
 	      $scope.secondDisable = true;
 	      $scope.thirdDisable = true;
 	      $scope.fourthDisable = true;

 	      $scope.changeFirst = function () {
 	      	$scope.secondList = ajaxService.getProjectResourceList($rootScope.projectId, '92', $scope.first.id);
 	          if ($scope.secondList.length == 0) {
 	            $scope.secondList.push({label:"マスタデータがありません", id:0});
 	              $scope.secondDisable = true;
 	          } else {
 	              $scope.secondDisable = false;
 	          }
 	          $scope.second = $scope.secondList[0];
 	          $scope.changeSecond();
 	      };

 	      $scope.changeSecond = function () {
 	          $scope.thirdList = ajaxService.getProjectResourceList($rootScope.projectId, '93', $scope.second.id);
 		        if ($scope.thirdList.length == 0) {
 		          $scope.thirdList.push({label:"マスタデータがありません", id:0});
 		            $scope.thirdDisable = true;
 		        } else {
 		            $scope.thirdDisable = false;
 		        }
 		        $scope.third = $scope.thirdList[0];
 		        $scope.changeThird();
 	      };

 	      $scope.changeThird = function () {
 	          $scope.fourthList = ajaxService.getProjectResourceList($rootScope.projectId, '94', $scope.third.id);
 		        if ($scope.fourthList.length == 0) {
 		          $scope.fourthList.push({label:"マスタデータがありません", id:0});
 		            $scope.fourthDisable = true;
 		        } else {
 		            $scope.fourthDisable = false;
 		        }
 		        $scope.fourth = $scope.fourthList[0];
 	      };


        $scope.getTargetList();

        $scope.statusDetailOb = new Object();
        if ($scope.showStatusDetail) {
			 $scope.statusDetailList = ajaxService.getProjectResourceList($rootScope.projectId, '4', 0);
			 $scope.statusDetailList.unshift({label:" ", id:null});
        }
        $scope.kbn2Ob = new Object();
        if ($scope.showKbn2) {
			 $scope.kbn2List = ajaxService.getProjectResourceList($rootScope.projectId, '5', 0);
			 $scope.kbn2List.unshift({label:" ", id:null});
        }
        $scope.kbn3Ob = new Object();
        if ($scope.showKbn3) {
			 $scope.kbn3List = ajaxService.getProjectResourceList($rootScope.projectId, '6', 0);
			 $scope.kbn3List.unshift({label:" ", id:null});
        }
        $scope.kbn4Ob = new Object();
        if ($scope.showKbn4) {
			 $scope.kbn4List = ajaxService.getProjectResourceList($rootScope.projectId, '7', 0);
			 $scope.kbn4List.unshift({label:" ", id:null});
        }
        $scope.kbn5Ob = new Object();
        if ($scope.showKbn5) {
			 $scope.kbn5List = ajaxService.getProjectResourceList($rootScope.projectId, '8', 0);
			 $scope.kbn5List.unshift({label:" ", id:null});
        }

        $scope.item1 = "";
        $scope.item2 = "";
        $scope.item3 = "";
        $scope.item4 = "";
        $scope.item5 = "";


        $scope.target = {};
        $("#checkreportDetailSp").css({
          'display' : 'none'
        });
        $("#checkreportCreaterSp").css({
            'display' : 'block'
        });
        $("body,html").animate({
            scrollTop : $("#checkreportCreaterSp").offset().top - 100
        }, 1000);
      };

      $scope.closeCreateTicketSp = function() {
        $("#checkreportDetailSp").css({
              'display' : 'none'
            });
            $("#checkreportCreaterSp").css({
                'display' : 'none'
            });
            $("body,html").animate({
                scrollTop : $("#checkreportList").offset().top - 100
            }, 1000);
      };

      $scope.showCreateTarget = function() {
        //工事項目リストを取得
        $scope.itemNameList = ajaxService.getTargetItemList($rootScope.projectId);
//        $scope.targetItemList = new Array();
//        for (var i=0; i<$scope.itemNameList.length; i++) {
//          if (i % 2 == 0) {
//            var obj = {"left":null, "right": null};
//              obj["left"] = $scope.itemNameList[i];
//              if (i == $scope.itemNameList.length - 1) {
//                $scope.targetItemList.push(obj);
//              }
//          } else {
//            obj["right"] = $scope.itemNameList[i];
//            $scope.targetItemList.push(obj);
//          }
//        }
          var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checkreport/sp/newCheckTargetSp.html',
              controller : 'ChecktargetCtrl',
              scope : $scope,
              size: 'lg',
              backdrop : "static",
              resolve : {
                message : function() {
                    return {
                          type : "ticket"
                      };
                  }
              }
          });

          modalInstance.result.then(function() {
            $scope.getTargetList();
            $scope.target = $scope.targetList[$scope.targetList.length-1];
          });
      };

      $scope.createTicketSp = function() {

        if (!$scope.fourth.id || $scope.fourth.id == 0 ) {
            $rootScope.showErrorMessage("小項目までを選択してください。");
            return true;
      	 }

        $scope.checklistList = ajaxService.searchChecksheetList($rootScope.projectId, "0");
        console.log($scope.checklistList);

        var checksheetId = "0";

        for (var i = 0; i < $scope.checklistList.length; i ++) {
       	 if ($scope.fourth.id == $scope.checklistList[i].fourthId) {
       		 checksheetId = $scope.checklistList[i].checksheetId;
       		 break;
       	 }
        }

        if (checksheetId == "0") {
            $rootScope.showErrorMessage("選択された小項目に関連する作業が存在しません。");
            return true;
        }

        if (! $scope.target.id) {
          $rootScope.showErrorMessage("対象工事を選択してください。");
          return true;
        }

        if ((!$scope.requestUser.userId || $scope.requestUser.userId == "") && (!$scope.requestGroup.groupId || $scope.requestGroup.groupId == "")) {
            $rootScope.showErrorMessage("管理技術者または指示グループを選択してください。");
            return true;
        }

        if ($scope.mustStatusDetail && $scope.statusDetailOb.id == null) {
       	 $rootScope.showErrorMessage($scope.statusDetailItemName + "を選択してください。");
            return true;
        }
        if ($scope.mustKbn2 && $scope.kbn2Ob.id == null) {
       	 $rootScope.showErrorMessage($scope.kbn2ItemName + "を選択してください。");
            return true;
        }
        if ($scope.mustKbn3 && $scope.kbn3Ob.id == null) {
       	 $rootScope.showErrorMessage($scope.kbn3ItemName + "を選択してください。");
            return true;
        }
        if ($scope.mustKbn4 && $scope.kbn4Ob.id == null) {
       	 $rootScope.showErrorMessage($scope.kbn4ItemName + "を選択してください。");
            return true;
        }
        if ($scope.mustKbn5 && $scope.kbn5Ob.id == null) {
       	 $rootScope.showErrorMessage($scope.kbn5ItemName + "を選択してください。");
            return true;
        }
        if ($scope.mustItem1 && ! $scope.item1) {
       	 $rootScope.showErrorMessage($scope.item1ItemName + "を入力してください。");
            return true;
        }
        if ($scope.mustItem2 && ! $scope.item2) {
       	 $rootScope.showErrorMessage($scope.item2ItemName + "を入力してください。");
            return true;
        }
        if ($scope.mustItem3 && ! $scope.item3) {
       	 $rootScope.showErrorMessage($scope.item3ItemName + "を入力してください。");
            return true;
        }
        if ($scope.mustItem4 && ! $scope.item4) {
       	 $rootScope.showErrorMessage($scope.item4ItemName + "を入力してください。");
            return true;
        }
        if ($scope.mustItem5 && ! $scope.item5) {
       	 $rootScope.showErrorMessage($scope.item5ItemName + "を入力してください。");
            return true;
        }

        var responseGroupIdlist = [];
        for (var i =0; i< $scope.responseGroups.selected.length; i++) {
          responseGroupIdlist.push($scope.responseGroups.selected[i].groupId);
        }
        var readingGroupIdlist = [];
        for (var i =0; i< $scope.readingGroups.selected.length; i++) {
        	if ($rootScope.listContains(readingGroupIdlist, $scope.readingGroups.selected[i].groupId) || $scope.readingGroups.selected[i].groupId == null){
          		 continue;
          	 }
          readingGroupIdlist.push($scope.readingGroups.selected[i].groupId);
        }

        var ticket = new Object();
        ticket.targetId = $scope.target.id;
        ticket.checksheetId = checksheetId;
        ticket.firstItemId = $scope.firstItem.id;
        ticket.secondItemId = $scope.secondItem.id;
        ticket.thirdItemId = $scope.thirdItem.id;
        ticket.startScheduledDate = $rootScope.formatDate($scope.startScheduledDate, "YYYY/MM/DD");
        ticket.endScheduledDate = $rootScope.formatDate($scope.endScheduledDate, "YYYY/MM/DD");
        ticket.startDate = $rootScope.formatDate($scope.startDate, "YYYY/MM/DD");
        ticket.endDate = $rootScope.formatDate($scope.endDate, "YYYY/MM/DD");
        ticket.requestUserId = $scope.requestUser.userId;
        ticket.responseGroupId = $scope.responseGroup.groupId;
        ticket.responseUserId = $scope.responseUser.userId;
        ticket.requestGroupId = $scope.requestGroup.groupId;
        ticket.responseGroupIdlist = responseGroupIdlist;
        ticket.readingGroupIdlist = readingGroupIdlist;
        ticket.statusDetailId = $scope.statusDetailOb.id;
        ticket.kbn2Id = $scope.kbn2Ob.id;
        ticket.kbn3Id = $scope.kbn3Ob.id;
        ticket.kbn4Id = $scope.kbn4Ob.id;
        ticket.kbn5Id = $scope.kbn5Ob.id;
        ticket.item1 = $scope.item1;
        ticket.item2 = $scope.item2;
        ticket.item3 = $scope.item3;
        ticket.item4 = $scope.item4;
        ticket.item5 = $scope.item5;

        if ($scope.parentId) {
          ticket.parentId = $scope.parentId;
        } else {
          ticket.parentId = 0;
        }
        //ステータス：作業前("01")
        ticket.statusId = "01";
        var url = window.location.href;
        var newTicketId = ajaxService.createTicket($rootScope.projectId, ticket, "チェックシートが新規作成されました。", url)
        if (ajaxService.result['resultCd'] != "000000") {
           $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        } else {
          $("#checkreportCreaterSp").css({
                'display' : 'none'
            });
           $rootScope.showInfoMessage("チェックシートが新規作成されました。");
           var url = window.location.href;
           var u = url.split("#")[0];
           window.open(u + "#/showReportDetailSp?id=" + newTicketId );
        }
        return true;
      };

        $scope.getTicketInfo = function (ticketId) {
          $scope.ticket = ajaxService.searchTicketInfo($rootScope.projectId, ticketId);

          $scope.statusOb = $rootScope.getStatusOb($scope.ticket.statusId);
          $scope.firstItem = $scope.getFirstItemOb($scope.ticket.firstItemId);
          $scope.secondItem = $scope.getSecondItemOb($scope.ticket.secondItemId);
          $scope.thirdItem = $scope.getThirdItemOb($scope.ticket.thirdItemId);
          $scope.responseGroup = $scope.getGroupOb($scope.ticket.responseGroupId);
          $scope.requestGroup = $scope.getGroupOb($scope.ticket.requestGroupId);

          $scope.responseGroups = {selected:$scope.ticket.responseGrouplist};
          $scope.readingGroups = {selected:$scope.ticket.readingGrouplist};

          if ($scope.ticket.startScheduledDate == null || $scope.ticket.startScheduledDate == "") {
            $scope.startScheduledDate = null;
          } else {
            $scope.startScheduledDate = new Date($scope.ticket.startScheduledDate);
          }
          if ($scope.ticket.endScheduledDate == null || $scope.ticket.endScheduledDate == "") {
              $scope.endScheduledDate = null;
            } else {
              $scope.endScheduledDate = new Date($scope.ticket.endScheduledDate);
            }
          if ($scope.ticket.startDate == null || $scope.ticket.startDate == "") {
            $scope.startDate = null;
          } else {
            $scope.startDate = new Date($scope.ticket.startDate);
          }
          if ($scope.ticket.endDate == null || $scope.ticket.endDate == "") {
            $scope.endDate = null;
          } else {
            $scope.endDate = new Date($scope.ticket.endDate);
          }
//          $scope.userList = ajaxService.searchUserList($rootScope.projectId, "1");
          if (! $scope.userList) {
            $scope.userList = ajaxService.selectUserList($rootScope.projectId);
            $scope.userList.unshift({userName:" ", userId:null});
          }
          for (var i=0; i<$scope.userList.length; i++) {
            if ($scope.ticket.requestUserId == $scope.userList[i].userId) {
              $scope.requestUser = $scope.userList[i];
            }
            if ($scope.ticket.responseUserId == $scope.userList[i].userId) {
              $scope.responseUser = $scope.userList[i];
            }
          }
          for (var i=0; i<$scope.userList.length; i++) {
              if (localStorage.userId == $scope.userList[i].userId) {
                $scope.loginUser = $scope.userList[i];
              }
            }

          $scope.isEditer = false;
          $scope.isVisitor = false;
          for (var j=0; j<$scope.loginUser.groupList.length; j++) {
            if ($scope.loginUser.groupList[j].groupId == $scope.ticket.responseGroupId) {
              $scope.isEditer = true;
              break;
            }
          }

          if (! $scope.ticket.responseGroupId && ! $scope.ticket.responseUserId) {
            $scope.isEditer = true;
          }

          if (! $scope.isEditer) {
            outer2 : for (var i=0; i<$scope.ticket.readingGrouplist.length; i++) {
                  for (var j=0; j<$scope.loginUser.groupList.length; j++) {
                    if ($scope.loginUser.groupList[j].groupId == $scope.ticket.readingGrouplist[i].groupId) {
                      $scope.isVisitor = true;
                      break outer2;
                    }
                  }
              }
          }

          $scope.notEditable = false;
          if ($scope.ticket.statusId == '03' || $scope.ticket.statusId == '04' || $scope.ticket.statusId == '05') {
            $scope.notEditable = true;
          }

          if (localStorage.mngKbn == '2') {
              $scope.isResponser = true;
              $scope.isRequester = true;
              $scope.isEditer = true;
          }


        };

        $scope.getCheckList = function(ticketId) {
            $scope.checkresultList = ajaxService.searchCheckResultList(ticketId);
            $scope.resultOkNum = 0;
            $scope.resultNgNum = 0;
            $scope.resultKeepNum = 0;
            $scope.resultOtherNum = 0;

            for (var i = 0; i < $scope.checkresultList.length; i++) {
              if ($scope.checkresultList[i].checkResult == "1") {
                $scope.resultOkNum++;
                $scope.checkresultList[i].checkResultName = "正常";
              } else if ($scope.checkresultList[i].checkResult == "2") {
                $scope.resultNgNum++;
                $scope.checkresultList[i].checkResultName = "異常";
              } else if ($scope.checkresultList[i].checkResult == "3") {
                $scope.resultKeepNum++;
                $scope.checkresultList[i].checkResultName = "保留";
              } else if ($scope.checkresultList[i].checkResult == "4") {
                $scope.resultOtherNum++;
                $scope.checkresultList[i].checkResultName = "対象外";
              }
            }
         };

         $scope.getResultInfoSp = function (ticketId, checkListId) {

           $scope.resultDetailList = ajaxService.searchResultDetailList(ticketId, checkListId);

           $scope.result = new Array();
           $scope.userResource = new Array();
           for (var i=0; i<$scope.resultDetailList.length; i++) {
             var rdOb = $scope.resultDetailList[i];
             $scope.result[i] = new Object();
             $scope.result[i].id = rdOb.resultDetailId;
             $scope.result[i].value = rdOb.checkResult;
             if (i == 0 && ! rdOb.checkResult) {
                 $scope.result[i].value = "1";
               }
             $scope.result[i].inputTypeId = rdOb.inputTypeId;
             $scope.result[i].mustFlg = rdOb.mustFlg;
             $scope.result[i].checkDetailName = rdOb.checkDetailName;
             if (rdOb.inputTypeId == 2) {
               //日付
               if (rdOb.checkResult) {
                 $scope.result[i].id = rdOb.resultDetailId;
                 $scope.result[i].value = new Date(rdOb.checkResult);
               }
             } else if (rdOb.inputTypeId == 3) {
               //セレクトボックス
               $scope["userResource"+rdOb.resultDetailId] = ajaxService.searchUserResourceDetail(rdOb.userResourceId);
               if (rdOb.checkResult) {
                 for (var j=0; j< $scope["userResource"+rdOb.resultDetailId].length; j++) {
                   if (rdOb.checkResult == $scope["userResource"+rdOb.resultDetailId][j].value) {
                     $scope.result[i].id = rdOb.resultDetailId;
                     $scope.result[i].value = $scope["userResource"+rdOb.resultDetailId][j];
                   }
                 }
               } else {
                 $scope.result[i].id = rdOb.resultDetailId;
                 $scope.result[i].value = $scope["userResource"+rdOb.resultDetailId][0];
               }
             } else if (rdOb.inputTypeId == 4) {
               //ラジオボタン
               $scope.userResource[i] = ajaxService.searchUserResourceDetail(rdOb.userResourceId);
             } else if (rdOb.inputTypeId == 5) {
               //チェックボックス
               if ($scope.result[i].value == 1 || $scope.result[i].value == "true") {
                 $scope.result[i].value = true;
               } else {
                 $scope.result[i].value = false;
               }
             } else if (rdOb.inputTypeId == 7) {
               //写真
               $scope.getImgList($scope.reportId, rdOb.resultDetailId);
             } else if (rdOb.inputTypeId == 8) {
               //音声
               $scope.getRadioList($scope.reportId, rdOb.resultDetailId);
             } else if (rdOb.inputTypeId == 9) {
               //動画
               $scope.getVideoList($scope.reportId, rdOb.resultDetailId);
             } else if (rdOb.inputTypeId == 10) {
               //手書き
                 $scope["signable"+rdOb.resultDetailId] = true;
                 $scope.getSign($scope.reportId, rdOb.resultDetailId);
             } else if (rdOb.inputTypeId == 11) {
              //360度カメラ
                 if (rdOb.checkResult) {
                   $scope["camera"+rdOb.resultDetailId] = true;
                   if (rdOb.checkResult.indexOf("/t/") != -1) {
                       $scope["cameraT"+rdOb.resultDetailId] = true;
                     } else {
                       $scope["cameraT"+rdOb.resultDetailId] = false;
                     }
                 } else {
                   $scope["camera"+rdOb.resultDetailId] = false;
                 }
             }
           }

           $scope.baseResult = angular.copy($scope.result);
         };

         $scope.getImgList = function(ticketId, checkResultId) {
             $scope["imgbean"+checkResultId] = new Array();
             var imgBeanList = ajaxService.searchImgBeanList(checkResultId);
             for (var i=0; i<imgBeanList.length; i++) {
               var imgOb = new Object();
               imgOb.no = i+1;
               var imgId = imgBeanList[i].id;
               imgOb.fileId = imgId;
               imgOb.fileName = imgBeanList[i].fileName;
               imgOb.url = urlPrefix + "checkreport/getCheckResultFile/"+localStorage.schema+"/"+checkResultId+"/"+localStorage.authId+"/"+imgId+"/th";
               $scope["imgbean"+checkResultId].push(imgOb);
             }
           };

           $scope.getRadioList = function(ticketId, checkResultId) {
               $scope["imgList"+checkResultId] = new Array();
                 var radioBeanList = ajaxService.searchImgBeanList(checkResultId);
                 for (var i=0; i<radioBeanList.length; i++) {
                     var raduoOb = new Object();
                     raduoOb.id = radioBeanList[i].id;
                     raduoOb.fileName = radioBeanList[i].fileName;
                     raduoOb.url = urlPrefix + "checkreport/getCheckResultFile/"+localStorage.schema+"/"+checkResultId+"/"+localStorage.authId+"/"+radioBeanList[i].id+"/null";
//                     raduoOb.url = urlPrefixFileVideo + radioBeanList[i].id +'.'+ raduoOb.fileName.split(".")[1];
                   $scope["imgList"+checkResultId].push(raduoOb);
                 }
             };

           $scope.getVideoList = function(ticketId, checkResultId) {
             $scope["imgList"+checkResultId] = new Array();
               var radioBeanList = ajaxService.searchImgBeanList(checkResultId);
               for (var i=0; i<radioBeanList.length; i++) {
                   var raduoOb = new Object();
                   raduoOb.id = radioBeanList[i].id;
                   raduoOb.fileName = radioBeanList[i].fileName;
                   raduoOb.url = urlPrefix + "checkreport/getCheckResultVideo/"+localStorage.schema+"/"+checkResultId+"/"+localStorage.authId+"/"+radioBeanList[i].id;
//                   raduoOb.url = urlPrefixFileVideo + radioBeanList[i].id +'.'+ raduoOb.fileName.split(".")[1];
                 $scope["imgList"+checkResultId].push(raduoOb);
               }
           };

           $scope.getSign = function(ticketId, checkResultId) {
               $scope["signFlg"+checkResultId] = true;
               $scope["sign"+checkResultId] = new Object();
                 var radioBeanList = ajaxService.searchImgBeanList(checkResultId);
                 if (radioBeanList.length != 0) {
                   //手書きあり
                   $scope["signable"+checkResultId] = false;
                   $scope["signId"+checkResultId] = radioBeanList[0].id;
                   $scope["signUrl"+checkResultId] = urlPrefix + "checkreport/getCheckResultFile/"+localStorage.schema+"/"+checkResultId+"/"+localStorage.authId+"/"+radioBeanList[0].id+"/null";
                 }
             };

           $scope.dynamicImgArray = function(checkResultId){
               $("#slider"+checkResultId).flexslider({
                   slideshow: false,
                   startAt: 0
               });
               return $scope["imgbean"+checkResultId];
           };

           $scope.dynamicArray = function(checkResultId){
               return $scope["imgList"+checkResultId];
           };

           $scope.showSignPc = function(resultId) {
               $scope["signable"+resultId] = true;
               $scope["signFlg"+resultId] = false;
               if ($("#signature"+resultId).children().length == 0 ) {
                 $("#signature"+resultId).jSignature({height:"200",width:"300"});
               }
               $("#signature"+resultId).jSignature("enable");
                   $("#signOK"+resultId).css({
                     'display' : 'initial'
                   });
                   $("#signReset"+resultId).css({
                       'display' : 'initial'
                     });
               };

               $scope.resetSignPc = function(resultId) {
                 var $sigdiv = $("#signature"+resultId);
                 $sigdiv.jSignature("reset");
                 $("#image"+resultId+" img").remove();
               };

               $scope.saveSignPc = function(resultId) {
                 $("#image"+resultId+" img").remove();
                 var $sigdiv = $("#signature"+resultId);
                 var datapair = $sigdiv.jSignature("getData", "image");
                 var i = new Image();

                 i.src = "data:" + datapair[0] + "," + datapair[1];
                 var sampleArr = $rootScope.base64ToArrayBuffer(datapair[1]);
                 var blob = new Blob([ sampleArr ], {type: 'image/png'});
                 blob.name = resultId + ".png";
                 blob.lastModifiedDate = new Date();

                 Upload.upload({
                     url : urlPrefix + "checkreport/uploadCheckResultFile",
                     type : "POST",
                     headers : {
                         "authorization" : localStorage.authId,
                     },
                     dataType : "multipart/form-data",
                     data : {file: blob, 'userName':localStorage.userName, 'loginId':localStorage.userId, 'checkResultId': resultId, 'projectId': $rootScope.projectId, 'ticketId':$scope.reportId, 'typeKbn':'Sign', "schema" : localStorage.schema }
                 }).then(function(response) {
                	 if (response.data.resultCd != '000000') {
                 		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
                 		return ;
                 	 }
                     $rootScope.showInfoMessage("手書きを保存しました。");
                     $scope.getSign($scope.reportId, resultId);
                 }, function(response) {
                   $rootScope.showErrorMessage(tr.T(response.data.resultCd));
                 });
               };

               $scope.deleteSign = function(resultId) {
                 if ($scope.isMustCheckResult(resultId) && ($scope.result[0].value == "1" || $scope.result[0].value == "2")) {
                   $rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
                   return ;
                 }


                 var modalInstance = $uibModal.open({
                       animation : true,
                       templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                       controller : 'confirmDialogCtrl',
                       scope : $scope,
                       backdrop : "static",
                       resolve : {
                           message : function() {
                               return {
                                   message : "該当手書きを削除してもよろしいですか？"
                               };
                           }
                       }
                   });

                 modalInstance.result.then(function() {
                     ajaxService.removeFileCheckResult($scope["signId"+resultId]);
                     if (ajaxService.result['resultCd'] != "000000") {
                       $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                     } else {
                       $rootScope.showInfoMessage("該当手書きを削除しました。");
                       $scope["signable"+resultId] = true;
                       $scope.getSign($scope.reportId, resultId);
                       if ($("#signature"+resultId).children().length != 0 ) {
                         $("#signature"+resultId).jSignature("clear");
                         $("#signature"+resultId).jSignature("disable");
                       }
                     }
                   });
               };

               $scope.getSignUrl = function(checkResultId){
                   return $scope["signUrl"+checkResultId];
                 };


           $scope.deleteFile = function(fileId, resultId, type) {
             if ($scope.isMustCheckResult(resultId) && ($scope.result[0].value == "1" || $scope.result[0].value == "2")) {
                if (ajaxService.hasCheckResultFile(resultId) == 1) {
                  //最後のファイルを削除時、必須項目なら、削除不可
                  $rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
                  return ;
                }
              }


             var modalInstance = $uibModal.open({
                 animation : true,
                 templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                 controller : 'confirmDialogCtrl',
                 scope : $scope,
                 backdrop : "static",
                 resolve : {
                     message : function() {
                         return {
                             message : "該当ファイルを削除してもよろしいですか？"
                         };
                     }
                 }
             });
             modalInstance.result.then(function() {
               ajaxService.removeFileCheckResult(fileId);
               if (ajaxService.result['resultCd'] != "000000") {
                 $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
               } else {
                 $rootScope.showInfoMessage("該当ファイルを削除しました。");
                 if (type == "Image") {
                   $scope.getResultInfoSp ($scope.reportId, $scope.checkListOb.checklistId);
                   $("body,html").animate({
                       scrollTop : $("#slider"+resultId).offset().top - 100
                   }, 1000);
                 } else if (type == "Radio") {
                     $scope.getRadioList($scope.reportId, resultId);
                 } else if (type == "Video") {
                     $scope.getVideoList($scope.reportId, resultId);
                 }

               }
             });
           };



         $scope.getCheckreportDetailSp = function(id , isInit) {

           if (! isInit) {
             if ($scope.checkResultIsChange()) {
               if (! $scope.saveResult(false)){
                 return ;
               }
             }
           }

             $scope.getCheckList($scope.reportId);
             $scope.complete = ($scope.resultOkNum + $scope.resultNgNum + $scope.resultOtherNum ) / $scope.checkresultList.length * 100;
             $scope.detailId = id;
             $scope.checkListOb = $scope.checkresultList[$scope.detailId - 1];

             $scope.checkListSize = $scope.checkresultList.length;

             if ($scope.detailId == $scope.checkListSize) {
               $scope.nextDetailId = 1;
               $scope.nextCheckListOb = $scope.checkresultList[$scope.nextDetailId - 1];
             } else {
               $scope.nextDetailId = $scope.detailId + 1;
               $scope.nextCheckListOb = $scope.checkresultList[$scope.nextDetailId - 1];
             }
             if ($scope.detailId == 1) {
               $scope.prefDetailId = $scope.checkListSize;
               $scope.prefCheckListOb = $scope.checkresultList[$scope.checkListSize-1];
             } else {
               $scope.prefDetailId =  $scope.detailId - 1;
               $scope.prefCheckListOb = $scope.checkresultList[$scope.prefDetailId - 1];
             }

             $scope.getResultInfoSp ($scope.reportId, $scope.checkListOb.checklistId);

         };


        $scope.showCheckreportDetailSp = function(checkreportId) {

            $scope.reportId = checkreportId;
            $scope.getTicketInfo($scope.reportId);
            $scope.getCheckreportDetailSp(1, true);

            $("#checkreportDetailSp").css({
              'display' : 'block'
            });
            $("#checkreportCreaterSp").css({
                'display' : 'none'
            });
            $("body,html").animate({
                scrollTop : $("#checkreportDetailSp").offset().top - 100
            }, 1000);
          };

          $scope.saveResult = function(isLoadDetail) {

              if (! $scope.result[0].value) {
                  $rootScope.showErrorMessage("最終確認を選択してください。");
                return false;
              }

              if ($scope.result[0].value == "1" || $scope.result[0].value == "2" ) {
                //必須チェック　後回し
                  for (var i=1; i<$scope.result.length; i++) {
                    if ($scope.result[i].mustFlg == "1") {
                      if ($scope.result[i].inputTypeId != 7 && $scope.result[i].inputTypeId != 8 && $scope.result[i].inputTypeId != 9 && $scope.result[i].inputTypeId != 10) {
                          if (! $scope.result[i].value) {
                                $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を入力してください。");
                                return false;
                          }
                      } else {
                        if (ajaxService.hasCheckResultFile($scope.result[i].id) == 0) {
                          // FILE無し
                          $rootScope.showErrorMessage($scope.result[i].checkDetailName+"をアップロードしてください。");
                          return false;
                        }
                      }
                    }
                  }
              }
              for (var i=0; i<$scope.result.length; i++) {
                if ($scope.result[i].value) {
                  if ($scope.result[i].inputTypeId == 2) {
                      var v = $rootScope.formatDate($scope.result[i].value, "YYYY/MM/DD");
                      $scope.result[i].checkResult = v;
                  } else if ($scope.result[i].inputTypeId == 3) {
                    $scope.result[i].checkResult = $scope.result[i].value.value;
                  } else {
                    $scope.result[i].checkResult = $scope.result[i].value;
                  }
                }
              }
              ajaxService.modifyCheckResult($rootScope.projectId, $scope.reportId, $scope.result, $scope.lat, $scope.lgt);
              if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                  return false;
                } else {
                  $rootScope.showInfoMessage("保存しました。");
                  if (isLoadDetail) {
                    $scope.getCheckreportDetailSp($scope.detailId, true);
                  }
                  $scope.getTicketInfo($scope.reportId);
                  return true;
                }
            };

            $scope.delete360Camera = function(resultId) {
              if ($scope.isMustCheckResult(resultId) && ($scope.result[0].value == "1" || $scope.result[0].value == "2")) {
                    $rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
                    return ;
                  }

              var resultList = [];
                resultList.push({"id":resultId, "checkResult":""});
                ajaxService.modifyCheckResult($rootScope.projectId, $scope.reportId, resultList);
                $rootScope.showInfoMessage("削除しました。");
                $scope.getCheckreportDetailSp($scope.detailId, true);
            };


          $scope.openUploadImg = function(resultId) {
              $uibModal.open({
                  animation : true,
                  templateUrl : 'app/pages/checklist/fileUploadModal.html',
                  controller : 'FileUploadCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      openFlag : function() {
                          return {
                              'flag' : 'New',
                              'kbn' : 'CheckResult',
                              'id': resultId,
                              'ticketId': $scope.reportId,
                              'typeKbn': "Image",
                              'checklistId': $scope.checkListOb.checklistId
                          };
                      }
                  }
              });
          };

          $scope.openUploadRadio = function(resultId) {
              $uibModal.open({
                  animation : true,
                  templateUrl : 'app/pages/checklist/fileUploadModal.html',
                  controller : 'FileUploadCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      openFlag : function() {
                          return {
                              'flag' : 'New',
                              'kbn' : 'CheckResult',
                              'id': resultId,
                              'ticketId': $scope.reportId,
                              'typeKbn': "Radio"
                          };
                      }
                  }
              });
          };

          $scope.openUploadVideo = function(resultId) {
              $uibModal.open({
                  animation : true,
                  templateUrl : 'app/pages/checklist/fileUploadModal.html',
                  controller : 'FileUploadCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      openFlag : function() {
                          return {
                              'flag' : 'New',
                              'kbn' : 'CheckResult',
                              'id': resultId,
                              'ticketId': $scope.reportId,
                              'typeKbn': "Video"
                          };
                      }
                  }
              });
          };

          $scope.showCheckListSp = function() {
            $uibModal.open({
              animation: true,
              templateUrl: "app/pages/checkreport/sp/checkreportResultListSp.html",
              scope : $scope,
              backdrop : "static",
              resolve: {
                  openFlag: function () {
                      return {};
                }
              }
            });
            $scope.checkListFileList = ajaxService.getFileList($scope.ticket.checksheetId);
          };
          $scope.showHistorySp = function() {

            $uibModal.open({
              animation: true,
              templateUrl: "app/pages/checkreport/sp/checkreportHistorySp.html",
              scope : $scope,
              backdrop : "static",
              resolve: {
                  openFlag: function () {
                      return {};
                }
              }
            });

            $scope.getCommentList($scope.reportId);

          };

          $scope.getCommentList = function(ticketId) {
              $scope.statusHistoryList = ajaxService.searchCommentList($rootScope.projectId, ticketId);
          };

          $scope.showTargetInfoSp = function() {
            $uibModal.open({
              animation: true,
              templateUrl: "app/pages/checkreport/sp/checkreportTargetInfoSp.html",
              scope : $scope,
              backdrop : "static",
              resolve: {
                  openFlag: function () {
                      return {};
                }
              }
            });

            // 工事検索
            $scope.itemNameList = ajaxService.getTargetItemList($rootScope.projectId);
            $scope.selectedTarget = ajaxService.searchTarget($scope.ticket.targetId);
            $scope.selectedTar = {};
            $scope.selectedTar.pref = $rootScope.getPrefOb($scope.selectedTarget.prefCd);
            $scope.selectedTar.reg = $rootScope.getRegionOb($scope.selectedTarget.region);

            $scope.targetFileList = ajaxService.getFileListTarget($scope.ticket.targetId);

          };

          $scope.getSubTicketList = function(ticketId) {
              $scope.subTicketList = ajaxService.getSubTicketList($rootScope.projectId, ticketId);
            };

          $scope.showTicketInfoSp = function() {

            $scope.$modalTicket = $uibModal.open({
                  animation: true,
                  templateUrl: "app/pages/checkreport/sp/checkreportTicketInfoSp.html",
                  scope : $scope,
                  backdrop : "static",
                  resolve: {
                      openFlag: function () {
                          return {};
                    }
                  }
                });

            $scope.getSubTicketList($scope.reportId);
          };

          $scope.modifyTicketSp = function() {

            if (($scope.complete != 100) && ($scope.statusOb.value == '03' || $scope.statusOb.value == '04' || $scope.statusOb.value == '05')) {
              $rootScope.showErrorMessage("未完了のチェック項目があるため、ステータスの更新ができません。");
              return "";
            }
            if (localStorage.mngKbn == '0' && ($scope.statusOb.value == '99' || $scope.statusOb.value == '04' || $scope.statusOb.value == '05')) {
              $rootScope.showErrorMessage($scope.statusOb.label + "を指定する権限がありません。");
                return "";
            }

            if (localStorage.mngKbn == '1' && $scope.statusOb.value == '05') {
              $rootScope.showErrorMessage($scope.statusOb.label + "を指定する権限がありません。");
                return "";
            }
            $scope.ticket.statusId = $scope.statusOb.value;
            if ($scope.firstItem) {
              $scope.ticket.firstItemId = $scope.firstItem.id;
            }

            if ($scope.secondItem) {
                $scope.ticket.secondItemId = $scope.secondItem.id;
            }

            if ($scope.thirdItem) {
                $scope.ticket.thirdItemId = $scope.thirdItem.id;
            }
              $scope.ticket.startScheduledDate = $rootScope.formatDate($scope.startScheduledDate, "YYYY/MM/DD");
              $scope.ticket.endScheduledDate = $rootScope.formatDate($scope.endScheduledDate, "YYYY/MM/DD");
              $scope.ticket.startDate = $rootScope.formatDate($scope.startDate, "YYYY/MM/DD");
              $scope.ticket.endDate = $rootScope.formatDate($scope.endDate, "YYYY/MM/DD");
              $scope.ticket.requestUserId = $scope.requestUser.userId;
              $scope.ticket.requestUserName = $scope.requestUser.userName;
              if ($scope.responseGroup) {
                $scope.ticket.responseGroupId = $scope.responseGroup.groupId;
                $scope.ticket.responseGroupName = $scope.responseGroup.groupName;
              }
              if ($scope.responseUser) {
                $scope.ticket.responseUserId = $scope.responseUser.userId;
                $scope.ticket.responseUserName = $scope.responseUser.userName;
              }
              if ($scope.requestGroup) {
                $scope.ticket.requestGroupId = $scope.requestGroup.groupId;
                $scope.ticket.requestGroupName = $scope.requestGroup.groupName;
              }

//              var responseGroupIdlist = [];
//              for (var i =0; i< $scope.responseGroups.selected.length; i++) {
//                responseGroupIdlist.push($scope.responseGroups.selected[i].groupId);
//              }
              var readingGroupIdlist = [];
              for (var i =0; i< $scope.readingGroups.selected.length; i++) {
            	  if ($rootScope.listContains(readingGroupIdlist, $scope.readingGroups.selected[i].groupId) || $scope.readingGroups.selected[i].groupId == null){
               		 continue;
               	 }
                readingGroupIdlist.push($scope.readingGroups.selected[i].groupId);
              }

//              $scope.ticket.responseGroupIdlist = responseGroupIdlist;
              $scope.ticket.readingGroupIdlist = readingGroupIdlist;

              ajaxService.modifyTicket($scope.ticket, $rootScope.projectId);
              if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
               } else {
                  $rootScope.showInfoMessage("チェックシートを更新しました。");
                  $scope.getTicketInfo($scope.ticket.id);
                  $scope.$$childTail.$dismiss();
               }
          };

          $scope.CheckreportDeleteSp = function() {
            var modalInstance = $uibModal.open({
                  animation : true,
                  templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                  controller : 'confirmDialogCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                              message : "チェックシートを削除してもよろしいですか？"
                          };
                      }
                  }
              });
            modalInstance.result.then(function() {
                ajaxService.removeTicket($rootScope.projectId, $scope.reportId);
                if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                } else {
                  $rootScope.showInfoMessage("チェックシートを削除しました。");
                  $scope.getCheckreportList();
                  $("#checkreportDetailSp").css({
                    'display' : 'none'
                  });
                  $("body,html").animate({
                      scrollTop : $("#checkreportList").offset().top - 100
                  }, 1000);
                  $scope.$modalTicket.dismiss();
                }
              });
          };


          $scope.reportComp = function() {
            //チェック完了
            $scope.ticket.statusId = "03";
            ajaxService.modifyTicket($scope.ticket, $rootScope.projectId);
            if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
             } else {
                $rootScope.showInfoMessage("更新しました。");
                $scope.getTicketInfo($scope.ticket.id);
             }
          };

          $scope.reportReturn = function() {
              //チェック中
              $scope.ticket.statusId = "02";
              ajaxService.modifyTicket($scope.ticket, $rootScope.projectId);
              if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
               } else {
                  $rootScope.showInfoMessage("更新しました。");
                  $scope.getTicketInfo($scope.ticket.id);
               }
            };

          //CKEditor
//            $scope.options = {
//              language: 'ja',
//              extraPlugins: 'colorbutton',
//              allowedContent: true,
//              entities: false
//            }
//            $scope.onReady = function () {
//            };

            $scope.saveComment = function () {
                var content = $scope.$$childTail.accordion.groups[0].$$childTail.content;
                if (! content) {
                  $rootScope.showErrorMessage("コメントを入力してください。");
                  return;
                }
                var url = window.location.href;
                ajaxService.saveComment($scope.reportId, $scope.ticket.statusId, content, $rootScope.projectId, url);
                if (ajaxService.result['resultCd'] != "000000") {
                    $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                  } else {
                    $rootScope.showInfoMessage("コメントを保存しました。");
                    $scope.getCommentList($scope.reportId);
                    $scope.$$childTail.accordion.groups[0].$$childTail.content = "";
                  }
              };

              $scope.checkResultIsChange = function () {

                  for (var i=0; i<$scope.result.length; i++) {

                    if ($scope.result[i].inputTypeId == 2) {
                      if ($rootScope.formatDate($scope.result[i].value, "YYYY/MM/DD") != $rootScope.formatDate($scope.baseResult[i].value, "YYYY/MM/DD")){
                        return true;
                      }
                    } else if ($scope.result[i].inputTypeId == 3) {
                      if ($scope.result[i].value.value != $scope.baseResult[i].value.value){
                            return true;
                          }
                    } else {
                      if ($scope.result[i].value != $scope.baseResult[i].value) {
                              return true;
                            }
                    }

                  }
                  return false;
                };

                $scope.isMustCheckResult = function (checkReusltId) {
                    for (var i=1; i<$scope.result.length; i++) {
                      if ($scope.result[i].id == checkReusltId) {
                        if ($scope.result[i].mustFlg == "1"){
                          return true;
                        } else {
                          return false;
                        }
                      }
                    }
                  };


                  $scope.scrollToBottom  = function(div) {
                	  setTimeout(function () {
                		  var objDiv = document.getElementById(div);
                		  objDiv.scrollTop = 150;
                      }, 110)
                  };

//                  $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);
                  // userOrder : 1,工事との距離順
                  $scope.userOrder = $scope.mngCommon.userOrder;

                  $scope.changeTarget  = function() {
                	  if ($scope.target.latitude && $scope.target.longitude) {
                		  if ($scope.userOrder == '1') {
                			  if ($scope.adminMng != '1') {

            					  $scope.getUserGroupSortWithTarget();

//                				  if (localStorage.mngKbn != '0') {
//                					  $scope.getUserGroupSortWithTarget();
//                				  } else {
//                					  $scope.groupList = angular.copy($scope.loginUser.groupList);
//                		              //指示者、チェック者は自分所属しているグループ内のユーザのみが見れる。
//                		              if ($scope.groupList.length == 0) {
//                		            	  $scope.userList = [];
//                		            	  $scope.userList.push($scope.loginUser);
//                		              } else {
//                		            	  var groupIdList = [];
//                		            	  for (var i = 0; i < $scope.groupList.length; i++) {
//                		            		  if ($scope.groupList[i].groupId) {
//                    		            		  groupIdList.push($scope.groupList[i].groupId);
//                		            		  }
//                		            	  }
//                		                  $scope.userList = ajaxService.selectUserListOrderByDis($rootScope.projectId, $scope.target.latitude, $scope.target.longitude, groupIdList);
//                		              }
//                		              $scope.userList.unshift({userName:" ", userId:''});
//                		              for (var i=0; i<$scope.userList.length; i++) {
//                	                      if (localStorage.userId == $scope.userList[i].userId) {
//                	                        $scope.requestUser = $scope.userList[i];
//                	                      }
//                	                    }
//
//                	                  $scope.responseUser = $scope.userList[0];
//
//                	                  var groups = ajaxService.selectGroupUserResourceListOrderByDis($rootScope.projectId, $scope.target.latitude, $scope.target.longitude, groupIdList);
//                				      if (ajaxService.result['resultCd'] == "000000") {
//                				    	  $scope.groupList = groups;
//                				          $scope.groupList.unshift({groupName:" ", groupId:null});
//                				          $scope.responseGroup = $scope.groupList[0];
//                				          $scope.requestGroup = $scope.groupList[0];
//                				      }
//                				  }
                		      } else {
                		    	  if (localStorage.mngKbn == '2') {
                    		    	  $scope.getUserGroupSortWithTarget();
                		    	  } else {
                		    		  $scope.groupList = angular.copy($scope.loginUser.groupList);
                		              //指示者、チェック者は自分所属しているグループ内のユーザのみが見れる。
                		              if ($scope.groupList.length == 0) {
                		            	  $scope.userList = [];
                		            	  $scope.userList.push($scope.loginUser);
                		              } else {
                		            	  var groupIdList = [];
                		            	  for (var i = 0; i < $scope.groupList.length; i++) {
                		            		  if ($scope.groupList[i].groupId) {
                    		            		  groupIdList.push($scope.groupList[i].groupId);
                		            		  }
                		            	  }
                		                  $scope.userList = ajaxService.selectUserListOrderByDis($rootScope.projectId, $scope.target.latitude, $scope.target.longitude, groupIdList);
                		              }
                		              $scope.userList.unshift({userName:" ", userId:''});
                		              for (var i=0; i<$scope.userList.length; i++) {
                	                      if (localStorage.userId == $scope.userList[i].userId) {
                	                        $scope.requestUser = $scope.userList[i];
                	                      }
                	                    }

                	                  $scope.responseUser = $scope.userList[0];

                	                  var groups = ajaxService.selectGroupUserResourceListOrderByDis($rootScope.projectId, $scope.target.latitude, $scope.target.longitude, groupIdList);
                				      if (ajaxService.result['resultCd'] == "000000") {
                				    	  $scope.groupList = groups;
                				          $scope.groupList.unshift({groupName:" ", groupId:null});
                				          $scope.responseGroup = $scope.groupList[0];
                				          $scope.requestGroup = $scope.groupList[0];
                				      }
                		    	  }
                		      }
                		  }
                	  }
                  };

                  $scope.getUserGroupSortWithTarget  = function() {
                	  var uses = ajaxService.selectUserListOrderByDis($rootScope.projectId, $scope.target.latitude, $scope.target.longitude, new Array());
        			  if (ajaxService.result['resultCd'] == "000000") {
        				  $scope.userList = uses;
                          $scope.userList.unshift({userName:" ", userId:null});
                          for (var i=0; i<$scope.userList.length; i++) {
                              if (localStorage.userId == $scope.userList[i].userId) {
                                $scope.requestUser = $scope.userList[i];
                              }
                            }

                            $scope.responseUser = $scope.userList[0];
        			  }

        			  if (localStorage.mngKbn != '0') {
        			      var groups = ajaxService.selectGroupUserResourceListOrderByDis($rootScope.projectId, $scope.target.latitude, $scope.target.longitude, new Array());
        			      if (ajaxService.result['resultCd'] == "000000") {
        			    	  $scope.groupList = groups;
        			          $scope.groupList.unshift({groupName:" ", groupId:null});
        			          $scope.responseGroup = $scope.groupList[0];
        			          $scope.requestGroup = $scope.groupList[0];
        			      }

        			  }
                  }


    }

	  $scope.$on('$destroy',function(){
		  if ($scope.timer){
    		  $interval.cancel($scope.timer);
    		  $scope.timer = null;
    	  }
	  });

      $scope.showItemInfo = function () {

      	$uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checkreport/checkreportItemInfo.html',
              controller: 'ItemnameCtrl',
              scope : $scope,
              size: 'lg',
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                        type : ""
                      };
                  }
              }
          });
      };

      $scope.reload = function () {
      	window.location.reload();
      };

      $scope.downloadCheckSheetList = function () {

    	  var ticketIdList = [];
    	  for (var i=0; i<$scope.ticketChoice.length; i++){
    		  if ($scope.ticketChoice[i]) {
    			  ticketIdList.push(i);
    		  }
    	  }
    	  if (ticketIdList.length==0) {
    		  $rootScope.showErrorMessage("チェックシートを選択してください。");
    		  return;
    	  }

    	  var responseUserNameList = [];
    	  for (var j = 0; j < $scope.checkreportList.length; j ++) {
    		  for (var n = 0; n < ticketIdList.length; n ++) {
    			  if ($scope.checkreportList[j].id == ticketIdList[n]) {
    				  if(responseUserNameList.indexOf($scope.checkreportList[j].responseUserName) < 0){
    					  responseUserNameList.push($scope.checkreportList[j].responseUserName);
    				  }
    			  }
    		  }
    	  }

    	  console.log(responseUserNameList);

    	  var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : "チェック報告一覧表を出力します。よろしいですか？",
                          flg : 2,
                          userNameList : responseUserNameList
                      };
                  }
              }
          });
        modalInstance.result.then(function(userNameList) {

        	console.log(userNameList);
            var todayFlag = document.todayFlag.today.checked;
            var todayFlg = 0;
            if (todayFlag){
            	//当日を含む
            	todayFlg = 1;
            }

            baProgressModal.open('app/pages/checkreport/progressModal.html',$scope);
      	    $http({
                url: urlPrefix + "checkreport/downloadChecksheetList/",
                method: "POST",
                data: JSON.stringify(
                        {"ticketIdList":ticketIdList,
                            "todayFlg" : todayFlg,
                            "schema" : localStorage.schema,
                            "projectId" : $rootScope.projectId,
                            "userNameList" : userNameList,
                            "loginId" : localStorage.userId
                            }), //this is your json data string
                headers: {
                   'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
            	var blob = new Blob([data], { type: "application/vnd.ms-excel" });

                var fileName = "実施作業一覧表.xls";

                var ostest = $window.navigator.userAgent.toLowerCase();
                var isiOS = false;

                if ( ostest.indexOf("iphone") !== -1 || ostest.indexOf("ipad") !== -1 || ostest.indexOf("mac os x") !== -1) {
                    isiOS = true;
                }

                if (isiOS) {
              	  var reader = new FileReader();
                    reader.onload =function(e) {
                      window.open(reader.result);
                    }
                    reader.readAsDataURL(blob);
                } else {
              	  if ($window.navigator.msSaveBlob) {
                        $window.navigator.msSaveBlob(blob, fileName);
                    } else {
                        var downloadLink = $('<a></a>');
                        downloadLink.attr('href', $window.URL.createObjectURL(blob));
                        downloadLink.attr('download', fileName);
                        downloadLink.attr('target', '_blank');
                        $('body').append(downloadLink);
                        downloadLink[0].click();
                        downloadLink.remove();
                    }
                }

                baProgressModal.close();
            }).error(function (data, status, headers, config) {
                baProgressModal.close();
                if (status == 400) {
                    $rootScope.showErrorMessage("同じ対象工事名のチェックシートを選択してください。");
                } else if (status == 401) {
                    $rootScope.showErrorMessage("未完了のチェックシートが含まれています。チェックシートを選択し直してください");
                } else {
                    $rootScope.showErrorMessage("システムエラー発生しました。");
                }
            });




          });

      };

  }

})();

/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.checkreport').controller('CheckreportSpCtrl', CheckreportSpCtrl);

    /** @ngInject */
    function CheckreportSpCtrl($scope, $filter, editableOptions, editableThemes, toastr, $sce, $timeout,
            toastrConfig, ajaxService, $state, $uibModal, $location, $window, themeLayoutSettings, Upload, $http, $rootScope, tr) {
      $scope.smartTablePageSize = 20;
      var theme = themeLayoutSettings;

      $scope.mngFlg = localStorage.mngKbn;
      $scope.loginUserId = localStorage.userId;

      if (!ajaxService.tokenCheck()) {
          return;
        };

        //############################## SP ##############################

      $scope.ctrl = $scope;

      $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);
      $scope.showResult = $scope.mngCommon.showResult;

      $scope.parentTicket = $scope.mngCommon.parentTicketType;
      $scope.adminMng = $scope.mngCommon.adminMng;
      $scope.finalApproval = $scope.mngCommon.finalApproval;
      $scope.commentWithMail = $scope.mngCommon.commentWithMail;

      $scope.lat = null;
      $scope.lgt = null;
      if(!navigator.geolocation){ alert('位置情報を共有してください。'); return; }
      navigator.geolocation.getCurrentPosition(
      function(position){
        $scope.lat = position.coords.latitude;
        $scope.lgt = position.coords.longitude;
        } ,
        function(){
          //alert('位置情報取得失敗！');
        }
      );

      $scope.showCheckreportDetailWindow = function(checkreportId) {

        if(ajaxService.hasTicket(checkreportId) == 0) {
           $rootScope.showErrorMessage("該当チェックシートが削除されました。");
           $scope.getCheckreportListSp();
           return ;
         }

        var url = window.location.href;
        var u = url.split("#")[0];
        window.open(u + "#/showReportDetailSp?id=" + id );

          $scope.reportId = checkreportId;
          $scope.getTicketInfo($scope.reportId);
          $scope.getCheckreportDetailSp(1, true);

          $("#checkreportDetailSp").css({
            'display' : 'block'
          });
          $("#checkreportCreaterSp").css({
              'display' : 'none'
          });
          $("body,html").animate({
              scrollTop : $("#checkreportDetailSp").offset().top - 100
          }, 1000);
        };

        $scope.itemTicketList = ajaxService.searchItemNameList('3', $rootScope.projectId);
		 $scope.showStatusDetail = false;
         $scope.showKbn2 = false;
         $scope.showKbn3 = false;
         $scope.showKbn4 = false;
         $scope.showKbn5 = false;
         $scope.showItem1 = false;
         $scope.showItem2 = false;
         $scope.showItem3 = false;
         $scope.showItem4 = false;
         $scope.showItem5 = false;

		 $scope.mustStatusDetail = false;
         $scope.mustKbn2 = false;
         $scope.mustKbn3 = false;
         $scope.mustKbn4 = false;
         $scope.mustKbn5 = false;
         $scope.mustItem1 = false;
         $scope.mustItem2 = false;
         $scope.mustItem3 = false;
         $scope.mustItem4 = false;
         $scope.mustItem5 = false;

		 for (var i=0; i<$scope.itemTicketList.length; i++) {
           var field = $scope.itemTicketList[i].fieldName;
           if (field == "statusDetail") {
             $scope.statusDetailItemName = $scope.itemTicketList[i].showName;
             if ($scope.itemTicketList[i].isShow != '1') {
                 $scope.showStatusDetail = true;
                  if ($scope.itemTicketList[i].isShow == '3') {
             		 $scope.mustStatusDetail = true;
                  }
             }
           }
           if (field == "kbn2") {
               $scope.kbn2ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showKbn2 = true;
                   if ($scope.itemTicketList[i].isShow == '3') {
               		 $scope.mustKbn2 = true;
                    }
               }
             }
           if (field == "kbn3") {
               $scope.kbn3ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showKbn3 = true;
                   if ($scope.itemTicketList[i].isShow == '3') {
                 		 $scope.mustKbn3 = true;
                      }
               }
             }
           if (field == "kbn4") {
               $scope.kbn4ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showKbn4 = true;
                   if ($scope.itemTicketList[i].isShow == '3') {
                 		 $scope.mustKbn4 = true;
                      }
               }
             }
           if (field == "kbn5") {
               $scope.kbn5ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showKbn5 = true;
                   if ($scope.itemTicketList[i].isShow == '3') {
                 		 $scope.mustKbn5 = true;
                      }
               }
             }
           if (field == "item1") {
               $scope.item1ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showItem1 = true;
                   if ($scope.itemTicketList[i].isShow == '3') {
                 		 $scope.mustItem1 = true;
                      }
               }
             }
           if (field == "item2") {
               $scope.item2ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showItem2 = true;
                   if ($scope.itemTicketList[i].isShow == '3') {
               		 $scope.mustItem2 = true;
                    }
               }
             }
           if (field == "item3") {
               $scope.item3ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showItem3 = true;
                   if ($scope.itemTicketList[i].isShow == '3') {
               		 $scope.mustItem3 = true;
                    }
               }
             }
           if (field == "item4") {
               $scope.item4ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showItem4 = true;
                   if ($scope.itemTicketList[i].isShow == '3') {
               		 $scope.mustItem4 = true;
                    }
               }
             }
           if (field == "item5") {
               $scope.item5ItemName = $scope.itemTicketList[i].showName;
               if ($scope.itemTicketList[i].isShow != '1') {
                   $scope.showItem5 = true;
                   if ($scope.itemTicketList[i].isShow == '3') {
               		 $scope.mustItem5 = true;
                    }
               }
             }
		 }

		 $scope.statusDetailList = [];
		 if ($scope.showStatusDetail) {
			 $scope.statusDetailList = ajaxService.getProjectResourceList($rootScope.projectId, '4', 0);
			 $scope.statusDetailList.unshift({label:" ", id:null});
		 }
		 $scope.kbn2List = [];
		 if ($scope.showKbn2) {
			 $scope.kbn2List = ajaxService.getProjectResourceList($rootScope.projectId, '5', 0);
			 $scope.kbn2List.unshift({label:" ", id:null});
		 }
		 $scope.kbn3List = [];
		 if ($scope.showKbn3) {
			 $scope.kbn3List = ajaxService.getProjectResourceList($rootScope.projectId, '6', 0);
			 $scope.kbn3List.unshift({label:" ", id:null});
		 }
		 $scope.kbn4List = [];
		 if ($scope.showKbn4) {
			 $scope.kbn4List = ajaxService.getProjectResourceList($rootScope.projectId, '7', 0);
			 $scope.kbn4List.unshift({label:" ", id:null});
		 }
		 $scope.kbn5List = [];
		 if ($scope.showKbn5) {
			 $scope.kbn5List = ajaxService.getProjectResourceList($rootScope.projectId, '8', 0);
			 $scope.kbn5List.unshift({label:" ", id:null});
		 }



      $scope.firstItemList = ajaxService.getProjectResourceList($rootScope.projectId, '1');
      $scope.secondItemList = ajaxService.getProjectResourceList($rootScope.projectId, '2');
      $scope.thirdItemList = ajaxService.getProjectResourceList($rootScope.projectId, '3');

      $scope.getFirstItemOb = function (value) {
        for (var i = 0; i < $scope.firstItemList.length; i++) {
          if (value == $scope.firstItemList[i].id) {
            return $scope.firstItemList[i];
          }
        }
      };
      $scope.getSecondItemOb = function (value) {
        for (var i = 0; i < $scope.secondItemList.length; i++) {
          if (value == $scope.secondItemList[i].id) {
            return $scope.secondItemList[i];
          }
        }
      };
      $scope.getThirdItemOb = function (value) {
        for (var i = 0; i < $scope.thirdItemList.length; i++) {
          if (value == $scope.thirdItemList[i].id) {
            return $scope.thirdItemList[i];
          }
        }
      };

      $scope.userList = ajaxService.selectUserList($rootScope.projectId);
      $scope.userList.unshift({userName:" ", userId:null});
      for (var i=0; i<$scope.userList.length; i++) {
          if (localStorage.userId == $scope.userList[i].userId) {
            $scope.loginUser = $scope.userList[i];
            break;
          }
        }

      if ($scope.adminMng != '1') {
    	  if (localStorage.mngKbn != '0') {
	        $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
	      } else {
	    	  $scope.groupList = angular.copy($scope.loginUser.groupList);
              //チェック管理者、チェック者は自分所属しているグループ内の技術者のみが見れる。
              if ($scope.groupList.length == 0) {
            	  $scope.userList = [];
            	  $scope.userList.push($scope.loginUser);
              } else {
            	  var groupIdList = [];
            	  for (var i = 0; i < $scope.groupList.length; i++) {
            		  groupIdList.push($scope.groupList[i].groupId);
            	  }
                  $scope.userList = ajaxService.getListByGroupIdList(groupIdList);
              }
              $scope.userList.unshift({userName:" ", userId:''});
	      }
      } else {
    	  if (localStorage.mngKbn == '2') {
              $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
            } else {
              $scope.groupList = angular.copy($scope.loginUser.groupList);
              //チェック管理者、チェック者は自分所属しているグループ内の技術者のみが見れる。
              if ($scope.groupList.length == 0) {
            	  $scope.userList = [];
            	  $scope.userList.push($scope.loginUser);
              } else {
            	  var groupIdList = [];
            	  for (var i = 0; i < $scope.groupList.length; i++) {
            		  groupIdList.push($scope.groupList[i].groupId);
            	  }
                  $scope.userList = ajaxService.getListByGroupIdList(groupIdList);
              }
              $scope.userList.unshift({userName:" ", userId:''});
            }
      }
      $scope.groupList.unshift({groupName:" ", groupId:null});


      $scope.getGroupOb = function (value) {
          for (var i = 0; i < $scope.groupList.length; i++) {
            if (value == $scope.groupList[i].groupId) {
              return $scope.groupList[i];
            }
          }
        };

        $scope.getStatusDetailOb = function (value) {
	        for (var i = 0; i < $scope.statusDetailList.length; i++) {
	          if (value == $scope.statusDetailList[i].id) {
	            return $scope.statusDetailList[i];
	          }
	        }
	        return new Object();
	      };
	      $scope.getKbn2Ob = function (value) {
	        for (var i = 0; i < $scope.kbn2List.length; i++) {
	          if (value == $scope.kbn2List[i].id) {
	            return $scope.kbn2List[i];
	          }
	        }
	        return new Object();
	      };
	      $scope.getKbn3Ob = function (value) {
	        for (var i = 0; i < $scope.kbn3List.length; i++) {
	          if (value == $scope.kbn3List[i].id) {
	            return $scope.kbn3List[i];
	          }
	        }
	        return new Object();
	      };
	      $scope.getKbn4Ob = function (value) {
	        for (var i = 0; i < $scope.kbn4List.length; i++) {
	          if (value == $scope.kbn4List[i].id) {
	            return $scope.kbn4List[i];
	          }
	        }
	        return new Object();
	      };
	      $scope.getKbn5Ob = function (value) {
	        for (var i = 0; i < $scope.kbn5List.length; i++) {
	          if (value == $scope.kbn5List[i].id) {
	            return $scope.kbn5List[i];
	          }
	        }
	        return new Object();
	      };


      $scope.getTargetList = function () {
        $scope.targetList = ajaxService.searchTargetIdNameList($rootScope.projectId);
      };

      $scope.showCheckreportCreateSp = function(parentId, parentTargetId) {
        if (parentId) {
          $scope.parentId = parentId;
        }

        $scope.firstItem = new Object();
        $scope.secondItem = new Object();
        $scope.thirdItem = new Object();

//        $scope.userList = ajaxService.searchUserList($rootScope.projectId, "1");
        if (! $scope.userList) {
          $scope.userList = ajaxService.selectUserList($rootScope.projectId);
          $scope.userList.unshift({userName:" ", userId:null});
        }

        for (var i=0; i<$scope.userList.length; i++) {
          if (localStorage.userId == $scope.userList[i].userId) {
            $scope.requestUser = $scope.userList[i];
          }
        }

        $scope.responseUser = new Object();

        $scope.responseGroup = new Object();
        $scope.requestGroup = new Object();

        $scope.responseGroups = {selected:[]};

        $scope.defaultGroupList = ajaxService.selectDefaultGroupList($rootScope.projectId);
        $scope.readingGroups = {selected:$scope.defaultGroupList};

        $scope.checklistList = ajaxService.searchChecksheetList($rootScope.projectId, "0");
        $scope.checklist = new Object();

        $scope.getTargetList();

        if (parentTargetId) {
       	 for (var i=0; i< $scope.targetList.length;i++) {
       		 if(parentTargetId == $scope.targetList[i].id){
       			 $scope.target = $scope.targetList[i];
       			 break;
       		 }
       	 }
        } else {
            $scope.target = {};
        }

        $("#checkreportDetailSp").css({
          'display' : 'none'
        });
        $("#checkreportCreaterSp").css({
            'display' : 'block'
        });
        $("body,html").animate({
            scrollTop : $("#checkreportCreaterSp").offset().top - 100
        }, 1000);
      };

      $scope.closeCreateTicketSp = function() {
        $("#checkreportDetailSp").css({
              'display' : 'block'
            });
            $("#checkreportCreaterSp").css({
                'display' : 'none'
            });
            $("body,html").animate({
                scrollTop : $("#checkreportDetailSp").offset().top - 100
            }, 1000);
      };

      $scope.showCreateTarget = function() {
        //工事項目リストを取得
        $scope.itemNameList = ajaxService.getTargetItemList($rootScope.projectId);
//        $scope.targetItemList = new Array();
//        for (var i=0; i<$scope.itemNameList.length; i++) {
//          if (i % 2 == 0) {
//            var obj = {"left":null, "right": null};
//              obj["left"] = $scope.itemNameList[i];
//              if (i == $scope.itemNameList.length - 1) {
//                $scope.targetItemList.push(obj);
//              }
//          } else {
//            obj["right"] = $scope.itemNameList[i];
//            $scope.targetItemList.push(obj);
//          }
//        }
          var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checkreport/sp/newCheckTargetSp.html',
              controller : 'ChecktargetCtrl',
              scope : $scope,
              size: 'lg',
              backdrop : "static",
              resolve : {
                message : function() {
                    return {
                          type : "ticket"
                      };
                  }
              }
          });

          modalInstance.result.then(function() {
            $scope.getTargetList();
            $scope.target = {};
          });
      };

      $scope.createTicketSp = function() {

        if (! $scope.checklist.checksheetId) {
          $rootScope.showErrorMessage("チェックを選択してください。");
          return
        }
        if (! $scope.target.id) {
          $rootScope.showErrorMessage("対象工事を選択してください。");
          return
        }

        if ((!$scope.requestUser.userId || $scope.requestUser.userId == "") && (!$scope.requestGroup.groupId || $scope.requestGroup.groupId == "")) {
            $rootScope.showErrorMessage("管理技術者または指示グループを選択してください。");
            return;
        }

        var responseGroupIdlist = [];
        for (var i =0; i< $scope.responseGroups.selected.length; i++) {
          responseGroupIdlist.push($scope.responseGroups.selected[i].groupId);
        }
        var readingGroupIdlist = [];
        for (var i =0; i< $scope.readingGroups.selected.length; i++) {
        	if ($rootScope.listContains(readingGroupIdlist, $scope.readingGroups.selected[i].groupId) || $scope.readingGroups.selected[i].groupId == null){
         		 continue;
         	 }
          readingGroupIdlist.push($scope.readingGroups.selected[i].groupId);
        }

        var ticket = new Object();
        ticket.targetId = $scope.target.id;
        ticket.checksheetId = $scope.checklist.checksheetId;
        ticket.firstItemId = $scope.firstItem.id;
        ticket.secondItemId = $scope.secondItem.id;
        ticket.thirdItemId = $scope.thirdItem.id;
        ticket.startScheduledDate = $rootScope.formatDate($scope.startScheduledDate, "YYYY/MM/DD");
        ticket.endScheduledDate = $rootScope.formatDate($scope.endScheduledDate, "YYYY/MM/DD");
        ticket.startDate = $rootScope.formatDate($scope.startDate, "YYYY/MM/DD");
        ticket.endDate = $rootScope.formatDate($scope.endDate, "YYYY/MM/DD");
        ticket.requestUserId = $scope.requestUser.userId;
        ticket.responseGroupId = $scope.responseGroup.groupId;
        ticket.responseUserId = $scope.responseUser.userId;
        ticket.requestGroupId = $scope.requestGroup.groupId;
        ticket.responseGroupIdlist = responseGroupIdlist;
        ticket.readingGroupIdlist = readingGroupIdlist;

        if ($scope.parentId) {
          ticket.parentId = $scope.parentId;
        } else {
          ticket.parentId = 0;
        }
        //ステータス：チェック前("01")
        ticket.statusId = "01";
        var url = window.location.href;
        var newTicketId = ajaxService.createTicket($rootScope.projectId, ticket, "チェックシートが新規作成されました。", url)
        if (ajaxService.result['resultCd'] != "000000") {
           $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        } else {
           $rootScope.showInfoMessage("チェックシートが新規作成されました。");
           $scope.closeCreateTicketSp();
           var url = window.location.href;
           var u = url.split("#")[0];
           window.open(u + "#/showReportDetailSp?id=" + newTicketId );
        }
      };

        $scope.getTicketInfo = function (ticketId) {
          $scope.ticket = ajaxService.searchTicketInfo($rootScope.projectId, ticketId);

          $scope.statusOb = $rootScope.getStatusOb($scope.ticket.statusId);
          $scope.firstItem = $scope.getFirstItemOb($scope.ticket.firstItemId);
          $scope.secondItem = $scope.getSecondItemOb($scope.ticket.secondItemId);
          $scope.thirdItem = $scope.getThirdItemOb($scope.ticket.thirdItemId);
          $scope.responseGroup = $scope.getGroupOb($scope.ticket.responseGroupId);
          $scope.requestGroup = $scope.getGroupOb($scope.ticket.requestGroupId);

          $scope.responseGroups = {selected:$scope.ticket.responseGrouplist};
          $scope.readingGroups = {selected:$scope.ticket.readingGrouplist};

          $scope.statusDetailOb = $scope.getStatusDetailOb($scope.ticket.statusDetailId);

          if ($scope.showKbn2) {
         	 $scope.kbn2Ob = $scope.getKbn2Ob($scope.ticket.kbn2Id);
          }
          if ($scope.showKbn3) {
         	 $scope.kbn3Ob = $scope.getKbn3Ob($scope.ticket.kbn3Id);
          }
          if ($scope.showKbn4) {
         	 $scope.kbn4Ob = $scope.getKbn4Ob($scope.ticket.kbn4Id);
          }
          if ($scope.showKbn5) {
         	 $scope.kbn5Ob = $scope.getKbn5Ob($scope.ticket.kbn5Id);
          }
          $scope.item1 = $scope.ticket.item1;
          $scope.item2 = $scope.ticket.item2;
          $scope.item3 = $scope.ticket.item3;
          $scope.item4 = $scope.ticket.item4;
          $scope.item5 = $scope.ticket.item5;

          if ($scope.ticket.startScheduledDate == null || $scope.ticket.startScheduledDate == "") {
            $scope.startScheduledDate = null;
          } else {
            $scope.startScheduledDate = new Date($scope.ticket.startScheduledDate);
          }
          if ($scope.ticket.endScheduledDate == null || $scope.ticket.endScheduledDate == "") {
              $scope.endScheduledDate = null;
            } else {
              $scope.endScheduledDate = new Date($scope.ticket.endScheduledDate);
            }
          if ($scope.ticket.startDate == null || $scope.ticket.startDate == "") {
            $scope.startDate = null;
          } else {
            $scope.startDate = new Date($scope.ticket.startDate);
          }
          if ($scope.ticket.endDate == null || $scope.ticket.endDate == "") {
            $scope.endDate = null;
          } else {
            $scope.endDate = new Date($scope.ticket.endDate);
          }
//          $scope.userList = ajaxService.searchUserList($rootScope.projectId, "1");
          if (! $scope.userList) {
            $scope.userList = ajaxService.selectUserList($rootScope.projectId);
            $scope.userList.unshift({userName:" ", userId:null});
          }
          for (var i=0; i<$scope.userList.length; i++) {
            if ($scope.ticket.requestUserId == $scope.userList[i].userId) {
              $scope.requestUser = $scope.userList[i];
            }
            if ($scope.ticket.responseUserId == $scope.userList[i].userId) {
              $scope.responseUser = $scope.userList[i];
            }
          }
          if ($scope.ticket.requestUserId && !$scope.requestUser) {
         	 $scope.requestUser = {userName:$scope.ticket.requestUserName, userId:$scope.ticket.requestUserId};
          }

          if ($scope.ticket.responseUserId && !$scope.responseUser) {
         	 $scope.responseUser = {userName:$scope.ticket.responseUserName, userId:$scope.ticket.responseUserId};
          }

//          for (var i=0; i<$scope.userList.length; i++) {
//              if (localStorage.userId == $scope.userList[i].userId) {
//                $scope.loginUser = $scope.userList[i];
//              }
//            }

          $scope.isResponser = false;
          $scope.isRequester = false;
          $scope.isEditer = false;
          $scope.isVisitor = false;
          for (var j=0; j<$scope.loginUser.groupList.length; j++) {
            if ($scope.loginUser.groupList[j].groupId == $scope.ticket.responseGroupId && $scope.ticket.responseGroupId) {
                $scope.isResponser = true;
              $scope.isEditer = true;
            }
            if ($scope.ticket.requestGroupId) {
           	 if ($scope.loginUser.groupList[j].groupId == $scope.ticket.requestGroupId && $scope.ticket.requestGroupId) {
                    $scope.isEditer = true;
                    $scope.isRequester = true;
                  }
            }
          }

//          if (! $scope.ticket.responseGroupId && ! $scope.ticket.responseUserId) {
//            $scope.isResponser = true;
//            $scope.isEditer = true;
//          }

          if (localStorage.userId == $scope.ticket.responseUserId) {
              $scope.isEditer = true;
              $scope.isResponser = true;
            }

          if (localStorage.userId == $scope.ticket.requestUserId) {
            $scope.isEditer = true;
            $scope.isRequester = true;
          }

          if (! $scope.isEditer) {
            outer2 : for (var i=0; i<$scope.ticket.readingGrouplist.length; i++) {
                  for (var j=0; j<$scope.loginUser.groupList.length; j++) {
                    if ($scope.loginUser.groupList[j].groupId == $scope.ticket.readingGrouplist[i].groupId) {
                      $scope.isVisitor = true;
                      break outer2;
                    }
                  }
              }
          }

          $scope.notEditable = false;
          if ($scope.ticket.statusId == '03' || $scope.ticket.statusId == '04' || $scope.ticket.statusId == '05') {
            $scope.notEditable = true;
          }


          if (localStorage.mngKbn == '2') {
              $scope.isResponser = true;
              $scope.isRequester = true;
              $scope.isEditer = true;
          }

        };

        $scope.getCheckList = function(ticketId) {
            $scope.checkresultList = ajaxService.searchCheckResultList(ticketId);
            $scope.resultOkNum = 0;
            $scope.resultNgNum = 0;
            $scope.resultKeepNum = 0;
            $scope.resultOtherNum = 0;

            for (var i = 0; i < $scope.checkresultList.length; i++) {
              if ($scope.checkresultList[i].checkResult == "1") {
                $scope.resultOkNum++;
                $scope.checkresultList[i].checkResultName = "正常";
              } else if ($scope.checkresultList[i].checkResult == "2") {
                $scope.resultNgNum++;
                $scope.checkresultList[i].checkResultName = "異常";
              } else if ($scope.checkresultList[i].checkResult == "3") {
                $scope.resultKeepNum++;
                $scope.checkresultList[i].checkResultName = "保留";
              } else if ($scope.checkresultList[i].checkResult == "4") {
                $scope.resultOtherNum++;
                $scope.checkresultList[i].checkResultName = "対象外";
              }
            }
         };

       $scope.checkLimitOneList = function (checkdetailId, outerIndex, showMsg){
        var limitList = ajaxService.searchCheckLimitList(checkdetailId);

          if ($scope.errorStyle == null) {
             //背景色設定のため
                $scope.errorStyle = new Array();
          }

        var entered = $scope.result[outerIndex].value;
        if (entered !=0 && !entered) {
        	$scope.errorStyle[outerIndex] = "";
        	return;
        }
        var detailName = $scope.result[outerIndex].checkDetailName;
        var logic1 = limitList[0].logic;

        var condition1 = limitList[0].condition;
        var value1 = limitList[0].value;
        var conditionChar1 = null;
        var errorMsgChar　= "";

        var flag = false;

         if(condition1 == 1 ) {
           conditionChar1 = "<"
         }else if (condition1 == 2){
           conditionChar1 =  ">"
         }else if (condition1 == 3){
           conditionChar1 = "≦"
         }else if (condition1 == 4){
           conditionChar1 = "≧"
         }

            if(condition1 == 1){
                if(entered < value1){
                    flag = true;
                }
            }else if(condition1 == 2){
                 if(entered > value1){
                    flag = true;
                }
            }else if(condition1 == 3){
                 if(entered <= value1){
                    flag = true;
                }
            }else if(condition1 == 4){
               if(entered >= value1){
                    flag = true;
                }
            }

            if(!flag){
            //OK
            $scope.errorStyle[outerIndex] = "";

            }else{
            //NG
                if (showMsg) {
                        var errorMsgChar = "[ "+ detailName +" ] : 異常値が入力されました。異常値：[ x"+ conditionChar1 + value1 + " ]";
                   $rootScope.showErrorMessage5Sec(errorMsgChar);
                }
                 $scope.errorStyle[outerIndex] = "peachpuff";
            }

      }


        $scope.checkLimit = function (checkdetailId, outerIndex, showMsg) {

    	if ($scope.errorStyle == null) {
            //背景色設定のため
               $scope.errorStyle = new Array();
         }

        var entered = $scope.result[outerIndex].value;

        if (entered !=0 && !entered) {
        	$scope.errorStyle[outerIndex] = "";
        	return;
        }

        if (typeof(entered) == 'undefined') {
     	   $rootScope.showErrorMessage($scope.result[outerIndex].checkDetailName+"を正しく入力してください。");
     	   return;
        }

        var limitList = ajaxService.searchCheckLimitList(checkdetailId);

        if(limitList.length==0){
          //異常値が設定されていない場合
          return "";
        }

        if(limitList.length == 1){
          $scope.checkLimitOneList(checkdetailId, outerIndex, showMsg);
          return "";
        }


        var detailName = $scope.result[outerIndex].checkDetailName;
        var logic1 = limitList[0].logic;
        var logic2 = limitList[1].logic;

        var condition1 = limitList[0].condition;
        var condition2  =limitList[1].condition;
        var conditionArr = [condition1, condition2];

        var value1 = limitList[0].value;
        var value2 = limitList[1].value;
        var valueArr = [value1, value2];

        var conditionChar1 = null;
        var conditionChar2 = null;
        var errorMsgChar　= "";

        var flag = [false, false];

        if(condition1 == 1 ) {
            conditionChar1 = "<"
          }else if (condition1 == 2){
            conditionChar1 =  ">"
          }else if (condition1 == 3){
            conditionChar1 = "≦"
          }else if (condition1 == 4){
            conditionChar1 = "≧"
          }


         if(condition2 == 1 ) {
           conditionChar2 = "<"
         }else if (condition2 == 2){
           conditionChar2 =  ">"
         }else if (condition2 == 3){
           conditionChar2 = "≦"
         }else if (condition2 == 4){
           conditionChar2 = "≧"
         }

         for(var i =0;i<conditionArr.length;i++){
            if(conditionArr[i] == 1){
                if(entered < valueArr[i]){
                    flag[i] = true;
                }else{
                    flag[i] = false;
                }
            }else if(conditionArr[i] == 2){
                 if(entered > valueArr[i]){
                    flag[i] = true;
                }else{
                    flag[i] = false;
                }
            }else if(conditionArr[i] == 3){
                 if(entered <= valueArr[i]){
                    flag[i] = true;
                }else{
                    flag[i] = false;
                }
            }else if(conditionArr[i] == 4){
               if(entered >= valueArr[i]){
                    flag[i] = true;
                }else{
                    flag[i] = false;
                }
            }
          }

          if(logic1 == 2 || logic2 == 2){
          //AnDの時
            if(flag[0] == false && flag[1] == false){
            //OK
            $scope.errorStyle[outerIndex] = "";
            }else{
            //NG
                if (showMsg) {
                   if(value1 < value2){
                        var errorMsgChar = "[ "+ detailName +" ] : 異常値が入力されました。異常値：[ x"+ conditionChar2 + value2 + " または x "+ conditionChar1 + value1 + ' ] ';
                   }else {
                        var errorMsgChar = "[ "+ detailName +" ] : 異常値が入力されました。異常値：[ x"+ conditionChar2 + value2 + " または x "+ conditionChar1 + value1 + ' ] ';
                   }
                   $rootScope.showErrorMessage5Sec(errorMsgChar);
                }
                $scope.errorStyle[outerIndex] = "peachpuff";

            }
          }

         if( (logic1 == logic2) == 1 ){
         //ORの時
           if(flag[0] == false || flag[1] == false){
           //OK
            $scope.errorStyle[outerIndex] = "";
           }else {
           //NG
                if (showMsg) {
                   if(value1 < value2){
                        errorMsgChar = "[ "+ detailName +" ] : 異常値が入力されました。異常値：[ x"+ conditionChar2 + value2 + " かつ x "+ conditionChar1 + value1 + ' ] ';
                   }else {
                        errorMsgChar = "[ "+ detailName +" ] : 異常値が入力されました。異常値：[ x"+ conditionChar2 + value2 + " かつ x "+ conditionChar1 + value1 + ' ] ';
                   }
                   $rootScope.showErrorMessage5Sec(errorMsgChar);
                }
                $scope.errorStyle[outerIndex] = "peachpuff";
            }
          }
      }

         $scope.getResultInfoSp = function (ticketId, checkListId) {

           $scope.resultDetailList = ajaxService.searchResultDetailList(ticketId, checkListId);

           $scope.chBoxResult = [];
           $scope.result = new Array();
           $scope.userResource = new Array();
           for (var i=0; i<$scope.resultDetailList.length; i++) {
             var rdOb = $scope.resultDetailList[i];
             $scope.result[i] = new Object();
             $scope.result[i].id = rdOb.resultDetailId;
             $scope.result[i].value = rdOb.checkResult;
             if (i == 0 && ! rdOb.checkResult) {
                 $scope.result[i].value = "1";
               }
             $scope.result[i].inputTypeId = rdOb.inputTypeId;
             $scope.result[i].mustFlg = rdOb.mustFlg;
             $scope.result[i].checkDetailName = rdOb.checkDetailName;
             if (rdOb.inputTypeId == 2) {
               //日付
               if (rdOb.checkResult) {
                 $scope.result[i].id = rdOb.resultDetailId;
                 $scope.result[i].value = new Date(rdOb.checkResult);
               }
             } else if (rdOb.inputTypeId == 3) {
               //セレクトボックス
               $scope["userResource"+rdOb.resultDetailId] = ajaxService.searchUserResourceDetail(rdOb.userResourceId);
               $scope["userResource"+rdOb.resultDetailId].unshift({label:" ", value:null});
               if (rdOb.checkResult) {
                 for (var j=0; j< $scope["userResource"+rdOb.resultDetailId].length; j++) {
                   if (rdOb.checkResult == $scope["userResource"+rdOb.resultDetailId][j].value) {
                     $scope.result[i].id = rdOb.resultDetailId;
                     $scope.result[i].value = $scope["userResource"+rdOb.resultDetailId][j];
                   }
                 }
               } else {
                 $scope.result[i].id = rdOb.resultDetailId;
                 $scope.result[i].value = $scope["userResource"+rdOb.resultDetailId][0];
               }
             } else if (rdOb.inputTypeId == 4) {
               //ラジオボタン
               $scope.userResource[i] = ajaxService.searchUserResourceDetail(rdOb.userResourceId);
             } else if (rdOb.inputTypeId == 5) {
               //チェックボックス
               $scope.userResource[i] = ajaxService.searchUserResourceDetail(rdOb.userResourceId);
               var checkBoxResult = $scope.result[i].value;
               if (checkBoxResult) {
                  var rlist = checkBoxResult.split("、");
                  $scope.chBoxResult[i] = [];
                  for (var r=0; r< rlist.length;r++) {
                    $scope.chBoxResult[i].push(parseInt(rlist[r]));
                  }
               }
             } else if (rdOb.inputTypeId == 7) {
               //写真
               $scope.getImgList($scope.reportId, rdOb.resultDetailId);
             } else if (rdOb.inputTypeId == 8) {
               //音声
               $scope.getRadioList($scope.reportId, rdOb.resultDetailId);
             } else if (rdOb.inputTypeId == 9) {
               //動画
               $scope.getVideoList($scope.reportId, rdOb.resultDetailId);
             } else if (rdOb.inputTypeId == 10) {
               //手書き
                 $scope["signable"+rdOb.resultDetailId] = true;
                 $scope.getSign($scope.reportId, rdOb.resultDetailId);
             } else if (rdOb.inputTypeId == 11) {
              //360度カメラ
                 if (rdOb.checkResult) {
                   $scope["camera"+rdOb.resultDetailId] = true;
                   if (rdOb.checkResult.indexOf("/t/") != -1) {
                       $scope["cameraT"+rdOb.resultDetailId] = true;
                     } else {
                       $scope["cameraT"+rdOb.resultDetailId] = false;
                     }
                 } else {
                   $scope["camera"+rdOb.resultDetailId] = false;
                 }
             } else if (rdOb.inputTypeId == 12) {
           	  $scope.result[i].value = parseFloat(rdOb.checkResult);
              //モダール立ち上げる前の初期化
            $scope.checkLimit(rdOb.checkDetailId, i, false);
            } else if (rdOb.inputTypeId == 13) {
                 //ファイル
                 $scope.getResultFileList($scope.reportId, rdOb.resultDetailId);
             }
           }

           $scope.baseResult = angular.copy($scope.result);
         };

         $scope.getImgResultListSp = function (ticketId, checkListId) {

             $scope.resultDetailList = ajaxService.searchResultDetailList(ticketId, checkListId);

             for (var i=0; i<$scope.resultDetailList.length; i++) {
               var rdOb = $scope.resultDetailList[i];
               if (rdOb.inputTypeId == 7) {
                 //写真
                 $scope.getImgList($scope.reportId, rdOb.resultDetailId);
               }
             }

           };





         $scope.getImgList = function(ticketId, checkResultId) {
             $scope["imgbean"+checkResultId] = new Array();
             var imgBeanList = ajaxService.searchImgBeanList(checkResultId);
             for (var i=0; i<imgBeanList.length; i++) {
               var imgOb = new Object();
               imgOb.no = i+1;
               var imgId = imgBeanList[i].id;
               imgOb.fileId = imgId;
               imgOb.fileName = imgBeanList[i].fileName;
               imgOb.url = urlPrefix + "checkreport/getCheckResultFile/"+localStorage.schema+"/"+checkResultId+"/"+localStorage.authId+"/"+imgId+"/dl";
               $scope["imgbean"+checkResultId].push(imgOb);

               //fileidでコミット持ってくる
                var imgComment = ajaxService.getImgComment(imgOb.fileId);
                imgOb.imgComm = imgComment;
             }

           };

           $scope.getRadioList = function(ticketId, checkResultId) {
               $scope["imgList"+checkResultId] = new Array();
                 var radioBeanList = ajaxService.searchImgBeanList(checkResultId);
                 for (var i=0; i<radioBeanList.length; i++) {
                     var raduoOb = new Object();
                     raduoOb.id = radioBeanList[i].id;
                     raduoOb.fileName = radioBeanList[i].fileName;
                     raduoOb.url = urlPrefix + "checkreport/getCheckResultVideo/"+localStorage.schema+"/"+checkResultId+"/"+localStorage.authId+"/"+radioBeanList[i].id;
//                     raduoOb.url = urlPrefixFileVideo + radioBeanList[i].id +'.'+ raduoOb.fileName.split(".")[1];
                   $scope["imgList"+checkResultId].push(raduoOb);
                 }
             };

           $scope.getVideoList = function(ticketId, checkResultId) {
             $scope["imgList"+checkResultId] = new Array();
               var radioBeanList = ajaxService.searchImgBeanList(checkResultId);
               for (var i=0; i<radioBeanList.length; i++) {
                   var raduoOb = new Object();
                   raduoOb.id = radioBeanList[i].id;
                   raduoOb.fileName = radioBeanList[i].fileName;
                   raduoOb.url = urlPrefix + "checkreport/getCheckResultVideo/"+localStorage.schema+"/"+checkResultId+"/"+localStorage.authId+"/"+radioBeanList[i].id;
//                   raduoOb.url = urlPrefixFileVideo + radioBeanList[i].id +'.'+ raduoOb.fileName.split(".")[1];
                 $scope["imgList"+checkResultId].push(raduoOb);
               }
           };

           $scope.getSign = function(ticketId, checkResultId) {
               $scope["signFlg"+checkResultId] = true;
               $scope["sign"+checkResultId] = new Object();
                 var radioBeanList = ajaxService.searchImgBeanList(checkResultId);
                 if (radioBeanList.length != 0) {
                   //手書きあり
                   $scope["signable"+checkResultId] = false;
                   $scope["signId"+checkResultId] = radioBeanList[0].id;
                   $scope["signUrl"+checkResultId] = urlPrefix + "checkreport/getCheckResultFile/"+localStorage.schema+"/"+checkResultId+"/"+localStorage.authId+"/"+radioBeanList[0].id+"/null";
                 }
             };

             $scope.getResultFileList = function(ticketId, checkResultId) {
                 $scope["imgList"+checkResultId] = new Array();
                 var imgBeanList = ajaxService.searchImgBeanList(checkResultId);
           	  $scope["hasFile"+checkResultId] = false;
                 if (imgBeanList.length > 0) {
               	  $scope["hasFile"+checkResultId] = true;
                     $scope["imgList"+checkResultId] = imgBeanList;
                 }
               };


           $scope.dynamicImgArray = function(checkResultId){
               $("#slider"+checkResultId).flexslider({
                   slideshow: false,
                   startAt: 0
               });
               return $scope["imgbean"+checkResultId];
           };

           $scope.dynamicArray = function(checkResultId){
               return $scope["imgList"+checkResultId];
           };

           $scope.hasImgArrayList = function(checkResultId){
         	  if ($scope["imgbean"+checkResultId].length > 1){
         		  return true;
         	  }
               return false;
           }

           $scope.showSignPc = function(resultId) {
               $scope["signable"+resultId] = true;
               $scope["signFlg"+resultId] = false;
               if ($("#signature"+resultId).children().length == 0 ) {
                 $("#signature"+resultId).jSignature({height:"200",width:"300"});
               }
               $("#signature"+resultId).jSignature("enable");
                   $("#signOK"+resultId).css({
                     'display' : 'initial'
                   });
                   $("#signReset"+resultId).css({
                       'display' : 'initial'
                     });
               };

               $scope.resetSignPc = function(resultId) {
                 var $sigdiv = $("#signature"+resultId);
                 $sigdiv.jSignature("reset");
                 $("#image"+resultId+" img").remove();
               };

               $scope.saveSignPc = function(resultId) {
                 $("#image"+resultId+" img").remove();
                 var $sigdiv = $("#signature"+resultId);
                 var datapair = $sigdiv.jSignature("getData", "image");
                 var i = new Image();

                 i.src = "data:" + datapair[0] + "," + datapair[1];
                 var sampleArr = $rootScope.base64ToArrayBuffer(datapair[1]);
                 var blob = new Blob([ sampleArr ], {type: 'image/png'});
                 blob.name = resultId + ".png";
                 blob.lastModifiedDate = new Date();

                 Upload.upload({
                     url : urlPrefix + "checkreport/uploadCheckResultFile",
                     type : "POST",
                     headers : {
                         "authorization" : localStorage.authId,
                     },
                     dataType : "multipart/form-data",
                     data : {file: blob, 'userName':localStorage.userName, 'loginId':localStorage.userId, 'checkResultId': resultId, 'projectId': $rootScope.projectId, 'ticketId':$scope.reportId, 'typeKbn':'Sign', "schema" : localStorage.schema }
                 }).then(function(response) {
                	 if (response.data.resultCd != '000000') {
                  		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
                  		return ;
                  	 }
                     $rootScope.showInfoMessage("手書きを保存しました。");
                     $scope.getSign($scope.reportId, resultId);
                 }, function(response) {
                   $rootScope.showErrorMessage(tr.T(response.data.resultCd));
                 });
               };

               $scope.deleteSign = function(resultId) {
//                 if ($scope.isMustCheckResult(resultId) && ($scope.result[0].value == "1" || $scope.result[0].value == "2")) {
//                   $rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
//                   return ;
//                 }

                 if ($scope.isMustCheckResult(resultId)){
       			  if($scope.showResult == '1'){
       	            	$scope.result[0].value = "";
       	        	} else {
       	        		if ($scope.result[0].value == "1" || $scope.result[0].value == "2") {
           	        		$rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
           	                return ;
       	        		}
       	        	}
       		     }


                 var modalInstance = $uibModal.open({
                       animation : true,
                       templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                       controller : 'confirmDialogCtrl',
                       scope : $scope,
                       backdrop : "static",
                       resolve : {
                           message : function() {
                               return {
                                   message : "該当手書きを削除してもよろしいですか？"
                               };
                           }
                       }
                   });

                 modalInstance.result.then(function() {

                	 if ($scope.result[0].value == "") {
                   		$scope.saveResult(true);
                   	  }

                     ajaxService.removeFileCheckResult($scope["signId"+resultId]);
                     if (ajaxService.result['resultCd'] != "000000") {
                       $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                     } else {
                       $rootScope.showInfoMessage("該当手書きを削除しました。");
                       $scope["signable"+resultId] = true;
                       $scope.getSign($scope.reportId, resultId);
                       if ($("#signature"+resultId).children().length != 0 ) {
                         $("#signature"+resultId).jSignature("clear");
                         $("#signature"+resultId).jSignature("disable");
                       }
                     }
                   });
               };

               $scope.getSignUrl = function(checkResultId){
                   return $scope["signUrl"+checkResultId];
                 };


           $scope.deleteFile = function(fileId, resultId, type) {
        	   if (ajaxService.hasCheckResultFile(resultId) == 1) {
         		  if ($scope.isMustCheckResult(resultId)){
         			  if($scope.showResult == '1'){
         	            	$scope.result[0].value = "";
         	        	} else {
         	        		if ($scope.result[0].value == "1" || $scope.result[0].value == "2") {
             	        		$rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
             	                return ;
         	        		}
         	        	}
         		  }
         	  }
//        	   if ($scope.isMustCheckResult(resultId) && ($scope.result[0].value == "1" || $scope.result[0].value == "2")) {
//                if (ajaxService.hasCheckResultFile(resultId) == 1) {
//                  //最後のファイルを削除時、必須項目なら、削除不可
//                  $rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
//                  return ;
//                }
//              }


             var modalInstance = $uibModal.open({
                 animation : true,
                 templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                 controller : 'confirmDialogCtrl',
                 scope : $scope,
                 backdrop : "static",
                 resolve : {
                     message : function() {
                         return {
                             message : "該当ファイルを削除してもよろしいですか？"
                         };
                     }
                 }
             });
             modalInstance.result.then(function() {
            	 if ($scope.result[0].value == "") {
             		$scope.saveResult(true);
             	}

               ajaxService.removeFileCheckResult(fileId);
               if (ajaxService.result['resultCd'] != "000000") {
                 $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
               } else {
                 $rootScope.showInfoMessage("該当ファイルを削除しました。");
                 if (type == "Image") {
                   $scope.getImgResultListSp ($scope.reportId, $scope.checkListOb.checklistId);
                   $("body,html").animate({
                       scrollTop : $("#slider"+resultId).offset().top -100
                   }, 1000);
                 } else if (type == "Radio") {
                     $scope.getRadioList($scope.reportId, resultId);
                 } else if (type == "Video") {
                     $scope.getVideoList($scope.reportId, resultId);
                 } else if (type == "File") {
                     $scope.getResultFileList($scope.reportId, resultId);
                 }

               }
             });
           };



         $scope.getCheckreportDetailSp = function(id , isInit) {

           if (! isInit) {
             if ($scope.checkResultIsChange()) {
               if (! $scope.saveResult(false)){
                 return ;
               }
             }
           }

             $scope.getCheckList($scope.reportId);
             $scope.complete = ($scope.resultOkNum + $scope.resultNgNum + $scope.resultOtherNum ) / $scope.checkresultList.length * 100;
             $scope.detailId = id;
             $scope.checkListOb = $scope.checkresultList[$scope.detailId - 1];

             $scope.checkListSize = $scope.checkresultList.length;

             if ($scope.detailId == $scope.checkListSize) {
               $scope.nextDetailId = 1;
               $scope.nextCheckListOb = $scope.checkresultList[$scope.nextDetailId - 1];
             } else {
               $scope.nextDetailId = $scope.detailId + 1;
               $scope.nextCheckListOb = $scope.checkresultList[$scope.nextDetailId - 1];
             }
             if ($scope.detailId == 1) {
               $scope.prefDetailId = $scope.checkListSize;
               $scope.prefCheckListOb = $scope.checkresultList[$scope.checkListSize-1];
             } else {
               $scope.prefDetailId =  $scope.detailId - 1;
               $scope.prefCheckListOb = $scope.checkresultList[$scope.prefDetailId - 1];
             }

             var content = $scope.checkListOb.checklistContent;
             if (content) {
               var urlStartIndex = content.indexOf("[[");
               var urlEndIndex = content.indexOf("]]");
               if (urlStartIndex != -1 && urlEndIndex != -1) {
                 var urlStr = content.substring(urlStartIndex, urlEndIndex + 2);
                 var link = content.substring(urlStartIndex + 2, urlEndIndex);
                 var url = "<a href = '"+ link +"' target = '_blank'>"+link+"</a>";
                 $scope.checkListOb.checklistContent = content.replace(urlStr, url);
               }
             }

             $scope.getResultInfoSp ($scope.reportId, $scope.checkListOb.checklistId);

         };

         $scope.showCheckreportDetailSpWindow = function(reportId) {
            var url = window.location.href;
            var u = url.split("#")[0];
            window.open(u + "#/showReportDetailSp?id=" + reportId );
         };


        $scope.showCheckreportDetailSp = function(checkreportId) {

            $scope.reportId = checkreportId;
            $scope.getTicketInfo($scope.reportId);
            $scope.getCheckreportDetailSp(1, true);

            $("#checkreportDetailSp").css({
              'display' : 'block'
            });
            $("#checkreportCreaterSp").css({
                'display' : 'none'
            });
            $("body,html").animate({
                scrollTop : $("#checkreportDetailSp").offset().top - 100
            }, 1000);
          };

          $scope.saveResult = function(isLoadDetail) {

        	  if($scope.showResult == '1'){
        		  if ($scope.result[0].value != '') {
        			//最終確認非表示,デフォルト正常
            		  $scope.result[0].value = "1";
        		  }
        	  } else {
        		  if (! $scope.result[0].value) {
    	            $rootScope.showErrorMessage("最終確認を選択してください。");
    	            return false;
    	          }
        	  }

              if ($scope.result[0].value == "1" || $scope.result[0].value == "2" ) {
                //必須チェック　後回し
                outer : for (var i=1; i<$scope.result.length; i++) {
                    if ($scope.result[i].mustFlg == "1") {
                      if ($scope.result[i].inputTypeId != 7 && $scope.result[i].inputTypeId != 8 && $scope.result[i].inputTypeId != 9 && $scope.result[i].inputTypeId != 10 && $scope.result[i].inputTypeId != 13) {
                        if ($scope.result[i].inputTypeId == 5 ) {
                              if ($scope.chBoxResult[i]) {
                                for (var k = 0; k < $scope.userResource[i].length; k++){
                                  if ($scope.chBoxResult[i][k]) {
                                    if ($scope.chBoxResult[i][k] != 0) {
                                      continue outer;
                                    }
                                  }
                                }
                                $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を入力してください。");
                                return false;
                              } else {
                                $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を入力してください。");
                                  return false;
                              }
                          } else if ($scope.result[i].inputTypeId == 12) {
                              if (! $scope.result[i].value) {
                            	  if ($scope.result[i].value != 0) {
                                      $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を正しく入力してください。");
                                      return false;
                            	  } else {
                            		  $scope.result[i].value = "0";
                            	  }
                              }
                            } else if ($scope.result[i].inputTypeId == 3) {
                                if (! $scope.result[i].value.value) {
                                    $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を選択してください。");
                                    return false;
                                }
                            }  else {
                            if (! $scope.result[i].value) {
                                  $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を入力してください。");
                                  return false;
                            }
                          }
                      } else {
                        if (ajaxService.hasCheckResultFile($scope.result[i].id) == 0) {
                          // FILE無し
                          $rootScope.showErrorMessage($scope.result[i].checkDetailName+"をアップロードしてください。");
                          return false;
                        }
                      }
                    }
                  }
              }

              var imgCommentList = [];

              for (var i=0; i<$scope.result.length; i++) {

                  if ($scope.result[i].inputTypeId == 2) {
                      var v = $rootScope.formatDate($scope.result[i].value, "YYYY/MM/DD");
                      $scope.result[i].checkResult = v;
                  } else if ($scope.result[i].inputTypeId == 3) {
                      if ($scope.result[i].value) {
                        $scope.result[i].checkResult = $scope.result[i].value.value;
                      }
                  } else if ($scope.result[i].inputTypeId == 5) {
                    if ($scope.chBoxResult[i]) {
                        var result = "";
                        for (var k = 0; k < $scope.userResource[i].length; k++){
                          if ($scope.chBoxResult[i][k]) {
                              if (result == "") {
                                result = $scope.chBoxResult[i][k]+"";
                              } else {
                                result = result + "、" + $scope.chBoxResult[i][k];
                              }
                          } else {
                            if (result == "") {
                              result = "0";
                            } else {
                              result = result + "、0";
                            }
                          }
                        }
                        $scope.result[i].checkResult = result;
                      } else {
                        $scope.result[i].checkResult = "";
                      }
                  } else if ($scope.result[i].inputTypeId == 12) {
                	  if (typeof($scope.result[i].value) == 'undefined') {
                          $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を正しく入力してください。");
                    	  return false;
                      }
                  	  if ($scope.result[i].value == 0) {
                  		  $scope.result[i].checkResult = "0";
                  	  } else {
                  		$scope.result[i].checkResult = $scope.result[i].value;
                  	  }
                  } else {
                    if ($scope.result[i].inputTypeId == 7 ) {
                      var imglist = $scope["imgbean"+$scope.result[i].id];
                      for (var j = 0; j < imglist.length; j++) {
                      var imgItem = imglist[j];
                      var imgCommOb = new Object();
                      imgCommOb.fileId = imgItem.fileId;
                      imgCommOb.imgComm = imgItem.imgComm;
                      imgCommentList.push(imgCommOb);
                     }
                  }

                   if ($scope.result[i].value) {
                     $scope.result[i].checkResult = $scope.result[i].value;
                   }
                }
              }

              var getImgList = [];
              getImgList =  ajaxService.modifyImgComment(imgCommentList);

              ajaxService.modifyCheckResult($rootScope.projectId, $scope.reportId, $scope.result, $scope.lat, $scope.lgt);
              if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                  return false;
                } else {
                  $rootScope.showInfoMessage("保存しました。");
                  if (isLoadDetail) {
                    $scope.getCheckreportDetailSp($scope.detailId, true);
                  }
                  $scope.getTicketInfo($scope.reportId);
                  return true;
                }
            };

            //一時保存
            $scope.temSaveResult = function(isLoadDetail) {

                //結果を保留にする
            	$scope.result[0].value = "3";


                var imgCommentList = [];

                for (var i=0; i<$scope.result.length; i++) {

                    if ($scope.result[i].inputTypeId == 2) {
                        var v = $rootScope.formatDate($scope.result[i].value, "YYYY/MM/DD");
                        $scope.result[i].checkResult = v;
                    } else if ($scope.result[i].inputTypeId == 3) {
                        if ($scope.result[i].value) {
                          $scope.result[i].checkResult = $scope.result[i].value.value;
                        }
                    } else if ($scope.result[i].inputTypeId == 5) {
                      if ($scope.chBoxResult[i]) {
                          var result = "";
                          for (var k = 0; k < $scope.userResource[i].length; k++){
                            if ($scope.chBoxResult[i][k]) {
                                if (result == "") {
                                  result = $scope.chBoxResult[i][k]+"";
                                } else {
                                  result = result + "、" + $scope.chBoxResult[i][k];
                                }
                            } else {
                              if (result == "") {
                                result = "0";
                              } else {
                                result = result + "、0";
                              }
                            }
                          }
                          $scope.result[i].checkResult = result;
                        } else {
                          $scope.result[i].checkResult = "";
                        }
                    } else if ($scope.result[i].inputTypeId == 12) {
                    	if (typeof($scope.result[i].value) == 'undefined') {
                            $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を正しく入力してください。");
                      	  return false;
                        }
                    	  if ($scope.result[i].value == 0) {
                    		  $scope.result[i].checkResult = "0";
                    	  } else {
                    		$scope.result[i].checkResult = $scope.result[i].value;
                    	  }
                    } else {
                      if ($scope.result[i].inputTypeId == 7 ) {
                        var imglist = $scope["imgbean"+$scope.result[i].id];
                        for (var j = 0; j < imglist.length; j++) {
                        var imgItem = imglist[j];
                        var imgCommOb = new Object();
                        imgCommOb.fileId = imgItem.fileId;
                        imgCommOb.imgComm = imgItem.imgComm;
                        imgCommentList.push(imgCommOb);
                      }
                    }

                      if ($scope.result[i].value) {
                        $scope.result[i].checkResult = $scope.result[i].value;
                      }
                    }
                }

                var getImgList = [];
                getImgList =  ajaxService.modifyImgComment(imgCommentList);

                ajaxService.modifyCheckResult($rootScope.projectId, $scope.reportId, $scope.result, $scope.lat, $scope.lgt);
                if (ajaxService.result['resultCd'] != "000000") {
                    $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                    return false;
                  } else {
                    $rootScope.showInfoMessage("一時保存しました。");
                    if (isLoadDetail) {
                      $scope.getCheckreportDetailSp($scope.detailId, true);
                    }
                    $scope.getTicketInfo($scope.reportId);
                    return true;
                  }
              };

            $scope.delete360Camera = function(resultId) {
            	if ($scope.isMustCheckResult(resultId)){
      			  if($scope.showResult == '1'){
      	            	$scope.result[0].value = "";
      	        	} else {
      	        		if ($scope.result[0].value == "1" || $scope.result[0].value == "2") {
          	        		$rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
          	                return ;
      	        		}
      	        	}
      		  }

              var resultList = [];
                resultList.push({"id":resultId, "checkResult":""});
                if ($scope.result[0].value == "") {
                	resultList.push({"id":$scope.result[0].id, "checkResult":""});
                }

                ajaxService.modifyCheckResult($rootScope.projectId, $scope.reportId, resultList);
                $rootScope.showInfoMessage("削除しました。");
                $scope.getCheckreportDetailSp($scope.detailId, true);
            };


          $scope.openUploadImg = function(resultId) {
              $uibModal.open({
                  animation : true,
                  templateUrl : 'app/pages/checklist/fileUploadModal.html',
                  controller : 'FileUploadCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      openFlag : function() {
                          return {
                              'flag' : 'New',
                              'kbn' : 'CheckResult',
                              'id': resultId,
                              'ticketId': $scope.reportId,
                              'typeKbn': "Image",
                              'checklistId': $scope.checkListOb.checklistId
                          };
                      }
                  }
              });
          };

          $scope.openUploadRadio = function(resultId) {
              $uibModal.open({
                  animation : true,
                  templateUrl : 'app/pages/checklist/fileUploadModal.html',
                  controller : 'FileUploadCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      openFlag : function() {
                          return {
                              'flag' : 'New',
                              'kbn' : 'CheckResult',
                              'id': resultId,
                              'ticketId': $scope.reportId,
                              'typeKbn': "Radio"
                          };
                      }
                  }
              });
          };

          $scope.openUploadVideo = function(resultId) {
              $uibModal.open({
                  animation : true,
                  templateUrl : 'app/pages/checklist/fileUploadModal.html',
                  controller : 'FileUploadCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      openFlag : function() {
                          return {
                              'flag' : 'New',
                              'kbn' : 'CheckResult',
                              'id': resultId,
                              'ticketId': $scope.reportId,
                              'typeKbn': "Video"
                          };
                      }
                  }
              });
          };

          $scope.openUploadFile = function(resultId) {
              $uibModal.open({
                  animation : true,
                  templateUrl : 'app/pages/checklist/fileUploadModal.html',
                  controller : 'FileUploadCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      openFlag : function() {
                          return {
                              'flag' : 'New',
                              'kbn' : 'CheckResult',
                              'id': resultId,
                              'ticketId': $scope.reportId,
                              'typeKbn': "File"
                          };
                      }
                  }
              });
          };


          $scope.showCheckListSp = function() {
            $uibModal.open({
              animation: true,
              templateUrl: "app/pages/checkreport/sp/checkreportResultListSp.html",
              scope : $scope,
              backdrop : "static",
              resolve: {
                  openFlag: function () {
                      return {};
                }
              }
            });
            $scope.checkListFileList = ajaxService.getFileList($scope.ticket.checksheetId);
          };
          $scope.showHistorySp = function() {

            $uibModal.open({
              animation: true,
              templateUrl: "app/pages/checkreport/sp/checkreportHistorySp.html",
              scope : $scope,
              backdrop : "static",
              resolve: {
                  openFlag: function () {
                      return {};
                }
              }
            });

            $scope.getCommentList($scope.reportId);

          };

          $scope.getCommentList = function(ticketId) {
              $scope.statusHistoryList = ajaxService.searchCommentList($rootScope.projectId, ticketId);
          };

          $scope.showTargetInfoSp = function() {
            $uibModal.open({
              animation: true,
              templateUrl: "app/pages/checkreport/sp/checkreportTargetInfoSp.html",
              scope : $scope,
              backdrop : "static",
              resolve: {
                  openFlag: function () {
                      return {};
                }
              }
            });

            // 工事検索
            $scope.itemNameList = ajaxService.getTargetItemList($rootScope.projectId);
            $scope.selectedTarget = ajaxService.searchTarget($scope.ticket.targetId);
            $scope.selectedTar = {};
            $scope.selectedTar.pref = $rootScope.getPrefOb($scope.selectedTarget.prefCd);
            $scope.selectedTar.reg = $rootScope.getRegionOb($scope.selectedTarget.region);

            $scope.targetFileList = ajaxService.getFileListTarget($scope.ticket.targetId);

          };

          $scope.getSubTicketList = function(ticketId) {
              $scope.subTicketList = ajaxService.getSubTicketList($rootScope.projectId, ticketId);
            };

          $scope.showTicketInfoSp = function() {

            $scope.$modalTicket = $uibModal.open({
                  animation: true,
                  templateUrl: "app/pages/checkreport/sp/checkreportTicketInfoSp.html",
                  scope : $scope,
                  backdrop : "static",
                  resolve: {
                      openFlag: function () {
                          return {};
                    }
                  }
                });

            $scope.getSubTicketList($scope.reportId);
          };

          $scope.modifyTicketSp = function() {

        	  if ($scope.mustStatusDetail && $scope.statusDetailOb.id == null) {
              	 $rootScope.showErrorMessage($scope.statusDetailItemName + "を選択してください。");
                   return "";
               }
               if ($scope.mustKbn2 && $scope.kbn2Ob.id == null) {
              	 $rootScope.showErrorMessage($scope.kbn2ItemName + "を選択してください。");
                   return "";
               }
               if ($scope.mustKbn3 && $scope.kbn3Ob.id == null) {
              	 $rootScope.showErrorMessage($scope.kbn3ItemName + "を選択してください。");
                   return "";
               }
               if ($scope.mustKbn4 && $scope.kbn4Ob.id == null) {
              	 $rootScope.showErrorMessage($scope.kbn4ItemName + "を選択してください。");
                   return "";
               }
               if ($scope.mustKbn5 && $scope.kbn5Ob.id == null) {
              	 $rootScope.showErrorMessage($scope.kbn5ItemName + "を選択してください。");
                   return "";
               }
               if ($scope.mustItem1 && ! $scope.item1) {
              	 $rootScope.showErrorMessage($scope.item1ItemName + "を入力してください。");
                   return "";
               }
               if ($scope.mustItem2 && ! $scope.item2) {
              	 $rootScope.showErrorMessage($scope.item2ItemName + "を入力してください。");
                   return "";
               }
               if ($scope.mustItem3 && ! $scope.item3) {
              	 $rootScope.showErrorMessage($scope.item3ItemName + "を入力してください。");
                   return "";
               }
               if ($scope.mustItem4 && ! $scope.item4) {
              	 $rootScope.showErrorMessage($scope.item4ItemName + "を入力してください。");
                   return "";
               }
               if ($scope.mustItem5 && ! $scope.item5) {
              	 $rootScope.showErrorMessage($scope.item5ItemName + "を入力してください。");
                   return "";
               }

        	  if ((!$scope.requestUser.userId || $scope.requestUser.userId == "") && (!$scope.requestGroup.groupId || $scope.requestGroup.groupId == "")) {
                  $rootScope.showErrorMessage("管理技術者または指示グループを選択してください。");
                  return "";
              }

            if (($scope.complete != 100) && ($scope.statusOb.value == '03' || $scope.statusOb.value == '04' || $scope.statusOb.value == '05')) {
              $rootScope.showErrorMessage("未完了のチェック項目があるため、ステータスの更新ができません。");
              return "";
            }

/*
            if (localStorage.mngKbn == '0' && ($scope.statusOb.value == '99' || $scope.statusOb.value == '04' || $scope.statusOb.value == '05')) {
              $rootScope.showErrorMessage($scope.statusOb.label + "を指定する権限がありません。");
                return "";
            }

            if (localStorage.mngKbn == '1' && $scope.statusOb.value == '05') {
              $rootScope.showErrorMessage($scope.statusOb.label + "を指定する権限がありません。");
                return "";
            }
            if ($scope.statusOb.value == '99' || $scope.statusOb.value == '04' || $scope.statusOb.value == '05') {
                if (localStorage.userId != $scope.ticket.requestUserId) {
                  var isRequestGroupUser = false
                  for (var j=0; j<$scope.loginUser.groupList.length; j++) {
                    if ($scope.loginUser.groupList[j].groupId == $scope.ticket.requestGroupId) {
                      isRequestGroupUser = true;
                      break;
                    }
                  }
                  if (! isRequestGroupUser) {
                    $rootScope.showErrorMessage($scope.statusOb.label + "を指定する権限がありません。");
                      return "";
                  }
                }
              }
*/
            $scope.ticket.statusId = $scope.statusOb.value;
            if ($scope.firstItem) {
              $scope.ticket.firstItemId = $scope.firstItem.id;
            }

            if ($scope.secondItem) {
                $scope.ticket.secondItemId = $scope.secondItem.id;
            }

            if ($scope.thirdItem) {
                $scope.ticket.thirdItemId = $scope.thirdItem.id;
            }
              $scope.ticket.startScheduledDate = $rootScope.formatDate($scope.startScheduledDate, "YYYY/MM/DD");
              $scope.ticket.endScheduledDate = $rootScope.formatDate($scope.endScheduledDate, "YYYY/MM/DD");
              $scope.ticket.startDate = $rootScope.formatDate($scope.startDate, "YYYY/MM/DD");
              $scope.ticket.endDate = $rootScope.formatDate($scope.endDate, "YYYY/MM/DD");
              if ($scope.requestUser) {
                $scope.ticket.requestUserId = $scope.requestUser.userId;
                $scope.ticket.requestUserName = $scope.requestUser.userName;
              }
              if ($scope.responseGroup) {
                $scope.ticket.responseGroupId = $scope.responseGroup.groupId;
                $scope.ticket.responseGroupName = $scope.responseGroup.groupName;
              }
              if ($scope.responseUser) {
                $scope.ticket.responseUserId = $scope.responseUser.userId;
                $scope.ticket.responseUserName = $scope.responseUser.userName;
              }
              if ($scope.requestGroup) {
                $scope.ticket.requestGroupId = $scope.requestGroup.groupId;
                $scope.ticket.requestGroupName = $scope.requestGroup.groupName;
              }

              if ($scope.showStatusDetail) {
            	  $scope.ticket.statusDetailId = $scope.statusDetailOb.id;
              }
              if ($scope.showKbn2) {
              	$scope.ticket.kbn2Id = $scope.kbn2Ob.id;
              	$scope.ticket.kbn2 = $scope.kbn2Ob.label;
              }
              if ($scope.showKbn3) {
              	$scope.ticket.kbn3Id = $scope.kbn3Ob.id;
              	$scope.ticket.kbn3 = $scope.kbn3Ob.label;
              }
              if ($scope.showKbn4) {
              	$scope.ticket.kbn4Id = $scope.kbn4Ob.id;
              	$scope.ticket.kbn4 = $scope.kbn4Ob.label;
              }
              if ($scope.showKbn5) {
              	$scope.ticket.kbn5Id = $scope.kbn5Ob.id;
              	$scope.ticket.kbn5 = $scope.kbn5Ob.label;
              }
              if ($scope.showItem1) {
              	$scope.ticket.item1 = $scope.item1;
              }
              if ($scope.showItem2) {
              	$scope.ticket.item2 = $scope.item2;
              }
              if ($scope.showItem3) {
              	$scope.ticket.item3 = $scope.item3;
              }
              if ($scope.showItem4) {
              	$scope.ticket.item4 = $scope.item4;
              }
              if ($scope.showItem5) {
              	$scope.ticket.item5 = $scope.item5;
              }

//              var responseGroupIdlist = [];
//              for (var i =0; i< $scope.responseGroups.selected.length; i++) {
//                responseGroupIdlist.push($scope.responseGroups.selected[i].groupId);
//              }
              var readingGroupIdlist = [];
              for (var i =0; i< $scope.readingGroups.selected.length; i++) {
            	  if ($rootScope.listContains(readingGroupIdlist, $scope.readingGroups.selected[i].groupId) || $scope.readingGroups.selected[i].groupId == null){
               		 continue;
               	 }
                readingGroupIdlist.push($scope.readingGroups.selected[i].groupId);
              }

//              $scope.ticket.responseGroupIdlist = responseGroupIdlist;
              $scope.ticket.readingGroupIdlist = readingGroupIdlist;

              ajaxService.modifyTicket($scope.ticket, $rootScope.projectId);
              if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
               } else {
                  $rootScope.showInfoMessage("チェックシートを更新しました。");
                  $scope.getTicketInfo($scope.ticket.id);
                  $scope.$$childTail.$dismiss();
               }
          };

          $scope.CheckreportDeleteSp = function() {
            var modalInstance = $uibModal.open({
                  animation : true,
                  templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                  controller : 'confirmDialogCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                              message : "チェックシートを削除してもよろしいですか？"
                          };
                      }
                  }
              });
            modalInstance.result.then(function() {
                ajaxService.removeTicket($rootScope.projectId, $scope.reportId);
                if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                } else {
                  $rootScope.showInfoMessage("チェックシートを削除しました。");
                  $timeout(function() {
                      window.close()
                    }, 1000);
                }
              });
          };

          $scope.modifyStatus = function(statusId) {

              if (statusId == '04') {
                $scope.subTicketList = ajaxService.getSubTicketList($rootScope.projectId, $scope.ticket.id);
                  for (var i=0; i<$scope.subTicketList.length; i++) {
                    var subTicket = $scope.subTicketList[i];
                    if (subTicket.statusId == '01' || subTicket.statusId == '02' || subTicket.statusId == '99' || subTicket.statusId == '03') {
                      $rootScope.showErrorMessage("未承認のサブチェックシートがあるため、承認ができません。");
                      return "";
                    }
                  }

              } else if (statusId == '05') {
                $scope.subTicketList = ajaxService.getSubTicketList($rootScope.projectId, $scope.ticket.id);
                  for (var i=0; i<$scope.subTicketList.length; i++) {
                    var subTicket = $scope.subTicketList[i];
                    if (subTicket.statusId == '01' || subTicket.statusId == '02' || subTicket.statusId == '99' || subTicket.statusId == '04' || subTicket.statusId == '03') {
                      $rootScope.showErrorMessage("未最終承認のサブチェックシートがあるため、最終承認ができません。");
                      return "";
                    }
                  }
              } else if (statusId == '99') {
                //差戻し
                if ($scope.ticket.parentId && $scope.ticket.parentId != 0) {
                  var parent = ajaxService.searchTicketInfo($rootScope.projectId, $scope.ticket.parentId);
                    while (parent && (parent.statusId == '03' || parent.statusId == '04' || parent.statusId == '05')) {
                      parent.statusId = '99';
                      ajaxService.modifyTicket(parent, $rootScope.projectId);
                      if (parent.parentId && parent.parentId != 0) {
                          parent = ajaxService.searchTicketInfo($rootScope.projectId, parent.parentId);
                      } else {
                          break;
                      }
                    }
                }
              }

                $scope.ticket.statusId = statusId;

                var readingGroupIdlist = [];
                for (var i =0; i< $scope.ticket.readingGrouplist.length; i++) {
                  readingGroupIdlist.push($scope.ticket.readingGrouplist[i].groupId);
                }
                $scope.ticket.readingGroupIdlist = readingGroupIdlist;

                ajaxService.modifyTicket($scope.ticket, $rootScope.projectId);
                if (ajaxService.result['resultCd'] != "000000") {
                    $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                 } else {
                    $rootScope.showInfoMessage("更新しました。");
                    $scope.getTicketInfo($scope.ticket.id);
                 }
              };


          $scope.reportComp = function() {

          //サブチェックシートのステータスを確認
            $scope.subTicketList = ajaxService.getSubTicketList($rootScope.projectId, $scope.ticket.id);

            for (var i=0; i<$scope.subTicketList.length; i++) {
              var subTicket = $scope.subTicketList[i];
              if (subTicket.statusId == '01' || subTicket.statusId == '02' || subTicket.statusId == '99') {
                $rootScope.showErrorMessage("未完了のサブチェックシートがあるため、チェック完了ができません。");
                return "";
              }
            }


            var sandMailFlg = 1;
            if ($scope.commentWithMail != '1') {
            	sandMailFlg = 0;
            }

            var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "チェックを完了してもよろしいですか？",
                            flg : sandMailFlg
                        };

                    }

                }
            });

            modalInstance.result.then(function() {
            	//チェック完了
                $scope.ticket.statusId = "03";

                var readingGroupIdlist = [];
                for (var i =0; i< $scope.readingGroups.selected.length; i++) {
              	  if ($rootScope.listContains(readingGroupIdlist, $scope.readingGroups.selected[i].groupId) || $scope.readingGroups.selected[i].groupId == null){
                 		 continue;
                 	 }
                  readingGroupIdlist.push($scope.readingGroups.selected[i].groupId);
                }

                $scope.ticket.readingGroupIdlist = readingGroupIdlist;

              //報告書メールのフラグ
                if ($scope.commentWithMail != '1') {
              	  $scope.ticket.sendReportFlag = false;
                } else {
                	var sendReportFlag = document.sendReportFlag.reportSend;
                    $scope.ticket.sendReportFlag = sendReportFlag.checked;
                }

                ajaxService.modifyTicket($scope.ticket, $rootScope.projectId);
                if (ajaxService.result['resultCd'] != "000000") {
                    $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                 } else {
                    $rootScope.showInfoMessage("更新しました。");
                    $scope.getTicketInfo($scope.ticket.id);
                 }

              });


          };

          $scope.reportReturn = function() {

        	  var modalInstance = $uibModal.open({
                  animation : true,
                  templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                  controller : 'confirmDialogCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                              message : "チェックを引戻してもよろしいですか？"
                          };
                      }
                  }
              });

        	  modalInstance.result.then(function() {

        		//チェック中
                  $scope.ticket.statusId = "02";

                  var readingGroupIdlist = [];
                  for (var i =0; i< $scope.readingGroups.selected.length; i++) {
                	  if ($rootScope.listContains(readingGroupIdlist, $scope.readingGroups.selected[i].groupId) || $scope.readingGroups.selected[i].groupId == null){
                   		 continue;
                   	 }
                    readingGroupIdlist.push($scope.readingGroups.selected[i].groupId);
                  }
                  $scope.ticket.readingGroupIdlist = readingGroupIdlist;

                  ajaxService.modifyTicket($scope.ticket, $rootScope.projectId);

                  if ($scope.ticket.parentId && $scope.ticket.parentId != 0) {
                      var parent = ajaxService.searchTicketInfo($rootScope.projectId, $scope.ticket.parentId);
                        while (parent && parent.statusId == '03') {
                          parent.statusId = '02';
                          ajaxService.modifyTicket(parent, $rootScope.projectId);
                          if (parent.parentId && parent.parentId != 0) {
                              parent = ajaxService.searchTicketInfo($rootScope.projectId, parent.parentId);
                          } else {
                              break;
                          }
                        }
                    }

                  if (ajaxService.result['resultCd'] != "000000") {
                      $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                   } else {
                      $rootScope.showInfoMessage("更新しました。");
                      $scope.getTicketInfo($scope.ticket.id);
                   }

                });


            };

            $scope.showTicketEditor = function () {
            	$("#ticketEditor").css({
                    'display' : 'block'
                  });
            	$("#ticketEditorFooter").css({
                    'display' : 'block'
                  });
                  $("#ticketShow").css({
                      'display' : 'none'
                  });
                  $("#ticketShowFooter").css({
                      'display' : 'none'
                  });
            };

            $scope.showUserInfo  = function(userId) {

                $scope.userInfo = ajaxService.searchUser($rootScope.projectId, userId);

                if ($scope.userInfo == null) {
              	  $rootScope.showErrorMessage("該当技術者が業務から外されたため、技術者情報が参照できません。");
              	  return;
                }

                $uibModal.open({
                  animation: true,
                  templateUrl: "app/pages/checkreport/sp/userInfoSp.html",
                  scope : $scope,
                  backdrop : "static",
                  resolve: {
                      openFlag: function () {
                          return {};
                    }
                  }
                });

              };

          //CKEditor
//            $scope.options = {
//              language: 'ja',
//              extraPlugins: 'colorbutton',
//              allowedContent: true,
//              entities: false
//            }
//            $scope.onReady = function () {
//            };

            $scope.saveComment = function () {
                var content = $scope.$$childTail.accordion.groups[0].$$childTail.content;
                if (! content) {
                  $rootScope.showErrorMessage("コメントを入力してください。");
                  return;
                }

                var modalInstance = $uibModal.open({
                    animation : true,
                    templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                    controller : 'confirmDialogCtrl',
                    scope : $scope,
                    backdrop : "static",
                    resolve : {
                        message : function() {
                            return {
                                message : "コメントを登録してもよろしいですか？"
                            };
                        }
                    }
                });

                modalInstance.result.then(function() {
                    var url = window.location.href;
                	ajaxService.saveComment($scope.reportId, $scope.ticket.statusId, content, $rootScope.projectId, url);
                    if (ajaxService.result['resultCd'] != "000000") {
                        $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                      } else {
                        $rootScope.showInfoMessage("コメントを保存しました。");
                        $scope.getCommentList($scope.reportId);
                        $scope.$$childTail.$$prevSibling.accordion.groups[0].$$childTail.content = "";
                      }

                });
              };

            $scope.deleteComment = function (id) {
                var modalInstance = $uibModal.open({
                      animation : true,
                      templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                      controller : 'confirmDialogCtrl',
                      scope : $scope,
                      backdrop : "static",
                      resolve : {
                          message : function() {
                              return {
                                  message : "該当コメントを削除してもよろしいですか？"
                              };
                          }
                      }
                  });
                  modalInstance.result.then(function() {
                    ajaxService.removeComment(id);
                    if (ajaxService.result['resultCd'] != "000000") {
                      $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                    } else {
                      $rootScope.showInfoMessage("該当コメントを削除しました。");
                      $scope.getCommentList($scope.reportId);
                    }
                  });
              };

              $scope.checkResultIsChange = function () {

                  for (var i=0; i<$scope.result.length; i++) {

                    if ($scope.result[i].inputTypeId == 2) {
                      if ($rootScope.formatDate($scope.result[i].value, "YYYY/MM/DD") != $rootScope.formatDate($scope.baseResult[i].value, "YYYY/MM/DD")){
                        return true;
                      }
                    } else if ($scope.result[i].inputTypeId == 3) {
                      if ($scope.result[i].value.value != $scope.baseResult[i].value.value){
                            return true;
                          }
                    } else {
                      if ($scope.result[i].value != $scope.baseResult[i].value) {
                              return true;
                            }
                    }

                  }
                  return false;
                };

                $scope.isMustCheckResult = function (checkReusltId) {
                    for (var i=1; i<$scope.result.length; i++) {
                      if ($scope.result[i].id == checkReusltId) {
                        if ($scope.result[i].mustFlg == "1"){
                          return true;
                        } else {
                          return false;
                        }
                      }
                    }
                  };



                  $scope.init = function () {
                      var u =window.location.hash;
                      var par = u.split("&");
                      if (par.length == 1) {
                        $scope.reportId = u.split("=")[1];
                        if ($scope.reportId.indexOf("#") > -1) {
                     	   $scope.reportId = $scope.reportId.split("#")[0];
                           $scope.showHistorySp();
                        }
                      } else if (par.length == 2) {
                        $scope.parentId = par[0].split("=")[1];
                        $scope.reportId = par[1].split("=")[1];
                      }

               	      var projectIdByTicketId = ajaxService.hasTicket($scope.reportId);
                      if(projectIdByTicketId == 0) {
                          alert("該当チェックシートが存在しません。");
                          window.close();
                          return ;
                        }

               	      if (projectIdByTicketId != $rootScope.projectId) {
                          alert("該当チェックシートが存在しません。");
                          window.close();
                          return ;
               	      }


                    //工事項目リストを取得
                      $scope.itemNameList = ajaxService.getTargetItemList($rootScope.projectId);
                      for (var i=0; i<$scope.itemNameList.length; i++) {
                        var field = $scope.itemNameList[i].fieldName;
                        if (field == "targetId") {
                          $scope.targetIdItemName = $scope.itemNameList[i].showName;
                        }
                        if (field == "targetName") {
                          $scope.targetNameItemName = $scope.itemNameList[i].showName;
                        }
                      }
                      $scope.getTicketInfo($scope.reportId);

                      $scope.getCheckreportDetailSp(1, true);

                    };
                    $scope.init();


                    $scope.scrollToBottom  = function(div) {
                  	  setTimeout(function () {
                  		  var objDiv = document.getElementById(div);
                  		  objDiv.scrollTop = 150;
                        }, 110)
                    };

                    $scope.copyTicketSp  = function() {
                    	var modalInstance = $uibModal.open({
                            animation : true,
                            templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                            controller : 'confirmDialogCtrl',
                            scope : $scope,
                            backdrop : "static",
                            resolve : {
                                message : function() {
                                    return {
                                        message : "このチェックシートをコピーして登録しますが、よろしいですか？"
                                    };
                                }
                            }
                        });
                      modalInstance.result.then(function() {
                      	var ticket = new Object();
                      	ticket.targetId = $scope.ticket.targetId;
        	            ticket.checksheetId = $scope.ticket.checksheetId;
        	            ticket.firstItemId = $scope.ticket.firstItemId;
        	            ticket.secondItemId = $scope.ticket.secondItemId;
        	            ticket.thirdItemId = $scope.ticket.thirdItemId;
        	            ticket.startScheduledDate = $scope.ticket.startScheduledDate;
        	            ticket.endScheduledDate = $scope.ticket.endScheduledDate;
        	            ticket.startDate = "";
        	            ticket.endDate = "";
        	            ticket.requestUserId = $scope.ticket.requestUserId;
        	            ticket.responseGroupId = $scope.ticket.responseGroupId;
        	            ticket.responseUserId = $scope.ticket.responseUserId;
        	            ticket.requestGroupId = $scope.ticket.requestGroupId;

        	            ticket.statusDetailId = $scope.ticket.statusDetailId;
        	            ticket.kbn2Id = $scope.ticket.kbn2Id;
        	            ticket.kbn3Id = $scope.ticket.kbn3Id;
        	            ticket.kbn4Id = $scope.ticket.kbn4Id;
        	            ticket.kbn5Id = $scope.ticket.kbn5Id;
        	            ticket.item1 = $scope.ticket.item1;
        	            ticket.item2 = $scope.ticket.item2;
        	            ticket.item3 = $scope.ticket.item3;
        	            ticket.item4 = $scope.ticket.item4;
        	            ticket.item5 = $scope.ticket.item5;

        	            var readingGroupIdlist = [];
        	            for (var i =0; i< $scope.ticket.readingGrouplist.length; i++) {
        	              readingGroupIdlist.push($scope.ticket.readingGrouplist[i].groupId);
        	            }
        	            ticket.readingGroupIdlist = readingGroupIdlist;
                        ticket.parentId = 0;

                        //ステータス：チェック前("01")
                        ticket.statusId = "01";
        	            var url = window.location.href;
                        var newTicketId = ajaxService.createTicket($rootScope.projectId, ticket, "チェックシートがコピーされました。コピー元のチェックシートIDは" + $scope.ticket.id + "です。", url)
        	            if (ajaxService.result['resultCd'] != "000000") {
        	               $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        	            } else {
        	               $rootScope.showInfoMessage("チェックシートがコピー作成されました。");
        	               var url = window.location.href;
        	               var u = url.split("#")[0];
        	               window.open(u + "#/showReportDetailSp?id=" + newTicketId );
        	            }
                        $scope.$$childTail.$$prevSibling.$dismiss();

                      });
                    };

                    $scope.setNowTime = function (outerIndex) {
                  	  $scope.result[outerIndex].value = new Date();
                    };

                    $scope.clearTime = function (outerIndex) {
                  	  $scope.result[outerIndex].value = null;
                    };

                    $scope.showAddFileInDetail = function (item) {

                  	  $uibModal.open({
                            animation: true,
                            templateUrl: "app/pages/checklist/checklistFile/addFileInDetailSp.html",
                            controller: 'AddFileInDetailCtrl',
                            scope : $scope,
                            resolve: {
                                openFlag : function() {
                                        return {
                                            'flag' : 'Show',
                                            'detailId': item.checkDetailId
                                        };
                                    }
                            }
                          });
                    };

                    $scope.saveImgCom = function (fileId, imgComm) {

                    	var imgCommentList = new Array();
                    	var imgCommOb = new Object();
                        imgCommOb.fileId = fileId;
                        imgCommOb.imgComm = imgComm;
                        imgCommentList.push(imgCommOb);

                        ajaxService.modifyImgComment(imgCommentList);

                        if (ajaxService.result['resultCd'] != "000000") {
	                        $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
	                      } else {
	                        $rootScope.showInfoMessage("コメントを保存しました。");
	                      }
                    };

                    $scope.offLineTicket = function () {

                    	if ($rootScope.unableOffLine) {
                    		$rootScope.showErrorMessage("ブラウザの問題で、チェックシートをダウンロードすることができません。");
                    	}

                    	$scope.offLineRs = true;

                    	console.log($scope.ticket);
                    	//オフライン対応、該当チェックシートをindexedDbに登録
                    	//チェックシート
                    	$rootScope.removeTicketIndexDb($scope.ticket.id);
                    	$rootScope.addTicketIndexDb($scope.ticket);
                    	//チェック結果
	               		 for (var i=0; i<$scope.checkresultList.length; i++) {
	               			var checklistId = $scope.checkresultList[i].checklistId;
	               			var checklistName = $scope.checkresultList[i].checklistName;
	               			var checklistContent = $scope.checkresultList[i].checklistContent;
	               			var checkResult = $scope.checkresultList[i].checkResult;

	               			var resultList = ajaxService.searchResultDetailList($scope.reportId, checklistId);

	               			for (var j=0; j<resultList.length; j++) {
	               				var rdOb = resultList[j];
	               				//プルダウン、ラジオボタン、チェックボックスについて、マスターデータもindexedDbに登録
	               				if (rdOb.inputTypeId == 3 || rdOb.inputTypeId == 4 || rdOb.inputTypeId == 5) {
	               					var userResourceDetail = ajaxService.searchUserResourceDetail(rdOb.userResourceId);
	               					rdOb.userResourceDetail = userResourceDetail;
	               				}

	               				//写真、動画、サインをindexedDbに登録
	               				if (rdOb.inputTypeId == 7 || rdOb.inputTypeId == 10) {
	               	               //写真,サイン
	               	               var imgBeanList = ajaxService.searchImgBeanList(rdOb.resultDetailId);
	               	               rdOb.imgBeanList = imgBeanList;
	               	               for (var k=0; k<imgBeanList.length; k++) {
	               	                   var imgId = imgBeanList[k].id;
	               	                   var url = urlPrefix + "checkreport/getCheckResultFile/"+localStorage.schema+"/"+rdOb.resultDetailId+"/"+localStorage.authId+"/"+imgId+"/dl";
	               	                   if (rdOb.inputTypeId == 10) {
	               	                	url = urlPrefix + "checkreport/getCheckResultFile/"+localStorage.schema+"/"+rdOb.resultDetailId+"/"+localStorage.authId+"/"+imgId+"/null";
	               	                   }
	               	                   var xmlhttp;
	               	                   xmlhttp=new XMLHttpRequest();
	               	                   xmlhttp.open("GET",url,true);
	               	                   xmlhttp.responseType = "blob";
	               	                   xmlhttp.onload = function(){
	               	                       console.log(this);
	               	                       if (this.status == 200) {
	               	                    	   var urlParams = this.responseURL.split("/");
	               	                    	   var imageId = urlParams[urlParams.length - 2];
	               	                    	   var resultDetailId = urlParams[urlParams.length - 4];
	               	                           var blob = this.response;
	               	                           console.log(blob);
	               	                           var imgComment = ajaxService.getImgComment(imageId);
	               	                           var tRsFileId = $scope.reportId + '-' + resultDetailId + '-' + imageId;
	               	                           var fileOb = {'tRsFileId' : tRsFileId, 'file':blob, 'imgComment': imgComment};
	               	                           $rootScope.removeFileIndexDb(tRsFileId);
	               	                           $rootScope.addFileIndexDb(fileOb);
	               	                       }
	               	                   }
	               	                   xmlhttp.send();
	               	               }
	               	             }
	               				 if (rdOb.inputTypeId == 8 || rdOb.inputTypeId == 9) {
		               	               //音声、動画
		               	               var imgBeanList = ajaxService.searchImgBeanList(rdOb.resultDetailId);
		               	               for (var k=0; k<imgBeanList.length; k++) {
		               	                   var imgId = imgBeanList[k].id;
		               	                   var url = urlPrefix + "checkreport/getCheckResultVideo/"+localStorage.schema+"/"+rdOb.resultDetailId+"/"+localStorage.authId+"/"+imgId;
		               	                   var xmlhttp;
		               	                   xmlhttp=new XMLHttpRequest();
		               	                   xmlhttp.open("GET",url,true);
		               	                   xmlhttp.responseType = "blob";
		               	                   xmlhttp.onload = function(){
		               	                       console.log(this);
		               	                       if (this.status == 200) {
		               	                    	   var urlParams = this.responseURL.split("/");
		               	                    	   var imageId = urlParams[urlParams.length - 1];
		               	                    	   var resultDetailId = urlParams[urlParams.length - 3];
		               	                           var blob = this.response;
		               	                           console.log(blob);
		               	                           var tRsFileId = $scope.reportId + '-' + resultDetailId + '-' + imageId;
		               	                           var fileOb = {'tRsFileId' : tRsFileId, 'file':blob};
		               	                           $rootScope.removeFileIndexDb(tRsFileId);
		               	                           $rootScope.addFileIndexDb(fileOb);
		               	                       }
		               	                   }
		               	                   xmlhttp.send();
		               	               }
		               	           }
	               			}

	               			var key = $scope.reportId + '-' + checklistId;
	               			var resultOb = {'tCheckId' : key, 'result':resultList, 'checklistName':checklistName, 'checklistContent':checklistContent, 'checkResult':checkResult};
	               			$rootScope.removeResultIndexDb(key);
	               			$rootScope.addResultIndexDb(resultOb);
	               		 }

                    	//comment
	               		var statusHistoryList = ajaxService.searchCommentList($rootScope.projectId, $scope.ticket.id);
	               		var commentOb = {'ticketId' : $scope.ticket.id, 'statusHistoryList':statusHistoryList};
                    	$rootScope.removeCommentIndexDb($scope.ticket.id);
                    	$rootScope.addCommentIndexDb(commentOb);

                    	//工事
                    	var itemNameList = ajaxService.getTargetItemList($rootScope.projectId);
                        var selectedTarget = ajaxService.searchTarget($scope.ticket.targetId);
                        var selectedTar = {};
                        selectedTar.pref = $rootScope.getPrefOb(selectedTarget.prefCd);
                        selectedTar.reg = $rootScope.getRegionOb(selectedTarget.region);

	               		var targetOb = {'targetId' : $scope.ticket.targetId, 'targetOb':selectedTarget, 'tar':selectedTar, 'item': itemNameList};
                    	$rootScope.removeTargetIndexDb($scope.ticket.targetId);
                    	$rootScope.addTargetIndexDb(targetOb);


	               		 if ($scope.offLineRs) {
	               			$rootScope.showInfoMessage("チェックシートをダウンロードしました。");
	               		 } else {
	               			$rootScope.showErrorMessage("チェックシートをダウンロードすることができません。");
	               		 }


                    };


                    $scope.openImgOrder = function (resultDetailId) {

                   	 $scope.imgOrderList = $scope["imgbean"+resultDetailId];
                   	 $scope.imgResultDetailId = resultDetailId;


                   	 $uibModal.open({
                            animation : true,
                            templateUrl : 'app/pages/checkreport/sp/imgOrderSp.html',
                            scope : $scope,
                            backdrop : "static",
                            resolve : {
                                message : function() {
                                    return {
                                    };
                                }
                            }
                        });


                     };

                     $scope.saveImgOrder = function () {

                   	  var isOK = true;
                   	  var errMsg = "";
                   	  for (var i = 0; i < $scope.imgOrderList.length; i ++) {
                   		  ajaxService.modifyImgOrder($scope.imgResultDetailId, $scope.imgOrderList[i].fileId, i);
                   		  if (ajaxService.result['resultCd'] != "000000") {
                   			  errMsg = tr.T(ajaxService.result['resultCd']);
                   			  isOK = false;
                   			  break;
                   		  }
                   	  }

                   	  if (! isOK) {
                   		  $rootScope.showErrorMessage(errMsg);
                   	  } else {
                   		  $rootScope.showInfoMessage("保存しました。");
                   		  $scope.$$childTail.$dismiss();
                   		  $scope.getImgList($scope.ticketId, $scope.imgResultDetailId);
                   		  window.location.reload();
                   	  }
                     };

  }

})();

/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.checkreport').controller('CheckResultCtrl', CheckResultCtrl);

    /** @ngInject */
    function CheckResultCtrl($scope, $rootScope, $filter, editableOptions, editableThemes, toastr, $uibModal,
            toastrConfig, ajaxService, $state, $location, $window, themeLayoutSettings, openFlag, $http, Upload, tr) {
//      $scope.ctrl = $scope;
      if (!ajaxService.tokenCheck()) {
            return;
          };

      $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);
      $scope.showResult = $scope.mngCommon.showResult;

      $scope.checkListInfo = openFlag.checkList;
      var content = $scope.checkListInfo.checklistContent;
      if (content) {
        var urlStartIndex = content.indexOf("[[");
        var urlEndIndex = content.indexOf("]]");
        if (urlStartIndex != -1 && urlEndIndex != -1) {
          var urlStr = content.substring(urlStartIndex, urlEndIndex + 2);
          var link = content.substring(urlStartIndex + 2, urlEndIndex);
          var url = "<a href = '"+ link +"' target = '_blank'>"+link+"</a>";
          $scope.checkListInfo.checklistContent = content.replace(urlStr, url);
        }
      }


      $scope.ticketId = openFlag.ticketId;
      $scope.checkListBeanList = openFlag.checkListBeanList;
      $scope.hasPrev = true;
      $scope.hasNext = true;

      $scope.lat = null;
      $scope.lgt = null;
      if(!navigator.geolocation){ alert('位置情報を共有してください。'); return; }
      navigator.geolocation.getCurrentPosition(
      function(position){
        $scope.lat = position.coords.latitude;
        $scope.lgt = position.coords.longitude;
        } ,
        function(){
          //alert('位置情報取得失敗！');
        }
      );

      $scope.showPrevDetail = function () {
        var r = true;
        if ($scope.checkResultIsChange()){
//          var modalInstance = $uibModal.open({
//                animation : true,
//                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
//                controller : 'confirmDialogCtrl',
//                scope : $scope,
//                backdrop : "static",
//                resolve : {
//                    message : function() {
//                        return {
//                            message : "チェック結果を保存して、前へ遷移しても宜しいですか？"
//                        };
//                    }
//                }
//            });
//            modalInstance.result.then(function() {
//            });
            r = $scope.saveResult();
        }

        if (r) {
          var checkListId = $scope.checkListInfo.checklistId;
          for (var i=0; i<$scope.checkListBeanList.length; i++) {
            if ($scope.checkListBeanList[i].checklistId == checkListId ) {
              $scope.checkListInfo = $scope.checkListBeanList[i-1];
              var content = $scope.checkListInfo.checklistContent;
              if (content) {
                var urlStartIndex = content.indexOf("[[");
                var urlEndIndex = content.indexOf("]]");
                if (urlStartIndex != -1 && urlEndIndex != -1) {
                  var urlStr = content.substring(urlStartIndex, urlEndIndex + 2);
                  var link = content.substring(urlStartIndex + 2, urlEndIndex);
                  var url = "<a href = '"+ link +"' target = '_blank'>"+link+"</a>";
                  $scope.checkListInfo.checklistContent = content.replace(urlStr, url);
                }
              }
            }
          }
          $scope.init($scope.ticketId, $scope.checkListInfo.checklistId);
        }

      };

      $scope.showNextDetail = function () {
        var r = true;
        if ($scope.checkResultIsChange()){
          r = $scope.saveResult();
        }
        if (r){
          var checkListId = $scope.checkListInfo.checklistId;
          for (var i=0; i<$scope.checkListBeanList.length; i++) {
            if ($scope.checkListBeanList[i].checklistId == checkListId ) {
              $scope.checkListInfo = $scope.checkListBeanList[i+1];
              var content = $scope.checkListInfo.checklistContent;
              if (content) {
                var urlStartIndex = content.indexOf("[[");
                var urlEndIndex = content.indexOf("]]");
                if (urlStartIndex != -1 && urlEndIndex != -1) {
                  var urlStr = content.substring(urlStartIndex, urlEndIndex + 2);
                  var link = content.substring(urlStartIndex + 2, urlEndIndex);
                  var url = "<a href = '"+ link +"' target = '_blank'>"+link+"</a>";
                  $scope.checkListInfo.checklistContent = content.replace(urlStr, url);
                }
              }
            }
          }
          $scope.init($scope.ticketId, $scope.checkListInfo.checklistId);
        }
      };

      $scope.checkLimitOneList = function (checkdetailId, outerIndex, showMsg){
        var limitList = ajaxService.searchCheckLimitList(checkdetailId);

          if ($scope.errorStyle == null) {
             //背景色設定のため
                $scope.errorStyle = new Array();
          }


        var entered = $scope.result[outerIndex].value;
        if (entered !=0 && !entered) {
        	return;
        }

        var detailName = $scope.result[outerIndex].checkDetailName;
        var logic1 = limitList[0].logic;

        var condition1 = limitList[0].condition;
        var value1 = limitList[0].value;
        var conditionChar1 = null;
        var errorMsgChar　= "";

        var flag = false;

         if(condition1 == 1 ) {
           conditionChar1 = "<"
         }else if (condition1 == 2){
           conditionChar1 =  ">"
         }else if (condition1 == 3){
           conditionChar1 = "≦"
         }else if (condition1 == 4){
           conditionChar1 = "≧"
         }

            if(condition1 == 1){
                if(entered < value1){
                    flag = true;
                }
            }else if(condition1 == 2){
                 if(entered > value1){
                    flag = true;
                }
            }else if(condition1 == 3){
                 if(entered <= value1){
                    flag = true;
                }
            }else if(condition1 == 4){
               if(entered >= value1){
                    flag = true;
                }
            }

            if(! flag){
            //OK
            $scope.errorStyle[outerIndex] = "";

            }else{
            //NG
                if (showMsg) {
                        var errorMsgChar = "[ "+ detailName +" ] : 異常値が入力されました。異常値：[ x"+ conditionChar1 + value1 + " ]";
                   $rootScope.showErrorMessage5Sec(errorMsgChar);
                }
                 $scope.errorStyle[outerIndex] = "peachpuff";
            }

      }


      $scope.checkLimit = function (checkdetailId, outerIndex, showMsg) {


       var entered = $scope.result[outerIndex].value;

       if ($scope.errorStyle == null) {
          //背景色設定のため
             $scope.errorStyle = new Array();
       }

       if (entered !=0 && !entered) {
    	   $scope.errorStyle[outerIndex] = "";
           return;
       }

       if (typeof(entered) == 'undefined') {
    	   $rootScope.showErrorMessage($scope.result[outerIndex].checkDetailName+"を正しく入力してください。");
    	   return;
       }
        var limitList = ajaxService.searchCheckLimitList(checkdetailId);

        if(limitList.length==0){
          //異常値が設定されていない場合
          return "";
        }

        if(limitList.length == 1){
          $scope.checkLimitOneList(checkdetailId, outerIndex, showMsg);
          return "";
        }

        var detailName = $scope.result[outerIndex].checkDetailName;
        var logic1 = limitList[0].logic;
        var logic2 = limitList[1].logic;

        var condition1 = limitList[0].condition;
        var condition2  =limitList[1].condition;
        var conditionArr = [condition1, condition2];

        var value1 = limitList[0].value;
        var value2 = limitList[1].value;
        var valueArr = [value1, value2];

        var conditionChar1 = null;
        var conditionChar2 = null;
        var errorMsgChar　= "";

        var flag = [false, false];

        if(condition1 == 1 ) {
            conditionChar1 = "<"
          }else if (condition1 == 2){
            conditionChar1 =  ">"
          }else if (condition1 == 3){
            conditionChar1 = "≦"
          }else if (condition1 == 4){
            conditionChar1 = "≧"
          }


         if(condition2 == 1 ) {
           conditionChar2 = "<"
         }else if (condition2 == 2){
           conditionChar2 =  ">"
         }else if (condition2 == 3){
           conditionChar2 = "≦"
         }else if (condition2 == 4){
           conditionChar2 = "≧"
         }

          for(var i =0;i<conditionArr.length;i++){
            if(conditionArr[i] == 1){
                if(entered < valueArr[i]){
                    flag[i] = true;
                }else{
                    flag[i] = false;
                }
            }else if(conditionArr[i] == 2){
                 if(entered > valueArr[i]){
                    flag[i] = true;
                }else{
                    flag[i] = false;
                }
            }else if(conditionArr[i] == 3){
                 if(entered <= valueArr[i]){
                    flag[i] = true;
                }else{
                    flag[i] = false;
                }
            }else if(conditionArr[i] == 4){
               if(entered >= valueArr[i]){
                    flag[i] = true;
                }else{
                    flag[i] = false;
                }
            }
          }

          if(logic1 == 2 || logic2 == 2){
          //AnDの時
            if( flag[0] == false && flag[1] == false){
            //OK
            $scope.errorStyle[outerIndex] = "";
            }else{
            //NG
                if (showMsg) {
                   if(value1 < value2){
                        var errorMsgChar = "[ "+ detailName +" ] : 異常値が入力されました。異常値：[ x"+ conditionChar1 + value1 + " または x "+ conditionChar2 + value2 + ' ] ';
                   }else {
                        var errorMsgChar = "[ "+ detailName +" ] : 異常値が入力されました。異常値：[ x"+ conditionChar2 + value2 + " または x "+ conditionChar1 + value1 + ' ] ';
                   }
                   $rootScope.showErrorMessage5Sec(errorMsgChar);
                }
                $scope.errorStyle[outerIndex] = "peachpuff";
            }
          }

         if( (logic1 == logic2) == 1 ){
         //ORの時
           if( flag[0] == false || flag[1] == false){
           //OK
            $scope.errorStyle[outerIndex] = "";
           }else {
           //NG
                if (showMsg) {
                   if(value1 < value2){
                        errorMsgChar = "[ "+ detailName +" ] : 異常値が入力されました。異常値：[ x"+ conditionChar1 + value1 + " かつ x "+ conditionChar2 + value2 + ' ] ';
                   }else {
                        errorMsgChar = "[ "+ detailName +" ] : 異常値が入力されました。異常値：[ x"+ conditionChar2 + value2 + " かつ x "+ conditionChar1 + value1 + ' ] ';
                   }
                   $rootScope.showErrorMessage5Sec(errorMsgChar);
                }
                $scope.errorStyle[outerIndex] = "peachpuff";
            }
          }
      }


      $scope.init = function (ticketId, checkListId) {
        $scope.isEditer = $scope.$parent.isEditer;
        $scope.isVisitor = $scope.$parent.isVisitor;
        $scope.isEditable = $scope.$parent.isEditable;
        if (! $scope.isEditable) {
          $scope.isEditer = false;
          $scope.isVisitor = true;
        }

        for (var i=0; i<$scope.checkListBeanList.length; i++) {
          if ($scope.checkListBeanList[i].checklistId == checkListId) {
            if (i == 0){
              $scope.hasPrev = false;
            } else {
              $scope.hasPrev = true;
            }
            if (i == $scope.checkListBeanList.length - 1){
              $scope.hasNext = false;
            } else {
              $scope.hasNext = true;
            }
          }
        }

        $scope.resultDetailList = ajaxService.searchResultDetailList(ticketId, checkListId);

        $scope.chBoxResult = [];
        $scope.finalCheck = "";
        $scope.result = new Array();
        $scope.userResource = new Array();
        for (var i=0; i<$scope.resultDetailList.length; i++) {
          var rdOb = $scope.resultDetailList[i];
          $scope.result[i] = new Object();
          $scope.result[i].id = rdOb.resultDetailId;
          $scope.result[i].value = rdOb.checkResult;
          if (i == 0 && ! rdOb.checkResult) {
            $scope.result[i].value = "1";
          }
          $scope.result[i].inputTypeId = rdOb.inputTypeId;
          $scope.result[i].mustFlg = rdOb.mustFlg;
          $scope.result[i].checkDetailName = rdOb.checkDetailName;
          if (rdOb.inputTypeId == 2) {
            //日付
            if (rdOb.checkResult) {
              $scope.result[i].id = rdOb.resultDetailId;
              $scope.result[i].value = new Date(rdOb.checkResult);
            }
          } else if (rdOb.inputTypeId == 3) {
            //セレクトボックス
            $scope["userResource"+rdOb.resultDetailId] = ajaxService.searchUserResourceDetail(rdOb.userResourceId);
            $scope["userResource"+rdOb.resultDetailId].unshift({label:" ", value:null});
            if (rdOb.checkResult) {
              for (var j=0; j< $scope["userResource"+rdOb.resultDetailId].length; j++) {
                if (rdOb.checkResult == $scope["userResource"+rdOb.resultDetailId][j].value) {
                  $scope.result[i].id = rdOb.resultDetailId;
                  $scope.result[i].value = $scope["userResource"+rdOb.resultDetailId][j];
                }
              }
            } else {
                $scope.result[i].id = rdOb.resultDetailId;
                $scope.result[i].value = $scope["userResource"+rdOb.resultDetailId][0];
            }
          } else if (rdOb.inputTypeId == 4) {
            //ラジオボタン
            $scope.userResource[i] = ajaxService.searchUserResourceDetail(rdOb.userResourceId);
          } else if (rdOb.inputTypeId == 5) {
            //チェックボックス
            $scope.userResource[i] = ajaxService.searchUserResourceDetail(rdOb.userResourceId);
            var checkBoxResult = $scope.result[i].value;
            if (checkBoxResult) {
               var rlist = checkBoxResult.split("、");
               $scope.chBoxResult[i] = [];
               for (var r=0; r< rlist.length;r++) {
                 $scope.chBoxResult[i].push(parseInt(rlist[r]));
               }
            }
          } else if (rdOb.inputTypeId == 7) {
            //写真
            $scope.getImgList($scope.ticketId, rdOb.resultDetailId);
          } else if (rdOb.inputTypeId == 8) {
            //音声
            $scope.getRadioList($scope.ticketId, rdOb.resultDetailId);
          } else if (rdOb.inputTypeId == 9) {
            //動画
            $scope.getVideoList($scope.ticketId, rdOb.resultDetailId);
          } else if (rdOb.inputTypeId == 10) {
            //手書き
              $scope["signable"+rdOb.resultDetailId] = true;
              $scope.getSign($scope.ticketId, rdOb.resultDetailId);
          } else if (rdOb.inputTypeId == 11) {
            //360度カメラ
            if (rdOb.checkResult) {
              $scope["camera"+rdOb.resultDetailId] = true;
              if (rdOb.checkResult.indexOf("/t/") != -1) {
                $scope["cameraT"+rdOb.resultDetailId] = true;
              } else {
                $scope["cameraT"+rdOb.resultDetailId] = false;
              }
            } else {
              $scope["camera"+rdOb.resultDetailId] = false;
            }
          } else if (rdOb.inputTypeId == 12) {
            //数値テキスト
            $scope.result[i].value = parseFloat(rdOb.checkResult);
            //モダール立ち上げる前の初期化
            $scope.checkLimit(rdOb.checkDetailId, i, false);
          } else if (rdOb.inputTypeId == 13) {
              //ファイル
              $scope.getResultFileList($scope.ticketId, rdOb.resultDetailId);
          }
        }
        $scope.baseResult = angular.copy($scope.result);

      };


      $scope.getImgList = function(ticketId, checkResultId) {

    	var oldImgBeanList = $scope["imgbean"+checkResultId];

        $scope["imgList"+checkResultId] = new Array();
        $scope["imgbean"+checkResultId] = new Array();

        var imgBeanList = ajaxService.searchImgBeanList(checkResultId);
        var fileList = new Array()
        for (var i=0; i<imgBeanList.length; i++) {
          if (i%3 == 0) {
             var imgRow = new Array();
             $scope["imgList"+checkResultId].push(imgRow);
          }
          var imgOb = new Object();
          imgOb.no = i+1;
          var imgId = imgBeanList[i].id;
          imgOb.fileId = imgId;
          imgOb.fileName = imgBeanList[i].fileName;
          imgOb.url = urlPrefix + "checkreport/getCheckResultFile/"+localStorage.schema+"/"+checkResultId+"/"+localStorage.authId+"/"+imgId+"/dl";
          imgRow.push(imgOb);
          $scope["imgbean"+checkResultId].push(imgOb);

          //fileidによりコミット持ってくる
          var imgComment = ajaxService.getImgComment(imgOb.fileId);

          //変更されたコメントがあればimgOb.imgCommに再設定
          var setByOld = false;
          if (oldImgBeanList) {
        	  for (var j = 0; j< oldImgBeanList.length; j++) {
        		  if (imgId == oldImgBeanList[j].fileId) {
        			  imgOb.imgComm = oldImgBeanList[j].imgComm;
        			  setByOld = true;
        		  }
        	  }
          }
          if (!setByOld) {
              imgOb.imgComm = imgComment;
          }

        }

      };


      $scope.getRadioList = function(ticketId, checkResultId) {
        $scope["imgList"+checkResultId] = new Array();
          var radioBeanList = ajaxService.searchImgBeanList(checkResultId);
          for (var i=0; i<radioBeanList.length; i++) {
              var raduoOb = new Object();
              raduoOb.id = radioBeanList[i].id;
              raduoOb.fileName = radioBeanList[i].fileName;
              raduoOb.url = urlPrefix + "checkreport/getCheckResultVideo/"+localStorage.schema+"/"+checkResultId+"/"+localStorage.authId+"/"+radioBeanList[i].id;
            $scope["imgList"+checkResultId].push(raduoOb);
          }
      };

      $scope.getVideoList = function(ticketId, checkResultId) {
        $scope["imgList"+checkResultId] = new Array();
          var radioBeanList = ajaxService.searchImgBeanList(checkResultId);
          for (var i=0; i<radioBeanList.length; i++) {
              var raduoOb = new Object();
              raduoOb.id = radioBeanList[i].id;
              raduoOb.fileName = radioBeanList[i].fileName;
              raduoOb.url = urlPrefix + "checkreport/getCheckResultVideo/"+localStorage.schema+"/"+checkResultId+"/"+localStorage.authId+"/"+radioBeanList[i].id;
            $scope["imgList"+checkResultId].push(raduoOb);
          }
      };

      $scope.getSign = function(ticketId, checkResultId) {
        $scope["signFlg"+checkResultId] = true;
        $scope["sign"+checkResultId] = new Object();
          var radioBeanList = ajaxService.searchImgBeanList(checkResultId);
          if (radioBeanList.length != 0) {
            //手書きあり
            $scope["signable"+checkResultId] = false;
            $scope["signId"+checkResultId] = radioBeanList[0].id;
            $scope["signUrl"+checkResultId] = urlPrefix + "checkreport/getCheckResultFile/"+localStorage.schema+"/"+checkResultId+"/"+localStorage.authId+"/"+radioBeanList[0].id+"/null";
          }
      };

      $scope.getResultFileList = function(ticketId, checkResultId) {
          $scope["imgList"+checkResultId] = new Array();
          var imgBeanList = ajaxService.searchImgBeanList(checkResultId);
    	  $scope["hasFile"+checkResultId] = false;
          if (imgBeanList.length > 0) {
        	  $scope["hasFile"+checkResultId] = true;
              $scope["imgList"+checkResultId] = imgBeanList;
          }

        };


      $scope.dynamicImgArray = function(checkResultId){
          return $scope["imgList"+checkResultId];
      }

      $scope.hasImgArrayList = function(checkResultId){
    	  if ($scope["imgbean"+checkResultId].length > 1){
    		  return true;
    	  }
          return false;
      }

      $scope.showComm = function(fileid){
        alert(fileid);
      }

      $scope.getSignUrl = function(checkResultId){
        return $scope["signUrl"+checkResultId];
      };


      $scope.init($scope.ticketId, $scope.checkListInfo.checklistId);

      $scope.showCheckDetailContent = function(resultId) {
        for (var i=0; i<$scope.resultDetailList.length; i++) {
          var rdOb = $scope.resultDetailList[i];
          if (rdOb.resultDetailId == resultId) {
            if (rdOb.checkDetailContent != "" || rdOb.checkDetailContent != null) {
              $rootScope.showComment(rdOb.checkDetailContent);
            } else {
              $rootScope.showComment("該当チェック項目の補足がありません。");
            }
          }
        }
      };

      $scope.openUploadImg = function(resultId, item) {
          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/fileUploadModal.html',
              controller : 'FileUploadCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  openFlag : function() {
                      return {
                          'flag' : 'New',
                          'kbn' : 'CheckResult',
                          'id': resultId,
                          'ticketId': $scope.ticketId,
                          'typeKbn': "Image"
                      };
                  }
              }
          });
      };

      $scope.openUploadRadio = function(resultId) {
          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/fileUploadModal.html',
              controller : 'FileUploadCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  openFlag : function() {
                      return {
                          'flag' : 'New',
                          'kbn' : 'CheckResult',
                          'id': resultId,
                          'ticketId': $scope.ticketId,
                          'typeKbn': "Radio"
                      };
                  }
              }
          });
      };

      $scope.openUploadVideo = function(resultId) {
          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/fileUploadModal.html',
              controller : 'FileUploadCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  openFlag : function() {
                      return {
                          'flag' : 'New',
                          'kbn' : 'CheckResult',
                          'id': resultId,
                          'ticketId': $scope.ticketId,
                          'typeKbn': "Video"
                      };
                  }
              }
          });
      };

      $scope.openUploadFile = function(resultId) {
          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/fileUploadModal.html',
              controller : 'FileUploadCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  openFlag : function() {
                      return {
                          'flag' : 'New',
                          'kbn' : 'CheckResult',
                          'id': resultId,
                          'ticketId': $scope.ticketId,
                          'typeKbn': "File"
                      };
                  }
              }
          });
      };

      $scope.showResultImg = function (checkResultId, index) {
        var ul = $('<ul></ul>');
        var li = $('<li></li>');
        for (var i=index-1; i<$scope["imgbean"+checkResultId].length; i++ ) {
          var url_th = $scope["imgbean"+checkResultId][i].url;
          var u = url_th.substring(0, url_th.length-2);
          var img = {};
          img[i] = $('<img></img>');
          img[i].attr('src', u+"null");
          img[i].attr('alt', $scope["imgbean"+checkResultId][i].fileName);
          li[0].appendChild(img[i][0]);
        }

        for (var i=0; i<index-1; i++ ) {
            var url_th = $scope["imgbean"+checkResultId][i].url;
            var u = url_th.substring(0, url_th.length-2);
            var img = {};
            img[i] = $('<img></img>');
            img[i].attr('src', u+"null");
            img[i].attr('alt', $scope["imgbean"+checkResultId][i].fileName);
            li[0].appendChild(img[i][0]);
        }
        ul[0].appendChild(li[0]);

        var viewer = new Viewer(ul[0],{
        	url : 'data-original',
        	toolbar : {
                zoomIn:true,
                zoomOut:true,
        		oneToOne: true,
                prev: function() {
                  viewer.prev(true);
                },
                play: true,
                next: function() {
                  viewer.next(true);
                },
                reset: true,
                rotateLeft : true,
                rotateRight : true,
                flipHorizontal: true,
                flipVertical:true,
                download: function() {
                    var a = document.createElement('a');
                    a.href = viewer.image.src;
                    a.download = viewer.image.alt;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                  }
        	}
        });

//        var viewer = new Viewer(ul[0]);
       viewer.show();
//
//
//        var viewer = new Viewer(ul[0], {
//            url : 'data-original',
//            toolbar : {
//              oneToOne : true,
//              prev : function() {
//                viewer.prev(true);
//              },
//              play : true,
//              next : function() {
//                viewer.next(true);
//              },
//              rotateLeft : true,
//              rotateRight : true,
//              download : false,
//              zoomIn:true,
//              zoomOut:true,
//            },
//          });

//        oneToOne: true,
//        prev: function() {
//          viewer.prev(true);
//        },
//        play: true,
//        next: function() {
//          viewer.next(true);
//        },
//        download: function() {
//          const a = document.createElement('a');
//          a.href = viewer.image.src;
//          a.download = viewer.image.alt;
//          document.body.appendChild(a);
//          a.click();
//          document.body.removeChild(a);
//        }

      }

      $scope.deleteFile = function(fileId, resultId, type) {
    	  if (ajaxService.hasCheckResultFile(resultId) == 1) {
    		  if ($scope.isMustCheckResult(resultId)){
    			  if($scope.showResult == '1'){
    	            	$scope.result[0].value = "";
    	        	} else {
    	        		if ($scope.result[0].value == "1" || $scope.result[0].value == "2") {
        	        		$rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
        	                return ;
    	        		}
    	        	}
    		  }
    	  }
//
//
//
//        if ($scope.isMustCheckResult(resultId) && ($scope.result[0].value == "1" || $scope.result[0].value == "2")) {
//          if (ajaxService.hasCheckResultFile(resultId) == 1) {
//            //最後のファイルを削除時、必須項目なら、削除不可
//        	if($scope.showResult == '1'){
//            	$scope.result[0].value = "";
//        	} else {
//        		$rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
//                return ;
//        	}
//          }
//        }

        var modalInstance = $uibModal.open({
            animation : true,
            templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
            controller : 'confirmDialogCtrl',
            scope : $scope,
            backdrop : "static",
            resolve : {
                message : function() {
                    return {
                        message : "該当ファイルを削除してもよろしいですか？"
                    };
                }
            }
        });
        modalInstance.result.then(function() {
        	if ($scope.result[0].value == "") {
        		$scope.saveResult();
        	}
          ajaxService.removeFileCheckResult(fileId);
          if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
          } else {
            $rootScope.showInfoMessage("該当ファイルを削除しました。");
            if (type == "Image") {

                $scope.getImgList($scope.ticketId, resultId);
                $scope.$parent.getCheckreportList($scope.ticketId);

            } else if (type == "Radio") {
                $scope.getRadioList($scope.ticketId, resultId);
            } else if (type == "Video") {
                $scope.getVideoList($scope.ticketId, resultId);
            } else if (type == "File") {
                $scope.getResultFileList($scope.ticketId, resultId);
            }

          }
        });
      };

      $scope.showSignPc = function(resultId) {
        $scope["signable"+resultId] = true;
        $scope["signFlg"+resultId] = false;
        if ($("#signature"+resultId).children().length == 0 ) {
          $("#signature"+resultId).jSignature({height:"200",width:"958"});
        }
        $("#signature"+resultId).jSignature("enable");
            $("#signOK"+resultId).css({
              'display' : 'initial'
            });
            $("#signReset"+resultId).css({
                'display' : 'initial'
              });
        };

        $scope.resetSignPc = function(resultId) {
          var $sigdiv = $("#signature"+resultId);
          $sigdiv.jSignature("reset");
          $("#image"+resultId+" img").remove();
        };

        $scope.saveSignPc = function(resultId) {
          $("#image"+resultId+" img").remove();
          var $sigdiv = $("#signature"+resultId);
          var datapair = $sigdiv.jSignature("getData", "image");
          var i = new Image();

          i.src = "data:" + datapair[0] + "," + datapair[1];
          var sampleArr = $rootScope.base64ToArrayBuffer(datapair[1]);
          var blob = new Blob([ sampleArr ], {type: 'image/png'});
          blob.name = resultId + ".png";
          blob.lastModifiedDate = new Date();

          Upload.upload({
              url : urlPrefix + "checkreport/uploadCheckResultFile",
              type : "POST",
              headers : {
                  "authorization" : localStorage.authId,
              },
              dataType : "multipart/form-data",
              data : {file: blob, 'userName':localStorage.userName, 'loginId':localStorage.userId, 'checkResultId': resultId, 'projectId': $rootScope.projectId, 'ticketId':$scope.ticketId, 'typeKbn':'Sign', "schema" : localStorage.schema }
          }).then(function(response) {
        	  if (response.data.resultCd != '000000') {
            		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
            		return ;
              }
              $rootScope.showInfoMessage("手書きを保存しました。");
              $scope.getSign($scope.ticketId, resultId);
              $scope.$parent.getCheckreportList($scope.ticketId);
          }, function(response) {
            $rootScope.showErrorMessage(tr.T(response.data.resultCd));
          });
        };

        $scope.deleteSign = function(resultId) {
//          if ($scope.isMustCheckResult(resultId) && ($scope.result[0].value == "1" || $scope.result[0].value == "2")) {
//                $rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
//                return ;
//          }

          if ($scope.isMustCheckResult(resultId)){
			  if($scope.showResult == '1'){
	            	$scope.result[0].value = "";
	        	} else {
	        		if ($scope.result[0].value == "1" || $scope.result[0].value == "2") {
    	        		$rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
    	                return ;
	        		}
	        	}
		  }

          var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "該当手書きを削除してもよろしいですか？"
                        };
                    }
                }
            });

          modalInstance.result.then(function() {
        	  if ($scope.result[0].value == "") {
          		$scope.saveResult();
          	  }

              ajaxService.removeFileCheckResult($scope["signId"+resultId]);
              if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              } else {
                $rootScope.showInfoMessage("該当手書きを削除しました。");
                $scope["signable"+resultId] = true;
                $scope.getSign($scope.ticketId, resultId);
                if ($("#signature"+resultId).children().length != 0 ) {
                  $("#signature"+resultId).jSignature("clear");
                  $("#signature"+resultId).jSignature("disable");
                }
              }
            });
        };



      $scope.saveResult = function() {

    	  if($scope.showResult == '1'){
    		  if ($scope.result[0].value != '') {
    			//最終確認非表示,デフォルト正常
        		  $scope.result[0].value = "1";
    		  }
    	  } else {
    		  if (! $scope.result[0].value) {
	            $rootScope.showErrorMessage("最終確認を選択してください。");
	            return false;
	          }
    	  }

        if ($scope.result[0].value == "1" || $scope.result[0].value == "2" ) {
          //必須チェック
            outer : for (var i=1; i<$scope.result.length; i++) {
              if ($scope.result[i].mustFlg == "1") {
                if ($scope.result[i].inputTypeId != 7 && $scope.result[i].inputTypeId != 8 && $scope.result[i].inputTypeId != 9 && $scope.result[i].inputTypeId != 10 && $scope.result[i].inputTypeId != 13) {
                    if ($scope.result[i].inputTypeId == 5 ) {
                        if ($scope.chBoxResult[i]) {
                          for (var k = 0; k < $scope.userResource[i].length; k++){
                            if ($scope.chBoxResult[i][k]) {
                              if ($scope.chBoxResult[i][k] != 0) {
                                continue outer;
                              }
                            }
                          }
                          $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を入力してください。");
                          return false;
                        } else {
                          $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を入力してください。");
                            return false;
                        }
                    } else if ($scope.result[i].inputTypeId == 12) {
                      if (! $scope.result[i].value) {
                    	  if ($scope.result[i].value != 0) {
                              $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を正しく入力してください。");
                              return false;
                    	  } else {
                    		  $scope.result[i].value = "0";
                    	  }
                      }
                    } else if ($scope.result[i].inputTypeId == 3) {
                        if (! $scope.result[i].value.value) {
                            $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を選択してください。");
                            return false;
                        }
                    } else {
                      if (! $scope.result[i].value) {
                            $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を入力してください。");
                            return false;
                      }
                    }
                } else {
                  if (ajaxService.hasCheckResultFile($scope.result[i].id) == 0) {
                    // FILE無し
                    $rootScope.showErrorMessage($scope.result[i].checkDetailName+"をアップロードしてください。");
                      return false;
                  }
                }
              }
            }
        }

        var imgCommentList = [];

        for (var i=0; i<$scope.result.length; i++) {

            if ($scope.result[i].inputTypeId == 2) {
                var v = $rootScope.formatDate($scope.result[i].value, "YYYY/MM/DD");
                $scope.result[i].checkResult = v;
            } else if ($scope.result[i].inputTypeId == 3) {
              if ($scope.result[i].value) {
                $scope.result[i].checkResult = $scope.result[i].value.value;
              }
            } else if ($scope.result[i].inputTypeId == 5) {
              if ($scope.chBoxResult[i]) {
                var result = "";
                for (var k = 0; k < $scope.userResource[i].length; k++){
                  if ($scope.chBoxResult[i][k]) {
                      if (result == "") {
                        result = $scope.chBoxResult[i][k]+"";
                      } else {
                        result = result + "、" + $scope.chBoxResult[i][k];
                      }
                  } else {
                    if (result == "") {
                      result = "0";
                    } else {
                      result = result + "、0";
                    }
                  }
                }
                $scope.result[i].checkResult = result;
              } else {
                $scope.result[i].checkResult = "";
              }
            } else if ($scope.result[i].inputTypeId == 12) {
            	if (typeof($scope.result[i].value) == 'undefined') {
                   $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を正しく入力してください。");
             	   return false;
                }
              	  if ($scope.result[i].value == 0) {
              		  $scope.result[i].checkResult = "0";
              	  } else {
              		$scope.result[i].checkResult = $scope.result[i].value;
              	  }
            } else {
              if ($scope.result[i].inputTypeId == 7) {
                var imglist = $scope["imgList"+$scope.result[i].id];
                for (var j = 0; j < imglist.length; j++) {
                  var imgItemList = imglist[j];
                  for (var n = 0; n < imgItemList.length; n++) {
                    var imgCommOb = new Object();
                    imgCommOb.fileId = imgItemList[n].fileId;
                    imgCommOb.imgComm = imgItemList[n].imgComm;
                    imgCommentList.push(imgCommOb);
                  }
                }
              }

              if ($scope.result[i].value) {
                $scope.result[i].checkResult = $scope.result[i].value;
              }
            }
        }

        var getImgList = [];
        getImgList =  ajaxService.modifyImgComment(imgCommentList);

        ajaxService.modifyCheckResult($rootScope.projectId, $scope.ticketId, $scope.result, $scope.lat, $scope.lgt);
        if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            return false;
          } else {
            $rootScope.showInfoMessage("保存しました。");
            $scope.init($scope.ticketId, $scope.checkListInfo.checklistId);
            $scope.$parent.getCheckreportList($scope.ticketId);
            $scope.$parent.getTicketInfo($scope.ticketId);
            return true;
          }
      };


      //一時保存
      $scope.temSaveResult = function() {

       $scope.result[0].value = "3";

        var imgCommentList = [];
        for (var i=0; i<$scope.result.length; i++) {

            if ($scope.result[i].inputTypeId == 2) {
                var v = $rootScope.formatDate($scope.result[i].value, "YYYY/MM/DD");
                $scope.result[i].checkResult = v;
            } else if ($scope.result[i].inputTypeId == 3) {
              if ($scope.result[i].value) {
                $scope.result[i].checkResult = $scope.result[i].value.value;
              }
            } else if ($scope.result[i].inputTypeId == 5) {
              if ($scope.chBoxResult[i]) {
                var result = "";
                for (var k = 0; k < $scope.userResource[i].length; k++){
                  if ($scope.chBoxResult[i][k]) {
                      if (result == "") {
                        result = $scope.chBoxResult[i][k]+"";
                      } else {
                        result = result + "、" + $scope.chBoxResult[i][k];
                      }
                  } else {
                    if (result == "") {
                      result = "0";
                    } else {
                      result = result + "、0";
                    }
                  }
                }
                $scope.result[i].checkResult = result;
              } else {
                $scope.result[i].checkResult = "";
              }
            } else if ($scope.result[i].inputTypeId == 12) {
            	if (typeof($scope.result[i].value) == 'undefined') {
                    $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を正しく入力してください。");
              	   return false;
                 }
              	  if ($scope.result[i].value == 0) {
              		  $scope.result[i].checkResult = "0";
              	  } else {
              		$scope.result[i].checkResult = $scope.result[i].value;
              	  }
            } else {
              if ($scope.result[i].inputTypeId == 7) {
                var imglist = $scope["imgList"+$scope.result[i].id];
                for (var j = 0; j < imglist.length; j++) {
                  var imgItemList = imglist[j];
                  for (var n = 0; n < imgItemList.length; n++) {
                    var imgCommOb = new Object();
                    imgCommOb.fileId = imgItemList[n].fileId;
                    imgCommOb.imgComm = imgItemList[n].imgComm;
                    imgCommentList.push(imgCommOb);
                  }
                }
              }

              if ($scope.result[i].value) {
                $scope.result[i].checkResult = $scope.result[i].value;
              }
            }
        }

        var getImgList = [];
        getImgList =  ajaxService.modifyImgComment(imgCommentList);

        ajaxService.modifyCheckResult($rootScope.projectId, $scope.ticketId, $scope.result, $scope.lat, $scope.lgt);
        if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            return false;
          } else {
            $rootScope.showInfoMessage("一時保存しました。");
            $scope.init($scope.ticketId, $scope.checkListInfo.checklistId);
            $scope.$parent.getCheckreportList($scope.ticketId);
            return true;
          };

      }


      $scope.delete360Camera = function(resultId) {
    	  if ($scope.isMustCheckResult(resultId)){
			  if($scope.showResult == '1'){
	            	$scope.result[0].value = "";
	        	} else {
	        		if ($scope.result[0].value == "1" || $scope.result[0].value == "2") {
    	        		$rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
    	                return ;
	        		}
	        	}
		  }

//        if ($scope.isMustCheckResult(resultId) && ($scope.result[0].value == "1" || $scope.result[0].value == "2")) {
//              $rootScope.showErrorMessage("必須項目を削除できません。チェック結果を「保留」、「対象外」にしてから、再度削除してください。");
//              return ;
//        }

        var resultList = [];
        resultList.push({"id":resultId, "checkResult":""});
        if ($scope.result[0].value == "") {
        	resultList.push({"id":$scope.result[0].id, "checkResult":""});
        }
        ajaxService.modifyCheckResult($rootScope.projectId, $scope.ticketId, resultList);
        $rootScope.showInfoMessage("削除しました。");
        $scope.init($scope.ticketId, $scope.checkListInfo.checklistId);
        $scope.$parent.getCheckreportList($scope.ticketId);
      };

      $scope.checkResultIsChange = function () {

        for (var i=0; i<$scope.result.length; i++) {

          if ($scope.result[i].inputTypeId == 2) {
            if ($rootScope.formatDate($scope.result[i].value, "YYYY/MM/DD") != $rootScope.formatDate($scope.baseResult[i].value, "YYYY/MM/DD")){
              return true;
            }
          } else if ($scope.result[i].inputTypeId == 3) {
            if ($scope.result[i].value.value != $scope.baseResult[i].value.value){
                  return true;
                }
          } else if ($scope.result[i].inputTypeId == 5) {

            var result = "";
            var hasValue = false;
            if  ($scope.chBoxResult[i]) {
              for (var k = 0; k < $scope.userResource[i].length; k++){
                    if ($scope.chBoxResult[i][k]) {
                        if (result == "") {
                          result = $scope.chBoxResult[i][k]+"";
                        } else {
                          result = result + "、" + $scope.chBoxResult[i][k];
                        }
                        if ($scope.chBoxResult[i][k] != 0) {
                          hasValue = true;
                        }
                    } else {
                      if (result == "") {
                        result = "0";
                      } else {
                        result = result + "、0";
                      }
                    }
                  }

                  if ($scope.baseResult[i].value) {
                    if (result != $scope.baseResult[i].value) {
                      return true;
                    }
                  } else {
                    if (result && hasValue) {
                      return true;
                    }
                  }
            }
          } else {
            if ($scope.result[i].value != $scope.baseResult[i].value) {
              return true;
            }
          }

        }
        return false;
      };

      $scope.isMustCheckResult = function (checkReusltId) {
        for (var i=1; i<$scope.result.length; i++) {
          if ($scope.result[i].id == checkReusltId) {
            if ($scope.result[i].mustFlg == "1"){
              return true;
            } else {
              return false;
            }
          }
        }
      };

      $scope.setNowTime = function (outerIndex) {
    	  $scope.result[outerIndex].value = new Date();
      };

      $scope.clearTime = function (outerIndex) {
    	  $scope.result[outerIndex].value = null;
      };


      $scope.showAddFileInDetail = function (item) {

    	  $uibModal.open({
              animation: true,
              templateUrl: "app/pages/checklist/checklistFile/addFileInDetail.html",
              controller: 'AddFileInDetailCtrl',
              backdrop : "static",
              scope : $scope,
              resolve: {
                  openFlag : function() {
                          return {
                              'flag' : 'Show',
                              'detailId': item.checkDetailId
                          };
                      }
              }
            });
      };

      $scope.openImgOrder = function (resultDetailId) {

    	 console.log($scope["imgbean"+resultDetailId]);

    	 $scope.imgOrderList = $scope["imgbean"+resultDetailId];
    	 $scope.imgResultDetailId = resultDetailId;

    	 $uibModal.open({
             animation : true,
             templateUrl : 'app/pages/checkreport/imgOrder.html',
             scope : $scope,
             backdrop : "static",
             resolve : {
                 message : function() {
                     return {
                     };
                 }
             }
         });
      };

      $scope.saveImgOrder = function () {

    	  var isOK = true;
    	  var errMsg = "";
    	  for (var i = 0; i < $scope.imgOrderList.length; i ++) {
    		  ajaxService.modifyImgOrder($scope.imgResultDetailId, $scope.imgOrderList[i].fileId, i);
    		  if (ajaxService.result['resultCd'] != "000000") {
    			  errMsg = tr.T(ajaxService.result['resultCd']);
    			  isOK = false;
    			  break;
    		  }
    	  }

    	  if (! isOK) {
    		  $rootScope.showErrorMessage(errMsg);
    	  } else {
    		  $rootScope.showInfoMessage("保存しました。");
    		  $scope.$$childTail.$dismiss();
    		  $scope.getImgList($scope.ticketId, $scope.imgResultDetailId);
    	  }
      };



    }
  })();



/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.checkreport')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.format = 'yyyy/MM/dd';
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
})();
/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.checkreport')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, $scope, baProgressModal) {

    	baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress($scope.aaaaa);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.checktarget').controller('ChecktargetCtrl', ChecktargetCtrl);

    /** @ngInject */
    function ChecktargetCtrl($scope, $filter, editableOptions, editableThemes, toastr,
            toastrConfig, ajaxService, $state, $location, $window, $uibModal, $rootScope, tr, Upload) {

    	if(! window.navigator.onLine){
    		//オフラインの場合、ダウンロードチケットへ遷移
    		window.location.href = "#/offline";
    		return;
    	}


        $rootScope.isHome = false;
        $rootScope.isProject = false;

    	if (!ajaxService.tokenCheck()) {
            return;
          };

          $scope.ctrl = $scope;

          $scope.changeTargetId = "";

      $scope.csvTitle = [];
      $scope.csvColumn = [];
      $scope.csvFileName = "対象工事.csv";

      $scope.smartTablePageSize = 20;

      $scope.showTargetId = false;
      $scope.showTargetName = false;
      $scope.showFirst = false;
      $scope.showSecond = false;
      $scope.showThird = false;
      $scope.showObjType = false;
      $scope.showRegion = false;
      $scope.showPref = false;
      $scope.showMuniName = false;
      $scope.showAddress = false;
      $scope.showLatitude = false;
      $scope.showLongitude = false;


      $scope.showKbn1 = false;
      $scope.showKbn2 = false;
      $scope.showKbn3 = false;
      $scope.showKbn4 = false;
      $scope.showKbn5 = false;

      $scope.showItem1 = false;
      $scope.showItem2 = false;
      $scope.showItem3 = false;
      $scope.showItem4 = false;
      $scope.showItem5 = false;
      $scope.showItem6 = false;
      $scope.showItem7 = false;
      $scope.showItem8 = false;
      $scope.showItem9 = false;
      $scope.showItem10 = false;
      $scope.showItem11 = false;
      $scope.showItem12 = false;
      $scope.showItem13 = false;
      $scope.showItem14 = false;
      $scope.showItem15 = false;
      $scope.showItem16 = false;
      $scope.showItem17 = false;
      $scope.showItem18 = false;
      $scope.showItem19 = false;
      $scope.showItem20 = false;

      $rootScope.initTarget = {prefCd :$rootScope.prefList[0], region: $rootScope.regionList[0]};
      //工事項目リストを取得
      $scope.itemNameList = ajaxService.getTargetItemList($rootScope.projectId);

      $scope.firstList = ajaxService.getProjectResourceList($rootScope.projectId, '1', 0);
      if ($scope.firstList.length == 0) {
        $scope.firstList.push({label:"マスタデータがありません", id:0});
        $scope.firstDisable = true;
      } else {
          $scope.firstDisable = false;
          $scope.firstList.unshift({label:" ", id:0});
      }
      $scope.first = $scope.firstList[0];


      $scope.secondList = [];
      if ($scope.first.id != 0) {
          $scope.secondList = ajaxService.getProjectResourceList($rootScope.projectId, '2', $scope.first.id);
          if ($scope.secondList.length == 0) {
            $scope.secondList.push({label:"マスタデータがありません", id:0});
              $scope.secondDisable = true;
          } else {
              $scope.secondDisable = false;
              $scope.secondList.unshift({label:" ", id:0});
          }
      } else {
          $scope.secondList.push({label:"マスタデータがありません", id:0});
          $scope.secondDisable = true;
      }
      $scope.second = $scope.secondList[0];

      $scope.thirdList = [];
      if ($scope.second.id != 0) {
          $scope.thirdList = ajaxService.getProjectResourceList($rootScope.projectId, '3', $scope.second.id);
          if ($scope.thirdList.length == 0) {
            $scope.thirdList.push({label:"マスタデータがありません", id:0});
              $scope.thirdDisable = true;
          } else {
              $scope.thirdDisable = false;
              $scope.thirdList.unshift({label:" ", id:0});
          }
      } else {
          $scope.thirdList.push({label:"マスタデータがありません", id:0});
          $scope.thirdDisable = true;
      }
      $scope.third = $scope.thirdList[0];

      $scope.changeFirst = function () {
        $scope.secondList = ajaxService.getProjectResourceList($rootScope.projectId, '2', $scope.first.id);
          if ($scope.secondList.length == 0) {
            $scope.secondList.push({label:"マスタデータがありません", id:0});
              $scope.secondDisable = true;
          } else {
              $scope.secondDisable = false;
              $scope.secondList.unshift({label:" ", id:0});
          }
          $scope.second = $scope.secondList[0];
          $scope.changeSecond();
      };
      $scope.changeSecond = function () {
          $scope.thirdList = ajaxService.getProjectResourceList($rootScope.projectId, '3', $scope.second.id);
            if ($scope.thirdList.length == 0) {
              $scope.thirdList.push({label:"マスタデータがありません", id:0});
                $scope.thirdDisable = true;
            } else {
                $scope.thirdDisable = false;
                $scope.thirdList.unshift({label:" ", id:0});
            }
            $scope.third = $scope.thirdList[0];
        };


      $scope.showChecktargetCreate = function() {
        $scope.targetItemList = new Array();
        for (var i=0; i<$scope.itemNameList.length; i++) {
          if (i % 2 == 0) {
            var obj = {"left":null, "right": null};
              obj["left"] = $scope.itemNameList[i];
              if (i == $scope.itemNameList.length - 1) {
                $scope.targetItemList.push(obj);
              }
          } else {
            obj["right"] = $scope.itemNameList[i];
            $scope.targetItemList.push(obj);
          }
        }

        $scope.kbn1Ob = new Object();
        $scope.kbn2Ob = new Object();
        $scope.kbn3Ob = new Object();
        $scope.kbn4Ob = new Object();
        $scope.kbn5Ob = new Object();

          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checktarget/newCheckTarget.html',
              controller : 'ChecktargetCtrl',
              scope : $scope,
              backdrop : "static",
              size: 'lg',
              resolve : {
                  message : function() {
                      return {
                        type : ""
                      };
                  }
              }
          });
      };

      $scope.createCheckTarget = function() {

        var target = new Object();
        var show = new Object();
        for (var i=0; i<$scope.itemNameList.length; i++) {
          var field = $scope.itemNameList[i].fieldName;
          target[field] = $("#"+field).val();
          show[field] = $scope.itemNameList[i].showName;

          if ($scope.itemNameList[i].isShow == '3') {
        	  if ($scope.itemNameList[i].entryId == '1' && !target[field]) {
                  $rootScope.showErrorMessage(show[field]+"を入力してください。");
                  return true;
        	  } else if ($scope.itemNameList[i].entryId == '3') {
        		  if (field == 'kbn1') {
        			  if (! $scope.kbn1Ob || $scope.kbn1Ob.id == null) {
                          $rootScope.showErrorMessage(show[field]+"を選択してください。");
                          return true;
        			  }
        		  }
        		  if (field == 'kbn2') {
        			  if (! $scope.kbn2Ob || $scope.kbn2Ob.id == null) {
                          $rootScope.showErrorMessage(show[field]+"を選択してください。");
                          return true;
        			  }
        		  }
        		  if (field == 'kbn3') {
        			  if (! $scope.kbn3Ob || $scope.kbn3Ob.id == null) {
                          $rootScope.showErrorMessage(show[field]+"を選択してください。");
                          return true;
        			  }
        		  }
        		  if (field == 'kbn4') {
        			  if (! $scope.kbn4Ob || $scope.kbn4Ob.id == null) {
                          $rootScope.showErrorMessage(show[field]+"を選択してください。");
                          return true;
        			  }
        		  }
        		  if (field == 'kbn5') {
        			  if (! $scope.kbn5Ob || $scope.kbn5Ob.id == null) {
                          $rootScope.showErrorMessage(show[field]+"を選択してください。");
                          return true;
        			  }
        		  }
        	  }
          }

        }

        target.first = $scope.first.id;
        target.second = $scope.second.id;
        target.third = $scope.third.id;


        if ($scope.kbn1Ob) {
            target.kbn1Id = $scope.kbn1Ob.id;
        } else {
        	target.kbn1Id = 0;
        }
        if ($scope.kbn2Ob) {
            target.kbn2Id = $scope.kbn2Ob.id;
        } else {
            target.kbn2Id = 0;
        }
        if ($scope.kbn3Ob) {
            target.kbn3Id = $scope.kbn3Ob.id;
        } else {
            target.kbn3Id = 0;
        }
        if ($scope.kbn4Ob) {
            target.kbn4Id = $scope.kbn4Ob.id;
        } else {
            target.kbn4Id = 0;
        }
        if ($scope.kbn5Ob) {
            target.kbn5Id = $scope.kbn5Ob.id;
        } else {
            target.kbn5Id = 0;
        }

        target.region = $rootScope.initTarget.region.value;
        if (target.region != '') {
          target.regionName = $rootScope.initTarget.region.label;
        }
        target.prefCd = $rootScope.initTarget.prefCd.value;
        if (target.prefCd != '') {
          target.prefName = $rootScope.initTarget.prefCd.label;
        }

        if (! target.targetId || target.targetId.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
//            $rootScope.showErrorMessage(show.targetId+"を入力してください。");
//            return true;
        	target.targetId = "未設定";
        }
        if (target.targetId.length > 24) {
            $rootScope.showErrorMessage(show.targetId+"は24桁以内で入力してください。");
            return true;
        }
        if (! target.targetName || target.targetName.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
            $rootScope.showErrorMessage(show.targetName+"を入力してください。");
            return true;
        }
        if (target.targetName.length > 256) {
            $rootScope.showErrorMessage(show.targetName+"は256桁以内で入力してください。");
            return true;
        }

        if (target.objType && target.objType.length > 256) {
            $rootScope.showErrorMessage(show.objType+"は256桁以内で入力してください。");
            return true;
        }
        if (target.muniName && target.muniName.length > 64) {
            $rootScope.showErrorMessage(show.muniName+"は64桁以内で入力してください。");
            return true;
        }
        if (target.address && target.address.length > 256) {
            $rootScope.showErrorMessage(show.address+"は256桁以内で入力してください。");
            return true;
        }
        if (target.latitude && target.latitude.length > 32) {
            $rootScope.showErrorMessage(show.latitude+"は32桁以内で入力してください。");
            return true;
        }
        if (target.longitude && target.longitude.length > 32) {
            $rootScope.showErrorMessage(show.longitude+"は32桁以内で入力してください。");
            return true;
        }
        ajaxService.createTarget($rootScope.projectId, target);
        if (ajaxService.result['resultCd'] == "E07002") {
            $rootScope.showErrorMessage("すでに登録されている"+show.targetId+"です。");
            return true;
        }

        if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            return true;
        }
        //一覧を取得
        if ($scope.$parent.getChecktargetList) {
          $scope.$parent.getChecktargetList();
        }

        $rootScope.showInfoMessage("対象工事を新規しました。");
        if (typeof $scope.$close == "function"){
            $scope.$close();
        }
        $scope.$dismiss();
      };


      $scope.getChecktargetList = function() {
        $scope.csvTitle = [];
        $scope.csvColumn = [];
      //トークン確認
  //            if (!ajaxService.tokenCheck()) {
  //                return;
  //            };

      $scope.checktargetList = ajaxService.searchTargetList($rootScope.projectId);

      for (var i=0; i<$scope.itemNameList.length; i++) {
        if ($scope.itemNameList[i].fieldName == 'targetId') {
            $scope.showTargetId = true;
            $scope.itemTargetId = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'targetName') {
            $scope.showTargetName = true;
            $scope.itemTargetName = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'first') {
            $scope.showFirst = true;
            $scope.itemFirst = $scope.itemNameList[i].showName;
            $scope.csvTitle.push($scope.itemFirst);
            $scope.csvColumn.push('firstName');
            continue;
        }
        if ($scope.itemNameList[i].fieldName == 'second') {
            $scope.showSecond = true;
            $scope.itemSecond = $scope.itemNameList[i].showName;
            $scope.csvTitle.push($scope.itemSecond);
            $scope.csvColumn.push('secondName');
            continue;
        }
        if ($scope.itemNameList[i].fieldName == 'third') {
            $scope.showThird = true;
            $scope.itemThird = $scope.itemNameList[i].showName;
            $scope.csvTitle.push($scope.itemThird);
            $scope.csvColumn.push('thirdName');
            continue;
        }
        if ($scope.itemNameList[i].fieldName == 'objType') {
            $scope.showObjType = true;
            $scope.itemObjType = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'region') {
            $scope.showRegion = true;
            $scope.itemRegion = $scope.itemNameList[i].showName;
            $scope.csvTitle.push($scope.itemRegion);
            $scope.csvColumn.push('regionName');
            continue;
        }
        if ($scope.itemNameList[i].fieldName == 'prefCd') {
            $scope.showPref = true;
            $scope.itemPref = $scope.itemNameList[i].showName;
            $scope.csvTitle.push($scope.itemPref);
            $scope.csvColumn.push('prefName');
            continue;
        }
        if ($scope.itemNameList[i].fieldName == 'muniName') {
            $scope.showMuniName = true;
            $scope.itemMuniName = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'address') {
            $scope.showAddress = true;
            $scope.itemAddress = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'latitude') {
            $scope.showLatitude = true;
            $scope.itemLatitude = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'longitude') {
            $scope.showLongitude = true;
            $scope.itemLongitude = $scope.itemNameList[i].showName;
        }

        if ($scope.itemNameList[i].fieldName == "kbn1") {
        	$scope.showKbn1 = true;
            $scope.itemKbn1 = $scope.itemNameList[i].showName;
            $scope.csvTitle.push($scope.itemKbn1);
            $scope.csvColumn.push('kbn1');
            continue;
        }
        if ($scope.itemNameList[i].fieldName == "kbn2") {
        	$scope.showKbn2 = true;
            $scope.itemKbn2 = $scope.itemNameList[i].showName;
            $scope.csvTitle.push($scope.itemKbn2);
            $scope.csvColumn.push('kbn2');
            continue;
        }
        if ($scope.itemNameList[i].fieldName == "kbn3") {
        	$scope.showKbn3 = true;
            $scope.itemKbn3 = $scope.itemNameList[i].showName;
            $scope.csvTitle.push($scope.itemKbn3);
            $scope.csvColumn.push('kbn3');
            continue;
        }
        if ($scope.itemNameList[i].fieldName == "kbn4") {
        	$scope.showKbn4 = true;
            $scope.itemKbn4 = $scope.itemNameList[i].showName;
            $scope.csvTitle.push($scope.itemKbn4);
            $scope.csvColumn.push('kbn4');
            continue;
        }
        if ($scope.itemNameList[i].fieldName == "kbn5") {
        	$scope.showKbn5 = true;
            $scope.itemKbn5 = $scope.itemNameList[i].showName;
            $scope.csvTitle.push($scope.itemKbn5);
            $scope.csvColumn.push('kbn5');
            continue;
        }

        if ($scope.itemNameList[i].fieldName == 'remarks1') {
            $scope.showItem1 = true;
            $scope.itemItem1 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks2') {
            $scope.showItem2 = true;
            $scope.itemItem2 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks3') {
            $scope.showItem3 = true;
            $scope.itemItem3 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks4') {
            $scope.showItem4 = true;
            $scope.itemItem4 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks5') {
            $scope.showItem5 = true;
            $scope.itemItem5 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks6') {
            $scope.showItem6 = true;
            $scope.itemItem6 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks7') {
            $scope.showItem7 = true;
            $scope.itemItem7 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks8') {
            $scope.showItem8 = true;
            $scope.itemItem8 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks9') {
            $scope.showItem9 = true;
            $scope.itemItem9 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks10') {
            $scope.showItem10 = true;
            $scope.itemItem10 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks11') {
            $scope.showItem11 = true;
            $scope.itemItem11 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks12') {
            $scope.showItem12 = true;
            $scope.itemItem12 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks13') {
            $scope.showItem13 = true;
            $scope.itemItem13 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks14') {
            $scope.showItem14 = true;
            $scope.itemItem14 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks15') {
            $scope.showItem15 = true;
            $scope.itemItem15 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks16') {
            $scope.showItem16 = true;
            $scope.itemItem16 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks17') {
            $scope.showItem17 = true;
            $scope.itemItem17 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks18') {
            $scope.showItem18 = true;
            $scope.itemItem18 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks19') {
            $scope.showItem19 = true;
            $scope.itemItem19 = $scope.itemNameList[i].showName;
        }
        if ($scope.itemNameList[i].fieldName == 'remarks20') {
            $scope.showItem20 = true;
            $scope.itemItem20 = $scope.itemNameList[i].showName;
        }

        $scope.csvTitle.push($scope.itemNameList[i].showName);
        $scope.csvColumn.push($scope.itemNameList[i].fieldName);
      }
      $scope.csvTitle.push("操作区分(1:追加 2:変更 3:削除)");
    };

    $scope.getChecktargetList();


    $scope.kbn1List = [];
	 if ($scope.showKbn1) {
		 $scope.kbn1List = ajaxService.getProjectResourceList($rootScope.projectId, '9', 0);
		 $scope.kbn1List.unshift({label:" ", id:null});
	 }
	 $scope.kbn2List = [];
	 if ($scope.showKbn2) {
		 $scope.kbn2List = ajaxService.getProjectResourceList($rootScope.projectId, '10', 0);
		 $scope.kbn2List.unshift({label:" ", id:null});
	 }
	 $scope.kbn3List = [];
	 if ($scope.showKbn3) {
		 $scope.kbn3List = ajaxService.getProjectResourceList($rootScope.projectId, '11', 0);
		 $scope.kbn3List.unshift({label:" ", id:null});
	 }
	 $scope.kbn4List = [];
	 if ($scope.showKbn4) {
		 $scope.kbn4List = ajaxService.getProjectResourceList($rootScope.projectId, '12', 0);
		 $scope.kbn4List.unshift({label:" ", id:null});
	 }
	 $scope.kbn5List = [];
	 if ($scope.showKbn5) {
		 $scope.kbn5List = ajaxService.getProjectResourceList($rootScope.projectId, '13', 0);
		 $scope.kbn5List.unshift({label:" ", id:null});
	 }

	 $scope.getKbn1Ob = function (value) {
        for (var i = 0; i < $scope.kbn1List.length; i++) {
          if (value == $scope.kbn1List[i].id) {
            return $scope.kbn1List[i];
          }
        }
        return new Object();
      };

 	 $scope.getKbn2Ob = function (value) {
         for (var i = 0; i < $scope.kbn2List.length; i++) {
           if (value == $scope.kbn2List[i].id) {
             return $scope.kbn2List[i];
           }
         }
         return new Object();
       };

  	 $scope.getKbn3Ob = function (value) {
          for (var i = 0; i < $scope.kbn3List.length; i++) {
            if (value == $scope.kbn3List[i].id) {
              return $scope.kbn3List[i];
            }
          }
          return new Object();
        };
   	 $scope.getKbn4Ob = function (value) {
         for (var i = 0; i < $scope.kbn4List.length; i++) {
           if (value == $scope.kbn4List[i].id) {
             return $scope.kbn4List[i];
           }
         }
         return new Object();
       };
  	 $scope.getKbn5Ob = function (value) {
         for (var i = 0; i < $scope.kbn5List.length; i++) {
           if (value == $scope.kbn5List[i].id) {
             return $scope.kbn5List[i];
           }
         }
         return new Object();
       };

    $scope.showChecktargetDetail = function (id) {

    	$rootScope.targetIdForTicket = null;
        $("#ticketList").css({
            'display' : 'none'
          });

      // 工事検索
      $scope.selectedTarget = ajaxService.searchTarget(id);

 	  $scope.kbn1Ob = $scope.getKbn1Ob($scope.selectedTarget.kbn1Id);
 	  $scope.kbn2Ob = $scope.getKbn2Ob($scope.selectedTarget.kbn2Id);
 	  $scope.kbn3Ob = $scope.getKbn3Ob($scope.selectedTarget.kbn3Id);
 	  $scope.kbn4Ob = $scope.getKbn4Ob($scope.selectedTarget.kbn4Id);
 	  $scope.kbn5Ob = $scope.getKbn5Ob($scope.selectedTarget.kbn5Id);

      $scope.firstList = ajaxService.getProjectResourceList($rootScope.projectId, '1', 0);
      if ($scope.firstList.length == 0) {
        $scope.firstList.push({label:"マスタデータがありません", id:0});
        $scope.firstDisable = true;
        $scope.first = $scope.firstList[0];
      } else {
          $scope.firstDisable = false;
          $scope.firstList.unshift({label:" ", id:0});
          for (var i = 0; i < $scope.firstList.length; i ++) {
            if ($scope.firstList[i].id == $scope.selectedTarget.first){
              $scope.first = $scope.firstList[i];
              break;
            }
          }
      }

      $scope.secondList = [];
      if ($scope.first.id != 0) {
          $scope.secondList = ajaxService.getProjectResourceList($rootScope.projectId, '2', $scope.first.id);
          if ($scope.secondList.length == 0) {
              $scope.secondList.push({label:"マスタデータがありません", id:0});
              $scope.secondDisable = true;
              $scope.second = $scope.secondList[0];
          } else {
              $scope.secondDisable = false;
              $scope.secondList.unshift({label:" ", id:0});
              for (var i = 0; i < $scope.secondList.length; i ++) {
                if ($scope.secondList[i].id == $scope.selectedTarget.second){
                  $scope.second = $scope.secondList[i];
                  break;
                }
              }
          }
      } else {
          $scope.secondList.push({label:"マスタデータがありません", id:0});
          $scope.secondDisable = true;
          $scope.second = $scope.secondList[0];
      }

      $scope.thirdList = [];
      if ($scope.second.id != 0) {
          $scope.thirdList = ajaxService.getProjectResourceList($rootScope.projectId, '3', $scope.second.id);
          if ($scope.thirdList.length == 0) {
            $scope.thirdList.push({label:"マスタデータがありません", id:0});
              $scope.thirdDisable = true;
              $scope.third = $scope.thirdList[0];
          } else {
              $scope.thirdDisable = false;
              $scope.thirdList.unshift({label:" ", id:0});
              for (var i = 0; i < $scope.thirdList.length; i ++) {
                  if ($scope.thirdList[i].id == $scope.selectedTarget.third){
                    $scope.third = $scope.thirdList[i];
                    break;
                  }
                }
          }
      } else {
          $scope.thirdList.push({label:"マスタデータがありません", id:0});
          $scope.thirdDisable = true;
          $scope.third = $scope.thirdList[0];
      }

      $scope.selectedTar = {};
      $scope.selectedTar.pref = $rootScope.getPrefOb($scope.selectedTarget.prefCd);
      $scope.selectedTar.reg = $rootScope.getRegionOb($scope.selectedTarget.region);

      $scope.targetItemList = new Array();
      $scope.show = {};
      $scope.isShow = {};
      for (var i=0; i<$scope.itemNameList.length; i++) {
        var field = $scope.itemNameList[i].fieldName;
        $scope.show[field] = $scope.itemNameList[i].showName;
        $scope.isShow[field] = $scope.itemNameList[i].isShow;
        if (i % 2 == 0) {
          var obj = {"left":null, "right": null};
            obj["left"] = $scope.itemNameList[i];
            if (i == $scope.itemNameList.length - 1) {
              $scope.targetItemList.push(obj);
            }
        } else {
          obj["right"] = $scope.itemNameList[i];
          $scope.targetItemList.push(obj);
        }
      }

      $scope.searchFileList();

      $("#checktargetDetail").css({
        'display' : 'block'
      });
      $("#fileList").css({
        'display' : 'block'
      });
      $("body,html").animate({
          scrollTop : $("#checktargetDetail").offset().top - 100
      }, 1000);
    };

    $scope.modifyTarget = function () {

    	if ($scope.isShow.kbn1 == '3') {
    		if (! $scope.kbn1Ob || $scope.kbn1Ob.id == null) {
                $rootScope.showErrorMessage($scope.show.kbn1+"を選択してください。");
                return;
			  }
    	}
    	if ($scope.isShow.kbn2 == '3') {
    		if (! $scope.kbn2Ob || $scope.kbn2Ob.id == null) {
                $rootScope.showErrorMessage($scope.show.kbn2+"を選択してください。");
                return;
			  }
    	}
    	if ($scope.isShow.kbn3 == '3') {
    		if (! $scope.kbn3Ob || $scope.kbn3Ob.id == null) {
                $rootScope.showErrorMessage($scope.show.kbn3+"を選択してください。");
                return;
			  }
    	}
    	if ($scope.isShow.kbn4 == '3') {
    		if (! $scope.kbn4Ob || $scope.kbn4Ob.id == null) {
                $rootScope.showErrorMessage($scope.show.kbn4+"を選択してください。");
                return;
			  }
    	}
    	if ($scope.isShow.kbn5 == '3') {
    		if (! $scope.kbn5Ob || $scope.kbn5Ob.id == null) {
                $rootScope.showErrorMessage($scope.show.kbn5+"を選択してください。");
                return;
			  }
    	}

    	if ($scope.isShow.remarks1 == '3') {
    	      if (! $scope.selectedTarget.remarks1 || $scope.selectedTarget.remarks1.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks1+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks2 == '3') {
    	      if (! $scope.selectedTarget.remarks2 || $scope.selectedTarget.remarks2.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks2+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks3 == '3') {
    	      if (! $scope.selectedTarget.remarks3 || $scope.selectedTarget.remarks3.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks3+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks4 == '3') {
    	      if (! $scope.selectedTarget.remarks4 || $scope.selectedTarget.remarks4.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks4+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks5 == '3') {
    	      if (! $scope.selectedTarget.remarks5 || $scope.selectedTarget.remarks5.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks5+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks6 == '3') {
    	      if (! $scope.selectedTarget.remarks6 || $scope.selectedTarget.remarks6.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks6+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks7 == '3') {
    	      if (! $scope.selectedTarget.remarks7 || $scope.selectedTarget.remarks7.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks7+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks8 == '3') {
    	      if (! $scope.selectedTarget.remarks8 || $scope.selectedTarget.remarks8.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks8+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks9 == '3') {
    	      if (! $scope.selectedTarget.remarks9 || $scope.selectedTarget.remarks9.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks9+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks10 == '3') {
    	      if (! $scope.selectedTarget.remarks10 || $scope.selectedTarget.remarks10.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks10+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks11 == '3') {
    	      if (! $scope.selectedTarget.remarks11 || $scope.selectedTarget.remarks11.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks11+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks12 == '3') {
    	      if (! $scope.selectedTarget.remarks12 || $scope.selectedTarget.remarks12.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks12+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks13 == '3') {
    	      if (! $scope.selectedTarget.remarks13 || $scope.selectedTarget.remarks13.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks13+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks14 == '3') {
    	      if (! $scope.selectedTarget.remarks14 || $scope.selectedTarget.remarks14.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks14+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks15 == '3') {
    	      if (! $scope.selectedTarget.remarks15 || $scope.selectedTarget.remarks15.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks15+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks16 == '3') {
    	      if (! $scope.selectedTarget.remarks16 || $scope.selectedTarget.remarks16.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks16+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks17 == '3') {
    	      if (! $scope.selectedTarget.remarks17 || $scope.selectedTarget.remarks17.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks17+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks18 == '3') {
    	      if (! $scope.selectedTarget.remarks18 || $scope.selectedTarget.remarks18.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks18+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks19 == '3') {
    	      if (! $scope.selectedTarget.remarks19 || $scope.selectedTarget.remarks19.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks19+"を入力してください。");
                  return;
    	      }
    	}
    	if ($scope.isShow.remarks20 == '3') {
    	      if (! $scope.selectedTarget.remarks20 || $scope.selectedTarget.remarks20.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
                  $rootScope.showErrorMessage($scope.show.remarks20+"を入力してください。");
                  return;
    	      }
    	}

      if ($scope.selectedTar.pref) {
        $scope.selectedTarget.prefCd = $scope.selectedTar.pref.value;
          $scope.selectedTarget.prefName = $scope.selectedTar.pref.label;
      }
      if ($scope.selectedTar.reg) {
        $scope.selectedTarget.region = $scope.selectedTar.reg.value;
          $scope.selectedTarget.regionName = $scope.selectedTar.reg.label;
      }


      $scope.selectedTarget.first = $scope.first.id;
      $scope.selectedTarget.second = $scope.second.id;
      $scope.selectedTarget.third = $scope.third.id;

      if ($scope.showKbn1) {
    	$scope.selectedTarget.kbn1Id = $scope.kbn1Ob.id;
      }
      if ($scope.showKbn2) {
      	$scope.selectedTarget.kbn2Id = $scope.kbn2Ob.id;
      }
      if ($scope.showKbn3) {
      	$scope.selectedTarget.kbn3Id = $scope.kbn3Ob.id;
      }
      if ($scope.showKbn4) {
      	$scope.selectedTarget.kbn4Id = $scope.kbn4Ob.id;
      }
      if ($scope.showKbn5) {
      	$scope.selectedTarget.kbn5Id = $scope.kbn5Ob.id;
      }


      if (! $scope.selectedTarget.targetId || $scope.selectedTarget.targetId.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
          $rootScope.showErrorMessage($scope.show.targetId+"を入力してください。");
          return;
      }
      if ($scope.selectedTarget.targetId.length > 24) {
          $rootScope.showErrorMessage($scope.show.targetId+"は24桁以内で入力してください。");
          return;
      }
      if (! $scope.selectedTarget.targetName || $scope.selectedTarget.targetName.replace(/^[\s|　]+|[\s|　]+$/g,'') == "") {
          $rootScope.showErrorMessage($scope.show.targetName+"を入力してください。");
          return;
      }
      if ($scope.selectedTarget.targetName.length > 256) {
          $rootScope.showErrorMessage($scope.show.targetName+"は256桁以内で入力してください。");
          return;
      }
      if ($scope.selectedTarget.objType && $scope.selectedTarget.objType.length > 256) {
          $rootScope.showErrorMessage($scope.show.objType+"は256桁以内で入力してください。");
          return;
      }
      if ($scope.selectedTarget.muniName && $scope.selectedTarget.muniName.length > 64) {
          $rootScope.showErrorMessage($scope.show.muniName+"は64桁以内で入力してください。");
          return;
      }
      if ($scope.selectedTarget.address && $scope.selectedTarget.address.length > 256) {
          $rootScope.showErrorMessage($scope.show.address+"は256桁以内で入力してください。");
          return;
      }
      if ($scope.selectedTarget.latitude && $scope.selectedTarget.latitude.length > 32) {
          $rootScope.showErrorMessage($scope.show.latitude+"は32桁以内で入力してください。");
          return;
      }
      if ($scope.selectedTarget.longitude && $scope.selectedTarget.longitude.length > 32) {
          $rootScope.showErrorMessage($scope.show.longitude+"は32桁以内で入力してください。");
          return;
      }

      if ($scope.changeTargetId != "") {
    	  $scope.selectedTarget.targetId = $scope.changeTargetId;
      }

      ajaxService.modifyTarget($scope.selectedTarget);
      if (ajaxService.result['resultCd'] != "000000") {
          $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
          return;
      }
      $rootScope.showInfoMessage("対象工事を更新しました。");
      $scope.getChecktargetList();
    };

    $scope.uploadFiles = function(file) {
        var name = file.name;
        if (name.toLowerCase().indexOf(".csv") == -1) {
          $rootScope.showErrorMessage("csvファイルをアップロードしてください。");
          return;
        }

        var modalInstance = $uibModal.open({
            animation : true,
            templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
            controller : 'confirmDialogCtrl',
            scope : $scope,
            backdrop : "static",
            resolve : {
                message : function() {
                    return {
                        message : "アップロードを実施してもよろしいですか？"
                    };
                }
            }
        });

        modalInstance.result.then(function() {
        	if (file) {
                Upload.upload({
                    url : urlPrefix + "checktarget/upload",
                    type : "POST",
                    headers : {
                        "authorization" : localStorage.authId,
                    },
                    dataType : "multipart/form-data",
                    data : {
                        'projectId': $rootScope.projectId, "schema" : localStorage.schema, 'loginId':localStorage.userId, file : file
                    }
                }).progress(function (evt) {
                    //progress
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    if (progressPercentage != 100) {
                      $rootScope.showInfoMessage("アップロード中：" + progressPercentage + "%");
                    }
                }).then(function(response) {
                    var name = response.config.data.file.name;
                    if (response.data.resultCd == "000000") {
                        $scope.update = response.data.updateCount;
                        $scope.skipUpdate = response.data.skipUpdate;
                        if ($scope.update > 0) {
                          $scope.getChecktargetList();
                        }
                        // errorFile
                        if (response.data.skipUpdate > 0) {
                             // データを用意する
                            var bom = new Uint8Array(
                                    [ 0xEF, 0xBB, 0xBF ]);
                            var content = "行番, エラーメッセージ";
                            content = content + "\n";
                            for (var i=0; i<response.data.skipUpdateInfo.length; i++) {
                                content = content + response.data.skipUpdateInfo[i] + "\n";
                            }
                            var blob = new Blob([ bom, content ], {
                                "type" : "text/csv"
                            });

                            // 出力
                            if ($window.navigator.msSaveBlob) {
                                $window.navigator.msSaveBlob(blob, "アップロード結果.csv");
                            } else {
                                var downloadLink = $('<a></a>');
                                downloadLink.attr('href', $window.URL.createObjectURL(blob));
                                downloadLink.attr('download', "アップロード結果.csv");
                                downloadLink.attr('target', '_blank');
                                $('body').append(downloadLink);
                                downloadLink[0].click();
                                downloadLink.remove();
                            }
                            $rootScope.showErrorMessage("エラーにより一部のデータが取り込まれていません。詳しくは出力した「アップロード結果.csv」ファイルを参照してください。");
                        } else {
                            $rootScope.showInfoMessage("アップロードが完了しました。");
                        }

                    } else {
                      $rootScope.showErrorMessage(tr.T(response.data.resultCd));
                    }
                }, function(response) {
                    if (response.status > 0)
                      $rootScope.showErrorMessage(response.status + ': ' + response.data);
                }, function(evt) {
//                    var progressPercentage = parseInt(100.0 *
//                            evt.loaded / evt.total);
//                    $scope.f.progressRate = progressPercentage;
                });
            }
        });

    };


    $scope.removeTarget = function () {

      var ticketNum = ajaxService.getTicketNumByTargetId($scope.selectedTarget.id);
      if (ticketNum !=0) {
        $rootScope.showErrorMessage("該当対象工事が使用されているため、削除できません。");
        return ;
      }

      var modalInstance = $uibModal.open({
          animation : true,
          templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
          controller : 'confirmDialogCtrl',
          scope : $scope,
          backdrop : "static",
          resolve : {
              message : function() {
                  return {
                      message : "削除してもよろしいですか？"
                  };
              }
          }
      });
      modalInstance.result.then(function() {
        ajaxService.removeTarget($scope.selectedTarget.id, $rootScope.projectId);
        if (ajaxService.result['resultCd'] != "000000") {
          $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        } else {
          $rootScope.showInfoMessage("対象工事を削除しました。");
          $scope.getChecktargetList();
          $("#checktargetDetail").css({
            'display' : 'none'
          });
          $("#fileList").css({
            'display' : 'none'
          });
          $("#ticketList").css({
              'display' : 'none'
            });
        }
      });
    };

    $scope.openUploadDialog = function() {
        $uibModal.open({
            animation : true,
            templateUrl : 'app/pages/checklist/fileUploadModal.html',
            controller : 'FileUploadCtrl',
            scope : $scope,
            backdrop : "static",
            resolve : {
                openFlag : function() {
                    return {
                        'flag' : 'New',
                        'kbn' : 'Checktarget',
                        'id': $scope.selectedTarget.id
                    };
                }
            }
        });
    };

    $scope.searchFileList = function () {
        $scope.fileList = ajaxService.getFileListTarget($scope.selectedTarget.id);
    };

    $scope.delFile = function (fileBean) {
      var modalInstance = $uibModal.open({
          animation : true,
          templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
          controller : 'confirmDialogCtrl',
          scope : $scope,
          backdrop : "static",
          resolve : {
              message : function() {
                  return {
                      message : "該当ファイルを削除してもよろしいですか？"
                  };
              }
          }
      });
      modalInstance.result.then(function() {
        ajaxService.removeFileTarget($rootScope.projectId, $scope.selectedTarget.id, fileBean.id, fileBean.fileExternal);
        if (ajaxService.result['resultCd'] != "000000") {
          $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        } else {
          $rootScope.showInfoMessage("該当ファイルを削除しました。");
          $scope.searchFileList();
        }
      });
    };

    $scope.showCheckreportList = function () {
    	$rootScope.targetIdForTicket = $scope.selectedTarget.id;

        $("#ticketList").css({
          'display' : 'block'
        });
        $("body,html").animate({
            scrollTop : $("#ticketList").offset().top - 100
        }, 1000);
    };

    $scope.showItem = function () {

    	$uibModal.open({
            animation : true,
            templateUrl : 'app/pages/checktarget/checktargetItemInfo.html',
            controller: 'ItemnameCtrl',
            scope : $scope,
            size: 'lg',
            backdrop : "static",
            resolve : {
                message : function() {
                    return {
                      type : ""
                    };
                }
            }
        });
    };

    $scope.reload = function () {
    	window.location.reload();
    };

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .directive('dashboardCalendar2', dashboardCalendar2);

  /** @ngInject */
  function dashboardCalendar2() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl2',
      templateUrl: 'app/pages/home/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .controller('DashboardCalendarCtrl2', DashboardCalendarCtrl2);

  /** @ngInject */
  function DashboardCalendarCtrl2($scope, $filter, $stateParams, ajaxService, $rootScope,
          $interval, stopableInterval, toastr, toastrConfig,
          editableOptions, editableThemes, baConfig) {

    $scope.ctrl = $scope;

    $scope.totalNum = 0;

    $scope.mngKbn = localStorage.mngKbn;

    $scope.adminMng = $scope.$$prevSibling.adminMng;

    $scope.userList = ajaxService.selectUserList($rootScope.projectId);
    $scope.userList.unshift({userName:" ", userId:''});

    for (var i=0; i<$scope.userList.length; i++) {
        if (localStorage.userId == $scope.userList[i].userId) {
          $scope.loginUser = $scope.userList[i];
          break;
        }
      }

    $scope.groupIdList = [];
    if (localStorage.mngKbn != '2') {
	   for (var j=0; j<$scope.loginUser.groupList.length; j++) {
		   $scope.groupIdList.push($scope.loginUser.groupList[j].groupId);
       }
    } else {
	   var groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
	   for (var j=0; j<groupList.length; j++) {
		   $scope.groupIdList.push(groupList[j].groupId);
       }
    }


    if ($scope.adminMng != '1') {
      if (localStorage.mngKbn != '0') {
        $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
      } else {
    	  $scope.groupList = angular.copy($scope.loginUser.groupList);
          //指示者、チェック者は自分所属しているグループ内のユーザのみが見れる。
          if ($scope.groupIdList.length == 0) {
        	  $scope.userList = [];
        	  $scope.userList.push($scope.loginUser);
          } else {
              $scope.userList = ajaxService.getListByGroupIdList($scope.groupIdList);
          }
          $scope.userList.unshift({userName:" ", userId:''});
      }
    } else {
	  if (localStorage.mngKbn == '2') {
          $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
        } else {
          $scope.groupList = angular.copy($scope.loginUser.groupList);
          //指示者、チェック者は自分所属しているグループ内のユーザのみが見れる。
          if ($scope.groupIdList.length == 0) {
        	  $scope.userList = [];
        	  $scope.userList.push($scope.loginUser);
          } else {
              $scope.userList = ajaxService.getListByGroupIdList($scope.groupIdList);
          }
          $scope.userList.unshift({userName:" ", userId:''});
        }
	}


    $scope.groupList.unshift({groupName:" ", groupId:0});
    $scope.responseGroup = $scope.groupList[0];
    $scope.responseUser = $scope.userList[0];

    $scope.eScheduledDateS = new Date();
    $scope.eScheduledDateE = new Date();

    var beforeWorkColor = "#FFF3E0";
    var onWorkColor = "#FFCC80";
    var completeColor = "#FFA726";
    var confirmColor = "#FB8C00";
    var finalConfirmColor = "#EF6C00";
    var returnColor = "#e85656";


    //工事項目リストを取得
    $scope.showFirst = false;
    $scope.showSecond = false;
    $scope.showThird = false;
    $scope.itemNameList = ajaxService.getTargetItemList($rootScope.projectId);
    for (var i=0; i<$scope.itemNameList.length; i++) {
      var field = $scope.itemNameList[i].fieldName;
      if (field == "first") {
        $scope.showFist = true;
        $scope.targetFirstItemName = $scope.itemNameList[i].showName;
      }
      if (field == "second") {
          $scope.showSecond = true;
          $scope.targetSecondItemName = $scope.itemNameList[i].showName;
        }
      if (field == "third") {
          $scope.showThird = true;
          $scope.targetThirdItemName = $scope.itemNameList[i].showName;
        }
      if (field == "targetName") {
        $scope.targetNameItemName = $scope.itemNameList[i].showName;
      }
    }


    $scope.firstList = ajaxService.getProjectResourceList($rootScope.projectId, '1', 0);
    if ($scope.firstList.length == 0) {
      $scope.firstList.push({label:"マスタデータがありません", id:0});
      $scope.firstDisable = true;
    } else {
        $scope.firstDisable = false;
        $scope.firstList.unshift({label:" ", id:0});
    }
    $scope.first = $scope.firstList[0];

    $scope.secondList = [];
    if ($scope.first.id != 0) {
        $scope.secondList = ajaxService.getProjectResourceList($rootScope.projectId, '2', $scope.first.id);
        if ($scope.secondList.length == 0) {
          $scope.secondList.push({label:"マスタデータがありません", id:0});
            $scope.secondDisable = true;
        } else {
            $scope.secondDisable = false;
            $scope.secondList.unshift({label:" ", id:0});
        }
    } else {
        $scope.secondList.push({label:"マスタデータがありません", id:0});
        $scope.secondDisable = true;
    }
    $scope.second = $scope.secondList[0];

    $scope.thirdList = [];
    if ($scope.second.id != 0) {
        $scope.thirdList = ajaxService.getProjectResourceList($rootScope.projectId, '3', $scope.second.id);
        if ($scope.thirdList.length == 0) {
          $scope.thirdList.push({label:"マスタデータがありません", id:0});
            $scope.thirdDisable = true;
        } else {
            $scope.thirdDisable = false;
            $scope.thirdList.unshift({label:" ", id:0});
        }
    } else {
        $scope.thirdList.push({label:"マスタデータがありません", id:0});
        $scope.thirdDisable = true;
    }
    $scope.third = $scope.thirdList[0];

    $scope.changeFirst = function () {
      $scope.secondList = ajaxService.getProjectResourceList($rootScope.projectId, '2', $scope.first.id);
        if ($scope.secondList.length == 0) {
          $scope.secondList.push({label:"マスタデータがありません", id:0});
            $scope.secondDisable = true;
        } else {
            $scope.secondDisable = false;
            $scope.secondList.unshift({label:" ", id:0});
        }
        $scope.second = $scope.secondList[0];
        $scope.changeSecond();

        $('#calendar').fullCalendar('refetchEvents');
    };
    $scope.changeSecond = function () {
        $scope.thirdList = ajaxService.getProjectResourceList($rootScope.projectId, '3', $scope.second.id);
          if ($scope.thirdList.length == 0) {
            $scope.thirdList.push({label:"マスタデータがありません", id:0});
              $scope.thirdDisable = true;
          } else {
              $scope.thirdDisable = false;
              $scope.thirdList.unshift({label:" ", id:0});
          }
          $scope.third = $scope.thirdList[0];

          $('#calendar').fullCalendar('refetchEvents');
      };


      $scope.changeThird = function () {
          $('#calendar').fullCalendar('refetchEvents');
      };
      $scope.changeResponseGroup = function () {
          $scope.responseUser = $scope.userList[0];
          $('#calendar').fullCalendar('refetchEvents');
      };

      $scope.changeResponseUser = function () {
          $scope.responseGroup = $scope.groupList[0];
          $('#calendar').fullCalendar('refetchEvents');
      };


    var dashboardColors = baConfig.colors.dashboard;

//    var tooltip = $('<div/>').qtip({
//        id: 'fullcalendar',
//        prerender: true,
//        content: {
//            text: ' ',
//            title: {
//                button: true
//            }
//        },
//        position: {
//            my: 'bottom center',
//            at: 'top center',
//            target: 'mouse',
//            viewport: $('#fullcalendar'),
//            adjust: {
//                mouse: false,
//                scroll: false
//            }
//        },
//        show: false,
//        hide: false,
//        style: 'qtip-light'
//    }).qtip('api');




    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next ',
        center: 'title',
        right: ' today, month, basicWeek'
      },
      views: {
          basicWeek: { // name of the view
              columnFormat: 'M/D ddd',
              contentHeight : 1300
          }
      },
      defaultDate: moment(),
      selectable: false,
      editable: false,
      selectHelper: true,
//      select: function (start, end) {
//        var title = prompt('Event Title:');
//        var eventData;
//        if (title) {
//          eventData = {
//            title: title,
//            start: start,
//            end: end
//          };
//          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
//        }
//        $element.fullCalendar('unselect');
//      },
      eventLimit: true, // allow "more" link when too many events

      // ボタン文字列
      buttonText: {
          today:    '今日',
          month:    '月',
          week:     '週',
          day:      '日'
      },
      // 月名称
      monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      // 月略称
      monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      // 曜日名称
      dayNames: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
      // 曜日略称
      dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
      titleFormat:'YYYY年MM月',

      eventMouseover:function(calEvent,jsevent){
    	  var fontColor = "#d45a00";
    	  if (calEvent.textColor) {
    		  fontColor = calEvent.textColor;
    	  }

    	  var innerHtml = "<table>" +
    	  		"<tr><td>ID:</td><td>"+$rootScope.padLeft(calEvent.ticketId, 8)+"</td></tr>" +
    	  		"<tr><td>"+$scope.targetNameItemName+":</td><td>"+calEvent.targetName+"</td></tr>" +
    	  		"<tr><td>チェック:</td><td>"+calEvent.checksheetName+"</td></tr>" +
    	  		"<tr><td>ステータス:</td><td>"+calEvent.statusName+"</td></tr>" +
    	  		"<tr><td>担当技術者:</td><td>"+calEvent.responseUserName+"</td></tr>" +
    	  		"<tr><td>担当技術者グループ:</td><td>"+calEvent.responseGroupName+"</td></tr>" +
    	  		"</table>"

		  var tooltip = '<div class="tooltipevent" style="width:auto;height:auto;color:'+fontColor+';background:'+calEvent.color+';position:absolute;z-index:10001;">' +innerHtml+ '</div>';
		    var $tooltip = $(tooltip).appendTo('body');

		    $(this).mouseover(function(e) {
		        $(this).css('z-index', 10000);
		        $tooltip.fadeIn('500');
		        $tooltip.fadeTo('10', 1.9);
		    }).mousemove(function(e) {
		        $tooltip.css('top', e.pageY + 10);
		        $tooltip.css('left', e.pageX + 20);
		    });
	  },

	  eventMouseout: function(calEvent, jsEvent) {
		    $(this).css('z-index', 8);
		    $('.tooltipevent').remove();
		},


      events: function(start, end, timezone, callback) {

        $scope.startDate = $rootScope.formatDate(start._d, "YYYY/MM/DD");
        $scope.endDate = $rootScope.formatDate(end._d, "YYYY/MM/DD");

        $scope.checkreportList = ajaxService.getCalendarTicketList($rootScope.projectId, $scope.groupIdList, $scope.startDate, $scope.endDate, $scope.first.id, $scope.second.id, $scope.third.id, $scope.responseGroup.groupId, $scope.responseUser.userId);
        var eventArray = [];

        for (var i =0; i <$scope.checkreportList.length; i++) {
          var ticket = $scope.checkreportList[i];
          var event = new Object();
          event.title = ticket.checksheetName + "：" + ticket.targetName;
          if (! ticket.startScheduledDate || !ticket.endScheduledDate) {
            continue;
          }
          event.ticketId = ticket.id;
          event.targetName = ticket.targetName;
          event.checksheetName = ticket.checksheetName;
          event.statusName = ticket.statusName;
          if (ticket.responseUserName) {
              event.responseUserName = ticket.responseUserName;
          } else {
        	  event.responseUserName = "";
          }
          if (ticket.responseGroupName) {
              event.responseGroupName = ticket.responseGroupName;
          } else {
              event.responseGroupName = "";
          }

          event.allDay=true;

          event.start = ticket.startScheduledDate;

          var tomorrow = new Date(ticket.endScheduledDate);
          tomorrow.setDate(tomorrow.getDate() + 1);
          event.end = $rootScope.formatDate(tomorrow, "YYYY/MM/DD");

          if (ticket.statusId == '01') {
            event.color = beforeWorkColor;
          } else if (ticket.statusId == '02') {
            event.color = onWorkColor;
          } else if (ticket.statusId == '03') {
            event.color = completeColor;
          } else if (ticket.statusId == '04') {
            event.color = confirmColor;
          } else if (ticket.statusId == '05') {
            event.color = finalConfirmColor;
          } else if (ticket.statusId == '99') {
            event.color = returnColor;
            event.textColor = "#fff";
          }

            eventArray.push(event);
        }
        callback(eventArray);

      },
      eventClick: function(calEvent, jsEvent, view) {

//          alert('Event: ' + calEvent.title);
//          alert('Coordinates: ' + jsEvent.pageX + ',' + jsEvent.pageY);
//          alert('View: ' + view.name);

          // change the border color just for fun

          var url = window.location.href;
          var u = url.split("#")[0];
          if ($rootScope.isMoblie) {
              window.open(u + "#/showReportDetailSp?id=" + calEvent.ticketId );
          } else {
              window.open(u + "#/showReportDetail?id=" + calEvent.ticketId );
          }

        },

      eventRender: function(eventObj, element) {

    	  $(element).tooltip({title: eventObj.title});
//        element.popover({
//            title: eventObj.title,
//            content: eventObj.title,
//            trigger: 'hover',
//            placement: 'top',
//            container: 'body'
//          });
//
//        element.qtip({
//            content: eventObj.title
//          });
        }


    });

  }
})();
/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.home').controller('HomeCtrl', HomeCtrl);

    /** @ngInject */
    function HomeCtrl($scope, $rootScope, $filter, editableOptions, editableThemes, toastr,
            toastrConfig, ajaxService, $state, $location, $window) {

    	if(! window.navigator.onLine){
    		//オフラインの場合、ダウンロードチケットへ遷移
    		window.location.href = "#/offline";
    		return;
    	}

  	  $rootScope.isHome = true;
      $rootScope.isProject = false;

       if (!ajaxService.tokenCheck()) {
         return;
       };

       $scope.unConfirm = ajaxService.getUnConfirmNum($rootScope.projectId);

       $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);
       $scope.showResult = $scope.mngCommon.showResult;

       $scope.showNews = function () {
         window.location.href = "#/news?kbn=m";
       }

       if (! $scope.userList) {
           $scope.userList = ajaxService.selectUserList($rootScope.projectId);
         }
       for (var i=0; i<$scope.userList.length; i++) {
           if (localStorage.userId == $scope.userList[i].userId) {
             $scope.loginUser = $scope.userList[i];
             break;
           }
         }

       var groupIdList = [];

       if (localStorage.mngKbn != '2') {
    	   for (var j=0; j<$scope.loginUser.groupList.length; j++) {
	         groupIdList.push($scope.loginUser.groupList[j].groupId);
	       }
       } else {
    	   var groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
    	   for (var j=0; j<groupList.length; j++) {
  	         groupIdList.push(groupList[j].groupId);
  	       }
       }

       $scope.returnNum = ajaxService.getReturnNum($rootScope.projectId, groupIdList);
       $scope.showReturnTicket = function () {
         window.location.href = "#/checkreport?kbn=r";
       }

       $scope.overStartDateNum = ajaxService.getOverStartDateNum($rootScope.projectId, groupIdList);
       $scope.showOverStartDate = function () {
         window.location.href = "#/checkreport?kbn=s";
       }

       $scope.overEndDateNum = ajaxService.getOverEndDateNum($rootScope.projectId, groupIdList);
       $scope.showOverEndDate = function () {
         window.location.href = "#/checkreport?kbn=e";
       }

       $scope.errorNum = ajaxService.getErrorNum($rootScope.projectId, groupIdList);
       $scope.showErrorTicket = function () {
         window.location.href = "#/checkreport?kbn=o";
       }


       var $element = $('#calendar').fullCalendar({
            //height: 335,
            header: {
              left: 'prev,next today',
              center: 'title',
              right: ''
            },
            defaultDate: moment(),
            selectable: false,
            editable: false,
            selectHelper: true,
            select: function (start, end) {
              var title = prompt('Event Title:');
              var eventData;
              if (title) {
                eventData = {
                  title: title,
                  start: start,
                  end: end
                };
                $element.fullCalendar('renderEvent', eventData, true); // stick? = true
              }
              $element.fullCalendar('unselect');
            },
            eventLimit: true, // allow "more" link when too many events

            // ボタン文字列
            buttonText: {
                today:    '今日',
                month:    '月',
                week:     '週',
                day:      '日'
            },
            // 月名称
            monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            // 月略称
            monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            // 曜日名称
            dayNames: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
            // 曜日略称
            dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
            titleFormat:'YYYY年MM月',

            events: function(start, end, timezone, callback) {}
          });

    }

})();

/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.itemname').controller('ItemnameCtrl', ItemnameCtrl);

    /** @ngInject */
    function ItemnameCtrl($scope, $rootScope,  $filter, editableOptions, editableThemes, toastr,
            toastrConfig, ajaxService, $state, $location, $window) {

    	if(! window.navigator.onLine){
    		//オフラインの場合、ダウンロードチケットへ遷移
    		window.location.href = "#/offline";
    		return;
    	}

        $rootScope.isHome = false;
        $rootScope.isProject = false;

      if (!ajaxService.tokenCheck()) {
            return;
          };
      $scope.showList = [{id:"0", text:"表示（任意）"},{id:"1", text:"非表示"},];
      $scope.showItemList = [{id:"3", text:"表示（必須）"},{id:"0", text:"表示（任意）"},{id:"1", text:"非表示"},];


      $scope.showIsShow = function (item) {
        var selected = [];
        selected = $filter('filter')($scope.showList, {id: item});
        return selected[0].text;
      };
      $scope.showItemIsShow = function (item) {
          var selected = [];
          selected = $filter('filter')($scope.showItemList, {id: item});
          return selected[0].text;
        };


      $scope.getItemList = function () {

        $scope.itemTargetList = ajaxService.searchItemNameList("2", $rootScope.projectId);

        for (var i =0 ; i < $scope.itemTargetList.length; i++) {
          var item = $scope.itemTargetList[i]
          if (item.itemNameId == '20000031') {
            $scope.first = item;
          }
          if (item.itemNameId == '20000032') {
            $scope.second = item;
          }
          if (item.itemNameId == '20000033') {
            $scope.third = item;
          }
        }

        $scope.itemTicketList = ajaxService.searchItemNameList("3", $rootScope.projectId);
      };

      $scope.getItemList();

      $scope.saveItem = function (item) {

        if (!item.showName) {
          item.showName = item.itemName;
        }
        if (item.isShow == '-') {
          item.isShow = '2'
        }
        ajaxService.modifyItemName(item, $rootScope.projectId);
        if (ajaxService.result['resultCd'] == "000000") {
          $rootScope.showInfoMessage("更新しました。");
          if (item.isShow == '2') {
            item.isShow = '-'
          }
        }

        if (item.itemNameId == '20000031' && item.isShow == '1') {
          $scope.second.isShow = '1';
          $scope.saveItem($scope.second);
        }

        if (item.itemNameId == '20000032' && item.isShow == '1') {
          $scope.third.isShow = '1';
          $scope.saveItem($scope.third);
        }

        if (item.itemNameId == '20000032' && item.isShow == '0') {
          $scope.first.isShow = '0';
          $scope.saveItem($scope.first);
        }

        if (item.itemNameId == '20000033' && item.isShow == '0') {
          $scope.second.isShow = '0';
          $scope.saveItem($scope.second);
        }
      };

      $scope.showMasterDate = function () {
        window.location.href = "#/masterdata#gotoMaster";
      };
      $scope.showMasterDateStatus = function () {
          window.location.href = "#/masterdata#gotoStatusDetail";
        };
      $scope.showTargetKbn = function () {
          window.location.href = "#/masterdata#gotoTargetKbn";
        };


    }

})();

/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.manage').controller('ManageCtrl', ManageCtrl);

    /** @ngInject */
    function ManageCtrl($scope, $rootScope, $filter, editableOptions, editableThemes, toastr,
            toastrConfig, ajaxService, $state, $location, $window, $sce) {

    	if(! window.navigator.onLine){
    		//オフラインの場合、ダウンロードチケットへ遷移
    		window.location.href = "#/offline";
    		return;
    	}

        $scope.ctrlScope = $scope;

        $scope.alertRadioTooltip = $sce.trustAsHtml('<div style="text-align:left">スマートフォンでのチェック開始時に、対象工事から指定した距離以上、離れていた場合にアラートを表示することができます。<br/>ただし、工事情報に緯度経度が設定されていることとスマートフォンのGPS設定がONになっていることが前提となります。</div>');
        $scope.groupRadioTooltip = $sce.trustAsHtml('<div style="text-align:left">チェックシート作成時にデフォルトで設定したい閲覧グループがある場合に、指定します。</div>');
        $scope.autoReloadTooltip = $sce.trustAsHtml('<div style="text-align:left">チェックシート一覧をオートリロード（自動更新）したい場合に、更新間隔を指定します。</div>');
        $scope.userRadioTooltip = $sce.trustAsHtml('<div style="text-align:left">チェックシート作成時に担当技術者、担当技術者グループ、管理技術者、指示グループ、閲覧グループを指定する際に対象工事に近い順に表示することができます。<br/>ただし、工事情報に緯度経度が設定されていることとスマートフォンのGPS設定がONになっていることが前提となります。</div>');
        $scope.resultRadioTooltip = $sce.trustAsHtml('<div style="text-align:left">チェック詳細ページの一番下のチェック結果欄（正常、異常、保留、対象外）を付加するかを指定できます。チェック結果欄をオンにするとチェックシート一覧で結果件数を表示します。</div>');
        $scope.imgDownRadioTooltip = $sce.trustAsHtml('<div style="text-align:left">報告書、写真のダウンロード時の写真サイズを撮影時のオリジナルにするかシステムで圧縮したサイズにするかを指定できます。オリジナルの場合はファイルサイズが大きく、ダウンロードに時間が掛かる場合があります。</div>');
        $scope.exlDownRadioTooltip = $sce.trustAsHtml('<div style="text-align:left">報告書出力時にサマリーシート＋各チェック毎のシートで出力するか、サマリー、各チェック含め全てで１シートで出力するかを指定します。</div>');
        $scope.logoDownRadioTooltip = $sce.trustAsHtml('<div style="text-align:left">報告書出力時に右上にロゴを出力するかを指定します。</div>');
        $scope.updateTimeRadioTooltip = $sce.trustAsHtml('<div style="text-align:left">報告書出力時にチェック更新日時を出力するかを指定します。</div>');
        $scope.ticketIdRadioTooltip = $sce.trustAsHtml('<div style="text-align:left">報告書出力時にチェックシートIDを出力するかを指定します。</div>');
        $scope.rrGroupRadioTooltip = $sce.trustAsHtml('<div style="text-align:left">報告書出力時に指示グループと担当技術者グループを出力するかを指定します。</div>');
        $scope.progressTooltip = $sce.trustAsHtml('<div style="text-align:left">チェックシート一覧にチェックシートの進捗率を「実施済件数」 ／ 「全体の項目数」でパーセンテージを算出し、進捗バーで表示する。</div>');
        $scope.finalApprovalTooltip = $sce.trustAsHtml('<div style="text-align:left">承認したチェックシートに対して、最終承認ボタンを表示します。</div>');
        $scope.commentTooltip = $sce.trustAsHtml('<div style="text-align:left">自身に関連するチェックシートのステータスが変更された場合（コメントが入力された場合含む）、ヘッダ部のベルマークまたはメールでの通知を指定することが可能です。<br/>ただし、メール送信通知については技術者情報にメールアドレスが設定されている場合に限ります。</div>');
        $scope.newsTooltip = $sce.trustAsHtml('<div style="text-align:left">自身に関連するお知らせがあった場合、ヘッダ部のベルマークまたはメールでの通知を指定することが可能です。<br/>ただし、メール送信通知については技術者情報にメールアドレスが設定されている場合に限ります。</div>');
        $scope.documentTooltip = $sce.trustAsHtml('<div style="text-align:left">ドキュメントをアップロードされた場合、ヘッダ部のベルマークまたはメールでの通知を指定することが可能です。<br/>ただし、メール送信通知については技術者情報にメールアドレスが設定されている場合に限ります。</div>');
        $scope.adminMngTooltip = $sce.trustAsHtml('<div style="text-align:left">担当技術者、管理技術者が全グループ閲覧可能か自身の所属するグループのみ閲覧可能かを指定します。</div>');
        $scope.defaultDateTooltip = $sce.trustAsHtml('<div style="text-align:left">トップページの「期間中完了予定チェックシート」の円グラフについて、デフォルトの対象期間を指定します。</div>');

        $rootScope.isHome = false;
        $rootScope.isProject = false;

        if (!ajaxService.tokenCheck()) {
            return;
          };

      $scope.diskSpace = ajaxService.getDiskSpace($rootScope.projectId);

      $scope.diskSpaceHisList = ajaxService.getDiskSpaceHistory($rootScope.projectId);

      $scope.yearList = new Array();
      var initYear = "";

      for (var i = 0; i < $scope.diskSpaceHisList.length; i++) {
    	  var his = $scope.diskSpaceHisList[i];
    	  var year = his.month.substring(0,4);
    	  if (initYear != year) {
    		  initYear = year;
        	  var flg = false;
        	  if (i == 0) {
        		  flg = true;
        	  }
    		  $scope.yearList.push({"year":year,"flg":flg});
    	      $scope["diskList" + year] = new Array();
    	  }
    	  $scope["diskList" + year].push(his);
      }

      $scope.dynamicArray = function(year){
          return $scope["diskList"+year];
      }

      $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);

      $scope.alertItems = [
                           {label: '0.5km', value: "0.5"},
                           {label: '1.0km', value: "1.0"},
                           {label: '1.5km', value: "1.5"},
                           {label: '2.0km', value: "2.0"},
                           {label: '2.5km', value: "2.5"},
                           {label: '3.0km', value: "3.0"},
                           {label: '3.5km', value: "3.5"},
                           {label: '4.0km', value: "4.0"},
                           {label: '4.5km', value: "4.5"},
                           {label: '5.0km', value: "5.0"}
                         ];


      $scope.autoReloadItems = [
                           {label: '1分間', value: "60"},
                           {label: '2分間', value: "120"},
                           {label: '5分間', value: "300"},
                           {label: '10分間', value: "600"}
                         ];

      $scope.defaultDateFroms = [
                             {label: '本日', value: "0"},
                             {label: '1ヵ月前', value: "1"},
                             {label: '2ヵ月前', value: "2"},
                             {label: '3ヵ月前', value: "3"}
                           ];

      $scope.defaultDateTos = [
                             {label: '本日', value: "0"},
                             {label: '1ヵ月後', value: "1"},
                             {label: '2ヵ月後', value: "2"},
                             {label: '3ヵ月後', value: "3"}
                           ];

      $scope.getAutoReloadSel = function () {
          for (var i=0; i<$scope.autoReloadItems.length; i++ ) {
            if ($scope.mngCommon.reloadTime == $scope.autoReloadItems[i].value) {
              return $scope.autoReloadItems[i]
            }
          }
        };
        $scope.ctrlScope.autoReloadSelected = $scope.getAutoReloadSel();
        if (! $scope.ctrlScope.autoReloadSelected) {
          $scope.ctrlScope.autoReloadSelected = $scope.autoReloadItems[0];
        }

      $scope.getAlertSel = function () {
        for (var i=0; i<$scope.alertItems.length; i++ ) {
          if ($scope.mngCommon.distance == $scope.alertItems[i].value) {
            return $scope.alertItems[i];
          }
        }
      };
      $scope.ctrlScope.alertSelected = $scope.getAlertSel();
      if (! $scope.ctrlScope.alertSelected) {
        $scope.ctrlScope.alertSelected = $scope.alertItems[0];
      }
      $scope.alertRadio = $scope.mngCommon.sysNaviFlg;

      $scope.autoReload = $scope.mngCommon.autoReload;

      $scope.userRadio = $scope.mngCommon.userOrder;

      $scope.resultRadio = $scope.mngCommon.showResult;

      $scope.imgDownRadio = $scope.mngCommon.imgDownloadType;

      $scope.exlDownRadio = $scope.mngCommon.exlDownloadType;

      $scope.logoDownRadio = $scope.mngCommon.logoDownloadType;

      $scope.updateTimeRadio = $scope.mngCommon.updateTimeType;

      $scope.ticketIdRadio = $scope.mngCommon.ticketIdType;

      $scope.rrGroupRadio = $scope.mngCommon.rrGroupType;

      $scope.parentTicketRadio = $scope.mngCommon.parentTicketType;

      $scope.commentWithMail = $scope.mngCommon.commentWithMail;

      $scope.commentWithBell = $scope.mngCommon.commentWithBell;

      $scope.newsWithMail = $scope.mngCommon.newsWithMail;

      $scope.newsWithBell = $scope.mngCommon.newsWithBell;

      $scope.documentWithMail = $scope.mngCommon.documentWithMail;

      $scope.documentWithBell = $scope.mngCommon.documentWithBell;

      $scope.progress = $scope.mngCommon.progress;

      $scope.finalApproval = $scope.mngCommon.finalApproval;

      $scope.adminMng = $scope.mngCommon.adminMng;

      $scope.defaultEndDateFrom = $scope.mngCommon.defaultEndDateFrom;

      $scope.defaultEndDateTo = $scope.mngCommon.defaultEndDateTo;


      if (! $scope.alertRadio) {
        $scope.alertRadio = "0";
      }

      if (! $scope.userRadio) {
        $scope.userRadio = "0";
      }

      if (! $scope.resultRadio) {
        $scope.resultRadio = "1";
      }

      if (! $scope.imgDownRadio) {
        $scope.imgDownRadio = "0";
      }
      if (! $scope.exlDownRadio) {
    	  //t-japan : 単一シートのみ
          $scope.exlDownRadio = "1";
        }
      if (! $scope.logoDownRadio) {
          $scope.logoDownRadio = "0";
        }
      if (! $scope.updateTimeRadio) {
          $scope.updateTimeRadio = "1";
        }
      if (! $scope.ticketIdRadio) {
          $scope.ticketIdRadio = "1";
        }
      if (! $scope.rrGroupRadio) {
          $scope.rrGroupRadio = "1";
        }
      if (! $scope.parentTicketRadio) {
          $scope.parentTicketRadio = "0";
        }
      if (! $scope.progress) {
          $scope.progress = "1";
        }
      if (! $scope.finalApproval) {
          $scope.finalApproval = "0";
        }
      if (! $scope.adminMng) {
          $scope.adminMng = "1";
        }

      if (! $scope.defaultEndDateFrom) {
          $scope.defaultEndDateFrom = $scope.defaultDateFroms[1];
        } else {
        	for (var i = 0; i <$scope.defaultDateFroms.length; i++ ) {
        		if ($scope.defaultEndDateFrom == $scope.defaultDateFroms[i].value) {
        			$scope.defaultEndDateFrom = $scope.defaultDateFroms[i];
        			break;
        		}
        	}
        }
      if (! $scope.defaultEndDateTo) {
          $scope.defaultEndDateTo = $scope.defaultDateTos[0];
        } else {
        	for (var i = 0; i <$scope.defaultDateTos.length; i++ ) {
        		if ($scope.defaultEndDateTo == $scope.defaultDateTos[i].value) {
        			$scope.defaultEndDateTo = $scope.defaultDateTos[i];
        			break;
        		}
        	}
        }

      if ($scope.commentWithMail == '0') {
      	$scope.commentWithMailCheckBox = false;
      } else {
      	  $scope.commentWithMailCheckBox = true;
      }
      if ($scope.commentWithBell == '0') {
  	    $scope.commentWithBellCheckBox = false;
	  } else {
		$scope.commentWithBellCheckBox = true;
	  }

      if ($scope.newsWithMail == '0') {
      	$scope.newsWithMailCheckBox = false;
      } else {
      	  $scope.newsWithMailCheckBox = true;
      }
      if ($scope.newsWithBell == '0') {
  	    $scope.newsWithBellCheckBox = false;
	  } else {
		$scope.newsWithBellCheckBox = true;
	  }

      if ($scope.documentWithMail == '0') {
      	$scope.documentWithMailCheckBox = false;
      } else {
      	  $scope.documentWithMailCheckBox = true;
      }
      if ($scope.documentWithBell == '0') {
  	    $scope.documentWithBellCheckBox = false;
	  } else {
		$scope.documentWithBellCheckBox = true;
	  }


      if (! $scope.autoReload) {
          $scope.autoReload = "0";
        }

      $scope.changeAlertRadio = function (value) {
        $scope.alertRadio = value;
      };

      $scope.changeAutoReload = function (value) {
          $scope.autoReload = value;
        };

      $scope.modifyAlert = function () {
        ajaxService.modifyMngCommon($rootScope.projectId, $scope.alertRadio, $scope.alertSelected.value);
        $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);
        $rootScope.showInfoMessage("更新しました。");
      };


      $scope.modifyUserSort = function (key) {
          ajaxService.modifyMngProperty($rootScope.projectId, key, $scope.userRadio);
          $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);
          $rootScope.showInfoMessage("更新しました。");
      }

      $scope.modifyShowResult = function (key) {
          ajaxService.modifyMngProperty($rootScope.projectId, key, $scope.resultRadio);
          $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);
          $rootScope.showInfoMessage("更新しました。");
      }


      $scope.initGroup = function (){
        $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);

          $scope.defaultGroupList = ajaxService.selectDefaultGroupList($rootScope.projectId);
          $scope.selectedGroups = {selected:$scope.defaultGroupList};

          $scope.groupRadio = "0";
          if ($scope.defaultGroupList.length != 0) {
            $scope.groupRadio = "1";
          }
      };

      $scope.initGroup();

      $scope.changeGroupRadio = function (value) {
        $scope.groupRadio = value;
        if (value == "0") {
          $scope.selectedGroups = {selected:[]};
        } else {
          $scope.selectedGroups = {selected:$scope.defaultGroupList};
        }
      };

      $scope.modifyDefaultGroup = function () {
        var groupidlist = [];
          for (var i =0; i< $scope.selectedGroups.selected.length; i++) {
        	  if ($rootScope.listContains(groupidlist, $scope.selectedGroups.selected[i].groupId)){
           		 continue;
           	 }
            groupidlist.push($scope.selectedGroups.selected[i].groupId);
          }

        ajaxService.modifyDefaultGroup($rootScope.projectId, groupidlist);
        $scope.initGroup();
        $rootScope.showInfoMessage("更新しました。");
      };

      $scope.modifySetting = function () {
    	  ajaxService.modifyMngCommon($rootScope.projectId, $scope.alertRadio, $scope.alertSelected.value);
    	  ajaxService.modifyMngProperty($rootScope.projectId, 'SHOW_RESULT', $scope.resultRadio);
          ajaxService.modifyMngProperty($rootScope.projectId, 'USER_ORDER', $scope.userRadio);
          ajaxService.modifyMngProperty($rootScope.projectId, 'IMG_DOWNLOAD_TYPE', $scope.imgDownRadio);
          ajaxService.modifyMngProperty($rootScope.projectId, 'EXL_DOWNLOAD_TYPE', $scope.exlDownRadio);
          ajaxService.modifyMngProperty($rootScope.projectId, 'LOGO_DOWNLOAD_TYPE', $scope.logoDownRadio);

          ajaxService.modifyMngProperty($rootScope.projectId, 'UPDATE_TIME_TYPE', $scope.updateTimeRadio);
          ajaxService.modifyMngProperty($rootScope.projectId, 'TICKET_ID_TYPE', $scope.ticketIdRadio);
          ajaxService.modifyMngProperty($rootScope.projectId, 'RR_GROUP_TYPE', $scope.rrGroupRadio);

          ajaxService.modifyMngProperty($rootScope.projectId, 'PARENT_TICKET_TYPE', $scope.parentTicketRadio);
          ajaxService.modifyMngProperty($rootScope.projectId, 'PROGRESS', $scope.progress);
          ajaxService.modifyMngProperty($rootScope.projectId, 'FINAL_APPROVAL', $scope.finalApproval);
          ajaxService.modifyMngProperty($rootScope.projectId, 'ADMIN_MNG', $scope.adminMng);
          ajaxService.modifyMngProperty($rootScope.projectId, 'DEFAULT_END_DATE_FROM', $scope.defaultEndDateFrom.value);
          ajaxService.modifyMngProperty($rootScope.projectId, 'DEFAULT_END_DATE_TO', $scope.defaultEndDateTo.value);
          if ($scope.commentWithMailCheckBox) {
        	  ajaxService.modifyMngProperty($rootScope.projectId, 'COMMENT_WITH_MAIL', "1");
          } else {
        	  ajaxService.modifyMngProperty($rootScope.projectId, 'COMMENT_WITH_MAIL', "0");
          }
          if ($scope.commentWithBellCheckBox) {
        	  ajaxService.modifyMngProperty($rootScope.projectId, 'COMMENT_WITH_BELL', "1");
          } else {
        	  ajaxService.modifyMngProperty($rootScope.projectId, 'COMMENT_WITH_BELL', "0");
          }
          if ($scope.newsWithMailCheckBox) {
        	  ajaxService.modifyMngProperty($rootScope.projectId, 'NEWS_WITH_MAIL', "1");
          } else {
        	  ajaxService.modifyMngProperty($rootScope.projectId, 'NEWS_WITH_MAIL', "0");
          }
          if ($scope.newsWithBellCheckBox) {
        	  ajaxService.modifyMngProperty($rootScope.projectId, 'NEWS_WITH_BELL', "1");
          } else {
        	  ajaxService.modifyMngProperty($rootScope.projectId, 'NEWS_WITH_BELL', "0");
          }
          if ($scope.documentWithMailCheckBox) {
        	  ajaxService.modifyMngProperty($rootScope.projectId, 'DOCUMENT_WITH_MAIL', "1");
          } else {
        	  ajaxService.modifyMngProperty($rootScope.projectId, 'DOCUMENT_WITH_MAIL', "0");
          }
          if ($scope.documentWithBellCheckBox) {
        	  ajaxService.modifyMngProperty($rootScope.projectId, 'DOCUMENT_WITH_BELL', "1");
          } else {
        	  ajaxService.modifyMngProperty($rootScope.projectId, 'DOCUMENT_WITH_BELL', "0");
          }

          ajaxService.modifyMngProperty($rootScope.projectId, 'AUTO_RELOAD', $scope.autoReload);
          ajaxService.modifyMngProperty($rootScope.projectId, 'RELOAD_TIME', $scope.autoReloadSelected.value);

    	  var groupidlist = [];
          for (var i =0; i< $scope.selectedGroups.selected.length; i++) {
        	  if ($rootScope.listContains(groupidlist, $scope.selectedGroups.selected[i].groupId)){
           		 continue;
           	 }
            groupidlist.push($scope.selectedGroups.selected[i].groupId);
          }

          ajaxService.modifyDefaultGroup($rootScope.projectId, groupidlist);
          $scope.initGroup();

    	  $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);

          $rootScope.showInfoMessage("更新しました。");
      }

    }

})();

/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.manual').controller('ManualCtrl', ManualCtrl);

    /** @ngInject */
    function ManualCtrl($scope, $filter, editableOptions, editableThemes, toastr,$uibModal,$rootScope,
            toastrConfig, ajaxService, $state, $location, $window) {

    	if(! window.navigator.onLine){
    		//オフラインの場合、ダウンロードチケットへ遷移
    		window.location.href = "#/offline";
    		return;
    	}

      $scope.smartTablePageSize = 20;

      $scope.ctrl = $scope;

      if (!ajaxService.tokenCheck()) {
          return;
        };

        $rootScope.isHome = false;
        $rootScope.isProject = false;

      $scope.readonly = false;
//      if (localStorage.mngKbn == "2" || localStorage.mngKbn == "9") {
//        $scope.readonly = false;
//      }

      $scope.openUploadDialog = function() {
          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/fileUploadModal.html',
              controller : 'FileUploadCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  openFlag : function() {
                      return {
                          'flag' : 'New',
                          'kbn' : 'Common'
                      };
                  }
              }
          });
      };


        ajaxService.confirmDocument($rootScope.projectId);

        $scope.getManualList = function() {
          $scope.fileList = ajaxService.getFileListCommon($rootScope.projectId);
        };

        $scope.getManualList();

        $scope.delFile = function (fileBean) {
            var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "該当ファイルを削除してもよろしいですか？"
                        };
                    }
                }
            });
            modalInstance.result.then(function() {
              ajaxService.removeFileCommon($rootScope.projectId, fileBean.id, fileBean.fileExternal);
              if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              } else {
                $rootScope.showInfoMessage("該当ファイルを削除しました。");
                $scope.getManualList();
              }
            });
          };

          $scope.getFileListSp = function() {
        	  $scope.fileList = ajaxService.getFileListByName($scope.fileName, $rootScope.projectId);
          }

    }

})();

/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.news').controller('NewsCtrl', NewsCtrl);

    /** @ngInject */
    function NewsCtrl($scope, $filter, editableOptions, editableThemes, toastr,$rootScope, tr,$uibModal,
            toastrConfig, ajaxService, $state, $location, $window) {

    	if(! window.navigator.onLine){
    		//オフラインの場合、ダウンロードチケットへ遷移
    		window.location.href = "#/offline";
    		return;
    	}

      $scope.smartTablePageSize = 20;
      $scope.ctrl = $scope;


      $scope.detailDisplay = 'none';

      if (!ajaxService.tokenCheck()) {
          return;
        };

        $scope.loginId = localStorage.userId;
        $scope.mngFlg = localStorage.mngKbn;

        if ($scope.mngFlg != "2") {
            $scope.userInfo = ajaxService.searchUser($rootScope.projectId, $scope.loginId);
            $scope.loginGroupList = $scope.userInfo.groupList;
        }


        $rootScope.isHome = false;
        $rootScope.isProject = false;

      $scope.readonly = false;
//      if (localStorage.mngKbn == "2" || localStorage.mngKbn == "9") {
//        $scope.readonly = false;
//      }


      $scope.searchFileList = function () {
          $scope.newsFileList = ajaxService.getFileListNews($scope.newsId);
      };

      $scope.showNewsDetail = function(newsId, isScroll) {
          $scope.newsId = newsId
          $scope.selectedNews = ajaxService.getNews(newsId);
          $scope.selectedNews.newsId = newsId;
          $scope.searchFileList();

          $scope.detailDisplay = 'block';

          $("#creater").css({
            'display' : 'none'
          });
          $("#confirmDetail").css({
              'display' : 'none'
            });
          if (isScroll) {
        	  $("body,html").animate({
                  scrollTop : $("#newsDetail").offset().top - 100
              }, 1000);
          }
        };


      $scope.getNewsList = function(isShowDetail) {

        var u =window.location.hash;
        var par = u.split("=");
        if (par.length == 1 || par[0].indexOf("news") == -1) {
          $scope.newsList = ajaxService.getNewsList($rootScope.projectId);
        } else {
          var kbn = par[1];
            if (kbn == 'm') {
              $scope.newsList = ajaxService.getUnconfirmNewsList($rootScope.projectId);
            } else {
            	$scope.newsList = ajaxService.getNewsList($rootScope.projectId);
            	if (isShowDetail) {
            		$scope.showNewsDetail(kbn, false);
            	}
            }
        }

      };

      $scope.getNewsList(true);


      $scope.createNews = new Object();


      $scope.showCreateNews = function () {

    	$scope.selectedGroups = {selected:[]};
    	$scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
    	$scope.selectedGroup = new Object();

        $scope.createNews = new Object();
          $("#creater").css({
            'display' : 'block'
          });
          $scope.detailDisplay = 'none';
          $("#confirmDetail").css({
              'display' : 'none'
            });

          $("body,html").animate({
              scrollTop : $("#creater").offset().top - 100
          }, 1000);
        };


        $scope.showCreateNewsSp = function () {

      	$scope.selectedGroups = {selected:[]};
      	$scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
      	$scope.selectedGroup = new Object();

          $scope.createNews = new Object();
            $("#creater").css({
              'display' : 'block'
            });
            $scope.detailDisplay = 'none';
//
//            $("#confirmDetail").css({
//                'display' : 'none'
//              });

            $("body,html").animate({
                scrollTop : $("#creater").offset().top - 100
            }, 1000);
          };


        $scope.create = function () {

	    	var groupidlist = [];

	    	for (var i =0; i< $scope.selectedGroups.selected.length; i++) {
	        	if ($rootScope.listContains(groupidlist, $scope.selectedGroups.selected[i].groupId)){
	           		 continue;
	           	 }
	          groupidlist.push($scope.selectedGroups.selected[i].groupId);
	        }

//	    	if ($scope.mngFlg == '2') {
//	    		for (var i =0; i< $scope.selectedGroups.selected.length; i++) {
//		        	if ($rootScope.listContains(groupidlist, $scope.selectedGroups.selected[i].groupId)){
//		           		 continue;
//		           	 }
//		          groupidlist.push($scope.selectedGroups.selected[i].groupId);
//		        }
//	    	} else {
//	    		if ($scope.loginGroupList.length == 1) {
//	    			groupidlist.push($scope.loginGroupList[0].groupId);
//	    		} else if ($scope.loginGroupList.length > 1) {
//	    			if (! $scope.selectedGroup.groupId) {
//	    				$rootScope.showErrorMessage("対象グループを選択してください。");
//	    				return true;
//	    			}
//	    			groupidlist.push($scope.selectedGroup.groupId);
//	    		}
//	    	}


          if (! $scope.createNews.limitDateD) {
              $rootScope.showErrorMessage("表示期限を入力してください。");
            return true;
          }

          if ($rootScope.formatDate($scope.createNews.limitDateD, "YYYY/MM/DD")  < $rootScope.formatDate(new Date(), "YYYY/MM/DD")) {
            $rootScope.showErrorMessage("表示期限は現在以降の日付を入力してください。");
              return true;
          }

          if (! $scope.createNews.title) {
              $rootScope.showErrorMessage("タイトルを入力してください。");
            return true;
          }
          if (! $scope.createNews.content) {
              $rootScope.showErrorMessage("内容を入力してください。");
            return true;
          }

          ajaxService.createNews($rootScope.projectId, $rootScope.formatDate($scope.createNews.limitDateD, "YYYY/MM/DD"), $scope.createNews.title, $scope.createNews.content, groupidlist);
          if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            return true;
          } else {
            $rootScope.showInfoMessage("お知らせを登録しました。");
            $scope.getNewsList(false);
            $("#creater").css({
                'display' : 'none'
              });
            $("#confirmDetail").css({
                'display' : 'none'
              });
            $("body,html").animate({
                scrollTop : $("#newsList").offset().top - 100
            }, 1000);;
            return true;
          }

        };

      $scope.openUploadDialog = function(newsId) {
          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/fileUploadModal.html',
              controller : 'FileUploadCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  openFlag : function() {
                      return {
                          'flag' : 'New',
                          'kbn' : 'News',
                          'id': $scope.newsId
                      };
                  }
              }
          });
      };

      $scope.delFile = function (fileBean) {
          var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : "該当ファイルを削除してもよろしいですか？"
                      };
                  }
              }
          });
          modalInstance.result.then(function() {
            ajaxService.removeFileNews($rootScope.projectId, $scope.newsId, fileBean.id, fileBean.fileExternal);
            if (ajaxService.result['resultCd'] != "000000") {
              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            } else {
              $rootScope.showInfoMessage("該当ファイルを削除しました。");
              $scope.searchFileList($scope.newsId);
            }
          });
        };

        $scope.confirmNews = function () {
          ajaxService.confirmNews($scope.newsId);
          if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
          } else {
            $rootScope.showInfoMessage("確認しました。");
            $scope.getNewsList(false);
            $scope.searchFileList($scope.newsId);
            $scope.selectedNews = ajaxService.getNews($scope.newsId);
          }
        };


        $scope.showNewsComfirmInfo = function (newsId) {
            $scope.selectedNews = ajaxService.getNews(newsId);
            $scope.selectedNews.newsId = newsId;
            $scope.userConfirmList = ajaxService.getUserConfirm(newsId);

            $scope.groupNames = "";
            var groupList = $scope.selectedNews.groupList;
            for (var i=0;i<groupList.length;i++) {
            	if ($scope.groupNames == '') {
            		$scope.groupNames = groupList[i].groupName;
            	} else {
                	$scope.groupNames = $scope.groupNames + "、" + groupList[i].groupName;
            	}
            }

            $("#creater").css({
              'display' : 'none'
            });
            $("#confirmDetail").css({
                'display' : 'block'
              });

            $scope.detailDisplay = 'none';
            $("body,html").animate({
                scrollTop : $("#confirmDetail").offset().top - 100
            }, 1000);
        };

        $scope.deleteNews = function (newsId) {
          var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "該当お知らせを削除してもよろしいですか？"
                        };
                    }
                }
            });
            modalInstance.result.then(function() {
              ajaxService.removeNews(newsId, $rootScope.projectId);
              if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              } else {
                $rootScope.showInfoMessage("削除しました。");
                $scope.getNewsList(false);
                $("#confirmDetail").css({
                    'display' : 'none'
                  });
                $("body,html").animate({
                    scrollTop : $("#newsList").offset().top - 100
                }, 1000);
              }
            });
        };

        $scope.deleteNewsSp = function (newsId) {
            var modalInstance = $uibModal.open({
                  animation : true,
                  templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                  controller : 'confirmDialogCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                              message : "該当お知らせを削除してもよろしいですか？"
                          };
                      }
                  }
              });
              modalInstance.result.then(function() {
                ajaxService.removeNews(newsId, $rootScope.projectId);
                if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                } else {
                  $rootScope.showInfoMessage("削除しました。");
                  $scope.getNewsList(false);
                  $scope.detailDisplay = 'none';
                  $("body,html").animate({
                      scrollTop : $("#newsList").offset().top - 100
                  }, 1000);
                }
              });
          };

    }

})();

/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.masterdata').controller('Masterdata4CheckSheetCtrl', Masterdata4CheckSheetCtrl);

    /** @ngInject */
    function Masterdata4CheckSheetCtrl($scope, ajaxService, $window, $uibModal, $rootScope, tr, Upload) {

    	$scope.projectId = "0";
    	if ($rootScope.projectId) {
        	$scope.projectId = $rootScope.projectId;
    	}

    	if ($scope.projectId == "0") {
    		//デフォルトチェック定義時、チェック詳細用選択値
    	      $scope.ctrl = $scope;
    		  $scope.detailList = new Array();
    	      $scope.removeIdList = new Array();

    	      $scope.getCheckResultList = function () {
    	        $scope.userResourceList = ajaxService.searchUserResource($scope.projectId, 0);
    	      };

    	      $scope.getCheckResultList();

    	      $scope.showCheckResultDetail = function (item) {
    	        $scope.userResGroupName = item.label
    	        $scope.userResGroup = item.value
    	        $scope.removeIdList = new Array();
    	        $scope.detailList = ajaxService.searchUserResourceDetail(item.value);
    	        $uibModal.open({
    	            animation: true,
    	            templateUrl: "app/pages/masterdata/checkResultDetailMaster.html",
    	            scope : $scope,
    	            backdrop : "static",
    	            resolve: {
    	                openFlag: function () {
    	                    return {};
    	              }
    	            }
    	          });
    	      };

    	      $scope.showCheckResultCreate = function () {
    	        $scope.detailList = new Array();
    	        $scope.userResGroupName = ""
    	        $scope.userResGroup = ""
    	        $uibModal.open({
    	          animation: true,
    	          templateUrl: "app/pages/masterdata/checkResultDetailMaster.html",
    	          scope : $scope,
    	          backdrop : "static",
    	          resolve: {
    	              openFlag: function () {
    	                  return {};
    	            }
    	          }
    	        });
    	      };

    	      $scope.removeUserResource = function (urg) {
    	    	  if (ajaxService.checkUserResource(urg) == '1') {
    	    		  $rootScope.showErrorMessage("該当チェック詳細を使用されているため、削除できません。");
    	              return;
    	    	  }

    	        var modalInstance = $uibModal.open({
    	            animation : true,
    	            templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
    	            controller : 'confirmDialogCtrl',
    	            scope : $scope,
    	            backdrop : "static",
    	            resolve : {
    	                message : function() {
    	                    return {
    	                        message : "該当チェック詳細を削除してもよろしいですか？"
    	                    };
    	                }
    	            }
    	        });

    	        modalInstance.result.then(function() {
    	          ajaxService.removeUserResource(urg);
    	          if (ajaxService.result['resultCd'] == "000000") {
    	            $rootScope.showInfoMessage("選択値詳細を削除しました。");
    	            $scope.getCheckResultList();
    	          }
    	        });
    	      };

    	      $scope.addDetail = function () {
    	        $scope.insertDetail = {
    	          value: 0,
    	          sort: $scope.detailList.length+1,
    	          label: '',
    	          ngFlg:'0'
    	        };
    	        $scope.detailList.push($scope.insertDetail);
    	      };

    	      $scope.removeDetail = function(index, value) {
    	        $scope.detailList.splice(index, 1);
    	        if (value) {
    	          $scope.removeIdList.push(value);
    	        }
    	      };

    	      $scope.saveDetail = function () {
    	    	  var err = 0;
    	        if (! $scope.userResGroupName) {
    	          $rootScope.showErrorMessage("結果名称を入力してください。");
    	            return;
    	        }
    	        var dl = $scope.detailList.length;
    	        if (dl == 0) {
    	          $rootScope.showErrorMessage("選択値を設定してください。");
    	          return;
    	        }
    	        var num = /^[0-9]*$/;
    	        for (var i=0; i < dl; i++) {
    	          if (! $("#label"+i).val().trim()) {
    	            $rootScope.showErrorMessage("選択値名称を入力してください。");
    	            return;
    	          }
    	          if ($("#sort"+i).val()) {
    	            if (! num.test($("#sort"+i).val())) {
    	              $rootScope.showErrorMessage("表示順に数字で入力してください。");
    	              return;
    	            }
    	          }
    	        }

    	        var urg = "";
    	        if ($scope.userResGroup) {
    	          urg = $scope.userResGroup;
    	        }
    	        var newUserResGroup = ajaxService.saveUserResource($scope.projectId, urg, $scope.userResGroupName);
    	        if (ajaxService.result['resultCd'] != "000000") {
    	            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	            return;
    	        }
    	        if (newUserResGroup) {
    	          $scope.userResGroup = newUserResGroup;
    	          urg = newUserResGroup;
    	        }
    	        if ($scope.removeIdList.length != 0) {

    	            var rs = ajaxService.removeUserResourceDetail($scope.removeIdList, urg);
    	            if (rs == "1") {
    	            	err = 1;
    	            	$rootScope.showErrorMessage("選択値詳細を使用されているため、削除できません。");
    	            }
    	            if (ajaxService.result['resultCd'] == "000000") {
    	              $scope.removeIdList = new Array();
    	            }
    	        }

    	        var usdList =[];
    	        for (var i=0; i < dl; i++) {
    	          var ngFlg = "0";
    	          if ($("#ngFlg"+i).prop("checked")) {
    	            ngFlg = "1";
    	          }
    	          var usdOb = {label:$("#label"+i).val(), value:$("#value"+i).val(), ngFlgStr:ngFlg, sort:i+1};
    	          usdList.push(usdOb);
    	        }
    	        ajaxService.saveUserResourceDetail(urg, usdList);

    	        $scope.getCheckResultList();
    	        $scope.detailList = ajaxService.searchUserResourceDetail(urg);

    	        if (ajaxService.result['resultCd'] == "000000") {
    	        	if (err == 0) {
    	                $rootScope.showInfoMessage("チェック詳細を保存しました。");
    	                $scope.$$childTail.$dismiss();
    	        	}
    	        }

    	        if (typeof $scope.$parent.loadResource == "function"){
    	            $scope.$parent.loadResource();
    	            $scope.$parent.createInputTypeConf();
    	        }

    	      };

    	   //チェック詳細END
    	}


    	  $scope.getFirstCheckList = function () {
            $scope.firstCheckList = ajaxService.getProjectResourceList($scope.projectId, '91', 0);
          };

          $scope.getSecondCheckList = function (parent) {
            $scope.secondCheckList = ajaxService.getProjectResourceList($scope.projectId, '92', parent);
          };

          $scope.getThirdCheckList = function (parent) {
            $scope.thirdCheckList = ajaxService.getProjectResourceList($scope.projectId, '93', parent);
          };

          $scope.getFourthCheckList = function (parent) {
            $scope.fourthCheckList = ajaxService.getProjectResourceList($scope.projectId, '94', parent);
          };


          $scope.getFirstCheckList();

          $scope.addFirstCheck = function () {
            $scope.insertFirstCheck = {
              id: 0,
              sort: $scope.firstCheckList.length+1,
              label: ''
            };
            $scope.firstCheckList.push($scope.insertFirstCheck);
          }
          $scope.addSecondCheck = function () {
            $scope.insertSecondCheck = {
              id: 0,
              sort: $scope.secondCheckList.length+1,
              label: ''
            };
            $scope.secondCheckList.push($scope.insertSecondCheck);
          }
          $scope.addThirdCheck = function () {
            $scope.insertThirdCheck = {
              id: 0,
              sort: $scope.thirdCheckList.length+1,
              label: ''
            };
            $scope.thirdCheckList.push($scope.insertThirdCheck);
          }
          $scope.addFourthCheck = function () {
              $scope.insertFourthCheck = {
                id: 0,
                sort: $scope.fourthCheckList.length+1,
                label: ''
              };
              $scope.fourthCheckList.push($scope.insertFourthCheck);
            }

          $scope.removeFirstCheckIdList = new Array();
          $scope.removeSecondCheckIdList = new Array();
          $scope.removeThirdCheckIdList = new Array();
          $scope.removeFourthCheckIdList = new Array();

          $scope.removeFirstCheck = function(index, item) {
            $scope.firstCheckList.splice(index, 1);
            if (item.id) {
                $scope.removeFirstCheckIdList.push(item);
              }
          };
          $scope.removeSecondCheck = function(index, item) {
            $scope.secondCheckList.splice(index, 1);
            if (item.id) {
                $scope.removeSecondCheckIdList.push(item);
              }
          };
          $scope.removeThirdCheck = function(index, item) {
            $scope.thirdCheckList.splice(index, 1);
            if (item.id) {
                $scope.removeThirdCheckIdList.push(item);
              }
          };
          $scope.removeFourthCheck = function(index, item) {
	          $scope.fourthCheckList.splice(index, 1);
	          if (item.id) {
	              $scope.removeFourthCheckIdList.push(item);
	            }
	        };

          $scope.cancelFirstCheck = function() {
        	  $scope.getFirstCheckList();
              $scope.removeFirstCheckIdList = new Array();
          };
          $scope.cancelSecondCheck = function() {
              $scope.getSecondCheckList($scope.SecondCheckParent);
              $scope.removeSecondCheckIdList = new Array();
          };
          $scope.cancelThirdCheck = function() {
              $scope.getThirdCheckList($scope.ThirdCheckParent);
              $scope.removeThirdCheckIdList = new Array();
          };
          $scope.cancelFourthCheck = function() {
              $scope.getFourthCheckList($scope.FourthCheckParent);
              $scope.removeFourthCheckIdList = new Array();
          };

          $scope.saveFirstCheckList = function() {

        	  var size = $scope.firstCheckList.length;

        	  for(var i=0 ;i < size; i++ ){
        		  $scope.firstCheckList[i].label = $("#firstCheckLabel"+i).val().trim();
        		  if  (! $scope.firstCheckList[i].label) {
        			  $rootScope.showErrorMessage("名称を入力してください。");
        			  return "";
        		  }
        	  }

        	  var modalInstance = $uibModal.open({
                  animation : true,
                  templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                  controller : 'confirmDialogCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                              message : "保存してもよろしいですか？"
                          };
                      }
                  }
              });
              modalInstance.result.then(function() {
            	  for (var i=0 ;i < size; i++) {
            		  $scope.firstCheckList[i].sort = i+1;
            		  $scope.firstCheckList[i].label = $("#firstCheckLabel"+i).val();
            		  if ($scope.firstCheckList[i].id == 0) {
            			//新規
            	          ajaxService.createProjectResource($scope.firstCheckList[i], $scope.projectId, '91', 0);
            	          if (ajaxService.result['resultCd'] != "000000") {
            	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            	              return "";
            	          }
            		  } else {
            			// 更新
            	          ajaxService.modifyProjectResource($scope.firstCheckList[i]);
            	          if (ajaxService.result['resultCd'] != "000000") {
            	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            	                return "";
            	            }
            		  }
            	  }

            	  for (var i = 0; i < $scope.removeFirstCheckIdList.length; i ++) {

            		  var isUsed =  ajaxService.checkUsedInCheckList(91, $scope.removeFirstCheckIdList[i].id);
                 	  if (isUsed != 0) {
                 		 $rootScope.showErrorMessage($scope.removeFirstCheckIdList[i].label + "を既にチェックで参照されているため、削除できません。");
                 		 continue;
                 	  }
            		  //削除
                 	 ajaxService.deleteProjectResource($scope.removeFirstCheckIdList[i].id);
            		  if (ajaxService.result['resultCd'] != "000000") {
        	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        	                return "";
        	            }
            	  }
            	  $rootScope.showInfoMessage("保存しました。");
                  $scope.getFirstCheckList();
                  $scope.removeFirstCheckIdList = new Array();
                  $("#master4Check2").css({
                      'display' : 'none'
                    });
                    $("#master4Check3").css({
                        'display' : 'none'
                      });
                    $("#master4Check4").css({
                        'display' : 'none'
                      });
              });
          };

          $scope.saveSecondCheckList = function() {
        	  var size = $scope.secondCheckList.length;

        	  for(var i=0 ;i < size; i++ ){
        		  $scope.secondCheckList[i].label = $("#secondCheckLabel"+i).val().trim();
        		  if  (! $scope.secondCheckList[i].label) {
        			  $rootScope.showErrorMessage("名称を入力してください。");
        			  return "";
        		  }
        	  }

        	  var modalInstance = $uibModal.open({
                  animation : true,
                  templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                  controller : 'confirmDialogCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                              message : "保存してもよろしいですか？"
                          };
                      }
                  }
              });
              modalInstance.result.then(function() {
            	  for (var i=0 ;i < size; i++) {
            		  $scope.secondCheckList[i].sort = i+1;
            		  $scope.secondCheckList[i].label = $("#secondCheckLabel"+i).val();
            		  if ($scope.secondCheckList[i].id == 0) {
            			//新規
            	          ajaxService.createProjectResource($scope.secondCheckList[i], $scope.projectId, '92', $scope.SecondCheckParent);
            	          if (ajaxService.result['resultCd'] != "000000") {
            	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            	              return "";
            	          }
            		  } else {
            			// 更新
            	          ajaxService.modifyProjectResource($scope.secondCheckList[i]);
            	          if (ajaxService.result['resultCd'] != "000000") {
            	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            	                return "";
            	            }
            		  }
            	  }

            	  for (var i = 0; i < $scope.removeSecondCheckIdList.length; i ++) {

            		  var isUsed =  ajaxService.checkUsedInCheckList(92, $scope.removeSecondCheckIdList[i].id);
                 	  if (isUsed != 0) {
                 		 $rootScope.showErrorMessage($scope.removeSecondCheckIdList[i].label + "を既にチェックで参照されているため、削除できません。");
                 		 continue;
                 	  }
            		  //削除
                 	 ajaxService.deleteProjectResource($scope.removeSecondCheckIdList[i].id);
            		  if (ajaxService.result['resultCd'] != "000000") {
        	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        	                return "";
        	            }
            	  }
            	  $rootScope.showInfoMessage("保存しました。");
                  $scope.getSecondCheckList($scope.SecondCheckParent);
                  $scope.removeSecondCheckIdList = new Array();
                    $("#master4Check3").css({
                        'display' : 'none'
                      });
                    $("#master4Check4").css({
                        'display' : 'none'
                      });

              });
          };

          $scope.saveThirdCheckList = function() {
        	  var size = $scope.thirdCheckList.length;

        	  for(var i=0 ;i < size; i++ ){
        		  $scope.thirdCheckList[i].label = $("#thirdCheckLabel"+i).val().trim();
        		  if  (! $scope.thirdCheckList[i].label) {
        			  $rootScope.showErrorMessage("名称を入力してください。");
        			  return "";
        		  }
        	  }

        	  var modalInstance = $uibModal.open({
                  animation : true,
                  templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                  controller : 'confirmDialogCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                              message : "保存してもよろしいですか？"
                          };
                      }
                  }
              });
              modalInstance.result.then(function() {
            	  for (var i=0 ;i < size; i++) {
            		  $scope.thirdCheckList[i].sort = i+1;
            		  $scope.thirdCheckList[i].label = $("#thirdCheckLabel"+i).val();
            		  if ($scope.thirdCheckList[i].id == 0) {
            			//新規
            	          ajaxService.createProjectResource($scope.thirdCheckList[i], $scope.projectId, '93',  $scope.ThirdCheckParent);
            	          if (ajaxService.result['resultCd'] != "000000") {
            	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            	              return "";
            	          }
            		  } else {
            			// 更新
            	          ajaxService.modifyProjectResource($scope.thirdCheckList[i]);
            	          if (ajaxService.result['resultCd'] != "000000") {
            	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            	                return "";
            	            }
            		  }
            	  }

            	  for (var i = 0; i < $scope.removeThirdCheckIdList.length; i ++) {

            		  var isUsed =  ajaxService.checkUsedInCheckList(93, $scope.removeThirdCheckIdList[i].id);
                 	  if (isUsed != 0) {
                 		 $rootScope.showErrorMessage($scope.removeThirdCheckIdList[i].label + "を既にチェックで参照されているため、削除できません。");
                 		 continue;
                 	  }
            		  //削除
                 	 ajaxService.deleteProjectResource($scope.removeThirdCheckIdList[i].id);
            		  if (ajaxService.result['resultCd'] != "000000") {
        	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        	                return "";
        	            }
            	  }
            	  $rootScope.showInfoMessage("保存しました。");
                  $scope.getThirdCheckList($scope.ThirdCheckParent);
                  $scope.removeThirdCheckIdList = new Array();
                  $("#master4Check4").css({
                      'display' : 'none'
                    });
              });
          };

          $scope.saveFourthCheckList = function() {
        	  var size = $scope.fourthCheckList.length;

        	  for(var i=0 ;i < size; i++ ){
        		  $scope.fourthCheckList[i].label = $("#fourthCheckLabel"+i).val().trim();
        		  if  (! $scope.fourthCheckList[i].label) {
        			  $rootScope.showErrorMessage("名称を入力してください。");
        			  return "";
        		  }
        	  }

        	  var modalInstance = $uibModal.open({
                  animation : true,
                  templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                  controller : 'confirmDialogCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                              message : "保存してもよろしいですか？"
                          };
                      }
                  }
              });
              modalInstance.result.then(function() {
            	  for (var i=0 ;i < size; i++) {
            		  $scope.fourthCheckList[i].sort = i+1;
            		  $scope.fourthCheckList[i].label = $("#fourthCheckLabel"+i).val();
            		  if ($scope.fourthCheckList[i].id == 0) {
            			//新規
            	          ajaxService.createProjectResource($scope.fourthCheckList[i], $scope.projectId, '94',  $scope.FourthCheckParent);
            	          if (ajaxService.result['resultCd'] != "000000") {
            	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            	              return "";
            	          }
            		  } else {
            			// 更新
            	          ajaxService.modifyProjectResource($scope.fourthCheckList[i]);
            	          if (ajaxService.result['resultCd'] != "000000") {
            	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            	                return "";
            	            }
            		  }
            	  }

            	  for (var i = 0; i < $scope.removeFourthCheckIdList.length; i ++) {

            		  //TODO マスタデータ削除時、確認ロジック修正要
            		  var isUsed =  ajaxService.checkUsedInCheckList(94, $scope.removeFourthCheckIdList[i].id);
                 	  if (isUsed != 0) {
                 		 $rootScope.showErrorMessage($scope.removeFourthCheckIdList[i].label + "を既にチェックで参照されているため、削除できません。");
                 		 continue;
                 	  }
            		  //削除
                 	 ajaxService.deleteProjectResource($scope.removeFourthCheckIdList[i].id);
            		  if (ajaxService.result['resultCd'] != "000000") {
        	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        	                return "";
        	            }
            	  }
            	  $rootScope.showInfoMessage("保存しました。");
                  $scope.getFourthCheckList($scope.FourthCheckParent);
                  $scope.removeFourthCheckIdList = new Array();
              });
          };

          $scope.showSecondCheck = function(item) {
            $scope.SecondCheckTileName = item.label;
            $scope.SecondCheckParent = item.id;

            $scope.getSecondCheckList($scope.SecondCheckParent);
              $("#master4Check2").css({
                'display' : 'block'
              });
              $("#master4Check3").css({
                  'display' : 'none'
                });
              $("#master4Check4").css({
                  'display' : 'none'
                });
              if ($scope.projectId != "0") {
            	  $("body,html").animate({
                      scrollTop : $("#master4Check2").offset().top - 100
                  }, 1000);
              }

          };

          $scope.showThirdCheck = function(item) {
            $scope.ThirdCheckTileName = item.label;
            $scope.ThirdCheckParent = item.id;

            $scope.getThirdCheckList($scope.ThirdCheckParent);
              $("#master4Check3").css({
                'display' : 'block'
              });
              $("#master4Check4").css({
                  'display' : 'none'
                });
              if ($scope.projectId != "0") {
            	  $("body,html").animate({
                      scrollTop : $("#master4Check3").offset().top - 100
                  }, 1000);
              }
          };

          $scope.showFourthCheck = function(item) {
            $scope.FourthCheckTileName = item.label;
            $scope.FourthCheckParent = item.id;

            $scope.getFourthCheckList($scope.FourthCheckParent);
              $("#master4Check4").css({
                'display' : 'block'
              });
              if ($scope.projectId != "0") {
	              $("body,html").animate({
	                  scrollTop : $("#master4Check4").offset().top - 100
	              }, 1000);
              }
          };


          $scope.showMaster4CheckAll = function() {

              $scope.master4CheckAllList = ajaxService.getMaster4CheckAllList("0");
              console.log($scope.master4CheckAllList);


              $scope.master4CheckShowList = [];
              for(var i=0; i<$scope.master4CheckAllList.length; i++){
                var first = $scope.master4CheckAllList[i];
                var firstShow = null;
                var num = 0;
                var secondList = first.childList;
                if (secondList && secondList.length !=0){
                  for (var j=0; j<secondList.length; j++) {
                    var second = secondList[j];
                    var firstShow2 = null;
                    var num2 = 0;
                    var thirdList = second.childList;
                    if (thirdList && thirdList.length !=0) {
                      for (var k=0; k<thirdList.length; k++) {
                        var third = thirdList[k];
                        var fourthList = third.childList;
                        if (fourthList && fourthList.length !=0) {
                        	for (var m=0; m<fourthList.length; m++) {
                                num ++;
                                num2 ++;
                        		var fourth = fourthList[m];
                        		var show = new Object();
                                show.tougoFirst = 1;
                                show.tougoSecond = 1;
                                show.tougoThird = 1;
                                if (j==0 && k == 0 && m==0) {
                                    show.firstName = first.label;
                                    show.secondName = second.label;
                                    show.thirdName = third.label;
                                    show.tougoFirst = secondList.length;
                                    show.tougoSecond = thirdList.length;
                                    show.tougoThird = fourthList.length;
                                    firstShow = show;
                                    firstShow2 = show;
                                  } else if (j!=0 && k == 0 && m==0){
                                      show.firstName = "";
                                      show.secondName = second.label;
                                      show.thirdName = third.label;
                                      show.tougoSecond = thirdList.length;
                                      show.tougoThird = fourthList.length;
                                      firstShow2 = show;
                                  } else if (k != 0 && m==0){
                                      show.firstName = "";
                                      show.secondName = "";
                                      show.thirdName = third.label;
                                      show.tougoThird = fourthList.length;
                                  } else {
                                      show.firstName = "";
                                      show.secondName = "";
                                      show.thirdName = "";
                                  }
                                show.fourthName = fourth.label;
                                $scope.master4CheckShowList.push(show);
                        	}
                        } else {
                            num ++;
                            num2 ++;
                        	var show = new Object();
                            show.tougoFirst = 1;
                            show.tougoSecond = 1;
                            if (j==0 && k == 0) {
                              show.firstName = first.label;
                              show.secondName = second.label;
                              show.tougoFirst = secondList.length;
                              show.tougoSecond = thirdList.length;
                              firstShow = show;
                              firstShow2 = show;
                            } else if (j!=0 && k == 0){
                                show.firstName = "";
                                show.secondName = second.label;
                                show.tougoSecond = thirdList.length;
                            } else {
                                show.firstName = "";
                                show.secondName = "";
                            }
                            show.thirdName = third.label;
                            show.fourthName = "";
                            $scope.master4CheckShowList.push(show);
                        }
                      }
                    } else {
                      num ++;
                      var show = new Object();
                      show.tougoFirst = 1;
                      show.tougoSecond = 1;
                      if (j == 0) {
                        show.firstName = first.label;
                        show.tougoFirst = secondList.length;
                        firstShow = show;
                      } else {
                        show.firstName = "";
                      }
                      show.secondName = second.label;
                      show.thirdName = "";
                      show.fourthName = "";
                      $scope.master4CheckShowList.push(show);
                    }

                    if (firstShow2) {
                      firstShow2.tougoSecond = num2;
                    }
                  }
                } else {
                  var show = new Object();
                  show.tougoFirst = 1;
                  show.tougoSecond = 1;
                  show.tougoThird = 1;
                  show.firstName = first.label;
                  show.secondName = "";
                  show.thirdName = "";
                  show.fourthName = "";
                  $scope.master4CheckShowList.push(show);
                }

                if (firstShow) {
                  firstShow.tougoFirst = num;
                }
              }

              console.log($scope.master4CheckShowList);

        	  $uibModal.open({
                  animation : true,
                  templateUrl : 'app/pages/masterdata/master4CheckAll.html',
                  scope : $scope,
                  size: 'lg',
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                            type : ""
                          };
                      }
                  }
              });
          }

    }

})();

/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.masterdata').controller('MasterdataCtrl', MasterdataCtrl);

    /** @ngInject */
    function MasterdataCtrl($scope, $filter, editableOptions, editableThemes, toastr,
            toastrConfig, ajaxService, $state, $location, $window, $uibModal, $rootScope, tr, Upload) {

    	if(! window.navigator.onLine){
    		//オフラインの場合、ダウンロードチケットへ遷移
    		window.location.href = "#/offline";
    		return;
    	}

      if (!ajaxService.tokenCheck()) {
            return;
          };

          $rootScope.isHome = false;
          $rootScope.isProject = false;

      $scope.ctrl = $scope;
      $scope.detailList = new Array();
      $scope.removeIdList = new Array();

      $scope.getCheckResultList = function () {
        $scope.userResourceList = ajaxService.searchUserResource($rootScope.projectId, 0);
      };

      $scope.getCheckResultList();

      $scope.showCheckResultDetail = function (item) {
        $scope.userResGroupName = item.label
        $scope.userResGroup = item.value
        $scope.removeIdList = new Array();
        $scope.detailList = ajaxService.searchUserResourceDetail(item.value);
        $uibModal.open({
            animation: true,
            templateUrl: "app/pages/masterdata/checkResultDetailMaster.html",
            scope : $scope,
            backdrop : "static",
            resolve: {
                openFlag: function () {
                    return {};
              }
            }
          });
      };

      $scope.showCheckResultCreate = function () {
        $scope.detailList = new Array();
        $scope.userResGroupName = ""
        $scope.userResGroup = ""
        $uibModal.open({
          animation: true,
          templateUrl: "app/pages/masterdata/checkResultDetailMaster.html",
          scope : $scope,
          backdrop : "static",
          resolve: {
              openFlag: function () {
                  return {};
            }
          }
        });
      };

      $scope.removeUserResource = function (urg) {
    	  if (ajaxService.checkUserResource(urg) == '1') {
    		  $rootScope.showErrorMessage("該当チェック詳細を使用されているため、削除できません。");
              return;
    	  }

        var modalInstance = $uibModal.open({
            animation : true,
            templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
            controller : 'confirmDialogCtrl',
            scope : $scope,
            backdrop : "static",
            resolve : {
                message : function() {
                    return {
                        message : "該当チェック詳細を削除してもよろしいですか？"
                    };
                }
            }
        });

        modalInstance.result.then(function() {
          ajaxService.removeUserResource(urg);
          if (ajaxService.result['resultCd'] == "000000") {
            $rootScope.showInfoMessage("選択値詳細を削除しました。");
            $scope.getCheckResultList();
          }
        });
      };

      $scope.addDetail = function () {
        $scope.insertDetail = {
          value: 0,
          sort: $scope.detailList.length+1,
          label: '',
          ngFlg:'0'
        };
        $scope.detailList.push($scope.insertDetail);
      };

      $scope.removeDetail = function(index, value) {
        $scope.detailList.splice(index, 1);
        if (value) {
          $scope.removeIdList.push(value);
        }
      };

      $scope.saveDetail = function () {
    	  var err = 0;
        if (! $scope.userResGroupName) {
          $rootScope.showErrorMessage("結果名称を入力してください。");
            return;
        }
        var dl = $scope.detailList.length;
        if (dl == 0) {
          $rootScope.showErrorMessage("選択値を設定してください。");
          return;
        }
        var num = /^[0-9]*$/;
        for (var i=0; i < dl; i++) {
          if (! $("#label"+i).val().trim()) {
            $rootScope.showErrorMessage("選択値名称を入力してください。");
            return;
          }
          if ($("#sort"+i).val()) {
            if (! num.test($("#sort"+i).val())) {
              $rootScope.showErrorMessage("表示順に数字で入力してください。");
              return;
            }
          }
        }

        var urg = "";
        if ($scope.userResGroup) {
          urg = $scope.userResGroup;
        }
        var newUserResGroup = ajaxService.saveUserResource($rootScope.projectId, urg, $scope.userResGroupName);
        if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            return;
        }
        if (newUserResGroup) {
          $scope.userResGroup = newUserResGroup;
          urg = newUserResGroup;
        }
        if ($scope.removeIdList.length != 0) {

            var rs = ajaxService.removeUserResourceDetail($scope.removeIdList, urg);
            if (rs == "1") {
            	err = 1;
            	$rootScope.showErrorMessage("選択値詳細を使用されているため、削除できません。");
            }
            if (ajaxService.result['resultCd'] == "000000") {
              $scope.removeIdList = new Array();
            }
        }

        var usdList =[];
        for (var i=0; i < dl; i++) {
          var ngFlg = "0";
          if ($("#ngFlg"+i).prop("checked")) {
            ngFlg = "1";
          }
          var usdOb = {label:$("#label"+i).val(), value:$("#value"+i).val(), ngFlgStr:ngFlg, sort:i+1};
          usdList.push(usdOb);
        }
        ajaxService.saveUserResourceDetail(urg, usdList);

        $scope.getCheckResultList();
        $scope.detailList = ajaxService.searchUserResourceDetail(urg);

        if (ajaxService.result['resultCd'] == "000000") {
        	if (err == 0) {
                $rootScope.showInfoMessage("チェック詳細を保存しました。");
        	}
        }
        if (typeof $scope.$close == "function"){
          $scope.$close();
        } else {
        	if (err == 0) {
            	$scope.$$childTail.$dismiss();
        	}
        }
      };


      $scope.saveStatus = function(status) {
    	  if (! status.showName) {
    		  $rootScope.showErrorMessage("表示名を入力してください。");
              return "";
    	  }
    	  status.isShow = '2';
    	  ajaxService.modifyItemName(status, $rootScope.projectId);
    	  if (ajaxService.result['resultCd'] != "000000") {
              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              return "";
          } else {
            $rootScope.showInfoMessage("保存しました。");
          }
      };

      $scope.itemStatusList = ajaxService.searchItemNameList("1", $rootScope.projectId);

      $scope.ticketItemNameList = ajaxService.searchItemNameList("3", $rootScope.projectId);
      for (var i=0; i<$scope.ticketItemNameList.length; i++) {
          var field = $scope.ticketItemNameList[i].fieldName;
          if (field == "statusDetail") {
              $scope.statusDetailItemName = $scope.ticketItemNameList[i].showName;
            }
          if (field == "kbn2") {
              $scope.ticketKbn2ItemName = $scope.ticketItemNameList[i].showName;
          }
          if (field == "kbn3") {
              $scope.ticketKbn3ItemName = $scope.ticketItemNameList[i].showName;
          }
          if (field == "kbn4") {
              $scope.ticketKbn4ItemName = $scope.ticketItemNameList[i].showName;
          }
          if (field == "kbn5") {
              $scope.ticketKbn5ItemName = $scope.ticketItemNameList[i].showName;
          }
      }



      $scope.getStatusDetailList = function () {
        $scope.statusDetailList = ajaxService.getProjectResourceList($rootScope.projectId, '4', 0);
      };
      $scope.getTicketKbn2List = function () {
        $scope.ticketKbn2List = ajaxService.getProjectResourceList($rootScope.projectId, '5', 0);
      };
      $scope.getTicketKbn3List = function () {
        $scope.ticketKbn3List = ajaxService.getProjectResourceList($rootScope.projectId, '6', 0);
      };
      $scope.getTicketKbn4List = function () {
        $scope.ticketKbn4List = ajaxService.getProjectResourceList($rootScope.projectId, '7', 0);
      };
      $scope.getTicketKbn5List = function () {
        $scope.ticketKbn5List = ajaxService.getProjectResourceList($rootScope.projectId, '8', 0);
      };

      $scope.getStatusDetailList();
      $scope.getTicketKbn2List();
      $scope.getTicketKbn3List();
      $scope.getTicketKbn4List();
      $scope.getTicketKbn5List();

      $scope.addStatusDetail = function () {
          $scope.insertedStatusDetail = {
            id: 0,
	        sort: $scope.statusDetailList.length+1,
            label: ''
          };
          $scope.statusDetailList.push($scope.insertedStatusDetail);
      };
      $scope.addTicketKbn2 = function () {
          $scope.insertedTicketKbn2 = {
            id: 0,
	        sort: $scope.ticketKbn2List.length+1,
            label: ''
          };
          $scope.ticketKbn2List.push($scope.insertedTicketKbn2);
      };
      $scope.addTicketKbn3 = function () {
          $scope.insertedTicketKbn3 = {
            id: 0,
	        sort: $scope.ticketKbn3List.length+1,
            label: ''
          };
          $scope.ticketKbn3List.push($scope.insertedTicketKbn3);
      };
      $scope.addTicketKbn4 = function () {
          $scope.insertedTicketKbn4 = {
            id: 0,
	        sort: $scope.ticketKbn4List.length+1,
            label: ''
          };
          $scope.ticketKbn4List.push($scope.insertedTicketKbn4);
      };
      $scope.addTicketKbn5 = function () {
          $scope.insertedTicketKbn5 = {
            id: 0,
	        sort: $scope.ticketKbn5List.length+1,
            label: ''
          };
          $scope.ticketKbn5List.push($scope.insertedTicketKbn5);
      };


      $scope.cancelStatusDetail = function() {
          $scope.getStatusDetailList();
          $scope.removeStatusDetailList = new Array();
      };
      $scope.cancelTicketKbn2 = function() {
          $scope.getTicketKbn2List();
          $scope.removeTicketKbn2List = new Array();
      };
      $scope.cancelTicketKbn3 = function() {
          $scope.getTicketKbn3List();
          $scope.removeTicketKbn3List = new Array();
      };
      $scope.cancelTicketKbn4 = function() {
          $scope.getTicketKbn4List();
          $scope.removeTicketKbn4List = new Array();
      };
      $scope.cancelTicketKbn5 = function() {
          $scope.getTicketKbn5List();
          $scope.removeTicketKbn5List = new Array();
      };


      $scope.removeStatusDetailList = new Array();
      $scope.removeTicketKbn2List = new Array();
      $scope.removeTicketKbn3List = new Array();
      $scope.removeTicketKbn4List = new Array();
      $scope.removeTicketKbn5List = new Array();

      $scope.removeStatusDetail = function(index, id) {
        $scope.statusDetailList.splice(index, 1);
        if (id) {
            $scope.removeStatusDetailList.push(id);
          }
      };
      $scope.removeTicketKbn2 = function(index, id) {
        $scope.ticketKbn2List.splice(index, 1);
        if (id) {
            $scope.removeTicketKbn2List.push(id);
          }
      };
      $scope.removeTicketKbn3 = function(index, id) {
        $scope.ticketKbn3List.splice(index, 1);
        if (id) {
            $scope.removeTicketKbn3List.push(id);
          }
      };
      $scope.removeTicketKbn4 = function(index, id) {
        $scope.ticketKbn4List.splice(index, 1);
        if (id) {
            $scope.removeTicketKbn4List.push(id);
          }
      };
      $scope.removeTicketKbn5 = function(index, id) {
        $scope.ticketKbn5List.splice(index, 1);
        if (id) {
            $scope.removeTicketKbn5List.push(id);
          }
      };


      $scope.saveStatusDetailList = function() {
    	  var size = $scope.statusDetailList.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.statusDetailList[i].label = $("#statusDetailLabel"+i).val().trim();
    		  if  (! $scope.statusDetailList[i].label) {
    			  $rootScope.showErrorMessage("名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  for (var i=0 ;i < size; i++) {
    		  $scope.statusDetailList[i].sort = i+1;
    		  $scope.statusDetailList[i].label = $("#statusDetailLabel"+i).val();
    		  if ($scope.statusDetailList[i].id == 0) {
    			//新規
    	          ajaxService.createProjectResource($scope.statusDetailList[i], $rootScope.projectId, '4',  0);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	              return "";
    	          }
    		  } else {
    			// 更新
    	            ajaxService.modifyProjectResource($scope.statusDetailList[i]);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
    		  }
    	  }

    	  for (var i = 0; i < $scope.removeStatusDetailList.length; i ++) {
    		  //削除
              ajaxService.deleteProjectResource($scope.removeStatusDetailList[i]);
    		  if (ajaxService.result['resultCd'] != "000000") {
	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
	                return "";
	            }
    	  }
    	  $rootScope.showInfoMessage("保存しました。");
          $scope.getStatusDetailList();
          $scope.removeStatusDetailList = new Array();
      };

      $scope.saveTicketKbn2List = function() {
    	  var size = $scope.ticketKbn2List.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.ticketKbn2List[i].label = $("#ticketKbn2Label"+i).val().trim();
    		  if  (! $scope.ticketKbn2List[i].label) {
    			  $rootScope.showErrorMessage("名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  for (var i=0 ;i < size; i++) {
    		  $scope.ticketKbn2List[i].sort = i+1;
    		  $scope.ticketKbn2List[i].label = $("#ticketKbn2Label"+i).val();
    		  if ($scope.ticketKbn2List[i].id == 0) {
    			//新規
    	          ajaxService.createProjectResource($scope.ticketKbn2List[i], $rootScope.projectId, '5',  0);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	              return "";
    	          }
    		  } else {
    			// 更新
    	            ajaxService.modifyProjectResource($scope.ticketKbn2List[i]);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
    		  }
    	  }

    	  for (var i = 0; i < $scope.removeTicketKbn2List.length; i ++) {
    		  //削除
              ajaxService.deleteProjectResource($scope.removeTicketKbn2List[i]);
    		  if (ajaxService.result['resultCd'] != "000000") {
	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
	                return "";
	            }
    	  }
    	  $rootScope.showInfoMessage("保存しました。");
          $scope.getTicketKbn2List();
          $scope.removeTicketKbn2List = new Array();
      };

      $scope.saveTicketKbn3List = function() {
    	  var size = $scope.ticketKbn3List.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.ticketKbn3List[i].label = $("#ticketKbn3Label"+i).val().trim();
    		  if  (! $scope.ticketKbn3List[i].label) {
    			  $rootScope.showErrorMessage("名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  for (var i=0 ;i < size; i++) {
    		  $scope.ticketKbn3List[i].sort = i+1;
    		  $scope.ticketKbn3List[i].label = $("#ticketKbn3Label"+i).val();
    		  if ($scope.ticketKbn3List[i].id == 0) {
    			//新規
    	          ajaxService.createProjectResource($scope.ticketKbn3List[i], $rootScope.projectId, '6',  0);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	              return "";
    	          }
    		  } else {
    			// 更新
    	            ajaxService.modifyProjectResource($scope.ticketKbn3List[i]);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
    		  }
    	  }

    	  for (var i = 0; i < $scope.removeTicketKbn3List.length; i ++) {
    		  //削除
              ajaxService.deleteProjectResource($scope.removeTicketKbn3List[i]);
    		  if (ajaxService.result['resultCd'] != "000000") {
	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
	                return "";
	            }
    	  }
    	  $rootScope.showInfoMessage("保存しました。");
          $scope.getTicketKbn3List();
          $scope.removeTicketKbn3List = new Array();
      };

      $scope.saveTicketKbn4List = function() {
    	  var size = $scope.ticketKbn4List.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.ticketKbn4List[i].label = $("#ticketKbn4Label"+i).val().trim();
    		  if  (! $scope.ticketKbn4List[i].label) {
    			  $rootScope.showErrorMessage("名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  for (var i=0 ;i < size; i++) {
    		  $scope.ticketKbn4List[i].sort = i+1;
    		  $scope.ticketKbn4List[i].label = $("#ticketKbn4Label"+i).val();
    		  if ($scope.ticketKbn4List[i].id == 0) {
    			//新規
    	          ajaxService.createProjectResource($scope.ticketKbn4List[i], $rootScope.projectId, '7',  0);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	              return "";
    	          }
    		  } else {
    			// 更新
    	            ajaxService.modifyProjectResource($scope.ticketKbn4List[i]);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
    		  }
    	  }

    	  for (var i = 0; i < $scope.removeTicketKbn4List.length; i ++) {
    		  //削除
              ajaxService.deleteProjectResource($scope.removeTicketKbn4List[i]);
    		  if (ajaxService.result['resultCd'] != "000000") {
	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
	                return "";
	            }
    	  }
    	  $rootScope.showInfoMessage("保存しました。");
          $scope.getTicketKbn4List();
          $scope.removeTicketKbn4List = new Array();
      };

      $scope.saveTicketKbn5List = function() {
    	  var size = $scope.ticketKbn5List.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.ticketKbn5List[i].label = $("#ticketKbn5Label"+i).val().trim();
    		  if  (! $scope.ticketKbn5List[i].label) {
    			  $rootScope.showErrorMessage("名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  for (var i=0 ;i < size; i++) {
    		  $scope.ticketKbn5List[i].sort = i+1;
    		  $scope.ticketKbn5List[i].label = $("#ticketKbn5Label"+i).val();
    		  if ($scope.ticketKbn5List[i].id == 0) {
    			//新規
    	          ajaxService.createProjectResource($scope.ticketKbn5List[i], $rootScope.projectId, '8',  0);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	              return "";
    	          }
    		  } else {
    			// 更新
    	            ajaxService.modifyProjectResource($scope.ticketKbn5List[i]);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
    		  }
    	  }

    	  for (var i = 0; i < $scope.removeTicketKbn5List.length; i ++) {
    		  //削除
              ajaxService.deleteProjectResource($scope.removeTicketKbn5List[i]);
    		  if (ajaxService.result['resultCd'] != "000000") {
	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
	                return "";
	            }
    	  }
    	  $rootScope.showInfoMessage("保存しました。");
          $scope.getTicketKbn5List();
          $scope.removeTicketKbn5List = new Array();
      };


      $scope.getCompanyList = function () {
        $scope.companyList = ajaxService.searchCompanyList();
      }

      $scope.getCompanyList();


      $scope.removeCompanyIdList = new Array();

      $scope.addCompany = function () {
        $scope.inserted = {
          id: 0,
          order: $scope.companyList.length+1,
          fName: '',
          dName: ''
        };
        $scope.companyList.push($scope.inserted);
      };

      $scope.removeCompany = function(index, id) {
          $scope.companyList.splice(index, 1);
          if (id) {
            $scope.removeCompanyIdList.push(id);
          }
        };


      $scope.deleteCompany = function(company) {
        ajaxService.deleteCompany(company.id);
        if (ajaxService.result['resultCd'] == "000000") {
          $rootScope.showInfoMessage("削除しました。");
        }
        $scope.getCompanyList();
      };

      $scope.saveCompanyList = function() {
    	  var size = $scope.companyList.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.companyList[i].fName = $("#label"+i).val().trim();
    		  if  (! $scope.companyList[i].fName) {
    			  $rootScope.showErrorMessage("会社名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  for (var i=0 ;i < size; i++) {
    		  $scope.companyList[i].order = i+1;
    		  $scope.companyList[i].fName = $("#label"+i).val();
    		  if ($scope.companyList[i].id == 0) {
    			//新規
    	          ajaxService.createCompany($scope.companyList[i]);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	              return "";
    	          }
    		  } else {
    			// 更新
    	          ajaxService.modifyCompany($scope.companyList[i]);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
    		  }
    	  }

    	  for (var i = 0; i < $scope.removeCompanyIdList.length; i ++) {
    		  //削除
    		  ajaxService.deleteCompany($scope.removeCompanyIdList[i]);
    		  if (ajaxService.result['resultCd'] != "000000") {
	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
	                return "";
	            }
    	  }
    	  $rootScope.showInfoMessage("保存しました。");
          $scope.getCompanyList();
          $scope.removeCompanyIdList = new Array();
      };


      $scope.saveCompany = function(company) {
        if (! company.fName) {
          $rootScope.showErrorMessage("会社名称を入力してください。");
          return "";
        }
        var num = /^[0-9]*$/;
        if (company.order) {
            if (! num.test(company.order)) {
              $rootScope.showErrorMessage("表示順に数字で入力してください。");
              return "";
            }
          }

        if (company.id == 0) {
          //新規
          ajaxService.createCompany(company);
          if (ajaxService.result['resultCd'] != "000000") {
              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              return "";
          } else {
            $rootScope.showInfoMessage("保存しました。");
          }
        } else {
          // 更新
          ajaxService.modifyCompany(company);
          if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                return "";
            } else {
              $rootScope.showInfoMessage("保存しました。");
            }
        }
        $scope.getCompanyList();
      };


      $scope.cancelCompany = function() {
    	  $scope.getCompanyList();
          $scope.removeCompanyIdList = new Array();
      };


      $scope.isUsedInTarget = ajaxService.checkUsedInTarget(0, 0, $rootScope.projectId);

      $scope.itemNameList = ajaxService.searchItemNameList("2", $rootScope.projectId);
      for (var i=0; i<$scope.itemNameList.length; i++) {
        var field = $scope.itemNameList[i].fieldName;
        if (field == "first") {
          $scope.firstItemName = $scope.itemNameList[i].showName;
        }
        if (field == "second") {
          $scope.secondItemName = $scope.itemNameList[i].showName;
        }
        if (field == "third") {
            $scope.thirdItemName = $scope.itemNameList[i].showName;
          }

        if (field == "kbn1") {
            $scope.targetKbn1ItemName = $scope.itemNameList[i].showName;
          }
        if (field == "kbn2") {
            $scope.targetKbn2ItemName = $scope.itemNameList[i].showName;
        }
        if (field == "kbn3") {
            $scope.targetKbn3ItemName = $scope.itemNameList[i].showName;
        }
        if (field == "kbn4") {
            $scope.targetKbn4ItemName = $scope.itemNameList[i].showName;
        }
        if (field == "kbn5") {
            $scope.targetKbn5ItemName = $scope.itemNameList[i].showName;
        }

      }


      $scope.getTargetKbn1List = function () {
          $scope.targetKbn1List = ajaxService.getProjectResourceList($rootScope.projectId, '9', 0);
      };

      $scope.getTargetKbn2List = function () {
        $scope.targetKbn2List = ajaxService.getProjectResourceList($rootScope.projectId, '10', 0);
      };

      $scope.getTargetKbn3List = function () {
        $scope.targetKbn3List = ajaxService.getProjectResourceList($rootScope.projectId, '11', 0);
      };

      $scope.getTargetKbn4List = function () {
        $scope.targetKbn4List = ajaxService.getProjectResourceList($rootScope.projectId, '12', 0);
      };

      $scope.getTargetKbn5List = function () {
        $scope.targetKbn5List = ajaxService.getProjectResourceList($rootScope.projectId, '13', 0);
      };

      $scope.getTargetKbn1List();
      $scope.getTargetKbn2List();
      $scope.getTargetKbn3List();
      $scope.getTargetKbn4List();
      $scope.getTargetKbn5List();

      $scope.addTargetKbn1 = function () {
          $scope.insertedTargetKbn1 = {
            id: 0,
	        sort: $scope.targetKbn1List.length+1,
            label: ''
          };
          $scope.targetKbn1List.push($scope.insertedTargetKbn1);
      };
      $scope.addTargetKbn2 = function () {
          $scope.insertedTargetKbn2 = {
            id: 0,
	        sort: $scope.targetKbn2List.length+1,
            label: ''
          };
          $scope.targetKbn2List.push($scope.insertedTargetKbn2);
      };
      $scope.addTargetKbn3 = function () {
          $scope.insertedTargetKbn3 = {
            id: 0,
	        sort: $scope.targetKbn3List.length+1,
            label: ''
          };
          $scope.targetKbn3List.push($scope.insertedTargetKbn3);
      };
      $scope.addTargetKbn4 = function () {
          $scope.insertedTargetKbn4 = {
            id: 0,
	        sort: $scope.targetKbn4List.length+1,
            label: ''
          };
          $scope.targetKbn4List.push($scope.insertedTargetKbn4);
      };
      $scope.addTargetKbn5 = function () {
          $scope.insertedTargetKbn5 = {
            id: 0,
	        sort: $scope.targetKbn5List.length+1,
            label: ''
          };
          $scope.targetKbn5List.push($scope.insertedTargetKbn5);
      };

      $scope.cancelTargetKbn1 = function() {
          $scope.getTargetKbn1List();
          $scope.removeTargetKbn1List = new Array();
      };
      $scope.cancelTargetKbn2 = function() {
          $scope.getTargetKbn2List();
          $scope.removeTargetKbn2List = new Array();
      };
      $scope.cancelTargetKbn3 = function() {
          $scope.getTargetKbn3List();
          $scope.removeTargetKbn3List = new Array();
      };
      $scope.cancelTargetKbn4 = function() {
          $scope.getTargetKbn4List();
          $scope.removeTargetKbn4List = new Array();
      };
      $scope.cancelTargetKbn5 = function() {
          $scope.getTargetKbn5List();
          $scope.removeTargetKbn5List = new Array();
      };

      $scope.removeTargetKbn1List = new Array();
      $scope.removeTargetKbn2List = new Array();
      $scope.removeTargetKbn3List = new Array();
      $scope.removeTargetKbn4List = new Array();
      $scope.removeTargetKbn5List = new Array();

      $scope.removeTargetKbn1 = function(index, id) {
        $scope.targetKbn1List.splice(index, 1);
        if (id) {
            $scope.removeTargetKbn1List.push(id);
          }
      };
      $scope.removeTargetKbn2 = function(index, id) {
        $scope.targetKbn2List.splice(index, 1);
        if (id) {
            $scope.removeTargetKbn2List.push(id);
          }
      };
      $scope.removeTargetKbn3 = function(index, id) {
        $scope.targetKbn3List.splice(index, 1);
        if (id) {
            $scope.removeTargetKbn3List.push(id);
          }
      };
      $scope.removeTargetKbn4 = function(index, id) {
        $scope.targetKbn4List.splice(index, 1);
        if (id) {
            $scope.removeTargetKbn4List.push(id);
          }
      };
      $scope.removeTargetKbn5 = function(index, id) {
        $scope.targetKbn5List.splice(index, 1);
        if (id) {
            $scope.removeTargetKbn5List.push(id);
          }
      };


      $scope.saveTargetKbn1List = function() {
    	  var size = $scope.targetKbn1List.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.targetKbn1List[i].label = $("#targetKbn1Label"+i).val().trim();
    		  if  (! $scope.targetKbn1List[i].label) {
    			  $rootScope.showErrorMessage("名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  for (var i=0 ;i < size; i++) {
    		  $scope.targetKbn1List[i].sort = i+1;
    		  $scope.targetKbn1List[i].label = $("#targetKbn1Label"+i).val();
    		  if ($scope.targetKbn1List[i].id == 0) {
    			//新規
    	          ajaxService.createProjectResource($scope.targetKbn1List[i], $rootScope.projectId, '9',  0);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	              return "";
    	          }
    		  } else {
    			// 更新
    	            ajaxService.modifyProjectResource($scope.targetKbn1List[i]);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
    		  }
    	  }

    	  for (var i = 0; i < $scope.removeTargetKbn1List.length; i ++) {
    		  //削除
              ajaxService.deleteProjectResource($scope.removeTargetKbn1List[i]);
    		  if (ajaxService.result['resultCd'] != "000000") {
	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
	                return "";
	            }
    	  }
    	  $rootScope.showInfoMessage("保存しました。");
          $scope.getTargetKbn1List();
          $scope.removeTargetKbn1List = new Array();
      };

      $scope.saveTargetKbn2List = function() {
    	  var size = $scope.targetKbn2List.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.targetKbn2List[i].label = $("#targetKbn2Label"+i).val().trim();
    		  if  (! $scope.targetKbn2List[i].label) {
    			  $rootScope.showErrorMessage("名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  for (var i=0 ;i < size; i++) {
    		  $scope.targetKbn2List[i].sort = i+1;
    		  $scope.targetKbn2List[i].label = $("#targetKbn2Label"+i).val();
    		  if ($scope.targetKbn2List[i].id == 0) {
    			//新規
    	          ajaxService.createProjectResource($scope.targetKbn2List[i], $rootScope.projectId, '10',  0);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	              return "";
    	          }
    		  } else {
    			// 更新
    	            ajaxService.modifyProjectResource($scope.targetKbn2List[i]);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
    		  }
    	  }

    	  for (var i = 0; i < $scope.removeTargetKbn2List.length; i ++) {
    		  //削除
              ajaxService.deleteProjectResource($scope.removeTargetKbn2List[i]);
    		  if (ajaxService.result['resultCd'] != "000000") {
	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
	                return "";
	            }
    	  }
    	  $rootScope.showInfoMessage("保存しました。");
          $scope.getTargetKbn2List();
          $scope.removeTargetKbn2List = new Array();
      };

      $scope.saveTargetKbn3List = function() {
    	  var size = $scope.targetKbn3List.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.targetKbn3List[i].label = $("#targetKbn3Label"+i).val().trim();
    		  if  (! $scope.targetKbn3List[i].label) {
    			  $rootScope.showErrorMessage("名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  for (var i=0 ;i < size; i++) {
    		  $scope.targetKbn3List[i].sort = i+1;
    		  $scope.targetKbn3List[i].label = $("#targetKbn3Label"+i).val();
    		  if ($scope.targetKbn3List[i].id == 0) {
    			//新規
    	          ajaxService.createProjectResource($scope.targetKbn3List[i], $rootScope.projectId, '11',  0);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	              return "";
    	          }
    		  } else {
    			// 更新
    	            ajaxService.modifyProjectResource($scope.targetKbn3List[i]);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
    		  }
    	  }

    	  for (var i = 0; i < $scope.removeTargetKbn3List.length; i ++) {
    		  //削除
              ajaxService.deleteProjectResource($scope.removeTargetKbn3List[i]);
    		  if (ajaxService.result['resultCd'] != "000000") {
	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
	                return "";
	            }
    	  }
    	  $rootScope.showInfoMessage("保存しました。");
          $scope.getTargetKbn3List();
          $scope.removeTargetKbn3List = new Array();
      };

      $scope.saveTargetKbn4List = function() {
    	  var size = $scope.targetKbn4List.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.targetKbn4List[i].label = $("#targetKbn4Label"+i).val().trim();
    		  if  (! $scope.targetKbn4List[i].label) {
    			  $rootScope.showErrorMessage("名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  for (var i=0 ;i < size; i++) {
    		  $scope.targetKbn4List[i].sort = i+1;
    		  $scope.targetKbn4List[i].label = $("#targetKbn4Label"+i).val();
    		  if ($scope.targetKbn4List[i].id == 0) {
    			//新規
    	          ajaxService.createProjectResource($scope.targetKbn4List[i], $rootScope.projectId, '12',  0);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	              return "";
    	          }
    		  } else {
    			// 更新
    	            ajaxService.modifyProjectResource($scope.targetKbn4List[i]);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
    		  }
    	  }

    	  for (var i = 0; i < $scope.removeTargetKbn4List.length; i ++) {
    		  //削除
              ajaxService.deleteProjectResource($scope.removeTargetKbn4List[i]);
    		  if (ajaxService.result['resultCd'] != "000000") {
	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
	                return "";
	            }
    	  }
    	  $rootScope.showInfoMessage("保存しました。");
          $scope.getTargetKbn4List();
          $scope.removeTargetKbn4List = new Array();
      };

      $scope.saveTargetKbn5List = function() {
    	  var size = $scope.targetKbn5List.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.targetKbn5List[i].label = $("#targetKbn5Label"+i).val().trim();
    		  if  (! $scope.targetKbn5List[i].label) {
    			  $rootScope.showErrorMessage("名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  for (var i=0 ;i < size; i++) {
    		  $scope.targetKbn5List[i].sort = i+1;
    		  $scope.targetKbn5List[i].label = $("#targetKbn5Label"+i).val();
    		  if ($scope.targetKbn5List[i].id == 0) {
    			//新規
    	          ajaxService.createProjectResource($scope.targetKbn5List[i], $rootScope.projectId, '13',  0);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	              return "";
    	          }
    		  } else {
    			// 更新
    	            ajaxService.modifyProjectResource($scope.targetKbn5List[i]);
    	          if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
    		  }
    	  }

    	  for (var i = 0; i < $scope.removeTargetKbn5List.length; i ++) {
    		  //削除
              ajaxService.deleteProjectResource($scope.removeTargetKbn5List[i]);
    		  if (ajaxService.result['resultCd'] != "000000") {
	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
	                return "";
	            }
    	  }
    	  $rootScope.showInfoMessage("保存しました。");
          $scope.getTargetKbn5List();
          $scope.removeTargetKbn5List = new Array();
      };


      $scope.getFirstList = function () {
        $scope.firstList = ajaxService.getProjectResourceList($rootScope.projectId, '1', 0);
      };
      $scope.getSecondList = function (parent) {
        $scope.secondList = ajaxService.getProjectResourceList($rootScope.projectId, '2', parent);
      };
      $scope.getThirdList = function (parent) {
        $scope.thirdList = ajaxService.getProjectResourceList($rootScope.projectId, '3', parent);
      };

      $scope.getFirstList();

      $scope.addFirst = function () {
        $scope.insertFirst = {
          id: 0,
          sort: $scope.firstList.length+1,
          label: ''
        };
        $scope.firstList.push($scope.insertFirst);
      }
      $scope.addSecond = function () {
        $scope.insertSecond = {
          id: 0,
          sort: $scope.secondList.length+1,
          label: ''
        };
        $scope.secondList.push($scope.insertSecond);
      }
      $scope.addThird = function () {
        $scope.insertThird = {
          id: 0,
          sort: $scope.thirdList.length+1,
          label: ''
        };
        $scope.thirdList.push($scope.insertThird);
      }

      $scope.removeFirstIdList = new Array();
      $scope.removeSecondIdList = new Array();
      $scope.removeThirdIdList = new Array();

      $scope.removeFirst = function(index, item) {
        $scope.firstList.splice(index, 1);
        if (item.id) {
            $scope.removeFirstIdList.push(item);
          }
      };
      $scope.removeSecond = function(index, item) {
        $scope.secondList.splice(index, 1);
        if (item.id) {
            $scope.removeSecondIdList.push(item);
          }
      };
      $scope.removeThird = function(index, item) {
        $scope.thirdList.splice(index, 1);
        if (item.id) {
            $scope.removeThirdIdList.push(item);
          }
      };

      $scope.cancelFirst = function() {
    	  $scope.getFirstList();
          $scope.removeFirstIdList = new Array();
      };
      $scope.cancelSecond = function() {
          $scope.getSecondList($scope.SecondParent);
          $scope.removeSecondIdList = new Array();
      };
      $scope.cancelThird = function() {
          $scope.getThirdList($scope.ThirdParent);
          $scope.removeThirdIdList = new Array();
      };

      $scope.saveFirstList = function() {
    	  var size = $scope.firstList.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.firstList[i].label = $("#firstLabel"+i).val().trim();
    		  if  (! $scope.firstList[i].label) {
    			  $rootScope.showErrorMessage("名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : "保存してもよろしいですか？"
                      };
                  }
              }
          });
          modalInstance.result.then(function() {
        	  for (var i=0 ;i < size; i++) {
        		  $scope.firstList[i].sort = i+1;
        		  $scope.firstList[i].label = $("#firstLabel"+i).val();
        		  if ($scope.firstList[i].id == 0) {
        			//新規
        	          ajaxService.createProjectResource($scope.firstList[i], $rootScope.projectId, '1', 0);
        	          if (ajaxService.result['resultCd'] != "000000") {
        	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        	              return "";
        	          }
        		  } else {
        			// 更新
        	          ajaxService.modifyProjectResource($scope.firstList[i]);
        	          if (ajaxService.result['resultCd'] != "000000") {
        	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        	                return "";
        	            }
        		  }
        	  }

        	  for (var i = 0; i < $scope.removeFirstIdList.length; i ++) {

        		  var isUsed =  ajaxService.checkUsedInTarget(1, $scope.removeFirstIdList[i].id, $rootScope.projectId);
             	  if (isUsed != 0) {
             		 $rootScope.showErrorMessage($scope.removeFirstIdList[i].label + "を既に工事で参照されているため、削除できません。");
             		 continue;
             	  }
        		  //削除
             	 ajaxService.deleteProjectResource($scope.removeFirstIdList[i].id);
        		  if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
        	  }
        	  $rootScope.showInfoMessage("保存しました。");
              $scope.getFirstList();
              $scope.removeFirstIdList = new Array();
              $("#master2").css({
                  'display' : 'none'
                });
                $("#master3").css({
                    'display' : 'none'
                  });

          });
      };

      $scope.saveSecondList = function() {
    	  var size = $scope.secondList.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.secondList[i].label = $("#secondLabel"+i).val().trim();
    		  if  (! $scope.secondList[i].label) {
    			  $rootScope.showErrorMessage("名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : "保存してもよろしいですか？"
                      };
                  }
              }
          });
          modalInstance.result.then(function() {
        	  for (var i=0 ;i < size; i++) {
        		  $scope.secondList[i].sort = i+1;
        		  $scope.secondList[i].label = $("#secondLabel"+i).val();
        		  if ($scope.secondList[i].id == 0) {
        			//新規
        	          ajaxService.createProjectResource($scope.secondList[i], $rootScope.projectId, '2', $scope.SecondParent);
        	          if (ajaxService.result['resultCd'] != "000000") {
        	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        	              return "";
        	          }
        		  } else {
        			// 更新
        	          ajaxService.modifyProjectResource($scope.secondList[i]);
        	          if (ajaxService.result['resultCd'] != "000000") {
        	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        	                return "";
        	            }
        		  }
        	  }

        	  for (var i = 0; i < $scope.removeSecondIdList.length; i ++) {

            	  var isUsed =  ajaxService.checkUsedInTarget(2, $scope.removeSecondIdList[i].id, $rootScope.projectId);
             	  if (isUsed != 0) {
             		 $rootScope.showErrorMessage($scope.removeSecondIdList[i].label + "を既に工事で参照されているため、削除できません。");
             		 continue;
             	  }
        		  //削除
             	 ajaxService.deleteProjectResource($scope.removeSecondIdList[i].id);
        		  if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
        	  }
        	  $rootScope.showInfoMessage("保存しました。");
              $scope.getSecondList($scope.SecondParent);
              $scope.removeSecondIdList = new Array();
                $("#master3").css({
                    'display' : 'none'
                  });

          });
      };

      $scope.saveThirdList = function() {
    	  var size = $scope.thirdList.length;

    	  for(var i=0 ;i < size; i++ ){
    		  $scope.thirdList[i].label = $("#thirdLabel"+i).val().trim();
    		  if  (! $scope.thirdList[i].label) {
    			  $rootScope.showErrorMessage("名称を入力してください。");
    			  return "";
    		  }
    	  }

    	  var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : "保存してもよろしいですか？"
                      };
                  }
              }
          });
          modalInstance.result.then(function() {
        	  for (var i=0 ;i < size; i++) {
        		  $scope.thirdList[i].sort = i+1;
        		  $scope.thirdList[i].label = $("#thirdLabel"+i).val();
        		  if ($scope.thirdList[i].id == 0) {
        			//新規
        	          ajaxService.createProjectResource($scope.thirdList[i], $rootScope.projectId, '3',  $scope.ThirdParent);
        	          if (ajaxService.result['resultCd'] != "000000") {
        	              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        	              return "";
        	          }
        		  } else {
        			// 更新
        	          ajaxService.modifyProjectResource($scope.thirdList[i]);
        	          if (ajaxService.result['resultCd'] != "000000") {
        	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
        	                return "";
        	            }
        		  }
        	  }

        	  for (var i = 0; i < $scope.removeThirdIdList.length; i ++) {

            	  var isUsed =  ajaxService.checkUsedInTarget(3, $scope.removeThirdIdList[i].id, $rootScope.projectId);
             	  if (isUsed != 0) {
             		 $rootScope.showErrorMessage($scope.removeSecondIdList[i].label + "を既に工事で参照されているため、削除できません。");
             		 continue;
             	  }
        		  //削除
             	 ajaxService.deleteProjectResource($scope.removeThirdIdList[i].id);
        		  if (ajaxService.result['resultCd'] != "000000") {
    	                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
    	                return "";
    	            }
        	  }
        	  $rootScope.showInfoMessage("保存しました。");
              $scope.getThirdList($scope.ThirdParent);
              $scope.removeThirdIdList = new Array();
          });
      };

      $scope.saveFirst = function(item) {
        if (! item.label) {
          $rootScope.showErrorMessage("名称を入力してください。");
          return "";
        }
        var num = /^[0-9]*$/;
        if (item.sort) {
            if (! num.test(item.sort)) {
              $rootScope.showErrorMessage("表示順に数字で入力してください。");
              return "";
            }
          }

        if (item.id == 0) {
          //新規
          ajaxService.createProjectResource(item, $rootScope.projectId, '1', 0);
          if (ajaxService.result['resultCd'] != "000000") {
              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              return "";
          } else {
            $rootScope.showInfoMessage("保存しました。");
          }
        } else {
          // 更新
          ajaxService.modifyProjectResource(item);
          if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                return "";
            } else {
              $rootScope.showInfoMessage("保存しました。");
            }
        }
        $scope.getFirstList();
      };

      $scope.saveSecond = function(item) {
        if (! item.label) {
          $rootScope.showErrorMessage("名称を入力してください。");
          return "";
        }
        var num = /^[0-9]*$/;
        if (item.sort) {
            if (! num.test(item.sort)) {
              $rootScope.showErrorMessage("表示順に数字で入力してください。");
              return "";
            }
          }

        if (item.id == 0) {
          //新規
          ajaxService.createProjectResource(item, $rootScope.projectId, '2', $scope.SecondParent);
          if (ajaxService.result['resultCd'] != "000000") {
              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              return "";
          } else {
            $rootScope.showInfoMessage("保存しました。");
          }
        } else {
          // 更新
          ajaxService.modifyProjectResource(item);
          if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                return "";
            } else {
              $rootScope.showInfoMessage("保存しました。");
            }
        }
        $scope.getSecondList($scope.SecondParent);
      };

      $scope.saveThird = function(item) {
        if (! item.label) {
          $rootScope.showErrorMessage("名称を入力してください。");
          return "";
        }
        var num = /^[0-9]*$/;
        if (item.sort) {
            if (! num.test(item.sort)) {
              $rootScope.showErrorMessage("表示順に数字で入力してください。");
              return "";
            }
          }

        if (item.id == 0) {
          //新規
          ajaxService.createProjectResource(item, $rootScope.projectId, '3',  $scope.ThirdParent);
          if (ajaxService.result['resultCd'] != "000000") {
              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              return "";
          } else {
            $rootScope.showInfoMessage("保存しました。");
          }
        } else {
          // 更新
          ajaxService.modifyProjectResource(item);
          if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                return "";
            } else {
              $rootScope.showInfoMessage("保存しました。");
            }
        }
        $scope.getThirdList($scope.ThirdParent);
      };

      $scope.deleteFirst = function(item) {
    	  var isUsed =  ajaxService.checkUsedInTarget(1, item.id, $rootScope.projectId);
     	  if (isUsed != 0) {
     		 $rootScope.showErrorMessage("既に工事で参照されているため、削除できません。");
     		 return;
     	  }

        var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : item.label + "を削除してもよろしいですか？"
                      };
                  }
              }
          });
          modalInstance.result.then(function() {
            ajaxService.deleteProjectResource(item.id);
            if (ajaxService.result['resultCd'] == "000000") {
              $rootScope.showInfoMessage("削除しました。");
            }
            $scope.getFirstList();
            $("#master2").css({
                'display' : 'none'
              });
              $("#master3").css({
                  'display' : 'none'
                });
          });
      };

      $scope.deleteSecond = function(item) {
    	  var isUsed =  ajaxService.checkUsedInTarget(2, item.id, $rootScope.projectId);
     	  if (isUsed != 0) {
     		 $rootScope.showErrorMessage("既に工事で参照されているため、削除できません。");
     		 return;
     	  }

        var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : item.label + "を削除してもよろしいですか？"
                      };
                  }
              }
          });
          modalInstance.result.then(function() {
            ajaxService.deleteProjectResource(item.id);
              if (ajaxService.result['resultCd'] == "000000") {
                $rootScope.showInfoMessage("削除しました。");
              }
              $scope.getSecondList($scope.SecondParent);
              $("#master3").css({
                  'display' : 'none'
                });
          });
      };

      $scope.deleteThird = function(item) {
    	  var isUsed =  ajaxService.checkUsedInTarget(3, item.id, $rootScope.projectId);
     	  if (isUsed != 0) {
     		 $rootScope.showErrorMessage("既に工事で参照されているため、削除できません。");
     		 return;
     	  }
        var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : item.label + "を削除してもよろしいですか？"
                      };
                  }
              }
          });
          modalInstance.result.then(function() {
            ajaxService.deleteProjectResource(item.id);
              if (ajaxService.result['resultCd'] == "000000") {
                $rootScope.showInfoMessage("削除しました。");
              }
              $scope.getThirdList($scope.ThirdParent);
          });

      };

      $scope.showSecond = function(item) {
        $scope.SecondTileName = item.label;
        $scope.SecondParent = item.id;

        $scope.getSecondList($scope.SecondParent);
          $("#master2").css({
            'display' : 'block'
          });
          $("#master3").css({
              'display' : 'none'
            });
          $("body,html").animate({
              scrollTop : $("#master2").offset().top - 100
          }, 1000);
      };

      $scope.showThird = function(item) {
        $scope.ThirdTileName = item.label;
        $scope.ThirdParent = item.id;

        $scope.getThirdList($scope.ThirdParent);
          $("#master3").css({
            'display' : 'block'
          });
          $("body,html").animate({
              scrollTop : $("#master3").offset().top - 100
          }, 1000);
      };


      $scope.showMasterAll = function() {

        $scope.masterAllList = ajaxService.getMasterAllList($rootScope.projectId);

        $scope.masterShowList = [];
        for(var i=0; i<$scope.masterAllList.length; i++){
          var first = $scope.masterAllList[i];
          var firstShow = null;
          var num = 0;
          var secondList = first.childList;
          if (secondList && secondList.length !=0){
            for (var j=0; j<secondList.length; j++) {
              var second = secondList[j];
              var thirdList = second.childList;
              if (thirdList && thirdList.length !=0) {
                for (var k=0; k<thirdList.length; k++) {
                  num ++;
                  var third = thirdList[k];
                  var show = new Object();
                  show.tougoFirst = 1;
                  show.tougoSecond = 1;
                  if (j==0 && k == 0) {
                    show.firstName = first.label;
                    show.secondName = second.label;
                    show.tougoFirst = secondList.length;
                    show.tougoSecond = thirdList.length;
                    firstShow = show;
                  } else if (j!=0 && k == 0){
                      show.firstName = "";
                      show.secondName = second.label;
                      show.tougoSecond = thirdList.length;
                  } else {
                      show.firstName = "";
                      show.secondName = "";
                  }
                  show.thirdName = third.label;
                  $scope.masterShowList.push(show);
                }
              } else {
                var show = new Object();
                show.tougoFirst = 1;
                show.tougoSecond = 1;
                num++;
                if (j == 0) {
                  show.firstName = first.label;
                  show.tougoFirst = secondList.length;
                  firstShow = show;
                } else {
                  show.firstName = "";
                }
                show.secondName = second.label;
                show.thirdName = "";
                $scope.masterShowList.push(show);
              }
            }
          } else {
            var show = new Object();
            show.tougoFirst = 1;
            show.tougoSecond = 1;
            show.firstName = first.label;
            show.secondName = "";
            show.thirdName = "";
            $scope.masterShowList.push(show);
          }
          if (firstShow) {
            firstShow.tougoFirst = num;
          }
        }

        $uibModal.open({
            animation : true,
            templateUrl : 'app/pages/masterdata/masterAll.html',
            scope : $scope,
            size: 'lg',
            backdrop : "static",
            resolve : {
                message : function() {
                    return {
                      type : ""
                    };
                }
            }
        });
      };


      $scope.showMaster4CheckAll = function() {

          $scope.master4CheckAllList = ajaxService.getMaster4CheckAllList($rootScope.projectId);
          console.log($scope.master4CheckAllList);


          $scope.master4CheckShowList = [];
          for(var i=0; i<$scope.master4CheckAllList.length; i++){
            var first = $scope.master4CheckAllList[i];
            var firstShow = null;
            var num = 0;
            var secondList = first.childList;
            if (secondList && secondList.length !=0){
              for (var j=0; j<secondList.length; j++) {
                var second = secondList[j];
                var firstShow2 = null;
                var num2 = 0;
                var thirdList = second.childList;
                if (thirdList && thirdList.length !=0) {
                  for (var k=0; k<thirdList.length; k++) {
                    var third = thirdList[k];
                    var fourthList = third.childList;
                    if (fourthList && fourthList.length !=0) {
                    	for (var m=0; m<fourthList.length; m++) {
                            num ++;
                            num2 ++;
                    		var fourth = fourthList[m];
                    		var show = new Object();
                            show.tougoFirst = 1;
                            show.tougoSecond = 1;
                            show.tougoThird = 1;
                            if (j==0 && k == 0 && m==0) {
                                show.firstName = first.label;
                                show.secondName = second.label;
                                show.thirdName = third.label;
                                show.tougoFirst = secondList.length;
                                show.tougoSecond = thirdList.length;
                                show.tougoThird = fourthList.length;
                                firstShow = show;
                                firstShow2 = show;
                              } else if (j!=0 && k == 0 && m==0){
                                  show.firstName = "";
                                  show.secondName = second.label;
                                  show.thirdName = third.label;
                                  show.tougoSecond = thirdList.length;
                                  show.tougoThird = fourthList.length;
                                  firstShow2 = show;
                              } else if (k != 0 && m==0){
                                  show.firstName = "";
                                  show.secondName = "";
                                  show.thirdName = third.label;
                                  show.tougoThird = fourthList.length;
                              } else {
                                  show.firstName = "";
                                  show.secondName = "";
                                  show.thirdName = "";
                              }
                            show.fourthName = fourth.label;
                            $scope.master4CheckShowList.push(show);
                    	}
                    } else {
                        num ++;
                        num2 ++;
                    	var show = new Object();
                        show.tougoFirst = 1;
                        show.tougoSecond = 1;
                        if (j==0 && k == 0) {
                          show.firstName = first.label;
                          show.secondName = second.label;
                          show.tougoFirst = secondList.length;
                          show.tougoSecond = thirdList.length;
                          firstShow = show;
                          firstShow2 = show;
                        } else if (j!=0 && k == 0){
                            show.firstName = "";
                            show.secondName = second.label;
                            show.tougoSecond = thirdList.length;
                        } else {
                            show.firstName = "";
                            show.secondName = "";
                        }
                        show.thirdName = third.label;
                        show.fourthName = "";
                        $scope.master4CheckShowList.push(show);
                    }
                  }
                } else {
                  num ++;
                  var show = new Object();
                  show.tougoFirst = 1;
                  show.tougoSecond = 1;
                  if (j == 0) {
                    show.firstName = first.label;
                    show.tougoFirst = secondList.length;
                    firstShow = show;
                  } else {
                    show.firstName = "";
                  }
                  show.secondName = second.label;
                  show.thirdName = "";
                  show.fourthName = "";
                  $scope.master4CheckShowList.push(show);
                }

                if (firstShow2) {
                  firstShow2.tougoSecond = num2;
                }
              }
            } else {
              var show = new Object();
              show.tougoFirst = 1;
              show.tougoSecond = 1;
              show.tougoThird = 1;
              show.firstName = first.label;
              show.secondName = "";
              show.thirdName = "";
              show.fourthName = "";
              $scope.master4CheckShowList.push(show);
            }

            if (firstShow) {
              firstShow.tougoFirst = num;
            }
          }

          console.log($scope.master4CheckShowList);

    	  $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/masterdata/master4CheckAll.html',
              scope : $scope,
              size: 'lg',
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                        type : ""
                      };
                  }
              }
          });
      }

      $scope.downloadMasterAll = function() {
        $scope.masterAllList = ajaxService.getMasterAllList($rootScope.projectId);

          $scope.masterShowList = [];
          for(var i=0; i<$scope.masterAllList.length; i++){
            var first = $scope.masterAllList[i];
            var secondList = first.childList;
            if (secondList && secondList.length !=0){
              for (var j=0; j<secondList.length; j++) {
                var second = secondList[j];
                var thirdList = second.childList;
                if (thirdList && thirdList.length !=0) {
                  for (var k=0; k<thirdList.length; k++) {
                    var third = thirdList[k];
                    var show = new Object();
                    show.firstName = first.label;
                    show.secondName = second.label;
                    show.thirdName = third.label;
                    $scope.masterShowList.push(show);
                  }
                } else {
                  var show = new Object();
                show.firstName = first.label;
                show.secondName = second.label;
                show.thirdName = "";
                $scope.masterShowList.push(show);
                }
              }
            } else {
              var show = new Object();
              show.firstName = first.label;
              show.secondName = "";
              show.thirdName = "";
              $scope.masterShowList.push(show);
            }
          }

          var csvTitle = [$scope.firstItemName, $scope.secondItemName, $scope.thirdItemName]

          var start = new Date().getTime();
          // データを用意する
          var bom = new Uint8Array(
                  [ 0xEF, 0xBB, 0xBF ]);
          var content = new Array();
          for (var i = 0; i < csvTitle.length; i++) {
              content.push(csvTitle[i]);
              content.push(",");
          }
          content.pop();
          content.push("\n");

          for (var i = 0; i < $scope.masterShowList.length; i++) {
            var ob = $scope.masterShowList[i]
              content.push(ob.firstName);
              content.push(",");
              content.push(ob.secondName);
              content.push(",");
              content.push(ob.thirdName);
              content.push(",");
              content.pop();
              content.push("\n");
          }

          var contentStr = content.join('');
          var str_array = Encoding.stringToCode(contentStr);
          var sjis_array = Encoding.convert(str_array, "SJIS", "UNICODE");
          var uint8_array = new Uint8Array(sjis_array);

          var blob = new Blob([uint8_array], {
              "type" : "text/csv"
          });
          var fileName = "工事カテゴリ.csv";
          // 出力
          if ($window.navigator.msSaveBlob) {
              // if browser is IE
              $window.navigator.msSaveBlob(blob,
                      fileName);
          } else {
              var downloadLink = $('<a></a>');
              downloadLink.attr('href', $window.URL.createObjectURL(blob));
              downloadLink.attr('download', fileName);
              downloadLink.attr('target', '_blank');
              $('body').append(downloadLink);
              downloadLink[0].click();
              downloadLink.remove();
          }
      };

      $scope.uploadMasterAll = function(file) {

          var targetNum = ajaxService.countTargetUsedMaster($rootScope.projectId);;
          if (targetNum != 0 ) {
            $rootScope.showErrorMessage("既に工事で参照されているため、アップロードによる更新はできません。");
            return;
          }

          var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : "アップロードを実施してもよろしいですか？"
                      };
                  }
              }
          });

          modalInstance.result.then(function() {
        	  if (file) {
                  var name = file.name;
                    if (name.toLowerCase().indexOf(".csv") == -1) {
                      $rootScope.showErrorMessage("csvファイルをアップロードしてください。");
                      return;
                    }

                    Upload.upload({
                        url : urlPrefix + "resource/uploadMaster",
                        type : "POST",
                        headers : {
                            "authorization" : localStorage.authId,
                        },
                        dataType : "multipart/form-data",
                        data : {
                            'projectId': $rootScope.projectId, "schema" : localStorage.schema, 'loginId':localStorage.userId, file : file
                        }
                    }).progress(function (evt) {
                        //progress
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        if (progressPercentage != 100) {
                          $rootScope.showInfoMessage("アップロード中：" + progressPercentage + "%");
                        }
                    }).then(function(response) {
                        var name = response.config.data.file.name;
                        if (response.data.resultCd == "000000") {
                            $scope.update = response.data.updateCount;
                            $scope.skipUpdate = response.data.skipUpdate;
                            if ($scope.update > 0) {
                              $scope.getFirstList();
                            }
                            // errorFile
                            if (response.data.skipUpdate > 0) {
                                 // データを用意する
                                var bom = new Uint8Array(
                                        [ 0xEF, 0xBB, 0xBF ]);
                                var content = "行番, エラーメッセージ";
                                content = content + "\n";
                                for (var i=0; i<response.data.skipUpdateInfo.length; i++) {
                                    content = content + response.data.skipUpdateInfo[i] + "\n";
                                }
                                var blob = new Blob([ bom, content ], {
                                    "type" : "text/csv"
                                });

                                // 出力
                                if ($window.navigator.msSaveBlob) {
                                    $window.navigator.msSaveBlob(blob, "アップロード結果.csv");
                                } else {
                                    var downloadLink = $('<a></a>');
                                    downloadLink.attr('href', $window.URL.createObjectURL(blob));
                                    downloadLink.attr('download', "アップロード結果.csv");
                                    downloadLink.attr('target', '_blank');
                                    $('body').append(downloadLink);
                                    downloadLink[0].click();
                                    downloadLink.remove();
                                }
                                $rootScope.showErrorMessage("エラーにより一部のデータが取り込まれていません。詳しくは出力した「アップロード結果.csv」ファイルを参照してください。");
                            } else {
                                $rootScope.showInfoMessage("アップロードが完了しました。");
                            }

                        } else {
                          $rootScope.showErrorMessage(tr.T(response.data.resultCd));
                        }
                    }, function(response) {
                        if (response.status > 0)
                          $rootScope.showErrorMessage(response.status + ': ' + response.data);
                    }, function(evt) {
//                        var progressPercentage = parseInt(100.0 *
//                                evt.loaded / evt.total);
//                        $scope.f.progressRate = progressPercentage;
                    });
                }
          });

      };

    }

})();

/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.offline').controller('OfflineCtrl', OfflineCtrl);

    /** @ngInject */
    function OfflineCtrl($scope, $filter, editableOptions, editableThemes, toastr, $sce, $timeout,
            toastrConfig, ajaxService, $state, $uibModal, $location, $window, themeLayoutSettings, Upload, $http, $rootScope, tr) {


     $scope.smartTablePageSize = 20;

     $scope.isEditer = true;
     $scope.isResponser = true;

     $scope.lat = null;
     $scope.lgt = null;
     if(!navigator.geolocation){ alert('位置情報を共有してください。'); return; }
     navigator.geolocation.getCurrentPosition(
     function(position){
       $scope.lat = position.coords.latitude;
       $scope.lgt = position.coords.longitude;
       } ,
       function(){
         //alert('位置情報取得失敗！');
       }
     );


     //ダウンロードしたチェックシート一覧取得
     $scope.selectTicketIndexDb = function (key) {
		var transaction = $rootScope.db.transaction(['ticket'],"readwrite");
		var store = transaction.objectStore('ticket');
		if (key) {
			var request = store.get(key);
		} else {
			var request = store.getAll();
		}
		request.onsuccess = function () {
			console.log(request.result);
			$scope.checkreportList = request.result;
			console.log($scope.checkreportList);
		}
	};

	$scope.selectTicketIndexDb();


	$scope.showDownloadTicketDetail = function (ticket) {

		$scope.ticket = ticket;
		$scope.ticketId = ticket.id;
		console.log($scope.ticket);

		$scope.statusOb = $rootScope.getStatusOb($scope.ticket.statusId);

		//チェック結果欄は非表示
		$scope.showResult = "1";

		//チェック詳細順番
		$scope.detailId = 1;

		$scope.checkresultList = [];

		//チェック結果取得
		var transaction = $rootScope.db2.transaction(['result'],"readwrite");
		var store = transaction.objectStore('result');
		var request = store.openCursor();
		request.onsuccess = function (event) {

			var cursor = event.target.result;

			if (cursor) {
				if (cursor.key.indexOf($scope.ticketId+'-') !== -1) {
					$scope.checkresultList.push(cursor.value);
				}
				cursor.continue();
			}
		}

		transaction.oncomplete = function(e) {
			console.log($scope.checkresultList);

			$scope.getResultDetailList();
	   }


		$("#ticketList").css({
          'display' : 'none'
        });
        $("#ticketDetail").css({
            'display' : 'block'
        });
        $("body,html").animate({
            scrollTop : $("#ticketDetail").offset().top - 100
        }, 1000);

	};

	$scope.getResultDetailList = function () {

		$scope.resultOkNum = 0;
        $scope.resultNgNum = 0;
        $scope.resultKeepNum = 0;
        $scope.resultOtherNum = 0;

        for (var i = 0; i < $scope.checkresultList.length; i++) {
          if ($scope.checkresultList[i].checkResult == "1") {
            $scope.resultOkNum++;
            $scope.checkresultList[i].checkResultName = "正常";
          } else if ($scope.checkresultList[i].checkResult == "2") {
            $scope.resultNgNum++;
            $scope.checkresultList[i].checkResultName = "異常";
          } else if ($scope.checkresultList[i].checkResult == "3") {
            $scope.resultKeepNum++;
            $scope.checkresultList[i].checkResultName = "保留";
          } else if ($scope.checkresultList[i].checkResult == "4") {
            $scope.resultOtherNum++;
            $scope.checkresultList[i].checkResultName = "対象外";
          }
        }
        $scope.complete = ($scope.resultOkNum + $scope.resultNgNum + $scope.resultOtherNum ) / $scope.checkresultList.length * 100;


		$scope.resultDetailList = $scope.checkresultList[$scope.detailId - 1].result;

		$scope.checkListOb = $scope.checkresultList[$scope.detailId - 1];

	    $scope.checkListSize = $scope.checkresultList.length;

	    if ($scope.detailId == $scope.checkListSize) {
	      $scope.nextDetailId = 1;
	      $scope.nextCheckListOb = $scope.checkresultList[$scope.nextDetailId - 1];
	    } else {
	      $scope.nextDetailId = $scope.detailId + 1;
	      $scope.nextCheckListOb = $scope.checkresultList[$scope.nextDetailId - 1];
	    }
	    if ($scope.detailId == 1) {
	      $scope.prefDetailId = $scope.checkListSize;
	      $scope.prefCheckListOb = $scope.checkresultList[$scope.checkListSize-1];
	    } else {
	      $scope.prefDetailId =  $scope.detailId - 1;
	      $scope.prefCheckListOb = $scope.checkresultList[$scope.prefDetailId - 1];
	    }

	    $scope.getResultInfoSp();
	};


	$scope.getResultInfoSp = function () {

        $scope.chBoxResult = [];
        $scope.result = new Array();
        $scope.userResource = new Array();
        for (var i=0; i<$scope.resultDetailList.length; i++) {
          var rdOb = $scope.resultDetailList[i];
          $scope.result[i] = new Object();
          $scope.result[i].id = rdOb.resultDetailId;
          $scope.result[i].value = rdOb.checkResult;
          if (i == 0 && ! rdOb.checkResult) {
              $scope.result[i].value = "1";
            }
          $scope.result[i].inputTypeId = rdOb.inputTypeId;
          $scope.result[i].mustFlg = rdOb.mustFlg;
          $scope.result[i].checkDetailName = rdOb.checkDetailName;
          if (rdOb.inputTypeId == 2) {
            //日付
            if (rdOb.checkResult) {
              $scope.result[i].id = rdOb.resultDetailId;
              $scope.result[i].value = new Date(rdOb.checkResult);
            }
          } else if (rdOb.inputTypeId == 3) {
            //セレクトボックス
      		$scope["userResource"+rdOb.resultDetailId] = rdOb.userResourceDetail;
  			console.log(rdOb.userResourceDetail);
  			$scope["userResource"+rdOb.resultDetailId].unshift({label:" ", value:null});
            if (rdOb.checkResult) {
              for (var j=0; j< $scope["userResource"+rdOb.resultDetailId].length; j++) {
                if (rdOb.checkResult == $scope["userResource"+rdOb.resultDetailId][j].value) {
                  $scope.result[i].id = rdOb.resultDetailId;
                  $scope.result[i].value = $scope["userResource"+rdOb.resultDetailId][j];
                }
              }
            } else {
              $scope.result[i].id = rdOb.resultDetailId;
              $scope.result[i].value = $scope["userResource"+rdOb.resultDetailId][0];
            }

          } else if (rdOb.inputTypeId == 4) {
            //ラジオボタン
            $scope.userResource[i] = rdOb.userResourceDetail;
          } else if (rdOb.inputTypeId == 5) {
            //チェックボックス
            $scope.userResource[i] = rdOb.userResourceDetail;
            var checkBoxResult = $scope.result[i].value;
            if (checkBoxResult) {
               var rlist = checkBoxResult.split("、");
               $scope.chBoxResult[i] = [];
               for (var r=0; r< rlist.length;r++) {
                 $scope.chBoxResult[i].push(parseInt(rlist[r]));
               }
            }
          } else if (rdOb.inputTypeId == 7) {
            //写真
            $scope.getImgList(rdOb);
          } else if (rdOb.inputTypeId == 8) {
            //音声
//            $scope.getRadioList($scope.reportId, rdOb.resultDetailId);
          } else if (rdOb.inputTypeId == 9) {
            //動画
//            $scope.getVideoList($scope.reportId, rdOb.resultDetailId);
          } else if (rdOb.inputTypeId == 10) {
            //手書き
              $scope["signable"+rdOb.resultDetailId] = true;
              $scope.getSign(rdOb);
          } else if (rdOb.inputTypeId == 11) {
           //360度カメラ
              if (rdOb.checkResult) {
                $scope["camera"+rdOb.resultDetailId] = true;
                if (rdOb.checkResult.indexOf("/t/") != -1) {
                    $scope["cameraT"+rdOb.resultDetailId] = true;
                  } else {
                    $scope["cameraT"+rdOb.resultDetailId] = false;
                  }
              } else {
                $scope["camera"+rdOb.resultDetailId] = false;
              }
          } else if (rdOb.inputTypeId == 12) {
        	  $scope.result[i].value = parseFloat(rdOb.checkResult);
           //モダール立ち上げる前の初期化
//           $scope.checkLimit(rdOb.checkDetailId, i, false);
          } else if (rdOb.inputTypeId == 13) {
              //ファイル
//              $scope.getResultFileList($scope.reportId, rdOb.resultDetailId);
          }
        }

        $scope.baseResult = angular.copy($scope.result);
      };

      $scope.getCheckreportDetailSp = function(id , isInit) {
    	  if (! $scope.saveResult(true)) {
    		  return;
    	  }
    	  $scope.detailId = id;
    	  $scope.getResultDetailList();
      };




















      $scope.dynamicImgArray = function(checkResultId){
		  $("#slider"+checkResultId).flexslider({
              slideshow: false,
              startAt: 0
          });
          return $scope["imgbean"+checkResultId];
      };

      $scope.getImgList = function(rdOb) {
    	  var checkResultId = rdOb.resultDetailId;
          $scope["imgbean"+checkResultId] = new Array();
          var imgBeanList = rdOb.imgBeanList;

          var offImgSize = 0;

        //ファイル結果取得
		$scope["fileList"+checkResultId] = [];
		var transaction = $rootScope.db3.transaction(['file'],"readwrite");
		var store = transaction.objectStore('file');
		var request = store.openCursor();
		request.onsuccess = function (event) {

			var cursor = event.target.result;

			if (cursor) {
				if (cursor.key.indexOf($scope.ticketId+'-'+checkResultId+'-') !== -1) {
					$scope["fileList"+checkResultId].push(cursor.value);
				}
				cursor.continue();
			}
		}

		transaction.oncomplete = function(e) {
			out:for (var i=0; i<imgBeanList.length; i++) {
		        var imgOb = new Object();
		        var imgId = imgBeanList[i].id;
		        imgOb.fileId = imgId;
		        imgOb.fileName = imgBeanList[i].fileName;
		        var flg = false;
		        for (var j=0; j<$scope["fileList"+checkResultId].length; j++) {
		        	var keys = $scope["fileList"+checkResultId][j].tRsFileId.split("-");
		        	var imageId = keys[2];
		        	if (imgId == imageId) {
		        		imgOb.url = URL.createObjectURL($scope["fileList"+checkResultId][j].file);
		        		imgOb.imgComm = $scope["fileList"+checkResultId][j].imgComment;
		        		imgOb.file = $scope["fileList"+checkResultId][j].file;
		        		flg = true;
		        	}
		        }
		        if (flg) {
		        	$scope["imgbean"+checkResultId].push(imgOb);
		        }
		    }

			for (var j=0; j<$scope["fileList"+checkResultId].length; j++) {
				var keys = $scope["fileList"+checkResultId][j].tRsFileId.split("-");
	        	var imageId = keys[2];
	        	if (imageId.indexOf('n') !== -1) {
	        		var imgOb = new Object();
	        		var imgId = imageId;
	        		imgOb.fileId = imgId;
	        		imgOb.fileName = $scope["fileList"+checkResultId][j].file.name;
	        		imgOb.url = URL.createObjectURL($scope["fileList"+checkResultId][j].file);
	        		imgOb.imgComm = $scope["fileList"+checkResultId][j].imgComment;
	        		imgOb.file = $scope["fileList"+checkResultId][j].file;
	        		$scope["imgbean"+checkResultId].push(imgOb);
	        		offImgSize ++ ;
	        	}
			}
			rdOb.offImgSize = offImgSize;
			console.log($scope["imgbean"+checkResultId]);
		 }
        };

        $scope.reflesh = function () {
        	$scope.showDownloadTicketDetail($scope.ticket);
        }




      $scope.getSign = function(rdOb) {

      	  var checkResultId = rdOb.resultDetailId;
          $scope["signFlg"+checkResultId] = true;
          $scope["sign"+checkResultId] = new Object();

        //ファイル結果取得
  		var fileList = [];
  		var transaction = $rootScope.db3.transaction(['file'],"readwrite");
  		var store = transaction.objectStore('file');
  		var request = store.openCursor();
  		request.onsuccess = function (event) {

  			var cursor = event.target.result;

  			if (cursor) {
  				if (cursor.key.indexOf($scope.ticketId+'-'+checkResultId+'-') !== -1) {
  					fileList.push(cursor.value);
  				}
  				cursor.continue();
  			}
  		}

  		transaction.oncomplete = function(e) {
  			console.log(fileList);
  			if (fileList.length != 0) {
  	            //手書きあり
  	            $scope["signable"+checkResultId] = false;
  	            var keys = fileList[0].tRsFileId.split("-");
  	            $scope["signId"+checkResultId] = keys[2];
  	            $scope["signUrl"+checkResultId] = URL.createObjectURL(fileList[0].file);
  	        }
  		 }
      };

      $scope.getSignUrl = function(checkResultId){
          return $scope["signUrl"+checkResultId];
      };


      $scope.openUploadImg = function(rdOb) {
          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/fileUploadModal.html',
              controller : 'FileUploadCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  openFlag : function() {
                      return {
                          'flag' : 'New',
                          'kbn' : 'offline',
                          'id': rdOb.resultDetailId,
                          'ticketId': $scope.ticketId,
                          'typeKbn': "Image",
                          'checklistId': $scope.checkListOb.checklistId,
                          'rdOb': rdOb
                      };
                  }
              }
          });
      };

      $scope.saveImgCom = function (imgOb, resultDetailId) {
    	  console.log(imgOb);
    	  var tRsFileId = $scope.ticketId + '-' + resultDetailId + '-' + imgOb.fileId;
          var fileOb = {'tRsFileId' : tRsFileId, 'file':imgOb.file, 'imgComment': imgOb.imgComm};
          $rootScope.removeFileIndexDb(tRsFileId);
          $rootScope.addFileIndexDb(fileOb);
          $rootScope.showInfoMessage("コメントを保存しました。");
      };

      $scope.deleteFile = function(imgOb, rdOb) {
        var modalInstance = $uibModal.open({
            animation : true,
            templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
            controller : 'confirmDialogCtrl',
            scope : $scope,
            backdrop : "static",
            resolve : {
                message : function() {
                    return {
                        message : "該当ファイルを削除してもよろしいですか？"
                    };
                }
            }
        });
        modalInstance.result.then(function() {
      	  var tRsFileId = $scope.ticketId + '-' + rdOb.resultDetailId + '-' + imgOb.fileId;
          $rootScope.removeFileIndexDb(tRsFileId);
          $rootScope.showInfoMessage("該当ファイルを削除しました。");
//          $scope.getImgList(rdOb);
          $scope.reflesh();
          $("body,html").animate({
              scrollTop : $("#slider"+ rdOb.resultDetailId).offset().top - 100
          }, 1000);
        });
      };

      $scope.setNowTime = function (outerIndex) {
	  	  $scope.result[outerIndex].value = new Date();
	  };

	  $scope.clearTime = function (outerIndex) {
	  	  $scope.result[outerIndex].value = null;
	  };

	  $scope.showTicketInfoSp = function() {
          $scope.$modalTicket = $uibModal.open({
                animation: true,
                templateUrl: "app/pages/offline/checkreportTicketInfoSp.html",
                scope : $scope,
                backdrop : "static",
                resolve: {
                    openFlag: function () {
                        return {};
                  }
                }
              });
      };








	  $scope.saveResult = function(isLoadDetail) {

    	  if($scope.showResult == '1'){
			//最終確認非表示,デフォルト対象外
    		$scope.result[0].value = "1";
    		$scope.checkresultList[$scope.detailId - 1].checkResult = '1';
    	  } else {
    		  if (! $scope.result[0].value) {
	            $rootScope.showErrorMessage("最終確認を選択してください。");
	            return false;
	          }
    	  }

          if ($scope.result[0].value == "1" || $scope.result[0].value == "2" ) {
            //必須チェック　後回し
            outer : for (var i=1; i<$scope.result.length; i++) {
                if ($scope.result[i].mustFlg == "1") {
                  if ($scope.result[i].inputTypeId != 7 && $scope.result[i].inputTypeId != 8 && $scope.result[i].inputTypeId != 9 && $scope.result[i].inputTypeId != 10 && $scope.result[i].inputTypeId != 13) {
                    if ($scope.result[i].inputTypeId == 5 ) {
                          if ($scope.chBoxResult[i]) {
                            for (var k = 0; k < $scope.userResource[i].length; k++){
                              if ($scope.chBoxResult[i][k]) {
                                if ($scope.chBoxResult[i][k] != 0) {
                                  continue outer;
                                }
                              }
                            }
                            $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を入力してください。");
                            return false;
                          } else {
                            $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を入力してください。");
                              return false;
                          }
                      } else if ($scope.result[i].inputTypeId == 12) {
                          if (! $scope.result[i].value) {
                        	  if ($scope.result[i].value != 0) {
                                  $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を正しく入力してください。");
                                  return false;
                        	  } else {
                        		  $scope.result[i].value = "0";
                        	  }
                          }
                        } else if ($scope.result[i].inputTypeId == 3) {
                            if (! $scope.result[i].value.value) {
                                $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を選択してください。");
                                return false;
                            }
                        }  else {
                        if (! $scope.result[i].value) {
                              $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を入力してください。");
                              return false;
                        }
                      }
                  } else {
                      //TODO
//                	  if (ajaxService.hasCheckResultFile($scope.result[i].id) == 0) {
//                      // FILE無し
//                      $rootScope.showErrorMessage($scope.result[i].checkDetailName+"をアップロードしてください。");
//                      return false;
//                    }
                  }
                }
              }
          }

          var imgCommentList = [];

          for (var i=0; i<$scope.result.length; i++) {

              if ($scope.result[i].inputTypeId == 2) {
                  var v = $rootScope.formatDate($scope.result[i].value, "YYYY/MM/DD");
                  $scope.result[i].checkResult = v;
              } else if ($scope.result[i].inputTypeId == 3) {
                  if ($scope.result[i].value) {
                    $scope.result[i].checkResult = $scope.result[i].value.value;
                  }
              } else if ($scope.result[i].inputTypeId == 5) {
                if ($scope.chBoxResult[i]) {
                    var result = "";
                    for (var k = 0; k < $scope.userResource[i].length; k++){
                      if ($scope.chBoxResult[i][k]) {
                          if (result == "") {
                            result = $scope.chBoxResult[i][k]+"";
                          } else {
                            result = result + "、" + $scope.chBoxResult[i][k];
                          }
                      } else {
                        if (result == "") {
                          result = "0";
                        } else {
                          result = result + "、0";
                        }
                      }
                    }
                    $scope.result[i].checkResult = result;
                  } else {
                    $scope.result[i].checkResult = "";
                  }
              } else if ($scope.result[i].inputTypeId == 12) {
            	  if (typeof($scope.result[i].value) == 'undefined') {
                      $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を正しく入力してください。");
                	  return false;
                  }
              	  if ($scope.result[i].value == 0) {
              		  $scope.result[i].checkResult = "0";
              	  } else {
              		$scope.result[i].checkResult = $scope.result[i].value;
              	  }
              } else {
                if ($scope.result[i].inputTypeId == 7 ) {
                  var imglist = $scope["imgbean"+$scope.result[i].id];

                  var fileList = $scope["fileList"+$scope.result[i].id];


                  for (var k = 0; k < fileList.length; k++) {
                	  var tRsFileId = fileList[k].tRsFileId;
                	  var keys = tRsFileId.split("-");
  		        	  var imageId = keys[2];
                	  for (var j = 0; j < imglist.length; j++) {
                		  if (imageId == imglist[j].fileId) {
                			  fileList[k].imgComment = imglist[j].imgComm
                		  }
                	  }

                	  $rootScope.removeFileIndexDb(tRsFileId);
                      $rootScope.addFileIndexDb(fileList[k]);
                  }
              }

               if ($scope.result[i].value) {
                 $scope.result[i].checkResult = $scope.result[i].value;
               }
            }
          }

          for (var i = 0; i < $scope.resultDetailList.length; i ++) {
        	  for (var j = 0; j < $scope.result.length; j ++) {
        		  if ($scope.resultDetailList[i].resultDetailId == $scope.result[j].id) {
        			  $scope.resultDetailList[i].checkResult = $scope.result[j].checkResult;
        		  }
        	  }
          }

          var key = $scope.checkresultList[$scope.detailId - 1].tCheckId;
          $scope.checkresultList[$scope.detailId - 1].result = $scope.resultDetailList;
          $rootScope.removeResultIndexDb(key);
 	      $rootScope.addResultIndexDb($scope.checkresultList[$scope.detailId - 1]);

 	      $rootScope.showInfoMessage("保存しました。");

 	      $scope.ticket.statusId = '02';
 	      $scope.ticket.statusName = 'チェック中';

 	      return true;

        };


        $scope.reportComp = function() {
              var modalInstance = $uibModal.open({
                  animation : true,
                  templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                  controller : 'confirmDialogCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                              message : "チェックを完了してもよろしいですか？"
                          };
                      }
                  }
              });

              modalInstance.result.then(function() {
            	  $scope.ticket.statusId = '03';
           	      $scope.ticket.statusName = 'チェック完了';
           	      $rootScope.removeTicketIndexDb($scope.ticket.id);
                  $rootScope.addTicketIndexDb($scope.ticket);
                  $scope.statusOb = $rootScope.getStatusOb($scope.ticket.statusId);
              });

        };

        $scope.reportReturn = function() {

      	  var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "チェックを引戻してもよろしいですか？"
                        };
                    }
                }
            });

      	  modalInstance.result.then(function() {

      		//チェック中
                $scope.ticket.statusId = "02";
                $scope.ticket.statusName = "チェック中";
         	    $rootScope.removeTicketIndexDb($scope.ticket.id);
                $rootScope.addTicketIndexDb($scope.ticket);
                $scope.statusOb = $rootScope.getStatusOb($scope.ticket.statusId);

          });


        };


    	//チェックシートアップロード
        $scope.uploadOffLineTicket = function() {

        	if(! window.navigator.onLine){
    			$rootScope.showErrorMessage("インターネットに接続してから、やり直して入力してください。");
    			return;
    		}

        	var ticketOnServer = ajaxService.searchTicketInfo($rootScope.projectId, $scope.ticketId);
        	if (ticketOnServer.statusId != '01' && ticketOnServer.statusId != '02'){
        		$rootScope.showErrorMessage("該当チェックシート既にチェック完了になりました。");
    			return;
        	}

        	//チェック結果取得
        	var checkresultList = [];
    		var transaction = $rootScope.db2.transaction(['result'],"readwrite");
    		var store = transaction.objectStore('result');
    		var request = store.openCursor();
    		request.onsuccess = function (event) {

    			var cursor = event.target.result;

    			if (cursor) {
    				if (cursor.key.indexOf($scope.ticketId+'-') !== -1) {
    					checkresultList.push(cursor.value);
    				}
    				cursor.continue();
    			}
    		}

    		transaction.oncomplete = function(e) {
    			console.log(checkresultList);
    			var uploadResultList = [];
    			for (var i = 0; i < checkresultList.length; i ++) {
    				var rList = checkresultList[i].result;
    				for (var j = 0; j < rList.length; j ++) {
    					var rsOb = {};
    					rsOb.id = rList[j].resultDetailId;
    					rsOb.checkResult = rList[j].checkResult;
    					uploadResultList.push(rsOb);
    				}
    			}

    			ajaxService.modifyCheckResult($rootScope.projectId, $scope.ticketId, uploadResultList, $scope.lat, $scope.lgt);
                if (ajaxService.result['resultCd'] != "000000") {
                    $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                } else {
                    $rootScope.showInfoMessage("チェックシートアップロードしました。");
                }
    	   }

    		 //ファイル結果取得
    		var rsFileList = [];
    		var transaction = $rootScope.db3.transaction(['file'],"readwrite");
    		var store = transaction.objectStore('file');
    		var request = store.openCursor();
    		request.onsuccess = function (event) {

    			var cursor = event.target.result;

    			if (cursor) {
    				if (cursor.key.indexOf($scope.ticketId+'-') !== -1) {
    					rsFileList.push(cursor.value);
    				}
    				cursor.continue();
    			}
    		}

    		transaction.oncomplete = function(e) {
    			console.log(rsFileList);
    			for (var i = 0; i < rsFileList.length; i ++) {
    				var rsFile = rsFileList[i];
    				var keys = rsFile.tRsFileId.split("-");
    				var checkResultId = keys[1];
    	        	var imageId = keys[2];
    	        	var file = rsFile.file;
    	        	var fileName = file.name;
    	        	var imgComm = rsFile.imgComment;
    	        	var typeKbn = 'File';
    	        	if($rootScope.isImg(fileName)) {
    	        		typeKbn = 'Image';
    	        	} else if ($rootScope.isRadio(fileName)) {
    	        		typeKbn = 'Radio';
    	        	} else if ($rootScope.isVideo(fileName)) {
    	        		typeKbn = 'Video';
    	        	}
    	        	if (imageId.indexOf('n') !== -1) {
    	        		//追加登録ファイル

    	        		Upload.upload({
    	                    url : urlPrefix + "checkreport/uploadCheckResultFile",
    	                    type : "POST",
    	                    headers : {
    	                        "authorization" : localStorage.authId,
    	                    },
    	                    dataType : "multipart/form-data",
    	                    data : {file: file, 'userName':localStorage.userName, 'loginId':localStorage.userId, 'checkResultId': checkResultId, 'projectId': $rootScope.projectId, 'ticketId':$scope.ticketId, 'typeKbn':typeKbn, 'imgComm':imgComm, "schema" : localStorage.schema}
    	                }).then(function(response) {
    	                	if (response.data.resultCd != '000000') {
    	                		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
    	                		return ;
    	                	}
    	                }, function(response) {
    	                });
    	        	}
    			}
    		}

        	//チェックシート更新
        	console.log($scope.ticket);
        	var ticketOb = angular.copy($scope.ticket);
        	delete ticketOb.$$hashKey;
        	ajaxService.modifyTicket(ticketOb, $rootScope.projectId);
        	$scope.removeOffLineTicket();
        	$scope.$$childTail.$dismiss();
        	$scope.showTicketList();
        };


        $scope.deleteOffLineTicket = function() {
        	var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "該当ダウンロードしたチェックシートを削除してもよろしいですか？"
                        };
                    }
                }
            });

      	  modalInstance.result.then(function() {
      		$scope.removeOffLineTicket();
      		$rootScope.showInfoMessage("ダウンロードしたチェックシートを削除しました。");
    		$scope.$$childTail.$$prevSibling.$dismiss();
        	$scope.showTicketList();
          });
        };


        $scope.removeOffLineTicket = function () {
        	//チェックシート
          	$rootScope.removeTicketIndexDb($scope.ticket.id);

          	//チェック結果
          	var checkresultList = [];
    		var transaction = $rootScope.db2.transaction(['result'],"readwrite");
    		var store = transaction.objectStore('result');
    		var request = store.openCursor();
    		request.onsuccess = function (event) {

    			var cursor = event.target.result;

    			if (cursor) {
    				if (cursor.key.indexOf($scope.ticketId+'-') !== -1) {
    					checkresultList.push(cursor.value);
    				}
    				cursor.continue();
    			}
    		}

    		transaction.oncomplete = function(e) {
    			for (var i = 0; i < checkresultList.length; i ++) {
    				var tCheckId = checkresultList[i].tCheckId;
    				$rootScope.removeResultIndexDb(tCheckId);
    			}
    	    }

    		//ファイル結果取得
    		var rsFileList = [];
    		var transaction = $rootScope.db3.transaction(['file'],"readwrite");
    		var store = transaction.objectStore('file');
    		var request = store.openCursor();
    		request.onsuccess = function (event) {

    			var cursor = event.target.result;

    			if (cursor) {
    				if (cursor.key.indexOf($scope.ticketId+'-') !== -1) {
    					rsFileList.push(cursor.value);
    				}
    				cursor.continue();
    			}
    		}

    		transaction.oncomplete = function(e) {
    			console.log(rsFileList);
    			for (var i = 0; i < rsFileList.length; i ++) {
    				var tRsFileId = rsFileList[i].tRsFileId;
    				$rootScope.removeFileIndexDb(tRsFileId);
    			}
    		}

        };


        $scope.temSaveResult = function(isLoadDetail) {

      	  if($scope.showResult == '1'){
  			//最終確認非表示,デフォルト対象外
      		$scope.result[0].value = "1";
      		$scope.checkresultList[$scope.detailId - 1].checkResult = '1';
      	  } else {
      		$scope.result[0].value = "3";
      	  }

            var imgCommentList = [];

            for (var i=0; i<$scope.result.length; i++) {

                if ($scope.result[i].inputTypeId == 2) {
                    var v = $rootScope.formatDate($scope.result[i].value, "YYYY/MM/DD");
                    $scope.result[i].checkResult = v;
                } else if ($scope.result[i].inputTypeId == 3) {
                    if ($scope.result[i].value) {
                      $scope.result[i].checkResult = $scope.result[i].value.value;
                    }
                } else if ($scope.result[i].inputTypeId == 5) {
                  if ($scope.chBoxResult[i]) {
                      var result = "";
                      for (var k = 0; k < $scope.userResource[i].length; k++){
                        if ($scope.chBoxResult[i][k]) {
                            if (result == "") {
                              result = $scope.chBoxResult[i][k]+"";
                            } else {
                              result = result + "、" + $scope.chBoxResult[i][k];
                            }
                        } else {
                          if (result == "") {
                            result = "0";
                          } else {
                            result = result + "、0";
                          }
                        }
                      }
                      $scope.result[i].checkResult = result;
                    } else {
                      $scope.result[i].checkResult = "";
                    }
                } else if ($scope.result[i].inputTypeId == 12) {
              	  if (typeof($scope.result[i].value) == 'undefined') {
                        $rootScope.showErrorMessage($scope.result[i].checkDetailName+"を正しく入力してください。");
                  	  return false;
                    }
                	  if ($scope.result[i].value == 0) {
                		  $scope.result[i].checkResult = "0";
                	  } else {
                		$scope.result[i].checkResult = $scope.result[i].value;
                	  }
                } else {
                  if ($scope.result[i].inputTypeId == 7 ) {
                    var imglist = $scope["imgbean"+$scope.result[i].id];

                    var fileList = $scope["fileList"+$scope.result[i].id];


                    for (var k = 0; k < fileList.length; k++) {
                  	  var tRsFileId = fileList[k].tRsFileId;
                  	  var keys = tRsFileId.split("-");
    		        	  var imageId = keys[2];
                  	  for (var j = 0; j < imglist.length; j++) {
                  		  if (imageId == imglist[j].fileId) {
                  			  fileList[k].imgComment = imglist[j].imgComm
                  		  }
                  	  }

                  	  $rootScope.removeFileIndexDb(tRsFileId);
                        $rootScope.addFileIndexDb(fileList[k]);
                    }
                }

                 if ($scope.result[i].value) {
                   $scope.result[i].checkResult = $scope.result[i].value;
                 }
              }
            }

            for (var i = 0; i < $scope.resultDetailList.length; i ++) {
          	  for (var j = 0; j < $scope.result.length; j ++) {
          		  if ($scope.resultDetailList[i].resultDetailId == $scope.result[j].id) {
          			  $scope.resultDetailList[i].checkResult = $scope.result[j].checkResult;
          		  }
          	  }
            }

            var key = $scope.checkresultList[$scope.detailId - 1].tCheckId;
            $scope.checkresultList[$scope.detailId - 1].result = $scope.resultDetailList;
            $rootScope.removeResultIndexDb(key);
   	      $rootScope.addResultIndexDb($scope.checkresultList[$scope.detailId - 1]);

   	      if (isLoadDetail) {
   	    	  $rootScope.showInfoMessage("保存しました。");

     	      $scope.ticket.statusId = '02';
     	      $scope.ticket.statusName = 'チェック中';

   	      }

   	      return true;

          };


          $scope.showHistorySp = function() {

              $uibModal.open({
                animation: true,
                templateUrl: "app/pages/offline/checkreportHistorySp.html",
                scope : $scope,
                backdrop : "static",
                resolve: {
                    openFlag: function () {
                        return {};
                  }
                }
              });

	            //ダウンロードしたコメント一覧取得
	     		var transaction = $rootScope.db5.transaction(['comment'],"readwrite");
	     		var store = transaction.objectStore('comment');
	     		var request = store.get($scope.ticketId);
	     		request.onsuccess = function () {
	     			$scope.statusHistoryList = request.result.statusHistoryList;
	     		}
          };


          $scope.showTargetInfoSp = function() {
              $uibModal.open({
                animation: true,
                templateUrl: "app/pages/offline/checkreportTargetInfoSp.html",
                scope : $scope,
                backdrop : "static",
                resolve: {
                    openFlag: function () {
                        return {};
                  }
                }
              });

              // 工事検索
              var transaction = $rootScope.db6.transaction(['target'],"readwrite");
	     	  var store = transaction.objectStore('target');
	     	  var request = store.get($scope.ticket.targetId);
	     	  request.onsuccess = function () {
	        	$scope.itemNameList = request.result.item;
	        	$scope.selectedTarget = request.result.targetOb;
	        	$scope.selectedTar = request.result.tar;
	     	  }
          };

          $scope.showCheckListSp = function() {
              $uibModal.open({
                animation: true,
                templateUrl: "app/pages/offline/checkreportResultListSp.html",
                scope : $scope,
                backdrop : "static",
                resolve: {
                    openFlag: function () {
                        return {};
                  }
                }
              });


              $scope.checkListFileList = ajaxService.getFileList($scope.ticket.checksheetId);
          };

	$scope.showTicketList = function () {

		//チェックシート一覧検索
		$scope.selectTicketIndexDb();

		$("#ticketDetail").css({
          'display' : 'none'
        });
        $("#ticketList").css({
            'display' : 'block'
        });
        $("body,html").animate({
            scrollTop : $("#ticketList").offset().top - 100
        }, 1000);
	};


	$scope.openUploadVideo = function(resultId) {
		$rootScope.showErrorMessage("ローカルに保存しているチケットは、音声、動画、ファイルのアップロードができません。");
	};


	$scope.openUploadRadio = function(resultId) {
		$rootScope.showErrorMessage("ローカルに保存しているチケットは、音声、動画、ファイルのアップロードができません。");
	};

	$scope.openUploadFile = function(resultId) {
		$rootScope.showErrorMessage("ローカルに保存しているチケットは、音声、動画、ファイルのアップロードができません。");
	};


}

})();

/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.password').controller('PasswordCtrl', PasswordCtrl);

    /** @ngInject */
    function PasswordCtrl($scope, ajaxService, $rootScope, tr, Upload) {

    	if(! window.navigator.onLine){
    		//オフラインの場合、ダウンロードチケットへ遷移
    		window.location.href = "#/offline";
    		return;
    	}

        $scope.contractorId = window.localStorage.contractorId;


      if (!ajaxService.tokenCheck()) {
            return;
          };
          $rootScope.isHome = false;
          $rootScope.isProject = false;

          var url = window.location.href;
          var ulList = url.split("#");
          if (ulList.length >= 2) {
            var u = url.split("#")[1];
              if (u.indexOf('/project') == 0) {
                  $rootScope.isProject = true;
                } else {
                  $rootScope.isProject = false;
                }
          }


      $scope.ctrlScope = $scope;
      $scope.userId = localStorage.userId;
      $scope.userName = localStorage.userName;

      if ($rootScope.projectId) {
    	  if (! $scope.userList) {
              $scope.userList = ajaxService.selectUserList($rootScope.projectId);
            }
          for (var i=0; i<$scope.userList.length; i++) {
              if (localStorage.userId == $scope.userList[i].userId) {
                $scope.loginUser = $scope.userList[i];
                break;
              }
            }
          $scope.tel =$scope.loginUser.tel;
          $scope.email = $scope.loginUser.mailAdd;
      } else {
    	  $scope.loginUser = ajaxService.searchSystemUser();
    	  $scope.tel = $scope.loginUser.tel;
    	  $scope.email = $scope.loginUser.mailAdd;
    	  $scope.email2 = $scope.loginUser.mailAdd2;
    	  $scope.email3 = $scope.loginUser.mailAdd3;
    	  $scope.email4 = $scope.loginUser.mailAdd4;
    	  $scope.email5 = $scope.loginUser.mailAdd5;
      }

      var passwordRule = ajaxService.getPasswordRule();
      $scope.pwdRuleLength = passwordRule.pwdRuleLength;
      $scope.pwdRuleUpper = passwordRule.pwdRuleUpper;
      $scope.pwdRuleLower = passwordRule.pwdRuleLower;
      $scope.pwdRuleNum = passwordRule.pwdRuleNum;
      $scope.pwdRuleSymbol = passwordRule.pwdRuleSymbol;

      $scope.checkPassword = function () {
          var reg = /([a-zA-Z0-9!@#$%^&*()_?<>{}])/;

          var upper = /[A-Z]+/;
          var lower = /[a-z]+/;
          var num = /[0-9]+/;
          var symbol = /[!@#$%^&*()_?<>{}]+/;

          var err = false;

          if ($scope.oldPassword == "" || $scope.oldPassword == null) {
              err = true;
            $rootScope.showErrorMessage("現在のパスワードを入力してください。");
          }
          if ($scope.newPassword == "" || $scope.newPassword == null) {
              err = true;
            $rootScope.showErrorMessage("新しいパスワードを入力してください。");
          }
          if ($scope.newPasswordConfirm == "" || $scope.newPasswordConfirm == null) {
              err = true;
            $rootScope.showErrorMessage("新しいパスワードの確認を入力してください。");
          }

          if (! err) {
            if(!reg.test($scope.oldPassword) || !reg.test($scope.newPassword) || !reg.test($scope.newPasswordConfirm)){
              err = true;
              $rootScope.showErrorMessage("パスワードには半角英数字と記号のみ使用できます。");
            }
            if ($scope.oldPassword == $scope.newPassword) {
                err = true;
              $rootScope.showErrorMessage("新しいパスワードと現在のパスワードが一致しています。");
            }
            if ($scope.newPassword != $scope.newPasswordConfirm) {
                err = true;
              $rootScope.showErrorMessage("新しいパスワードと新しいパスワードの確認が一致しません。");
            }
          }

          if (! err) {
            if ($scope.pwdRuleUpper == "true") {
              if (! upper.test($scope.newPassword)) {
                      err = true;
                $rootScope.showErrorMessage("パスワードは少なくとも一つの大文字を含めてください。");
              }
            }
            if ($scope.pwdRuleLower == "true") {
              if (! lower.test($scope.newPassword)) {
                      err = true;
                $rootScope.showErrorMessage("パスワードは少なくとも一つの小文字を含めてください。");
              }
            }
            if ($scope.pwdRuleNum == "true") {
              if (! num.test($scope.newPassword)) {
                      err = true;
                $rootScope.showErrorMessage("パスワードは少なくとも一つの数字を含めてください。");
              }
            }
            if ($scope.pwdRuleSymbol == "true") {
              if (! symbol.test($scope.newPassword)) {
                      err = true;
                $rootScope.showErrorMessage("パスワードは少なくとも一つの記号を含めてください。");
              }
            }
            if ($scope.pwdRuleLength != "" && $scope.pwdRuleLength != null) {
                if ($scope.newPassword.length < $scope.pwdRuleLength) {
                        err = true;
                  $rootScope.showErrorMessage("パスワードは"+ $scope.pwdRuleLength + "桁以上で入力してください。");
                }
              }
          }

          return err;
        };

      $scope.modifyPassword = function () {
        var err = $scope.checkPassword();
        if (! err) {
            ajaxService.modifyPassword($scope.oldPassword, $scope.newPassword);
            if (ajaxService.result['resultCd'] != "000000") {
              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              return;
            }
            $("#oldPassword").val("");
            $("#newPassword").val("");
            $("#newPasswordConfirm").val("");
            $rootScope.showInfoMessage("パスワードを更新しました。");
        }

      };


      $scope.modifyUserTelEmail = function () {
    	  var regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    	  if ($scope.email) {
        	  if (! regEmail.test($scope.email)) {
                  $rootScope.showErrorMessage("128桁以内の有効的なメールアドレスを入力してください。");
                  return ;
        	  }
          }
    	  ajaxService.modifyUserTelEmail($scope.tel, $scope.email);
    	  $rootScope.showInfoMessage("更新しました。");

      }


      $scope.modifyPasswordSystem = function () {

        var reg = /([a-zA-Z0-9!@#$%^&*()_?<>{}])/;
        var regEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

        var err = false;
        if (! $scope.userId) {
            err = true;
            $rootScope.showErrorMessage("技術者IDを入力してください。");
          } else {
            if ($scope.userId.length > 32 || !reg.test($scope.userId)) {
                err = true;
                $rootScope.showErrorMessage("技術者IDに32桁以内の半角英字、数字を入力してください。");
            }
          }

          if (! $scope.userName) {
              err = true;
              $rootScope.showErrorMessage("技術者名を入力してください。");
          } else {
              if ($scope.userName.length > 128) {
                  err = true;
                  $rootScope.showErrorMessage("128桁数以内の文字を入力してください。");
              }
          }

          if ($scope.oldPassword || $scope.newPassword || $scope.newPasswordConfirm) {
              err = $scope.checkPassword();
          }

          if ($scope.email) {
        	  if (! regEmail.test($scope.email)) {
        		  err = true;
                  $rootScope.showErrorMessage("128桁以内の有効的なメールアドレスを入力してください。");
        	  }
          } else {
        	  $rootScope.showErrorMessage("メールアドレスを入力してください。");
    		  err = true;
          }
          if ($scope.email2) {
        	  if (! regEmail.test($scope.email2)) {
        		  err = true;
                  $rootScope.showErrorMessage("メールアドレス２に128桁以内の有効的なメールアドレスを入力してください。");
        	  }
          }
          if ($scope.email3) {
        	  if (! regEmail.test($scope.email3)) {
        		  err = true;
                  $rootScope.showErrorMessage("メールアドレス３に128桁以内の有効的なメールアドレスを入力してください。");
        	  }
          }
          if ($scope.email4) {
        	  if (! regEmail.test($scope.email4)) {
        		  err = true;
                  $rootScope.showErrorMessage("メールアドレス４に128桁以内の有効的なメールアドレスを入力してください。");
        	  }
          }
          if ($scope.email5) {
        	  if (! regEmail.test($scope.email5)) {
        		  err = true;
                  $rootScope.showErrorMessage("メールアドレス５に128桁以内の有効的なメールアドレスを入力してください。");
        	  }
          }

          if (! err) {
              ajaxService.modifyPasswordSystem($scope.userId, $scope.userName, $scope.oldPassword, $scope.newPassword, $scope.tel, $scope.email, $scope.email2, $scope.email3, $scope.email4, $scope.email5);
              if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                return;
              }
              $("#oldPassword").val("");
              $("#newPassword").val("");
              $("#newPasswordConfirm").val("");
              window.localStorage.userId = $scope.userId;
              window.localStorage.userName = $scope.userName;
              $rootScope.showInfoMessage("アカウント情報を更新しました。");
          }


      };

      $scope.loadUserImg = function () {
  		var fileId = ajaxService.getUserImg(localStorage.userId);
  		if (fileId != 0) {
  			$scope.picture = urlPrefix + "project/showUserImg/"+ fileId +"/"+localStorage.schema;
  			$scope.noPicture = false;
			$rootScope.loginUserImg = urlPrefix + "project/showUserImg/"+ fileId +"/"+localStorage.schema;
  		} else {
  	        $scope.picture = "assets/img/app/profile/defaultUser.png";
  			$scope.noPicture = true;
  		}
      };
      $scope.loadUserImg();

      $scope.removePicture = function () {
    	  ajaxService.deleteUserImg();
    	  $scope.loadUserImg();
    	  $rootScope.showInfoMessage("プロフィール写真を削除しました。");
    	  $rootScope.loginUserImg = "assets/img/app/profile/defaultUser.png";
      };

      $scope.uploadPicture = function () {
          var fileInput = document.getElementById('uploadFile');
          fileInput.click();
        };

        $scope.getFile = function (fileOb) {

        	if (! fileOb || ! fileOb.name) {
        		$rootScope.showErrorMessage("有効な画像ファイルを選択してください。");
                return;
        	}

        	if(! $rootScope.isImg(fileOb.name)) {
                $rootScope.showErrorMessage("画像以外のファイルがアップロードできません。");
                return;
              }

        	if (!$scope.noPicture) {
        		ajaxService.deleteUserImg();
        	}

        	Upload.upload({
                url : urlPrefix + "checkreport/uploadUserFile",
                type : "POST",
                headers : {
                    "authorization" : localStorage.authId,
                },
                dataType : "multipart/form-data",
                data : {file: fileOb, 'loginId':localStorage.userId, "schema" : localStorage.schema}
            }).then(function(response) {
            	if (response.data.resultCd != '000000') {
            		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
            		return ;
            	}
                //取得
                $scope.loadUserImg();
                $rootScope.showInfoMessage("プロフィール写真を変更しました。");


            }, function(response) {
              $rootScope.showErrorMessage(tr.T(response.data.resultCd));
            });

        };

    }

})();

/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.project').controller('ProjectCtrl', ProjectCtrl);

    /** @ngInject */

    function ProjectCtrl($scope, ajaxService, $rootScope, $uibModal, tr, Upload, $window, $filter ) {

      if (!ajaxService.tokenCheck()) {
            return;
          };


          $scope.schema = localStorage.schema;

          $scope.kcmeNewsList = ajaxService.selectKcmeNews();

          $scope.kcmeNewsType = '1';
          $scope.kcmeNews = '';

          $scope.csvTitle = ["技術者ID",
                                     "パスワード",
                                     "技術者名",
                                    "権限",
                                     "操作区分(1:追加 2:変更 3:削除)"
                                     ];

                $scope.csvColumn = ["userId",
                                      "",
                                      "userName",
                                      "mngFlagName",
                                      ""
                                      ];

          $scope.csvFileName = "技術者.csv";

        $scope.uploadFiles = function(file) {
            var name = file.name;

            if (name.toLowerCase().indexOf(".csv") == -1) {
              $rootScope.showErrorMessage("csvファイルをアップロードしてください。");
              return;
            }
            var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "アップロードを実施してもよろしいですか？"

                        };
                    }
                }
            });

            modalInstance.result.then(function() {
            	if (file) {
                    Upload.upload({
                        url : urlPrefix + "project/uploadUser",
                        type : "POST",
                        headers : {
                            "authorization" : localStorage.authId,
                        },
                        dataType : "multipart/form-data",
                        data : {
                            'projectId': $rootScope.projectId, 'regionCode': localStorage.regionCode, "schema" : localStorage.schema, 'loginId':localStorage.userId, file : file
                        }
                    }).progress(function (evt) {
                        //progress
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        if (progressPercentage != 100) {
                          $rootScope.showInfoMessage("アップロード中：" + progressPercentage + "%");
                        }
                    }).then(function(response) {
                        var name = response.config.data.file.name;
                        if (response.data.resultCd == "000000") {
                            $scope.update = response.data.updateCount;
                            $scope.skipUpdate = response.data.skipUpdate;
                            if ($scope.update > 0) {
                                $scope.allUser = ajaxService.searchAllUser();
                            }
                            // errorFile
                            if (response.data.skipUpdate > 0) {
                                 // データを用意する
                                var bom = new Uint8Array(
                                        [ 0xEF, 0xBB, 0xBF ]);
                                var content = "行番, エラーメッセージ";
                                content = content + "\n";
                                for (var i=0; i<response.data.skipUpdateInfo.length; i++) {
                                    content = content + response.data.skipUpdateInfo[i] + "\n";
                                }
                                var blob = new Blob([ bom, content ], {
                                    "type" : "text/csv"
                                });

                                // 出力
                                if ($window.navigator.msSaveBlob) {
                                    $window.navigator.msSaveBlob(blob, "アップロード結果.csv");
                                } else {
                                    var downloadLink = $('<a></a>');
                                    downloadLink.attr('href', $window.URL.createObjectURL(blob));
                                    downloadLink.attr('download', "アップロード結果.csv");
                                    downloadLink.attr('target', '_blank');
                                    $('body').append(downloadLink);
                                    downloadLink[0].click();
                                    downloadLink.remove();
                                }
                                $rootScope.showErrorMessage("エラーにより一部のデータが取り込まれていません。詳しくは出力した「アップロード結果.csv」ファイルを参照してください。");
                            } else {
                                $rootScope.showInfoMessage("アップロードが完了しました。");
                            }

                        } else {
                          $rootScope.showErrorMessage(tr.T(response.data.resultCd));
                        }
                    }, function(response) {
                        if (response.status > 0)
                          $rootScope.showErrorMessage(response.status + ': ' + response.data);
                    }, function(evt) {
                    });
                }
            });
        };


          $scope.createKcmeNews = function(){
        	  if (! $scope.kcmeNews) {
        		  $rootScope.showErrorMessage("お知らせ内容を入力してください。");
                  return ;
        	  }

        	  ajaxService.createKcmeNews($scope.kcmeNews, $scope.kcmeNewsType);
        	  if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                  return;
                }
                $rootScope.showInfoMessage("お知らせを登録しました。");
                $scope.kcmeNewsList = ajaxService.selectKcmeNews();
                $scope.kcmeNewsType = '1';
                $scope.kcmeNews = '';
          };

          $scope.deleteKcmeNews = function(id){

        	  ajaxService.deleteKcmeNews(id);
        	  if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                  return;
                }
                $rootScope.showInfoMessage("お知らせを削除しました。");
                $scope.kcmeNewsList = ajaxService.selectKcmeNews();
          };


          $rootScope.isProject = true;

          $scope.smartTablePageSize = 20;
      $scope.ctrlScope = $scope;
      $rootScope.mngKbn = window.localStorage.mngKbn;
      $rootScope.realMngKbn = window.localStorage.realMngKbn;

      var usedPlanList = ajaxService.searchResource("USED_PLAN");
      $scope.usedPlan = usedPlanList[0];
      $scope.showNextMonthPlan = false;
      $scope.nextMonthPlan =  ajaxService.getPlanHistory();
      if ($scope.nextMonthPlan != 0 && $scope.nextMonthPlan < $scope.usedPlan.value) {
    	  $scope.showNextMonthPlan = true;
      }

      $scope.projectList = ajaxService.searchProjectList(window.localStorage.regionCode);

      $scope.getTotalDisk = function(){
    	    var total = 0;
    	    for(var i = 0; i < $scope.projectList.length; i++){
    	        var project = $scope.projectList[i];
    	        total += project.diskSpace;
    	    }
    	    return total;
    	}

      $scope.diskSpace = $scope.getTotalDisk();

      $scope.diskSpaceHisList = ajaxService.getDiskSpaceHistoryAll();

      $scope.yearList = new Array();
      var initYear = "";

      for (var i = 0; i < $scope.diskSpaceHisList.length; i++) {
    	  var his = $scope.diskSpaceHisList[i];
    	  var year = his.month.substring(0,4);
    	  if (initYear != year) {
    		  initYear = year;
        	  var flg = false;
        	  if (i == 0) {
        		  flg = true;
        	  }
    		  $scope.yearList.push({"year":year,"flg":flg});
    	      $scope["diskList" + year] = new Array();
    	  }
    	  $scope["diskList" + year].push(his);
      }

      $scope.dynamicArray = function(year){
          return $scope["diskList"+year];
      }



      $scope.getRemainDisk = function () {
    	  return $scope.usedPlan.value * 1024 * 1024 * 1024 - $scope.getTotalDisk();
      }

      $scope.usedPa = (($scope.getTotalDisk() / ($scope.usedPlan.value * 1024 * 1024 * 1024)) * 100).toFixed(2);

      $scope.choicePorject = function(id, name) {

    	if ($rootScope.mngKbn == '3' || window.localStorage.mngKbn == '3') {
      		//業務に入ると、拠点管理者⇒業務管理者と見なす
      		$rootScope.mngKbn = '2'
      		window.localStorage.mngKbn = '2'
      	}

        $rootScope.projectId = id;
        window.localStorage.projectId = id;
        $rootScope.projectName = name;
        window.localStorage.projectName = name;
        window.location.href = "#/home";
      };

      $scope.showChangePassword = function() {
        $("#passwordP").css({
          'display' : 'block'
        });

        $("#projectP").css({
          'display' : 'none'
        });

        $("#alreadyUser").css({
          'display' : 'none'
        });

        $("#allUser").css({
            'display' : 'none'
          });

        $("#systemP").css({
          'display' : 'none'
        });

        $("body,html").animate({
            scrollTop : $("#passwordP").offset().top - 100
        }, 1000);
      };


      $scope.showChangeSys = function() {
        var passwordRule = ajaxService.getPasswordRule();
        $scope.lock = passwordRule.lock;
        $scope.pwdMaxErrNum = parseInt(passwordRule.pwdMaxErrNum);
        $scope.pwdPeriod = passwordRule.pwdPeriod;
        $scope.pwdPeriodNum = parseInt(passwordRule.pwdPeriodNum);
        $scope.pwdRuleLength = parseInt(passwordRule.pwdRuleLength);
        $scope.tabletMode = passwordRule.tabletMode;

        if (passwordRule.pwdRuleUpper == 'true') {
          $scope.pwdRuleUpper = true;
        } else {
          $scope.pwdRuleUpper = false;
        }
        if (passwordRule.pwdRuleLower == 'true') {
            $scope.pwdRuleLower = true;
          } else {
            $scope.pwdRuleLower = false;
          }
        if (passwordRule.pwdRuleNum == 'true') {
            $scope.pwdRuleNum = true;
          } else {
            $scope.pwdRuleNum = false;
          }
        if (passwordRule.pwdRuleSymbol == 'true') {
            $scope.pwdRuleSymbol = true;
          } else {
            $scope.pwdRuleSymbol = false;
          }

        $("#systemP").css({
          'display' : 'block'
        });

        $("#projectP").css({
          'display' : 'none'
        });
        $("#alreadyUser").css({
            'display' : 'none'
          });
        $("#allUser").css({
            'display' : 'none'
          });

        $("#passwordP").css({
          'display' : 'none'
        });

        $("#detaultCheck").css({
          'display' : 'none'
        });

        $("#listDetail").css({
          'display' : 'none'
        });

        $("#fileList").css({
          'display' : 'none'
        });

        $("body,html").animate({
            scrollTop : $("#systemP").offset().top - 100
        }, 1000);
      };

      $scope.modifyPasswordRule = function() {

        if ($scope.lock == "1") {
            if (! /^[0-9]+$/.test($scope.pwdMaxErrNum)) {
              $rootScope.showErrorMessage("パスワード入力ミス許容回数に数字を入力してください。");
              return ;
            }
            if ($scope.pwdMaxErrNum == "0") {
              $rootScope.showErrorMessage("1以上の数字を入力してください。");
                return ;
            }
        } else {
          $scope.pwdMaxErrNum = "";
        }
        if ($scope.pwdPeriod == "1") {
            if (! /^[0-9]+$/.test($scope.pwdPeriodNum)) {
              $rootScope.showErrorMessage("パスワード有効期間に数字を入力してください。");
              return ;
            }
            if ($scope.pwdPeriodNum == "0") {
              $rootScope.showErrorMessage("1以上の数字を入力してください。");
                return ;
            }
        } else {
          $scope.pwdPeriodNum = "";
        }

        if ($scope.pwdRuleLength) {
          if (! /^[0-9]+$/.test($scope.pwdRuleLength)) {
            $rootScope.showErrorMessage("パスワード設定条件の最小長に数字を入力してください。");
            return ;
          }
          if ($scope.pwdRuleLength == "0") {
            $rootScope.showErrorMessage("1以上の数字を入力してください。");
              return ;
          }
        }

        ajaxService.modifyPasswordRule($scope.lock,$scope.pwdMaxErrNum,$scope.pwdPeriod,$scope.pwdPeriodNum,$scope.pwdRuleLength,$scope.pwdRuleUpper,$scope.pwdRuleLower,$scope.pwdRuleNum,$scope.pwdRuleSymbol, $scope.tabletMode);
        if (ajaxService.result['resultCd'] != "000000") {
          $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
          return;
        }
        $rootScope.showInfoMessage("システム情報を設定しました。");
      };


      $scope.initPasswordRule = function() {
          ajaxService.modifyPasswordRule("0","","0","","",false,false,false,false, "0");
          if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            return;
          }
          $rootScope.showInfoMessage("システム情報をリセットしました。");
          $scope.lock = "0";
          $scope.pwdMaxErrNum = "";
          $scope.pwdPeriod = "0";
          $scope.pwdPeriodNum = "";
          $scope.pwdRuleLength = "";
          $scope.pwdRuleUpper = false;
          $scope.pwdRuleLower = false;
          $scope.pwdRuleNum = false;
          $scope.pwdRuleSymbol = false;

          $scope.tabletMode = "0";
      }

      $scope.showProjectInfo = function (id, name) {
        if (id) {
           $scope.projectId = id;
           $scope.projectName = name;
           $scope.userList = ajaxService.searchUserList(id, "0");
        } else {
           $scope.projectId = "";
           $scope.projectName = "";
        }
        $("#projectP").css({
          'display' : 'block'
        });

        $("#alreadyUser").css({
          'display' : 'none'
        });

        $("#passwordP").css({
          'display' : 'none'
        });
        $("#allUser").css({
            'display' : 'none'
          });

        $("#systemP").css({
          'display' : 'none'
        });

        $("body,html").animate({
            scrollTop : $("#projectP").offset().top - 100
        }, 1000);
      };

      $scope.saveProject = function () {
        if ($scope.projectName == "" || $scope.projectName == null) {
          $rootScope.showErrorMessage("業務名を入力してください。");
          return;
        }

        if ($scope.projectId == "") {
          // 新規
          $scope.projectId = ajaxService.createProject($scope.projectName);
          if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            return;
          }

          $scope.projectList = ajaxService.searchProjectList();
          $scope.userList = ajaxService.searchUserList($scope.projectId, "0");
          $rootScope.showInfoMessage("業務を新規しました。");
        } else {
          // 更新
          ajaxService.modifyProject($scope.projectId, $scope.projectName);
          if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            return;
          }
          $scope.projectList = ajaxService.searchProjectList();
          $rootScope.showInfoMessage("業務を更新しました。");
        }
      };

      $scope.removeUser = function (userId, isDetail) {
        ajaxService.removeUserFromProject($scope.projectId, userId);
        if (ajaxService.result['resultCd'] != "000000") {
          $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
          return;
        }
        if (isDetail) {
        	$scope.$parent.userListForProject = ajaxService.searchAddUserList($scope.projectId);
            $scope.$parent.userList = ajaxService.searchUserList($scope.projectId, "0");
        } else {
        $scope.userListForProject = ajaxService.searchAddUserList($scope.projectId);
        $scope.userList = ajaxService.searchUserList($scope.projectId, "0");
        }

      };

      $scope.newUser = function () {
        $uibModal.open({
          animation: true,
          templateUrl: "app/pages/user/newUser.html",
          controller: 'UserCtrl',
          backdrop : "static",
          scope : $scope,
          resolve: {
              openFlag: function () {
                  return {
                    "userId":"",
                    "projectId":$scope.projectId,
                  };
            }
          }
        });

        $rootScope.isProject = true;

        $scope.userName = "";
        $scope.groupList = ajaxService.selectGroupUserResourceList($scope.projectId);
        $scope.selectedGroups = {selected:[]};
          $scope.rollList = [
                           {label: '担当技術者', value: "0"},
                           {label: '指示者', value: "1"},
                           {label: '管理技術者', value: "2"}
                         ];
         $scope.companyList = ajaxService.searchCompanyList();
         $scope.companyList.unshift({fName:"----", id:0});
         $scope.companySelected = $scope.companyList[0];
         $scope.rollSelected = $scope.rollList[0];
      };

      $scope.showUserDetail = function(user) {
          $uibModal.open({
            animation: true,
            templateUrl: "app/pages/project/userDetail.html",
            controller: 'ProjectCtrl',
            backdrop : "static",
            scope : $scope,
            resolve: {
                openFlag: function () {
                    return {};
              }
            }
          });

          $rootScope.isProject = true;
          $scope.userInfo = user;


          $scope.groupList = ajaxService.selectGroupUserResourceList($scope.projectId);

          var selectedGroupList = [];
          for (var i =0; i<user.groupList.length; i++) {
        	  for (var j =0; j<$scope.groupList.length; j++) {
        		  if (user.groupList[i].groupId == $scope.groupList[j].groupId) {
        			  selectedGroupList.push($scope.groupList[j]);
        		  }
        	  }
          }

          $scope.selectedGroups = {selected:selectedGroupList};


          $scope.companyList = ajaxService.searchCompanyList();
          $scope.companyList.unshift({fName:"----", id:0});

          $scope.rollList = [
                                {label: '担当技術者', value: "0"},
                                {label: '指示者', value: "1"},
                                {label: '管理技術者', value: "2"}
                              ];
          for (var i=0; i<$scope.companyList.length; i++) {
            if ($scope.companyList[i].id == $scope.userInfo.comId) {
              $scope.userInfo.companySelected = $scope.companyList[i];
              break;
            }
          }
          if (! $scope.userInfo.companySelected) {
        	  $scope.userInfo.companySelected = $scope.companyList[0];
          }

          for (var i=0; i<$scope.rollList.length; i++) {
            if ($scope.rollList[i].value == $scope.userInfo.mngFlag) {
              $scope.userInfo.rollSelected = $scope.rollList[i];
              break;
            }
          }
        };

        $scope.modifyUser = function(form) {
            var groupidlist = [];
            for (var i =0; i< $scope.selectedGroups.selected.length; i++) {
            	if ($rootScope.listContains(groupidlist, $scope.selectedGroups.selected[i].groupId)){
	           		 continue;
	           	 }
              groupidlist.push($scope.selectedGroups.selected[i].groupId);
            }

            var password = $scope.userInfo.password;
            var passwordConfirm = $scope.userInfo.passwordConfirm;
            if (password) {
              var passwordRule = ajaxService.getPasswordRule();
                $scope.pwdRuleLength = passwordRule.pwdRuleLength;
                $scope.pwdRuleUpper = passwordRule.pwdRuleUpper;
                $scope.pwdRuleLower = passwordRule.pwdRuleLower;
                $scope.pwdRuleNum = passwordRule.pwdRuleNum;
                $scope.pwdRuleSymbol = passwordRule.pwdRuleSymbol;
                var reg = /([a-zA-Z0-9!@#$%^&*()_?<>{}])/;

                var upper = /[A-Z]+/;
                var lower = /[a-z]+/;
                var num = /[0-9]+/;
                var symbol = /[!@#$%^&*()_?<>{}]+/;

                var err = false;

                if (! err) {
                  if(!reg.test(password) || !reg.test(passwordConfirm)){
                    err = true;
                    $rootScope.showErrorMessage("パスワードには半角英数字と記号のみ使用できます。");
                  }
                  if (password != passwordConfirm) {
                      err = true;
                    $rootScope.showErrorMessage("パスワードとパスワードの確認が一致しません。");
                  }
                }

                if (! err) {
                  if ($scope.pwdRuleUpper == "true") {
                    if (! upper.test(password)) {
                            err = true;
                      $rootScope.showErrorMessage("パスワードは少なくとも一つの大文字を含めてください。");
                    }
                  }
                  if ($scope.pwdRuleLower == "true") {
                    if (! lower.test(password)) {
                            err = true;
                      $rootScope.showErrorMessage("パスワードは少なくとも一つの小文字を含めてください。");
                    }
                  }
                  if ($scope.pwdRuleNum == "true") {
                    if (! num.test(password)) {
                            err = true;
                      $rootScope.showErrorMessage("パスワードは少なくとも一つの数字を含めてください。");
                    }
                  }
                  if ($scope.pwdRuleSymbol == "true") {
                    if (! symbol.test(password)) {
                            err = true;
                      $rootScope.showErrorMessage("パスワードは少なくとも一つの記号を含めてください。");
                    }
                  }
                  if ($scope.pwdRuleLength != "" && $scope.pwdRuleLength != null) {
                      if (password.length < $scope.pwdRuleLength) {
                              err = true;
                        $rootScope.showErrorMessage("パスワードは"+ $scope.pwdRuleLength + "桁以上で入力してください。");
                      }
                    }
                }

                if (err) {
                    return;
                }
            }

            var mngFlg = "0";

            if ($scope.userInfo.mngFlag == '3') {
            	mngFlg = "3";
            } else if ($scope.userInfo.mngFlag == '9') {
            	mngFlg = "9";
            } else {
            	mngFlg = $scope.userInfo.rollSelected.value;
            }

            ajaxService.modifyUser($scope.userInfo.userId,
                $scope.userInfo.userName,
                password,
                $scope.userInfo.companySelected.id,
                $scope.userInfo.organization,
                $scope.userInfo.tel,
                $scope.userInfo.mailAdd,
                $scope.userInfo.address,
                $scope.userInfo.lat,
                $scope.userInfo.lng,
                mngFlg,
                groupidlist,
                $scope.userInfo.accountLock,$scope.projectId);
            if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                return "";
            } else {
              $rootScope.showInfoMessage("更新しました。");
              $scope.$$childTail.$dismiss();
              $scope.$parent.userList = ajaxService.searchUserList($scope.projectId, "0");
            }

        };


      $scope.showAddUser = function () {
        $scope.userListForProject = ajaxService.searchAddUserList($scope.projectId);
        $("#alreadyUser").css({
          'display' : 'block'
        });
        $("body,html").animate({
            scrollTop : $("#alreadyUser").offset().top - 100
        }, 1000);
      };

      $scope.addUser = function (userId) {
        ajaxService.addUserToProject($scope.projectId, userId);
        if (ajaxService.result['resultCd'] != "000000") {
          $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
          return;
        }
        $scope.userListForProject = ajaxService.searchAddUserList($scope.projectId);
        $scope.userList = ajaxService.searchUserList($scope.projectId, "0");
      };

      $scope.deleteProject = function () {
        var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : "業務を削除してもよろしいですか？"
                      };
                  }
              }
          });

        modalInstance.result.then(function() {
          ajaxService.removeProject($scope.projectId);
          if (ajaxService.result['resultCd'] == "000000") {
            $rootScope.showInfoMessage("業務を削除しました。");
            $scope.projectList = ajaxService.searchProjectList();
            $("#projectP").css({
                'display' : 'none'
              });
            $("#alreadyUser").css({
                'display' : 'none'
              });
            $("#allUser").css({
                'display' : 'none'
              });
          }
        });
      };


      $scope.showPlan = function () {
    	  $scope.addon = ($scope.usedPlan.value - 40);
    	  $scope.newPlan = $scope.addon  + 40;
    	  $scope.$modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/project/plan.html',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : ""
                      };
                  }
              }
          });
      };

      $scope.changeAddon = function () {
    	  if ($scope.addon > 100) {
    		  $scope.addon = parseInt($scope.addon /100) * 100;
    	  }
    	  $scope.newPlan = $scope.addon + 40;
      };

      $scope.updatePlan = function () {

    	  if ($scope.addon != 0 && $scope.addon < 100) {
    		  $rootScope.showErrorMessage("0か100以上の整数を入れてください。");
              return ;
    	  }

    	  var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : "利用上限容量は　"+ $scope.newPlan +"G　に変更してもよろしいですか？"
                      };
                  }
              }
          });


        modalInstance.result.then(function() {
        	var msg = "プランを変更しました。";
        	if ($scope.newPlan < $scope.usedPlan.value) {
        		msg = "プランを変更しました。来月から適用されます。";
      	    }
            ajaxService.updatePlanValue($scope.newPlan);
            var usedPlanList = ajaxService.searchResource("USED_PLAN");
            $scope.usedPlan = usedPlanList[0];
            $scope.$modalInstance.dismiss();
            $rootScope.showInfoMessage(msg);
            $scope.showNextMonthPlan = false;
            $scope.nextMonthPlan =  ajaxService.getPlanHistory();
            if ($scope.nextMonthPlan != 0 && $scope.nextMonthPlan < $scope.usedPlan.value) {
          	  $scope.showNextMonthPlan = true;
            }
        });

      };


      $scope.showAllUserInfo = function () {

          $scope.allUser = ajaxService.searchAllUser();


    	  $("#systemP").css({
              'display' : 'none'
            });

            $("#projectP").css({
              'display' : 'none'
            });
            $("#alreadyUser").css({
                'display' : 'none'
              });
            $("#allUser").css({
                'display' : 'block'
              });

            $("#passwordP").css({
              'display' : 'none'
            });

            $("body,html").animate({
                scrollTop : $("#allUser").offset().top - 100
            }, 1000);
      };

      $scope.deleteUser = function(userId) {
          var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "該当技術者を削除してもよろしいですか？"
                        };
                    }
                }
            });

            modalInstance.result.then(function() {
              ajaxService.removeUser(userId);
              if (ajaxService.result['resultCd'] == "000000") {
                $rootScope.showInfoMessage("技術者を削除しました。");
                $scope.allUser = ajaxService.searchAllUser();
              }
            });
        };

    	$scope.loadLoginLogo = function () {
    		var logo = ajaxService.getLogo("1");
    		var path = logo.logoPath;
    		if (path && path != '') {
    			$scope.pictureLogin = urlPrefix + "project/showLogo/1/"+ logo.fileId +"/"+localStorage.schema;
    			$scope.noPictureLogin = false;
    		} else {
    	        $scope.pictureLogin = $filter('appImage')('no_photo.png');
    			$scope.noPictureLogin = true;
    		}
        };

        $scope.loadLoginLogo();


    	$scope.loadHeaderLogo = function () {
    		var logo = ajaxService.getLogo("2");
    		var path = logo.logoPath;
    		if (path && path != '') {
    			$scope.pictureHeader = urlPrefix + "project/showLogo/2/"+ logo.fileId + "/" +localStorage.schema;
    			$scope.noPictureHeader = false;
    			$rootScope.headerImg = urlPrefix + "project/showLogo/2/"+ logo.fileId + "/" +localStorage.schema;
    		} else {
    	        $scope.pictureHeader = $filter('appImage')('no_photo-header.png');
    			$scope.noPictureHeader = true;
    		}
        };

        $scope.loadHeaderLogo();

    	$scope.loadBookMarkLogo = function () {
    		var logo = ajaxService.getLogo("3");
    		var path = logo.logoPath;
    		if (path && path != '') {
    			$scope.pictureBookMark = urlPrefix + "project/showLogo/3/"+ logo.fileId + "/" +localStorage.schema;
    			$scope.noPictureBookMark = false;
    			$rootScope.bookMarkImg = urlPrefix + "project/showLogo/3/"+ logo.fileId + "/" +localStorage.schema;
    		} else {
    	        $scope.pictureBookMark = $filter('appImage')('no_photo-header.png');
    			$scope.noPictureBookMark = true;
    		}
        };

        $scope.loadBookMarkLogo();

      $scope.removeLoginLogo = function () {
    	  $("#uploadFileLogin").val('');
    	  ajaxService.deleteLogo("1");
    	  $scope.loadLoginLogo();
    	  $rootScope.showInfoMessage("ログイン画面のロゴを削除しました。");
      };

      $scope.removeHeaderLogo = function () {
    	  $("#uploadFileHeader").val('');
    	  ajaxService.deleteLogo("2");
    	  $scope.loadHeaderLogo();
    	  $rootScope.showInfoMessage("ヘッダ部のロゴを削除しました。");
    	  $rootScope.headerImg = "";
      };

      $scope.removeBookMarkLogo = function () {
    	  $("#uploadFileBookMark").val('');
    	  ajaxService.deleteLogo("3");
    	  $scope.loadBookMarkLogo();
    	  $rootScope.showInfoMessage("ブックマークアイコンを削除しました。");
    	  $rootScope.bookMarkImg = "";
          window.location.reload();
      };



        $scope.uploadLoginLogo = function () {
          var fileInput = document.getElementById('uploadFileLogin');
          fileInput.click();
        };

        $scope.getLoginLogo = function (fileOb) {

        	if (! fileOb || ! fileOb.name) {
        		$rootScope.showErrorMessage("有効な画像ファイルを選択してください。");
                return;
        	}

        	if(! $rootScope.isImg(fileOb.name)) {
                $rootScope.showErrorMessage("画像以外のファイルがアップロードできません。");
                return;
              }

        	if (!$scope.noPictureLogin) {
        		ajaxService.deleteLogo("1");
        	}

        	Upload.upload({
                url : urlPrefix + "checkreport/uploadLogoFile",
                type : "POST",
                headers : {
                    "authorization" : localStorage.authId,
                },
                dataType : "multipart/form-data",
                data : {file: fileOb, 'loginId':localStorage.userId, 'typeKbn':'1', "schema" : localStorage.schema}
            }).then(function(response) {
            	if (response.data.resultCd != '000000') {
            		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
            		return ;
            	}
                //取得
                $scope.loadLoginLogo();
                $rootScope.showInfoMessage("ログイン画面のロゴを入れ替えました。");


            }, function(response) {
              $rootScope.showErrorMessage(tr.T(response.data.resultCd));
            });

        };

        $scope.uploadHeaderLogo = function () {
            var fileInput = document.getElementById('uploadFileHeader');
            fileInput.click();
          };

          $scope.uploadBookMarkLogo = function () {
              var fileInput = document.getElementById('uploadFileBookMark');
              fileInput.click();
            };

        $scope.getHeaderLogo = function (fileOb) {
        	if (! fileOb || ! fileOb.name) {
        		$rootScope.showErrorMessage("有効な画像ファイルを選択してください。");
                return;
        	}

        	if(! $rootScope.isImg(fileOb.name)) {
                $rootScope.showErrorMessage("画像以外のファイルがアップロードできません。");
                return;
              }

        	if (!$scope.noPictureHeader) {
        		ajaxService.deleteLogo("2");
        	}

        	Upload.upload({
                url : urlPrefix + "checkreport/uploadLogoFile",
                type : "POST",
                headers : {
                    "authorization" : localStorage.authId,
                },
                dataType : "multipart/form-data",
                data : {file: fileOb, 'loginId':localStorage.userId, 'typeKbn':'2', "schema" : localStorage.schema}
            }).then(function(response) {
            	if (response.data.resultCd != '000000') {
            		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
            		return ;
            	}

                //取得
                $scope.loadHeaderLogo();
                $rootScope.showInfoMessage("ヘッダ部のロゴを入れ替えました。");


            }, function(response) {
              $rootScope.showErrorMessage(tr.T(response.data.resultCd));
            });

        };

        $scope.getBookMarkLogo = function (fileOb) {
        	if (! fileOb || ! fileOb.name) {
        		$rootScope.showErrorMessage("有効な画像ファイルを選択してください。");
                return;
        	}

        	if(! $rootScope.isImg(fileOb.name)) {
                $rootScope.showErrorMessage("画像以外のファイルがアップロードできません。");
                return;
              }

        	if (!$scope.noPictureBookMark) {
        		ajaxService.deleteLogo("3");
        	}

        	Upload.upload({
                url : urlPrefix + "checkreport/uploadLogoFile",
                type : "POST",
                headers : {
                    "authorization" : localStorage.authId,
                },
                dataType : "multipart/form-data",
                data : {file: fileOb, 'loginId':localStorage.userId, 'typeKbn':'3', "schema" : localStorage.schema}
            }).then(function(response) {
            	if (response.data.resultCd != '000000') {
            		$rootScope.showErrorMessage(tr.T(response.data.resultCd));
            		return ;
            	}

                //取得
                $scope.loadBookMarkLogo();
                $rootScope.showInfoMessage("ブックマークアイコンを入れ替えました。");


            }, function(response) {
              $rootScope.showErrorMessage(tr.T(response.data.resultCd));
            });

        };

        $scope.linkToManual = function () {
        	var url="https://smartbee.jp/report/docs/" ;
        	window.open(url);
        };

        $scope.linkToRelease = function () {
        	var url="https://smartbee.jp/report/release/" ;
        	window.open(url);
        };


        $scope.choiceRegion = function () {
        	if (! $scope.regionRadio) {
                $rootScope.showErrorMessage("拠点を選択してください。");
                return ;
        	}
        	window.localStorage.regionCode = $scope.regionRadio;
        	if ($rootScope.mngKbn == '9') {
        		//拠点に入ると、システム管理者⇒拠点管理者と見なす
        		$rootScope.mngKbn = '3';
        		window.localStorage.mngKbn = '3';
        	}
            $scope.projectList = ajaxService.searchProjectList(window.localStorage.regionCode);
        };


        $scope.gotoRegionChoice = function () {
        	window.localStorage.regionCode = "";
        	$rootScope.mngKbn = '9';
        	window.localStorage.mngKbn = '9';

            window.location.reload();

        };

        $scope.showDefaultMstData = function () {
        	if ($rootScope.projectId && $rootScope.projectId !='0') {
        		$rootScope.showErrorMessage("再度ログインしてから、やり直してください。");
                return ;
        	}

        	$uibModal.open({
                animation : true,
                templateUrl : 'app/pages/project/defaultMasterData.html',
                controller: 'Masterdata4CheckSheetCtrl',
                scope : $scope,
                size: 'lg',
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                          type : ""
                        };
                    }
                }
            });
        };

        $scope.showDefaultCheckSheetList = function () {
        	if ($rootScope.projectId && $rootScope.projectId !='0') {
        		$rootScope.showErrorMessage("再度ログインしてから、やり直してください。");
                return ;
        	}

        	//検索
            $scope.checksheetList = ajaxService.searchChecksheetList('0', "0");
            console.log($scope.checksheetList);

            $("#detaultCheck").css({
              'display' : 'block'
            });

            $("#listDetail").css({
              'display' : 'none'
            });

            $("#fileList").css({
                'display' : 'none'
              });

            $("#projectP").css({
              'display' : 'none'
            });
            $("#alreadyUser").css({
                'display' : 'none'
              });
            $("#allUser").css({
                'display' : 'none'
              });

            $("#passwordP").css({
              'display' : 'none'
            });

            $("#systemP").css({
              'display' : 'none'
            });

            $("body,html").animate({
                scrollTop : $("#detaultCheck").offset().top - 100
            }, 1000);
        };

        $scope.showChecklistCreate = function () {

          $scope.isCopy = false;

          $scope.ctrl = $scope;
          //初期化
	      $scope.firstList = ajaxService.getProjectResourceList('0', '91', 0);
	      $scope.firstList.unshift({label:" ", id:null})
	      $scope.secondList = [{label:"マスタデータがありません", id:null}];
	      $scope.thirdList = [{label:"マスタデータがありません", id:null}];
	      $scope.fourthList = [{label:"マスタデータがありません", id:null}];

	      $scope.first = $scope.firstList[0];
	      $scope.second = $scope.secondList[0];
	      $scope.third = $scope.thirdList[0];
	      $scope.fourth = $scope.fourthList[0];

	      $scope.firstDisable = false;
	      $scope.secondDisable = true;
	      $scope.thirdDisable = true;
	      $scope.fourthDisable = true;

	      $scope.frequency = "";

          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/project/newDefaultCheckSheet.html',
              scope : $scope,
              size: 'lg',
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                      };
                  }
              }
          });
        };

        $scope.changeFirst = function () {
        	$scope.secondList = ajaxService.getProjectResourceList('0', '92', $scope.first.id);
            if ($scope.secondList.length == 0) {
              $scope.secondList.push({label:"マスタデータがありません", id:0});
                $scope.secondDisable = true;
            } else {
                $scope.secondDisable = false;
            }
            $scope.second = $scope.secondList[0];
            $scope.changeSecond();
        };

        $scope.changeSecond = function () {
            $scope.thirdList = ajaxService.getProjectResourceList('0', '93', $scope.second.id);
	        if ($scope.thirdList.length == 0) {
	          $scope.thirdList.push({label:"マスタデータがありません", id:0});
	            $scope.thirdDisable = true;
	        } else {
	            $scope.thirdDisable = false;
	        }
	        $scope.third = $scope.thirdList[0];
	        $scope.changeThird();
        };

        $scope.changeThird = function () {
            $scope.fourthList = ajaxService.getProjectResourceList('0', '94', $scope.third.id);

            //コピー時、コピー元を選択させない。
            var j = -1;
            if ($scope.fourthList.length != 0 && $scope.isCopy) {
            	for (var i = 0; i<$scope.fourthList.length; i ++) {
            		if ($scope.fourthList[i].id == $scope.copyMoto.fourthId) {
            			j = i;
            		}
            	}
            }
            if (j >= 0) {
            	$scope.fourthList.splice(j, 1);
            }

	        if ($scope.fourthList.length == 0) {
	          $scope.fourthList.push({label:"マスタデータがありません", id:0});
	            $scope.fourthDisable = true;
	        } else {
	            $scope.fourthDisable = false;
	        }
	        $scope.fourth = $scope.fourthList[0];
        };

        $scope.createCheckSheet = function () {

        	if (!$scope.fourth.id || $scope.fourth.id == 0 ) {
              $rootScope.showErrorMessage("小項目までを選択してください。マスタデータがない場合、マスタデータを登録してからやり直してください。");
              return;
        	}

        	var checklistName = $scope.first.label + '⇒' + $scope.second.label + '⇒' + $scope.third.label + '⇒' + $scope.fourth.label;

            $scope.checksheetId = ajaxService.createChecksheet($scope.fourth.id, checklistName, $scope.frequency, '0');

            if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                return;
            }
            $rootScope.showInfoMessage("チェックを新規作成しました。");
            $scope.$$childTail.$dismiss();
            $scope.checksheetList = ajaxService.searchChecksheetList('0', "0");

            $scope.showChecklistDetail($scope.checksheetList[0]);
          };

          $scope.searchFileList = function () {
              $scope.fileList = ajaxService.getFileList($rootScope.selectedChecksheetId);
          };

          $scope.showChecklistDetail = function(item) {

        	  $scope.isUsedByTicket = true;

              $rootScope.selectedChecksheetId = item.checksheetId;

              $scope.selectedCheckSheet = item;

              $scope.$$childHead.$$nextSibling.$$nextSibling.$$nextSibling.$$childHead.getCheckList();
              $scope.$$childHead.$$nextSibling.$$nextSibling.$$nextSibling.$$childHead.init();

              $scope.fileList = ajaxService.getFileList($rootScope.selectedChecksheetId);

              $("#listDetail").css({
                'display' : 'block'
              });

              $("#fileList").css({
                'display' : 'block'
              });

              $("body,html").animate({
                  scrollTop : $("#listDetail").offset().top - 100
              }, 1000);

            };

        $scope.deleteChecksheet = function () {
            var ticketNum = ajaxService.getTicketNumByChecksheetId($rootScope.selectedChecksheetId);
            if (ticketNum !=0) {
              $rootScope.showErrorMessage("該当チェックを使用されているため、編集、削除できません。");
              return "";
            }
            var msg = "現在のバージョン削除してもよろしいですか？";
            if ($scope.selectedCheckSheet.version == 1) {
            	msg = "削除してもよろしいですか？";
            }
            var modalInstance = $uibModal.open({
                  animation : true,
                  templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                  controller : 'confirmDialogCtrl',
                  scope : $scope,
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                              message : msg
                          };
                      }
                  }
              });
              modalInstance.result.then(function() {
                ajaxService.removeChecksheet($rootScope.selectedChecksheetId, '0');
                if (ajaxService.result['resultCd'] != "000000") {
                  $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                } else {
                  $rootScope.showInfoMessage("チェックを削除しました。");
                  $scope.checksheetList = ajaxService.searchChecksheetList('0', "0");
                  $("#listDetail").css({
                      'display' : 'none'
                    });
                  $("#fileList").css({
                      'display' : 'none'
                    });
                }
              });
          };

      $scope.openDetail = function (page, info) {
          $uibModal.open({
            animation: true,
            templateUrl: page,
            controller: 'DetailCtrl',
            size: 'lg',
            backdrop : "static",
            scope : $scope,
            resolve: {
                checklistInfo: function () {
                    return {
                      checklistId : info.checklistId,
                      checklistName : info.checklistName,
                      checklistContent : info.checklistContent
                    };
              }
            }
          });
        };

        $scope.openUploadDialog = function() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/checklist/fileUploadModal.html',
                controller : 'FileUploadCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    openFlag : function() {
                        return {
                            'flag' : 'New',
                            'kbn' : 'Checksheet',
                            'id': $rootScope.selectedChecksheetId
                        };
                    }
                }
            });
        };

        $scope.delFile = function (fileBean) {
            var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "該当ファイルを削除してもよろしいですか？"
                        };
                    }
                }
            });

            modalInstance.result.then(function() {
              ajaxService.removeFile('0', $rootScope.selectedChecksheetId, fileBean.id, fileBean.fileExternal);
              if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              } else {
                $rootScope.showInfoMessage("該当ファイルを削除しました。");
                $scope.searchFileList();
              }
            });
          };

          $scope.showCheckAllInfo = function(checksheetId, checksheetName) {

        	  //チェック全体を取得する
              $scope.checkAllList = ajaxService.getCheckAllInfoList(checksheetId);

        	  var listId = 0;
        	  var j = 0;
        	  for (var i=0; i< $scope.checkAllList.length; i++) {
        		  if (listId == $scope.checkAllList[i].checklistId) {
        			  $scope.checkAllList[i].checklistName = "";
        			  $scope.checkAllList[j].togoNum = $scope.checkAllList[j].togoNum + 1;
        		  } else {
        			  j = i;
        			  listId = $scope.checkAllList[i].checklistId;
        			  $scope.checkAllList[j].togoNum = 1;
        		  }
        	  }

        	  $scope.checksheetName = checksheetName;

        	  $uibModal.open({
                  animation : true,
                  templateUrl : 'app/pages/checklist/checkAll.html',
                  scope : $scope,
                  size: 'lg',
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                            type : ""
                          };
                      }
                  }
              });
          };

          $scope.showCheckAllInfoAtDetail = function(){
        	  $scope.showCheckAllInfo($scope.selectedCheckSheet.checksheetId, $scope.selectedCheckSheet.checksheetName);
          }

        $scope.saveList = function() {
        	if(document.getElementById("finalApproval01").checked){
        		$scope.selectedCheckSheet.releaseFlag = 1;
        	} else {
        		$scope.selectedCheckSheet.releaseFlag = 0;
        	}

        	console.log($scope.selectedCheckSheet);


          if (!$scope.selectedCheckSheet.checksheetName) {
            $rootScope.showErrorMessage("チェック名を入力してください。");
            return "";
          }

          var ticketNum = ajaxService.getTicketNumByChecksheetId($rootScope.selectedChecksheetId);
          if (ticketNum !=0) {
        	  //TODO チケットが使用している場合、チェックバージョンをアップする
            $rootScope.showErrorMessage("該当チェックを使用されているため、編集、削除できません。");
            return "";
          }

          var modalInstance = $uibModal.open({
              animation : true,
              templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
              controller : 'confirmDialogCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  message : function() {
                      return {
                          message : "保存してもよろしいですか？"
                      };
                  }
              }
          });
          modalInstance.result.then(function() {
            var clcScope = $scope.$$childHead.$$nextSibling.$$nextSibling.$$nextSibling.$$childHead;

            ajaxService.modifyChecksheet($rootScope.selectedChecksheetId, $scope.selectedCheckSheet.frequency, '0', $scope.selectedCheckSheet.releaseFlag);
            if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                return "";
            }

            if (clcScope.removeIdList.length != 0) {
              ajaxService.removeChecklist(clcScope.removeIdList, '0');
              if (ajaxService.result['resultCd'] == "000000") {
                clcScope.removeIdList = new Array();
              }
            }

            for (var i=0; i<clcScope.todoList.length; i++) {
              var downloadF = "1";
                if (! $("#downloadFlg"+i).prop("checked")) {
                  downloadF = "0";
                }
                clcScope.todoList[i].downloadFlgStr = downloadF;
                clcScope.todoList[i].sort = i + 1;
            }

            ajaxService.modifyChecklist(clcScope.todoList);

            $rootScope.showInfoMessage("チェックを更新しました。");
            $scope.checksheetList = ajaxService.searchChecksheetList('0', "0");
            $scope.$$childTail.newTodoText = '';
          });

          return "";
        };

        $scope.showCopyChecksheet = function(item) {

          $scope.isCopy = true;

          $scope.ctrl = $scope;
            //初期化
  	      $scope.firstList = ajaxService.getProjectResourceList('0', '91', 0);
  	      $scope.firstList.unshift({label:" ", id:null})
  	      $scope.secondList = [{label:"マスタデータがありません", id:null}];
  	      $scope.thirdList = [{label:"マスタデータがありません", id:null}];
  	      $scope.fourthList = [{label:"マスタデータがありません", id:null}];

  	      $scope.first = $scope.firstList[0];
  	      $scope.second = $scope.secondList[0];
  	      $scope.third = $scope.thirdList[0];
  	      $scope.fourth = $scope.fourthList[0];

  	      $scope.firstDisable = false;
  	      $scope.secondDisable = true;
  	      $scope.thirdDisable = true;
  	      $scope.fourthDisable = true;

            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/project/newDefaultCheckSheet.html',
                scope : $scope,
                size: 'lg',
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                        };
                    }
                }
            });

          $scope.copyMoto = item;
          $scope.frequency = $scope.copyMoto.frequency;

          };

          $scope.copyCheckSheet = function() {

	    	  if (!$scope.fourth.id || $scope.fourth.id == 0 ) {
	              $rootScope.showErrorMessage("小項目までを選択してください。マスタデータがない場合、マスタデータを登録してからやり直してください。");
	              return;
              }

	          var checklistName = $scope.first.label + '⇒' + $scope.second.label + '⇒' + $scope.third.label + '⇒' + $scope.fourth.label;

              $scope.checksheetId = ajaxService.copyChecksheet($scope.copyMoto.checksheetId, $scope.fourth.id, checklistName, $scope.frequency, $scope.copyMoto.fourthId, '0');
              $scope.checksheetList = ajaxService.searchChecksheetList('0', "0");
              $rootScope.showInfoMessage("チェックをコピーしました。");
              $scope.$$childTail.$dismiss();

          };


          $scope.showChoiceMstData = function () {
          	if ($rootScope.projectId && $rootScope.projectId !='0') {
          		$rootScope.showErrorMessage("再度ログインしてから、やり直してください。");
                  return ;
          	}

          	$uibModal.open({
                  animation : true,
                  templateUrl : 'app/pages/project/defaultChoiceMasterData.html',
                  controller: 'Masterdata4CheckSheetCtrl',
                  scope : $scope,
                  size: 'lg',
                  backdrop : "static",
                  resolve : {
                      message : function() {
                          return {
                            type : ""
                          };
                      }
                  }
              });
          };

          /* Jiwon ： 異常値設定のモダール　 */
        $scope.openLimit = function (page, info) {
          $uibModal.open({
            animation: true,
            templateUrl: page,
            controller: 'LimitCtrl',
            backdrop : "static",
            scope : $scope,
            resolve: {
                checkdetailInfo: function () {
                    return {
                      title: info.title,
                      id : info.id,

                    };
              }
            }
          });
        };

             /* Jiwon  */
        $scope.openFileModal = function (page, info) {
          $uibModal.open({
            animation: true,
            templateUrl: page,
            controller: 'AddFileInDetailCtrl',
            backdrop : "static",
            scope : $scope,
            resolve: {
                openFlag : function() {
                        return {
                            'flag' : 'New',
                            'kbn' : 'Checksheet',
                            'id': $rootScope.selectedChecksheetId,
                            'detailId': info.id
                        };
                    }
            }
          });
        };

        $scope.versionUp = function() {
      	  //バージョンアップ：自身コピー
		  console.log($scope.selectedCheckSheet);
			  var modalInstance = $uibModal.open({
		        animation : true,
		        templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
		        controller : 'confirmDialogCtrl',
		        scope : $scope,
		        backdrop : "static",
		        resolve : {
		            message : function() {
		                return {
		                    message : "チェックのバージョンをアップしてもよろしですか？"
		                };
		            }
		        }
		    });

			  modalInstance.result.then(function() {
				$scope.checksheetId = ajaxService.copyChecksheet($scope.selectedCheckSheet.checksheetId, $scope.selectedCheckSheet.fourthId, $scope.selectedCheckSheet.checksheetName, $scope.selectedCheckSheet.frequency, $scope.selectedCheckSheet.fourthId, '0');
				$scope.checksheetList = ajaxService.searchChecksheetList('0', "0");
		      $scope.showChecklistDetail($scope.checksheetList[0]);


		      $scope.onReleaseClick(0);

		      $rootScope.showInfoMessage("チェックのバージョンをアップしました。");
			  });

	    };


	    //報告書設定
	    $scope.showDownloadInfo = function(checksheetId, checksheetName){


	    	  var chId = checksheetId;
	    	  var chName = checksheetName;

	    	  if (! chId) {
	    		  chId = $scope.selectedCheckSheet.checksheetId;
	    	  }
	    	  if (! chName) {
	    		  chName = $scope.selectedCheckSheet.checksheetName;
	    	  }

	    	  $uibModal.open({
	              animation : true,
	              templateUrl : 'app/pages/checklist/downloadSetting.html',
	              scope : $scope,
	              controller : 'DownloadSettingCtrl',
	              size: 'lg',
	              backdrop : "static",
	              resolve : {
	            	  checksheetInfo : function() {
	                      return {
	                        checksheetId : chId,
	                        checksheetName : chName,
	                      };
	                  }
	              }
	          });
	      };



        //公開非公開の判定
        $scope.onReleaseClick = function(e) {
            var remove_text = document.getElementById('release_button');
            if(remove_text == null) return false;
            remove_text.innerHTML = '';

            if (e==1){
            	var release_button = '<label class="radio-inline custom-radio nowrap">'
        			+'<input type="radio" name="releaseFlag" id="finalApproval01" value="1"  class="ng-pristine ng-untouched ng-valid ng-not-empty" form="release_flag" checked>'
        			+'<span>公開する</span>'
        			+'</label>'
        			+'<label class="radio-inline custom-radio nowrap">'
        			+'<input type="radio" name="releaseFlag" id="finalApproval11" value="0"  class="ng-pristine ng-untouched ng-valid ng-not-empty" form="release_flag">'
        			+'<span>公開しない</span>'
        			+'</label>';

            } else {
            	var release_button = '<label class="radio-inline custom-radio nowrap">'
        			+'<input type="radio" name="releaseFlag" id="finalApproval01" value="1"  class="ng-pristine ng-untouched ng-valid ng-not-empty" form="release_flag">'
        			+'<span>公開する</span>'
        			+'</label>'
        			+'<label class="radio-inline custom-radio nowrap">'
        			+'<input type="radio" name="releaseFlag" id="finalApproval11" value="0"  class="ng-pristine ng-untouched ng-valid ng-not-empty" form="release_flag" checked>'
        			+'<span>公開しない</span>'
        			+'</label>';
            }
            var element = document.getElementById('release_button');
        	element.insertAdjacentHTML('afterbegin', release_button);

            return false;
        }

    }
})();


/**
 * @author h.son created on 01.02.2018
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.user').controller('UserCtrl', UserCtrl)
      .directive('pwCheck', [ function() {
        return {
            require : 'ngModel',
            link : function(scope, elem, attrs, ctrl) {
                var firstPassword = '#' + attrs.pwCheck;
                elem.add(firstPassword).on('keyup', function() {
                    scope.$apply(function() {
                        var v = elem.val() === $(firstPassword).val();
                        ctrl.$setValidity('pwmatch', v);
                    });
                });
            }
        }
    } ]);

    /** @ngInject */
    function UserCtrl($scope, $filter, editableOptions, editableThemes, toastr, tr,
            toastrConfig, ajaxService, $state, $location, $window, $uibModal, $rootScope, Upload) {

    	if(! window.navigator.onLine){
    		//オフラインの場合、ダウンロードチケットへ遷移
    		window.location.href = "#/offline";
    		return;
    	}

      if (!ajaxService.tokenCheck()) {
            return;
          };

          $rootScope.isHome = false;
          $rootScope.isProject = false;


          if ($rootScope.projectId) {
        	  $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);
              $scope.userOrder = $scope.mngCommon.userOrder;

              if ($scope.userOrder == '1') {
            	  $scope.csvTitle = ["技術者ID",
                                     "パスワード",
                                     "技術者名",
                                     "権限",
                                     "所属グループ",
                                     "所属会社",
                                     "所属組織",
                                     "電話番号",
                                     "メールアドレス",
                                     "住所",
                                     "緯度",
                                     "経度",
                                     "アカウントロック",
                                     "最終ログイン日時",
                                     "操作区分(1:追加 2:変更 3:削除)"
                                     ];

                  $scope.csvColumn = ["userId",
                                      "",
                                      "userName",
                                      "mngFlagName",
                                      "groupName",
                                      "comName",
                                      "organization",
                                      "tel",
                                      "mailAdd",
                                      "address",
                                      "lat",
                                      "lng",
                                      "accountLockStr",
                                      "lastLoginTime"
                                      ];
              } else {
            	  $scope.csvTitle = ["技術者ID",
                                     "パスワード",
                                     "技術者名",
                                     "権限",
                                     "所属グループ",
                                     "所属会社",
                                     "所属組織",
                                     "電話番号",
                                     "メールアドレス",
                                     "住所",
                                     "アカウントロック",
                                     "最終ログイン日時",
                                     "操作区分(1:追加 2:変更 3:削除)"
                                     ];

                  $scope.csvColumn = ["userId",
                                      "",
                                      "userName",
                                      "mngFlagName",
                                      "groupName",
                                      "comName",
                                      "organization",
                                      "tel",
                                      "mailAdd",
                                      "address",
                                      "accountLockStr",
                                      "lastLoginTime"
                                      ];
              }
          }

      $scope.csvFileName = "技術者.csv";

      $scope.ctrl = $scope;
      $scope.smartTablePageSize = 20;

      $scope.showGroupDetail = false;
	  $scope.status01 = true;
      $scope.status02 = true;
  	  $scope.status03 = true;
      $scope.status04 = true;
      $scope.status05 = true;
      $scope.status99 = true;

      $scope.showDetailSetting = function () {
    	  if ($scope.showGroupDetail) {
    		  $scope.showGroupDetail = false;
    	  } else {
    		  $scope.showGroupDetail = true;
    	  }
      }

       $scope.getUserList = function() {
          $scope.userList = ajaxService.selectUserList($rootScope.projectId);
        };

        $scope.init = function () {
          if ($rootScope.projectId) {
            $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
          }
          $scope.getUserList();
        };

        $scope.init();

        $scope.showCreateGroup = function () {
            $scope.error = false;
            $scope.errCd = "";
            $scope.errMsg = "";
            $scope.pwerror = false;
            $scope.selectedUsers = {selected:[]};
            $scope.modalInstance = $uibModal.open({
                animation : true,
                templateUrl : "app/pages/user/group/newGroup.html",
                size : "md",
                scope : $scope,
                backdrop : "static",
                resolve : {
                }
            });
        };

        $scope.showUserCreate = function () {
          $scope.error = false;
            $scope.errCd = "";
            $scope.errMsg = "";
            $scope.pwerror = false;
            $scope.selectedGroups = {selected:[]};
            $scope.modalInstance = $uibModal.open({
                animation : true,
                templateUrl : "app/pages/user/newUser.html",
                size : "md",
                scope : $scope,
                backdrop : "static",
                resolve : {
                }
            });

            $scope.userName = "";
            $scope.rollList = [
                                  {label: '担当技術者', value: "0"},
                                  {label: '指示者', value: "1"},
                                  {label: '管理技術者', value: "2"}
                                ];
            $scope.companyList = ajaxService.searchCompanyList();
            $scope.companyList.unshift({fName:"----", id:0});
            $scope.companySelected = $scope.companyList[0];
            $scope.rollSelected = $scope.rollList[0];
        };



        $scope.saveNewGroup = function(form) {
            if (!form.$valid) {
                return "";
            }
            var groupName = $scope.$$childTail.$$childTail.groupName;

            var groupId = $scope.$$childTail.$$childTail.groupId;
            var address = $scope.$$childTail.$$childTail.address;
            var lat = $scope.$$childTail.$$childTail.lat;
            var lng = $scope.$$childTail.$$childTail.lng;

            var userId = [];
            var userList = [];
            for (var i =0; i< $scope.selectedUsers.selected.length; i++) {
            	if ($rootScope.listContains(userId, $scope.selectedUsers.selected[i].userId)){
	           		 continue;
	           	 }
              userId.push($scope.selectedUsers.selected[i].userId);
              userList.push($scope.selectedUsers.selected[i]);
            }

            var newGroupId = ajaxService.createGroup(groupName, groupId,address, lat, lng, userId, $rootScope.projectId);
            if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                return "";
            } else {
            	var statusList = [];
            	if (!$scope.status01) {
            		statusList.push('01');
            	}
            	if (!$scope.status02) {
            		statusList.push('02');
            	}
            	if (!$scope.status03) {
            		statusList.push('03');
            	}
            	if (!$scope.status04) {
            		statusList.push('04');
            	}
            	if (!$scope.status05) {
            		statusList.push('05');
            	}
            	if (!$scope.status99) {
            		statusList.push('99');
            	}
            	ajaxService.modifyStatusList(newGroupId, statusList);

            	if (ajaxService.result['resultCd'] != "000000") {
                    $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                    return "";
                } else {
                    $rootScope.showInfoMessage("登録しました。");
                    $scope.choiceGroupId = newGroupId;
                    $scope.currentGroup = {"groupId":"","groupName":""};
                    $scope.currentGroup.groupId = newGroupId;
                    $scope.currentGroup.groupName = groupName;
                    $scope.currentGroup.groupIdShow = groupId;
                    $scope.currentGroup.address = address;
                    $scope.currentGroup.lat = lat;
                    $scope.currentGroup.lng = lng;
                    $scope.selectedUsers = {selected:userList};
                    $scope.init();
                    $scope.$$childTail.$dismiss();
                }
            }
        };

        $scope.showModifyGroup = function(item) {
            $scope.showGroupDetail = false;
            $scope.error = false;
            $scope.errCd = "";
            $scope.errMsg = "";
            $scope.pwerror = false;
            $scope.currentGroup = {"groupId":"","groupName":""};
            $scope.currentGroup.groupId = item.groupId;
            $scope.currentGroup.groupName = item.groupName;
            $scope.currentGroup.groupIdShow = item.groupIdShow;
            $scope.currentGroup.address = item.address;
            $scope.currentGroup.lat = item.lat;
            $scope.currentGroup.lng = item.lng;
            $scope.selectedUsers = {selected:item.userList};


            var statusList = ajaxService.getStatusList($scope.currentGroup.groupId);
        	$scope.status01 = true;
            $scope.status02 = true;
        	$scope.status03 = true;
            $scope.status04 = true;
            $scope.status05 = true;
            $scope.status99 = true;
            if(statusList && statusList.length > 0){
            	for (var i=0;i<statusList.length;i++) {
            		if (statusList[i] == '01') {
                        $scope.status01 = false;
            		}
            		if (statusList[i] == '02') {
                        $scope.status02 = false;
            		}
            		if (statusList[i] == '03') {
                        $scope.status03 = false;
            		}
            		if (statusList[i] == '04') {
                        $scope.status04 = false;
            		}
            		if (statusList[i] == '05') {
                        $scope.status05 = false;
            		}
            		if (statusList[i] == '99') {
                        $scope.status99 = false;
            		}
            	}
            }

            $scope.modalInstance = $uibModal.open({
                animation : true,
                templateUrl : "app/pages/user/group/modifyGroup.html",
                size : "md",
                scope : $scope,
                backdrop : "static",
                resolve : {
                }
            });
        };

        $scope.modifyGroup = function(form) {
          if (!form.$valid) {
              return "";
          }
          var groupId = $scope.currentGroup.groupId;
          var groupName = $scope.currentGroup.groupName;
          var groupIdShow = $scope.currentGroup.groupIdShow;
          var address = $scope.currentGroup.address;
          var lat = $scope.currentGroup.lat;
          var lng = $scope.currentGroup.lng;
          var userIdlist = [];
          for (var i =0; i< $scope.selectedUsers.selected.length; i++) {
        	  if ($rootScope.listContains(userIdlist, $scope.selectedUsers.selected[i].userId)){
	           		 continue;
	           	 }
            userIdlist.push($scope.selectedUsers.selected[i].userId);
          }
          ajaxService.modifyGroup(groupId, groupName, groupIdShow, address, lat, lng, userIdlist, $rootScope.projectId);
          if (ajaxService.result['resultCd'] != "000000") {
              $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
              return "";
          } else {
        	var statusList = [];
          	if (!$scope.status01) {
          		statusList.push('01');
          	}
          	if (!$scope.status02) {
          		statusList.push('02');
          	}
          	if (!$scope.status03) {
          		statusList.push('03');
          	}
          	if (!$scope.status04) {
          		statusList.push('04');
          	}
          	if (!$scope.status05) {
          		statusList.push('05');
          	}
          	if (!$scope.status99) {
          		statusList.push('99');
          	}
          	ajaxService.modifyStatusList($scope.currentGroup.groupId, statusList);
          	if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                return "";
            } else {
            	$rootScope.showInfoMessage("編集しました。");
                $scope.init();
                $scope.$$childTail.$dismiss();
            }
          }
        };


        $scope.removeGroup = function(groupId) {
          var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "該当グループを削除してもよろしいですか？"
                        };
                    }
                }
            });

            modalInstance.result.then(function() {
              ajaxService.removeGroup(groupId);
              if (ajaxService.result['resultCd'] == "000000") {
                $rootScope.showInfoMessage("グループを削除しました。");
                $scope.init();
              }
            });
        };

        $scope.addUser = function(form) {
            if (!form.$valid) {
                return;
            }

            var password = $scope.$$childTail.password;
            var passwordConfirm = $scope.$$childTail.passwordConfirm;

            var passwordRule = ajaxService.getPasswordRule();
            $scope.pwdRuleLength = passwordRule.pwdRuleLength;
            $scope.pwdRuleUpper = passwordRule.pwdRuleUpper;
            $scope.pwdRuleLower = passwordRule.pwdRuleLower;
            $scope.pwdRuleNum = passwordRule.pwdRuleNum;
            $scope.pwdRuleSymbol = passwordRule.pwdRuleSymbol;
            var reg = /([a-zA-Z0-9!@#$%^&*()_?<>{}])/;

            var upper = /[A-Z]+/;
            var lower = /[a-z]+/;
            var num = /[0-9]+/;
            var symbol = /[!@#$%^&*()_?<>{}]+/;

            var err = false;

            if (password == "" || password == null) {
                err = true;
              $rootScope.showErrorMessage("パスワードを入力してください。");
            }
            if (passwordConfirm == "" || passwordConfirm == null) {
                err = true;
              $rootScope.showErrorMessage("パスワードの確認を入力してください。");
            }

            if (! err) {
              if(!reg.test(password) || !reg.test(passwordConfirm)){
                err = true;
                $rootScope.showErrorMessage("パスワードには半角英数字と記号のみ使用できます。");
              }
              if (password != passwordConfirm) {
                  err = true;
                $rootScope.showErrorMessage("パスワードとパスワードの確認が一致しません。");
              }
            }

            if (! err) {
              if ($scope.pwdRuleUpper == "true") {
                if (! upper.test(password)) {
                        err = true;
                  $rootScope.showErrorMessage("パスワードは少なくとも一つの大文字を含めてください。");
                }
              }
              if ($scope.pwdRuleLower == "true") {
                if (! lower.test(password)) {
                        err = true;
                  $rootScope.showErrorMessage("パスワードは少なくとも一つの小文字を含めてください。");
                }
              }
              if ($scope.pwdRuleNum == "true") {
                if (! num.test(password)) {
                        err = true;
                  $rootScope.showErrorMessage("パスワードは少なくとも一つの数字を含めてください。");
                }
              }
              if ($scope.pwdRuleSymbol == "true") {
                if (! symbol.test(password)) {
                        err = true;
                  $rootScope.showErrorMessage("パスワードは少なくとも一つの記号を含めてください。");
                }
              }
              if ($scope.pwdRuleLength != "" && $scope.pwdRuleLength != null) {
                  if (password.length < $scope.pwdRuleLength) {
                          err = true;
                    $rootScope.showErrorMessage("パスワードは"+ $scope.pwdRuleLength + "桁以上で入力してください。");
                  }
                }
            }

            if (err) {
                return;
            }

            var userId = $scope.$$childTail.userId;
            var userName = $scope.$$childTail.userName;
            var groupidlist = [];
            for (var i =0; i< $scope.selectedGroups.selected.length; i++) {
            	if ($rootScope.listContains(groupidlist, $scope.selectedGroups.selected[i].groupId)){
	           		 continue;
	           	 }
              groupidlist.push($scope.selectedGroups.selected[i].groupId);
            }
            var company = $scope.$$childTail.companySelected.id;
            var role = $scope.$$childTail.rollSelected.value;
            var orgName = $scope.$$childTail.orgName;
            var tel = $scope.$$childTail.tel;
            var email = $scope.$$childTail.email;
            var address = $scope.$$childTail.address;
            var lat = $scope.$$childTail.lat;
            var lng = $scope.$$childTail.lng;

            if ($rootScope.projectId) {
              ajaxService.createUser(userId,userName,password,company,orgName,tel,email,address,lat,lng, role,groupidlist,$rootScope.projectId);
              } else {
                ajaxService.createUser(userId,userName,password,company,orgName,tel,email,address,lat,lng, role,groupidlist,$scope.projectId);
              }

            if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                return "";
            } else {
              $rootScope.showInfoMessage("登録しました。");
              $scope.$$childTail.$dismiss();
              if ($rootScope.projectId) {
                $scope.init();
              } else {
                $scope.$parent.userList = ajaxService.searchUserList($scope.projectId, "0");
              }

            }
        };

        $scope.showUserDetail = function(user) {
          $uibModal.open({
            animation: true,
            templateUrl: "app/pages/user/userDetail.html",
            controller: 'UserCtrl',
            scope : $scope,
            backdrop : "static",
            resolve: {
                openFlag: function () {
                    return {};
              }
            }
          });
          $scope.userInfo = user;

          $scope.selectedGroups = {selected:user.groupList};

          $scope.companyList = ajaxService.searchCompanyList();
          $scope.companyList.unshift({fName:"----", id:0});

          $scope.rollList = [
                                {label: '担当技術者', value: "0"},
                                {label: '指示者', value: "1"},
                                {label: '管理技術者', value: "2"}
                              ];
          for (var i=0; i<$scope.companyList.length; i++) {
            if ($scope.companyList[i].id == $scope.userInfo.comId) {
              $scope.userInfo.companySelected = $scope.companyList[i];
              break;
            }
          }
          if (! $scope.userInfo.companySelected) {
        	  $scope.userInfo.companySelected = $scope.companyList[0];
          }

          for (var i=0; i<$scope.rollList.length; i++) {
            if ($scope.rollList[i].value == $scope.userInfo.mngFlag) {
              $scope.userInfo.rollSelected = $scope.rollList[i];
              break;
            }
          }

        };


        $scope.cancelUser = function() {
          $scope.$parent.init();
          $scope.$$childTail.$dismiss();
        };



        $scope.modifyUser = function(form) {
            var groupidlist = [];
            for (var i =0; i< $scope.selectedGroups.selected.length; i++) {
            	if ($rootScope.listContains(groupidlist, $scope.selectedGroups.selected[i].groupId)){
	           		 continue;
	           	 }
              groupidlist.push($scope.selectedGroups.selected[i].groupId);
            }

            var password = $scope.userInfo.password;
            var passwordConfirm = $scope.userInfo.passwordConfirm;
            if (password) {
              var passwordRule = ajaxService.getPasswordRule();
                $scope.pwdRuleLength = passwordRule.pwdRuleLength;
                $scope.pwdRuleUpper = passwordRule.pwdRuleUpper;
                $scope.pwdRuleLower = passwordRule.pwdRuleLower;
                $scope.pwdRuleNum = passwordRule.pwdRuleNum;
                $scope.pwdRuleSymbol = passwordRule.pwdRuleSymbol;
                var reg = /([a-zA-Z0-9!@#$%^&*()_?<>{}])/;

                var upper = /[A-Z]+/;
                var lower = /[a-z]+/;
                var num = /[0-9]+/;
                var symbol = /[!@#$%^&*()_?<>{}]+/;

                var err = false;

                if (! err) {
                  if(!reg.test(password) || !reg.test(passwordConfirm)){
                    err = true;
                    $rootScope.showErrorMessage("パスワードには半角英数字と記号のみ使用できます。");
                  }
                  if (password != passwordConfirm) {
                      err = true;
                    $rootScope.showErrorMessage("パスワードとパスワードの確認が一致しません。");
                  }
                }

                if (! err) {
                  if ($scope.pwdRuleUpper == "true") {
                    if (! upper.test(password)) {
                            err = true;
                      $rootScope.showErrorMessage("パスワードは少なくとも一つの大文字を含めてください。");
                    }
                  }
                  if ($scope.pwdRuleLower == "true") {
                    if (! lower.test(password)) {
                            err = true;
                      $rootScope.showErrorMessage("パスワードは少なくとも一つの小文字を含めてください。");
                    }
                  }
                  if ($scope.pwdRuleNum == "true") {
                    if (! num.test(password)) {
                            err = true;
                      $rootScope.showErrorMessage("パスワードは少なくとも一つの数字を含めてください。");
                    }
                  }
                  if ($scope.pwdRuleSymbol == "true") {
                    if (! symbol.test(password)) {
                            err = true;
                      $rootScope.showErrorMessage("パスワードは少なくとも一つの記号を含めてください。");
                    }
                  }
                  if ($scope.pwdRuleLength != "" && $scope.pwdRuleLength != null) {
                      if (password.length < $scope.pwdRuleLength) {
                              err = true;
                        $rootScope.showErrorMessage("パスワードは"+ $scope.pwdRuleLength + "桁以上で入力してください。");
                      }
                    }
                }

                if (err) {
                    return;
                }
            }

            var mngFlg = "0";

            if ($scope.userInfo.mngFlag == '3') {
            	mngFlg = "3";
            } else if ($scope.userInfo.mngFlag == '9') {
            	mngFlg = "9";
            } else {
            	mngFlg = $scope.userInfo.rollSelected.value;
            }

            ajaxService.modifyUser($scope.userInfo.userId,
                $scope.userInfo.userName,
                password,
                $scope.userInfo.companySelected.id,
                $scope.userInfo.organization,
                $scope.userInfo.tel,
                $scope.userInfo.mailAdd,
                $scope.userInfo.address,
                $scope.userInfo.lat,
                $scope.userInfo.lng,
                mngFlg,
                groupidlist,
                $scope.userInfo.accountLock,$rootScope.projectId);
            if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
                return "";
            } else {
              $rootScope.showInfoMessage("更新しました。");
              $scope.$$childTail.$dismiss();
              $scope.$parent.init();
            }

        };

        $scope.removeUser = function(userId, isDetail) {
          var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "該当技術者を削除してもよろしいですか？"
                        };
                    }
                }
            });

            modalInstance.result.then(function() {
              ajaxService.removeUser(userId);
              if (ajaxService.result['resultCd'] == "000000") {
                $rootScope.showInfoMessage("技術者を削除しました。");
                if (isDetail) {
                	$scope.$parent.init();
                    $scope.$dismiss();
                } else {
                $scope.init();
                }
              }
            });
        };

        $scope.modifyStatus = function() {

            $scope.status01 = true;
            $scope.status02 = true;
        	$scope.status03 = true;
            $scope.status04 = true;
            $scope.status05 = true;
            $scope.status99 = true;

            var statusList = ajaxService.getStatusList($scope.currentGroup.groupId);

            if(statusList){
            	for (var i=0;i<statusList.length;i++) {
            		if (statusList[i] == '01') {
                        $scope.status01 = false;
            		}
            		if (statusList[i] == '02') {
                        $scope.status02 = false;
            		}
            		if (statusList[i] == '03') {
                        $scope.status03 = false;
            		}
            		if (statusList[i] == '04') {
                        $scope.status04 = false;
            		}
            		if (statusList[i] == '05') {
                        $scope.status05 = false;
            		}
            		if (statusList[i] == '99') {
                        $scope.status99 = false;
            		}
            	}
            }

        	$uibModal.open({
                animation: true,
                templateUrl: "app/pages/user/group/groupStatus.html",
                scope : $scope,
                backdrop : "static",
                resolve: {
                    openFlag: function () {
                        return {};
                  }
                }
              });
        };


        $scope.saveGroupStatus = function() {
        	var statusList = [];
        	if (!$scope.status01) {
        		statusList.push('01');
        	}
        	if (!$scope.status02) {
        		statusList.push('02');
        	}
        	if (!$scope.status03) {
        		statusList.push('03');
        	}
        	if (!$scope.status04) {
        		statusList.push('04');
        	}
        	if (!$scope.status05) {
        		statusList.push('05');
        	}
        	if (!$scope.status99) {
        		statusList.push('99');
        	}

        	ajaxService.modifyStatusList($scope.currentGroup.groupId, statusList);

        	if (ajaxService.result['resultCd'] != "000000") {
                $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
            } else {
              $rootScope.showInfoMessage("保存しました。");
              $scope.$$childTail.$dismiss();
            }

        };


        $scope.uploadFiles = function(file) {
            var name = file.name;
            if (name.toLowerCase().indexOf(".csv") == -1) {
              $rootScope.showErrorMessage("csvファイルをアップロードしてください。");
              return;
            }
            var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "アップロードを実施してもよろしいですか？"
                        };
                    }
                }
            });


            modalInstance.result.then(function() {
            	if (file) {
                    Upload.upload({
                        url : urlPrefix + "user/uploadUser",
                        type : "POST",
                        headers : {
                            "authorization" : localStorage.authId,
                        },
                        dataType : "multipart/form-data",
                        data : {
                            'projectId': $rootScope.projectId, 'regionCode': localStorage.regionCode, "schema" : localStorage.schema, 'loginId':localStorage.userId, file : file
                        }
                    }).progress(function (evt) {
                        //progress
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        if (progressPercentage != 100) {
                          $rootScope.showInfoMessage("アップロード中：" + progressPercentage + "%");
                        }
                    }).then(function(response) {
                        var name = response.config.data.file.name;
                        if (response.data.resultCd == "000000") {
                            $scope.update = response.data.updateCount;
                            $scope.skipUpdate = response.data.skipUpdate;
                            if ($scope.update > 0) {
                              $scope.init();
                            }
                            // errorFile
                            if (response.data.skipUpdate > 0) {
                                 // データを用意する
                                var bom = new Uint8Array(
                                        [ 0xEF, 0xBB, 0xBF ]);
                                var content = "行番, エラーメッセージ";
                                content = content + "\n";
                                for (var i=0; i<response.data.skipUpdateInfo.length; i++) {
                                    content = content + response.data.skipUpdateInfo[i] + "\n";
                                }
                                var blob = new Blob([ bom, content ], {
                                    "type" : "text/csv"
                                });

                                // 出力
                                if ($window.navigator.msSaveBlob) {
                                    $window.navigator.msSaveBlob(blob, "アップロード結果.csv");
                                } else {
                                    var downloadLink = $('<a></a>');
                                    downloadLink.attr('href', $window.URL.createObjectURL(blob));
                                    downloadLink.attr('download', "アップロード結果.csv");
                                    downloadLink.attr('target', '_blank');
                                    $('body').append(downloadLink);
                                    downloadLink[0].click();
                                    downloadLink.remove();
                                }
                                $rootScope.showErrorMessage("エラーにより一部のデータが取り込まれていません。詳しくは出力した「アップロード結果.csv」ファイルを参照してください。");
                            } else {
                                $rootScope.showInfoMessage("アップロードが完了しました。");
                            }

                        } else {
                          $rootScope.showErrorMessage(tr.T(response.data.resultCd));
                        }
                    }, function(response) {
                        if (response.status > 0)
                          $rootScope.showErrorMessage(response.status + ': ' + response.data);
                    }, function(evt) {
                    });
                }
            });
        };


        $scope.downloadGroup = function() {


            if ($scope.userOrder == '1') {
            	var csvTitle = ["グループID",
     	                         "グループ名",
     	                         "含む技術者",
     	                         "住所",
     	                         "緯度",
     	                         "経度"
     	                         ];

     	      var csvColumn = ["groupIdShow",
     	                          "groupName",
     	                          "userName",
     	                          "address",
     	                          "lat",
     	                          "lng"
     	                          ];
            } else {
            	var csvTitle = ["グループID",
    	                         "グループ名",
    	                         "含む技術者"
    	                         ];

    	      var csvColumn = ["groupIdShow",
    	                          "groupName",
    	                          "userName"
    	                          ];
            }


  	      var csvFileName = "グループ.csv";


        	var start = new Date().getTime();
            // データを用意する
            var bom = new Uint8Array(
                    [ 0xEF, 0xBB, 0xBF ]);
            var content = new Array();
            for (var i = 0; i < csvTitle.length; i++) {
                content.push(csvTitle[i]);
                content.push(",");
            }
            content.pop();
            content.push("\n");

            for (var i = 0; i < $scope.groupList.length; i++) {
                for (var j = 0; j < csvColumn.length; j++) {
                    content.push($scope.groupList[i][csvColumn[j]]);
                    content.push(",");
                }
                content.pop();
                content.push("\n");
            }

            var contentStr = content.join('');
            var str_array = Encoding.stringToCode(contentStr);
            var sjis_array = Encoding.convert(str_array, "SJIS", "UNICODE");
            var uint8_array = new Uint8Array(sjis_array);

            var blob = new Blob([uint8_array], {
                "type" : "text/csv"
            });

            var fileName = csvFileName;
            // 出力
            if ($window.navigator.msSaveBlob) {
                // if browser is IE
                $window.navigator.msSaveBlob(blob,
                        fileName);
            } else {
            	var downloadLink = $('<a></a>');
                downloadLink.attr('href', $window.URL.createObjectURL(blob));
                downloadLink.attr('download', fileName);
                downloadLink.attr('target', '_blank');
                $('body').append(downloadLink);
                downloadLink[0].click();
                downloadLink.remove();
            }

        };



        $scope.uploadGroup = function(file) {
            var name = file.name;
            if (name.toLowerCase().indexOf(".csv") == -1) {
              $rootScope.showErrorMessage("csvファイルをアップロードしてください。");
              return;
            }

            var modalInstance = $uibModal.open({
                animation : true,
                templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
                controller : 'confirmDialogCtrl',
                scope : $scope,
                backdrop : "static",
                resolve : {
                    message : function() {
                        return {
                            message : "アップロードを実施してもよろしいですか？"
                        };
                    }
                }
            });

            modalInstance.result.then(function() {
            	if (file) {
                    Upload.upload({
                        url : urlPrefix + "user/uploadGroup",
                        type : "POST",
                        headers : {
                            "authorization" : localStorage.authId,
                        },
                        dataType : "multipart/form-data",
                        data : {
                            'projectId': $rootScope.projectId, "schema" : localStorage.schema, 'loginId':localStorage.userId, file : file
                        }
                    }).progress(function (evt) {
                        //progress
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        if (progressPercentage != 100) {
                          $rootScope.showInfoMessage("アップロード中：" + progressPercentage + "%");
                        }
                    }).then(function(response) {
                        var name = response.config.data.file.name;
                        if (response.data.resultCd == "000000") {
                            $scope.update = response.data.updateCount;
                            $scope.skipUpdate = response.data.skipUpdate;
                            if ($scope.update > 0) {
                              $scope.init();
                            }
                            // errorFile
                            if (response.data.skipUpdate > 0) {
                                 // データを用意する
                                var bom = new Uint8Array(
                                        [ 0xEF, 0xBB, 0xBF ]);
                                var content = "行番, エラーメッセージ";
                                content = content + "\n";
                                for (var i=0; i<response.data.skipUpdateInfo.length; i++) {
                                    content = content + response.data.skipUpdateInfo[i] + "\n";
                                }
                                var blob = new Blob([ bom, content ], {
                                    "type" : "text/csv"
                                });

                                // 出力
                                if ($window.navigator.msSaveBlob) {
                                    $window.navigator.msSaveBlob(blob, "アップロード結果.csv");
                                } else {
                                    var downloadLink = $('<a></a>');
                                    downloadLink.attr('href', $window.URL.createObjectURL(blob));
                                    downloadLink.attr('download', "アップロード結果.csv");
                                    downloadLink.attr('target', '_blank');
                                    $('body').append(downloadLink);
                                    downloadLink[0].click();
                                    downloadLink.remove();
                                }
                                $rootScope.showErrorMessage("エラーにより一部のデータが取り込まれていません。詳しくは出力した「アップロード結果.csv」ファイルを参照してください。");
                            } else {
                                $rootScope.showInfoMessage("アップロードが完了しました。");
                            }

                        } else {
                          $rootScope.showErrorMessage(tr.T(response.data.resultCd));
                        }
                    }, function(response) {
                        if (response.status > 0)
                          $rootScope.showErrorMessage(response.status + ': ' + response.data);
                    }, function(evt) {
                    });
                }
            });
        };


    }

})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('bookMarkLogoSelect', bookMarkLogoSelect);

  /** @ngInject */
  function bookMarkLogoSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getBookMarkLogo($scope.file);
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('headerLogoSelect', headerLogoSelect);

  /** @ngInject */
  function headerLogoSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getHeaderLogo($scope.file);
        })
      }
    }
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('loginLogoSelect', loginLogoSelect);

  /** @ngInject */
  function loginLogoSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getLoginLogo($scope.file);
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile($scope.file);
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function(templateUrl, $scope) {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: templateUrl,
                        size: 'sm',
                        scope : $scope,
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme').factory('tr', ['$translate', function($translate) {
        var T = {
            T:function(key) {
                if(key){
                    return $translate.instant(key);
                }
                return key;
            }
        }
        return T;
    }]);

})();
/**
 * @author h.son
 * created on 08.02.2018
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.checklist')
      .directive('checklistContent', checklistContent);

  /** @ngInject */
  function checklistContent() {
    return {
      restrict: 'EA',
      controller: 'ChecklistContentCtrl',
      templateUrl: 'app/pages/checklist/checklistContent/checklistContent.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.checklist')
      .controller('ChecklistContentCtrl', ChecklistContentCtrl);

  /** @ngInject */
  function ChecklistContentCtrl($scope, baConfig, $timeout, $rootScope, ajaxService) {
    if (!ajaxService.tokenCheck()) {
          return;
        };

    $scope.init = function () {
    	$scope.transparent = true;

        $scope.addedChecklistId =[];

        $scope.removeIdList = [];

        $scope.sortableOptions = {
          disabled: false,

          stop: function(e, ui) {
              //do nothing
          }
        };

        $scope.newTodoText = '';
    };

    $scope.init();


    $scope.getCheckList = function () {
      $scope.todoList = ajaxService.searchChecklistList($rootScope.selectedChecksheetId);
    }


    $scope.addToDoItem = function () {

    	if (!$scope.todoList) {
    		$scope.todoList = ajaxService.searchChecklistList($rootScope.selectedChecksheetId);
    	}

        if (! $scope.newTodoText) {
          $rootScope.showErrorMessage("チェック項目名を入力してください。");
          return ;
        }

    	var ticketNum = ajaxService.getTicketNumByChecksheetId($rootScope.selectedChecksheetId);
        if (ticketNum !=0) {
          $rootScope.showErrorMessage("チェックバージョンをアップしてからやり直してください。");
          return ;
        }

      var sort = $scope.todoList.length+1
      var newChecklistId = ajaxService.createChecklist($rootScope.selectedChecksheetId, $scope.newTodoText, sort);
      $scope.addedChecklistId.push(newChecklistId);

      $scope.todoList.push({
          checklistId:newChecklistId,
          checklistName: $scope.newTodoText,
          downloadFlg:true,
          sort:sort,
        });

      $scope.newTodoText = '';
    };


    $scope.showDetail = function (info) {
      if ($rootScope.projectId) {
    	  $scope.$parent.openDetail("app/pages/checklist/checklistDetail/checklistDetail.html", info);
      } else {
    	  $scope.$parent.$parent.openDetail("app/pages/checklist/checklistDetail/checklistDetail.html", info);
      }

    };



    $scope.removeChecklist = function (index, checklistId) {
    	var ticketNum = ajaxService.getTicketNumByChecksheetId($rootScope.selectedChecksheetId);
        if (ticketNum !=0) {
          $rootScope.showErrorMessage("チェックバージョンをアップしてからやり直してください。");
          return ;
        }
      $scope.todoList.splice(index, 1);
      if (checklistId) {
        $scope.removeIdList.push(checklistId);
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.checklist')
      .controller('DetailCtrl', DetailCtrl);

  /** @ngInject */
  function DetailCtrl($scope, $rootScope, baConfig, $timeout, ajaxService, $uibModal, checklistInfo) {

    if (!ajaxService.tokenCheck()) {
          return;
        };

    $scope.projectId = "0";
	if ($rootScope.projectId) {
    	$scope.projectId = $rootScope.projectId;
	}

    $scope.checklistId =checklistInfo.checklistId;
    $scope.checklistName =checklistInfo.checklistName;
    $scope.checklistContent =checklistInfo.checklistContent;

    $scope.removeIdList = new Array();

    $scope.loadResource = function () {
      if (! $rootScope.inputTypeItems) {
        $rootScope.inputTypeItems = ajaxService.searchResource("INPUT_TYPE");
      }
      var defaultResource = [{label: '----', value: 0}];
      var userResource = ajaxService.searchUserResource($scope.projectId, 1);
      $scope.chioseItemMaster = defaultResource.concat(userResource);
    };

    $scope.loadResource();

    $scope.showCreateUserReource = function () {

      var mdCtrl = 'MasterdataCtrl';
      if ($scope.projectId == "0") {
    	  mdCtrl = 'Masterdata4CheckSheetCtrl';
      }

      var modalInstance = $uibModal.open({
        animation: true,
        controller: mdCtrl,
        templateUrl: "app/pages/masterdata/checkResultDetailMaster.html",
        scope : $scope,
        backdrop : "static",
        resolve: {
            openFlag: function () {
                return {};
          }
        }
      });
      modalInstance.result.then(function() {
        $scope.loadResource();
        $scope.createInputTypeConf();
      });
    };

    $scope.checkDetailList = ajaxService.searchCheckDetailList($scope.checklistId);

    $scope.createInputTypeConf = function () {

        $scope.showLimitCol = false;
        $scope.inputTypeConf = [];
        $scope.itemMasterConf = [];

        for (var i = 0; i < $scope.checkDetailList.length; i++) {
        	for (var j=0;j<$rootScope.inputTypeItems.length;j++) {
        		if ($scope.checkDetailList[i].inputType == $rootScope.inputTypeItems[j].value) {
        			$scope.inputTypeConf.push($rootScope.inputTypeItems[j]);
            }
            if (!$scope.showLimitCol && $scope.checkDetailList[i].inputType == 12) {
              $scope.showLimitCol = true;
            }
        	}
//          $scope.inputTypeConf.push($rootScope.inputTypeItems[$scope.checkDetailList[i].inputType - 1]);
          $scope.itemMasterConf.push($scope.selectItemMaster($scope.checkDetailList[i].itemMaster));
        }
      };

      $scope.selectItemMaster = function (value) {
        for (var j = 0; j < $scope.chioseItemMaster.length; j++) {
          if ($scope.chioseItemMaster[j].value == value) {
            return $scope.chioseItemMaster[j];
          }
        }
      }

    $scope.inputTypeConf = [];
    $scope.itemMasterConf = [];
    $scope.createInputTypeConf();

    $scope.transparent = false;


    $scope.sortableOptions = {
      update: function(e, ui) {
      },

      stop: function(e, ui) {
          //do nothing
          $scope.createInputTypeConf();
      }
    };



    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if(! $scope.newTodoText){
        $rootScope.showErrorMessage("チェック詳細項目名を入力してください。");
        return;
      }
      var ticketNum = ajaxService.getTicketNumByChecksheetId($rootScope.selectedChecksheetId);
      if (ticketNum !=0) {
        $rootScope.showErrorMessage("チェックバージョンをアップしてからやり直してください。");
        return;
      }
      if (clickPlus || event.which === 13) {
          var detailBeanList =[];
          var detailOb = {no:$scope.checkDetailList.length+1, id:0, title:$scope.newTodoText, content:"", inputType:6, itemMaster:0, mustFlgStr:"1" };
          detailBeanList.push(detailOb);
          ajaxService.saveCheckDetail($scope.checklistId, detailBeanList, $scope.projectId);
          var checkDetailList = ajaxService.searchCheckDetailList($scope.checklistId);
          if (checkDetailList.length > 0) {
        	  $scope.checkDetailList.push(checkDetailList[checkDetailList.length-1]);
          }
      }
      $scope.newTodoText = '';
      $scope.createInputTypeConf();
    };


    $scope.inputTypeConfChange = function (index) {
      $scope.checkDetailList[index].inputType = $scope.inputTypeConf[index].value;
      if ( $scope.inputTypeConf[index].value != 3 && $scope.inputTypeConf[index].value != 4 && $scope.inputTypeConf[index].value != 5) {
        $scope.checkDetailList[index].itemMaster = 0;
        $scope.itemMasterConf[index] = $scope.chioseItemMaster[0];
      }

      $scope.showLimitCol = false;
      for (var i = 0; i < $scope.checkDetailList.length; i++) {
        if (!$scope.showLimitCol && $scope.checkDetailList[i].inputType == 12) {
          $scope.showLimitCol = true;
        }
      }
    };

    $scope.itemMasterConfChange = function (index) {
      $scope.checkDetailList[index].itemMaster = $scope.itemMasterConf[index].value;
    };

    $scope.removeDetail = function (index, id) {
       var ticketNum = ajaxService.getTicketNumByChecksheetId($rootScope.selectedChecksheetId);
       if (ticketNum !=0) {
          $rootScope.showErrorMessage("チェックバージョンをアップしてからやり直してください。");
          return "";
        }

      $scope.checkDetailList.splice(index, 1);
      if (id) {
        $scope.removeIdList.push(id);
      }
      $scope.createInputTypeConf();
    };


    $scope.saveCheckDetail = function () {

      var ticketNum = ajaxService.getTicketNumByChecksheetId($rootScope.selectedChecksheetId);
      if (ticketNum !=0) {
        $rootScope.showErrorMessage("チェックバージョンをアップしてからやり直してください。");
        return true;
      }

      var cdl = $scope.checkDetailList.length;

      //入力チェック
      for (var i=0; i<cdl; i++) {
        if (!$("#title"+i).val()){
          $rootScope.showErrorMessage("チェック詳細項目名を入力してください。");
          return true;
        }
        var inputTy = $scope.getInputTypeValue($("#inputType"+i).val());
        var inputIm = 0;
        if (inputTy == 3 || inputTy == 4 || inputTy == 5) {
          inputIm = $scope.getItemMastValue($("#itemMast"+i).val());
          if (inputIm == 0) {
            $rootScope.showErrorMessage("入力方式がセレクトボックス、ラジオボタン、チェックボックスの場合、選択値を選択してください。");
            return true;
          }
        }
      }

      if ($scope.removeIdList.length != 0) {
          ajaxService.removeCheckDetail($scope.removeIdList, $scope.projectId);
          if (ajaxService.result['resultCd'] == "000000") {
            $scope.removeIdList = new Array();
          }
        }

        var detailBeanList =[];
        for (var i=0; i<cdl; i++) {
          var inputTy = $scope.getInputTypeValue($("#inputType"+i).val());
          var inputIm = 0;
          if (inputTy == 3 || inputTy == 4 || inputTy == 5) {
            inputIm = $scope.getItemMastValue($("#itemMast"+i).val());
          }
          var mustF = "0";
          if ($("#mustFlg"+i).prop("checked")) {
            mustF = "1";
          }
          var detailOb = {no:i+1, id:$scope.checkDetailList[i].id, title:$("#title"+i).val(), content:$("#content"+i).val(), unit:$("#unit"+i).val(), inputType:inputTy, itemMaster:inputIm, mustFlgStr:mustF };
          detailBeanList.push(detailOb);
        }
        ajaxService.saveCheckDetail($scope.checklistId, detailBeanList, $scope.projectId);
        if (ajaxService.result['resultCd'] == "000000") {
          $scope.checkDetailList = ajaxService.searchCheckDetailList($scope.checklistId);
          $rootScope.showInfoMessage("保存しました。");
          $scope.$$childTail.$parent.$dismiss();
          return true;
        }

    };

    $scope.getInputTypeValue = function (hashkey) {
      for (var i =0; i<$rootScope.inputTypeItems.length; i++) {
        var a = JSON.stringify($rootScope.inputTypeItems[i]);
        if (a.indexOf(hashkey) != -1) {
          return $rootScope.inputTypeItems[i].value
        }
      }
    };

    $scope.getItemMastValue = function (hashkey) {
        for (var i =0; i<$scope.chioseItemMaster.length; i++) {
          var a = JSON.stringify($scope.chioseItemMaster[i]);
          if (a.indexOf(hashkey) != -1) {
            return $scope.chioseItemMaster[i].value
          }
        }
      };

    $scope.showLimit = function (info) {
      $scope.$parent.openLimit("app/pages/checklist/checklistLimit/checklistLimit.html", info);

    };


    $scope.showAddFileInDetail = function (info) {
      $scope.$parent.openFileModal("app/pages/checklist/checklistFile/addFileInDetail.html", info);
      console.log(info);
    };
  }
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.pages.checklist')
      .controller('AddFileInDetailCtrl', AddFileInDetailCtrl);

    /** @ngInject */
    function AddFileInDetailCtrl($scope, $rootScope, $state, $uibModal, Upload, openFlag, $timeout, ajaxService, tr) {
      if (!ajaxService.tokenCheck()) {
        return;
      };

      $scope.projectId = "0";
  	  if ($rootScope.projectId) {
      	$scope.projectId = $rootScope.projectId;
  	  }


      $scope.detailId = openFlag.detailId;
      $scope.flag = openFlag.flag;

      $scope.readonly = false;

      if ($scope.flag == 'Show') {
          $scope.readonly = true;
      }


      $scope.searchFileList = function (detailId) {
        //detailID⇒関連ファイル一覧を取得する
        $scope.fileList = ajaxService.getFileDetailList(detailId);
      };


      $scope.searchFileList($scope.detailId) ;

      $scope.openUploadDialogInDetail = function() { //確認　関連ファイルでアップロードボタン押下する時
          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/checklist/fileUploadModal.html',
              controller : 'FileUploadCtrl',
              scope : $scope,
              backdrop : "static",
              resolve : {
                  openFlag : function() {
                      return {
                          'flag' : 'New',
                          'kbn' : 'Checkdetail',
                          'id': $scope.detailId
                      };
                  }
              }
          });
      };


        $scope.delDetailFile = function (fileBean) {
        var modalInstance = $uibModal.open({
            animation : true,
            templateUrl : 'app/theme/components/commonDialog/ConfirmDialogWithYesNo.html',
            controller : 'confirmDialogCtrl',
            scope : $scope,
            backdrop : "static",
            resolve : {
                message : function() {
                    return {
                        message : "該当ファイルを削除してもよろしいですか？"
                    };
                }
            }
        });

        modalInstance.result.then(function() {
          ajaxService.removeDetailFile($scope.projectId, $scope.detailId, fileBean.id, fileBean.fileExternal);
          if (ajaxService.result['resultCd'] != "000000") {
            $rootScope.showErrorMessage(tr.T(ajaxService.result['resultCd']));
          } else {
            $rootScope.showInfoMessage("該当ファイルを削除しました。");
            $scope.searchFileList($scope.detailId);
          }
        });

      };

    }
}) ();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.checklist')
      .controller('LimitCtrl', LimitCtrl);

  /** @ngInject */
  function LimitCtrl($scope, $rootScope, baConfig, $timeout, ajaxService, $uibModal, checkdetailInfo) {

    if (!ajaxService.tokenCheck()) {
          return;
    };

    //画面上の初期値設定
    $scope.conditionList= [
                        {label :"＜（未満）", value: 1},
                        {label :"＞（超え）", value: 2},
                        {label :"≦（以下）", value: 3},
                        {label :"≧（以上）", value: 4},

    ];
    $scope.condition = $scope.conditionList[0]; //モダールが立ち上げた時、初期値を設定
    $scope.condition2 = $scope.conditionList[0];
    $scope.numberValue = null;
    $scope.numberValue2 = null;

    //条件２のlogicはラジオボタン
    $scope.logicRadio = 1;

    $scope.detailName = checkdetailInfo.title;
    $scope.detailId = checkdetailInfo.id;

    //二番目の条件が画面上で動く時のフラグ
    $scope.isTwoConditon = false;

    //listの検索
    $scope.checkLimitList = ajaxService.searchCheckLimitList($scope.detailId);

   /*  {id: 43, checkdetailId: 98, logic: 1, condition: 1, value: "-1"} */
   if ($scope.checkLimitList.length == 0) {
     //条件なし、（新規）

   } else if ($scope.checkLimitList.length == 1) {
     //条件が1個
     for (var i = 0; i<$scope.conditionList.length; i++) {
       if ($scope.checkLimitList[0].condition == $scope.conditionList[i].value ){
         $scope.condition = $scope.conditionList[i];
       }
     }

     $scope.numberValue = parseFloat($scope.checkLimitList[0].value); //こちらでのvalueはカラム名
     //valueはvarcharタイプだからparseする

   } else if ($scope.checkLimitList.length == 2) {
     //条件2個
     $scope.isTwoConditon = true;

     for (var i = 0; i<$scope.conditionList.length; i++) {
       if ($scope.checkLimitList[0].condition == $scope.conditionList[i].value ){
         $scope.condition = $scope.conditionList[i];
       }
       if ($scope.checkLimitList[1].condition == $scope.conditionList[i].value ){
         $scope.condition2 = $scope.conditionList[i];
       }
     }

     $scope.numberValue = parseFloat($scope.checkLimitList[0].value);
     $scope.numberValue2 = parseFloat($scope.checkLimitList[1].value);

     $scope.logicRadio = $scope.checkLimitList[1].logic;

   }



    //追加ボタンを押下するともう一つの行が発生できるために
    $scope.addDetail = function () {
      $scope.isTwoConditon = true;
    }


    //なかみをクリア
    $scope.removeLimit = function(){
      if($scope.isTwoConditon){
        $scope.condition = $scope.condition2;
        $scope.numberValue = $scope.numberValue2;

        //条件２の行は閉じる, 初期化
        $scope.condition2 = $scope.conditionList[0];
        $scope.numberValue2 = null;
        $scope.logicRadio = 1;
        $scope.isTwoConditon=false;

      }else {
        $scope.condition = $scope.conditionList[0];
        $scope.numberValue = null;
      }

    }

    $scope.removeLimit2 = function(){
        $scope.condition2 = $scope.conditionList[0];
        $scope.numberValue2 = null;
        $scope.logicRadio = 1;
        $scope.isTwoConditon=false;
    }




    //function - insertDB
    $scope.saveCheckLimit = function () {

      //ticket check
      var ticketNum = ajaxService.getTicketNumByChecksheetId($rootScope.selectedChecksheetId);
      if (ticketNum !=0) {
        $rootScope.showErrorMessage("チェックバージョンをアップしてからやり直してください。");
        return true;
      }

      //値チェック
      if($scope.isTwoConditon){ //条件２までの行がある時のチェック
       if ($scope.numberValue2 == null || $scope.numberValue == null) {
          $rootScope.showErrorMessage("条件の値を入力してください");
          return true;
         }
       }else if($scope.numberValue == null){　//条件1の時のチェック
          $rootScope.showErrorMessage("条件の値を入力してください");
          return true;
       }

       if($scope.numberValue == $scope.numberValue2){
       $rootScope.showErrorMessage("同じ値が入力しています");
          return true;
       }



      var limitBeanList =[];
      //Limitの場合は二つのobjectが最大
        var checklimitBean = new Object();
        checklimitBean.logic = "1"; //条件１は必ずAND
        checklimitBean.condition = $scope.condition.value;
        checklimitBean.value = $scope.numberValue;
        checklimitBean.checkdetailId = $scope.detailId;
        limitBeanList.push(checklimitBean);

        var checklimitBeanSecond = new Object();
        checklimitBeanSecond.logic = $scope.logicRadio; //条件２は選択
        checklimitBeanSecond.condition = $scope.condition2.value;
        checklimitBeanSecond.value = $scope.numberValue2;
        checklimitBean.checkdetailId = $scope.detailId;

        if( $scope.isTwoConditon){
          limitBeanList.push(checklimitBeanSecond);
        }

        ajaxService.saveCheckLimit($scope.detailId, limitBeanList); //checkDetailListid,
             if (ajaxService.result['resultCd'] == "000000") {
              $rootScope.showInfoMessage("保存しました。");
              $scope.$$childTail.$parent.$dismiss();
              return true;
            }
  }
}
})();














/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .directive('commentShow', commentShow);

  /** @ngInject */
  function commentShow() {
    return {
      restrict: 'E',
      controller: 'CommentShowCtrl',
      templateUrl: 'app/pages/home/commentShow/commentShow.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .controller('CommentShowCtrl', CommentShowCtrl);

  /** @ngInject */
  function CommentShowCtrl($scope, ajaxService, $rootScope) {
	  
	  
	  
	  $scope.commentMsgList = ajaxService.getCommentMsgList()
	  
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      },{
          type: 'text-message',
          author: 'Kostya',
          surname: 'Danovsky',
          header: 'Posted new message',
          text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
          time: 'Today 11:55 pm',
          ago: '25 minutes ago',
          expanded: false,
        },{
            type: 'text-message',
            author: 'Kostya',
            surname: 'Danovsky',
            header: 'Posted new message',
            text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
            time: 'Today 11:55 pm',
            ago: '25 minutes ago',
            expanded: false,
          },{
              type: 'text-message',
              author: 'Kostya',
              surname: 'Danovsky',
              header: 'Posted new message',
              text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
              time: 'Today 11:55 pm',
              ago: '25 minutes ago',
              expanded: false,
            },{
                type: 'text-message',
                author: 'Kostya',
                surname: 'Danovsky',
                header: 'Posted new message',
                text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                time: 'Today 11:55 pm',
                ago: '25 minutes ago',
                expanded: false,
              },{
                  type: 'text-message',
                  author: 'Kostya',
                  surname: 'Danovsky',
                  header: 'Posted new message',
                  text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                  time: 'Today 11:55 pm',
                  ago: '25 minutes ago',
                  expanded: false,
                },{
                    type: 'text-message',
                    author: 'Kostya',
                    surname: 'Danovsky',
                    header: 'Posted new message',
                    text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                    time: 'Today 11:55 pm',
                    ago: '25 minutes ago',
                    expanded: false,
                  },{
                      type: 'text-message',
                      author: 'Kostya',
                      surname: 'Danovsky',
                      header: 'Posted new message',
                      text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                      time: 'Today 11:55 pm',
                      ago: '25 minutes ago',
                      expanded: false,
                    },{
                        type: 'text-message',
                        author: 'Kostya',
                        surname: 'Danovsky',
                        header: 'Posted new message',
                        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                        time: 'Today 11:55 pm',
                        ago: '25 minutes ago',
                        expanded: false,
                      },{
                          type: 'text-message',
                          author: 'Kostya',
                          surname: 'Danovsky',
                          header: 'Posted new message',
                          text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                          time: 'Today 11:55 pm',
                          ago: '25 minutes ago',
                          expanded: false,
                        },{
                            type: 'text-message',
                            author: 'Kostya',
                            surname: 'Danovsky',
                            header: 'Posted new message',
                            text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                            time: 'Today 11:55 pm',
                            ago: '25 minutes ago',
                            expanded: false,
                          },{
                              type: 'text-message',
                              author: 'Kostya',
                              surname: 'Danovsky',
                              header: 'Posted new message',
                              text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                              time: 'Today 11:55 pm',
                              ago: '25 minutes ago',
                              expanded: false,
                            },{
                                type: 'text-message',
                                author: 'Kostya',
                                surname: 'Danovsky',
                                header: 'Posted new message',
                                text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                                time: 'Today 11:55 pm',
                                ago: '25 minutes ago',
                                expanded: false,
                              },{
                                  type: 'text-message',
                                  author: 'Kostya',
                                  surname: 'Danovsky',
                                  header: 'Posted new message',
                                  text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                                  time: 'Today 11:55 pm',
                                  ago: '25 minutes ago',
                                  expanded: false,
                                },{
                                    type: 'text-message',
                                    author: 'Kostya',
                                    surname: 'Danovsky',
                                    header: 'Posted new message',
                                    text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                                    time: 'Today 11:55 pm',
                                    ago: '25 minutes ago',
                                    expanded: false,
                                  },{
                                      type: 'text-message',
                                      author: 'Kostya',
                                      surname: 'Danovsky',
                                      header: 'Posted new message',
                                      text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                                      time: 'Today 11:55 pm',
                                      ago: '25 minutes ago',
                                      expanded: false,
                                    },{
                                        type: 'text-message',
                                        author: 'Kostya',
                                        surname: 'Danovsky',
                                        header: 'Posted new message',
                                        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                                        time: 'Today 11:55 pm',
                                        ago: '25 minutes ago',
                                        expanded: false,
                                      },{
                                          type: 'text-message',
                                          author: 'Kostya',
                                          surname: 'Danovsky',
                                          header: 'Posted new message',
                                          text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                                          time: 'Today 11:55 pm',
                                          ago: '25 minutes ago',
                                          expanded: false,
                                        },{
                                            type: 'text-message',
                                            author: 'Kostya',
                                            surname: 'Danovsky',
                                            header: 'Posted new message',
                                            text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                                            time: 'Today 11:55 pm',
                                            ago: '25 minutes ago',
                                            expanded: false,
                                          },{
                                              type: 'text-message',
                                              author: 'Kostya',
                                              surname: 'Danovsky',
                                              header: 'Posted new message',
                                              text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                                              time: 'Today 11:55 pm',
                                              ago: '25 minutes ago',
                                              expanded: false,
                                            },{
                                                type: 'text-message',
                                                author: 'Kostya',
                                                surname: 'Danovsky',
                                                header: 'Posted new message',
                                                text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                                                time: 'Today 11:55 pm',
                                                ago: '25 minutes ago',
                                                expanded: false,
                                              },{
                                                  type: 'text-message',
                                                  author: 'Kostya',
                                                  surname: 'Danovsky',
                                                  header: 'Posted new message',
                                                  text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                                                  time: 'Today 11:55 pm',
                                                  ago: '25 minutes ago',
                                                  expanded: false,
                                                },{
                                                    type: 'text-message',
                                                    author: 'Kostya',
                                                    surname: 'Danovsky',
                                                    header: 'Posted new message',
                                                    text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                                                    time: 'Today 11:55 pm',
                                                    ago: '25 minutes ago',
                                                    expanded: false,
                                                  },{
                                                      type: 'text-message',
                                                      author: 'Kostya',
                                                      surname: 'Danovsky',
                                                      header: 'Posted new message',
                                                      text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
                                                      time: 'Today 11:55 pm',
                                                      ago: '25 minutes ago',
                                                      expanded: false,
                                                    }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {

		var ua = navigator.userAgent.toLowerCase();
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var page = 'app/pages/home/trafficChart/trafficChart.html';
    if (isMobile) {
    	if (ua.indexOf('mobile') == -1 || ua.indexOf('ipad') > 0 ){
    		if (window.localStorage.tabletMode == '1') {
    			isMobile = false;
    		}
    	}
    }
      if(isMobile) {
        page = 'app/pages/home/trafficChart/trafficChartSp.html';
      }
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: page
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper, ajaxService, $rootScope) {
      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;

  	var ua = navigator.userAgent.toLowerCase();
      var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
      if (isMobile) {
      	if (ua.indexOf('mobile') == -1 || ua.indexOf('ipad')  > 0){
      		if (window.localStorage.tabletMode == '1') {
      			isMobile = false;
      		}
      	}
      }

      $scope.ctrl = $scope;

      $scope.totalNum = 0;

      $scope.mngKbn = localStorage.mngKbn;

      $scope.adminMng = $scope.$$nextSibling.$$prevSibling.$$nextSibling.$parent.$parent.mngCommon.adminMng;

      $scope.defaultEndDateFrom = $scope.$$nextSibling.$$prevSibling.$$nextSibling.$parent.$parent.mngCommon.defaultEndDateFrom;
      $scope.defaultEndDateTo = $scope.$$nextSibling.$$prevSibling.$$nextSibling.$parent.$parent.mngCommon.defaultEndDateTo;

      if (! $scope.defaultEndDateFrom) {
    	  $scope.defaultEndDateFrom = "1";
      }
      if (! $scope.defaultEndDateTo) {
    	  $scope.defaultEndDateTo = "0";
      }

      $scope.userList = ajaxService.selectUserList($rootScope.projectId);
      $scope.userList.unshift({userName:" ", userId:''});

      for (var i=0; i<$scope.userList.length; i++) {
          if (localStorage.userId == $scope.userList[i].userId) {
            $scope.loginUser = $scope.userList[i];
            break;
          }
        }

      var groupIdList = [];
      if (localStorage.mngKbn != '2') {
   	   for (var j=0; j<$scope.loginUser.groupList.length; j++) {
	         groupIdList.push($scope.loginUser.groupList[j].groupId);
	       }
      } else {
   	   var groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
   	   for (var j=0; j<groupList.length; j++) {
 	         groupIdList.push(groupList[j].groupId);
 	       }
      }

      if ($scope.adminMng != '1') {
    	  if (localStorage.mngKbn != '0') {
              $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
            } else {
            	$scope.groupList = angular.copy($scope.loginUser.groupList);
                //指示者、作業者は自分所属しているグループ内のユーザのみが見れる。
                if (groupIdList.length == 0) {
              	  $scope.userList = [];
              	  $scope.userList.push($scope.loginUser);
                } else {
                    $scope.userList = ajaxService.getListByGroupIdList(groupIdList);
                }
                $scope.userList.unshift({userName:" ", userId:''});
            }
      } else {
    	  if (localStorage.mngKbn == '2') {
              $scope.groupList = ajaxService.selectGroupUserResourceList($rootScope.projectId);
            } else {
              $scope.groupList = angular.copy($scope.loginUser.groupList);
              //指示者、作業者は自分所属しているグループ内のユーザのみが見れる。
              if (groupIdList.length == 0) {
            	  $scope.userList = [];
            	  $scope.userList.push($scope.loginUser);
              } else {
                  $scope.userList = ajaxService.getListByGroupIdList(groupIdList);
              }
              $scope.userList.unshift({userName:" ", userId:''});
            }
      }


      $scope.groupList.unshift({groupName:" ", groupId:0});
      $scope.responseGroup = $scope.groupList[0];
      $scope.responseUser = $scope.userList[0];

      var t=new Date();
      var iToDay=t.getDate();
      var iToMon=t.getMonth();
      var iToYear=t.getFullYear();
      var newDayFrom1 = new Date(iToYear,iToMon-1,iToDay-1);
      var newDayFrom2 = new Date(iToYear,iToMon-2,iToDay-1);
      var newDayFrom3 = new Date(iToYear,iToMon-3,iToDay-1);

      var newDayTo1 = new Date(iToYear,iToMon+1,iToDay);
      var newDayTo2 = new Date(iToYear,iToMon+2,iToDay);
      var newDayTo3 = new Date(iToYear,iToMon+3,iToDay);

      if ($scope.defaultEndDateFrom == "0") {
          $scope.eScheduledDateS = t;
      } else if ($scope.defaultEndDateFrom == "1") {
          $scope.eScheduledDateS = newDayFrom1;
      } else if ($scope.defaultEndDateFrom == "2") {
          $scope.eScheduledDateS = newDayFrom2;
      } else if ($scope.defaultEndDateFrom == "3") {
          $scope.eScheduledDateS = newDayFrom3;
      }

      if ($scope.defaultEndDateTo == "0") {
          $scope.eScheduledDateE = t;
      } else if ($scope.defaultEndDateTo == "1") {
          $scope.eScheduledDateE = newDayTo1;
      } else if ($scope.defaultEndDateTo == "2") {
          $scope.eScheduledDateE = newDayTo2;
      } else if ($scope.defaultEndDateTo == "3") {
          $scope.eScheduledDateE = newDayTo3;
      }

      var beforeWorkColor = "#FFF3E0";
      var onWorkColor = "#FFCC80";
      var completeColor = "#FFA726";
      var confirmColor = "#FB8C00";
      var finalConfirmColor = "#EF6C00";
      var returnColor = "#e85656";


      //工事項目リストを取得
      $scope.showFirst = false;
      $scope.showSecond = false;
      $scope.showThird = false;
      $scope.itemNameList = ajaxService.getTargetItemList($rootScope.projectId);
      for (var i=0; i<$scope.itemNameList.length; i++) {
        var field = $scope.itemNameList[i].fieldName;
        if (field == "first") {
          $scope.showFist = true;
          $scope.targetFirstItemName = $scope.itemNameList[i].showName;
        }
        if (field == "second") {
            $scope.showSecond = true;
            $scope.targetSecondItemName = $scope.itemNameList[i].showName;
          }
        if (field == "third") {
            $scope.showThird = true;
            $scope.targetThirdItemName = $scope.itemNameList[i].showName;
          }
      }

      $scope.firstList = ajaxService.getProjectResourceList($rootScope.projectId, '1', 0);
      if ($scope.firstList.length == 0) {
        $scope.firstList.push({label:"マスタデータがありません", id:0});
        $scope.firstDisable = true;
      } else {
          $scope.firstDisable = false;
          $scope.firstList.unshift({label:" ", id:0});
      }
      $scope.first = $scope.firstList[0];

      $scope.secondList = [];
      if ($scope.first.id != 0) {
          $scope.secondList = ajaxService.getProjectResourceList($rootScope.projectId, '2', $scope.first.id);
          if ($scope.secondList.length == 0) {
            $scope.secondList.push({label:"マスタデータがありません", id:0});
              $scope.secondDisable = true;
          } else {
              $scope.secondDisable = false;
              $scope.secondList.unshift({label:" ", id:0});
          }
      } else {
          $scope.secondList.push({label:"マスタデータがありません", id:0});
          $scope.secondDisable = true;
      }
      $scope.second = $scope.secondList[0];

      $scope.thirdList = [];
      if ($scope.second.id != 0) {
          $scope.thirdList = ajaxService.getProjectResourceList($rootScope.projectId, '3', $scope.second.id);
          if ($scope.thirdList.length == 0) {
            $scope.thirdList.push({label:"マスタデータがありません", id:0});
              $scope.thirdDisable = true;
          } else {
              $scope.thirdDisable = false;
              $scope.thirdList.unshift({label:" ", id:0});
          }
      } else {
          $scope.thirdList.push({label:"マスタデータがありません", id:0});
          $scope.thirdDisable = true;
      }
      $scope.third = $scope.thirdList[0];

      $scope.changeFirst = function () {
        $scope.secondList = ajaxService.getProjectResourceList($rootScope.projectId, '2', $scope.first.id);
          if ($scope.secondList.length == 0) {
            $scope.secondList.push({label:"マスタデータがありません", id:0});
              $scope.secondDisable = true;
          } else {
              $scope.secondDisable = false;
              $scope.secondList.unshift({label:" ", id:0});
          }
          $scope.second = $scope.secondList[0];
          $scope.changeSecond();

          $scope.getTicketNum();
      };
      $scope.changeSecond = function () {
          $scope.thirdList = ajaxService.getProjectResourceList($rootScope.projectId, '3', $scope.second.id);
            if ($scope.thirdList.length == 0) {
              $scope.thirdList.push({label:"マスタデータがありません", id:0});
                $scope.thirdDisable = true;
            } else {
                $scope.thirdDisable = false;
                $scope.thirdList.unshift({label:" ", id:0});
            }
            $scope.third = $scope.thirdList[0];

            $scope.getTicketNum();
        };


        $scope.changeThird = function () {
            $scope.getTicketNum();
        };
        $scope.changeResponseGroup = function () {
            $scope.responseUser = $scope.userList[0];
            $scope.getTicketNum();
        };

        $scope.changeResponseUser = function () {
            $scope.responseGroup = $scope.groupList[0];
            $scope.getTicketNum();
        };

        $scope.showTicket = function (statusId) {
          var first = 0;
          var second = 0;
          var third = 0;
          var resGroup = 0;
          var resUser = "";
          if ($scope.first) {
            first = $scope.first.id;
          }
          if ($scope.second) {
            second = $scope.second.id;
          }
          if ($scope.third) {
            third = $scope.third.id;
          }
          if ($scope.responseGroup) {
            resGroup = $scope.responseGroup.groupId;
          }
          if ($scope.responseUser) {
            resUser = $scope.responseUser.userId;
          }

          window.location.href = "#/checkreport?kbn=g&statusId="+statusId+"&sEnd="+$scope.sdStart+"&eEnd="+$scope.sdEnd+"&first="+first+"&second="+second+"&third="+third+"&resGroup="+resGroup+"&resUser="+resUser;
        };

      $scope.getTicketNum = function () {

        $scope.sdStart = $rootScope.formatDate($scope.eScheduledDateS, "YYYY/MM/DD");
        $scope.sdEnd = $rootScope.formatDate($scope.eScheduledDateE, "YYYY/MM/DD");

          $scope.beforeWorkNum = ajaxService.getTicketTotalNum($rootScope.projectId, groupIdList, $scope.sdStart, $scope.sdEnd, $scope.first.id, $scope.second.id, $scope.third.id, $scope.responseGroup.groupId, $scope.responseUser.userId, '01');
          $scope.onWorkNum = ajaxService.getTicketTotalNum($rootScope.projectId, groupIdList, $scope.sdStart, $scope.sdEnd, $scope.first.id, $scope.second.id, $scope.third.id, $scope.responseGroup.groupId, $scope.responseUser.userId, '02');
          $scope.completeNum = ajaxService.getTicketTotalNum($rootScope.projectId, groupIdList, $scope.sdStart, $scope.sdEnd, $scope.first.id, $scope.second.id, $scope.third.id, $scope.responseGroup.groupId, $scope.responseUser.userId, '03');
          $scope.confirmNum = ajaxService.getTicketTotalNum($rootScope.projectId, groupIdList, $scope.sdStart, $scope.sdEnd, $scope.first.id, $scope.second.id, $scope.third.id, $scope.responseGroup.groupId, $scope.responseUser.userId, '04');
          $scope.finalConfirmNum = ajaxService.getTicketTotalNum($rootScope.projectId, groupIdList, $scope.sdStart, $scope.sdEnd, $scope.first.id, $scope.second.id, $scope.third.id, $scope.responseGroup.groupId, $scope.responseUser.userId, '05');
          $scope.returnNum = ajaxService.getTicketTotalNum($rootScope.projectId, groupIdList, $scope.sdStart, $scope.sdEnd, $scope.first.id, $scope.second.id, $scope.third.id, $scope.responseGroup.groupId, $scope.responseUser.userId, '99');

          $scope.totalNum = $scope.beforeWorkNum + $scope.onWorkNum + $scope.completeNum + $scope.confirmNum + $scope.finalConfirmNum + $scope.returnNum;

          if ($scope.totalNum != 0) {
            $("#allNum").html($scope.totalNum + "件");
            $scope.beforeWorkPer = ($scope.beforeWorkNum * 100 / $scope.totalNum).toFixed(0);
            $scope.onWorkPer = ($scope.onWorkNum * 100 / $scope.totalNum).toFixed(0);
            $scope.completePer = ($scope.completeNum * 100 / $scope.totalNum).toFixed(0);
            $scope.confirmPer = ($scope.confirmNum * 100 / $scope.totalNum).toFixed(0);
            $scope.finalConfirmPer = ($scope.finalConfirmNum * 100 / $scope.totalNum).toFixed(0);
            $scope.returnPer = ($scope.returnNum * 100 / $scope.totalNum).toFixed(0);
          } else {
              $scope.beforeWorkPer = 0;
              $scope.onWorkPer = 0;
              $scope.completePer = 0;
              $scope.confirmPer = 0;
              $scope.finalConfirmPer = 0;
              $scope.returnPer = 0;
            $("#allNum").html("該当するチェックシートがありません。");
          }

          $scope.doughnutData = {
                  labels: [
                      $rootScope.getStatusShowName('01'),
                      $rootScope.getStatusShowName('02'),
                      $rootScope.getStatusShowName('03'),
                      $rootScope.getStatusShowName('04'),
                      $rootScope.getStatusShowName('05'),
                      $rootScope.getStatusShowName('99')
                  ],
                  datasets: [
                      {
                          data: [$scope.beforeWorkNum, $scope.onWorkNum, $scope.completeNum, $scope.confirmNum, $scope.finalConfirmNum, $scope.returnNum],
                          backgroundColor: [
                              beforeWorkColor,
                              onWorkColor,
                              completeColor,
                              confirmColor,
                              finalConfirmColor,
                              returnColor

                          ],
                          hoverBackgroundColor: [
                              colorHelper.shade(beforeWorkColor, 15),
                              colorHelper.shade(onWorkColor, 15),
                              colorHelper.shade(completeColor, 15),
                              colorHelper.shade(confirmColor, 15),
                              colorHelper.shade(finalConfirmColor, 15),
                              colorHelper.shade(returnColor, 15)
                          ],
                          percentage: [$scope.beforeWorkPer, $scope.onWorkPer, $scope.completePer, $scope.confirmPer, $scope.finalConfirmPer, $scope.returnPer]
                      }]
              };

          $scope.pList = [$scope.beforeWorkPer, $scope.onWorkPer, $scope.completePer, $scope.confirmPer, $scope.finalConfirmPer, $scope.returnPer];
          $scope.id=[
               '01',
               '02',
               '03',
               '04',
               '05',
               '99'
           ];

          var ch = document.getElementById('canvas-holder');

          var chartArea = document.getElementById('chart-area');

          chartArea.remove();
          $('#canvas-holder').append('<canvas id="chart-area"></canvas>');
          chartArea = document.getElementById('chart-area');

          if(isMobile) {
            chartArea.width = ch.clientWidth;
            chartArea.height = ch.clientHeight;
           }

              var ctx = chartArea.getContext('2d');

              window.myDoughnut = new Chart(ctx, {
                  type: 'doughnut',
                  data: $scope.doughnutData,
                  options: {
                      cutoutPercentage: 64,
                      responsive: false,
                      elements: {
                          arc: {
                              borderWidth: 0
                          }
                      },
                      'onClick' : function (evt, item) {
                          var element = this.getElementAtEvent(event);
                          if (element.length > 0) {
                              var label = element[0]._model.label;
                              if (label == $rootScope.getStatusShowName('01')) {
                            	  $scope.showTicket('01');
                              } else if (label == $rootScope.getStatusShowName('02')) {
                            	  $scope.showTicket('02');
                              } else if (label == $rootScope.getStatusShowName('03')) {
                            	  $scope.showTicket('03');
                              } else if (label == $rootScope.getStatusShowName('04')) {
                            	  $scope.showTicket('04');
                              } else if (label == $rootScope.getStatusShowName('05')) {
                            	  $scope.showTicket('05');
                              } else if (label == $rootScope.getStatusShowName('99')) {
                            	  $scope.showTicket('99');
                              }
                          }

                      }
                  }
              });
      }

      $scope.getTicketNum();

  }
})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(fileId, ext) {
      ext = ext || 'png';

      if (fileId != 0) {
    	  return urlPrefix + "project/showUserImg/"+ fileId +"/"+localStorage.schema;
      } else {
    	  return layoutPaths.images.profile + 'defaultUser.' + ext;

      }







    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {

        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    var url = window.location.href;
    var u = url.split("#")[1];

    var menuPage = 'app/theme/components/baSidebar/ba-sidebar.html';

	var ua = navigator.userAgent.toLowerCase();
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    if (isMobile) {
    	if (ua.indexOf('mobile') == -1 || ua.indexOf('ipad') > 0 ){
    		if (window.localStorage.tabletMode == '1') {
    			isMobile = false;
    		}
    	}
    }
    if(isMobile) {
      menuPage = 'app/theme/components/baSidebar/ba-sidebar-sp.html';
    }

    if ( u.indexOf('/showReportDetail') != 0) {
      return {
        restrict: 'E',
        templateUrl: menuPage,
        controller: 'BaSidebarCtrl',
        link: function(scope, el) {

          scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
          jqWindow.on('click', _onWindowClick);
          jqWindow.on('resize', _onWindowResize);

          scope.$on('$destroy', function() {
            jqWindow.off('click', _onWindowClick);
            jqWindow.off('resize', _onWindowResize);
          });

          function _onWindowClick($evt) {
            if (!baUtil.isDescendant(el[0], $evt.target) &&
                !$evt.originalEvent.$sidebarEventProcessed &&
                !baSidebarService.isMenuCollapsed() &&
                baSidebarService.canSidebarBeHidden()) {
              $evt.originalEvent.$sidebarEventProcessed = true;
              $timeout(function () {
                baSidebarService.setMenuCollapsed(true);
              }, 10);
            }
          }

          // watch window resize to change menu collapsed state if needed
          function _onWindowResize() {
            var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
            var newMenuHeight = _calculateMenuHeight();
            if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
              scope.$apply(function () {
                scope.menuHeight = newMenuHeight;
                baSidebarService.setMenuCollapsed(newMenuCollapsed)
              });
            }
          }

          function _calculateMenuHeight() {
            return el[0].childNodes[0].clientHeight - 84;
          }
        }
      };
    } else {
      return new Object();
    }
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
      var isMenuCollapsed = shouldMenuBeCollapsed();
//        var url = window.location.href;
//          if (url.indexOf('/showReportDetail') > -1) {
//            isMenuCollapsed = true;
//          }

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  oldTitle: s.oldTitle,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService, $rootScope) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });

    $scope.gotoProject = function () {

    	if ($rootScope.realMngKbn == '9' || $rootScope.realMngKbn == '3') {
        	$rootScope.mngKbn = '3';
        	window.localStorage.mngKbn = '3';
    	}

        $rootScope.projectId = '';
        window.localStorage.projectId = '';
        $rootScope.projectName = '';
        window.localStorage.projectName = '';
        $rootScope.isProject = false;
        $rootScope.isHome = false;

    	window.location.href = "#/project";
    };

    $scope.clearTargetId = function () {
    	$rootScope.targetIdForTicket = null;
    };

  }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.theme.components').controller('baWizardCtrl',
            baWizardCtrl);

    /** @ngInject */
    function baWizardCtrl($scope) {
        var vm = this;
        vm.tabs = [];

        vm.tabNum = 0;
        vm.progress = 0;

        vm.addTab = function(tab) {
            tab.setPrev(vm.tabs[vm.tabs.length - 1]);
            vm.tabs.push(tab);
            vm.selectTab(0);
        };

        $scope.$watch(angular.bind(vm, function() {
            return vm.tabNum;
        }), calcProgress);

        vm.selectTab = function(tabNum) {
            if (tabNum > vm.tabNum) {
                if (tabNum - vm.tabNum > 1) {
                    return;
                }
                if ($scope.$parent.checkNext(vm.tabNum) == false) {
                    return;
                }
            }
            vm.tabs[vm.tabNum].submit();
            if (vm.tabs[tabNum].isAvailiable()) {
                vm.tabNum = tabNum;
                vm.tabs.forEach(function(t, tIndex) {
                    tIndex == vm.tabNum ? t.select(true) : t.select(false);
                });
            }
        };

        vm.isFirstTab = function() {
            return vm.tabNum == 0;
        };

        vm.isLastTab = function() {
            return vm.tabNum == vm.tabs.length - 1;
        };

        vm.nextTab = function() {
            vm.selectTab(vm.tabNum + 1)
        };

        vm.previousTab = function() {
            vm.selectTab(vm.tabNum - 1)
        };

        function calcProgress() {
            vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
        }
    }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);
        wizard.progress = ((wizard.tabNum + 1) / wizard.tabs.length) * 100;
        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovsky created on 16.12.2015
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components').controller(
      'confirmDialogCtrl', confirmDialogCtrl);

  /** @ngInject */
  function confirmDialogCtrl($scope, message) {
    $scope.message = message.message;
    $scope.flg = message.flg;
    $scope.userNameList = message.userNameList;
    $scope.userNames = {selected:[]};
    $scope.doYes = function() {
      if ($scope.flg == 2) {
    	  console.log($scope.userNames.selected);
    	  $scope.$close($scope.userNames.selected);
      } else {
          $scope.$close();
      }
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {

		var ua = navigator.userAgent.toLowerCase();
	  var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
	  if (isMobile) {
	    	if (ua.indexOf('mobile') == -1 || ua.indexOf('ipad')  > 0){
	    		if (window.localStorage.tabletMode == '1') {
	    			isMobile = false;
	    		}
	    	}
	    }

	  if (! isMobile) {
		  return {
		      restrict: 'E',
		      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
		      controller: 'MsgCenterCtrl'
		    };
	  } else {
		  return {
		      restrict: 'E',
		      templateUrl: 'app/theme/components/msgCenter/msgCenterSp.html',
		      controller: 'MsgCenterCtrl'
		    };
	  }


  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce, $interval, $rootScope, $filter, editableOptions, editableThemes, toastr, themeLayoutSettings,
          toastrConfig, ajaxService, $state, $location, $window) {

	  var theme = themeLayoutSettings;

      $scope.ctrl = $scope;
      var maxDate = 10;


	  $scope.commentList = [];
	  $scope.newsList = [];

	  $scope.mngCommon = ajaxService.getMngCommon($rootScope.projectId);
	  $scope.commentWithBell = $scope.mngCommon.commentWithBell;
	  $scope.newsWithBell = $scope.mngCommon.newsWithBell;
	  $scope.documentWithBell = $scope.mngCommon.documentWithBell;

	  if (! $scope.commentWithBell) {
	      $scope.commentWithBell = '1';
	  }
	  if (! $scope.newsWithBell) {
	      $scope.newsWithBell = '1';
	  }
	  if (! $scope.documentWithBell) {
	      $scope.documentWithBell = '1';
	  }


      var timeout = 60000 //60秒ごとにCommentNumを取得
	  $scope.unConfirmNumTicket = 0;

	  $scope.getUnConfirmNum = function () {
		  if ($scope.commentWithBell == '1') {
			  $scope.unConfirmNumTicket = ajaxService.countUnConfirmComment(maxDate, $rootScope.projectId);
			  $scope.unConfirmNum = $scope.unConfirmNumTicket + $scope.unConfirmNumNews + $scope.unConfirmNumDocument;
		  }
	  };

	  $scope.getUnConfirmNum();

	  var timeout_upd = $interval($scope.getUnConfirmNum,timeout);
	  $scope.getCommentList = function () {
          if($scope.isOpenComment){
        	  if ($scope.unConfirmNumTicket != 0) {
        		  ajaxService.confirmComment($rootScope.projectId);
        		  $scope.unConfirmNumTicket = 0;
        	  }
        	  //コメント内容取得
        	  $scope.commentList = ajaxService.getUserCommentList(maxDate, $rootScope.projectId);
        	  $scope.newsList = ajaxService.getUnconfirmNewsList($rootScope.projectId);
        	  if ($scope.unConfirmNumNews != 0) {
        		  $scope.unConfirmNumNews = ajaxService.getUnConfirmNum($rootScope.projectId);
        	  }
			  $scope.unConfirmNum = $scope.unConfirmNumTicket + $scope.unConfirmNumNews + $scope.unConfirmNumDocument;
          } else {
        	  $scope.commentList = [];
        	  $scope.newsList = [];
          }
	  };

	  $scope.unConfirmNumNews = 0;

	  $scope.getUnConfirmNumNews = function () {
		  if ($scope.newsWithBell == '1') {
			  $scope.unConfirmNumNews = ajaxService.getUnConfirmNum($rootScope.projectId);
			  $scope.unConfirmNum = $scope.unConfirmNumTicket + $scope.unConfirmNumNews + $scope.unConfirmNumDocument;
		  }
	  };

	  $scope.getUnConfirmNumNews();

	  var timeout_new = $interval($scope.getUnConfirmNumNews,timeout);


	  $scope.unConfirmNumDocument = 0;

	  $scope.getUnConfirmNumDocument = function () {
		  if ($scope.documentWithBell == '1') {
			  $scope.unConfirmNumDocument = ajaxService.getUnConfirmNumDocument($rootScope.projectId);
			  $scope.unConfirmNum = $scope.unConfirmNumTicket + $scope.unConfirmNumNews + $scope.unConfirmNumDocument;
		  }
	  };

	  $scope.getUnConfirmNumDocument();

	  var timeout_document = $interval($scope.getUnConfirmNumDocument,timeout);



	  $scope.resetList = function () {
		  if(! $scope.isOpenComment){
			  $scope.commentList = [];
			  $scope.newsList = [];
		  }
	  }
	  var timeout_upd2 = $interval($scope.resetList,100);


	  $scope.$on('$destroy',function(){
	       $interval.cancel(timeout_upd);
	       $interval.cancel(timeout_upd2);
	       $interval.cancel(timeout_new);
	       $interval.cancel(timeout_document);
	   });


	  $scope.showComment = function (comment) {
		  var url = window.location.href;
          var u = url.split("#")[0];
		  if (! theme.mobile) {
			  //PC
			  if (comment.type == '3') {
				  window.open(u + "#/showReportDetail?id=" + comment.ticketId);
			  } else {
				  window.open(u + "#/showReportDetail?id=" + comment.ticketId + "#commentList");
			  }
		  } else {
			  //SP
			  if (comment.type == '3') {
				  window.open(u + "#/showReportDetailSp?id=" + comment.ticketId);
			  } else {
				  window.open(u + "#/showReportDetailSp?id=" + comment.ticketId  + "#commentList");
			  }
		  }
	  };


	  $scope.showNews = function (news) {
		   window.location.href = "#/news?id="+ news.newsId;
		   window.location.reload();
	  };



	  $scope.showDocument = function () {
		   window.location.href = "#/manual";
		   window.location.reload();
	  };



  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  var app = angular.module('BlurAdmin.theme.components');
  app.controller('PageTopCtrl', PageTopCtrl);
  app.directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {

    var url = window.location.href;
      var u = url.split("#")[1];
      if ( u.indexOf('/showReportDetail') != 0) {
        return {
              restrict: 'E',
              templateUrl: 'app/theme/components/pageTop/pageTop.html',
              controller: 'PageTopCtrl'
            };
      } else {
        return new Object();
      }



  }

  /** @ngInject */
  function PageTopCtrl($scope) {
      $("#loginUserN").html(localStorage.userName);
      $scope.userName = localStorage.userName;
      $scope.projectName = localStorage.projectName;
        $scope.logOut = function() {
            var schema = localStorage.schema;
            var key1 = localStorage.key1;
            window.location = "auth.html";
            localStorage.clear();

            //-------------------トライアル--------------------

//              if (schema != 'smartbee') {
//                  window.location = "auth.html?key=" + key1;
//              }
//              localStorage.schema = schema;
//              localStorage.key1 = key1;

              //-------------------トライアル--------------------
//            localStorage.mailId = data.mailId;
//            localStorage.userName = data.userName;
//            localStorage.groupId = data.groupId;
//            localStorage.groupName = data.groupName;
//            localStorage.mngFlg = data.mngFlg;
//            localStorage.token = data.token;
          };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/checklist/checkAll.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">{{checksheetName}}</h4></div><div class="modal-body text-left"><table class="table table-bordered"><tbody><tr style="font-weight: 600; font-size: 20px;"><td style="text-align: left;">\u30C1\u30A7\u30C3\u30AF\u9805\u76EE</td><td>\u30C1\u30A7\u30C3\u30AF\u8A73\u7D30\u9805\u76EE</td><td style="min-width: 110px;">\u5165\u529B\u65B9\u5F0F</td></tr><tr ng-repeat="item in checkAllList"><td ng-if="item.checklistName != \'\'" rowspan="{{item.togoNum}}" style="text-align: left;">{{item.checklistName}}</td><td style="text-align: left;">{{item.checkDetailName}}</td><td style="text-align: left;">{{item.inputTypeName}}</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/checklist/checklist.html','<div class="widgets"><div class="row" id="comments"><div class="col-md-12"><div ba-panel="" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u4E00\u89A7" ba-panel-class="with-scroll"><div include-with-scope="app/pages/checklist/list.html"></div></div></div></div><div class="row" id="comments"><div class="col-md-12 panel-width2"><div ba-panel="" ba-panel-title="{{selectedCheckSheet.first}}\u21D2{{selectedCheckSheet.second}}\u21D2{{selectedCheckSheet.third}}\u21D2{{selectedCheckSheet.fourth}} (ver.{{$root.padLeft(selectedCheckSheet.version, 3)}})" ba-panel-class="with-scroll" id="listDetail" style="display: none;"><div include-with-scope="app/pages/checklist/listDetail.html"></div></div></div></div><div class="row"><div class="col-md-12" id="fileList" ba-panel="" ba-panel-title="\u30D5\u30A1\u30A4\u30EB\u4E00\u89A7" style="display: none;" ba-panel-class="with-scroll"><div ng-include="\'app/pages/checklist/fileList.html\'"></div></div></div><div class="row" ng-show="historyList.length > 0"><div class="col-md-12" id="fileList" ba-panel="" ba-panel-title="\u30D5\u30A1\u30A4\u30EB\u5C65\u6B74" ba-panel-class="with-scroll"><div ng-include="\'app/pages/checklist/fileHistoryList.html\'"></div></div></div></div>');
$templateCache.put('app/pages/checklist/defaultChecksheetList.html','<div class="modal-content" style="width:1075px"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30C7\u30D5\u30A9\u30EB\u30C8\u30C1\u30A7\u30C3\u30AF\u4E00\u89A7</h4></div><div class="modal-body text-left" style="overflow-y: auto;"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-change="resetPage()" ng-model="defaultListPageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="listData" st-safe-src="defaultChecksheetList" style="table-layout: fixed;" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th class="table-id" style="width: 35px">#</th><th st-sort="first" st-sort-default="obverse" style="width: 170px">\u533A\u5206</th><th st-sort="second" style="width: 156px">\u5927\u9805\u76EE</th><th st-sort="third" style="width: 226px">\u4E2D\u9805\u76EE</th><th st-sort="fourth" style="width: 263px">\u5C0F\u9805\u76EE</th><th st-sort="version" style="width: 45px">Ver.</th><th style="width: 168px;">\u64CD\u4F5C</th></tr><tr><th></th><th><select st-search="first" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'first\'" value="{{item.first}}">{{item.first}}</option></select></th><th><select st-search="second" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'second\'" value="{{item.second}}">{{item.second}}</option></select></th><th><select st-search="third" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'third\'" value="{{item.third}}">{{item.third}}</option></select></th><th><select st-search="fourth" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fourth\'" value="{{item.fourth}}">{{item.fourth}}</option></select></th><th><select st-search="version" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'version\'" value="{{item.version}}">{{item.version}}</option></select></th><th><button type="button" class="btn btn-xs btn-info" ng-click="copyDefaultChecksheetList()">\u4E00\u62EC\u30B3\u30D4\u30FC</button> <label class="checkbox-inline custom-checkbox nowrap" style="padding-left: 45px;"><input type="checkbox" value="01" ng-model="ctrl.allChoice" choice-dchecksheet=""> <span style="display: initial;padding-left: 0;"></span></label></th></tr></thead><tbody><tr ng-repeat="item in listData"><td class="table-id" style="overflow: hidden">{{$index + 1}}</td><td style="white-space: nowrap; overflow: hidden"><p style="overflow: hidden; text-overflow: ellipsis">{{item.first}}</p></td><td style="white-space: nowrap; overflow: hidden"><p style="overflow: hidden; text-overflow: ellipsis">{{item.second}}</p></td><td style="white-space: nowrap; overflow: hidden"><p style="overflow: hidden; text-overflow: ellipsis">{{item.third}}</p></td><td style="white-space: nowrap; overflow: hidden"><p style="overflow: hidden; text-overflow: ellipsis">{{item.fourth}}</p></td><td style="white-space: nowrap; overflow: hidden"><p style="overflow: hidden; text-overflow: ellipsis">{{$root.padLeft(item.version, 3) }}</p></td><td style="overflow: hidden"><button type="button" class="btn btn-xs btn-info" click-and-disable="copyDefaultChecksheet(item)">\u30B3\u30D4\u30FC</button> <button type="button" class="btn btn-xs btn-info" ng-click="showCheckAllInfo(item.checksheetId,item.checksheetName)">\u95B2\u89A7</button> <label class="checkbox-inline custom-checkbox nowrap" style="padding-left: 25px; margin-left: 5px;"><input type="checkbox" value="item.id" ng-model="ctrl.checksheetChoice[item.checksheetId]"> <span style="display: initial;padding-left: 0;"></span></label></td></tr></tbody><tfoot><tr><td class="text-left" colspan="9"><div st-pagination="" st-items-by-page="defaultListPageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/checklist/downloadSetting.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u5831\u544A\u66F8\u51FA\u529B\u8A2D\u5B9A</h4></div><div class="modal-body text-left"><div class="form-group"><label style="font-size: 18px; font-weight: 400; color:#666666;">\uFF11\uFF0E\u51FA\u529B\u9805\u76EE\u8A2D\u5B9A</label></div><div class="form-group" style="margin-left: 20px;"><uib-accordion><uib-accordion-group heading="\uFF11\uFF0D\uFF11\uFF0E\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u9805\u76EE" panel-class="accordion-panel bootstrap-panel panel-default" is-open="false"><table class="table table-bordered"><tbody><tr style="font-size: 14px; font-weight: 600;"><td style="text-align: left;">\u9805\u76EE\u540D</td><td>\u8868\u793A\u540D</td><td>\u51FA\u529B\u30AD\u30FC\u30EF\u30FC\u30C9</td></tr><tr style="font-size: 14px;"><td style="text-align: left;">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8ID</td><td>\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8ID</td><td><input type="text" maxlength="512" class="form-control" ng-model="ticketIdKey" ng-blur="addMark(this, \'ticketIdKey\')"></td></tr><tr style="font-size: 14px;"><td style="text-align: left;">\u30B9\u30C6\u30FC\u30BF\u30B9</td><td>\u30B9\u30C6\u30FC\u30BF\u30B9</td><td><input type="text" maxlength="512" class="form-control" ng-model="ticketStatusKey" ng-blur="addMark(this, \'ticketStatusKey\')"></td></tr><tr style="font-size: 14px;"><td style="text-align: left;">\u958B\u59CB\u65E5(\u4E88\u5B9A)</td><td>\u958B\u59CB\u65E5(\u4E88\u5B9A)</td><td><input type="text" maxlength="512" class="form-control" ng-model="startScheduledDateKey" ng-blur="addMark(this, \'startScheduledDateKey\')"></td></tr><tr style="font-size: 14px;"><td style="text-align: left;">\u5B8C\u4E86\u65E5(\u4E88\u5B9A)</td><td>\u5B8C\u4E86\u65E5(\u4E88\u5B9A)</td><td><input type="text" maxlength="512" class="form-control" ng-model="endScheduledDateKey" ng-blur="addMark(this, \'endScheduledDateKey\')"></td></tr><tr style="font-size: 14px;"><td style="text-align: left;">\u958B\u59CB\u65E5(\u5B9F\u7E3E)</td><td>\u958B\u59CB\u65E5(\u5B9F\u7E3E)</td><td><input type="text" maxlength="512" class="form-control" ng-model="startDateKey" ng-blur="addMark(this, \'startDateKey\')"></td></tr><tr style="font-size: 14px;"><td style="text-align: left;">\u5B8C\u4E86\u65E5(\u5B9F\u7E3E)</td><td>\u5B8C\u4E86\u65E5(\u5B9F\u7E3E)</td><td><input type="text" maxlength="512" class="form-control" ng-model="endDateKey" ng-blur="addMark(this, \'endDateKey\')"></td></tr><tr style="font-size: 14px;"><td style="text-align: left;">\u7BA1\u7406\u6280\u8853\u8005</td><td>\u7BA1\u7406\u6280\u8853\u8005</td><td><input type="text" maxlength="512" class="form-control" ng-model="requestUserKey" ng-blur="addMark(this, \'requestUserKey\')"></td></tr><tr style="font-size: 14px;"><td style="text-align: left;">\u6307\u793A\u30B0\u30EB\u30FC\u30D7</td><td>\u6307\u793A\u30B0\u30EB\u30FC\u30D7</td><td><input type="text" maxlength="512" class="form-control" ng-model="requestGroupKey" ng-blur="addMark(this, \'requestGroupKey\')"></td></tr><tr style="font-size: 14px;"><td style="text-align: left;">\u62C5\u5F53\u6280\u8853\u8005</td><td>\u62C5\u5F53\u6280\u8853\u8005</td><td><input type="text" maxlength="512" class="form-control" ng-model="responseUserKey" ng-blur="addMark(this, \'responseUserKey\')"></td></tr><tr style="font-size: 14px;"><td style="text-align: left;">\u62C5\u5F53\u6280\u8853\u8005\u30B0\u30EB\u30FC\u30D7</td><td>\u62C5\u5F53\u6280\u8853\u8005\u30B0\u30EB\u30FC\u30D7</td><td><input type="text" maxlength="512" class="form-control" ng-model="responseGroupKey" ng-blur="addMark(this, \'responseGroupKey\')"></td></tr><tr style="font-size: 14px;"><td style="text-align: left;">\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7</td><td>\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7</td><td><input type="text" maxlength="512" class="form-control" ng-model="readingGroupKey" ng-blur="addMark(this, \'readingGroupKey\')"></td></tr><tr ng-show="showStatusDetail" style="font-size: 14px;"><td style="text-align: left;">\u533A\u52061</td><td>{{statusDetailItemName}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="statusDetailKey" ng-blur="addMark(this, \'statusDetailKey\')"></td></tr><tr ng-show="showTicketKbn2" style="font-size: 14px;"><td style="text-align: left;">\u533A\u52062</td><td>{{kbn2ItemName}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="ticketKbn2Key" ng-blur="addMark(this, \'ticketKbn2Key\')"></td></tr><tr ng-show="showTicketKbn3" style="font-size: 14px;"><td style="text-align: left;">\u533A\u52063</td><td>{{kbn3ItemName}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="ticketKbn3Key" ng-blur="addMark(this, \'ticketKbn3Key\')"></td></tr><tr ng-show="showTicketKbn4" style="font-size: 14px;"><td style="text-align: left;">\u533A\u52064</td><td>{{kbn4ItemName}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="ticketKbn4Key" ng-blur="addMark(this, \'ticketKbn4Key\')"></td></tr><tr ng-show="showTicketKbn5" style="font-size: 14px;"><td style="text-align: left;">\u533A\u52065</td><td>{{kbn5ItemName}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="ticketKbn5Key" ng-blur="addMark(this, \'ticketKbn5Key\')"></td></tr><tr ng-show="showTicketItem1" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60271</td><td>{{item1ItemName}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="ticketItem1Key" ng-blur="addMark(this, \'ticketItem1Key\')"></td></tr><tr ng-show="showTicketItem2" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60272</td><td>{{item2ItemName}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="ticketItem2Key" ng-blur="addMark(this, \'ticketItem2Key\')"></td></tr><tr ng-show="showTicketItem3" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60273</td><td>{{item3ItemName}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="ticketItem3Key" ng-blur="addMark(this, \'ticketItem3Key\')"></td></tr><tr ng-show="showTicketItem4" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60274</td><td>{{item4ItemName}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="ticketItem4Key" ng-blur="addMark(this, \'ticketItem4Key\')"></td></tr><tr ng-show="showTicketItem5" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60275</td><td>{{item5ItemName}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="ticketItem5Key" ng-blur="addMark(this, \'ticketItem5Key\')"></td></tr></tbody></table></uib-accordion-group></uib-accordion><uib-accordion><uib-accordion-group heading="\uFF11\uFF0D\uFF12\uFF0E\u5BFE\u8C61\u5DE5\u4E8B\u9805\u76EE" panel-class="accordion-panel bootstrap-panel panel-default" is-open="false"><table class="table table-bordered"><tbody><tr style="font-size: 14px; font-weight: 600;"><td style="text-align: left;">\u9805\u76EE\u540D</td><td>\u8868\u793A\u540D</td><td>\u51FA\u529B\u30AD\u30FC\u30EF\u30FC\u30C9</td></tr><tr ng-show="showTargetId" style="font-size: 14px;"><td style="text-align: left;">\u5BFE\u8C61\u5DE5\u4E8BID</td><td>{{itemTargetId}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="targetIdKey" ng-blur="addMark(this, \'targetIdKey\')"></td></tr><tr ng-show="showTargetName" style="font-size: 14px;"><td style="text-align: left;">\u5BFE\u8C61\u5DE5\u4E8B\u540D</td><td>{{itemTargetName}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="targetNameKey" ng-blur="addMark(this, \'targetNameKey\')"></td></tr><tr ng-show="showFirst" style="font-size: 14px;"><td style="text-align: left;">\u30AB\u30C6\u30B4\u30EA\uFF08\u5927\uFF09</td><td>{{itemFirst}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="firstKey" ng-blur="addMark(this, \'firstKey\')"></td></tr><tr ng-show="showSecond" style="font-size: 14px;"><td style="text-align: left;">\u30AB\u30C6\u30B4\u30EA\uFF08\u4E2D\uFF09</td><td>{{itemSecond}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="secondKey" ng-blur="addMark(this, \'secondKey\')"></td></tr><tr ng-show="showThird" style="font-size: 14px;"><td style="text-align: left;">\u30AB\u30C6\u30B4\u30EA\uFF08\u5C0F\uFF09</td><td>{{itemThird}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="thirdKey" ng-blur="addMark(this, \'thirdKey\')"></td></tr><tr ng-show="showAddress" style="font-size: 14px;"><td style="text-align: left;">\u4F4F\u6240</td><td>{{itemAddress}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="addressKey" ng-blur="addMark(this, \'addressKey\')"></td></tr><tr ng-show="showLatitude" style="font-size: 14px;"><td style="text-align: left;">\u7DEF\u5EA6</td><td>{{itemLatitude}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="latKey" ng-blur="addMark(this, \'latKey\')"></td></tr><tr ng-show="showLongitude" style="font-size: 14px;"><td style="text-align: left;">\u7D4C\u5EA6</td><td>{{itemLongitude}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="lonKey" ng-blur="addMark(this, \'lonKey\')"></td></tr><tr ng-show="showKbn1" style="font-size: 14px;"><td style="text-align: left;">\u533A\u52061</td><td>{{itemKbn1}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="kbn1Key" ng-blur="addMark(this, \'kbn1Key\')"></td></tr><tr ng-show="showKbn2" style="font-size: 14px;"><td style="text-align: left;">\u533A\u52062</td><td>{{itemKbn2}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="kbn2Key" ng-blur="addMark(this, \'kbn2Key\')"></td></tr><tr ng-show="showKbn3" style="font-size: 14px;"><td style="text-align: left;">\u533A\u52063</td><td>{{itemKbn3}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="kbn3Key" ng-blur="addMark(this, \'kbn3Key\')"></td></tr><tr ng-show="showKbn4" style="font-size: 14px;"><td style="text-align: left;">\u533A\u52064</td><td>{{itemKbn4}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="kbn4Key" ng-blur="addMark(this, \'kbn4Key\')"></td></tr><tr ng-show="showKbn5" style="font-size: 14px;"><td style="text-align: left;">\u533A\u52065</td><td>{{itemKbn5}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="kbn5Key" ng-blur="addMark(this, \'kbn5Key\')"></td></tr><tr ng-show="showItem1" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60271</td><td>{{itemItem1}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item1Key" ng-blur="addMark(this, \'item1Key\')"></td></tr><tr ng-show="showItem2" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60272</td><td>{{itemItem2}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item2Key" ng-blur="addMark(this, \'item2Key\')"></td></tr><tr ng-show="showItem3" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60273</td><td>{{itemItem3}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item3Key" ng-blur="addMark(this, \'item3Key\')"></td></tr><tr ng-show="showItem4" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60274</td><td>{{itemItem4}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item4Key" ng-blur="addMark(this, \'item4Key\')"></td></tr><tr ng-show="showItem5" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60275</td><td>{{itemItem5}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item5Key" ng-blur="addMark(this, \'item5Key\')"></td></tr><tr ng-show="showItem6" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60276</td><td>{{itemItem6}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item6Key" ng-blur="addMark(this, \'item6Key\')"></td></tr><tr ng-show="showItem7" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60277</td><td>{{itemItem7}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item7Key" ng-blur="addMark(this, \'item7Key\')"></td></tr><tr ng-show="showItem8" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60278</td><td>{{itemItem8}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item8Key" ng-blur="addMark(this, \'item8Key\')"></td></tr><tr ng-show="showItem9" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u60279</td><td>{{itemItem9}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item9Key" ng-blur="addMark(this, \'item9Key\')"></td></tr><tr ng-show="showItem10" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u602710</td><td>{{itemItem10}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item10Key" ng-blur="addMark(this, \'item10Key\')"></td></tr><tr ng-show="showItem11" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u602711</td><td>{{itemItem11}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item11Key" ng-blur="addMark(this, \'item11Key\')"></td></tr><tr ng-show="showItem12" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u602712</td><td>{{itemItem12}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item12Key" ng-blur="addMark(this, \'item12Key\')"></td></tr><tr ng-show="showItem13" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u602713</td><td>{{itemItem13}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item13Key" ng-blur="addMark(this, \'item13Key\')"></td></tr><tr ng-show="showItem14" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u602714</td><td>{{itemItem14}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item14Key" ng-blur="addMark(this, \'item14Key\')"></td></tr><tr ng-show="showItem15" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u602715</td><td>{{itemItem15}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item15Key" ng-blur="addMark(this, \'item15Key\')"></td></tr><tr ng-show="showItem16" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u602716</td><td>{{itemItem16}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item16Key" ng-blur="addMark(this, \'item16Key\')"></td></tr><tr ng-show="showItem17" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u602717</td><td>{{itemItem17}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item17Key" ng-blur="addMark(this, \'item17Key\')"></td></tr><tr ng-show="showItem18" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u602718</td><td>{{itemItem18}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item18Key" ng-blur="addMark(this, \'item18Key\')"></td></tr><tr ng-show="showItem19" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u602719</td><td>{{itemItem19}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item19Key" ng-blur="addMark(this, \'item19Key\')"></td></tr><tr ng-show="showItem20" style="font-size: 14px;"><td style="text-align: left;">\u5C5E\u602720</td><td>{{itemItem20}}</td><td><input type="text" maxlength="512" class="form-control" ng-model="item20Key" ng-blur="addMark(this, \'item20Key\')"></td></tr></tbody></table></uib-accordion-group></uib-accordion><uib-accordion><uib-accordion-group heading="\uFF11\uFF0D\uFF13\uFF0E\u30C1\u30A7\u30C3\u30AF\u9805\u76EE" panel-class="accordion-panel bootstrap-panel panel-default" is-open="true"><table class="table table-bordered"><tbody><tr style="font-size: 14px; font-weight: 600;"><td style="text-align: left;">\u30C1\u30A7\u30C3\u30AF\u9805\u76EE</td><td>\u30C1\u30A7\u30C3\u30AF\u8A73\u7D30\u9805\u76EE</td><td>\u5165\u529B\u65B9\u5F0F</td><td>\u51FA\u529B\u30AD\u30FC\u30EF\u30FC\u30C9</td></tr><tr ng-repeat="item in checkAllList"><td ng-if="item.checklistName != \'\'" rowspan="{{item.togoNum}}" style="text-align: left;">{{item.checklistName}}</td><td style="text-align: left;" ng-if="item.checkDetailId != 0">{{item.checkDetailName}}</td><td style="text-align: left; background-color: #f5f5f5;" ng-if="item.checkDetailId == 0">{{item.checkDetailName}}</td><td style="text-align: left;" ng-if="item.checkDetailId != 0">{{item.inputTypeName}}</td><td style="text-align: left; background-color: #f5f5f5;" ng-if="item.checkDetailId == 0">{{item.inputTypeName}}</td><td ng-if="item.inputTypeId == 0 && item.checkDetailId != 0">\u30C1\u30A7\u30C3\u30AF\u8A73\u7D30\u9805\u76EE\u306A\u3057</td><td ng-if="item.inputTypeId == 8 || item.inputTypeId == 9 || item.inputTypeId == 11 || item.inputTypeId == 13">\u51FA\u529B\u5BFE\u8C61\u5916</td><td ng-if="(item.inputTypeId == 0 && item.checkDetailId == 0) || item.inputTypeId == 1 || item.inputTypeId == 2 || item.inputTypeId == 3 || item.inputTypeId == 4 || item.inputTypeId == 5 || item.inputTypeId == 6 || item.inputTypeId == 12 || item.inputTypeId == 14"><input type="text" class="form-control" ng-model="item.key" ng-blur="addMarkCheckList(item)" maxlength="512"></td><td ng-if="item.inputTypeId == 7"><table style="width: 100%;"><tr><td colspan="2"><input type="text" maxlength="512" class="form-control" ng-model="item.key" ng-blur="addMarkCheckList(item)"></td></tr><tr><td>\u5199\u771F\u30A8\u30EA\u30A2\u306E\u30BB\u30EB\u6570\uFF1A<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="imgTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div></td><td><label>\u7E26\uFF1A<input type="text" class="form-control" ng-model="item.cellNum" style="width: 50px;display: inherit;margin-right: 5px;"> \uFF0A \u6A2A\uFF1A<input type="text" class="form-control" ng-model="item.cellNumCol" style="width: 50px;display: inherit;margin-right: 5px;"></label></td></tr><tr><td>\u51FA\u529B\u679A\u6570\uFF1A</td><td><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" value="1" ng-model="item.outNum" data-ng-change="changeOutNum(\'1\')"> <span>\u5358\u6570</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" value="0" ng-model="item.outNum" data-ng-change="changeOutNum(\'0\')"> <span>\u8907\u6570</span></label></p></div></td></tr><tr ng-show="item.outNum == 0"><td>1\u884C\u3042\u305F\u308A\u306E\u679A\u6570\uFF1A</td><td><select class="form-control selectpicker" selectpicker="" ng-model="item.maxNumInLine" ng-options="m for m in [1,2,3,4]"></select></td></tr><tr ng-show="item.outNum == 0"><td colspan="2"><div><p>\u5199\u771F\u304C0\u679A\u306E\u5834\u5408\u3001\u5199\u771F\u30A8\u30EA\u30A2\u3092\u51FA\u529B\u3057\u306A\u3044\uFF1A <label class="checkbox-inline custom-checkbox nowrap"><input ng-checked="item.dlErea" type="checkbox" ng-model="item.dlErea"> <span></span></label></p></div></td></tr><tr><td>\u5199\u771F\u30B3\u30E1\u30F3\u30C8\u306E\u884C\u6570\uFF1A</td><td><input type="text" class="form-control" ng-model="item.commentCellNum" style="width: 50px;display: inherit;margin-right: 5px;"></td></tr></table></td><td ng-if="item.inputTypeId == 10"><table style="width: 100%;"><tr><td colspan="2"><input type="text" maxlength="512" class="form-control" ng-model="item.key" ng-blur="addMarkCheckList(item)"></td></tr><tr><td>\u624B\u66F8\u304D\u30A8\u30EA\u30A2\u306E\u30BB\u30EB\u6570\uFF1A<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="signTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div></td><td><input type="text" class="form-control" ng-model="item.cellNum" style="width: 50px;display: inherit;margin-right: 5px;"> <label>\u7E26{{item.cellNum}}\uFF0A\u6A2A{{item.cellNum}}</label></td></tr></table></td></tr></tbody></table></uib-accordion-group></uib-accordion></div><div class="form-group"><label style="font-size: 18px; font-weight: 400; color:#666666;">\uFF12\uFF0E\u51FA\u529B\u30D5\u30A1\u30A4\u30EB\u540D\u8A2D\u5B9A</label><div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="fileNameTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div><input type="text" maxlength="200" class="form-control" ng-model="downloadFileName" placeholder="{{defaultFileName}}"></div><div class="form-group" ng-if="! file"><label style="font-size: 18px; font-weight: 400; color:#666666;">\uFF13\uFF0E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002</label> <button type="button" class="btn btn-info" ng-click="saveExcelFile()">\u6DFB\u4ED8</button></div><div class="form-group" ng-if="file"><label style="font-size: 18px; font-weight: 400; color:#666666;">\uFF13\uFF0E\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\uFF1A<a href="javascript:;" ng-click="downLoadFile(file);">{{file.fileName}}</a></label> <button style="margin-left: 10px;" type="button" class="btn btn-default" ng-click="removeDownloadSetting()">\u524A\u9664</button></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="saveDownloadSetting()">\u4FDD\u5B58</button> <button type="button" class="btn btn-default" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/checklist/excelUploadModal.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30D5\u30A1\u30A4\u30EB\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</h4></div><div class="modal-body text-left"><div ng-show="! $root.isMoblie" ngf-drop="" ngf-select="" ng-model="files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" accept="*" style="padding: 27px 0px; width: 500px; margin-left: 40px; padding-bottom: 100px;" ngf-pattern="\'*\'"><i class="material-icons" style="height:75px; font-size: 80px; color: #C0C0C0;">description</i></div><div ng-show="$root.isMoblie" ngf-drop="" ngf-select="" ng-model="files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" accept="*" style="padding: 27px 0px; width: 250px; margin-left: 40px; padding-bottom: 100px;" ngf-pattern="\'*\'"><i class="material-icons" style="height:75px; font-size: 80px; color: #C0C0C0;">description</i></div><div ngf-no-file-drop="">File Drag/Drop is not supported for this browser</div><table style="margin: 10px 40px;"><tr ng-repeat="item in getFileList()"><td>\u30D5\u30A1\u30A4\u30EB{{$index+1}}\uFF1A{{item.name}}</td></tr></table><ul><li><lable>\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u4E2D\uFF1A{{fileName}}</lable><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: {{ progressRate }}%">{{progressRate }}%</div></div></li><li><lable>\u30D5\u30A1\u30A4\u30EB\u6570\uFF1A{{complete + \'/\' + files.length}}</lable><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: {{ allProgressRate }}%">{{allProgressRate }}%</div></div></li></ul></div><div class="modal-footer"><button ng-if="files.length != 0" type="button" class="btn btn-primary" ng-click="upload()">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button> <button type="button" class="btn btn-default" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/checklist/fileHistoryList.html','<div ng-show="!readonly" style="margin-bottom: 10px"><button type="button" class="btn btn-info btn-sm" ng-click="openUploadDialog4History()"><i class="fa fa-upload" style="margin-right: 10px;"></i>Upload</button></div><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><div class="horizontal-scroll"><table class="table" st-table="historyListCopy" st-safe-src="historyList" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th style="text-align: left" st-sort="fileName">\u30D5\u30A1\u30A4\u30EB\u540D</th><th st-sort="size">\u30B5\u30A4\u30BA</th><th st-sort="user">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u8005</th><th st-sort="time">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u65E5\u6642</th><th>\u64CD\u4F5C</th></tr><tr><th><select st-search="fileName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fileName\'" value="{{item.fileName}}">{{item.fileName}}</option></select></th><th><select st-search="size" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'size\'" value="{{item.size}}">{{item.size}}</option></select></th><th><select st-search="user" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'user\'" value="{{item.user}}">{{item.user}}</option></select></th><th><select st-search="time" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'time\'" value="{{item.time}}">{{item.time}}</option></select></th><th></th></tr></thead><tbody><tr ng-repeat="item in historyListCopy"><td style="white-space: nowrap; width: 30%" ng-show="!isFolder(item)" class="table-id"><a href="javascript:;" ng-click="downLoadTicketFile(item);">{{item.fileName}}</a> <button ng-show="isImg(item)" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px;" ng-click="previewImage(item, this, \'0\')"><i class="material-icons">open_in_new</i></button></td><td style="white-space: nowrap; text-align: right; width: 10%">{{ getFileSize(item.size) }}</td><td style="white-space: nowrap; width: 20%">{{ item.user }}</td><td style="white-space: nowrap; width: 20%">{{ item.time }}</td><td style="white-space: nowrap"><button ng-show="!readonly" class="editable-table-button btn btn-xs btn-danger" ng-click="delFileHistory(item)">Delete</button></td></tr></tbody><tfoot><tr><td colspan="14" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/checklist/fileList.html','<div ng-show="!readonly" style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info btn-sm" ng-click="openUploadDialog()">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="fileListCopy" st-safe-src="fileList" st-set-filter="customFilter" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th style="text-align:left" st-sort="fileName">\u30D5\u30A1\u30A4\u30EB\u540D</th><th st-sort="size">\u30B5\u30A4\u30BA</th><th st-sort="userName">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u8005</th><th st-sort="updateTime">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u65E5\u6642</th><th ng-show="!readonly">\u64CD\u4F5C</th></tr><tr><th><select st-search="fileName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fileName\'" value="{{item.fileName}}">{{item.fileName}}</option></select></th><th><select st-search="size" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'size\'" value="{{item.size}}">{{item.size}}</option></select></th><th><select st-search="userName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userName\'" value="{{item.userName}}">{{item.userName}}</option></select></th><th><select st-search="updateTime" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'updateTime\'" value="{{item.updateTime}}">{{item.updateTime}}</option></select></th><th ng-show="!readonly"></th></tr></thead><tbody><tr ng-repeat="item in fileListCopy"><td style="white-space: nowrap; width: 30%" class="table-id"><a href="javascript:;" ng-click="downLoadFile(item);">{{item.fileName}}</a> <button ng-show="isImg(item.fileName)" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="previewImage(item)"><i class="material-icons">open_in_new</i></button></td><td style="white-space: nowrap; text-align:right; width: 10%">{{ $root.getFileSize(item.size) }}</td><td style="white-space: nowrap; width: 20%">{{ item.userName }}</td><td style="white-space: nowrap; width: 20%">{{ item.updateTime }}</td><td ng-show="!readonly" style="white-space: nowrap"><button class="editable-table-button btn btn-xs btn-danger" ng-click="delFile(item)">\u524A\u9664</button></td></tr></tbody><tfoot><tr><td colspan="14" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/checklist/fileUploadModal.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30D5\u30A1\u30A4\u30EB\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</h4></div><div class="modal-body text-left"><div ng-show="! $root.isMoblie" ngf-drop="" ngf-select="" ng-model="files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" accept="*" style="padding: 27px 0px; width: 500px; margin-left: 40px; padding-bottom: 100px;" ngf-pattern="\'*\'"><img src="assets/img/camera2.png" style="height:75px"></div><div ng-show="$root.isMoblie" ngf-drop="" ngf-select="" ng-model="files" class="drop-box" ngf-drag-over-class="\'dragover\'" ngf-multiple="true" ngf-allow-dir="true" accept="*" style="padding: 27px 0px; width: 250px; margin-left: 40px; padding-bottom: 100px;" ngf-pattern="\'*\'"><img src="assets/img/camera2.png" style="height:75px"></div><div ngf-no-file-drop="">File Drag/Drop is not supported for this browser</div><table style="margin: 10px 40px;"><tr ng-repeat="item in getFileList()"><td>\u30D5\u30A1\u30A4\u30EB{{$index+1}}\uFF1A{{item.name}}</td></tr></table><ul><li><label>\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u4E2D\uFF1A{{fileName}}</label><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: {{ progressRate }}%">{{progressRate}}%</div></div></li><li><label>\u30D5\u30A1\u30A4\u30EB\u6570\uFF1A{{complete + \'/\' + files.length}}</label><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: {{ allProgressRate }}%">{{allProgressRate }}%</div></div></li></ul></div><div class="modal-footer"><button ng-if="files.length != 0" type="button" class="btn btn-info" click-and-disable="upload()">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/checklist/list.html','<div><div style="position: absolute; top: 5px; right: 20px;"><button style="margin-right: 20px;" type="button" class="btn btn-info" ng-click="showOtherProjectList()" ng-if="projectList.length > 0">\u4ED6\u696D\u52D9\u304B\u3089\u30C1\u30A7\u30C3\u30AF\u30B3\u30D4\u30FC</button> <button style="margin-right: 20px;" type="button" class="btn btn-info" ng-click="showDefaultChecklist()">\u30C7\u30D5\u30A9\u30EB\u30C8\u30C1\u30A7\u30C3\u30AF\u30B3\u30D4\u30FC</button> <button type="button" class="btn btn-info" ng-click="showChecklistCreate()">\u65B0\u898F</button></div><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="listData" st-safe-src="checksheetList" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th class="table-id">#</th><th st-sort="first">\u533A\u5206</th><th st-sort="second">\u5927\u9805\u76EE</th><th st-sort="third">\u4E2D\u9805\u76EE</th><th st-sort="fourth">\u5C0F\u9805\u76EE</th><th st-sort="frequency">\u78BA\u8A8D\u306E\u7A0B\u5EA6</th><th st-sort="kbn">\u30C1\u30A7\u30C3\u30AF\u533A\u5206(\u30B3\u30D4\u30FC\u5143\u306E\u30D0\u30FC\u30B8\u30E7\u30F3)</th><th st-sort="version">\u30D0\u30FC\u30B8\u30E7\u30F3</th><th style="min-width: 163px;">\u64CD\u4F5C</th></tr><tr><th></th><th><select st-search="first" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'first\'" value="{{item.first}}">{{item.first}}</option></select></th><th><select st-search="second" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'second\'" value="{{item.second}}">{{item.second}}</option></select></th><th><select st-search="third" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'third\'" value="{{item.third}}">{{item.third}}</option></select></th><th><select st-search="fourth" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fourth\'" value="{{item.fourth}}">{{item.fourth}}</option></select></th><th><select st-search="frequency" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'frequency\'" value="{{item.frequency}}">{{item.frequency}}</option></select></th><th><select st-search="kbn" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'kbn\'" value="{{item.kbn}}">{{item.kbn}}</option></select></th><th><select st-search="version" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'version\'" value="{{item.version}}">{{item.version}}</option></select></th><th></th></tr></thead><tbody><tr ng-repeat="item in listData"><td class="table-id" ng-dblclick="showChecklistDetail2(item);">{{$index + 1}}</td><td style="white-space: nowrap" ng-dblclick="showChecklistDetail2(item);">{{item.first}}</td><td style="white-space: nowrap" ng-dblclick="showChecklistDetail2(item);">{{item.second}}</td><td style="white-space: nowrap" ng-dblclick="showChecklistDetail2(item);">{{item.third}}</td><td style="white-space: nowrap"><a href="javascript:;" ng-click="showChecklistDetail2(item);">{{item.fourth}}</a></td><td style="white-space: nowrap" ng-dblclick="showChecklistDetail2(item);">{{item.frequency}}</td><td style="white-space: nowrap" ng-dblclick="showChecklistDetail2(item);">{{item.kbn}}</td><td style="white-space: nowrap" ng-dblclick="showChecklistDetail2(item);">{{ $root.padLeft(item.version, 3) }}</td><td><button type="button" class="btn btn-xs btn-info" ng-click="showCopyChecksheet(item)">\u30B3\u30D4\u30FC</button> <button type="button" class="btn btn-xs btn-info" ng-click="showCheckAllInfo(item.checksheetId,item.checksheetName)">\u95B2\u89A7</button> <button type="button" class="btn btn-xs btn-info" ng-click="showDownloadInfo(item.checksheetId,item.checksheetName)">\u5831\u544A\u66F8</button></td></tr></tbody><tfoot><tr><td class="text-left" colspan="9"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/checklist/listDetail.html','<div style="position: absolute; top: 5px; right: 20px;"><span style="margin-right:12px;" id="release_button"></span> <button type="button" class="btn btn-info" ng-click="showDownloadInfo(null, null)" style="margin-right: 12px;">\u5831\u544A\u66F8\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8</button> <button ng-if="isUsedByTicket" type="button" class="btn btn-info" ng-click="versionUp();" style="margin-right: 12px;">\u30D0\u30FC\u30B8\u30E7\u30F3\u30A2\u30C3\u30D7</button> <button type="button" class="btn btn-info" ng-click="showCheckAllInfoAtDetail()" style="margin-right: 12px;">\u95B2\u89A7</button> <button type="button" class="btn btn-danger" ng-click="deleteChecksheet()">\u524A\u9664</button></div><form editable-form="" shown="true" name="editableForm" onaftersave="saveList();" id="release_flag"><h4 style="margin-bottom: 25px;" class="grid-h">\u78BA\u8A8D\u306E\u7A0B\u5EA6\uFF1A<span editable-text="selectedCheckSheet.frequency" e-style="width:680px" e-name="checksheetName" onbeforesave="checkSubject($data)" e-maxlength="256">{{ selectedCheckSheet.frequency }}</span></h4><button type="button" class="btn btn-primary" style="position: absolute; top: 53px; right: 15px;" ng-click="editableForm.$show();openEdit()" ng-show="!editableForm.$visible">\u7DE8\u96C6</button> <span style="position: absolute; top: 53px; right: 15px;" ng-show="editableForm.$visible"><button type="submit" class="btn btn-info" ng-disabled="editableForm.$waiting">\u4FDD\u5B58</button></span><checklist-content></checklist-content></form>');
$templateCache.put('app/pages/checklist/newList.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" ng-if="!isCopy">\u30C1\u30A7\u30C3\u30AF\u767B\u9332</h4><h4 class="modal-title" ng-if="isCopy">\u30C1\u30A7\u30C3\u30AF\u30B3\u30D4\u30FC</h4></div><div class="modal-body text-left"><h5 ng-if="isCopy">\u30B3\u30D4\u30FC\u5143\uFF1A{{copyMoto.checksheetName}}</h5><h5 ng-if="isCopy">\u30B3\u30D4\u30FC\u5148\u306E\u60C5\u5831\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002</h5><table class="table table-bordered" style="border: none; border-collapse:separate; border-spacing:0px 2px; table-layout: fixed;"><tbody><tr><th style="width:15%">\u533A\u5206\uFF1A<label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%"><select class="form-control selectpicker" selectpicker="" style="max-width:200px" ng-model="ctrl.first" ng-disabled="firstDisable" ng-change="changeFirst()" ng-options="item as item.label for item in firstList"></select></td><th style="width:15%">\u5927\u9805\u76EE\uFF1A<label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.second" ng-disabled="secondDisable" ng-change="changeSecond()" ng-options="item as item.label for item in secondList"></select></td></tr><tr><th style="width:15%">\u4E2D\u9805\u76EE\uFF1A<label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.third" ng-disabled="thirdDisable" ng-change="changeThird()" ng-options="item as item.label for item in thirdList"></select></td><th style="width:15%">\u5C0F\u9805\u76EE\uFF1A<label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.fourth" ng-disabled="fourthDisable" ng-options="item as item.label for item in fourthList"></select></td></tr><tr><th style="width:15%">\u78BA\u8A8D\u306E\u7A0B\u5EA6\uFF1A</th><td style="border: none; width:35%"><input type="text" class="form-control" ng-model="ctrl.frequency" maxlength="256"></td><th style="width:15%"></th><td style="border: none; width:35%"></td></tr></tbody></table></div><div class="modal-footer"><button ng-if="!isCopy" type="button" class="btn btn-info" click-and-disable="createCheckSheet()">\u767B\u9332</button> <button ng-if="isCopy" type="button" class="btn btn-info" click-and-disable="copyCheckSheet()">\u30B3\u30D4\u30FC</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/checklist/otherChecksheetList.html','<div class="modal-content" style="width:1075px"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">{{otherProjectName}}\u30C1\u30A7\u30C3\u30AF\u4E00\u89A7</h4></div><div class="modal-body text-left" style="overflow-y: auto;"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-change="resetPage()" ng-model="defaultListPageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="listData" st-safe-src="otherChecksheetList" style="table-layout: fixed;" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th class="table-id" style="width: 35px">#</th><th st-sort="first" st-sort-default="obverse" style="width: 170px">\u533A\u5206</th><th st-sort="second" style="width: 156px">\u5927\u9805\u76EE</th><th st-sort="third" style="width: 226px">\u4E2D\u9805\u76EE</th><th st-sort="fourth" style="width: 263px">\u5C0F\u9805\u76EE</th><th st-sort="version" style="width: 45px">Ver.</th><th style="width: 168px;">\u64CD\u4F5C</th></tr><tr><th></th><th><select st-search="first" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'first\'" value="{{item.first}}">{{item.first}}</option></select></th><th><select st-search="second" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'second\'" value="{{item.second}}">{{item.second}}</option></select></th><th><select st-search="third" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'third\'" value="{{item.third}}">{{item.third}}</option></select></th><th><select st-search="fourth" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fourth\'" value="{{item.fourth}}">{{item.fourth}}</option></select></th><th><select st-search="version" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'version\'" value="{{item.version}}">{{item.version}}</option></select></th><th><button type="button" class="btn btn-xs btn-info" ng-click="copyOtherChecksheetList()">\u4E00\u62EC\u30B3\u30D4\u30FC</button> <label class="checkbox-inline custom-checkbox nowrap" style="padding-left: 45px;"><input type="checkbox" value="01" ng-model="ctrl.allChoice" choice-dchecksheet=""> <span style="display: initial;padding-left: 0;"></span></label></th></tr></thead><tbody><tr ng-repeat="item in listData"><td class="table-id" style="overflow: hidden">{{$index + 1}}</td><td style="white-space: nowrap; overflow: hidden"><p style="overflow: hidden; text-overflow: ellipsis">{{item.first}}</p></td><td style="white-space: nowrap; overflow: hidden"><p style="overflow: hidden; text-overflow: ellipsis">{{item.second}}</p></td><td style="white-space: nowrap; overflow: hidden"><p style="overflow: hidden; text-overflow: ellipsis">{{item.third}}</p></td><td style="white-space: nowrap; overflow: hidden"><p style="overflow: hidden; text-overflow: ellipsis">{{item.fourth}}</p></td><td style="white-space: nowrap; overflow: hidden"><p style="overflow: hidden; text-overflow: ellipsis">{{$root.padLeft(item.version, 3) }}</p></td><td style="overflow: hidden"><button type="button" class="btn btn-xs btn-info" click-and-disable="copyOtherChecksheet(item)">\u30B3\u30D4\u30FC</button> <button type="button" class="btn btn-xs btn-info" ng-click="showCheckAllInfo(item.checksheetId,item.checksheetName)">\u95B2\u89A7</button> <label class="checkbox-inline custom-checkbox nowrap" style="padding-left: 25px; margin-left: 5px;"><input type="checkbox" value="item.id" ng-model="ctrl.checksheetChoice[item.checksheetId]"> <span style="display: initial;padding-left: 0;"></span></label></td></tr></tbody><tfoot><tr><td class="text-left" colspan="9"><div st-pagination="" st-items-by-page="defaultListPageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/checklist/progressModalProcessing.html','<div class="modal-content"><div class="modal-body"><table style="width: 100%;"><tr><td style="color: #d45a00;text-align: center;"><h3>\u51E6\u7406\u4E2D\u30FB\u30FB\u30FB</h3></td></tr><tr><td style="text-align: center;"><img src="assets/img/loading01.gif" alt="Loading" style="width: 50px;"></td></tr></table></div></div>');
$templateCache.put('app/pages/checklist/projectList.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u4ED6\u696D\u52D9\u4E00\u89A7</h4></div><div class="modal-body text-left" style="overflow-y: auto;"><span style="font-size: 20px;" ng-if="projectList.length > 0">\u4ED6\u696D\u52D9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span><table class="table-project"><tr ng-repeat="item in projectList"><td><a href="javascript:;" ng-click="showOtherChecklist(item.projectId, item.projectName);$dismiss()">{{$index+1}}.{{item.projectName}}</a></td></tr></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/checkreport/checkListFileList.html','<div class="horizontal-scroll" ng-if="checkListFileList.length > 0" style="border-top: 1px solid rgba(0, 0, 0, 0.12);"><table class="table" st-table="fileListCopy" st-safe-src="checkListFileList" st-set-filter="customFilter" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th style="text-align:left" st-sort="fileName">\u30D5\u30A1\u30A4\u30EB\u540D</th><th st-sort="size">\u30B5\u30A4\u30BA</th><th st-sort="userName">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u8005</th><th st-sort="updateTime">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u65E5\u6642</th></tr><tr><th><select st-search="fileName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fileName\'" value="{{item.fileName}}">{{item.fileName}}</option></select></th><th><select st-search="size" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'size\'" value="{{item.size}}">{{item.size}}</option></select></th><th><select st-search="userName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userName\'" value="{{item.userName}}">{{item.userName}}</option></select></th><th><select st-search="updateTime" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'updateTime\'" value="{{item.updateTime}}">{{item.updateTime}}</option></select></th></tr></thead><tbody><tr ng-repeat="item in fileListCopy"><td style="white-space: nowrap; width: 30%" class="table-id"><a href="javascript:;" ng-click="downLoadFile(item);">{{item.fileName}}</a> <button ng-show="isImg(item.fileName)" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="previewImage(item)"><i class="material-icons">open_in_new</i></button></td><td style="white-space: nowrap; text-align:right; width: 10%">{{ $root.getFileSize(item.size) }}</td><td style="white-space: nowrap; width: 20%">{{ item.userName }}</td><td style="white-space: nowrap; width: 20%">{{ item.updateTime }}</td></tr></tbody><tfoot><tr><td colspan="14" class="text-left"></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/checkreport/checkreport.html','<div class="widgets" ng-if="!$root.isMoblie"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="<a href=\'javascript:;\' ng-click=\'showCheckreportList();\'>\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u4E00\u89A7</a>" ba-panel-class="with-scroll"><div include-with-scope="app/pages/checkreport/checkreportList.html"></div></div></div></div></div><div class="widgets" ng-if="$root.isMoblie"><div class="row"><div class="col-md-12" style="padding :0;" id="checkreportList"><div ba-panel="" ba-panel-title="<a href=\'javascript:;\' ng-click=\'showCheckreportList();\'>\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u4E00\u89A7</a>" ba-panel-class="sp-panel"><div include-with-scope="app/pages/checkreport/sp/checkreportListSp.html"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="sp-panel" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u8A73\u7D30\uFF08ID\uFF1A{{$root.padLeft(reportId, 8)}}\uFF09" id="checkreportDetailSp" style="display: none; padding :0;"><div ng-include="\'app/pages/checkreport/sp/checkreportDetailSp.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="sp-panel" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u65B0\u898F" id="checkreportCreaterSp" style="display: none; padding :0;"><div ng-include="\'app/pages/checkreport/sp/checkreportCreaterSp.html\'"></div></div></div></div>');
$templateCache.put('app/pages/checkreport/checkreportCreater.html','<div class="col-md-12"><div class="table-responsive" style="border-bottom: 1px solid rgba(0, 0, 0, 0.12);" id="ticketDiv"><table class="table table-bordered" style="border: none; border-spacing: 0px 2px; border-collapse: separate; table-layout: fixed;"><tbody><tr><th style="width:15%">{{targetNameItemName}}\uFF1A <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button style="margin-left: 10px; type=" button"="" class="btn btn-xs btn-info" ng-click="showCreateTarget()">\u8FFD\u52A0</button></th><td style="border: none; width:35%" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.target" ng-change="changeTarget()" ng-options="item as item.targetNameId for item in targetList"></select></td><th style="width:15%"></th><td style="border: none; width:35%"></td></tr><tr><th style="width:15%">\u533A\u5206\uFF1A <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.first" ng-change="changeFirst()" ng-options="item as item.label for item in firstList"></select></td><th style="width:15%">\u5927\u9805\u76EE\uFF1A <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.second" ng-disabled="secondDisable" ng-change="changeSecond()" ng-options="item as item.label for item in secondList"></select></td></tr><tr><th style="width:15%">\u4E2D\u9805\u76EE\uFF1A <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.third" ng-disabled="thirdDisable" ng-change="changeThird()" ng-options="item as item.label for item in thirdList"></select></td><th style="width:15%">\u5C0F\u9805\u76EE\uFF1A <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.fourth" ng-disabled="fourthDisable" ng-options="item as item.label for item in fourthList"></select></td></tr><tr><th>\u958B\u59CB\u65E5(\u4E88\u5B9A)\uFF1A</th><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-model="ctrl.startScheduledDate" type="text" placeholder="" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td><th>\u5B8C\u4E86\u65E5(\u4E88\u5B9A)\uFF1A</th><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-model="ctrl.endScheduledDate" type="text" placeholder="" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td></tr><tr><th>\u958B\u59CB\u65E5(\u5B9F\u7E3E)\uFF1A</th><td style="border: none;"></td><th>\u5B8C\u4E86\u65E5(\u5B9F\u7E3E)\uFF1A</th><td style="border: none;"></td></tr><tr><th>\u7BA1\u7406\u6280\u8853\u8005\uFF1A</th><td style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.requestUser" ng-options="item as item.userNameId for item in userList"></select></td><th>\u6307\u793A\u30B0\u30EB\u30FC\u30D7\uFF1A</th><td style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.requestGroup" ng-options="item as item.groupNameId for item in groupList"></select></td></tr><tr><th>\u62C5\u5F53\u6280\u8853\u8005\uFF1A</th><td style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.responseUser" ng-options="item as item.userNameId for item in userList"></select></td><th>\u62C5\u5F53\u6280\u8853\u8005\u30B0\u30EB\u30FC\u30D7\uFF1A</th><td style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.responseGroup" ng-options="item as item.groupNameId for item in groupList"></select></td></tr><tr><th>\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7\uFF1A</th><td style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><ui-select multiple="" ng-model="readingGroups.selected" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="">{{$item.groupNameId}}</ui-select-match><ui-select-choices repeat="readingGroups in groupList | filter: $select.search">{{readingGroups.groupNameId}}</ui-select-choices></ui-select></td><th>\u30B9\u30C6\u30FC\u30BF\u30B9\uFF1A</th><td style="border: none;"><span>{{ $root.getStatusShowName(\'01\') }}</span></td></tr><tr ng-if="parentTicket == \'1\'"><th>\u89AA\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\uFF1A</th><td style="border: none;"><span><a href="javascript:;" ng-click="showCheckreportDetail(parentId);">{{ $root.padLeft(parentId, 8) }}</a></span></td><th ng-if="showStatusDetail">{{statusDetailItemName}}\uFF1A <label ng-if="mustStatusDetail" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="showStatusDetail" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.statusDetailOb" ng-options="item as item.label for item in statusDetailList"></select></td><th ng-if="! showStatusDetail && showKbn2">{{kbn2ItemName}}\uFF1A <label ng-if="mustKbn2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && showKbn2" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && showKbn3">{{kbn3ItemName}}\uFF1A <label ng-if="mustKbn3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && showKbn3" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && showKbn4">{{kbn4ItemName}}\uFF1A <label ng-if="mustKbn4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && showKbn4" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && showKbn5">{{kbn5ItemName}}\uFF1A <label ng-if="mustKbn5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && showKbn5" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && showItem1">{{item1ItemName}}\uFF1A <label ng-if="mustItem1" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && showItem1" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item1" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && showItem2">{{item2ItemName}}\uFF1A <label ng-if="mustItem2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && showItem2" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item2" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && showItem3">{{item3ItemName}}\uFF1A <label ng-if="mustItem3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && showItem3" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item3" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && showItem4">{{item4ItemName}}\uFF1A <label ng-if="mustItem4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && showItem4" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item4" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && !showItem4 && showItem5">{{item5ItemName}}\uFF1A <label ng-if="mustItem5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && !showItem4 && showItem5" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item5" maxlength="256"></td><th ng-if="numOfShow == 0"></th><td ng-if="numOfShow == 0" style="border: none;"></td></tr><tr ng-if="parentTicket != \'1\' && numOfShow <= 1"><th ng-if="showStatusDetail">{{statusDetailItemName}}\uFF1A <label ng-if="mustStatusDetail" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="showStatusDetail" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.statusDetailOb" ng-options="item as item.label for item in statusDetailList"></select></td><th ng-if="! showStatusDetail && showKbn2">{{kbn2ItemName}}\uFF1A <label ng-if="mustKbn2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && showKbn2" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && showKbn3">{{kbn3ItemName}}\uFF1A <label ng-if="mustKbn3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && showKbn3" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && showKbn4">{{kbn4ItemName}}\uFF1A <label ng-if="mustKbn4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && showKbn4" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && showKbn5">{{kbn5ItemName}}\uFF1A <label ng-if="mustKbn5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && showKbn5" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && showItem1">{{item1ItemName}}\uFF1A <label ng-if="mustItem1" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && showItem1" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item1" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && showItem2">{{item2ItemName}}\uFF1A <label ng-if="mustItem2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && showItem2" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item2" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && showItem3">{{item3ItemName}}\uFF1A <label ng-if="mustItem3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && showItem3" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item3" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && showItem4">{{item4ItemName}}\uFF1A <label ng-if="mustItem4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && showItem4" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item4" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && !showItem4 && showItem5">{{item5ItemName}}\uFF1A <label ng-if="mustItem5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && !showItem4 && showItem5" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item5" maxlength="256"></td><th></th><td style="border: none;"></td></tr><tr ng-if="numOfShow > 1" ng-repeat="ticketItem in ticketItemList"><th>{{ ticketItem.left.showName }}\uFF1A <label ng-if="ticketItem.left.isShow == \'3\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="ticketItem.left.fieldName == \'statusDetail\'" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.statusDetailOb" ng-options="item as item.label for item in statusDetailList"></select></td><td ng-if="ticketItem.left.fieldName == \'kbn2\'" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select></td><td ng-if="ticketItem.left.fieldName == \'kbn3\'" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select></td><td ng-if="ticketItem.left.fieldName == \'kbn4\'" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select></td><td ng-if="ticketItem.left.fieldName == \'kbn5\'" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></td><td ng-if="ticketItem.left.fieldName == \'item1\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item1" maxlength="256"></td><td ng-if="ticketItem.left.fieldName == \'item2\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item2" maxlength="256"></td><td ng-if="ticketItem.left.fieldName == \'item3\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item3" maxlength="256"></td><td ng-if="ticketItem.left.fieldName == \'item4\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item4" maxlength="256"></td><td ng-if="ticketItem.left.fieldName == \'item5\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item5" maxlength="256"></td><th ng-if="ticketItem.right">{{ ticketItem.right.showName }}\uFF1A <label ng-if="ticketItem.right.isShow == \'3\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="ticketItem.right.fieldName == \'statusDetail\'" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.statusDetailOb" ng-options="item as item.label for item in statusDetailList"></select></td><td ng-if="ticketItem.right.fieldName == \'kbn2\'" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select></td><td ng-if="ticketItem.right.fieldName == \'kbn3\'" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select></td><td ng-if="ticketItem.right.fieldName == \'kbn4\'" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select></td><td ng-if="ticketItem.right.fieldName == \'kbn5\'" style="border: none;" ng-click="scrollToBottom(\'ticketDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></td><td ng-if="ticketItem.right.fieldName == \'item1\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item1" maxlength="256"></td><td ng-if="ticketItem.right.fieldName == \'item2\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item2" maxlength="256"></td><td ng-if="ticketItem.right.fieldName == \'item3\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item3" maxlength="256"></td><td ng-if="ticketItem.right.fieldName == \'item4\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item4" maxlength="256"></td><td ng-if="ticketItem.right.fieldName == \'item5\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item5" maxlength="256"></td><th ng-if="!ticketItem.right"></th><td ng-if="!ticketItem.right" style="border: none;"></td></tr><tr><th colspan="4" style="text-align: center;"><button type="button" class="btn btn-info" ng-click="createTicket()">\u767B\u9332</button></th></tr></tbody></table></div></div>');
$templateCache.put('app/pages/checkreport/checkreportDetail.html','<div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info" ng-click="downloadTicket(\'1\')">\u767D\u7D19\u5E33\u7968</button> <button type="button" class="btn btn-info" ng-click="downloadTicket(\'0\')">\u5831\u544A\u66F8\u51FA\u529B</button> <button ng-if="isEditer && (ticket.statusId != \'03\' && ticket.statusId != \'04\' && ticket.statusId != \'05\') && parentTicket == \'1\'" type="button" class="btn btn-info" ng-click="showCreateSubTicket()">\u30B5\u30D6\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8</button> <button ng-if="isEditer" type="button" class="btn btn-info" ng-click="copyTicket()">\u30B3\u30D4\u30FC</button> <button ng-if="isRequester" type="button" class="btn btn-danger" ng-click="CheckreportDelete()">\u524A\u9664</button><div ng-if="isEditer" class="btn-toolbar-example" style="padding-right: 50px;"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"><div ng-if="ticket.statusId != \'04\' && ticket.statusId != \'05\'" class="btn-group" role="group" aria-label="First group"><button type="button" class="btn btn-info" ng-if="ticket.statusId != \'03\' && isResponser" ng-click="modifyStatus(\'03\')">\u30C1\u30A7\u30C3\u30AF\u5B8C\u4E86</button> <button ng-if="ticket.statusId == \'03\' && isResponser" type="button" class="btn btn-info" ng-click="modifyStatus(\'02\')">&nbsp;\u5F15\u623B\u3057&nbsp;</button></div><form name="sendReportFlag" style="display:inline-block;white-space:nowrap;" ng-if="ticket.statusId != \'03\' && isResponser && commentWithMail == \'1\'"><label class="custom-checkbox browser-checkbox" ng-if="ticket.statusId != \'03\' && isResponser" for="reportSend"><input name="reportSend" type="checkbox" value="send" id="reportSend" checked=""> <span>\u901A\u77E5\u30E1\u30FC\u30EB\u306B\u5831\u544A\u66F8\u3092\u6DFB\u4ED8\u3059\u308B</span></label></form><div ng-if="(mngFlg == \'1\' || mngFlg ==\'2\' ) && (ticket.statusId == \'03\' || ticket.statusId == \'04\' || ticket.statusId == \'05\')" class="btn-group" role="group" aria-label="Second group"><button ng-if="ticket.statusId == \'03\'" type="button" class="btn btn-primary" ng-click="modifyStatus(\'04\')">&nbsp;&nbsp;\u627F\u8A8D&nbsp;&nbsp;</button> <button ng-if="mngFlg ==\'2\' && ticket.statusId == \'04\' && finalApproval ==\'1\'" type="button" class="btn btn-primary" ng-click="modifyStatus(\'05\')">\u6700\u7D42\u627F\u8A8D</button> <button type="button" class="btn btn-primary" ng-click="modifyStatus(\'99\')">&nbsp;\u5DEE\u623B\u3057&nbsp;</button></div></div></div></div><div class="col-md-12"><form editable-form="" name="editableForm" onaftersave="modifyTicket()"><button type="button" class="btn btn-primary" ng-if="isEditer" style="position: absolute; right: 15px; top:-10px;" ng-click="editableForm.$show()" ng-show="!editableForm.$visible">\u7DE8\u96C6</button> <span style="position: absolute; right: 15px; top:-15px;" ng-show="editableForm.$visible"><button type="button" class="btn btn-danger" ng-disabled="editableForm.$waiting" ng-click="editableForm.$cancel()">\u53D6\u6D88</button></span><div ng-show="!editableForm.$visible" class="table-responsive" style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); margin-top: 25px;"><table class="table table-bordered" style="border: none; border-spacing: 0px 2px; border-collapse: separate;"><tbody><tr><th style="width:15%">{{targetNameItemName}}\uFF1A</th><td style="border: none; width:35%"><a href="javascript:;" ng-click="showTargetInfo(ticket.targetId);">{{ ticket.targetName }}</a></td><th style="width:15%"></th><td style="border: none; width:35%"></td></tr><tr><th style="width:15%">\u533A\u5206\uFF1A</th><td style="border: none; width:35%">{{ ticket.first }}</td><th style="width:15%">\u5927\u9805\u76EE\uFF1A</th><td style="border: none; width:35%">{{ ticket.second }}</td></tr><tr><th style="width:15%">\u4E2D\u9805\u76EE\uFF1A</th><td style="border: none; width:35%">{{ ticket.third }}</td><th style="width:15%">\u5C0F\u9805\u76EE\uFF1A</th><td style="border: none; width:35%"><a href="javascript:;" ng-click="scrollToCheckList();">{{ ticket.fourth }}</a></td></tr><tr><th>\u958B\u59CB\u65E5(\u4E88\u5B9A)\uFF1A</th><td style="border: none;">{{ ticket.startScheduledDate }}</td><th>\u5B8C\u4E86\u65E5(\u4E88\u5B9A)\uFF1A</th><td style="border: none;">{{ ticket.endScheduledDate }}</td></tr><tr><th>\u958B\u59CB\u65E5(\u5B9F\u7E3E)\uFF1A</th><td style="border: none;">{{ ticket.startDate }}</td><th>\u5B8C\u4E86\u65E5(\u5B9F\u7E3E)\uFF1A</th><td style="border: none;">{{ ticket.endDate }}</td></tr><tr><th>\u7BA1\u7406\u6280\u8853\u8005\uFF1A</th><td style="border: none;"><a href="javascript:;" ng-click="showUserInfo(ticket.requestUserId);">{{ ticket.requestUserName }}</a></td><th>\u6307\u793A\u30B0\u30EB\u30FC\u30D7\uFF1A</th><td style="border: none;"><a href="javascript:;" ng-click="showGroupUserList(ticket.requestGroupId);">{{ ticket.requestGroupName }}</a></td></tr><tr><th>\u62C5\u5F53\u6280\u8853\u8005\uFF1A</th><td style="border: none;"><a href="javascript:;" ng-click="showUserInfo(ticket.responseUserId);">{{ ticket.responseUserName }}</a></td><th>\u62C5\u5F53\u6280\u8853\u8005\u30B0\u30EB\u30FC\u30D7\uFF1A</th><td style="border: none;"><a href="javascript:;" ng-click="showGroupUserList(ticket.responseGroupId);">{{ ticket.responseGroupName }}</a></td></tr><tr><th>\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7\uFF1A</th><td style="border: none;"><span ng-repeat="item in ticket.readingGrouplist"><a href="javascript:;" ng-click="showGroupUserList(item.groupId);">{{ item.groupName }}</a>&nbsp;&nbsp;</span></td><th>\u30B9\u30C6\u30FC\u30BF\u30B9\uFF1A</th><td style="border: none;">{{ ticket.statusName }}</td></tr><tr ng-if="parentTicket == \'1\'"><th>\u89AA\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\uFF1A</th><td style="border: none;"><a ng-if="ticket.parentId != 0" href="javascript:;" ng-click="showParentTicketDetail();">{{ $root.padLeft(ticket.parentId, 8) }}</a><span ng-if="ticket.parentId == 0">\u306A\u3057</span></td><th ng-if="showStatusDetail">{{statusDetailItemName}}\uFF1A</th><td ng-if="showStatusDetail" style="border: none;">{{ ticket.statusDetail }}</td><th ng-if="! showStatusDetail && showKbn2">{{kbn2ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && showKbn2" style="border: none;">{{ ticket.kbn2 }}</td><th ng-if="! showStatusDetail && !showKbn2 && showKbn3">{{kbn3ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && showKbn3" style="border: none;">{{ ticket.kbn3 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && showKbn4">{{kbn4ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && showKbn4" style="border: none;">{{ ticket.kbn4 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && showKbn5">{{kbn5ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && showKbn5" style="border: none;">{{ ticket.kbn5 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && showItem1">{{item1ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && showItem1" style="border: none;">{{ ticket.item1 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && showItem2">{{item2ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && showItem2" style="border: none;">{{ ticket.item2 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && showItem3">{{item3ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && showItem3" style="border: none;">{{ ticket.item3 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && showItem4">{{item4ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && showItem4" style="border: none;">{{ ticket.item4 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && !showItem4 && showItem5">{{item5ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && !showItem4 && showItem5" style="border: none;">{{ ticket.item5 }}</td><th ng-if="numOfShow == 0"></th><td ng-if="numOfShow == 0" style="border: none;"></td></tr><tr ng-if="parentTicket != \'1\' && numOfShow <= 1"><th ng-if="showStatusDetail">{{statusDetailItemName}}\uFF1A</th><td ng-if="showStatusDetail" style="border: none;">{{ ticket.statusDetail }}</td><th ng-if="! showStatusDetail && showKbn2">{{kbn2ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && showKbn2" style="border: none;">{{ ticket.kbn2 }}</td><th ng-if="! showStatusDetail && !showKbn2 && showKbn3">{{kbn3ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && showKbn3" style="border: none;">{{ ticket.kbn3 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && showKbn4">{{kbn4ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && showKbn4" style="border: none;">{{ ticket.kbn4 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && showKbn5">{{kbn5ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && showKbn5" style="border: none;">{{ ticket.kbn5 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && showItem1">{{item1ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && showItem1" style="border: none;">{{ ticket.item1 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && showItem2">{{item2ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && showItem2" style="border: none;">{{ ticket.item2 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && showItem3">{{item3ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && showItem3" style="border: none;">{{ ticket.item3 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && showItem4">{{item4ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && showItem4" style="border: none;">{{ ticket.item4 }}</td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && !showItem4 && showItem5">{{item5ItemName}}\uFF1A</th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && !showItem4 && showItem5" style="border: none;">{{ ticket.item5 }}</td><th></th><td style="border: none;"></td></tr><tr ng-if="numOfShow > 1" ng-repeat="ticketItem in ticketItemList"><th>{{ ticketItem.left.showName }}\uFF1A</th><td ng-if="ticketItem.left.fieldName == \'statusDetail\'" style="border: none;">{{ ticket.statusDetail }}</td><td ng-if="ticketItem.left.fieldName == \'kbn2\'" style="border: none;">{{ ticket.kbn2 }}</td><td ng-if="ticketItem.left.fieldName == \'kbn3\'" style="border: none;">{{ ticket.kbn3 }}</td><td ng-if="ticketItem.left.fieldName == \'kbn4\'" style="border: none;">{{ ticket.kbn4 }}</td><td ng-if="ticketItem.left.fieldName == \'kbn5\'" style="border: none;">{{ ticket.kbn5 }}</td><td ng-if="ticketItem.left.fieldName == \'item1\'" style="border: none;">{{ ticket.item1 }}</td><td ng-if="ticketItem.left.fieldName == \'item2\'" style="border: none;">{{ ticket.item2 }}</td><td ng-if="ticketItem.left.fieldName == \'item3\'" style="border: none;">{{ ticket.item3 }}</td><td ng-if="ticketItem.left.fieldName == \'item4\'" style="border: none;">{{ ticket.item4 }}</td><td ng-if="ticketItem.left.fieldName == \'item5\'" style="border: none;">{{ ticket.item5 }}</td><th ng-if="ticketItem.right">{{ ticketItem.right.showName }}\uFF1A</th><td ng-if="ticketItem.right.fieldName == \'statusDetail\'" style="border: none;">{{ ticket.statusDetail }}</td><td ng-if="ticketItem.right.fieldName == \'kbn2\'" style="border: none;">{{ ticket.kbn2 }}</td><td ng-if="ticketItem.right.fieldName == \'kbn3\'" style="border: none;">{{ ticket.kbn3 }}</td><td ng-if="ticketItem.right.fieldName == \'kbn4\'" style="border: none;">{{ ticket.kbn4 }}</td><td ng-if="ticketItem.right.fieldName == \'kbn5\'" style="border: none;">{{ ticket.kbn5 }}</td><td ng-if="ticketItem.right.fieldName == \'item1\'" style="border: none;">{{ ticket.item1 }}</td><td ng-if="ticketItem.right.fieldName == \'item2\'" style="border: none;">{{ ticket.item2 }}</td><td ng-if="ticketItem.right.fieldName == \'item3\'" style="border: none;">{{ ticket.item3 }}</td><td ng-if="ticketItem.right.fieldName == \'item4\'" style="border: none;">{{ ticket.item4 }}</td><td ng-if="ticketItem.right.fieldName == \'item5\'" style="border: none;">{{ ticket.item5 }}</td><th ng-if="!ticketItem.right"></th><td ng-if="!ticketItem.right" style="border: none;"></td></tr></tbody></table></div><div ng-show="editableForm.$visible" class="table-responsive" style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); margin-top: 25px;" id="ticketDetailDiv"><table class="table table-bordered" style="border: none; border-spacing: 0px 2px; border-collapse: separate;"><tbody><tr><th style="width:15%">{{targetNameItemName}}\uFF1A</th><td style="border: none; width:35%"><a href="javascript:;" ng-click="showTargetInfo(ticket.targetId);">{{ ticket.targetName }}</a></td><th style="width:15%"></th><td style="border: none; width:35%"></td></tr><tr><th style="width:15%">\u533A\u5206\uFF1A</th><td style="border: none; width:35%">{{ ticket.first }}</td><th style="width:15%">\u5927\u9805\u76EE\uFF1A</th><td style="border: none; width:35%">{{ ticket.second }}</td></tr><tr><th style="width:15%">\u4E2D\u9805\u76EE\uFF1A</th><td style="border: none; width:35%">{{ ticket.third }}</td><th style="width:15%">\u5C0F\u9805\u76EE\uFF1A</th><td style="border: none; width:35%"><a href="javascript:;" ng-click="scrollToCheckList();">{{ ticket.fourth }}</a></td></tr><tr><th>\u958B\u59CB\u65E5(\u4E88\u5B9A)\uFF1A</th><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-model="ctrl.startScheduledDate" type="text" placeholder="" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td><th>\u5B8C\u4E86\u65E5(\u4E88\u5B9A)\uFF1A</th><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-model="ctrl.endScheduledDate" type="text" placeholder="" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td></tr><tr><th>\u958B\u59CB\u65E5(\u5B9F\u7E3E)\uFF1A</th><td style="border: none;">{{ ticket.startDate }}</td><th>\u5B8C\u4E86\u65E5(\u5B9F\u7E3E)\uFF1A</th><td style="border: none;">{{ ticket.endDate }}</td></tr><tr><th>\u7BA1\u7406\u6280\u8853\u8005\uFF1A</th><td style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.requestUser" ng-options="item as item.userNameId for item in userList"></select></td><th>\u6307\u793A\u30B0\u30EB\u30FC\u30D7\uFF1A</th><td style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.requestGroup" ng-options="item as item.groupNameId for item in groupList"></select></td></tr><tr><th>\u62C5\u5F53\u6280\u8853\u8005\uFF1A</th><td style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.responseUser" ng-options="item as item.userNameId for item in userList"></select></td><th>\u62C5\u5F53\u6280\u8853\u8005\u30B0\u30EB\u30FC\u30D7\uFF1A</th><td style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.responseGroup" ng-options="item as item.groupNameId for item in groupList"></select></td></tr><tr><th>\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7\uFF1A</th><td style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><ui-select multiple="" ng-model="readingGroups.selected" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="">{{$item.groupNameId}}</ui-select-match><ui-select-choices repeat="readingGroups in groupList | filter: $select.search">{{readingGroups.groupNameId}}</ui-select-choices></ui-select></td><th>\u30B9\u30C6\u30FC\u30BF\u30B9\uFF1A</th><td style="border: none;">{{ ticket.statusName }}</td></tr><tr ng-if="parentTicket == \'1\'"><th>\u89AA\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\uFF1A</th><td style="border: none;"><a ng-if="ticket.parentId != 0" href="javascript:;" ng-click="showParentTicketDetail();">{{ $root.padLeft(ticket.parentId, 8) }}</a><span ng-if="ticket.parentId == 0">\u306A\u3057</span></td><th ng-if="showStatusDetail">{{statusDetailItemName}}\uFF1A <label ng-if="mustStatusDetail" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="showStatusDetail" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.statusDetailOb" ng-options="item as item.label for item in statusDetailList"></select></td><th ng-if="! showStatusDetail && showKbn2">{{kbn2ItemName}}\uFF1A <label ng-if="mustKbn2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && showKbn2" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && showKbn3">{{kbn3ItemName}}\uFF1A <label ng-if="mustKbn3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && showKbn3" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && showKbn4">{{kbn4ItemName}}\uFF1A <label ng-if="mustKbn4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && showKbn4" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && showKbn5">{{kbn5ItemName}}\uFF1A <label ng-if="mustKbn5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && showKbn5" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && showItem1">{{item1ItemName}}\uFF1A <label ng-if="mustItem1" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && showItem1" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item1" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && showItem2">{{item2ItemName}}\uFF1A <label ng-if="mustItem2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && showItem2" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item2" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && showItem3">{{item3ItemName}}\uFF1A <label ng-if="mustItem3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && showItem3" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item3" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && showItem4">{{item4ItemName}}\uFF1A <label ng-if="mustItem4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && showItem4" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item4" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && !showItem4 && showItem5">{{item5ItemName}}\uFF1A <label ng-if="mustItem5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && !showItem4 && showItem5" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item5" maxlength="256"></td><th ng-if="numOfShow == 0"></th><td ng-if="numOfShow == 0" style="border: none;"></td></tr><tr ng-if="parentTicket != \'1\' && numOfShow <= 1"><th ng-if="showStatusDetail">{{statusDetailItemName}}\uFF1A <label ng-if="mustStatusDetail" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="showStatusDetail" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.statusDetailOb" ng-options="item as item.label for item in statusDetailList"></select></td><th ng-if="! showStatusDetail && showKbn2">{{kbn2ItemName}}\uFF1A <label ng-if="mustKbn2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && showKbn2" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && showKbn3">{{kbn3ItemName}}\uFF1A <label ng-if="mustKbn3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && showKbn3" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && showKbn4">{{kbn4ItemName}}\uFF1A <label ng-if="mustKbn4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && showKbn4" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && showKbn5">{{kbn5ItemName}}\uFF1A <label ng-if="mustKbn5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && showKbn5" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && showItem1">{{item1ItemName}}\uFF1A <label ng-if="mustItem1" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && showItem1" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item1" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && showItem2">{{item2ItemName}}\uFF1A <label ng-if="mustItem2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && showItem2" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item2" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && showItem3">{{item3ItemName}}\uFF1A <label ng-if="mustItem3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && showItem3" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item3" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && showItem4">{{item4ItemName}}\uFF1A <label ng-if="mustItem4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && showItem4" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item4" maxlength="256"></td><th ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && !showItem4 && showItem5">{{item5ItemName}}\uFF1A <label ng-if="mustItem5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="! showStatusDetail && !showKbn2 && !showKbn3 && !showKbn4 && !showKbn5 && ! showItem1 && !showItem2 && !showItem3 && !showItem4 && showItem5" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item5" maxlength="256"></td><th></th><td style="border: none;"></td></tr><tr ng-if="numOfShow > 1" ng-repeat="ticketItem in ticketItemList"><th>{{ ticketItem.left.showName }}\uFF1A <label ng-if="ticketItem.left.isShow == \'3\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="ticketItem.left.fieldName == \'statusDetail\'" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.statusDetailOb" ng-options="item as item.label for item in statusDetailList"></select></td><td ng-if="ticketItem.left.fieldName == \'kbn2\'" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select></td><td ng-if="ticketItem.left.fieldName == \'kbn3\'" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select></td><td ng-if="ticketItem.left.fieldName == \'kbn4\'" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select></td><td ng-if="ticketItem.left.fieldName == \'kbn5\'" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></td><td ng-if="ticketItem.left.fieldName == \'item1\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item1" maxlength="256"></td><td ng-if="ticketItem.left.fieldName == \'item2\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item2" maxlength="256"></td><td ng-if="ticketItem.left.fieldName == \'item3\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item3" maxlength="256"></td><td ng-if="ticketItem.left.fieldName == \'item4\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item4" maxlength="256"></td><td ng-if="ticketItem.left.fieldName == \'item5\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item5" maxlength="256"></td><th ng-if="ticketItem.right">{{ ticketItem.right.showName }}\uFF1A <label ng-if="ticketItem.right.isShow == \'3\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-if="ticketItem.right.fieldName == \'statusDetail\'" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.statusDetailOb" ng-options="item as item.label for item in statusDetailList"></select></td><td ng-if="ticketItem.right.fieldName == \'kbn2\'" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select></td><td ng-if="ticketItem.right.fieldName == \'kbn3\'" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select></td><td ng-if="ticketItem.right.fieldName == \'kbn4\'" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select></td><td ng-if="ticketItem.right.fieldName == \'kbn5\'" style="border: none;" ng-click="scrollToBottom(\'ticketDetailDiv\')"><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></td><td ng-if="ticketItem.right.fieldName == \'item1\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item1" maxlength="256"></td><td ng-if="ticketItem.right.fieldName == \'item2\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item2" maxlength="256"></td><td ng-if="ticketItem.right.fieldName == \'item3\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item3" maxlength="256"></td><td ng-if="ticketItem.right.fieldName == \'item4\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item4" maxlength="256"></td><td ng-if="ticketItem.right.fieldName == \'item5\'" style="border: none;"><input type="text" class="form-control" ng-model="ctrl.item5" maxlength="256"></td><th ng-if="!ticketItem.right"></th><td ng-if="!ticketItem.right" style="border: none;"></td></tr><tr><th colspan="4" style="text-align: center;"><button type="submit" class="btn btn-info">\u4FDD\u5B58</button></th></tr></tbody></table></div></form><div id="subTickets" ng-if="subTicketList.length > 0 && parentTicket == \'1\'"><h4 class="grid-h ng-scope" style="margin-bottom: 10px; margin-top: 20px;">\u30B5\u30D6\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8</h4><table class="table" style="border: none;" st-table="subTicketData" st-safe-src="subTicketList"><tr style="border-bottom: 1px solid rgba(0, 0, 0, 0.12);"><td style="border: none; text-align: left;">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8ID</td><td style="border: none;">\u30B9\u30C6\u30FC\u30BF\u30B9</td><td style="border: none;">\u958B\u59CB\u65E5(\u4E88\u5B9A)</td><td style="border: none;">\u5B8C\u4E86\u65E5(\u4E88\u5B9A)</td><td style="border: none;">\u958B\u59CB\u65E5(\u5B9F\u7E3E)</td><td style="border: none;">\u5B8C\u4E86\u65E5(\u5B9F\u7E3E)</td><td style="border: none;">\u62C5\u5F53\u6280\u8853\u8005</td><td style="border: none;">\u62C5\u5F53\u6280\u8853\u8005\u30B0\u30EB\u30FC\u30D7</td><td style="border: none;">{{targetNameItemName}}</td></tr><tr ng-repeat="item in subTicketData"><td style="border: none; text-align: left;"><a href="javascript:;" ng-click="showSubTicketDetail(item.id);">{{$root.padLeft(item.id, 8)}}</a></td><td style="border: none;">{{item.statusName}}</td><td style="border: none;">{{item.startScheduledDate}}</td><td style="border: none;">{{item.endScheduledDate}}</td><td style="border: none;">{{item.startDate}}</td><td style="border: none;">{{item.endDate}}</td><td style="border: none;">{{item.responseUserName}}</td><td style="border: none;">{{item.responseGroupName}}</td><td style="border: none;">{{item.targetName}}</td></tr></table></div></div>');
$templateCache.put('app/pages/checkreport/checkreportInfo.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u65B0\u898F" id="checkreportCreater"><div ng-include="\'app/pages/checkreport/checkreportCreater.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u8A73\u7D30\uFF08ID\uFF1A{{$root.padLeft(ticketId, 8)}}\uFF09" id="checkreportDetail"><div ng-include="\'app/pages/checkreport/checkreportDetail.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="\u30C1\u30A7\u30C3\u30AF" id="checkResultList"><div ng-include="\'app/pages/checkreport/checkResultList.html\'"></div></div></div><div class="row" id="comments"><div class="col-md-12 panel-body"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'strikeThrough\',\'ul\', \'ol\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'quote\',\'undo\',\'redo\', \'fontColor\']]"></text-angular-toolbar><text-angular name="htmlcontent" ta-target-toolbars="toolbarMain" ng-model="content"></text-angular></div><div class="panel-body"><button class="btn btn-info" type="button" ng-click="saveComment()">\u4FDD\u5B58</button></div></div></div><div class="col-md-12" ba-panel="" ba-panel-title="\u30B3\u30E1\u30F3\u30C8({{statusHistoryList.length}})" ba-panel-class="with-scroll" id="commentList"><div ng-repeat="comment in statusHistoryList" class="panel panel-default bootstrap-panel" style="border-style:solid;border-width:1px;box-shadow: none;border-color:#ddd"><div class="panel-heading"><img ng-src="{{comment.img}}" style="top: 4px; position: absolute; width: 35px;height: 35px;border-radius: 50%;vertical-align: text-top;"> <label style="margin-left: 40px; margin-right:10px;font-size:14px">{{comment.userName}}</label> <label style="margin-right:10px;font-size:14px">{{comment.updateTime}}</label> <label style="margin-right:10px;font-size:14px">{{comment.statusName}}</label> <button ng-if="comment.type == \'2\' && comment.userId == loginUserId" style="position: absolute; right: 10px; top: 5px;" class="btn btn-danger" type="button" ng-click="deleteComment(comment.id)">\u524A\u9664</button></div><div class="panel-body" ng-bind-html="comment.comment"></div></div></div></div></div>');
$templateCache.put('app/pages/checkreport/checkreportItemInfo.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss();reload();" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u9805\u76EE\u7DE8\u96C6</h4></div><div class="modal-body text-left"><table class="table table-bordered table-condensed"><tr><td style="text-align: center; width:5%">#</td><td style="width:25%">\u9805\u76EE\u540D</td><td style="width:35%">\u8868\u793A\u540D</td><td style="width:15%">\u8868\u793A/\u975E\u8868\u793A</td><td style="width:20%">\u64CD\u4F5C</td></tr><tr ng-repeat="item in itemTicketList" class="editable-row"><td>{{$index + 1}}</td><td ng-if="item.itemNameId == \'30000001\'"><a href="javascript:;" ng-click="showMasterDateStatus();">{{item.itemName}}</a></td><td ng-if="item.itemNameId != \'30000001\'">{{item.itemName}}</td><td><span editable-text="item.showName" e-name="showName" e-form="rowform" e-required="" e-maxlength="128">{{item.showName}}</span></td><td style="width:10%"><span ng-if="item.isShow != \'-\'" editable-select="item.isShow" e-name="isShow" e-form="rowform" e-selectpicker="" e-ng-options="i.id as i.text for i in showItemList">{{ showItemIsShow(item.isShow) }}</span> <span ng-if="item.isShow == \'-\'">{{item.isShow}}</span></td><td style="width:17%"><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" onaftersave="saveItem(item);"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-info editable-table-button btn-xs">\u4FDD\u5B58</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">\u53D6\u6D88</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">\u7DE8\u96C6</button></div></td></tr></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss();reload();">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/checkreport/checkreportList.html','<div class="horizontal-scroll"><div ng-if="$root.targetIdForTicket == null" style="position: absolute; top: 5px; right: 20px;"><button style="margin-right: 30px;" type="button" class="btn btn-info" ng-click="showItemInfo()" ng-if="mngFlg == \'2\'">\u9805\u76EE\u7DE8\u96C6</button> <button ng-if="showCondition" type="button" class="btn btn-primary" ng-click="openSearchCon()">\u691C\u7D22\u6761\u4EF6</button> <button type="button" class="btn btn-info" ng-click="showCheckreportList()">\u30EA\u30ED\u30FC\u30C9</button> <button type="button" class="btn btn-info" ng-click="showCheckreportCreate()">\u65B0\u898F</button></div><table style="border-collapse: separate; margin-bottom: 10px; border-spacing: 0px 5px; padding: 10px; border: 1px solid #ddd;" ng-if="showCondition && showCondition2"><tr><td style="width: 95px;text-align: right;">\u958B\u59CB\u65E5(\u4E88\u5B9A)\uFF1A</td><td style="border: none; width: 140px;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-change="getTicketNum()" ng-model="ctrl.sScheduledDateF" type="text" placeholder="FROM" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td><td style="width: 20px; text-align: center;">&nbsp;&nbsp;\uFF5E&nbsp;&nbsp;</td><td style="border: none; width: 140px;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-change="getTicketNum()" ng-model="ctrl.sScheduledDateT" type="text" placeholder="TO" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td><td style="width: 95px;text-align: right;">\u5B8C\u4E86\u65E5(\u4E88\u5B9A)\uFF1A</td><td style="border: none; width: 140px;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-change="getTicketNum()" ng-model="ctrl.eScheduledDateF" type="text" placeholder="FROM" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td><td style="width: 20px; text-align: center;">&nbsp;&nbsp;\uFF5E&nbsp;&nbsp;</td><td style="border: none; width: 140px;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-change="getTicketNum()" ng-model="ctrl.eScheduledDateT" type="text" placeholder="TO" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td></tr><tr><td style="width: 95px;text-align: right;">\u958B\u59CB\u65E5(\u5B9F\u7E3E)\uFF1A</td><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-change="getTicketNum()" ng-model="ctrl.sDateF" type="text" placeholder="FROM" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td><td style="width: 20px; text-align: center;">&nbsp;&nbsp;\uFF5E&nbsp;&nbsp;</td><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-change="getTicketNum()" ng-model="ctrl.sDateT" type="text" placeholder="TO" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td><td style="width: 95px;text-align: right;">\u5B8C\u4E86\u65E5(\u5B9F\u7E3E)\uFF1A</td><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-change="getTicketNum()" ng-model="ctrl.eDateF" type="text" placeholder="FROM" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td><td style="width: 20px; text-align: center;">&nbsp;&nbsp;\uFF5E&nbsp;&nbsp;</td><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-change="getTicketNum()" ng-model="ctrl.eDateT" type="text" placeholder="TO" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td></tr><tr><td colspan="8" style="padding-top: 10px; text-align: center;"><button style="padding-right:10px" type="button" class="btn btn-primary" ng-click="getListByDate()">\u691C\u7D22</button> <button type="button" class="btn btn-danger" ng-click="clearCondition()">\u30AF\u30EA\u30A2</button> <button type="button" class="btn btn-danger" ng-click="closeSearchCon()">\u9589\u3058\u308B</button></td></tr></table><div class="form-group select-page-size-wrap" style="position: absolute;"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-change="resetPage()" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="reportData" st-safe-src="checkreportList" style="margin-top: 70px;margin-bottom: 50px;" st-filtered-collection="stFilteredCollection"><thead><tr><td><span ng-if="showCondition && showCondition2" style="top: 281px;position: absolute;">\u5408\u8A08\uFF1A &nbsp;<table-size></table-size>&nbsp;\u4EF6</span> <span ng-if="(! showCondition || !showCondition2)" style="top: 125px;position: absolute;">\u5408\u8A08\uFF1A &nbsp;<table-size></table-size>&nbsp;\u4EF6</span></td></tr><tr ng-if="showCondition && showCondition2 && $root.targetIdForTicket == null"><td style="border: none;"><div style="position: absolute; top: 226px; right: 20px;"><button type="file" ngf-select="uploadFiles($file)" class="btn btn-info" accept=".csv, text/csv" ngf-max-size="10MB">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div></td></tr><tr ng-if="(! showCondition || !showCondition2 && $root.targetIdForTicket == null)"><td style="border: none;"><div style="position: absolute; top: 75px; right: 20px;"><button type="file" ngf-select="uploadFiles($file)" class="btn btn-info" accept=".csv, text/csv" ngf-max-size="10MB">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div></td></tr><tr class="sortable"><th><label class="checkbox-inline custom-checkbox nowrap" style="padding-left: 45px;"><input type="checkbox" value="01" ng-model="ctrl.allChoice" choice-ticket=""> <span style="display: initial;padding-left: 0;"></span></label></th><th class="table-id" st-sort="id">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8ID</th><th ng-if="progressFlg == \'1\'" st-sort="progress">\u9032\u6357</th><th st-sort="targetIdShow">{{targetIdItemName}}</th><th st-sort="targetName">{{targetNameItemName}}</th><th st-sort="statusId">\u30B9\u30C6\u30FC\u30BF\u30B9</th><th ng-if="showStatusDetail" st-sort="statusDetail">{{statusDetailItemName}}</th><th ng-if="showKbn2" st-sort="kbn2">{{kbn2ItemName}}</th><th ng-if="showKbn3" st-sort="kbn3">{{kbn3ItemName}}</th><th ng-if="showKbn4" st-sort="kbn4">{{kbn4ItemName}}</th><th ng-if="showKbn5" st-sort="kbn5">{{kbn5ItemName}}</th><th ng-if="showItem1" st-sort="item1">{{item1ItemName}}</th><th ng-if="showItem2" st-sort="item2">{{item2ItemName}}</th><th ng-if="showItem3" st-sort="item3">{{item3ItemName}}</th><th ng-if="showItem4" st-sort="item4">{{item4ItemName}}</th><th ng-if="showItem5" st-sort="item5">{{item5ItemName}}</th><th st-sort="first">\u533A\u5206</th><th st-sort="second">\u5927\u9805\u76EE</th><th st-sort="third">\u4E2D\u9805\u76EE</th><th st-sort="fourthAndVer">\u5C0F\u9805\u76EE(\u30D0\u30FC\u30B8\u30E7\u30F3)</th><th ng-if="showResult != \'1\'" st-sort="errNum">\u7570\u5E38</th><th ng-if="showFist" st-sort="targetFirstName">{{targetFirstItemName}}</th><th ng-if="showSecond" st-sort="targetSecondName">{{targetSecondItemName}}</th><th ng-if="showThird" st-sort="targetThirdName">{{targetThirdItemName}}</th><th st-sort="startScheduledDate">\u958B\u59CB\u65E5(\u4E88\u5B9A)</th><th st-sort="endScheduledDate">\u5B8C\u4E86\u65E5(\u4E88\u5B9A)</th><th st-sort="startDate">\u958B\u59CB\u65E5(\u5B9F\u7E3E)</th><th st-sort="endDate">\u5B8C\u4E86\u65E5(\u5B9F\u7E3E)</th><th st-sort="requestUserName">\u7BA1\u7406\u6280\u8853\u8005</th><th st-sort="requestGroupName">\u6307\u793A\u30B0\u30EB\u30FC\u30D7</th><th st-sort="responseUserName">\u62C5\u5F53\u6280\u8853\u8005</th><th st-sort="responseGroupName">\u62C5\u5F53\u6280\u8853\u8005\u30B0\u30EB\u30FC\u30D7</th><th st-sort="readingGroupName">\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7</th><th st-sort="parentId" ng-if="parentTicket == \'1\'">\u89AA\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8ID</th></tr><tr><th style="vertical-align: middle;"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info" uib-dropdown-toggle="">\u64CD\u4F5C <span class="caret"></span></button><ul uib-dropdown-menu="" style="min-width: initial;"><li ng-if="opFlg == 1"><a href="javascript:;" ng-click="deleteTicketList()">\u524A\u9664</a></li><li><a href="javascript:;" ng-click="ticketListZip()">\u5831\u544A\u66F8\u51FA\u529B</a></li><li><a href="javascript:;" ng-click="downloadCheckSheetList()">\u5B9F\u65BD\u4F5C\u696D\u4E00\u89A7\u8868\u51FA\u529B</a></li><li><a href="javascript:;" ng-click="ticketContentListZip()">\u5199\u771F\u51FA\u529B</a></li><li><a href="javascript:;" ng-click="downloadCheckResultCsv()">\u30C1\u30A7\u30C3\u30AF\u7D50\u679CCSV\u51FA\u529B</a></li><li><a href="javascript:;" ng-click="downloadTicketCsv()">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8CSV\u51FA\u529B</a></li></ul></div></th><th style="vertical-align: middle;"><select st-search="id" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'id\'" value="{{item.id}}">{{item.id}}</option></select></th><th ng-if="progressFlg == \'1\'" style="vertical-align: middle;"><select st-search="progress" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'progress\'" value="{{item.progress}}">{{item.progress}}</option></select></th><th style="vertical-align: middle;"><select st-search="targetIdShow" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'targetIdShow\'" value="{{item.targetIdShow}}">{{item.targetIdShow}}</option></select></th><th style="vertical-align: middle;"><select st-search="targetName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'targetName\'" value="{{item.targetName}}">{{item.targetName}}</option></select></th><th style="vertical-align: middle;"><select st-search="statusName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'statusName\'" value="{{item.statusName}}">{{item.statusName}}</option></select></th><th style="vertical-align: middle;" ng-if="showStatusDetail"><select st-search="statusDetail" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'statusDetail\'" value="{{item.statusDetail}}">{{item.statusDetail}}</option></select></th><th style="vertical-align: middle;" ng-if="showKbn2"><select st-search="kbn2" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'kbn2\'" value="{{item.kbn2}}">{{item.kbn2}}</option></select></th><th style="vertical-align: middle;" ng-if="showKbn3"><select st-search="kbn3" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'kbn3\'" value="{{item.kbn3}}">{{item.kbn3}}</option></select></th><th style="vertical-align: middle;" ng-if="showKbn4"><select st-search="kbn4" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'kbn4\'" value="{{item.kbn4}}">{{item.kbn4}}</option></select></th><th style="vertical-align: middle;" ng-if="showKbn5"><select st-search="kbn5" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'kbn5\'" value="{{item.kbn5}}">{{item.kbn5}}</option></select></th><th style="vertical-align: middle;" ng-if="showItem1"><select st-search="item1" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'item1\'" value="{{item.item1}}">{{item.item1}}</option></select></th><th style="vertical-align: middle;" ng-if="showItem2"><select st-search="item2" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'item2\'" value="{{item.item2}}">{{item.item2}}</option></select></th><th style="vertical-align: middle;" ng-if="showItem3"><select st-search="item3" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'item3\'" value="{{item.item3}}">{{item.item3}}</option></select></th><th style="vertical-align: middle;" ng-if="showItem4"><select st-search="item4" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'item4\'" value="{{item.item4}}">{{item.item4}}</option></select></th><th style="vertical-align: middle;" ng-if="showItem5"><select st-search="item5" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'item5\'" value="{{item.item5}}">{{item.item5}}</option></select></th><th style="vertical-align: middle;"><select st-search="first" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'first\'" value="{{item.first}}">{{item.first}}</option></select></th><th style="vertical-align: middle;"><select st-search="second" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'second\'" value="{{item.second}}">{{item.second}}</option></select></th><th style="vertical-align: middle;"><select st-search="third" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'third\'" value="{{item.third}}">{{item.third}}</option></select></th><th style="vertical-align: middle;"><select st-search="fourthAndVer" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fourthAndVer\'" value="{{item.fourthAndVer}}">{{item.fourthAndVer}}</option></select></th><th ng-if="showResult != \'1\'" style="vertical-align: middle;"><select st-search="errNum" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'errNum\'" value="{{item.errNum}}">{{item.errNum}}</option></select></th><th style="vertical-align: middle;" ng-if="showFist"><select st-search="targetFirstName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'targetFirstName\'" value="{{item.targetFirstName}}">{{item.targetFirstName}}</option></select></th><th style="vertical-align: middle;" ng-if="showSecond"><select st-search="targetSecondName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'targetSecondName\'" value="{{item.targetSecondName}}">{{item.targetSecondName}}</option></select></th><th style="vertical-align: middle;" ng-if="showThird"><select st-search="targetThirdName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'targetThirdName\'" value="{{item.targetThirdName}}">{{item.targetThirdName}}</option></select></th><th style="vertical-align: middle;"><select st-search="startScheduledDate" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'startScheduledDate\'" value="{{item.startScheduledDate}}">{{item.startScheduledDate}}</option></select></th><th style="vertical-align: middle;"><select st-search="endScheduledDate" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'endScheduledDate\'" value="{{item.endScheduledDate}}">{{item.endScheduledDate}}</option></select></th><th style="vertical-align: middle;"><select st-search="startDate" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'startDate\'" value="{{item.startDate}}">{{item.startDate}}</option></select></th><th style="vertical-align: middle;"><select st-search="endDate" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'endDate\'" value="{{item.endDate}}">{{item.endDate}}</option></select></th><th style="vertical-align: middle;"><select st-search="requestUserName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'requestUserName\'" value="{{item.requestUserName}}">{{item.requestUserName}}</option></select></th><th style="vertical-align: middle;"><select st-search="requestGroupName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'requestGroupName\'" value="{{item.requestGroupName}}">{{item.requestGroupName}}</option></select></th><th style="vertical-align: middle;"><select st-search="responseUserName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'responseUserName\'" value="{{item.responseUserName}}">{{item.responseUserName}}</option></select></th><th style="vertical-align: middle;"><select st-search="responseGroupName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'responseGroupName\'" value="{{item.responseGroupName}}">{{item.responseGroupName}}</option></select></th><th style="vertical-align: middle;"><select st-search="readingGroupName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'readingGroupName\'" value="{{item.readingGroupName}}">{{item.readingGroupName}}</option></select></th><th ng-if="parentTicket == \'1\'" style="vertical-align: middle;"><select st-search="parentId" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'parentId\'" value="{{item.parentId}}">{{item.parentId}}</option></select></th></tr></thead><tbody><tr ng-repeat="item in reportData"><td style="white-space: nowrap"><label class="checkbox-inline custom-checkbox nowrap" style="padding-left: 25px;"><input type="checkbox" value="item.id" ng-model="ctrl.ticketChoice[item.id]"> <span style="display: initial;padding-left: 0;"></span></label></td><td class="table-id"><a href="javascript:;" ng-click="showCheckreportDetail(item.id);">{{ $root.padLeft(item.id, 8) }}</a></td><td ng-if="progressFlg == \'1\'" style="white-space: nowrap; vertical-align: middle; padding-left: 0px;" ng-dblclick="showCheckreportDetail(item.id);"><div style="margin: auto;" class="progress" ng-if="item.progress == 100"><div class="progress-bar progress-bar-info" role="progressbar" style="width: {{item.progress}}%"><span>{{item.progress}}%</span></div></div><div style="margin: auto;" class="progress" ng-if="item.progress != 100"><div class="progress-bar progress-bar-danger" role="progressbar" style="width: {{item.progress}}%"><div style="width: 52px;" ng-if="item.progress >= 50">{{item.progress}}%</div><div style="color: #666666;width: 52px;" ng-if="item.progress < 50">{{item.progress}}%</div></div></div></td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.targetIdShow}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.targetName}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.statusName}}</td><td ng-if="showStatusDetail" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.statusDetail}}</td><td ng-if="showKbn2" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.kbn2}}</td><td ng-if="showKbn3" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.kbn3}}</td><td ng-if="showKbn4" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.kbn4}}</td><td ng-if="showKbn5" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.kbn5}}</td><td ng-if="showItem1" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.item1}}</td><td ng-if="showItem2" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.item2}}</td><td ng-if="showItem3" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.item3}}</td><td ng-if="showItem4" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.item4}}</td><td ng-if="showItem5" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.item5}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.first}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.second}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.third}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.fourthAndVer}}</td><td ng-if="item.errNum == 0 && showResult != \'1\'" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">0</td><td ng-if="item.errNum != 0 && showResult != \'1\'" style="white-space: nowrap;color: #F00;" ng-dblclick="showCheckreportDetail(item.id);">{{item.errNum}}</td><td ng-if="showFist" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.targetFirstName}}</td><td ng-if="showSecond" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.targetSecondName}}</td><td ng-if="showThird" style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.targetThirdName}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.startScheduledDate}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.endScheduledDate}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.startDate}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.endDate}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.requestUserName}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.requestGroupName}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.responseUserName}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.responseGroupName}}</td><td style="white-space: nowrap" ng-dblclick="showCheckreportDetail(item.id);">{{item.readingGroupName}}</td><td ng-if="parentTicket == \'1\'" class="table-id"><a href="javascript:;" ng-click="showCheckreportDetail(item.parentId);">{{ $root.padLeft(item.parentId, 8) }}</a></td></tr></tbody><tfoot><tr><td colspan="32" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10" style="position: absolute;"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/checkreport/checkreportTargetFileList.html','<div class="horizontal-scroll" ng-if="targetFileList.length > 0" style="border-top: 1px solid rgba(0, 0, 0, 0.12);"><table class="table" st-table="fileListCopy" st-safe-src="targetFileList" st-set-filter="customFilter" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th style="text-align:left" st-sort="fileName">\u30D5\u30A1\u30A4\u30EB\u540D</th><th st-sort="size">\u30B5\u30A4\u30BA</th><th st-sort="userName">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u8005</th><th st-sort="updateTime">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u65E5\u6642</th></tr><tr><th><select st-search="fileName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fileName\'" value="{{item.fileName}}">{{item.fileName}}</option></select></th><th><select st-search="size" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'size\'" value="{{item.size}}">{{item.size}}</option></select></th><th><select st-search="userName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userName\'" value="{{item.userName}}">{{item.userName}}</option></select></th><th><select st-search="updateTime" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'updateTime\'" value="{{item.updateTime}}">{{item.updateTime}}</option></select></th></tr></thead><tbody><tr ng-repeat="item in fileListCopy"><td style="white-space: nowrap; width: 30%" class="table-id"><a href="javascript:;" ng-click="downLoadFile(item);">{{item.fileName}}</a> <button ng-show="isImg(item.fileName)" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="previewImage(item)"><i class="material-icons">open_in_new</i></button></td><td style="white-space: nowrap; text-align:right; width: 10%">{{ $root.getFileSize(item.size) }}</td><td style="white-space: nowrap; width: 20%">{{ item.userName }}</td><td style="white-space: nowrap; width: 20%">{{ item.updateTime }}</td></tr></tbody><tfoot><tr><td colspan="14" class="text-left"></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/checkreport/checkreportTargetInfo.html','<div class="modal-content" style="width:1030px"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u5DE5\u4E8B\u60C5\u5831</h4></div><div class="modal-body text-left"><div class="table-responsive"><table class="table table-bordered" style="border: none; border-collapse:separate; border-spacing:0px 2px;"><tbody><tr ng-repeat="targetItem in targetItemList"><th style="width:15%">{{targetItem.left.showName}}\uFF1A</th><td style="border: none; width:35%"><span ng-show="targetItem.left.fieldName != \'region\' && targetItem.left.fieldName != \'prefCd\' && targetItem.left.fieldName != \'first\' && targetItem.left.fieldName != \'second\' && targetItem.left.fieldName != \'third\'">{{ selectedTarget[targetItem.left.fieldName] }}</span> <span ng-show="targetItem.left.fieldName == \'first\'">{{ selectedTarget.firstName }}</span> <span ng-show="targetItem.left.fieldName == \'second\'">{{ selectedTarget.secondName }}</span> <span ng-show="targetItem.left.fieldName == \'third\'">{{ selectedTarget.thirdName }}</span> <span ng-show="targetItem.left.fieldName == \'prefCd\'">{{ selectedTar.pref.label }}</span> <span ng-show="targetItem.left.fieldName == \'region\'">{{ selectedTar.reg.label }}</span></td><th ng-show="targetItem.right != null" style="width:15%">{{targetItem.right.showName}}\uFF1A</th><td ng-show="targetItem.right != null" style="border: none; width:35%"><span ng-show="targetItem.right.fieldName != \'region\' && targetItem.right.fieldName != \'prefCd\' && targetItem.right.fieldName != \'first\' && targetItem.right.fieldName != \'second\' && targetItem.right.fieldName != \'third\'">{{ selectedTarget[targetItem.right.fieldName] }}</span> <span ng-show="targetItem.right.fieldName == \'first\'">{{ selectedTarget.firstName }}</span> <span ng-show="targetItem.right.fieldName == \'second\'">{{ selectedTarget.secondName }}</span> <span ng-show="targetItem.right.fieldName == \'third\'">{{ selectedTarget.thirdName }}</span> <span ng-show="targetItem.right.fieldName == \'prefCd\'">{{ selectedTar.pref.label }}</span> <span ng-show="targetItem.right.fieldName == \'region\'">{{ selectedTar.reg.label }}</span></td></tr></tbody></table></div><div ng-include="\'app/pages/checkreport/checkreportTargetFileList.html\'"></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/checkreport/checkResultDetail.html','<div class="modal-content" style="width:1030px"><div class="modal-header bg-warning" style="background-color:#ffaf0d;"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">{{checkListInfo.checklistName}}</h4></div><div class="modal-body text-left"><div style="margin-bottom: 20px;" ng-bind-html="checkListInfo.checklistContent"></div><div><div ng-repeat="item in resultDetailList" ng-init="outerIndex = $index"><div class="form-group" ng-if="item.inputTypeId == 1" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <input ng-disabled="isVisitor" type="text" class="form-control" ng-model="result[outerIndex].value" maxlength="512"></div><div class="form-group" ng-if="item.inputTypeId == 2" ng-controller="datepickerpopupCtrl" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <input ng-disabled="isVisitor" ng-model="result[outerIndex].value" type="text" placeholder="YYYY/MM/DD" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"></div><div class="form-group" ng-if="item.inputTypeId == 3" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><select ng-disabled="isVisitor" class="form-control selectpicker" selectpicker="" ng-model="result[outerIndex].value" ng-options="item1 as item1.label for item1 in userResource{{item.resultDetailId}}"></select></div><div class="form-group" ng-if="item.inputTypeId == 4" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><p class="input-group"><label class="radio-inline custom-radio nowrap" ng-repeat="item2 in userResource[outerIndex]"><input ng-disabled="isVisitor" type="radio" value="{{item2.value}}" ng-model="result[outerIndex].value"> <span>{{item2.label}}</span></label></p></div><div class="form-group" ng-if="item.inputTypeId == 5" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><p class="input-group"><label class="checkbox-inline custom-checkbox nowrap" ng-repeat="item6 in userResource[outerIndex]"><input ng-disabled="isVisitor" ng-checked="chBoxResult[outerIndex][$index] == item6.value" type="checkbox" ng-true-value="{{item6.value}}" ng-false-value="0" ng-model="chBoxResult[outerIndex][$index]"> <span>{{item6.label}}</span></label></p></div><div class="form-group" ng-if="item.inputTypeId == 6" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <textarea ng-disabled="isVisitor" class="form-control" ng-model="result[outerIndex].value" maxlength="512"></textarea></div><div class="form-group" ng-if="item.inputTypeId == 7" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><div class="img-wrapper" ng-repeat="item3 in dynamicImgArray(item.resultDetailId)"><h5 style="left:9px">No.{{item3[0].no}}</h5><a href="javascript:;" ng-click="showResultImg(item.resultDetailId, item3[0].no)"><img ng-src="{{item3[0].url}}" alt="" title=""></a> <button ng-if="isEditer" style="left: 255px;" type="button" class="img-delete-button" ng-click="deleteFile(item3[0].fileId, item.resultDetailId, \'Image\')">\u524A\u9664</button> <textarea class="img-textarea" name="content" style="left: 9px;" ng-model="item3[0].imgComm" ng-disabled="! isEditer">{{item3[0].imgComm}}</textarea><h5 ng-if="item3[1] != null" style="left:342px">No.{{item3[1].no}}</h5><a href="javascript:;" ng-click="showResultImg(item.resultDetailId, item3[1].no)"><img ng-src="{{item3[1].url}}" alt="" title=""></a> <button ng-if="item3[1] != null && isEditer" style="left: 588px;" type="button" class="img-delete-button" ng-click="deleteFile(item3[1].fileId, item.resultDetailId, \'Image\')">\u524A\u9664</button> <textarea ng-if="item3[1] != null" class="img-textarea" name="content" style="left: 342px;" ng-model="item3[1].imgComm" ng-disabled="! isEditer">{{item3[1].imgComm}}</textarea><h5 ng-if="item3[2] != null" style="left:676px">No.{{item3[2].no}}</h5><a href="javascript:;" ng-click="showResultImg(item.resultDetailId, item3[2].no)"><img ng-src="{{item3[2].url}}" alt="" title=""></a> <button ng-if="item3[2] != null && isEditer" style="left: 922px;" type="button" class="img-delete-button" ng-click="deleteFile(item3[2].fileId, item.resultDetailId, \'Image\')">\u524A\u9664</button> <textarea ng-if="item3[2] != null" class="img-textarea" name="content" style="left: 676px;" ng-model="item3[2].imgComm" ng-disabled="! isEditer">{{item3[2].imgComm}}</textarea></div><br><button ng-if="isEditer" type="button" class="btn btn-info btn-sm" ng-click="openUploadImg(item.resultDetailId,item);">\u5199\u771F\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button> <button ng-if="isEditer && hasImgArrayList(item.resultDetailId)" type="button" class="btn btn-info btn-sm" ng-click="openImgOrder(item.resultDetailId);">\u4E26\u3079\u66FF\u3048</button></div><div class="form-group" ng-if="item.inputTypeId == 8" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><table class="table" style="border: none; border-collapse:separate; border-spacing:0px 10px;"><tr ng-repeat="item4 in dynamicImgArray(item.resultDetailId)"><td style="border:none">No.{{$index+1}}</td><td style="border:none">{{item4.fileName}}</td><td style="border:none; width: 350px;"><video style="height: 54px; width: 400px;" controls="" ng-src="{{item4.url}}" preload="auto" webkit-playsinline="" playsinline=""></video></td><td style="border:none"><button ng-if="isEditer" type="button" ng-click="deleteFile(item4.id, item.resultDetailId, \'Radio\')" class="btn btn-danger editable-table-button btn-xs">\u524A\u9664</button></td></tr></table><br><button ng-if="isEditer" type="button" class="btn btn-info btn-sm" ng-click="openUploadRadio(item.resultDetailId);">\u97F3\u58F0\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="form-group" ng-if="item.inputTypeId == 9" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><table class="table" style="border: none; border-collapse:separate; border-spacing:0px 10px;"><tr ng-repeat="item5 in dynamicImgArray(item.resultDetailId)"><td style="border:none; vertical-align: middle;">No.{{$index+1}}</td><td style="border:none; vertical-align: middle;">{{item5.fileName}}</td><td style="border:none; width: 350px;"><video style="width: 400px;" controls="" ng-src="{{item5.url}}" preload="auto" webkit-playsinline="" playsinline=""></video></td><td style="border:none; vertical-align: middle;"><button ng-if="isEditer" type="button" ng-click="deleteFile(item5.id, item.resultDetailId, \'Radio\')" class="btn btn-danger editable-table-button btn-xs">\u524A\u9664</button></td></tr></table><br><button ng-if="isEditer" type="button" class="btn btn-info btn-sm" ng-click="openUploadVideo(item.resultDetailId)">\u52D5\u753B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="form-group" ng-if="item.inputTypeId == 10" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><div style="text-align: center;"><button ng-if="isEditer" ng-show="signable{{item.resultDetailId}} && signFlg{{item.resultDetailId}}" type="button" class="btn btn-info" ng-click="showSignPc(item.resultDetailId)">\u624B\u66F8\u3059\u308B</button> <button ng-if="isEditer" ng-show="! signable{{item.resultDetailId}}" type="button" class="btn btn-danger" ng-click="deleteSign(item.resultDetailId)">\u524A\u9664</button><div ng-show="signable{{item.resultDetailId}}" id="signature{{item.resultDetailId}}" style="height: 202px;border: 1px solid #ccc;margin: 10px 20px;"></div><button ng-show="!signFlg{{item.resultDetailId}}" type="button" class="btn btn-info" ng-click="saveSignPc(item.resultDetailId)" id="signOK{{item.resultDetailId}}">\u78BA\u5B9A</button> <button ng-show="!signFlg{{item.resultDetailId}}" type="button" class="btn btn-danger" ng-click="resetSignPc(item.resultDetailId)" id="signReset{{item.resultDetailId}}">\u30EA\u30BB\u30C3\u30C8</button><div ng-show="! signable{{item.resultDetailId}}" style="margin:20px"><img ng-src="{{getSignUrl(item.resultDetailId)}}" alt="" title=""></div></div></div><div class="form-group" ng-if="item.inputTypeId == 11" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <input ng-disabled="isVisitor" ng-show="!camera{{item.resultDetailId}}" type="text" class="form-control" ng-model="result[outerIndex].value"><div ng-show="camera{{item.resultDetailId}}" style="text-align: center;"><blockquote data-mode="click2play" data-width="100%" data-height="478" class="ricoh-theta-tour-image" ng-show="cameraT{{item.resultDetailId}}"><a href="{{result[outerIndex].value}}"></a></blockquote><blockquote data-mode="click2play" data-width="100%" data-height="478" class="ricoh-theta-spherical-image" ng-show="! cameraT{{item.resultDetailId}}"><a href="{{result[outerIndex].value}}"></a></blockquote><script async="" src="https://smartbee.theta360.biz/widgets.js" charset="utf-8"></script><button ng-if="isEditer" type="button" class="btn btn-danger" ng-click="delete360Camera(item.resultDetailId)" style="margin-top: 5px;">\u524A\u9664</button></div></div><div class="form-group" ng-if="item.inputTypeId == 12" style="margin-bottom: 30px;"><label ng-if="item.unit == \'\' || item.unit ==null" style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-if="item.unit != \'\' && item.unit !=null" style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}({{item.unit}})</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <input ng-disabled="isVisitor" type="number" class="form-control" ng-model="result[outerIndex].value" pattern="-?[0-9]+([\\.,][0-9]+)?" inputmode="numeric" ng-blur="checkLimit(item.checkDetailId, outerIndex, true)" ng-style="{\'background-color\':errorStyle[outerIndex] }"></div><div class="form-group" ng-if="item.inputTypeId == 13" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><table ng-show="hasFile{{item.resultDetailId}}" class="table" st-table="fileListCopy" st-safe-src="dynamicImgArray(item.resultDetailId)" st-set-filter="customFilter" style="table-layout:fixed"><tbody><tr ng-repeat="item13 in fileListCopy"><td style="white-space: nowrap; border: none; width:90%" class="table-id cut-with-dots"><a href="javascript:;" ng-click="downLoadFile(item13);">{{item13.fileName}}</a></td><td style="text-align: right; border: none; width:10%"><button ng-if="isEditer" type="button" ng-click="deleteFile(item13.id, item.resultDetailId, \'File\')" class="btn btn-danger editable-table-button btn-xs">\u524A\u9664</button></td></tr></tbody></table><br><button ng-if="isEditer" type="button" class="btn btn-info btn-sm" ng-click="openUploadFile(item.resultDetailId)">\u30D5\u30A1\u30A4\u30EB\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="form-group" ng-if="item.inputTypeId == 14" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><div style="display: flex;"><div ng-disabled="isVisitor" uib-timepicker="" ng-model="result[outerIndex].value" hour-step="1" minute-step="1" show-meridian="false"></div><button style="margin: auto 0; margin-left: 10px;" type="button" class="btn btn-info" ng-click="setNowTime(outerIndex);" ng-if="isEditer">\u73FE\u5728\u6642\u523B</button> <button style="margin: auto 0; margin-left: 10px;" type="button" class="btn btn-danger" ng-click="clearTime(outerIndex);" ng-if="isEditer">\u30AF\u30EA\u30A2</button></div></div></div><div ng-if="showResult != \'1\'" class="form-group" style="text-align: center; border:1px solid rgba(0, 0, 0, 0.12);"><label style="font-size: 18px; font-weight: 400; color:#666666; padding-top: 15px;">\u30C1\u30A7\u30C3\u30AF\u7D50\u679C</label><p class="input-group"><label class="radio-inline custom-radio nowrap"><input ng-disabled="isVisitor" type="radio" name="finalCheck" value="1" ng-model="result[0].value"> <span>\u6B63\u5E38</span></label> <label class="radio-inline custom-radio nowrap"><input ng-disabled="isVisitor" type="radio" name="finalCheck" value="2" ng-model="result[0].value"> <span>\u7570\u5E38</span></label> <label class="radio-inline custom-radio nowrap"><input ng-disabled="isVisitor" type="radio" name="finalCheck" value="3" ng-model="result[0].value"> <span>\u4FDD\u7559</span></label> <label class="radio-inline custom-radio nowrap"><input ng-disabled="isVisitor" type="radio" name="finalCheck" value="4" ng-model="result[0].value"> <span>\u5BFE\u8C61\u5916</span></label></p></div></div></div><div class="modal-footer"><button ng-if="hasPrev" style="position: absolute; left: 10px;" type="button" class="btn btn-info" ng-click="showPrevDetail();">\u2190 \u524D\u3078</button> <button ng-if="hasNext" style="position: absolute; right: 10px;" type="button" class="btn btn-info" ng-click="showNextDetail();">\u6B21\u3078 \u2192</button> <button type="button" class="btn btn-info" ng-click="saveResult();" ng-if="isEditer">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button> <button type="button" class="btn btn-info" ng-click="temSaveResult();" ng-if="isEditer">\u4E00\u6642\u4FDD\u5B58</button></div></div>');
$templateCache.put('app/pages/checkreport/checkResultList.html','<div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info" ng-click="downloadContent()">\u5199\u771F\u51FA\u529B</button></div><div class="col-md-12"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">{{ ticket.checksheetName }}<span style="float: right;">ver.{{ $root.padLeft(ticket.version, 3) }}</span></div><div class="panel-body"><div class="alert" style="margin-bottom: 5px; color:#000;">\u30C1\u30A7\u30C3\u30AF\u9805\u76EE\u6570 <span class="checkreport-msg">{{checkresultList.length}}</span>\u4EF6<div style="display: inline;" ng-if="showResult != \'1\'">\uFF08\u6B63\u5E38\uFF1A <span class="checkreport-msg">{{resultOkNum}}</span>\u4EF6\u3001 \u7570\u5E38\uFF1A <span ng-if="resultNgNum != 0" class="checkreport-msg" style="color: #F00;">{{resultNgNum}}</span> <span ng-if="resultNgNum == 0" class="checkreport-msg">{{resultNgNum}}</span>\u4EF6\u3001 \u4FDD\u7559\uFF1A <span class="checkreport-msg">{{resultKeepNum}}</span>\u4EF6\u3001 \u5BFE\u8C61\u5916\uFF1A <span class="checkreport-msg">{{resultOtherNum}}</span>\u4EF6\uFF09</div></div><div class="horizontal-scroll"><table class="table table-bordered table-checkreport"><thead><tr style="background-color:#fcf2dd;"><th style="text-align: center;" class="table-id">#</th><th style="text-align: center; min-width: 200px;">\u30C1\u30A7\u30C3\u30AF\u9805\u76EE</th><th style="text-align: center;">\u30C1\u30A7\u30C3\u30AF\u5185\u5BB9</th><th style="text-align: center;" ng-if="showResult != \'1\'">\u30C1\u30A7\u30C3\u30AF\u7D50\u679C</th><th style="text-align: center;">&nbsp;&nbsp;\u62C5\u5F53\u6280\u8853\u8005&nbsp;&nbsp;</th><th style="text-align: center;">\u66F4\u65B0\u65E5\u6642</th><th style="text-align: center;">\u30C1\u30A7\u30C3\u30AF\u9805\u76EE\u8A73\u7D30</th></tr></thead><tbody ng-repeat="item in checkresultList"><tr><td style="vertical-align: middle;line-height:25px" rowspan="2" class="table-id">{{$index+1}}</td><td style="line-height:25px">{{item.checklistName}}</td><td style="line-height:25px" ng-bind-html="item.checklistContent"></td><td ng-if="(item.checkResult != \'2\' && item.checkResult != null && item.checkResult != \'\') && showResult != \'1\'" style="text-align: center;line-height:25px">{{item.checkResultName}}</td><td ng-if="item.checkResult == \'2\' && showResult != \'1\'" style="text-align: center; color:#F00;line-height:25px">{{item.checkResultName}}</td><td ng-if="(item.checkResult == null || item.checkResult == \'\') && showResult != \'1\'" style="text-align: center;line-height:25px">\u672A\u7740\u624B</td><td ng-if="item.checkResult != null && item.checkResult != \'\'" style="text-align: center;line-height:25px">{{item.userName}}</td><td ng-if="item.checkResult == null || item.checkResult == \'\'" style="text-align: center;line-height:25px"></td><td ng-if="item.checkResult != null && item.checkResult != \'\'" style="text-align: center; line-height:25px">{{item.updateTime}}</td><td ng-if="item.checkResult == null || item.checkResult == \'\'" style="text-align: center;line-height:25px"></td><td style="text-align: center;line-height:25px"><button class="status-button btn btn-xs btn-info" ng-click="showCheckResultDetail(item)">\u8A73\u7D30</button></td></tr><tr><td colspan="6" style="text-align: left;" ng-if="item.imgNum != 0"><img ng-if="$index &lt; 6" ng-repeat="item2 in item.imgInfo" class="img-table-list" ng-src="{{item2.url}}" alt="" title=""> <span ng-if="item.imgNum &gt; 6">...</span></td></tr></tbody></table></div></div></div><div ng-include="\'app/pages/checkreport/checkListFileList.html\'"></div></div>');
$templateCache.put('app/pages/checkreport/groupUserList.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u6240\u5C5E\u6280\u8853\u8005\u4E00\u89A7</h4></div><div class="modal-body"><div class="horizontal-scroll"><table class="table" st-table="userData" st-safe-src="groupUserList" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th class="table-id">#</th><th st-sort="userId" st-sort-default="obverse">\u6280\u8853\u8005ID</th><th st-sort="userName">\u6280\u8853\u8005\u540D</th><th st-sort="mngFlagName">\u6A29\u9650</th><th st-sort="tel">\u96FB\u8A71\u756A\u53F7</th><th st-sort="mailAdd">\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9</th></tr><tr><th></th><th><select st-search="userId" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userId\'" value="{{item.userId}}">{{item.userId}}</option></select></th><th><select st-search="userName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userName\'" value="{{item.userName}}">{{item.userName}}</option></select></th><th><select st-search="mngFlagName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'mngFlagName\'" value="{{item.mngFlagName}}">{{item.mngFlagName}}</option></select></th><th><select st-search="tel" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'tel\'" value="{{item.tel}}">{{item.tel}}</option></select></th><th><select st-search="mailAdd" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'mailAdd\'" value="{{item.mailAdd}}">{{item.mailAdd}}</option></select></th></tr></thead><tbody><tr ng-repeat="item in userData"><td class="table-id">{{$index + 1}}</td><td style="white-space: nowrap">{{item.userId}}</td><td style="white-space: nowrap">{{item.userName}}</td><td style="white-space: nowrap">{{item.mngFlagName}}</td><td style="white-space: nowrap">{{item.tel}}</td><td style="white-space: nowrap">{{item.mailAdd}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/checkreport/imgOrder.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u5199\u771F\u306E\u4E26\u3079\u66FF\u3048</h4></div><div class="modal-body text-left"><h5>\u5199\u771F\u3092\u30C9\u30E9\u30C3\u30B0\u30A2\u30F3\u30C9\u30C9\u30ED\u30C3\u30D7\u3057\u3066\u3001\u4E26\u3079\u66FF\u3048\u307E\u3059\u3002</h5><ul class="todo-list" ui-sortable="sortableOptions" ng-model="imgOrderList"><li class="list" ng-repeat="item in imgOrderList" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px; height: initial;"><table class="checklist-table"><tr><td style="width:30px"><span class="cut-with-dots">{{ item.no }}</span></td><td><img ng-src="{{item.url}}" alt="" title="" style="width:100%"></td></tr></table></li></ul></div><div class="modal-footer"><button type="button" class="btn btn-info" click-and-disable="saveImgOrder()">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/checkreport/progressModal.html','<div class="modal-content"><div class="modal-body"><table style="width: 100%;"><tr><td style="color: #d45a00;text-align: center;"><h3>\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D\u30FB\u30FB\u30FB</h3></td></tr><tr><td style="text-align: center;"><img src="assets/img/loading01.gif" alt="Loading" style="width: 50px;"></td></tr></table></div></div>');
$templateCache.put('app/pages/checkreport/progressModalDownload.html','<div class="modal-content"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/checkreport/progressModalUpload.html','<div class="modal-content"><div class="modal-body"><table style="width: 100%;"><tr><td style="color: #d45a00;text-align: center;"><h3>\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u4E2D\u30FB\u30FB\u30FB</h3></td></tr><tr><td style="text-align: center;"><img src="assets/img/loading01.gif" alt="Loading" style="width: 50px;"></td></tr></table></div></div>');
$templateCache.put('app/pages/checkreport/userInfo.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u6280\u8853\u8005\u60C5\u5831</h4></div><div class="modal-body"><form name="myForm"><div class="form-group"><label>\u6280\u8853\u8005ID</label><br><h4 style="margin-left: 5px;">{{userInfo.userId}}</h4></div><div class="form-group"><label for="userName">\u6280\u8853\u8005\u540D</label><br><h4 style="margin-left: 5px;">{{userInfo.userName}}</h4></div><div class="form-group"><label>\u6240\u5C5E\u4F1A\u793E</label><br><h4 style="margin-left: 5px;">{{userInfo.comName}}</h4></div><div class="form-group"><label for="orgName">\u6240\u5C5E\u7D44\u7E54</label><br><h4 style="margin-left: 5px;">{{userInfo.organization}}</h4></div><div class="form-group"><label for="tel">\u96FB\u8A71\u756A\u53F7</label><br><h4 style="margin-left: 5px;">{{userInfo.tel}}</h4></div><div class="form-group"><label for="email">\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9</label><br><h4 style="margin-left: 5px;">{{userInfo.mailAdd}}</h4></div><div class="form-group"><label>\u6A29\u9650</label><br><h4 style="margin-left: 5px;">{{userInfo.mngFlagName}}</h4></div><div class="form-group"><label for="group">\u6240\u5C5E\u30B0\u30EB\u30FC\u30D7</label><br><h4 style="margin-left: 5px;">{{userInfo.groupName}}</h4></div><div class="form-group"><label for="status">\u30A2\u30AB\u30A6\u30F3\u30C8\u30ED\u30C3\u30AF</label><br><h4 style="margin-left: 5px;">{{userInfo.accountLockStr}}</h4></div></form></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/checktarget/checktarget.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\u5BFE\u8C61\u5DE5\u4E8B\u4E00\u89A7" ba-panel-class="with-scroll"><div include-with-scope="app/pages/checktarget/checktargetList.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\u5BFE\u8C61\u5DE5\u4E8B\u8A73\u7D30" ba-panel-class="with-scroll" id="checktargetDetail" style="display: none;"><div include-with-scope="app/pages/checktarget/checktargetDetail.html"></div></div></div></div><div class="row"><div class="col-md-12" id="ticketList" style="display: none;" ba-panel="" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u4E00\u89A7" ba-panel-class="with-scroll"><div ng-if="$root.targetIdForTicket" ng-include="\'app/pages/checkreport/checkreportList.html\'" ng-controller="CheckreportListCtrl"></div></div></div><div class="row"><div class="col-md-12" id="fileList" style="display: none;" ba-panel="" ba-panel-title="\u30D5\u30A1\u30A4\u30EB\u4E00\u89A7" ba-panel-class="with-scroll"><div ng-include="\'app/pages/checklist/fileList.html\'"></div></div></div><div class="row" ng-show="historyList.length > 0"><div class="col-md-12" id="fileList" ba-panel="" ba-panel-title="\u30D5\u30A1\u30A4\u30EB\u5C65\u6B74" ba-panel-class="with-scroll"><div ng-include="\'app/pages/checklist/fileHistoryList.html\'"></div></div></div></div>');
$templateCache.put('app/pages/checktarget/checktargetDetail.html','<div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info" ng-click="showCheckreportList()">\u95A2\u9023\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8</button> <button type="button" class="btn btn-danger" ng-click="removeTarget()">\u524A\u9664</button></div><div class="table-responsive" style="border-bottom: 1px solid rgba(0, 0, 0, 0.12);"><table class="table table-bordered" style="border: none; border-collapse:separate; border-spacing:0px 2px;"><tbody><tr ng-repeat="targetItem in targetItemList"><th style="width:15%">{{targetItem.left.showName}}\uFF1A<label ng-if="targetItem.left.isShow == \'3\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%"><span ng-show="targetItem.left.fieldName == \'targetId\' && selectedTarget.targetId != \'\u672A\u8A2D\u5B9A\'">{{ selectedTarget.targetId }}</span> <input ng-show="targetItem.left.fieldName == \'targetId\' && selectedTarget.targetId == \'\u672A\u8A2D\u5B9A\'" type="text" class="form-control" ng-model="ctrl.changeTargetId" maxlength="24"> <input ng-show="targetItem.left.fieldName != \'kbn1\' && targetItem.left.fieldName != \'kbn2\' && targetItem.left.fieldName != \'kbn3\' && targetItem.left.fieldName != \'kbn4\' && targetItem.left.fieldName != \'kbn5\' && targetItem.left.fieldName != \'targetId\' && targetItem.left.fieldName != \'first\' && targetItem.left.fieldName != \'second\' && targetItem.left.fieldName != \'third\'" type="text" class="form-control" ng-model="selectedTarget[targetItem.left.fieldName]" maxlength="500"><select ng-show="targetItem.left.fieldName == \'first\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.first" id="{{targetItem.left.fieldName}}" ng-disabled="firstDisable" ng-change="changeFirst()" ng-options="item as item.label for item in firstList"></select><select ng-show="targetItem.left.fieldName == \'second\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.second" id="{{targetItem.left.fieldName}}" ng-disabled="secondDisable" ng-change="changeSecond()" ng-options="item as item.label for item in secondList"></select><select ng-show="targetItem.left.fieldName == \'third\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.third" id="{{targetItem.left.fieldName}}" ng-disabled="thirdDisable" ng-options="item as item.label for item in thirdList"></select><select ng-show="targetItem.left.fieldName == \'kbn1\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn1Ob" ng-options="item as item.label for item in kbn1List"></select><select ng-show="targetItem.left.fieldName == \'kbn2\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select><select ng-show="targetItem.left.fieldName == \'kbn3\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select><select ng-show="targetItem.left.fieldName == \'kbn4\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select><select ng-show="targetItem.left.fieldName == \'kbn5\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></td><th ng-show="targetItem.right != null" style="width:15%">{{targetItem.right.showName}}\uFF1A<label ng-if="targetItem.right.fieldName == \'targetName\' || targetItem.right.isShow == \'3\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-show="targetItem.right != null" style="border: none; width:35%"><input ng-show="targetItem.right.fieldName != \'kbn1\' && targetItem.right.fieldName != \'kbn2\' && targetItem.right.fieldName != \'kbn3\' && targetItem.right.fieldName != \'kbn4\' && targetItem.right.fieldName != \'kbn5\' && targetItem.right.fieldName != \'first\' && targetItem.right.fieldName != \'second\' && targetItem.right.fieldName != \'third\'" type="text" class="form-control" ng-model="selectedTarget[targetItem.right.fieldName]"><select ng-show="targetItem.right.fieldName == \'first\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.first" id="{{targetItem.right.fieldName}}" ng-disabled="firstDisable" ng-change="changeFirst()" ng-options="item as item.label for item in firstList"></select><select ng-show="targetItem.right.fieldName == \'second\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.second" id="{{targetItem.right.fieldName}}" ng-disabled="secondDisable" ng-change="changeSecond()" ng-options="item as item.label for item in secondList"></select><select ng-show="targetItem.right.fieldName == \'third\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.third" id="{{targetItem.right.fieldName}}" ng-disabled="thirdDisable" ng-options="item as item.label for item in thirdList"></select><select ng-show="targetItem.right.fieldName == \'kbn1\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn1Ob" ng-options="item as item.label for item in kbn1List"></select><select ng-show="targetItem.right.fieldName == \'kbn2\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select><select ng-show="targetItem.right.fieldName == \'kbn3\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select><select ng-show="targetItem.right.fieldName == \'kbn4\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select><select ng-show="targetItem.right.fieldName == \'kbn5\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></td></tr><tr><td colspan="4" style="border: none;"><button type="button" class="btn btn-info" ng-click="modifyTarget()">\u4FDD\u5B58</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/checktarget/checktargetItemInfo.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss();reload();" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u9805\u76EE\u7DE8\u96C6</h4></div><div class="modal-body text-left"><table class="table table-bordered table-condensed"><tr><td style="text-align: center; width:5%">#</td><td style="width:25%">\u9805\u76EE\u540D</td><td style="width:35%">\u8868\u793A\u540D</td><td style="width:15%">\u8868\u793A/\u975E\u8868\u793A</td><td style="width:20%">\u64CD\u4F5C</td></tr><tr ng-repeat="item in itemTargetList" class="editable-row"><td>{{$index + 1}}</td><td ng-if="item.itemNameId == \'20000031\' || item.itemNameId == \'20000032\' || item.itemNameId == \'20000033\'"><a href="javascript:;" ng-click="showMasterDate();">{{item.itemName}}</a></td><td ng-if="item.itemNameId == \'20000034\'"><a href="javascript:;" ng-click="showTargetKbn();">{{item.itemName}}</a></td><td ng-if="item.itemNameId != \'20000031\' && item.itemNameId != \'20000032\' && item.itemNameId != \'20000033\' && item.itemNameId != \'20000034\'">{{item.itemName}}</td><td><span editable-text="item.showName" e-name="showName" e-form="rowform" e-required="" e-maxlength="128">{{item.showName}}</span></td><td style="width:10%" ng-if="item.mngFlg != \'1\'"><span ng-if="item.isShow != \'-\'" editable-select="item.isShow" e-name="isShow" e-form="rowform" e-selectpicker="" e-ng-options="i.id as i.text for i in showList">{{ showIsShow(item.isShow) }}</span> <span ng-if="item.isShow == \'-\'">{{item.isShow}}</span></td><td style="width:10%" ng-if="item.mngFlg == \'1\'"><span ng-if="item.isShow != \'-\'" editable-select="item.isShow" e-name="isShow" e-form="rowform" e-selectpicker="" e-ng-options="i.id as i.text for i in showItemList">{{ showItemIsShow(item.isShow) }}</span> <span ng-if="item.isShow == \'-\'">{{item.isShow}}</span></td><td style="width:17%"><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" onaftersave="saveItem(item);"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-info editable-table-button btn-xs">\u4FDD\u5B58</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">\u53D6\u6D88</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">\u7DE8\u96C6</button></div></td></tr></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss();reload();">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/checktarget/checktargetList.html','<div class="horizontal-scroll"><div style="position: absolute; top: 5px; right: 20px;"><button style="margin-right: 30px;" type="button" class="btn btn-info" ng-click="showItem()">\u9805\u76EE\u7DE8\u96C6</button> <button type="button" class="btn btn-info" ng-click="showChecktargetCreate()">\u65B0\u898F</button></div><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="targetData" st-safe-src="checktargetList" st-filtered-collection="stFilteredCollection"><thead><tr><td><div style="position: absolute; top: 75px; right: 20px;"><a class="btn btn-warning" style="background: #209e91; border-color: #209e91;" st-export-csv-sjis="">\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a> <button type="file" ngf-select="uploadFiles($file)" class="btn btn-info" accept=".csv, text/csv" ngf-max-size="10MB">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div></td></tr><tr class="sortable"><th class="table-id" st-sort="no" st-sort-default="obverse">#</th><th st-sort="targetId">{{itemTargetId}}</th><th st-sort="targetName">{{itemTargetName}}</th><th ng-show="showFirst" st-sort="firstName">{{itemFirst}}</th><th ng-show="showSecond" st-sort="secondName">{{itemSecond}}</th><th ng-show="showThird" st-sort="thirdName">{{itemThird}}</th><th ng-show="showObjType" st-sort="objType">{{itemObjType}}</th><th ng-show="showRegion" st-sort="regionName">{{itemRegion}}</th><th ng-show="showPref" st-sort="prefName">{{itemPref}}</th><th ng-show="showMuniName" st-sort="muniName">{{itemMuniName}}</th><th ng-show="showAddress" st-sort="address">{{itemAddress}}</th><th ng-show="showLatitude" st-sort="latitude">{{itemLatitude}}</th><th ng-show="showLongitude" st-sort="longitude">{{itemLongitude}}</th><th ng-show="showKbn1" st-sort="kbn1">{{itemKbn1}}</th><th ng-show="showKbn2" st-sort="kbn2">{{itemKbn2}}</th><th ng-show="showKbn3" st-sort="kbn3">{{itemKbn3}}</th><th ng-show="showKbn4" st-sort="kbn4">{{itemKbn4}}</th><th ng-show="showKbn5" st-sort="kbn5">{{itemKbn5}}</th><th ng-show="showItem1" st-sort="remarks1">{{itemItem1}}</th><th ng-show="showItem2" st-sort="remarks2">{{itemItem2}}</th><th ng-show="showItem3" st-sort="remarks3">{{itemItem3}}</th><th ng-show="showItem4" st-sort="remarks4">{{itemItem4}}</th><th ng-show="showItem5" st-sort="remarks5">{{itemItem5}}</th><th ng-show="showItem6" st-sort="remarks6">{{itemItem6}}</th><th ng-show="showItem7" st-sort="remarks7">{{itemItem7}}</th><th ng-show="showItem8" st-sort="remarks8">{{itemItem8}}</th><th ng-show="showItem9" st-sort="remarks9">{{itemItem9}}</th><th ng-show="showItem10" st-sort="remarks10">{{itemItem10}}</th><th ng-show="showItem11" st-sort="remarks11">{{itemItem11}}</th><th ng-show="showItem12" st-sort="remarks12">{{itemItem12}}</th><th ng-show="showItem13" st-sort="remarks13">{{itemItem13}}</th><th ng-show="showItem14" st-sort="remarks14">{{itemItem14}}</th><th ng-show="showItem15" st-sort="remarks15">{{itemItem15}}</th><th ng-show="showItem16" st-sort="remarks16">{{itemItem16}}</th><th ng-show="showItem17" st-sort="remarks17">{{itemItem17}}</th><th ng-show="showItem18" st-sort="remarks18">{{itemItem18}}</th><th ng-show="showItem19" st-sort="remarks19">{{itemItem19}}</th><th ng-show="showItem20" st-sort="remarks20">{{itemItem20}}</th></tr><tr><th></th><th><select st-search="targetId" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'targetId\'" value="{{item.targetId}}">{{item.targetId}}</option></select></th><th><select st-search="targetName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'targetName\'" value="{{item.targetName}}">{{item.targetName}}</option></select></th><th ng-show="showFirst"><select st-search="firstName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'firstName\'" value="{{item.firstName}}">{{item.firstName}}</option></select></th><th ng-show="showSecond"><select st-search="secondName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'secondName\'" value="{{item.secondName}}">{{item.secondName}}</option></select></th><th ng-show="showThird"><select st-search="thirdName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'thirdName\'" value="{{item.thirdName}}">{{item.thirdName}}</option></select></th><th ng-show="showObjType"><select st-search="objType" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'objType\'" value="{{item.objType}}">{{item.objType}}</option></select></th><th ng-show="showRegion"><select st-search="regionName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'regionName\'" value="{{item.regionName}}">{{item.regionName}}</option></select></th><th ng-show="showPref"><select st-search="prefName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'prefName\'" value="{{item.prefName}}">{{item.prefName}}</option></select></th><th ng-show="showMuniName"><select st-search="muniName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'muniName\'" value="{{item.muniName}}">{{item.muniName}}</option></select></th><th ng-show="showAddress"><select st-search="address" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'address\'" value="{{item.address}}">{{item.address}}</option></select></th><th ng-show="showLatitude"><select st-search="latitude" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'latitude\'" value="{{item.latitude}}">{{item.latitude}}</option></select></th><th ng-show="showLongitude"><select st-search="longitude" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'longitude\'" value="{{item.longitude}}">{{item.longitude}}</option></select></th><th ng-show="showKbn1"><select st-search="kbn1" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'kbn1\'" value="{{item.kbn1}}">{{item.kbn1}}</option></select></th><th ng-show="showKbn2"><select st-search="kbn2" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'kbn2\'" value="{{item.kbn2}}">{{item.kbn2}}</option></select></th><th ng-show="showKbn3"><select st-search="kbn3" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'kbn3\'" value="{{item.kbn3}}">{{item.kbn3}}</option></select></th><th ng-show="showKbn4"><select st-search="kbn4" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'kbn4\'" value="{{item.kbn4}}">{{item.kbn4}}</option></select></th><th ng-show="showKbn5"><select st-search="kbn5" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'kbn5\'" value="{{item.kbn5}}">{{item.kbn5}}</option></select></th><th ng-show="showItem1"><select st-search="remarks1" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks1\'" value="{{item.remarks1}}">{{item.remarks1}}</option></select></th><th ng-show="showItem2"><select st-search="remarks2" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks2\'" value="{{item.remarks2}}">{{item.remarks2}}</option></select></th><th ng-show="showItem3"><select st-search="remarks3" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks3\'" value="{{item.remarks3}}">{{item.remarks3}}</option></select></th><th ng-show="showItem4"><select st-search="remarks4" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks4\'" value="{{item.remarks4}}">{{item.remarks4}}</option></select></th><th ng-show="showItem5"><select st-search="remarks5" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks5\'" value="{{item.remarks5}}">{{item.remarks5}}</option></select></th><th ng-show="showItem6"><select st-search="remarks6" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks6\'" value="{{item.remarks6}}">{{item.remarks6}}</option></select></th><th ng-show="showItem7"><select st-search="remarks7" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks7\'" value="{{item.remarks7}}">{{item.remarks7}}</option></select></th><th ng-show="showItem8"><select st-search="remarks8" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks8\'" value="{{item.remarks8}}">{{item.remarks8}}</option></select></th><th ng-show="showItem9"><select st-search="remarks9" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks9\'" value="{{item.remarks9}}">{{item.remarks9}}</option></select></th><th ng-show="showItem10"><select st-search="remarks10" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks10\'" value="{{item.remarks10}}">{{item.remarks10}}</option></select></th><th ng-show="showItem11"><select st-search="remarks11" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks11\'" value="{{item.remarks11}}">{{item.remarks11}}</option></select></th><th ng-show="showItem12"><select st-search="remarks12" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks12\'" value="{{item.remarks12}}">{{item.remarks12}}</option></select></th><th ng-show="showItem13"><select st-search="remarks13" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks13\'" value="{{item.remarks13}}">{{item.remarks13}}</option></select></th><th ng-show="showItem14"><select st-search="remarks14" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks14\'" value="{{item.remarks14}}">{{item.remarks14}}</option></select></th><th ng-show="showItem15"><select st-search="remarks15" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks15\'" value="{{item.remarks15}}">{{item.remarks15}}</option></select></th><th ng-show="showItem16"><select st-search="remarks16" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks16\'" value="{{item.remarks16}}">{{item.remarks16}}</option></select></th><th ng-show="showItem17"><select st-search="remarks17" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks17\'" value="{{item.remarks17}}">{{item.remarks17}}</option></select></th><th ng-show="showItem18"><select st-search="remarks18" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks18\'" value="{{item.remarks18}}">{{item.remarks18}}</option></select></th><th ng-show="showItem19"><select st-search="remarks19" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks19\'" value="{{item.remarks19}}">{{item.remarks19}}</option></select></th><th ng-show="showItem20"><select st-search="remarks20" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'remarks20\'" value="{{item.remarks20}}">{{item.remarks20}}</option></select></th></tr></thead><tbody><tr ng-repeat="item in targetData"><td style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{$index+1}}</td><td class="table-id"><a href="javascript:;" ng-click="showChecktargetDetail(item.id);">{{item.targetId}}</a></td><td style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.targetName}}</td><td ng-show="showFirst" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.firstName}}</td><td ng-show="showSecond" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.secondName}}</td><td ng-show="showThird" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.thirdName}}</td><td ng-show="showObjType" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.objType}}</td><td ng-show="showRegion" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.regionName}}</td><td ng-show="showPref" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.prefName}}</td><td ng-show="showMuniName" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.muniName}}</td><td ng-show="showAddress" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.address}}</td><td ng-show="showLatitude" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.latitude}}</td><td ng-show="showLongitude" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.longitude}}</td><td ng-show="showKbn1" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.kbn1}}</td><td ng-show="showKbn2" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.kbn2}}</td><td ng-show="showKbn3" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.kbn3}}</td><td ng-show="showKbn4" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.kbn4}}</td><td ng-show="showKbn5" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.kbn5}}</td><td ng-show="showItem1" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks1}}</td><td ng-show="showItem2" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks2}}</td><td ng-show="showItem3" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks3}}</td><td ng-show="showItem4" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks4}}</td><td ng-show="showItem5" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks5}}</td><td ng-show="showItem6" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks6}}</td><td ng-show="showItem7" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks7}}</td><td ng-show="showItem8" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks8}}</td><td ng-show="showItem9" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks9}}</td><td ng-show="showItem10" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks10}}</td><td ng-show="showItem11" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks11}}</td><td ng-show="showItem12" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks12}}</td><td ng-show="showItem13" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks13}}</td><td ng-show="showItem14" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks14}}</td><td ng-show="showItem15" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks15}}</td><td ng-show="showItem16" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks16}}</td><td ng-show="showItem17" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks17}}</td><td ng-show="showItem18" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks18}}</td><td ng-show="showItem19" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks19}}</td><td ng-show="showItem20" style="white-space: nowrap" ng-dblclick="showChecktargetDetail(item.id);">{{item.remarks20}}</td></tr></tbody><tfoot><tr><td colspan="35" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/checktarget/newCheckTarget.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u5DE5\u4E8B\u60C5\u5831</h4></div><div class="modal-body text-left"><table class="table table-bordered" style="border: none; border-collapse:separate; border-spacing:0px 2px;"><tbody><tr ng-repeat="targetItem in targetItemList"><th style="width:15%">{{targetItem.left.showName}}\uFF1A<label ng-if="targetItem.left.isShow == \'3\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%"><input ng-show="targetItem.left.fieldName != \'kbn1\' && targetItem.left.fieldName != \'kbn2\' && targetItem.left.fieldName != \'kbn3\' && targetItem.left.fieldName != \'kbn4\' && targetItem.left.fieldName != \'kbn5\' && targetItem.left.fieldName != \'first\' && targetItem.left.fieldName != \'second\' && targetItem.left.fieldName != \'third\'" type="text" class="form-control" id="{{targetItem.left.fieldName}}" maxlength="500"><select ng-show="targetItem.left.fieldName == \'first\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.first" id="{{targetItem.left.fieldName}}" ng-disabled="firstDisable" ng-change="changeFirst()" ng-options="item as item.label for item in firstList"></select><select ng-show="targetItem.left.fieldName == \'second\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.second" id="{{targetItem.left.fieldName}}" ng-disabled="secondDisable" ng-change="changeSecond()" ng-options="item as item.label for item in secondList"></select><select ng-show="targetItem.left.fieldName == \'third\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.third" id="{{targetItem.left.fieldName}}" ng-disabled="thirdDisable" ng-options="item as item.label for item in thirdList"></select><select ng-show="targetItem.left.fieldName == \'kbn1\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn1Ob" ng-options="item as item.label for item in kbn1List"></select><select ng-show="targetItem.left.fieldName == \'kbn2\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select><select ng-show="targetItem.left.fieldName == \'kbn3\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select><select ng-show="targetItem.left.fieldName == \'kbn4\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select><select ng-show="targetItem.left.fieldName == \'kbn5\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></td><th ng-show="targetItem.right != null" style="width:15%">{{targetItem.right.showName}}\uFF1A<label ng-if="targetItem.right.fieldName == \'targetName\' || targetItem.right.isShow == \'3\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td ng-show="targetItem.right != null" style="border: none; width:35%"><input ng-show="targetItem.right.fieldName != \'kbn1\' && targetItem.right.fieldName != \'kbn2\' && targetItem.right.fieldName != \'kbn3\' && targetItem.right.fieldName != \'kbn4\' && targetItem.right.fieldName != \'kbn5\' && targetItem.right.fieldName != \'first\' && targetItem.right.fieldName != \'second\' && targetItem.right.fieldName != \'third\'" type="text" class="form-control" id="{{targetItem.right.fieldName}}"><select ng-show="targetItem.right.fieldName == \'first\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.first" id="{{targetItem.right.fieldName}}" ng-disabled="firstDisable" ng-change="changeFirst()" ng-options="item as item.label for item in firstList"></select><select ng-show="targetItem.right.fieldName == \'second\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.second" id="{{targetItem.right.fieldName}}" ng-disabled="secondDisable" ng-change="changeSecond()" ng-options="item as item.label for item in secondList"></select><select ng-show="targetItem.right.fieldName == \'third\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.third" id="{{targetItem.right.fieldName}}" ng-disabled="thirdDisable" ng-options="item as item.label for item in thirdList"></select><select ng-show="targetItem.right.fieldName == \'kbn1\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn1Ob" ng-options="item as item.label for item in kbn1List"></select><select ng-show="targetItem.right.fieldName == \'kbn2\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select><select ng-show="targetItem.right.fieldName == \'kbn3\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select><select ng-show="targetItem.right.fieldName == \'kbn4\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select><select ng-show="targetItem.right.fieldName == \'kbn5\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-info" click-and-disable="createCheckTarget()">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/home/dashboardCalendar.html','<div ng-if="! $root.isMoblie" style="padding-bottom: 20px;margin-left: 15px;"><table style="margin-top: 20px;"><tr><td style="width: 70px;">\u30B0\u30EB\u30FC\u30D7\uFF1A</td><td style="border: none;width: 130px;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.responseGroup" ng-change="changeResponseGroup()" ng-options="item as item.groupName for item in groupList"></select></td><td ng-if="! (mngKbn == \'0\' && adminMng != \'1\')" style="width: 70px; padding-left: 10px;">\u6280\u8853\u8005\uFF1A</td><td ng-if="! (mngKbn == \'0\' && adminMng != \'1\')" style="border: none;width: 130px;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.responseUser" ng-change="changeResponseUser()" ng-options="item as item.userName for item in userList"></select></td></tr></table><table style="border-collapse: separate; border-spacing: 0px 5px;" ng-if="showFist"><tr><td>{{targetFirstItemName}}\uFF1A</td><td style="border: none;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.first" ng-disabled="firstDisable" ng-change="changeFirst()" ng-options="item as item.label for item in firstList"></select></td></tr><tr><td ng-if="showSecond">{{targetSecondItemName}}\uFF1A</td><td style="border: none;" ng-if="showSecond"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.second" ng-disabled="secondDisable" ng-change="changeSecond()" ng-options="item as item.label for item in secondList"></select></td></tr><tr><td ng-if="showThird">{{targetThirdItemName}}\uFF1A</td><td style="border: none;" ng-if="showThird"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.third" ng-disabled="thirdDisable" ng-change="changeThird()" ng-options="item as item.label for item in thirdList"></select></td></tr></table></div><div ng-if="$root.isMoblie" style="padding-left: 22px;"><table style="border-collapse: separate; border-spacing: 0px 5px;"><tr><td>\u30B0\u30EB\u30FC\u30D7\uFF1A</td><td style="border: none;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.responseGroup" ng-change="changeResponseGroup()" ng-options="item as item.groupName for item in groupList"></select></td></tr><tr ng-if="! (mngKbn == \'0\' && adminMng != \'1\')"><td>\u6280\u8853\u8005\uFF1A</td><td style="border: none;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.responseUser" ng-change="changeResponseUser()" ng-options="item as item.userName for item in userList"></select></td></tr><tr ng-if="showFist"><td>{{targetFirstItemName}}\uFF1A</td><td style="border: none;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.first" ng-disabled="firstDisable" ng-change="changeFirst()" ng-options="item as item.label for item in firstList"></select></td></tr><tr ng-if="showSecond"><td>{{targetSecondItemName}}\uFF1A</td><td style="border: none;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.second" ng-disabled="secondDisable" ng-change="changeSecond()" ng-options="item as item.label for item in secondList"></select></td></tr><tr ng-if="showThird"><td>{{targetThirdItemName}}\uFF1A</td><td style="border: none;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.third" ng-disabled="thirdDisable" ng-change="changeThird()" ng-options="item as item.label for item in thirdList"></select></td></tr></table></div><div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/home/home.html','<div class="widgets" ng-if="!$root.isMoblie"><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="\u671F\u9593\u4E2D\u5B8C\u4E86\u4E88\u5B9A\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8" ba-panel-class="traffic-panel with-scroll"><traffic-chart></traffic-chart></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u4E88\u5B9A" ba-panel-class="panel-calendar feed-comply-panel with-scroll calendar-panel"><dashboard-calendar2></dashboard-calendar2></div></div><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="\u672A\u78BA\u8A8D\u304A\u77E5\u3089\u305B" ba-panel-class="with-scroll"><div ng-if="unConfirm != 0" style="font-size: 20px; text-align: center; margin: 10px;"><a href="javascript:;" ng-click="showNews();"><span style="font-size: 50px;">{{unConfirm}}</span></a><div style="position: absolute; right: 50px;">\u4EF6</div></div><div ng-if="unConfirm == 0" style="font-size: 20px; text-align: center; margin: 10px;"><span style="font-size: 50px;">0</span><div style="position: absolute; right: 50px;">\u4EF6</div></div></div><div class="col-md-3" ba-panel="" ba-panel-title="{{ $root.getStatusShowName(\'99\') }}\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8" ba-panel-class="with-scroll"><div ng-if="returnNum != 0" style="font-size: 20px; text-align: center; margin: 10px;"><a href="javascript:;" ng-click="showReturnTicket();"><span style="font-size: 50px;">{{returnNum}}</span></a><div style="position: absolute; right: 50px;">\u4EF6</div></div><div ng-if="returnNum == 0" style="font-size: 20px; text-align: center; margin: 10px;"><span style="font-size: 50px;">0</span><div style="position: absolute; right: 50px;">\u4EF6</div></div></div><div ng-if="showResult != \'1\'" class="col-md-3" ba-panel="" ba-panel-title="\u7570\u5E38\u3042\u308A\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8" ba-panel-class="with-scroll"><div ng-if="errorNum != 0" style="font-size: 20px; text-align: center; margin: 10px;"><a href="javascript:;" ng-click="showErrorTicket();"><span style="font-size: 50px;">{{errorNum}}</span></a><div style="position: absolute; right: 50px;">\u4EF6</div></div><div ng-if="errorNum == 0" style="font-size: 20px; text-align: center; margin: 10px;"><span style="font-size: 50px;">0</span><div style="position: absolute; right: 50px;">\u4EF6</div></div></div></div><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="\u958B\u59CB\u65E5\u8D85\u904E\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8" ba-panel-class="with-scroll"><div ng-if="overStartDateNum != 0" style="font-size: 20px; text-align: center; margin: 10px;"><a href="javascript:;" ng-click="showOverStartDate();"><span style="font-size: 50px;">{{overStartDateNum}}</span></a><div style="position: absolute; right: 50px;">\u4EF6</div></div><div ng-if="overStartDateNum == 0" style="font-size: 20px; text-align: center; margin: 10px;"><span style="font-size: 50px;">0</span><div style="position: absolute; right: 50px;">\u4EF6</div></div></div><div class="col-md-3" ba-panel="" ba-panel-title="\u5B8C\u4E86\u65E5\u8D85\u904E\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8" ba-panel-class="with-scroll"><div ng-if="overEndDateNum != 0" style="font-size: 20px; text-align: center; margin: 10px;"><a href="javascript:;" ng-click="showOverEndDate();"><span style="font-size: 50px;">{{overEndDateNum}}</span></a><div style="position: absolute; right: 50px;">\u4EF6</div></div><div ng-if="overEndDateNum == 0" style="font-size: 20px; text-align: center; margin: 10px;"><span style="font-size: 50px;">0</span><div style="position: absolute; right: 50px;">\u4EF6</div></div></div></div></div><div class="widgets" ng-if="$root.isMoblie"><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="\u672A\u78BA\u8A8D\u304A\u77E5\u3089\u305B" ba-panel-class="with-scroll"><div ng-if="unConfirm != 0" style="font-size: 20px; text-align: center; margin: 10px;"><a href="javascript:;" ng-click="showNews();"><span style="font-size: 50px;">{{unConfirm}}</span></a><div style="position: absolute; right: 50px;">\u4EF6</div></div><div ng-if="unConfirm == 0" style="font-size: 20px; text-align: center; margin: 10px;"><span style="font-size: 50px;">0</span><div style="position: absolute; right: 50px;">\u4EF6</div></div></div><div class="col-md-3" ba-panel="" ba-panel-title="{{ $root.getStatusShowName(\'99\') }}\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8" ba-panel-class="with-scroll"><div ng-if="returnNum != 0" style="font-size: 20px; text-align: center; margin: 10px;"><a href="javascript:;" ng-click="showReturnTicket();"><span style="font-size: 50px;">{{returnNum}}</span></a><div style="position: absolute; right: 50px;">\u4EF6</div></div><div ng-if="returnNum == 0" style="font-size: 20px; text-align: center; margin: 10px;"><span style="font-size: 50px;">0</span><div style="position: absolute; right: 50px;">\u4EF6</div></div></div><div ng-if="showResult != \'1\'" class="col-md-3" ba-panel="" ba-panel-title="\u7570\u5E38\u3042\u308A\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8" ba-panel-class="with-scroll"><div ng-if="errorNum != 0" style="font-size: 20px; text-align: center; margin: 10px;"><a href="javascript:;" ng-click="showErrorTicket();"><span style="font-size: 50px;">{{errorNum}}</span></a><div style="position: absolute; right: 50px;">\u4EF6</div></div><div ng-if="errorNum == 0" style="font-size: 20px; text-align: center; margin: 10px;"><span style="font-size: 50px;">0</span><div style="position: absolute; right: 50px;">\u4EF6</div></div></div></div><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="\u958B\u59CB\u65E5\u8D85\u904E\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8" ba-panel-class="with-scroll"><div ng-if="overStartDateNum != 0" style="font-size: 20px; text-align: center; margin: 10px;"><a href="javascript:;" ng-click="showOverStartDate();"><span style="font-size: 50px;">{{overStartDateNum}}</span></a><div style="position: absolute; right: 50px;">\u4EF6</div></div><div ng-if="overStartDateNum == 0" style="font-size: 20px; text-align: center; margin: 10px;"><span style="font-size: 50px;">0</span><div style="position: absolute; right: 50px;">\u4EF6</div></div></div><div class="col-md-3" ba-panel="" ba-panel-title="\u5B8C\u4E86\u65E5\u8D85\u904E\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8" ba-panel-class="with-scroll"><div ng-if="overEndDateNum != 0" style="font-size: 20px; text-align: center; margin: 10px;"><a href="javascript:;" ng-click="showOverEndDate();"><span style="font-size: 50px;">{{overEndDateNum}}</span></a><div style="position: absolute; right: 50px;">\u4EF6</div></div><div ng-if="overEndDateNum == 0" style="font-size: 20px; text-align: center; margin: 10px;"><span style="font-size: 50px;">0</span><div style="position: absolute; right: 50px;">\u4EF6</div></div></div></div><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="\u671F\u9593\u4E2D\u5B8C\u4E86\u4E88\u5B9A\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8" ba-panel-class="traffic-panel with-scroll"><traffic-chart></traffic-chart></div></div><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u4E88\u5B9A" ba-panel-class="panel-calendar-sp feed-comply-panel calendar-panel"><dashboard-calendar2></dashboard-calendar2></div></div></div>');
$templateCache.put('app/pages/itemname/itemMenu.html','<table class="table table-bordered table-condensed"><tr><th style="text-align: center;">#</th><th>\u9805\u76EE\u540D</th><th>\u8868\u793A\u540D</th><th>\u30B3\u30E1\u30F3\u30C8</th><th>\u8868\u793A/\u975E\u8868\u793A</th><th>\u64CD\u4F5C</th></tr><tr ng-repeat="item in itemMenuList" class="editable-row"><td>{{$index + 1}}</td><td>{{item.itemName}}</td><td><span editable-text="item.showName" e-name="showName" e-form="rowform" e-required="">{{item.showName}}</span></td><td style="width:40%"><span editable-text="item.comment" e-name="comment" e-form="rowform" e-required="">{{item.comment}}</span></td><td style="width:10%"><span ng-if="item.isShow != \'-\'" editable-select="item.isShow" e-name="isShow" e-form="rowform" e-selectpicker="" e-ng-options="i.id as i.text for i in showList">{{ showIsShow(item.isShow) }}</span> <span ng-if="item.isShow == \'-\'">{{item.isShow}}</span></td><td style="width:17%"><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-info editable-table-button btn-xs">\u4FDD\u5B58</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">\u53D6\u6D88</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">\u7DE8\u96C6</button></div></td></tr></table>');
$templateCache.put('app/pages/itemname/itemname.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\u5BFE\u8C61\u5DE5\u4E8B" ba-panel-class="with-scroll"><div include-with-scope="app/pages/itemname/itemTarget.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8" ba-panel-class="with-scroll"><div include-with-scope="app/pages/itemname/itemTicket.html"></div></div></div></div></div>');
$templateCache.put('app/pages/itemname/itemTarget.html','<table class="table table-bordered table-condensed"><tr><td style="text-align: center; width:10%">#</td><td style="width:25%">\u9805\u76EE\u540D</td><td style="width:35%">\u8868\u793A\u540D</td><td style="width:15%">\u8868\u793A/\u975E\u8868\u793A</td><td style="width:15%">\u64CD\u4F5C</td></tr><tr ng-repeat="item in itemTargetList" class="editable-row"><td>{{$index + 1}}</td><td ng-if="item.itemNameId == \'20000031\' || item.itemNameId == \'20000032\' || item.itemNameId == \'20000033\'"><a href="javascript:;" ng-click="showMasterDate();">{{item.itemName}}</a></td><td ng-if="item.itemNameId == \'20000034\'"><a href="javascript:;" ng-click="showTargetKbn();">{{item.itemName}}</a></td><td ng-if="item.itemNameId != \'20000031\' && item.itemNameId != \'20000032\' && item.itemNameId != \'20000033\' && item.itemNameId != \'20000034\'">{{item.itemName}}</td><td><span editable-text="item.showName" e-name="showName" e-form="rowform" e-required="" e-maxlength="128">{{item.showName}}</span></td><td style="width:10%" ng-if="item.mngFlg != \'1\'"><span ng-if="item.isShow != \'-\'" editable-select="item.isShow" e-name="isShow" e-form="rowform" e-selectpicker="" e-ng-options="i.id as i.text for i in showList">{{ showIsShow(item.isShow) }}</span> <span ng-if="item.isShow == \'-\'">{{item.isShow}}</span></td><td style="width:10%" ng-if="item.mngFlg == \'1\'"><span ng-if="item.isShow != \'-\'" editable-select="item.isShow" e-name="isShow" e-form="rowform" e-selectpicker="" e-ng-options="i.id as i.text for i in showItemList">{{ showItemIsShow(item.isShow) }}</span> <span ng-if="item.isShow == \'-\'">{{item.isShow}}</span></td><td style="width:17%"><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" onaftersave="saveItem(item);"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-info editable-table-button btn-xs">\u4FDD\u5B58</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">\u53D6\u6D88</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">\u7DE8\u96C6</button></div></td></tr></table>');
$templateCache.put('app/pages/itemname/itemTicket.html','<table class="table table-bordered table-condensed"><tr><td style="text-align: center; width:10%">#</td><td style="width:25%">\u9805\u76EE\u540D</td><td style="width:35%">\u8868\u793A\u540D</td><td style="width:15%">\u8868\u793A/\u975E\u8868\u793A</td><td style="width:15%">\u64CD\u4F5C</td></tr><tr ng-repeat="item in itemTicketList" class="editable-row"><td>{{$index + 1}}</td><td ng-if="item.itemNameId == \'30000001\'"><a href="javascript:;" ng-click="showMasterDateStatus();">{{item.itemName}}</a></td><td ng-if="item.itemNameId != \'30000001\'">{{item.itemName}}</td><td><span editable-text="item.showName" e-name="showName" e-form="rowform" e-required="" e-maxlength="128">{{item.showName}}</span></td><td style="width:10%"><span ng-if="item.isShow != \'-\'" editable-select="item.isShow" e-name="isShow" e-form="rowform" e-selectpicker="" e-ng-options="i.id as i.text for i in showItemList">{{ showItemIsShow(item.isShow) }}</span> <span ng-if="item.isShow == \'-\'">{{item.isShow}}</span></td><td style="width:17%"><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" onaftersave="saveItem(item);"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-info editable-table-button btn-xs">\u4FDD\u5B58</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">\u53D6\u6D88</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">\u7DE8\u96C6</button></div></td></tr></table>');
$templateCache.put('app/pages/manage/defaultGroup.html','<table class="table table-condensed"><tr><td style="width:45%">\u30C7\u30D5\u30A9\u30EB\u30C8\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7\uFF1A</td><td><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="groupRadio" id="groupRadio1" value="1" ng-model="ctrlScope.groupRadio" data-ng-change="changeGroupRadio(\'1\')"> <span>\u8A2D\u5B9A\u3059\u308B</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="groupRadio" id="groupRadio0" value="0" ng-model="ctrlScope.groupRadio" data-ng-change="changeGroupRadio(\'0\')"> <span>\u8A2D\u5B9A\u3057\u306A\u3044</span></label></p></div></td></tr><tr><td>\u30B0\u30EB\u30FC\u30D7\uFF1A</td><td><div><ui-select id="group" multiple="" ng-model="selectedGroups.selected" ng-disabled="groupRadio == \'0\'" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="\u30C7\u30D5\u30A9\u30EB\u30C8\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7">{{$item.groupName}}</ui-select-match><ui-select-choices repeat="selectedGroups in groupList | filter: $select.search">{{selectedGroups.groupName}}</ui-select-choices></ui-select></div></td></tr><tr><td colspan="2" style="text-align: center; padding-top: 10px;"><button type="button" class="btn btn-info" ng-click="modifyDefaultGroup()">\u4FDD\u5B58</button></td></tr></table>');
$templateCache.put('app/pages/manage/manage.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="\u30C7\u30A3\u30B9\u30AF\u5BB9\u91CF" ba-panel-class="with-scroll"><div include-with-scope="app/pages/manage/photoManage.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\u8A2D\u5B9A" ba-panel-class="with-scroll"><div include-with-scope="app/pages/manage/settingManage.html"></div></div></div></div></div>');
$templateCache.put('app/pages/manage/photoManage.html','<div><div class="alert"><strong style="color:#d45a00;">\u73FE\u5728\u306E\u3054\u5229\u7528\u30C7\u30A3\u30B9\u30AF\u5BB9\u91CF<span style="font-size: 30px;font-weight: bold;margin: 0 10px;">{{ $root.getFileSize(diskSpace) }}</span></strong></div></div><uib-accordion><uib-accordion-group ng-repeat="item in yearList" heading="{{item.year}}\u5E74" panel-class="accordion-panel bootstrap-panel panel-default" is-open="item.flg"><table class="table"><tr><td>#</td><td>\u96C6\u8A08\u6708</td><td>\u30C7\u30A3\u30B9\u30AF\u5BB9\u91CF</td></tr><tr ng-repeat="disk in dynamicArray(item.year)" class="editable-row"><td>{{$index+1}}</td><td>{{$root.changeYYYYMM(disk.month)}}</td><td>{{$root.getFileSize(disk.disk)}}</td></tr></table></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/manage/settingManage.html','<table class="table table-condensed"><tr class="black-muted-bg"><th>\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u64CD\u4F5C</th></tr><tr><td rowspan="2" style="text-align: left;padding-top: 5px;width: 309px;">\u4F4D\u7F6E\u60C5\u5831\u30A2\u30E9\u30FC\u30C8<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="alertRadioTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td style="text-align: right;padding-top: 5px;">\u901A\u77E5\uFF1A</td><td style="padding-top: 5px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="alertRadio" id="alertRadio1" value="1" ng-model="ctrlScope.alertRadio" data-ng-change="changeAlertRadio(\'1\')"> <span>\u30AA\u30F3</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="alertRadio" id="alertRadio0" value="0" ng-model="ctrlScope.alertRadio" data-ng-change="changeAlertRadio(\'0\')"> <span>\u30AA\u30D5</span></label></p></div></td></tr><tr><td style="text-align: right;border: none; padding-bottom: 10px;">\u8DDD\u96E2\uFF1A</td><td style="border: none; padding-bottom: 10px;"><div><select class="form-control selectpicker" selectpicker="" ng-model="ctrlScope.alertSelected" ng-options="item as item.label for item in alertItems" ng-disabled="alertRadio == \'0\'"></select></div></td></tr><tr><td rowspan="2" style="text-align: left;padding-top: 5px;">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u4F5C\u6210\u6642\u306E\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="groupRadioTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>:</td><td style="width: 200px; text-align: right;padding-top: 5px;">\u30C7\u30D5\u30A9\u30EB\u30C8\uFF1A</td><td style="padding-top: 5px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="groupRadio" id="groupRadio1" value="1" ng-model="ctrlScope.groupRadio" data-ng-change="changeGroupRadio(\'1\')"> <span>\u8A2D\u5B9A\u3059\u308B</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="groupRadio" id="groupRadio0" value="0" ng-model="ctrlScope.groupRadio" data-ng-change="changeGroupRadio(\'0\')"> <span>\u8A2D\u5B9A\u3057\u306A\u3044</span></label></p></div></td></tr><tr><td style="text-align: right;border: none; padding-bottom: 10px;">\u30B0\u30EB\u30FC\u30D7\uFF1A</td><td style="border: none;"><div><ui-select id="group" multiple="" ng-model="selectedGroups.selected" ng-disabled="groupRadio == \'0\'" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="\u30C7\u30D5\u30A9\u30EB\u30C8\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7">{{$item.groupName}}</ui-select-match><ui-select-choices repeat="selectedGroups in groupList | filter: $select.search">{{selectedGroups.groupName}}</ui-select-choices></ui-select></div></td></tr><tr><td rowspan="2" style="text-align: left;padding-top: 5px;">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u4E00\u89A7\u30AA\u30FC\u30C8\u30EA\u30ED\u30FC\u30C9<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="autoReloadTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td style="text-align: right;padding-top: 5px;"></td><td style="padding-top: 5px;padding-left: 5px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="autoReload" id="autoReload1" value="1" ng-model="ctrlScope.autoReload" data-ng-change="changeAutoReload(\'1\')"> <span>\u30AA\u30F3</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="autoReload" id="autoReload0" value="0" ng-model="ctrlScope.autoReload" data-ng-change="changeAutoReload(\'0\')"> <span>\u30AA\u30D5</span></label></p></div></td></tr><tr><td style="text-align: right;border: none; padding-bottom: 10px;">\u9593\u9694\u6642\u9593\uFF1A</td><td style="border: none; padding-bottom: 10px;"><div><select class="form-control selectpicker" selectpicker="" ng-model="ctrlScope.autoReloadSelected" ng-options="item as item.label for item in autoReloadItems" ng-disabled="autoReload == \'0\'"></select></div></td></tr><tr><td style="text-align: left;padding: 5px 8px;">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u4E00\u89A7\u306B\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u6BCE\u306E\u9032\u6357\u7387\u8868\u793A<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="progressTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td></td><td style="padding: 5px 0 5px 5px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="progress" id="progress0" value="1" ng-model="ctrlScope.progress"> <span>\u8868\u793A</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="progress" id="progress1" value="0" ng-model="ctrlScope.progress"> <span>\u975E\u8868\u793A</span></label></p></div></td></tr><tr><td style="width:250px; text-align: left;padding: 5px 8px;">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u4F5C\u6210\u6642\u306E\u6280\u8853\u8005\u4E26\u3073\u9806<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="userRadioTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td></td><td style="padding: 5px 0 5px 5px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="userRadio" id="userRadio0" value="0" ng-model="ctrlScope.userRadio"> <span>ID\u9806</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="userRadio" id="userRadio1" value="1" ng-model="ctrlScope.userRadio"> <span>\u5DE5\u4E8B\u3068\u306E\u8DDD\u96E2\u306E\u8FD1\u3044\u9806</span></label></p></div></td></tr><tr><td style="text-align: left;padding: 5px 8px;">\u62C5\u5F53\u6280\u8853\u8005\u3001\u6307\u793A\u8005\u306E\u95B2\u89A7\u533A\u5206<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="adminMngTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td></td><td style="padding: 5px 0 5px 5px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="adminMng" id="adminMng0" value="0" ng-model="ctrlScope.adminMng"> <span>\u5168\u30B0\u30EB\u30FC\u30D7</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="adminMng" id="adminMng1" value="1" ng-model="ctrlScope.adminMng"> <span>\u6240\u5C5E\u30B0\u30EB\u30FC\u30D7\u306E\u307F</span></label></p></div></td></tr><tr><td style="text-align: left;padding: 5px 8px;">\u6700\u7D42\u627F\u8A8D\u30DC\u30BF\u30F3\u306E\u8868\u793A<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="finalApprovalTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td></td><td style="padding: 5px 0 5px 5px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="finalApproval1" id="finalApproval01" value="1" ng-model="ctrlScope.finalApproval"> <span>\u8868\u793A</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="finalApproval1" id="finalApproval11" value="0" ng-model="ctrlScope.finalApproval"> <span>\u975E\u8868\u793A</span></label></p></div></td></tr><tr class="black-muted-bg"><th>\u5831\u544A\u66F8\u51FA\u529B</th></tr><tr><td style="text-align: left;padding: 5px 8px;">\u30C1\u30A7\u30C3\u30AF\u8A73\u7D30\u30DA\u30FC\u30B8\u306E\u30C1\u30A7\u30C3\u30AF\u7D50\u679C\u6B04<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="resultRadioTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td></td><td style="padding: 5px 0 5px 5px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="resultRadio" id="resultRadio0" value="0" ng-model="ctrlScope.resultRadio"> <span>\u8868\u793A</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="resultRadio" id="resultRadio1" value="1" ng-model="ctrlScope.resultRadio"> <span>\u975E\u8868\u793A</span></label></p></div></td></tr><tr><td style="text-align: left;padding: 5px 8px;">\u51FA\u529B\u6642\u306E\u5199\u771F\u30B5\u30A4\u30BA<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="imgDownRadioTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td></td><td style="padding: 5px 0 5px 5px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="imgDownRadio" id="imgDownRadio0" value="0" ng-model="ctrlScope.imgDownRadio"> <span>\u5727\u7E2E</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="imgDownRadio" id="imgDownRadio1" value="1" ng-model="ctrlScope.imgDownRadio"> <span>\u30AA\u30EA\u30B8\u30CA\u30EB</span></label></p></div></td></tr><tr><td style="text-align: left;padding: 5px 8px;">\u5831\u544A\u66F8\u306E\u30ED\u30B4<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="logoDownRadioTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td></td><td style="padding: 5px 0 5px 5px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="logoDownRadio" id="logoDownRadio0" value="0" ng-model="ctrlScope.logoDownRadio"> <span>\u51FA\u529B\u3059\u308B</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="logoDownRadio" id="logoDownRadio1" value="1" ng-model="ctrlScope.logoDownRadio"> <span>\u51FA\u529B\u3057\u306A\u3044</span></label></p></div></td></tr><tr><td style="text-align: left;padding: 5px 8px;">\u30C1\u30A7\u30C3\u30AF\u66F4\u65B0\u65E5\u6642<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="updateTimeRadioTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td></td><td style="padding: 5px 0 5px 5px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="updateTimeRadio" id="updateTimeRadio0" value="0" ng-model="ctrlScope.updateTimeRadio"> <span>\u51FA\u529B\u3059\u308B</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="updateTimeRadio" id="updateTimeRadio1" value="1" ng-model="ctrlScope.updateTimeRadio"> <span>\u51FA\u529B\u3057\u306A\u3044</span></label></p></div></td></tr><tr><td style="text-align: left;padding: 5px 8px;">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8ID<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="ticketIdRadioTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td></td><td style="padding: 5px 0 5px 5px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="ticketIdRadio" id="ticketIdRadio0" value="0" ng-model="ctrlScope.ticketIdRadio"> <span>\u51FA\u529B\u3059\u308B</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="ticketIdRadio" id="ticketIdRadio1" value="1" ng-model="ctrlScope.ticketIdRadio"> <span>\u51FA\u529B\u3057\u306A\u3044</span></label></p></div></td></tr><tr><td style="text-align: left;padding: 5px 8px;">\u6307\u793A\u30B0\u30EB\u30FC\u30D7\u3068\u62C5\u5F53\u6280\u8853\u8005\u30B0\u30EB\u30FC\u30D7<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="rrGroupRadioTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td></td><td style="padding: 5px 0 5px 5px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="rrGroupRadio" id="rrGroupRadio0" value="0" ng-model="ctrlScope.rrGroupRadio"> <span>\u51FA\u529B\u3059\u308B</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="rrGroupRadio" id="rrGroupRadio1" value="1" ng-model="ctrlScope.rrGroupRadio"> <span>\u51FA\u529B\u3057\u306A\u3044</span></label></p></div></td></tr><tr class="black-muted-bg"><th>\u901A\u77E5\u8A2D\u5B9A</th></tr><tr><td rowspan="2" style="text-align: left;padding: 5px 8px;">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u306E\u30B9\u30C6\u30FC\u30BF\u30B9\u304C\u5909\u66F4\u3055\u308C\u305F\u969B\u306E\u901A\u77E5<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="commentTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td rowspan="2"></td><td style="padding: 5px 0 0 5px;"><div><p><label class="checkbox-inline custom-checkbox nowrap"><input ng-checked="ctrlScope.commentWithBellCheckBox" type="checkbox" ng-model="ctrlScope.commentWithBellCheckBox"> <span><i class="material-icons">notifications_none</i> \u30D8\u30C3\u30C0\u30FC\u90E8\u306E\u30D9\u30EB\u901A\u77E5</span></label></p></div></td></tr><tr><td style="padding: 5px 0 0 5px; text-align: left;padding-bottom: 10px;border: none;"><div><p><label class="checkbox-inline custom-checkbox nowrap"><input ng-checked="ctrlScope.commentWithMailCheckBox" type="checkbox" ng-model="ctrlScope.commentWithMailCheckBox"> <span><i style="font-size: 20px;vertical-align: middle;" class="ion-email"></i> \u30E1\u30FC\u30EB\u9001\u4FE1\u901A\u77E5</span></label></p></div></td></tr><tr><td rowspan="2" style="text-align: left;padding: 5px 8px;">\u304A\u77E5\u3089\u305B\u3092\u8A18\u8F09\u3055\u308C\u305F\u969B\u306E\u901A\u77E5<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="newsTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td rowspan="2"></td><td style="padding: 5px 0 0 5px;"><div><p><label class="checkbox-inline custom-checkbox nowrap"><input ng-checked="ctrlScope.newsWithBellCheckBox" type="checkbox" ng-model="ctrlScope.newsWithBellCheckBox"> <span><i class="material-icons">notifications_none</i> \u30D8\u30C3\u30C0\u30FC\u90E8\u306E\u30D9\u30EB\u901A\u77E5</span></label></p></div></td></tr><tr><td style="padding: 5px 0 0 5px; text-align: left;padding-bottom: 10px;border: none;"><div><p><label class="checkbox-inline custom-checkbox nowrap"><input ng-checked="ctrlScope.newsWithMailCheckBox" type="checkbox" ng-model="ctrlScope.newsWithMailCheckBox"> <span><i style="font-size: 20px;vertical-align: middle;" class="ion-email"></i> \u30E1\u30FC\u30EB\u9001\u4FE1\u901A\u77E5</span></label></p></div></td></tr><tr><td rowspan="2" style="text-align: left;padding: 5px 8px;">\u5171\u6709\u30C7\u30FC\u30BF\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u305F\u969B\u306E\u901A\u77E5<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="documentTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td rowspan="2"></td><td style="padding: 5px 0 0 5px;"><div><p><label class="checkbox-inline custom-checkbox nowrap"><input ng-checked="ctrlScope.documentWithBellCheckBox" type="checkbox" ng-model="ctrlScope.documentWithBellCheckBox"> <span><i class="material-icons">notifications_none</i> \u30D8\u30C3\u30C0\u30FC\u90E8\u306E\u30D9\u30EB\u901A\u77E5</span></label></p></div></td></tr><tr><td style="padding: 5px 0 0 5px; text-align: left;padding-bottom: 10px;border: none;"><div><p><label class="checkbox-inline custom-checkbox nowrap"><input ng-checked="ctrlScope.documentWithMailCheckBox" type="checkbox" ng-model="ctrlScope.documentWithMailCheckBox"> <span><i style="font-size: 20px;vertical-align: middle;" class="ion-email"></i> \u30E1\u30FC\u30EB\u9001\u4FE1\u901A\u77E5</span></label></p></div></td></tr><tr><td rowspan="2" style="text-align: left;padding-top: 5px;">\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8\u306E\u30C7\u30D5\u30A9\u30EB\u30C8\u671F\u9593\u8A2D\u5B9A<div style="margin-left: 5px;color: #ffaf0d;font-size: larger;display: inline;" class="ng-scope" tooltip-placement="right" uib-tooltip-html="defaultDateTooltip"><i class="ion-help-circled" aria-hidden="true"></i></div>\uFF1A</td><td style="text-align: right;padding-top: 5px;">\u5B8C\u4E86\u4E88\u5B9A\u65E5\uFF08FROM\uFF09\uFF1A</td><td style="padding-top: 5px;padding-left: 5px;"><div><select class="form-control selectpicker" selectpicker="" ng-model="ctrlScope.defaultEndDateFrom" ng-options="item as item.label for item in defaultDateFroms"></select></div></td></tr><tr><td style="text-align: right;border: none; padding-bottom: 10px;">\u5B8C\u4E86\u4E88\u5B9A\u65E5\uFF08TO\uFF09\uFF1A</td><td style="border: none; padding-bottom: 10px;padding-left: 5px;"><div><select class="form-control selectpicker" selectpicker="" ng-model="ctrlScope.defaultEndDateTo" ng-options="item as item.label for item in defaultDateTos"></select></div></td></tr><tr><td colspan="3" style="text-align: center; padding-top: 10px;"><button type="button" class="btn btn-info" ng-click="modifySetting()">\u4FDD\u5B58</button></td></tr></table>');
$templateCache.put('app/pages/manage/showDefaultResultManage.html','<table class="table table-condensed"><tr><td style="width:60%">\u30C1\u30A7\u30C3\u30AF\u8A73\u7D30\u30DA\u30FC\u30B8\u306E\u30C1\u30A7\u30C3\u30AF\u7D50\u679C\uFF1A</td><td><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="resultRadio" id="resultRadio1" value="1" ng-model="ctrlScope.resultRadio"> <span>\u975E\u8868\u793A</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="resultRadio" id="resultRadio0" value="0" ng-model="ctrlScope.resultRadio"> <span>\u8868\u793A</span></label></p></div></td></tr><tr><td colspan="2" style="text-align: center; padding-top: 10px;"><button type="button" class="btn btn-info" ng-click="modifyShowResult(\'SHOW_RESULT\')">\u4FDD\u5B58</button></td></tr></table>');
$templateCache.put('app/pages/manage/systemManage.html','<table class="table table-condensed"><tr><td style="width:40%">\u30A2\u30E9\u30FC\u30C8\u901A\u77E5\uFF1A</td><td><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="alertRadio" id="alertRadio1" value="1" ng-model="ctrlScope.alertRadio" data-ng-change="changeAlertRadio(\'1\')"> <span>\u30AA\u30F3</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="alertRadio" id="alertRadio0" value="0" ng-model="ctrlScope.alertRadio" data-ng-change="changeAlertRadio(\'0\')"> <span>\u30AA\u30D5</span></label></p></div></td></tr><tr><td>\u57FA\u6E96\u8DDD\u96E2\uFF1A</td><td><div><select class="form-control selectpicker" selectpicker="" ng-model="ctrlScope.alertSelected" ng-options="item as item.label for item in alertItems" ng-disabled="alertRadio == \'0\'"></select></div></td></tr><tr><td colspan="2" style="text-align: center; padding-top: 10px;"><button type="button" class="btn btn-info" ng-click="modifyAlert()">\u4FDD\u5B58</button></td></tr></table>');
$templateCache.put('app/pages/manage/userOrderManage.html','<table class="table table-condensed"><tr><td style="width:40%">\u6280\u8853\u8005\u30BD\u30FC\u30C8\u9806\uFF1A</td><td><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="userRadio" id="userRadio1" value="1" ng-model="ctrlScope.userRadio"> <span>\u5BFE\u8C61\u5DE5\u4E8B\u3068\u306E\u8DDD\u96E2\u306E\u8FD1\u3044\u9806</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="userRadio" id="userRadio0" value="0" ng-model="ctrlScope.userRadio"> <span>\u30A2\u30EB\u30D5\u30A1\u30D9\u30C3\u30C8</span></label></p></div></td></tr><tr><td colspan="2" style="text-align: center; padding-top: 10px;"><button type="button" class="btn btn-info" ng-click="modifyUserSort(\'USER_ORDER\')">\u4FDD\u5B58</button></td></tr></table>');
$templateCache.put('app/pages/manual/manual.html','<div class="widgets"><div class="row"><div ng-if="!$root.isMoblie" class="col-md-12"><div ba-panel="" ba-panel-title="\u5171\u6709\u30C7\u30FC\u30BF\u4E00\u89A7" ba-panel-class="with-scroll"><div include-with-scope="app/pages/manual/manualList.html"></div></div></div><div ng-if="$root.isMoblie" class="col-md-12" style="padding :0;"><div ba-panel="" ba-panel-title="\u5171\u6709\u30C7\u30FC\u30BF\u4E00\u89A7" ba-panel-class="sp-panel"><div include-with-scope="app/pages/manual/manualListSp.html"></div></div></div></div></div>');
$templateCache.put('app/pages/manual/manualList.html','<div ng-show="!readonly" style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info btn-sm" ng-click="openUploadDialog()">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="fileListCopy" st-safe-src="fileList" st-set-filter="customFilter" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th style="text-align:left" st-sort="fileName">\u30D5\u30A1\u30A4\u30EB\u540D</th><th st-sort="size">\u30B5\u30A4\u30BA</th><th st-sort="userName">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u8005</th><th st-sort="updateTime">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u65E5\u6642</th><th ng-show="!readonly">\u64CD\u4F5C</th></tr><tr><th><select st-search="fileName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fileName\'" value="{{item.fileName}}">{{item.fileName}}</option></select></th><th><select st-search="size" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'size\'" value="{{item.size}}">{{item.size}}</option></select></th><th><select st-search="userName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userName\'" value="{{item.userName}}">{{item.userName}}</option></select></th><th><select st-search="updateTime" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'updateTime\'" value="{{item.updateTime}}">{{item.updateTime}}</option></select></th><th ng-show="!readonly"></th></tr></thead><tbody><tr ng-repeat="item in fileListCopy"><td style="white-space: nowrap; width: 30%" class="table-id"><a href="javascript:;" ng-click="downLoadFile(item);">{{item.fileName}}</a> <button ng-show="isImg(item.fileName)" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="previewImage(item)"><i class="material-icons">open_in_new</i></button></td><td style="white-space: nowrap; text-align:right; width: 10%">{{ $root.getFileSize(item.size) }}</td><td style="white-space: nowrap; width: 20%">{{ item.userName }}</td><td style="white-space: nowrap; width: 20%">{{ item.updateTime }}</td><td ng-show="!readonly" style="white-space: nowrap"><button class="editable-table-button btn btn-xs btn-danger" ng-click="delFile(item)">\u524A\u9664</button></td></tr></tbody><tfoot><tr><td colspan="14" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/manual/manualListSp.html','<div><table style="border-collapse: separate; border-spacing: 0px 5px; width: 90%; margin: 0 auto;"><tr><td>\u30D5\u30A1\u30A4\u30EB\u540D:</td><td><input type="text" class="form-control" ng-model="ctrl.fileName"></td></tr><tr><td colspan="2" style="text-align: center;"><button style="padding-right:10px" type="button" class="btn btn-primary" ng-click="getFileListSp()">\u691C\u7D22</button></td></tr></table><table class="table table-striped" st-table="manualData" st-safe-src="fileList"><thead><tr><td class="text-left"></td></tr></thead><tbody><tr ng-repeat="item in manualData" style="border: 1px solid rgba(0, 0, 0, 0.12);"><td style="padding-right: 8px !important;line-height: 30px;"><table style="width: 100%;"><tr><td style="text-align: left;padding-top: 5px;"><a href="javascript:;" ng-click="downLoadFile(item);">{{item.fileName}}</a> <button ng-show="isImg(item.fileName)" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="previewImage(item)"><i class="material-icons">open_in_new</i></button></td></tr><tr><td style="text-align: left;padding-bottom: 5px;">{{item.updateTime}}</td></tr></table></td></tr></tbody><tfoot><tr><td class="text-left"></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/masterdata/checkResultDetailMaster.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u9078\u629E\u5024\u8A73\u7D30</h4></div><div class="modal-body text-left"><div style="margin-bottom: 20px;"><input ng-model="ctrl.userResGroupName" type="text" class="form-control" placeholder="\u7D50\u679C\u540D\u79F0"></div><div class="add-row-editable-table"><button class="btn btn-info" ng-click="addDetail()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:83%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="detailList"><li class="list" ng-repeat="item in detailList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:83%;"><span class="cut-with-dots"><input id="label{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="value{{$index}}" type="hidden" value="{{::item.value}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeDetail($index,item.value)">\u524A\u9664</button></td></tr></table></li></ul></div></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="saveDetail();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/masterdata/checkResultMaster.html','<div><div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info" ng-click="showCheckResultCreate()">\u65B0\u898F</button></div><table class="table" st-table="listData" st-safe-src="userResourceList" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th st-sort="label" style="width:90%">\u30C1\u30A7\u30C3\u30AF\u8A73\u7D30\u30C7\u30FC\u30BF</th><th>\u64CD\u4F5C</th></tr><tr><th><select st-search="label" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'label\'" value="{{item.label}}">{{item.label}}</option></select></th><th></th></tr></thead><tbody><tr ng-repeat="item in listData"><td class="table-id"><a href="javascript:;" ng-click="showCheckResultDetail(item);">{{item.label}}</a></td><td><button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUserResource(item.value)">\u524A\u9664</button></td></tr></tbody><tfoot><tr><td class="text-left" colspan="2"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/masterdata/companyMaster.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addCompany()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:80%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="companyList"><li class="list" ng-repeat="item in companyList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:83%;"><span class="cut-with-dots"><input id="label{{$index}}" type="text" value="{{::item.fName}}" class="form-control" maxlength="100"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeCompany($index,item.id)">\u524A\u9664</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="companyList.length > 0 || (companyList.length == 0 && removeCompanyIdList.length !=0)"><button type="button" class="btn btn-info" ng-click="saveCompanyList();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelCompany()">\u53D6\u6D88</button></div><div style="height:30px" id="gotoMaster" ng-if="!(companyList.length > 0 || (companyList.length == 0 && removeCompanyIdList.length !=0))"></div><div class="add-row-editable-table" id="gotoMaster" ng-show="companyList.length > 0 || (companyList.length == 0 && removeCompanyIdList.length !=0)"><button class="btn btn-info" ng-click="addCompany()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/master1.html','<div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info" ng-click="showMasterAll()">\u95B2\u89A7</button> <a class="btn btn-warning" style="background: #209e91; border-color: #209e91;" ng-click="downloadMasterAll()">\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a> <button ng-if="isUsedInTarget == 0" type="file" ngf-select="uploadMasterAll($file)" class="btn btn-info" accept=".csv, text/csv" ngf-max-size="10MB">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="add-row-editable-table"><button class="btn btn-info" ng-click="addFirst()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:75%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="width:20%;text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="firstList"><li class="list" ng-repeat="item in firstList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:75%;"><span class="cut-with-dots"><input id="firstLabel{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="width:134px;text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeFirst($index,item)">\u524A\u9664</button> <button ng-if="item.id != 0" type="button" class="status-button btn btn-xs btn-info" ng-click="showSecond(item)">\u8A73\u7D30</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="firstList.length > 0 || (firstList.length == 0 && removeFirstIdList.length !=0)"><button type="button" class="btn btn-info" ng-click="saveFirstList();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelFirst()">\u53D6\u6D88</button></div><div style="height:30px" id="gotoTargetKbn" ng-if="!(firstList.length > 0 || (firstList.length == 0 && removeFirstIdList.length !=0))"></div><div class="add-row-editable-table" id="gotoTargetKbn" ng-show="firstList.length > 0 || (firstList.length == 0 && removeFirstIdList.length !=0)"><button class="btn btn-info" ng-click="addFirst()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/master2.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addSecond()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:75%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="width:20%;text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="secondList"><li class="list" ng-repeat="item in secondList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:75%;"><span class="cut-with-dots"><input id="secondLabel{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="width:134px;text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeSecond($index,item)">\u524A\u9664</button> <button ng-if="item.id != 0" type="button" class="status-button btn btn-xs btn-info" ng-click="showThird(item)">\u8A73\u7D30</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="secondList.length > 0 || (secondList.length == 0 && removeSecondIdList.length !=0)"><button type="button" class="btn btn-info" ng-click="saveSecondList();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelSecond()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="secondList.length > 0 || (secondList.length == 0 && removeSecondIdList.length !=0)"><button class="btn btn-info" ng-click="addSecond()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/master3.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addThird()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:78%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="thirdList"><li class="list" ng-repeat="item in thirdList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:80%;"><span class="cut-with-dots"><input id="thirdLabel{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeThird($index,item)">\u524A\u9664</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="thirdList.length > 0 || (thirdList.length == 0 && removeThirdIdList.length !=0)"><button type="button" class="btn btn-info" ng-click="saveThirdList();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelThird()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="thirdList.length > 0 || (thirdList.length == 0 && removeThirdIdList.length !=0)"><button class="btn btn-info" ng-click="addThird()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/master4Check1.html','<div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info" ng-click="showMaster4CheckAll()">\u95B2\u89A7</button></div><div class="add-row-editable-table"><button class="btn btn-info" ng-click="addFirstCheck()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:75%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="width:20%;text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="firstCheckList"><li class="list" ng-repeat="item in firstCheckList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:75%;"><span class="cut-with-dots"><input id="firstCheckLabel{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="width:134px;text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeFirstCheck($index,item)">\u524A\u9664</button> <button ng-if="item.id != 0" type="button" class="status-button btn btn-xs btn-info" ng-click="showSecondCheck(item)">\u8A73\u7D30</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="firstCheckList.length > 0 || (firstCheckList.length == 0 && removeFirstCheckIdList.length !=0)"><button type="button" class="btn btn-info" ng-click="saveFirstCheckList();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelFirstCheck()">\u53D6\u6D88</button></div><div style="height:30px" id="gotoTargetKbn" ng-if="!(firstCheckList.length > 0 || (firstCheckList.length == 0 && removeFirstCheckIdList.length !=0))"></div><div class="add-row-editable-table" id="gotoTargetKbn" ng-show="firstCheckList.length > 0 || (firstCheckList.length == 0 && removeFirstCheckIdList.length !=0)"><button class="btn btn-info" ng-click="addFirstCheck()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/master4Check2.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addSecondCheck()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:75%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="width:20%;text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="secondCheckList"><li class="list" ng-repeat="item in secondCheckList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:75%;"><span class="cut-with-dots"><input id="secondCheckLabel{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="width:134px;text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeSecondCheck($index,item)">\u524A\u9664</button> <button ng-if="item.id != 0" type="button" class="status-button btn btn-xs btn-info" ng-click="showThirdCheck(item)">\u8A73\u7D30</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="secondCheckList.length > 0 || (secondCheckList.length == 0 && removeSecondCheckIdList.length !=0)"><button type="button" class="btn btn-info" ng-click="saveSecondCheckList();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelSecondCheck()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="secondCheckList.length > 0 || (secondCheckList.length == 0 && removeSecondCheckIdList.length !=0)"><button class="btn btn-info" ng-click="addSecondCheck()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/master4Check3.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addThirdCheck()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:75%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="width:20%;text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="thirdCheckList"><li class="list" ng-repeat="item in thirdCheckList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:75%;"><span class="cut-with-dots"><input id="thirdCheckLabel{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="width:134px;text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeThirdCheck($index,item)">\u524A\u9664</button> <button ng-if="item.id != 0" type="button" class="status-button btn btn-xs btn-info" ng-click="showFourthCheck(item)">\u8A73\u7D30</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="thirdCheckList.length > 0 || (thirdCheckList.length == 0 && removeThirdCheckIdList.length !=0)"><button type="button" class="btn btn-info" ng-click="saveThirdCheckList();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelThirdCheck()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="thirdCheckList.length > 0 || (thirdCheckList.length == 0 && removeThirdCheckIdList.length !=0)"><button class="btn btn-info" ng-click="addThirdCheck()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/master4Check4.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addFourthCheck()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:78%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="fourthCheckList"><li class="list" ng-repeat="item in fourthCheckList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:80%;"><span class="cut-with-dots"><input id="fourthCheckLabel{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeFourthCheck($index,item)">\u524A\u9664</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="fourthCheckList.length > 0 || (fourthCheckList.length == 0 && removeFourthCheckIdList.length !=0)"><button type="button" class="btn btn-info" ng-click="saveFourthCheckList();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelFourthCheck()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="fourthCheckList.length > 0 || (fourthCheckList.length == 0 && removeFourthCheckIdList.length !=0)"><button class="btn btn-info" ng-click="addFourthCheck()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/master4CheckAll.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u4E00\u89A7</h4></div><div class="modal-body text-left"><table class="table table-bordered"><tbody><tr style="font-weight: 600; font-size: 20px;"><td style="text-align: left;">\u533A\u5206</td><td>\u5927\u9805\u76EE</td><td>\u4E2D\u9805\u76EE</td><td>\u5C0F\u9805\u76EE</td></tr><tr ng-repeat="masterItem in master4CheckShowList"><td ng-if="masterItem.firstName != \'\'" rowspan="{{masterItem.tougoFirst}}" style="text-align: left;">{{masterItem.firstName}}</td><td style="text-align: left;" ng-if="masterItem.secondName != \'\'" rowspan="{{masterItem.tougoSecond}}">{{masterItem.secondName}}</td><td style="text-align: left;" ng-if="masterItem.thirdName != \'\'" rowspan="{{masterItem.tougoThird}}">{{masterItem.thirdName}}</td><td style="text-align: left;" ng-if="masterItem.secondName == \'\' && masterItem.thirdName == \'\' && masterItem.fourthName == \'\'"></td><td style="text-align: left;" ng-if="masterItem.thirdName == \'\' && masterItem.fourthName == \'\'"></td><td style="text-align: left;">{{masterItem.fourthName}}</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/masterdata/masterAll.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u4E00\u89A7</h4></div><div class="modal-body text-left"><table class="table table-bordered"><tbody><tr style="font-weight: 600; font-size: 20px;"><td style="text-align: left;">{{firstItemName}}</td><td>{{secondItemName}}</td><td>{{thirdItemName}}</td></tr><tr ng-repeat="masterItem in masterShowList"><td ng-if="masterItem.firstName != \'\'" rowspan="{{masterItem.tougoFirst}}" style="text-align: left;">{{masterItem.firstName}}</td><td style="text-align: left;" ng-if="masterItem.secondName != \'\'" rowspan="{{masterItem.tougoSecond}}">{{masterItem.secondName}}</td><td style="text-align: left;" ng-if="masterItem.secondName == \'\' && masterItem.thirdName == \'\'"></td><td style="text-align: left;">{{masterItem.thirdName}}</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/masterdata/masterdata.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u8A73\u7D30(\u30BB\u30EC\u30AF\u30C8\u30DC\u30C3\u30AF\u30B9\u9078\u629E\u5024)" ba-panel-class="with-scroll"><div include-with-scope="app/pages/masterdata/checkResultMaster.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="\u30B9\u30C6\u30FC\u30BF\u30B9" ba-panel-class="with-scroll" id="statusPanel"><div include-with-scope="app/pages/masterdata/statusMaster.html"></div></div></div></div><div class="row" ng-controller="Masterdata4CheckSheetCtrl"><div class="col-md-8"><div ba-panel="" ba-panel-title="\u533A\u5206" ba-panel-class="with-scroll" id="master4Check1"><div include-with-scope="app/pages/masterdata/master4Check1.html"></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="\u5927\u9805\u76EE\uFF1A{{SecondCheckTileName}}" ba-panel-class="with-scroll" id="master4Check2" style="display: none;"><div include-with-scope="app/pages/masterdata/master4Check2.html"></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="\u4E2D\u9805\u76EE\uFF1A{{ThirdCheckTileName}}" ba-panel-class="with-scroll" id="master4Check3" style="display: none;"><div include-with-scope="app/pages/masterdata/master4Check3.html"></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="\u5C0F\u9805\u76EE\uFF1A{{FourthCheckTileName}}" ba-panel-class="with-scroll" id="master4Check4" style="display: none;"><div include-with-scope="app/pages/masterdata/master4Check4.html"></div></div></div></div><div class="row"><div class="col-md-8"><div ba-panel="" ba-panel-title="\u4F1A\u793E" ba-panel-class="with-scroll"><div include-with-scope="app/pages/masterdata/companyMaster.html"></div></div></div></div><div class="row"><div class="col-md-8"><div ba-panel="" ba-panel-title="{{firstItemName}}" ba-panel-class="with-scroll" id="master1"><div include-with-scope="app/pages/masterdata/master1.html"></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="{{secondItemName}}\uFF1A{{SecondTileName}}" ba-panel-class="with-scroll" id="master2" style="display: none;"><div include-with-scope="app/pages/masterdata/master2.html"></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="{{thirdItemName}}\uFF1A{{ThirdTileName}}" ba-panel-class="with-scroll" id="master3" style="display: none;"><div include-with-scope="app/pages/masterdata/master3.html"></div></div></div></div><div ba-panel="" ba-panel-title="\u5DE5\u4E8B\u533A\u5206\u30DE\u30B9\u30BF\u30C7\u30FC\u30BF"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{targetKbn1ItemName}}" ba-panel-class="with-scroll" id="targetKbn1Panel"><div include-with-scope="app/pages/masterdata/targetKbn1Master.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="{{targetKbn2ItemName}}" ba-panel-class="with-scroll" id="targetKbn2Panel"><div include-with-scope="app/pages/masterdata/targetKbn2Master.html"></div></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{targetKbn3ItemName}}" ba-panel-class="with-scroll" id="targetKbn3Panel"><div include-with-scope="app/pages/masterdata/targetKbn3Master.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="{{targetKbn4ItemName}}" ba-panel-class="with-scroll" id="targetKbn4Panel"><div include-with-scope="app/pages/masterdata/targetKbn4Master.html"></div></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{targetKbn5ItemName}}" ba-panel-class="with-scroll" id="targetKbn5Panel"><div include-with-scope="app/pages/masterdata/targetKbn5Master.html"></div></div></div></div></div><div ba-panel="" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u533A\u5206\u30DE\u30B9\u30BF\u30C7\u30FC\u30BF"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{statusDetailItemName}}" ba-panel-class="with-scroll" id="statusDetailIPanel"><div include-with-scope="app/pages/masterdata/statusDetailMaster.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="{{ticketKbn2ItemName}}" ba-panel-class="with-scroll" id="ticketKbn2Panel"><div include-with-scope="app/pages/masterdata/ticketKbn2Master.html"></div></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{ticketKbn3ItemName}}" ba-panel-class="with-scroll" id="ticketKbn3Panel"><div include-with-scope="app/pages/masterdata/ticketKbn3Master.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="{{ticketKbn4ItemName}}" ba-panel-class="with-scroll" id="ticketKbn4Panel"><div include-with-scope="app/pages/masterdata/ticketKbn4Master.html"></div></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="{{ticketKbn5ItemName}}" ba-panel-class="with-scroll" id="ticketKbn5Panel"><div include-with-scope="app/pages/masterdata/ticketKbn5Master.html"></div></div></div></div></div></div>');
$templateCache.put('app/pages/masterdata/statusDetailMaster.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addStatusDetail()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:78%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="statusDetailList"><li class="list" ng-repeat="item in statusDetailList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:80%;"><span class="cut-with-dots"><input id="statusDetailLabel{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeStatusDetail($index,item.id)">\u524A\u9664</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="statusDetailList.length > 0 || (statusDetailList.length == 0 && removeStatusDetailList.length !=0)"><button type="button" class="btn btn-info" ng-click="saveStatusDetailList();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelStatusDetail()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="statusDetailList.length > 0 || (statusDetailList.length == 0 && removeStatusDetailList.length !=0)"><button class="btn btn-info" ng-click="addStatusDetail()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/statusMaster.html','<table class="table"><tr><td style="width: 25%; text-align: left;">\u9805\u76EE\u540D</td><td style="width: 45%;">\u8868\u793A\u540D</td><td style="width: 30%;">\u64CD\u4F5C</td></tr><tr ng-repeat="status in itemStatusList" class="editable-row"><td style="text-align: left;"><span>{{status.itemName}}</span></td><td><span editable-text="status.showName" e-name="label" e-form="rowform" e-required="" e-maxlength="128">{{status.showName}}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" onaftersave="saveStatus(status);"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-info editable-table-button btn-xs">\u4FDD\u5B58</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-danger editable-table-button btn-xs">\u53D6\u6D88</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">\u7DE8\u96C6</button></div></td></tr></table>');
$templateCache.put('app/pages/masterdata/targetKbn1Master.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addTargetKbn1()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:78%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="targetKbn1List"><li class="list" ng-repeat="item in targetKbn1List" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:80%;"><span class="cut-with-dots"><input id="targetKbn1Label{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeTargetKbn1($index,item.id)">\u524A\u9664</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="targetKbn1List.length > 0 || (targetKbn1List.length == 0 && removeTargetKbn1List.length !=0)"><button type="button" class="btn btn-info" ng-click="saveTargetKbn1List();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelTargetKbn1()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="targetKbn1List.length > 0 || (targetKbn1List.length == 0 && removeTargetKbn1List.length !=0)"><button class="btn btn-info" ng-click="addTargetKbn1()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/targetKbn2Master.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addTargetKbn2()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:78%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="targetKbn2List"><li class="list" ng-repeat="item in targetKbn2List" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:80%;"><span class="cut-with-dots"><input id="targetKbn2Label{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeTargetKbn2($index,item.id)">\u524A\u9664</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="targetKbn2List.length > 0 || (targetKbn2List.length == 0 && removeTargetKbn2List.length !=0)"><button type="button" class="btn btn-info" ng-click="saveTargetKbn2List();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelTargetKbn2()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="targetKbn2List.length > 0 || (targetKbn2List.length == 0 && removeTargetKbn2List.length !=0)"><button class="btn btn-info" ng-click="addTargetKbn2()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/targetKbn3Master.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addTargetKbn3()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:78%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="targetKbn3List"><li class="list" ng-repeat="item in targetKbn3List" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:80%;"><span class="cut-with-dots"><input id="targetKbn3Label{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeTargetKbn3($index,item.id)">\u524A\u9664</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="targetKbn3List.length > 0 || (targetKbn3List.length == 0 && removeTargetKbn3List.length !=0)"><button type="button" class="btn btn-info" ng-click="saveTargetKbn3List();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelTargetKbn3()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="targetKbn3List.length > 0 || (targetKbn3List.length == 0 && removeTargetKbn3List.length !=0)"><button class="btn btn-info" ng-click="addTargetKbn3()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/targetKbn4Master.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addTargetKbn4()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:78%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="targetKbn4List"><li class="list" ng-repeat="item in targetKbn4List" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:80%;"><span class="cut-with-dots"><input id="targetKbn4Label{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeTargetKbn4($index,item.id)">\u524A\u9664</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="targetKbn4List.length > 0 || (targetKbn4List.length == 0 && removeTargetKbn4List.length !=0)"><button type="button" class="btn btn-info" ng-click="saveTargetKbn4List();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelTargetKbn4()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="targetKbn4List.length > 0 || (targetKbn4List.length == 0 && removeTargetKbn4List.length !=0)"><button class="btn btn-info" ng-click="addTargetKbn4()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/targetKbn5Master.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addTargetKbn5()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:78%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="targetKbn5List"><li class="list" ng-repeat="item in targetKbn5List" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:80%;"><span class="cut-with-dots"><input id="targetKbn5Label{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeTargetKbn5($index,item.id)">\u524A\u9664</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="targetKbn5List.length > 0 || (targetKbn5List.length == 0 && removeTargetKbn5List.length !=0)"><button type="button" class="btn btn-info" ng-click="saveTargetKbn5List();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelTargetKbn5()">\u53D6\u6D88</button></div><div style="height:30px" id="gotoStatusDetail" ng-if="!(targetKbn5List.length > 0 || (targetKbn5List.length == 0 && removeTargetKbn5List.length !=0))"></div><div class="add-row-editable-table" id="gotoStatusDetail" ng-show="targetKbn5List.length > 0 || (targetKbn5List.length == 0 && removeTargetKbn5List.length !=0)"><button class="btn btn-info" ng-click="addTargetKbn5()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/ticketKbn2Master.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addTicketKbn2()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:78%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="ticketKbn2List"><li class="list" ng-repeat="item in ticketKbn2List" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:80%;"><span class="cut-with-dots"><input id="ticketKbn2Label{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeTicketKbn2($index,item.id)">\u524A\u9664</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="ticketKbn2List.length > 0 || (ticketKbn2List.length == 0 && removeTicketKbn2List.length !=0)"><button type="button" class="btn btn-info" ng-click="saveTicketKbn2List();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelTicketKbn2()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="ticketKbn2List.length > 0 || (ticketKbn2List.length == 0 && removeTicketKbn2List.length !=0)"><button class="btn btn-info" ng-click="addTicketKbn2()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/ticketKbn3Master.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addTicketKbn3()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:78%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="ticketKbn3List"><li class="list" ng-repeat="item in ticketKbn3List" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:80%;"><span class="cut-with-dots"><input id="ticketKbn3Label{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeTicketKbn3($index,item.id)">\u524A\u9664</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="ticketKbn3List.length > 0 || (ticketKbn3List.length == 0 && removeTicketKbn3List.length !=0)"><button type="button" class="btn btn-info" ng-click="saveTicketKbn3List();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelTicketKbn3()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="ticketKbn3List.length > 0 || (ticketKbn3List.length == 0 && removeTicketKbn3List.length !=0)"><button class="btn btn-info" ng-click="addTicketKbn3()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/ticketKbn4Master.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addTicketKbn4()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:78%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="ticketKbn4List"><li class="list" ng-repeat="item in ticketKbn4List" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:80%;"><span class="cut-with-dots"><input id="ticketKbn4Label{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeTicketKbn4($index,item.id)">\u524A\u9664</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="ticketKbn4List.length > 0 || (ticketKbn4List.length == 0 && removeTicketKbn4List.length !=0)"><button type="button" class="btn btn-info" ng-click="saveTicketKbn4List();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelTicketKbn4()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="ticketKbn4List.length > 0 || (ticketKbn4List.length == 0 && removeTicketKbn4List.length !=0)"><button class="btn btn-info" ng-click="addTicketKbn4()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/masterdata/ticketKbn5Master.html','<div class="add-row-editable-table"><button class="btn btn-info" ng-click="addTicketKbn5()">\u8FFD\u52A0</button></div><div class="task-todo-container transparent"><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:5%;text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:78%;text-align: center;"><span class="cut-with-dots">\u540D\u79F0</span></td><td style="text-align: center;"><span class="cut-with-dots">\u64CD\u4F5C</span></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="ticketKbn5List"><li class="list" ng-repeat="item in ticketKbn5List" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:5%;"><span class="cut-with-dots">{{$index+1}}</span></td><td style="width:80%;"><span class="cut-with-dots"><input id="ticketKbn5Label{{$index}}" type="text" value="{{::item.label}}" class="form-control" maxlength="128"></span> <input id="id{{$index}}" type="hidden" value="{{::item.id}}"></td><td style="text-align: center;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeTicketKbn5($index,item.id)">\u524A\u9664</button></td></tr></table></li></ul></div><div style="text-align: center; margin-top: 10px;" ng-show="ticketKbn5List.length > 0 || (ticketKbn5List.length == 0 && removeTicketKbn5List.length !=0)"><button type="button" class="btn btn-info" ng-click="saveTicketKbn5List();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="cancelTicketKbn5()">\u53D6\u6D88</button></div><div class="add-row-editable-table" ng-show="ticketKbn5List.length > 0 || (ticketKbn5List.length == 0 && removeTicketKbn5List.length !=0)"><button class="btn btn-info" ng-click="addTicketKbn5()">\u8FFD\u52A0</button></div>');
$templateCache.put('app/pages/news/news.html','<div class="widgets" ng-if="!$root.isMoblie"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\u304A\u77E5\u3089\u305B\u4E00\u89A7" ba-panel-class="with-scroll" id="newsList"><div include-with-scope="app/pages/news/newsList.html"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="\u304A\u77E5\u3089\u305B\u8A73\u7D30" id="newsDetail" ng-style="{display: detailDisplay}"><div ng-include="\'app/pages/news/newsDetail.html\'"></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\u304A\u77E5\u3089\u305B\u65B0\u898F" ba-panel-class="with-scroll" id="creater" style="display: none;"><div include-with-scope="app/pages/news/newsCreater.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\u304A\u77E5\u3089\u305B\u7BA1\u7406" ba-panel-class="with-scroll" id="confirmDetail" style="display: none;"><div include-with-scope="app/pages/news/newsConfirmDetail.html"></div></div></div></div></div><div class="widgets" ng-if="$root.isMoblie"><div class="row"><div class="col-md-12" style="padding :0;"><div ba-panel="" ba-panel-title="\u304A\u77E5\u3089\u305B\u4E00\u89A7" ba-panel-class="with-scroll sp-panel" id="newsList"><div include-with-scope="app/pages/news/newsListSp.html"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="\u304A\u77E5\u3089\u305B\u8A73\u7D30" ba-panel-class="with-scroll sp-panel" id="newsDetail" style="padding :0;" ng-style="{display: detailDisplay}"><div ng-include="\'app/pages/news/newsDetailSp.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="\u304A\u77E5\u3089\u305B\u65B0\u898F" ba-panel-class="with-scroll sp-panel" id="creater" style="display: none;padding :0;"><div include-with-scope="app/pages/news/newsCreaterSp.html"></div></div></div></div>');
$templateCache.put('app/pages/news/newsConfirmDetail.html','<div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-danger" ng-click="deleteNews(selectedNews.newsId)">\u524A\u9664</button></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">\u304A\u77E5\u3089\u305B\u60C5\u5831</div><div class="panel-body"><div class="horizontal-scroll"><table class="table-target"><tr><th style="width:15%;min-width: 90px;">\u5BFE\u8C61\u30B0\u30EB\u30FC\u30D7\uFF1A</th><td style="width:85%">{{groupNames}}</td></tr><tr><th style="width:15%;min-width: 90px;">\u8868\u793A\u671F\u9650\uFF1A</th><td style="width:85%">{{selectedNews.limitDay}}</td></tr><tr><th>\u30BF\u30A4\u30C8\u30EB\uFF1A</th><td>{{selectedNews.title}}</td></tr><tr><th>\u5185\u5BB9\uFF1A</th><td style="word-wrap:break-word"><div style="word-wrap:break-word; max-width:900px" ng-bind-html="selectedNews.comment"></div></td></tr></table></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">\u78BA\u8A8D\u72B6\u6CC1</div><div class="panel-body"><div class="horizontal-scroll"><table class="table table-bordered table-checkreport"><thead><tr style="background-color:#fcf2dd;"><th style="text-align: center;" class="table-id">#</th><th style="text-align: center;">\u6280\u8853\u8005\u540D</th><th style="text-align: center;">\u78BA\u8A8D\u72B6\u6CC1</th><th style="text-align: center;">\u78BA\u8A8D\u65E5\u6642</th></tr></thead><tbody><tr ng-repeat="item in userConfirmList"><td class="table-id">{{$index+1}}</td><td>{{item.userId}}</td><td style="text-align: center; color: #F00;" ng-if="item.status == null || item.status == \'0\'">\u672A\u78BA\u8A8D</td><td style="text-align: center;" ng-if="item.status == \'1\'">\u78BA\u8A8D\u6E08</td><td style="text-align: center;" ng-if="item.status == \'1\'">{{item.confirmDate}}</td><td style="text-align: center;" ng-if="item.status == null || item.status == \'0\'"></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/pages/news/newsCreater.html','<div class="table-responsive" style="border-bottom: 1px solid rgba(0, 0, 0, 0.12);"><table class="table table-bordered" style="border: none; border-collapse:separate; border-spacing:0px 2px;"><tbody><tr><th style="vertical-align: middle;width:15%;">\u5BFE\u8C61\u30B0\u30EB\u30FC\u30D7\uFF1A</th><td style="border: none;"><ui-select id="group" multiple="" ng-model="selectedGroups.selected" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="\u9078\u629E\u3057\u306A\u3044\u5834\u5408\u3001\u5168\u3066\u306E\u30B0\u30EB\u30FC\u30D7\u304C\u5BFE\u8C61\u306B\u306A\u308B">{{$item.groupName}}</ui-select-match><ui-select-choices repeat="selectedGroups in groupList | filter: $select.search">{{selectedGroups.groupName}}</ui-select-choices></ui-select></td></tr><tr><th style="vertical-align: middle;width:15%;">\u8868\u793A\u671F\u9650\uFF1A</th><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin-bottom:auto;"><input ng-model="createNews.limitDateD" type="text" placeholder="YYYY/MM/DD" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td></tr><tr><th>\u30BF\u30A4\u30C8\u30EB\uFF1A</th><td style="border: none;"><input type="text" class="form-control" ng-model="createNews.title" maxlength="128"></td></tr><tr><th>\u5185\u5BB9\uFF1A</th><td style="border: none;"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'strikeThrough\',\'ul\', \'ol\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'quote\',\'undo\',\'redo\', \'fontColor\']]"></text-angular-toolbar><text-angular name="htmlcontent" ta-target-toolbars="toolbarMain" ng-model="createNews.content"></text-angular></td></tr><tr><th colspan="2" style="text-align: center;"><button type="button" class="btn btn-info" click-and-disable="create();">\u4FDD\u5B58</button></th></tr></tbody></table></div>');
$templateCache.put('app/pages/news/newsCreaterSp.html','<div class="typography-widget"><div class="section-block" style="text-align: center;"><div class="text-left"><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5BFE\u8C61\u30B0\u30EB\u30FC\u30D7\uFF1A</label><ui-select id="group" multiple="" ng-model="selectedGroups.selected" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="\u9078\u629E\u3057\u306A\u3044\u5834\u5408\u3001\u5168\u3066\u306E\u30B0\u30EB\u30FC\u30D7\u304C\u5BFE\u8C61\u306B\u306A\u308B">{{$item.groupName}}</ui-select-match><ui-select-choices repeat="selectedGroups in groupList | filter: $select.search">{{selectedGroups.groupName}}</ui-select-choices></ui-select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u8868\u793A\u671F\u9650\uFF1A</label><p class="input-group" style="" margin:="" 0;border-collapse:="" collapse;"="" ng-controller="datepickerpopupCtrl"><input ng-model="createNews.limitDateD" type="text" placeholder="YYYY/MM/DD" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u30BF\u30A4\u30C8\u30EB\uFF1A</label><br><input type="text" class="form-control" ng-model="createNews.title" maxlength="128"></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5185\u5BB9\uFF1A</label><br><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'strikeThrough\',\'ul\', \'ol\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'quote\',\'undo\',\'redo\', \'fontColor\']]"></text-angular-toolbar><text-angular style="text-align: left;" name="htmlcontent" ta-target-toolbars="toolbarMain" ng-model="createNews.content"></text-angular></div></div><div style="text-align: center; padding-top: 10px;"><button type="button" class="btn btn-info" click-and-disable="create()">\u4FDD\u5B58</button></div></div></div>');
$templateCache.put('app/pages/news/newsDetail.html','<div class="typography-widget"><div class="section-block" style="text-align: center;"><h1>{{selectedNews.title}}</h1><div style="word-wrap:break-word;max-width: 900px;margin: auto;"><div style="text-align: left;" ng-bind-html="selectedNews.comment"></div><button ng-if="selectedNews.status == \'0\'" type="button" class="btn btn-info" ng-click="confirmNews()" style="margin-top: 20px;">\u78BA\u8A8D</button></div><div style="margin-top: 20px;" ng-include="\'app/pages/news/newsFileList.html\'"></div></div></div>');
$templateCache.put('app/pages/news/newsDetailSp.html','<div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-danger" ng-click="deleteNewsSp(selectedNews.newsId)">\u524A\u9664</button></div><div class="typography-widget"><div class="section-block" style="text-align: center;"><h1>{{selectedNews.title}}</h1><div style="word-wrap:break-word;max-width: 900px;margin: auto;"><div style="text-align: left;" ng-bind-html="selectedNews.comment"></div><button ng-if="selectedNews.status == \'0\'" type="button" class="btn btn-info" ng-click="confirmNews()" style="margin-top: 20px;">\u78BA\u8A8D</button><div style="margin-top: 20px;"><uib-accordion ng-if="newsFileList.length > 0"><uib-accordion-group heading="\u95A2\u9023\u30D5\u30A1\u30A4\u30EB" panel-class="panel-info bootstrap-panel accordion-panel" style="text-align: center;"><div ng-include="\'app/pages/news/newsFileListSp.html\'"></div></uib-accordion-group></uib-accordion></div></div></div></div>');
$templateCache.put('app/pages/news/newsFileList.html','<div class="horizontal-scroll" ng-if="!readonly || newsFileList.length > 0" style="border-top: 1px solid rgba(0, 0, 0, 0.12);"><div ng-if="loginId == selectedNews.createUserId" style="text-align: right;"><button type="button" class="btn btn-info" style="margin: 5px 15px;" ng-click="openUploadDialog()">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><table class="table" st-table="fileListCopy" st-safe-src="newsFileList" st-set-filter="customFilter" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th style="text-align:left" st-sort="fileName">\u30D5\u30A1\u30A4\u30EB\u540D</th><th st-sort="size">\u30B5\u30A4\u30BA</th><th st-sort="userName">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u8005</th><th st-sort="updateTime">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u65E5\u6642</th><th>\u64CD\u4F5C</th></tr><tr><th><select st-search="fileName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fileName\'" value="{{item.fileName}}">{{item.fileName}}</option></select></th><th><select st-search="size" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'size\'" value="{{item.size}}">{{item.size}}</option></select></th><th><select st-search="userName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userName\'" value="{{item.userName}}">{{item.userName}}</option></select></th><th><select st-search="updateTime" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'updateTime\'" value="{{item.updateTime}}">{{item.updateTime}}</option></select></th><th></th></tr></thead><tbody><tr ng-repeat="item in fileListCopy"><td style="white-space: nowrap; width: 30%" class="table-id"><a href="javascript:;" ng-click="downLoadFile(item);">{{item.fileName}}</a> <button ng-show="isImg(item.fileName)" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="previewImage(item)"><i class="material-icons">open_in_new</i></button></td><td style="white-space: nowrap; text-align:right; width: 10%">{{ $root.getFileSize(item.size) }}</td><td style="white-space: nowrap; width: 20%">{{ item.userName }}</td><td style="white-space: nowrap; width: 20%">{{ item.updateTime }}</td><td style="white-space: nowrap"><button class="editable-table-button btn btn-xs btn-danger" ng-click="delFile(item)">\u524A\u9664</button></td></tr></tbody><tfoot><tr><td colspan="14" class="text-left"></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/news/newsFileListSp.html','<div class="horizontal-scroll" ng-if="!readonly || newsFileList.length > 0" style="border-top: 1px solid rgba(0, 0, 0, 0.12);"><table class="table" st-table="fileListCopy" st-safe-src="newsFileList" st-set-filter="customFilter" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th style="text-align:left" st-sort="fileName">\u30D5\u30A1\u30A4\u30EB\u540D</th></tr><tr><th><select st-search="fileName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fileName\'" value="{{item.fileName}}">{{item.fileName}}</option></select></th></tr></thead><tbody><tr ng-repeat="item in fileListCopy"><td style="white-space: nowrap; width: 30%" class="table-id"><a href="javascript:;" ng-click="downLoadFile(item);">{{item.fileName}}</a> <button ng-show="isImg(item.fileName)" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="previewImage(item)"><i class="material-icons">open_in_new</i></button></td></tr></tbody><tfoot><tr><td colspan="14" class="text-left"></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/news/newsList.html','<div class="horizontal-scroll"><div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info" ng-click="showCreateNews()">\u65B0\u898F</button></div><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="newsData" st-safe-src="newsList" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th class="table-id" st-sort="no">#</th><th st-sort="title">\u30BF\u30A4\u30C8\u30EB</th><th st-sort="createDay">\u767B\u9332\u65E5</th><th st-sort="limitDay">\u8868\u793A\u671F\u9650</th><th st-sort="status">\u78BA\u8A8D\u72B6\u6CC1</th><th st-sort="confirmDate">\u78BA\u8A8D\u65E5\u6642</th><th ng-if="!readonly" st-sort="confirmNum">\u78BA\u8A8D\u6E08\u6280\u8853\u8005\u6570</th><th ng-if="!readonly" st-sort="unConfirmNum">\u672A\u78BA\u8A8D\u6280\u8853\u8005\u6570</th><th ng-if="!readonly"></th></tr><tr><th></th><th><select st-search="title" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'title\'" value="{{item.title}}">{{item.title}}</option></select></th><th><select st-search="createDay" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'createDay\'" value="{{item.createDay}}">{{item.createDay}}</option></select></th><th><select st-search="limitDay" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'limitDay\'" value="{{item.limitDay}}">{{item.limitDay}}</option></select></th><th><select st-search="status" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'status\'" value="{{item.status}}">{{item.status}}</option></select></th><th><select st-search="confirmDate" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'confirmDate\'" value="{{item.confirmDate}}">{{item.confirmDate}}</option></select></th><th ng-if="!readonly"><select st-search="confirmNum" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'confirmNum\'" value="{{item.confirmNum}}">{{item.confirmNum}}</option></select></th><th ng-if="!readonly"><select st-search="unConfirmNum" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'unConfirmNum\'" value="{{item.unConfirmNum}}">{{item.unConfirmNum}}</option></select></th><th ng-if="!readonly"></th></tr></thead><tbody><tr ng-repeat="item in newsData"><td class="table-id">{{$index+1}}</td><td style="white-space: nowrap"><a href="javascript:;" ng-click="showNewsDetail(item.newsId, true);">{{item.title}}</a></td><td style="white-space: nowrap">{{item.createDay}}</td><td style="white-space: nowrap">{{item.limitDay}}</td><td style="white-space: nowrap; color: #F00;" ng-if="item.status == null || item.status == \'0\'">\u672A\u78BA\u8A8D</td><td style="white-space: nowrap" ng-if="item.status == \'1\'">\u78BA\u8A8D\u6E08</td><td style="white-space: nowrap" ng-if="item.status == null || item.status == \'0\'"></td><td style="white-space: nowrap" ng-if="item.status == \'1\'">{{item.confirmDate}}</td><td ng-if="!readonly" style="white-space: nowrap">{{item.confirmNum}}</td><td ng-if="!readonly" style="white-space: nowrap">{{item.unConfirmNum}}</td><td ng-if="!readonly"><button type="button" class="status-button btn btn-xs btn-info" ng-click="showNewsComfirmInfo(item.newsId);">\u8A73\u7D30</button></td></tr></tbody><tfoot><tr><td colspan="9" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/news/newsListSp.html','<div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info" ng-click="showCreateNewsSp()">\u65B0\u898F</button></div><div><table class="table" st-table="newsData" st-safe-src="newsList"><thead><tr class="sortable sp_table_title"><th st-sort="title">\u30BF\u30A4\u30C8\u30EB</th><th st-sort="createDate">\u767B\u9332\u65E5</th><th st-sort="confirmStatus">\u78BA\u8A8D\u72B6\u6CC1</th></tr></thead><tbody><tr ng-repeat="item in newsData" ng-click="showNewsDetail(item.newsId, true);"><td style="text-align:left"><a href="javascript:;">{{item.title}}</a></td><td>{{item.createDay}}</td><td class="unit_result"><span ng-if="item.status == \'0\'" class="notYet">\u672A</span> <span ng-if="item.status == \'1\'">\u6E08</span></td></tr></tbody><tfoot><tr><td colspan="4" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/offline/checkreportHistorySp.html','<div class="modal-content" style="margin: 66px 0px 0px;"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30B3\u30E1\u30F3\u30C8</h4></div><div class="modal-body text-left" style="text-align: left;"><table style="width:100%; margin-bottom: 20px;" ng-repeat="item in statusHistoryList"><tr style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"><td style="width:7%;">{{$index+1}}</td><td colspan="2" style="width:95%; font-weight: bold; padding-bottom: 5px;">{{item.statusName}}</td></tr><tr><td></td><td style="padding-top: 5px;">{{item.userName}}</td><td rowspan="2" style="padding-top: 5px;"></td></tr><tr><td></td><td>{{item.updateTime}}</td></tr><tr><td></td><td colspan="2" ng-bind-html="item.comment"></td></tr></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/offline/checkreportResultListSp.html','<div class="modal-content" style="margin: 66px 0px 0px;"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30C1\u30A7\u30C3\u30AF</h4></div><div class="modal-body text-left"><h5>{{ticket.checksheetName}}</h5><h6 ng-if="ticket.frequency != \'\' && ticket.frequency != null">{{ticket.frequency}}</h6><ul class="dropdownSp"><li ng-repeat="item in checkresultList"><button type="button" ng-click="getCheckreportDetailSp($index+1, false);$dismiss()" class="success" ng-if="item.checkResult != \'3\' && item.checkResult != \'\' && item.checkResult != null"><span style="overflow: hidden; width: 94%; display: inline-block;text-overflow: ellipsis;">{{$index+1}}\uFF0E{{item.checklistName}}</span></button> <button type="button" ng-click="getCheckreportDetailSp($index+1, false);$dismiss()" class="alart" ng-if="item.checkResult == \'3\' || item.checkResult == \'\' || item.checkResult == null"><span style="overflow: hidden; width: 94%; display: inline-block;text-overflow: ellipsis;">{{$index+1}}\uFF0E{{item.checklistName}}</span></button></li></ul></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/offline/checkreportTargetInfoSp.html','<div class="modal-content" style="margin: 66px 0px 0px;"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u5BFE\u8C61\u5DE5\u4E8B\u60C5\u5831</h4></div><div class="modal-body text-left"><table style="width:100%; margin-bottom: 10px;"><tr ng-repeat="targetItem in itemNameList"><th style="width:30%;">{{targetItem.showName}}\uFF1A</th><td style="width:70%;" ng-show="targetItem.fieldName != \'region\' && targetItem.fieldName != \'prefCd\' && targetItem.fieldName != \'first\' && targetItem.fieldName != \'second\' && targetItem.fieldName != \'third\'">{{ selectedTarget[targetItem.fieldName] }}</td><td style="width:70%;" ng-show="targetItem.fieldName == \'first\'">{{ selectedTarget.firstName }}</td><td style="width:70%;" ng-show="targetItem.fieldName == \'second\'">{{ selectedTarget.secondName }}</td><td style="width:70%;" ng-show="targetItem.fieldName == \'third\'">{{ selectedTarget.thirdName }}</td><td style="width:70%;" ng-show="targetItem.fieldName == \'prefCd\'">{{ selectedTar.pref.label }}</td><td style="width:70%;" ng-show="targetItem.fieldName == \'region\'">{{ selectedTar.reg.label }}</td></tr></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/offline/checkreportTicketInfoSp.html','<div class="modal-content" style="margin: 66px 0px 0px;"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u60C5\u5831</h4></div><div class="modal-body text-left" id="ticketShow" style="display: block;"><div class="form-group" style="padding-top: 30px;"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5BFE\u8C61\u5DE5\u4E8B\uFF1A <span style="padding-left: 10px;">{{ ticket.targetName }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u533A\u5206\uFF1A <span style="padding-left: 10px;">{{ ticket.first }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5927\u9805\u76EE\uFF1A <span style="padding-left: 10px;">{{ ticket.second }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u4E2D\u9805\u76EE\uFF1A <span style="padding-left: 10px;">{{ ticket.third }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5C0F\u9805\u76EE\uFF1A <span style="padding-left: 10px;">{{ ticket.fourth }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u30B9\u30C6\u30FC\u30BF\u30B9\uFF1A <span style="padding-left: 10px;">{{ ticket.statusName }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u958B\u59CB\u65E5(\u4E88\u5B9A)\uFF1A <span style="padding-left: 10px;">{{ ticket.startScheduledDate }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5B8C\u4E86\u65E5(\u4E88\u5B9A)\uFF1A <span style="padding-left: 10px;">{{ ticket.endScheduledDate }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u958B\u59CB\u65E5(\u5B9F\u7E3E)\uFF1A <span style="padding-left: 10px;">{{ ticket.startDate }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5B8C\u4E86\u65E5(\u5B9F\u7E3E)\uFF1A <span style="padding-left: 10px;">{{ ticket.endDate }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u7BA1\u7406\u6280\u8853\u8005\uFF1A <span style="padding-left: 10px;">{{ ticket.requestUserName }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u6307\u793A\u30B0\u30EB\u30FC\u30D7\uFF1A <span style="padding-left: 10px;">{{ ticket.requestGroupName }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u62C5\u5F53\u6280\u8853\u8005\uFF1A <span style="padding-left: 10px;">{{ ticket.responseUserName }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u62C5\u5F53\u6280\u8853\u8005\u30B0\u30EB\u30FC\u30D7\uFF1A <span style="padding-left: 10px;">{{ ticket.responseGroupName }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7\uFF1A <span style="padding-left: 10px;">{{ ticket.readingGroupName }}</span></label></div><div class="form-group" ng-if="parentTicket == \'1\'"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u89AA\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\uFF1A <span style="padding-left: 10px;"><a href="javascript:;" ng-click="showCheckreportDetailSpWindow(ticket.parentId);$dismiss();">{{ $root.padLeft(ticket.parentId, 8) }}</a></span></label></div><div class="form-group" ng-if="showStatusDetail"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{statusDetailItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.statusDetail }}</span></label></div><div class="form-group" ng-if="showKbn2"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn2ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.kbn2 }}</span></label></div><div class="form-group" ng-if="showKbn3"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn3ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.kbn3 }}</span></label></div><div class="form-group" ng-if="showKbn4"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn4ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.kbn4 }}</span></label></div><div class="form-group" ng-if="showKbn5"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn5ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.kbn5 }}</span></label></div><div class="form-group" ng-if="showItem1"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item1ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.item1 }}</span></label></div><div class="form-group" ng-if="showItem2"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item2ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.item2 }}</span></label></div><div class="form-group" ng-if="showItem3"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item3ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.item3 }}</span></label></div><div class="form-group" ng-if="showItem4"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item4ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.item4 }}</span></label></div><div class="form-group" ng-if="showItem5"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item5ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.item5 }}</span></label></div><div id="subTickets" ng-if="subTicketList.length > 0 && parentTicket == \'1\'" style="border-top: 1px solid rgba(0, 0, 0, 0.12);"><h4 class="grid-h ng-scope" style="margin-bottom: 10px; margin-top: 20px;">\u30B5\u30D6\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8</h4><table class="table" style="border: none;" st-table="subTicketData" st-safe-src="subTicketList"><tr ng-repeat="item in subTicketData"><td style="border: none; text-align: left; width: 40%;"><a href="javascript:;" ng-click="showCheckreportDetailSpWindow(item.id);$dismiss();">{{$root.padLeft(item.id, 8)}}</a></td><td style="border: none; width: 30%;">{{item.statusName}}</td><td style="border: none; width: 30%;">{{item.responseUserName}}</td></tr></table></div></div><div class="modal-footer" id="ticketShowFooter" style="display: block;"><div style="position: absolute; top: 63px; left: 5px;"><button ng-if="isEditer" type="button" class="btn btn-info" ng-click="uploadOffLineTicket()">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div style="position: absolute; top: 63px; right: 5px;"><button ng-if="isEditer" type="button" class="btn btn-danger" ng-click="deleteOffLineTicket()">\u524A\u9664</button></div></div><div class="modal-body text-left" id="ticketEditor" style="display: none;"><div class="form-group" style="padding-top: 30px;"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5BFE\u8C61\u5DE5\u4E8B\uFF1A</label><br><span style="padding-left: 10px;">{{ ticket.targetName }}</span></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u533A\u5206\uFF1A <span style="padding-left: 10px;">{{ ticket.first }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5927\u9805\u76EE\uFF1A <span style="padding-left: 10px;">{{ ticket.second }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u4E2D\u9805\u76EE\uFF1A <span style="padding-left: 10px;">{{ ticket.third }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5C0F\u9805\u76EE\uFF1A <span style="padding-left: 10px;">{{ ticket.fourth }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u30B9\u30C6\u30FC\u30BF\u30B9\uFF1A</label><br><span style="padding-left: 10px;">{{ ticket.statusName }}</span></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u958B\u59CB\u65E5(\u4E88\u5B9A)\uFF1A</label><p class="input-group" style="margin: 0;border-collapse: collapse;" ng-controller="datepickerpopupCtrl"><input ng-disabled="isVisitor" ng-model="ctrl.startScheduledDate" type="text" placeholder="" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5B8C\u4E86\u65E5(\u4E88\u5B9A)\uFF1A</label><p class="input-group" style="margin: 0;border-collapse: collapse;" ng-controller="datepickerpopupCtrl"><input ng-disabled="isVisitor" ng-model="ctrl.endScheduledDate" type="text" placeholder="" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u958B\u59CB\u65E5(\u5B9F\u7E3E)\uFF1A</label><br><span style="padding-left: 10px;">{{ ticket.startDate }}</span></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5B8C\u4E86\u65E5(\u5B9F\u7E3E)\uFF1A</label><br><span style="padding-left: 10px;">{{ ticket.endDate }}</span></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u7BA1\u7406\u6280\u8853\u8005\uFF1A</label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.requestUser" ng-options="item as item.userNameId for item in userList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u6307\u793A\u30B0\u30EB\u30FC\u30D7\uFF1A</label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.requestGroup" ng-options="item as item.groupNameId for item in groupList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u62C5\u5F53\u6280\u8853\u8005\uFF1A</label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.responseUser" ng-options="item as item.userNameId for item in userList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u62C5\u5F53\u6280\u8853\u8005\u30B0\u30EB\u30FC\u30D7\uFF1A</label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.responseGroup" ng-options="item as item.groupNameId for item in groupList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7\uFF1A</label><ui-select multiple="" ng-model="readingGroups.selected" ng-disabled="isVisitor" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="">{{$item.groupNameId}}</ui-select-match><ui-select-choices repeat="readingGroups in groupList | filter: $select.search">{{readingGroups.groupNameId}}</ui-select-choices></ui-select></div><div class="form-group" ng-if="parentTicket == \'1\'"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u89AA\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\uFF1A</label><br><span style="padding-left: 10px;">{{ $root.padLeft(ticket.parentId, 8) }}</span></div><div class="form-group" ng-if="showStatusDetail"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{statusDetailItemName}}\uFF1A <label ng-if="mustStatusDetail" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.statusDetailOb" ng-options="item as item.label for item in statusDetailList"></select></div><div class="form-group" ng-if="showKbn2"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn2ItemName}}\uFF1A <label ng-if="mustKbn2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select></div><div class="form-group" ng-if="showKbn3"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn3ItemName}}\uFF1A <label ng-if="mustKbn3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select></div><div class="form-group" ng-if="showKbn4"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn4ItemName}}\uFF1A <label ng-if="mustKbn4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select></div><div class="form-group" ng-if="showKbn5"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn5ItemName}}\uFF1A <label ng-if="mustKbn5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></div><div class="form-group" ng-if="showItem1"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item1ItemName}}\uFF1A <label ng-if="mustItem1" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item1" maxlength="256" ng-disabled="isVisitor"></div><div class="form-group" ng-if="showItem2"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item2ItemName}}\uFF1A <label ng-if="mustItem2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item2" maxlength="256" ng-disabled="isVisitor"></div><div class="form-group" ng-if="showItem3"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item3ItemName}}\uFF1A <label ng-if="mustItem3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item3" maxlength="256" ng-disabled="isVisitor"></div><div class="form-group" ng-if="showItem4"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item4ItemName}}\uFF1A <label ng-if="mustItem4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item4" maxlength="256" ng-disabled="isVisitor"></div><div class="form-group" ng-if="showItem5"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item5ItemName}}\uFF1A <label ng-if="mustItem5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item5" maxlength="256" ng-disabled="isVisitor"></div><div id="subTickets" ng-if="subTicketList.length > 0 && parentTicket == \'1\'" style="border-top: 1px solid rgba(0, 0, 0, 0.12);"><h4 class="grid-h ng-scope" style="margin-bottom: 10px; margin-top: 20px;">\u30B5\u30D6\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8</h4><table class="table" style="border: none;" st-table="subTicketData" st-safe-src="subTicketList"><tr ng-repeat="item in subTicketData"><td style="border: none; text-align: left; width: 40%;"><a href="javascript:;" ng-click="showCheckreportDetailSpWindow(item.id);$dismiss();">{{$root.padLeft(item.id, 8)}}</a></td><td style="border: none; width: 30%;">{{item.statusName}}</td><td style="border: none; width: 30%;">{{item.responseUserName}}</td></tr></table></div></div><div class="modal-footer" id="ticketEditorFooter" style="display: none;"><button ng-if="isEditer" type="button" class="btn btn-info" ng-click="modifyTicketSp()">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button><div style="position: absolute; top: 63px; left: 5px;" ng-if="(mngFlg == \'1\' || mngFlg ==\'2\' ) && (ticket.statusId == \'03\' || ticket.statusId == \'04\' || ticket.statusId == \'05\')"><button ng-if="ticket.statusId == \'03\'" type="button" class="btn btn-primary" ng-click="modifyStatus(\'04\')">\u627F\u8A8D</button> <button ng-if="mngFlg ==\'2\' && ticket.statusId == \'04\' && finalApproval ==\'1\'" type="button" class="btn btn-primary" ng-click="modifyStatus(\'05\')">\u6700\u7D42\u627F\u8A8D</button> <button type="button" class="btn btn-primary" ng-click="modifyStatus(\'99\')">\u5DEE\u623B\u3057</button></div><div style="position: absolute; top: 63px; right: 5px;"><button ng-if="isEditer && !notEditable && parentTicket == \'1\'" type="button" class="btn btn-info" ng-click="showCheckreportCreateSp(ticket.id, ticket.targetId);$dismiss();">\u30B5\u30D6\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8</button> <button ng-if="isRequester" type="button" class="btn btn-danger" ng-click="CheckreportDeleteSp();">\u524A\u9664</button></div></div></div>');
$templateCache.put('app/pages/offline/offline.html','<div class="widgets"><div class="row"><div class="col-md-12" style="padding :0;" id="ticketList"><div ba-panel="" ba-panel-title="\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u4E00\u89A7" ba-panel-class="sp-panel"><div include-with-scope="app/pages/offline/offlineList.html"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="sp-panel" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u8A73\u7D30\uFF08ID\uFF1A{{$root.padLeft(ticketId, 8)}}\uFF09" id="ticketDetail" style="display: none; padding :0;"><div ng-include="\'app/pages/offline/offlineDetail.html\'"></div></div></div></div>');
$templateCache.put('app/pages/offline/offlineDetail.html','<div style="text-align: center; margin-bottom: 15px;"><div class="btn-group"><button style="font-weight: bold;" type="button" class="btn btn-default" ng-click="showTicketInfoSp()"><span>\uFF81\uFF6A\uFF6F\uFF78\uFF7C\uFF70\uFF84&nbsp;</span></button> <button style="font-weight: bold;" type="button" class="btn btn-default" ng-click="showCheckListSp()"><span>\u30C1\u30A7\u30C3\u30AF</span></button> <button style="font-weight: bold;" type="button" class="btn btn-default" ng-click="showHistorySp()"><span>\u30B3\u30E1\u30F3\u30C8</span></button> <button style="font-weight: bold;" type="button" class="btn btn-default" ng-click="showTargetInfoSp()"><span>\u5BFE\u8C61\u5DE5\u4E8B</span></button></div></div><div class="col-md-12" style="padding :0;"><div ng-if="statusOb.value == \'03\' || statusOb.value == \'04\' || statusOb.value == \'05\'" class="alert bg-info" style="text-align: center; margin-bottom: 0px;padding:10px 0px 2px; background: #5bc0de;"><span class="checkreport-msg" style="font-size: 22px;">{{statusOb.label}}</span></div><div ng-if="statusOb.value == \'01\' || statusOb.value == \'02\' || statusOb.value == \'99\'" class="alert bg-danger" style="text-align: center; margin-bottom: 0px;padding:10px 0px 2px; background: #e85656;"><span class="checkreport-msg" style="font-size: 22px;">{{statusOb.label}}</span></div><div class="progress" style="height:10px;margin-top: 2px;" ng-if="complete != 100"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="66" aria-valuemin="0" aria-valuemax="100" style="width: {{complete}}%"><span class="sr-only">{{complete}}% \u5B8C\u6210</span></div></div><div class="progress" style="height:10px;margin-top: 2px;" ng-if="complete == 100"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="66" aria-valuemin="0" aria-valuemax="100" style="width: 100%"><span class="sr-only">100% \u5B8C\u6210</span></div></div><div class="unit_title"><button ng-disabled="complete != 100 || isVisitor" type="button" ng-if="(statusOb.value == \'01\' || statusOb.value == \'02\' || statusOb.value == \'99\') && complete != 100" style="box-shadow :0 0 0 4px #eeeeee, 0 0 0 8px #fff, 0 0 18px rgba(0, 0, 0, 0.8)">\u30C1\u30A7\u30C3\u30AF\u5B8C\u4E86</button> <button type="button" ng-click="reportComp();" ng-if="( statusOb.value == \'01\' || statusOb.value == \'02\' || statusOb.value == \'99\') && complete == 100 && isResponser">\u30C1\u30A7\u30C3\u30AF\u5B8C\u4E86</button> <button ng-disabled="isVisitor" type="button" ng-if="statusOb.value == \'03\' && isVisitor" style="box-shadow :0 0 0 4px #eeeeee, 0 0 0 8px #fff, 0 0 18px rgba(0, 0, 0, 0.8)">\u5F15\u623B\u3057</button> <button type="button" ng-click="reportReturn();" ng-if="statusOb.value == \'03\' && isEditer && isResponser">\u5F15\u623B\u3057</button><dl><dt>\u5DE5\u4E8BID\uFF1A</dt><dd>{{ticket.targetIdShow}}</dd><dt>\u5DE5\u4E8B\u540D\uFF1A</dt><dd>{{ticket.targetName}}</dd><dt>\u958B\u59CB\u65E5\uFF1A</dt><dd>{{ticket.startDate}}</dd></dl></div><div class="unit_pager"><button style="width:85px; white-space: nowrap;" type="button" ng-click="getCheckreportDetailSp(prefDetailId, false);"><span class="cut-with-dots">{{prefDetailId}}.{{prefCheckListOb.checklistName}}</span></button><p><span>{{detailId}}</span>/<span>{{checkresultList.length}}</span></p><button style="width:85px; white-space: nowrap;" type="button" ng-click="getCheckreportDetailSp(nextDetailId, false);"><span class="cut-with-dots">{{nextDetailId}}.{{nextCheckListOb.checklistName}}</span></button></div><div class="unit_edit" ng-if="checkListOb.checkResult != \'3\' && checkListOb.checkResult != \'\' && checkListOb.checkResult != null"><h3 class="success" style="display: inline-flex;"><span class="cut-with-dots" style="width:85%; white-space: nowrap;">{{detailId}}\uFF0E{{checkListOb.checklistName}}</span><small>\u5165\u529B\u6E08</small></h3><p ng-bind-html="checkListOb.checklistContent"></p></div><div class="unit_edit" ng-if="! (checkListOb.checkResult != \'3\' && checkListOb.checkResult != \'\' && checkListOb.checkResult != null)"><h3 class="alart" style="display: inline-flex;"><span class="cut-with-dots" style="width:85%; white-space: nowrap;">{{detailId}}\uFF0E{{checkListOb.checklistName}}</span><small>\u672A\u5165\u529B</small></h3><p ng-bind-html="checkListOb.checklistContent"></p></div><div ng-repeat="item in resultDetailList" ng-init="outerIndex = $index"><div class="form-group" ng-if="item.inputTypeId == 1" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <input ng-disabled="isVisitor || notEditable" type="text" class="form-control" ng-model="result[outerIndex].value" maxlength="512"></div><div class="form-group" ng-if="item.inputTypeId == 2" ng-controller="datepickerpopupCtrl" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <input ng-disabled="isVisitor || notEditable" ng-model="result[outerIndex].value" type="text" placeholder="YYYY/MM/DD" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"></div><div class="form-group" ng-if="item.inputTypeId == 3" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><select ng-disabled="isVisitor || notEditable" class="form-control selectpicker" selectpicker="" ng-model="result[outerIndex].value" ng-options="item1 as item1.label for item1 in userResource{{item.resultDetailId}}"></select></div><div class="form-group" ng-if="item.inputTypeId == 4" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><p class="input-group"><label class="radio-inline custom-radio nowrap" ng-repeat="item2 in userResource[outerIndex]"><input ng-disabled="isVisitor || notEditable" type="radio" value="{{item2.value}}" ng-model="result[outerIndex].value"> <span>{{item2.label}}</span></label></p></div><div class="form-group" ng-if="item.inputTypeId == 5" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><p class="input-group"><label class="checkbox-inline custom-checkbox nowrap" ng-repeat="item6 in userResource[outerIndex]"><input ng-disabled="isVisitor || notEditable" ng-checked="chBoxResult[outerIndex][$index] == item6.value" type="checkbox" ng-true-value="{{item6.value}}" ng-false-value="0" ng-model="chBoxResult[outerIndex][$index]"> <span>{{item6.label}}</span></label></p></div><div class="form-group" ng-if="item.inputTypeId == 6" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <textarea ng-disabled="isVisitor || notEditable" class="form-control" ng-model="result[outerIndex].value" maxlength="512"></textarea></div><div class="form-group" ng-if="item.inputTypeId == 7" style="margin-bottom: 30px;"><label id="imgLabel{{item.resultDetailId}}" style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><div id="slider{{item.resultDetailId}}" class="flexslider" style="position: relative; height: 100%;text-align: center; background: #eee;border-radius: 6px;margin: 0;"><ul class="slides"><li ng-repeat="item3 in dynamicImgArray(item.resultDetailId)"><div><img ng-src="{{item3.url}}" alt="" title=""> <button ng-if="isEditer && !notEditable" type="button" ng-click="deleteFile(item3, item)"><i class="material-icons" style="margin-right: 2px;">delete_forever</i>\u524A\u9664</button> <textarea ng-if="isEditer && !notEditable" name="content" cols="50" rows="5" style="left: 9px; bottom: 10px; width: 100%; margin-bottom: 22px;" ng-model="item3.imgComm" ng-disabled="! isEditer" placeholder="\u30B3\u30E1\u30F3\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"></textarea> <button ng-if="isEditer && !notEditable" type="button" ng-click="saveImgCom(item3, item.resultDetailId)" style="top:auto; color: #fff; background: #2dacd1; border-color: #2dacd1;bottom: 0px;">\u30B3\u30E1\u30F3\u30C8\u4FDD\u5B58</button></div></li></ul></div><br><button ng-if="isEditer && !notEditable" type="button" class="btn btn-info btn-sm" ng-click="openUploadImg(item)">\u5199\u771F\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="form-group" ng-if="item.inputTypeId == 8" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><table class="table" style="border-top: 1px solid rgba(0, 0, 0, 0.12); border-collapse:separate; border-spacing:0px 10px;" ng-repeat="item4 in dynamicArray(item.resultDetailId)"><tr><td style="border:none">No.{{$index+1}}</td></tr><tr><td style="border:none">{{item4.fileName}}</td></tr><tr><td style="border:none; width: 350px;"><video style="width: 100%;" controls="" ng-src="{{item4.url}}" preload="auto" webkit-playsinline="" playsinline=""></video></td></tr><tr><td style="border:none"><button ng-if="isEditer && !notEditable" type="button" ng-click="deleteFile(item4.id, item.resultDetailId, \'Radio\')" class="btn btn-danger editable-table-button btn-xs">\u524A\u9664</button></td></tr></table><br><button ng-if="isEditer && !notEditable" type="button" class="btn btn-info btn-sm" ng-click="openUploadRadio(item.resultDetailId)">\u97F3\u58F0\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="form-group" ng-if="item.inputTypeId == 9" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><table class="table" style="border-top: 1px solid rgba(0, 0, 0, 0.12); border-collapse:separate; border-spacing:0px 10px;" ng-repeat="item5 in dynamicArray(item.resultDetailId)"><tr><td style="border:none; vertical-align: middle;">No.{{$index+1}}</td></tr><tr><td style="border:none; vertical-align: middle;">{{item5.fileName}}</td></tr><tr><td style="border:none; width: 350px;"><video style="width: 100%;" controls="" ng-src="{{item5.url}}" type="video/mp4" preload="auto" webkit-playsinline="" playsinline=""></video></td></tr><tr><td style="border:none; vertical-align: middle;"><button ng-if="isEditer && !notEditable" type="button" ng-click="deleteFile(item5.id, item.resultDetailId, \'Radio\')" class="btn btn-danger editable-table-button btn-xs">\u524A\u9664</button></td></tr></table><br><button ng-if="isEditer && !notEditable" type="button" class="btn btn-info btn-sm" ng-click="openUploadVideo(item.resultDetailId)">\u52D5\u753B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="form-group" ng-if="item.inputTypeId == 10" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><div style="text-align: center;"><button ng-if="isEditer && !notEditable" ng-show="signable{{item.resultDetailId}} && signFlg{{item.resultDetailId}}" type="button" class="btn btn-info" ng-click="showSignPc(item.resultDetailId)">\u624B\u66F8\u3059\u308B</button> <button ng-if="isEditer && !notEditable" ng-show="! signable{{item.resultDetailId}}" type="button" class="btn btn-danger" ng-click="deleteSign(item.resultDetailId)">\u524A\u9664</button><div ng-show="signable{{item.resultDetailId}}" id="signature{{item.resultDetailId}}" style="height: 202px;border: 1px solid #ccc;margin: 10px 20px;"></div><button ng-show="!signFlg{{item.resultDetailId}}" type="button" class="btn btn-info" ng-click="saveSignPc(item.resultDetailId)" id="signOK{{item.resultDetailId}}">\u78BA\u5B9A</button> <button ng-show="!signFlg{{item.resultDetailId}}" type="button" class="btn btn-danger" ng-click="resetSignPc(item.resultDetailId)" id="signReset{{item.resultDetailId}}">\u30EA\u30BB\u30C3\u30C8</button><div ng-show="! signable{{item.resultDetailId}}" style="margin:20px"><img style="width: 100%;" ng-src="{{getSignUrl(item.resultDetailId)}}" alt="" title=""></div></div></div><div class="form-group" ng-if="item.inputTypeId == 11" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <input ng-disabled="isVisitor" ng-show="!camera{{item.resultDetailId}}" type="text" class="form-control" ng-model="result[outerIndex].value"><div ng-show="camera{{item.resultDetailId}}" style="text-align: center;"><blockquote data-mode="click2play" data-width="100%" data-height="478" class="ricoh-theta-tour-image" ng-show="cameraT{{item.resultDetailId}}"><a href="{{result[outerIndex].value}}"></a></blockquote><blockquote data-mode="click2play" data-width="100%" data-height="478" class="ricoh-theta-spherical-image" ng-show="! cameraT{{item.resultDetailId}}"><a href="{{result[outerIndex].value}}"></a></blockquote><script async="" src="https://smartbee.theta360.biz/widgets.js" charset="utf-8"></script><button ng-if="isEditer && !notEditable" type="button" class="btn btn-danger" ng-click="delete360Camera(item.resultDetailId)" style="margin-top: 5px;">\u524A\u9664</button></div></div><div class="form-group" ng-if="item.inputTypeId == 12" style="margin-bottom: 30px;"><label ng-if="item.unit == \'\' || item.unit ==null" style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-if="item.unit != \'\' && item.unit !=null" style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}({{item.unit}})</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <input ng-disabled="isVisitor || notEditable" type="number" class="form-control" ng-model="result[outerIndex].value" pattern="-?[0-9]+([\\.,][0-9]+)?" inputmode="numeric" ng-blur="checkLimit(item.checkDetailId, outerIndex, true)" ng-style="{\'background-color\':errorStyle[outerIndex]}"></div><div class="form-group" ng-if="item.inputTypeId == 13" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><table class="table table-striped" st-table="fileData" st-safe-src="dynamicArray(item.resultDetailId)"><thead><tr><td class="text-left"></td></tr></thead><tbody><tr ng-repeat="item13 in fileData" style="border: 1px solid rgba(0, 0, 0, 0.12);"><td style="padding-right: 8px !important;line-height: 30px;"><table style="width: 100%;"><tr><td style="text-align: left;padding-top: 5px;"><a href="javascript:;" ng-click="downLoadFile(item13);">{{item13.fileName}}</a></td></tr><tr><td style="text-align: center;"><button ng-if="isEditer && !notEditable" type="button" ng-click="deleteFile(item13.id, item.resultDetailId, \'File\')" class="btn btn-danger editable-table-button btn-xs">\u524A\u9664</button></td></tr></table></td></tr></tbody><tfoot><tr><td class="text-left"></td></tr></tfoot></table><br><button ng-if="isEditer && !notEditable" type="button" class="btn btn-info btn-sm" ng-click="openUploadFile(item.resultDetailId)">\u30D5\u30A1\u30A4\u30EB\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="form-group" ng-if="item.inputTypeId == 14" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><div style="display: flex;"><div ng-disabled="isVisitor || notEditable" uib-timepicker="" ng-model="result[outerIndex].value" hour-step="1" minute-step="1" show-meridian="false"></div><button style="margin: auto 0; margin-left: 10px;" type="button" class="btn btn-info" ng-click="setNowTime(outerIndex);" ng-if="isEditer && !notEditable">\u73FE\u5728\u6642\u523B</button> <button style="margin: auto 0; margin-left: 10px;" type="button" class="btn btn-danger" ng-click="clearTime(outerIndex);" ng-if="isEditer && !notEditable">\u30AF\u30EA\u30A2</button></div></div></div><div ng-if="showResult != \'1\'" class="form-group" style="text-align: center; border:1px solid rgba(0, 0, 0, 0.12);"><label style="font-size: 18px; font-weight: 400; color:#666666; padding-top: 15px;">\u30C1\u30A7\u30C3\u30AF\u7D50\u679C</label><p class="input-group"><label class="radio-inline custom-radio nowrap"><input ng-disabled="isVisitor || notEditable" type="radio" name="finalCheck" value="1" ng-model="result[0].value"> <span>\u6B63\u5E38</span></label> <label class="radio-inline custom-radio nowrap"><input ng-disabled="isVisitor || notEditable" type="radio" name="finalCheck" value="2" ng-model="result[0].value"> <span>\u7570\u5E38</span></label> <label class="radio-inline custom-radio nowrap"><input ng-disabled="isVisitor || notEditable" type="radio" name="finalCheck" value="3" ng-model="result[0].value"> <span>\u4FDD\u7559</span></label> <label class="radio-inline custom-radio nowrap"><input ng-disabled="isVisitor || notEditable" type="radio" name="finalCheck" value="4" ng-model="result[0].value"> <span>\u5BFE\u8C61\u5916</span></label></p></div><div style="text-align: center; padding-top: 10px;"><button ng-if="isEditer && !notEditable" type="button" class="btn btn-info" ng-click="saveResult(true)">\u4FDD\u5B58</button></div><div style="text-align: center; padding-top: 10px;"><button ng-if="isEditer && !notEditable" type="button" class="btn btn-info" ng-click="temSaveResult(true)">\u4E00\u6642\u4FDD\u5B58</button></div><div class="unit_pager" style="padding-bottom: 40px;"><button style="width:85px; white-space: nowrap;" type="button" ng-click="getCheckreportDetailSp(prefDetailId, false);"><span class="cut-with-dots">{{prefDetailId}}.{{prefCheckListOb.checklistName}}</span></button><p><span>{{detailId}}</span>/<span>{{checkresultList.length}}</span></p><button style="width:85px; white-space: nowrap;" type="button" ng-click="getCheckreportDetailSp(nextDetailId, false);"><span class="cut-with-dots">{{nextDetailId}}.{{nextCheckListOb.checklistName}}</span></button></div></div><div style="text-align: center; margin-bottom: 15px;"><div class="btn-group"><button style="font-weight: bold;" type="button" class="btn btn-default" ng-click="showTicketList()"><span>\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u4E00\u89A7\u3092\u8868\u793A</span></button></div></div>');
$templateCache.put('app/pages/offline/offlineList.html','<div class="horizontal-scroll"><table class="table table-striped" st-table="reportData" st-safe-src="checkreportList" style="word-break:break-all; background-color: #19191A; color: #fff;"><thead><tr><td colspan="4" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></thead><tbody><tr style="background: none;"><td colspan="4"><span>\u5408\u8A08\uFF1A &nbsp; {{checkreportList.length}} &nbsp;\u4EF6</span></td></tr><tr ng-repeat="item in reportData" ng-click="showDownloadTicketDetail(item);" style="border: 1px solid rgba(0, 0, 0, 0.12); border-color: #fff;"><td ng-if="item.statusId == \'01\' || item.statusId == \'02\' || item.statusId == \'99\'" style="width: 5%;background: #e85656;">&nbsp;</td><td ng-if="!(item.statusId == \'01\' || item.statusId == \'02\' || item.statusId == \'99\')" style="width: 5%;background: #5bc0de;">&nbsp;</td><td style="padding-right: 8px !important;line-height: 30px;"><table style="width: 100%;"><tr><td style="text-align: left;">{{ $root.padLeft(item.id, 8) }}</td><td style="text-align: right; width: 50%;">{{item.statusName}}</td></tr><tr><td colspan="2" style="font-weight: bold;text-align: left; font-size: 20px;">{{item.targetName}}</td></tr><tr><td colspan="2" style="text-align: left;">{{item.startScheduledDate}}&nbsp;&nbsp;\uFF5E&nbsp;&nbsp;{{item.endScheduledDate}}</td></tr><tr><td style="text-align: left;">{{item.checksheetName}}</td><td style="text-align: right; width: 50%;">{{item.responseUserName}}</td></tr></table></td></tr></tbody><tfoot><tr><td colspan="4" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/password/password.html','<div class="widgets"><div class="row"><div ng-if="!$root.isMoblie" class="col-md-6"><div ba-panel="" ba-panel-title="\u30A2\u30AB\u30A6\u30F3\u30C8" ba-panel-class="with-scroll"><div include-with-scope="app/pages/password/userInfo.html"></div></div></div><div ng-if="!$root.isMoblie" class="col-md-6"><div ba-panel="" ba-panel-title="\u30D1\u30B9\u30EF\u30FC\u30C9\u5909\u66F4" ba-panel-class="with-scroll"><div include-with-scope="app/pages/password/passwordUpdate.html"></div></div></div><div ng-if="$root.isMoblie" class="col-md-6" style="padding :0;"><div ba-panel="" ba-panel-title="\u30A2\u30AB\u30A6\u30F3\u30C8" ba-panel-class="sp-panel"><div include-with-scope="app/pages/password/userInfo.html"></div></div></div><div ng-if="$root.isMoblie" class="col-md-6" style="padding :0;"><div ba-panel="" ba-panel-title="\u30D1\u30B9\u30EF\u30FC\u30C9\u5909\u66F4" ba-panel-class="sp-panel"><div include-with-scope="app/pages/password/passwordUpdate.html"></div></div></div></div></div>');
$templateCache.put('app/pages/password/passwordUpdate.html','<div class="form-group"><label for="oldPassword">\u73FE\u5728\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\uFF1A</label> <input type="password" class="form-control" ng-model="ctrlScope.oldPassword" placeholder="\u73FE\u5728\u306E\u30D1\u30B9\u30EF\u30FC\u30C9" maxlength="128"></div><div class="form-group"><label for="newPassword">\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\uFF1A</label> <input type="password" class="form-control" ng-model="ctrlScope.newPassword" placeholder="\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9" maxlength="128"></div><div class="form-group"><label for="newPasswordConfirm">\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D\uFF1A</label> <input type="password" class="form-control" ng-model="ctrlScope.newPasswordConfirm" placeholder="\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D" maxlength="128"></div><div style="text-align: center;"><button type="button" class="btn btn-info" ng-click="modifyPassword()">\u4FDD\u5B58</button></div>');
$templateCache.put('app/pages/password/passwordUpdateSystem.html','<div class="form-group" ng-if="contractorId != \'\'"><label for="oldPassword">\u5951\u7D04\u8005ID\uFF1A</label><br><h4 style="margin-left: 5px;">{{contractorId}}</h4></div><div class="form-group"><label for="oldPassword">\u6280\u8853\u8005ID\uFF1A</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <input type="text" class="form-control" ng-model="ctrlScope.userId" placeholder="\u6280\u8853\u8005ID" maxlength="128"></div><div class="form-group"><label for="oldPassword">\u6280\u8853\u8005\u540D\uFF1A</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <input type="text" class="form-control" ng-model="ctrlScope.userName" placeholder="\u6280\u8853\u8005\u540D" maxlength="128"></div><div class="form-group"><label for="oldPassword">\u73FE\u5728\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\uFF1A</label> <input type="password" class="form-control" ng-model="ctrlScope.oldPassword" placeholder="\u73FE\u5728\u306E\u30D1\u30B9\u30EF\u30FC\u30C9" maxlength="128"></div><div class="form-group"><label for="newPassword">\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\uFF1A</label> <input type="password" class="form-control" ng-model="ctrlScope.newPassword" placeholder="\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9" maxlength="128"></div><div class="form-group"><label for="newPasswordConfirm">\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D\uFF1A</label> <input type="password" class="form-control" ng-model="ctrlScope.newPasswordConfirm" placeholder="\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D" maxlength="128"></div><div class="form-group"><label for="tel">\u96FB\u8A71\u756A\u53F7\uFF1A</label> <input type="text" class="form-control" placeholder="\u96FB\u8A71\u756A\u53F7" ng-model="ctrlScope.tel" maxlength="20"></div><div class="form-group"><label>\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF11\uFF1A</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <input type="text" class="form-control" placeholder="\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF11" ng-model="ctrlScope.email" maxlength="128"></div><div class="form-group"><label>\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF12\uFF1A</label> <input type="text" class="form-control" placeholder="\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF12" ng-model="ctrlScope.email2" maxlength="128"></div><div class="form-group"><label>\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF13\uFF1A</label> <input type="text" class="form-control" placeholder="\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF13" ng-model="ctrlScope.email3" maxlength="128"></div><div class="form-group"><label>\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF14\uFF1A</label> <input type="text" class="form-control" placeholder="\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF14" ng-model="ctrlScope.email4" maxlength="128"></div><div class="form-group"><label>\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF15\uFF1A</label> <input type="text" class="form-control" placeholder="\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF15" ng-model="ctrlScope.email5" maxlength="128"></div><div style="text-align: center;"><button type="button" class="btn btn-info" ng-click="modifyPasswordSystem()">\u4FDD\u5B58</button></div>');
$templateCache.put('app/pages/password/userInfo.html','<div class="form-group"><label style="font-size: 16px;">\u6280\u8853\u8005ID\uFF1A</label> <label style="font-size: 16px;">{{userId}}</label><br><label style="font-size: 16px;">\u6280\u8853\u8005\u540D\uFF1A</label> <label style="font-size: 16px;">{{userName}}</label><br><label style="font-size: 16px;">\u6240\u5C5E\u30B0\u30EB\u30FC\u30D7\uFF1A</label> <label style="font-size: 16px;">{{loginUser.groupName}}</label></div><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-6 control-label">\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u5199\u771F\uFF1A</label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u5199\u771F\u3092\u5909\u66F4\u3059\u308B</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div><div class="form-group"><label>\u96FB\u8A71\u756A\u53F7</label> <input type="text" class="form-control" placeholder="\u96FB\u8A71\u756A\u53F7" ng-model="ctrlScope.tel" maxlength="20"></div><div class="form-group"><label>\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9</label> <input type="text" class="form-control" placeholder="\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9" ng-model="ctrlScope.email" maxlength="128"></div><div class="form-group" style="text-align: center;"><button type="button" class="btn btn-info" ng-click="modifyUserTelEmail()">\u4FDD\u5B58</button></div>');
$templateCache.put('app/pages/project/addUserList.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="userData" st-safe-src="userListForProject" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th class="table-id" st-sort="no" st-sort-default="obverse">#</th><th st-sort="userId">\u6280\u8853\u8005ID</th><th st-sort="userName">\u6280\u8853\u8005\u540D</th><th st-sort="mngFlagName">\u6A29\u9650</th><th st-sort="comName">\u6240\u5C5E\u4F1A\u793E</th><th st-sort="organization">\u6240\u5C5E\u7D44\u7E54</th><th st-sort="mailAdd">\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9</th><th>\u64CD\u4F5C</th></tr><tr><th></th><th><select st-search="userId" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userId\'" value="{{item.userId}}">{{item.userId}}</option></select></th><th><select st-search="userName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userName\'" value="{{item.userName}}">{{item.userName}}</option></select></th><th><select st-search="mngFlagName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'mngFlagName\'" value="{{item.mngFlagName}}">{{item.mngFlagName}}</option></select></th><th><select st-search="comName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'comName\'" value="{{item.comName}}">{{item.comName}}</option></select></th><th><select st-search="organization" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'organization\'" value="{{item.organization}}">{{item.organization}}</option></select></th><th><select st-search="mailAdd" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'mailAdd\'" value="{{item.mailAdd}}">{{item.mailAdd}}</option></select></th><th></th></tr></thead><tbody><tr ng-repeat="item in userData"><td class="table-id">{{$index+1}}</td><td style="white-space: nowrap">{{item.userId}}</td><td style="white-space: nowrap">{{item.userName}}</td><td style="white-space: nowrap">{{item.mngFlagName}}</td><td style="white-space: nowrap">{{item.comName}}</td><td style="white-space: nowrap">{{item.organization}}</td><td style="white-space: nowrap">{{item.mailAdd}}</td><td style="white-space: nowrap"><button class="btn btn-info editable-table-button btn-xs" ng-click="addUser(item.userId)">\u8FFD\u52A0</button></td></tr></tbody><tfoot><tr><td colspan="8" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/project/allUser.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="userData" st-safe-src="allUser" st-filtered-collection="stFilteredCollection"><tr><td style="border: none;"><div style="position: absolute; top : 70px; right: 20px;"><a class="btn btn-warning" style="background: #209e91; border-color: #209e91;" st-export-csv-sjis="">\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a> <button type="file" ngf-select="uploadFiles($file)" class="btn btn-info" accept=".csv, text/csv" ngf-max-size="10MB">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div></td></tr><thead><tr class="sortable"><th class="table-id" st-sort="no" st-sort-default="obverse">#</th><th st-sort="userId">\u6280\u8853\u8005ID</th><th st-sort="userName">\u6280\u8853\u8005\u540D</th><th st-sort="mngFlag">\u6A29\u9650</th><th st-sort="projectName">\u6240\u5C5E\u696D\u52D9</th><th st-sort="lastLoginTime">\u6700\u7D42\u30ED\u30B0\u30A4\u30F3\u65E5\u6642</th><th>\u64CD\u4F5C</th></tr><tr><th></th><th><select st-search="userId" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userId\'" value="{{item.userId}}">{{item.userId}}</option></select></th><th><select st-search="userName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userName\'" value="{{item.userName}}">{{item.userName}}</option></select></th><th><select st-search="mngFlagName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'mngFlagName\'" value="{{item.mngFlagName}}">{{item.mngFlagName}}</option></select></th><th><select st-search="projectName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'projectName\'" value="{{item.projectName}}">{{item.projectName}}</option></select></th><th><select st-search="lastLoginTime" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'lastLoginTime\'" value="{{item.lastLoginTime}}">{{item.lastLoginTime}}</option></select></th><th></th></tr></thead><tbody><tr ng-repeat="item in userData"><td class="table-id">{{$index +1 }}</td><td style="white-space: nowrap">{{item.userId}}</td><td style="white-space: nowrap">{{item.userName}}</td><td style="white-space: nowrap">{{item.mngFlagName}}</td><td style="white-space: nowrap">{{item.projectName}}</td><td style="white-space: nowrap">{{item.lastLoginTime}}</td><td><button ng-if="item.projectName == \'\' && !(item.mngFlag == \'3\' || item.mngFlag == \'9\')" type="button" class="status-button btn btn-xs btn-danger" ng-click="deleteUser(item.userId);">\u524A\u9664</button></td></tr></tbody><tfoot><tr><td colspan="7" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/project/defaultCheckSheetList.html','<div><div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info" ng-click="showChecklistCreate()">\u65B0\u898F</button></div><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="listData" st-safe-src="checksheetList" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th class="table-id">#</th><th st-sort="first" st-sort-default="obverse">\u533A\u5206</th><th st-sort="second">\u5927\u9805\u76EE</th><th st-sort="third">\u4E2D\u9805\u76EE</th><th st-sort="fourth">\u5C0F\u9805\u76EE</th><th st-sort="frequency">\u78BA\u8A8D\u306E\u7A0B\u5EA6</th><th st-sort="version">\u30D0\u30FC\u30B8\u30E7\u30F3</th><th style="min-width: 163px;">\u64CD\u4F5C</th></tr><tr><th></th><th><select st-search="first" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'first\'" value="{{item.first}}">{{item.first}}</option></select></th><th><select st-search="second" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'second\'" value="{{item.second}}">{{item.second}}</option></select></th><th><select st-search="third" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'third\'" value="{{item.third}}">{{item.third}}</option></select></th><th><select st-search="fourth" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fourth\'" value="{{item.fourth}}">{{item.fourth}}</option></select></th><th><select st-search="frequency" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'frequency\'" value="{{item.frequency}}">{{item.frequency}}</option></select></th><th><select st-search="version" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'version\'" value="{{item.version}}">{{item.version}}</option></select></th><th></th></tr></thead><tbody><tr ng-repeat="item in listData"><td class="table-id" ng-dblclick="showChecklistDetail(item);">{{$index + 1}}</td><td style="white-space: nowrap" ng-dblclick="showChecklistDetail(item);">{{item.first}}</td><td style="white-space: nowrap" ng-dblclick="showChecklistDetail(item);">{{item.second}}</td><td style="white-space: nowrap" ng-dblclick="showChecklistDetail(item);">{{item.third}}</td><td style="white-space: nowrap"><a href="javascript:;" ng-click="showChecklistDetail(item);onReleaseClick(item.releaseFlag);">{{item.fourth}}</a></td><td style="white-space: nowrap" ng-dblclick="showChecklistDetail(item);">{{item.frequency}}</td><td style="white-space: nowrap" ng-dblclick="showChecklistDetail(item);">{{$root.padLeft(item.version, 3) }}</td><td><button type="button" class="btn btn-xs btn-info" ng-click="showCopyChecksheet(item)">\u30B3\u30D4\u30FC</button> <button type="button" class="btn btn-xs btn-info" ng-click="showCheckAllInfo(item.checksheetId,item.checksheetName)">\u95B2\u89A7</button> <button type="button" class="btn btn-xs btn-info" ng-click="showDownloadInfo(item.checksheetId,item.checksheetName)">\u5831\u544A\u66F8</button></td></tr></tbody><tfoot><tr><td class="text-left" colspan="9"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/project/defaultChoiceMasterData.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30C1\u30A7\u30C3\u30AF\u8A73\u7D30\u7528\u9078\u629E\u80A2</h4></div><div class="modal-body text-left"><div><div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info" ng-click="showCheckResultCreate()">\u65B0\u898F</button></div><table class="table" style="margin-top: 25px;" st-table="listData" st-safe-src="userResourceList" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th st-sort="label" style="width:90%">\u30C1\u30A7\u30C3\u30AF\u8A73\u7D30\u30C7\u30FC\u30BF</th><th>\u64CD\u4F5C</th></tr><tr><th><select st-search="label" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'label\'" value="{{item.label}}">{{item.label}}</option></select></th><th></th></tr></thead><tbody><tr ng-repeat="item in listData"><td class="table-id"><a href="javascript:;" ng-click="showCheckResultDetail(item);">{{item.label}}</a></td><td><button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUserResource(item.value)">\u524A\u9664</button></td></tr></tbody><tfoot><tr><td class="text-left" colspan="2"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/project/defaultMasterData.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30C7\u30D5\u30A9\u30EB\u30C8\u30DE\u30B9\u30BF\u30C7\u30FC\u30BF</h4></div><div class="modal-body text-left"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\u533A\u5206" ba-panel-class="with-scroll" id="master4Check1"><div include-with-scope="app/pages/masterdata/master4Check1.html"></div></div></div><div class="col-md-12"><div ba-panel="" ba-panel-title="\u5927\u9805\u76EE\uFF1A{{SecondCheckTileName}}" ba-panel-class="with-scroll" id="master4Check2" style="display: none;"><div include-with-scope="app/pages/masterdata/master4Check2.html"></div></div></div><div class="col-md-12"><div ba-panel="" ba-panel-title="\u4E2D\u9805\u76EE\uFF1A{{ThirdCheckTileName}}" ba-panel-class="with-scroll" id="master4Check3" style="display: none;"><div include-with-scope="app/pages/masterdata/master4Check3.html"></div></div></div><div class="col-md-12"><div ba-panel="" ba-panel-title="\u5C0F\u9805\u76EE\uFF1A{{FourthCheckTileName}}" ba-panel-class="with-scroll" id="master4Check4" style="display: none;"><div include-with-scope="app/pages/masterdata/master4Check4.html"></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/project/logo.html','<div class="horizontal-scroll"><table class="table" style="border-collapse:separate; border-spacing:0px 20px;"><tr><td style="border: none;vertical-align: middle; width: 175px; text-align: center;">\u30ED\u30B0\u30A4\u30F3\u753B\u9762\u306E\u30ED\u30B4\uFF1A</td><td style="border: none;"><div class="login-logo"><div class="login-wrapper"><img ng-if="!noPictureLogin" ng-src="{{ pictureLogin }}" ng-click="uploadLoginLogo()"> <img ng-if="noPictureLogin" ng-src="{{ pictureLogin }}" ng-click="uploadLoginLogo()" style="width: 320px;"></div><i class="ion-ios-close-outline" ng-click="removeLoginLogo()" ng-if="!noPictureLogin"></i> <a href="" class="change-userpic" ng-click="uploadLoginLogo()">\u30ED\u30B0\u30A4\u30F3\u753B\u9762\u306E\u30ED\u30B4\u3092\u5909\u66F4\u3059\u308B</a> <input type="file" ng-show="false" id="uploadFileLogin" login-logo-select=""></div></td></tr><tr><td style="border: none;vertical-align: middle; width: 150px; text-align: center;">\u30D8\u30C3\u30C0\u90E8\u306E\u30ED\u30B4\uFF1A</td><td style="border: none;"><div class="header-logo"><div class="header-wrapper"><img ng-if="!noPictureHeader" ng-src="{{ pictureHeader }}" ng-click="uploadHeaderLogo()"> <img ng-if="noPictureHeader" ng-src="{{ pictureHeader }}" ng-click="uploadHeaderLogo()" style="width: 320px;"></div><i class="ion-ios-close-outline" ng-click="removeHeaderLogo()" ng-if="!noPictureHeader"></i> <a href="" class="change-userpic" ng-click="uploadHeaderLogo()">\u30D8\u30C3\u30C0\u90E8\u306E\u30ED\u30B4\u3092\u5909\u66F4\u3059\u308B</a> <input type="file" ng-show="false" id="uploadFileHeader" header-logo-select=""></div></td></tr><tr><td style="border: none;vertical-align: middle; width: 150px; text-align: center;">\u30D6\u30C3\u30AF\u30DE\u30FC\u30AF\u30A2\u30A4\u30B3\u30F3\uFF1A</td><td style="border: none;"><div class="bookmark-logo"><div class="bookmark-wrapper"><img ng-if="!noPictureBookMark" ng-src="{{ pictureBookMark }}" ng-click="uploadBookMarkLogo()"> <img ng-if="noPictureBookMark" ng-src="{{ pictureBookMark }}" ng-click="uploadBookMarkLogo()" style="width: 86px;"></div><i class="ion-ios-close-outline" ng-click="removeBookMarkLogo()" ng-if="!noPictureBookMark"></i> <a href="" class="change-userpic" ng-click="uploadBookMarkLogo()">\u30D6\u30C3\u30AF\u30DE\u30FC\u30AF\u30A2\u30A4\u30B3\u30F3\u3092\u5909\u66F4\u3059\u308B</a> <input type="file" ng-show="false" id="uploadFileBookMark" book-mark-logo-select=""></div></td></tr></table></div>');
$templateCache.put('app/pages/project/newDefaultCheckSheet.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" ng-if="!isCopy">\u30C1\u30A7\u30C3\u30AF\u767B\u9332</h4><h4 class="modal-title" ng-if="isCopy">\u30C1\u30A7\u30C3\u30AF\u30B3\u30D4\u30FC</h4></div><div class="modal-body text-left"><h5 ng-if="isCopy">\u30B3\u30D4\u30FC\u5143\uFF1A{{copyMoto.checksheetName}}</h5><h5 ng-if="isCopy">\u30B3\u30D4\u30FC\u5148\u306E\u60C5\u5831\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002</h5><table class="table table-bordered" style="border: none; border-collapse:separate; border-spacing:0px 2px; table-layout: fixed;"><tbody><tr><th style="width:15%">\u533A\u5206\uFF1A<label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.first" ng-disabled="firstDisable" ng-change="changeFirst()" ng-options="item as item.label for item in firstList"></select></td><th style="width:15%">\u5927\u9805\u76EE\uFF1A<label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.second" ng-disabled="secondDisable" ng-change="changeSecond()" ng-options="item as item.label for item in secondList"></select></td></tr><tr><th style="width:15%">\u4E2D\u9805\u76EE\uFF1A<label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.third" ng-disabled="thirdDisable" ng-change="changeThird()" ng-options="item as item.label for item in thirdList"></select></td><th style="width:15%">\u5C0F\u9805\u76EE\uFF1A<label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.fourth" ng-disabled="fourthDisable" ng-options="item as item.label for item in fourthList"></select></td></tr><tr><th style="width:15%">\u78BA\u8A8D\u306E\u7A0B\u5EA6\uFF1A</th><td style="border: none; width:35%"><input type="text" class="form-control" ng-model="ctrl.frequency" maxlength="256"></td><th style="width:15%"></th><td style="border: none; width:35%"></td></tr></tbody></table></div><div class="modal-footer"><button ng-if="!isCopy" type="button" class="btn btn-info" ng-click="createCheckSheet();onReleaseClick(0)">\u767B\u9332</button> <button ng-if="isCopy" type="button" class="btn btn-info" ng-click="copyCheckSheet()">\u30B3\u30D4\u30FC</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/project/passwordRule.html','<table class="table table-bordered" style="margin-bottom: 10px;"><tr><td rowspan="4"><label>\u30D1\u30B9\u30EF\u30FC\u30C9\u30DD\u30EA\u30B7\u30FC</label></td><td style="text-align: center;"><label>\u30D1\u30B9\u30EF\u30FC\u30C9\u30ED\u30C3\u30AF\uFF1A</label></td><td><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="lock" id="lock1" value="1" ng-model="ctrlScope.lock"> <span>\u30AA\u30F3</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="lock" id="lock2" value="0" ng-model="ctrlScope.lock"> <span>\u30AA\u30D5</span></label></p></td></tr><tr><td><label>\u30D1\u30B9\u30EF\u30FC\u30C9\u5165\u529B\u30DF\u30B9\u8A31\u5BB9\u56DE\u6570\uFF1A</label></td><td><input type="number" class="form-control" ng-model="ctrlScope.pwdMaxErrNum" maxlength="2" style="width: 100px; display: initial;" ng-disabled="lock == \'0\'" oninput="if(value.length>2)value=value.slice(0,2)">\u56DE</td></tr><tr><td><label>\u30D1\u30B9\u30EF\u30FC\u30C9\u6709\u52B9\u671F\u9593\uFF1A</label></td><td><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="pwdPeriod" id="pwdPeriod1" value="1" ng-model="ctrlScope.pwdPeriod"> <span>\u3042\u308A</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="pwdPeriod" id="pwdPeriod2" value="0" ng-model="ctrlScope.pwdPeriod"> <span>\u306A\u3057</span></label></p><input type="number" class="form-control" ng-model="ctrlScope.pwdPeriodNum" maxlength="3" style="width: 100px; display: initial;" ng-disabled="pwdPeriod == \'0\'" oninput="if(value.length>3)value=value.slice(0,3)">\u65E5\u9593</td></tr><tr><td><label>\u30D1\u30B9\u30EF\u30FC\u30C9\u8A2D\u5B9A\u6761\u4EF6\uFF1A</label></td><td>\u6700\u5C0F\u9577<input type="number" class="form-control" ng-model="ctrlScope.pwdRuleLength" maxlength="2" style="width: 100px; display: initial;" oninput="if(value.length>2)value=value.slice(0,2)">\u6841<p><label class="checkbox-inline custom-checkbox nowrap"><input ng-checked="pwdRuleUpperCheck" type="checkbox" ng-model="ctrlScope.pwdRuleUpper" value="1"> <span>\u5927\u6587\u5B57 (A-Z)</span></label></p><p><label class="checkbox-inline custom-checkbox nowrap"><input ng-checked="pwdRuleLowerCheck" type="checkbox" ng-model="ctrlScope.pwdRuleLower" value="1"> <span>\u5C0F\u6587\u5B57 (a-z)</span></label></p><p><label class="checkbox-inline custom-checkbox nowrap"><input ng-checked="pwdRuleNumCheck" type="checkbox" ng-model="ctrlScope.pwdRuleNum" value="1"> <span>\u6570\u5B57 (0-9)</span></label></p><p><label class="checkbox-inline custom-checkbox nowrap"><input ng-checked="pwdRuleSymbolCheck" type="checkbox" ng-model="ctrlScope.pwdRuleSymbol" value="1"> <span>\u8A18\u53F7 (\u4E0A\u8A18\u4EE5\u5916)</span></label></p></td></tr></table><div style="text-align: center;"><button type="button" class="btn btn-info" ng-click="modifyPasswordRule()">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="initPasswordRule()">\u30EA\u30BB\u30C3\u30C8</button></div>');
$templateCache.put('app/pages/project/plan.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30D7\u30E9\u30F3\u5909\u66F4</h4></div><div class="modal-body text-left"><div>\u73FE\u5728\u306E\u30D7\u30E9\u30F3\uFF1A\u5229\u7528\u4E0A\u9650\u5BB9\u91CF<span style="padding-left: 10px; font-size: 30px; font-weight: bold;">40 + <input type="number" pattern="[0-9]*" min="0" ng-model="ctrlScope.addon" ng-change="changeAddon()" step="100" style="width: 120px;" oninput="if(value.length>4)value=value.slice(0,4)"> = {{newPlan}}</span>GB</div></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="updatePlan()">\u5909\u66F4</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/project/planHistory.html','<div><div class="alert"><strong style="color:#d45a00;">\u73FE\u5728\u306E\u3054\u5229\u7528\u30C7\u30A3\u30B9\u30AF\u5BB9\u91CF<span style="font-size: 30px;font-weight: bold;margin: 0 10px;">{{ $root.getFileSize(diskSpace) }}</span></strong></div></div><uib-accordion><uib-accordion-group ng-repeat="item in yearList" heading="{{item.year}}\u5E74" panel-class="accordion-panel bootstrap-panel panel-default" is-open="item.flg"><table class="table"><tr><td>#</td><td>\u96C6\u8A08\u6708</td><td>\u30C7\u30A3\u30B9\u30AF\u5BB9\u91CF</td><td>\u30D7\u30E9\u30F3\u60C5\u5831</td></tr><tr ng-repeat="disk in dynamicArray(item.year)" class="editable-row"><td>{{$index+1}}</td><td>{{$root.changeYYYYMM(disk.month)}}</td><td>{{$root.getFileSize(disk.disk)}}</td><td>{{disk.usedPlan}}GB</td></tr></table></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/project/project.html','<div class="widgets"><div class="row" ng-if="$root.mngKbn == \'9\' && !$root.isMoblie"><div class="col-md-12" style="padding-left: 0;"><div ba-panel="" ba-panel-title="\u62E0\u70B9\u4E00\u89A7" ba-panel-class="with-scroll"><div class="row" style="margin-bottom: 30px; margin-left: 0px"><span style="font-size: 20px;">\u62E0\u70B9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span><table class="table-project"><tr style="border-bottom: 1px solid rgb(221, 221, 221);"><td><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="regionRadio" id="regionRadio1" value="1" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'1\')"> <span>\u5317\u6D77\u9053</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="regionRadio" id="regionRadio2" value="2" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'2\')"> <span>\u6771\u5317</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="regionRadio" id="regionRadio4" value="4" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'4\')"> <span>\u5317\u9678</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="regionRadio" id="regionRadio3" value="3" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'3\')"> <span>\u6771\u4EAC</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="regionRadio" id="regionRadio5" value="5" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'5\')"> <span>\u540D\u53E4\u5C4B</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="regionRadio" id="regionRadio6" value="6" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'6\')"> <span>\u5927\u962A</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="regionRadio" id="regionRadio7" value="7" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'7\')"> <span>\u4E2D\u56FD</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="regionRadio" id="regionRadio8" value="8" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'8\')"> <span>\u56DB\u56FD</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="regionRadio" id="regionRadio9" value="9" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'9\')"> <span>\u4E5D\u5DDE</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="regionRadio" id="regionRadio10" value="10" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'10\')"> <span>\u6280\u8853\u63A8\u9032\u5BA4</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="regionRadio" id="regionRadio11" value="11" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'11\')"> <span>\u7814\u4FEE\u7528</span></label> <button style="margin-left: 30px;" class="btn btn-info" ng-click="choiceRegion()">\u7D9A\u884C</button></p></div></td></tr></table><button class="btn btn-info" ng-click="showDefaultMstData()">\u30C7\u30D5\u30A9\u30EB\u30C8\u30DE\u30B9\u30BF\u30C7\u30FC\u30BF</button> <button class="btn btn-info" ng-click="showDefaultCheckSheetList()">\u30C7\u30D5\u30A9\u30EB\u30C8\u30C1\u30A7\u30C3\u30AF\u7BA1\u7406</button> <button class="btn btn-info" ng-click="showChoiceMstData()">\u30C1\u30A7\u30C3\u30AF\u8A73\u7D30\u7528\u9078\u629E\u80A2</button> <button class="btn btn-info" ng-click="showChangeSys()">\u30B7\u30B9\u30C6\u30E0\u60C5\u5831\u8A2D\u5B9A</button></div></div></div></div><div class="row" ng-if="$root.mngKbn == \'9\' && $root.isMoblie"><div class="col-md-12" style="padding-left: 0;"><div ba-panel="" ba-panel-title="\u62E0\u70B9\u4E00\u89A7" ba-panel-class="with-scroll"><div class="row" style="margin-bottom: 30px; margin-left: 0px"><span style="font-size: 20px;">\u62E0\u70B9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span><table class="table-project" style="margin: 10px 0px;"><tr style="border-bottom: 1px solid rgb(221, 221, 221);"><td><div><p><label class="radio-inline custom-radio nowrap" style="margin-left: 10px;width:100%;"><input type="radio" name="regionRadio" id="regionRadio1" value="1" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'1\')"> <span>\u5317\u6D77\u9053</span></label> <label class="radio-inline custom-radio nowrap" style="width:100%"><input type="radio" name="regionRadio" id="regionRadio2" value="2" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'2\')"> <span>\u6771\u5317</span></label> <label class="radio-inline custom-radio nowrap" style="width:100%"><input type="radio" name="regionRadio" id="regionRadio4" value="4" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'4\')"> <span>\u5317\u9678</span></label> <label class="radio-inline custom-radio nowrap" style="width:100%"><input type="radio" name="regionRadio" id="regionRadio3" value="3" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'3\')"> <span>\u6771\u4EAC</span></label> <label class="radio-inline custom-radio nowrap" style="width:100%"><input type="radio" name="regionRadio" id="regionRadio5" value="5" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'5\')"> <span>\u540D\u53E4\u5C4B</span></label> <label class="radio-inline custom-radio nowrap" style="width:100%"><input type="radio" name="regionRadio" id="regionRadio6" value="6" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'6\')"> <span>\u5927\u962A</span></label> <label class="radio-inline custom-radio nowrap" style="width:100%"><input type="radio" name="regionRadio" id="regionRadio7" value="7" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'7\')"> <span>\u4E2D\u56FD</span></label> <label class="radio-inline custom-radio nowrap" style="width:100%"><input type="radio" name="regionRadio" id="regionRadio8" value="8" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'8\')"> <span>\u56DB\u56FD</span></label> <label class="radio-inline custom-radio nowrap" style="width:100%"><input type="radio" name="regionRadio" id="regionRadio9" value="9" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'9\')"> <span>\u4E5D\u5DDE</span></label> <label class="radio-inline custom-radio nowrap" style="width:100%"><input type="radio" name="regionRadio" id="regionRadio10" value="10" ng-model="ctrlScope.regionRadio" data-ng-change="changeRegionRadio(\'10\')"> <span>\u6280\u8853\u63A8\u9032\u5BA4</span></label></p></div></td></tr></table><button style="margin-left: 30px;" class="btn btn-info" ng-click="choiceRegion()">\u7D9A\u884C</button></div></div></div></div><div class="row" ng-if="$root.mngKbn != \'9\'"><div class="col-md-12" style="padding-left: 0;"><div ba-panel="" ba-panel-title="\u696D\u52D9\u4E00\u89A7" ba-panel-class="with-scroll"><div class="row" style="margin-bottom: 30px; margin-left: 0px"><span style="font-size: 20px;" ng-if="projectList.length > 0">\u696D\u52D9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span> <span style="font-size: 20px;" ng-if="projectList.length == 0 && !$root.isMoblie">\u696D\u52D9\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span> <span style="font-size: 20px;" ng-if="projectList.length == 0 && $root.isMoblie">\u696D\u52D9\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002</span><table class="table-project"><tr ng-repeat="item in projectList"><td><a href="javascript:;" ng-click="choicePorject(item.projectId, item.projectName)">{{$index+1}}.{{item.projectName}}</a></td><td ng-if="$root.mngKbn == \'3\' && !$root.isMoblie" style="width: 30%; text-align: right;font-size: 25px;">{{ $root.getFileSize(item.diskSpace) }}</td><td><button ng-if="$root.mngKbn == \'3\' && !$root.isMoblie" class="btn btn-primary" ng-click="showProjectInfo(item.projectId, item.projectName)">\u7BA1\u7406</button></td></tr><tr style="border-top: 1px solid rgb(221, 221, 221);" ng-if="$root.mngKbn == \'3\' && projectList.length !=0 && !$root.isMoblie"><td style="text-align: right;">\u3054\u5229\u7528\u30C7\u30A3\u30B9\u30AF\u5BB9\u91CF\u306E\u5408\u8A08\uFF1A</td><td style="text-align: right;">{{$root.getFileSize(getTotalDisk())}}</td><td></td></tr></table><button ng-if="$root.mngKbn == \'3\' && !$root.isMoblie" class="btn btn-info" ng-click="showProjectInfo()">\u696D\u52D9\u65B0\u898F\u8FFD\u52A0</button> <button ng-if="$root.mngKbn == \'3\' && !$root.isMoblie" class="btn btn-info" ng-click="showAllUserInfo()">\u5168\u6280\u8853\u8005\u4E00\u89A7</button> <a style="float: right;margin-right: 20px;padding-top: 18px;" ng-if="$root.realMngKbn == \'9\'" href="javascript:;" ng-click="gotoRegionChoice()">\u62E0\u70B9\u9078\u629E\u753B\u9762\u3078</a></div></div></div></div><div ng-if="!$root.isMoblie" class="row" id="projectP" style="display: none;"><div class="col-md-12" style="padding-left: 0;"><div ba-panel="" ba-panel-title="\u696D\u52D9\u60C5\u5831" ba-panel-class="with-scroll"><div ng-if="projectId != \'\'" style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-danger" ng-click="deleteProject()">\u524A\u9664</button></div><div class="form-group"><label>\u696D\u52D9\u540D\uFF1A</label> <input class="form-control" ng-model="ctrlScope.projectName" placeholder="\u696D\u52D9\u540D" maxlength="128"></div><div style="text-align: center; margin-bottom: 10px;"><button type="button" class="btn btn-info" ng-click="saveProject()">\u4FDD\u5B58</button></div><div ng-show="projectId != \'\'"><h3>\u6240\u5C5E\u6280\u8853\u8005\u4E00\u89A7</h3><div include-with-scope="app/pages/project/userList.html"></div><div style="text-align: center; margin-bottom: 10px;"><button type="button" class="btn btn-info" ng-click="newUser()">\u65B0\u898F\u6280\u8853\u8005\u8FFD\u52A0</button> <button type="button" class="btn btn-info" ng-click="showAddUser()">\u65E2\u5B58\u6280\u8853\u8005\u8FFD\u52A0</button></div></div></div></div></div><div ng-if="$root.mngKbn == \'9\'&& !$root.isMoblie" class="row" id="detaultCheck" style="display: none;"><div class="col-md-12" style="padding-left: 0;"><div ba-panel="" ba-panel-title="\u30C7\u30D5\u30A9\u30EB\u30C8\u30C1\u30A7\u30C3\u30AF" ba-panel-class="with-scroll"><div include-with-scope="app/pages/project/defaultCheckSheetList.html"></div></div></div></div><div ng-if="$root.mngKbn == \'9\'&& !$root.isMoblie" class="row" id="comments"><div class="col-md-12 panel-width1" style="padding-left: 0;"><div ba-panel="" ba-panel-title="{{selectedCheckSheet.first}}\u21D2{{selectedCheckSheet.second}}\u21D2{{selectedCheckSheet.third}}\u21D2{{selectedCheckSheet.fourth}} (ver.{{$root.padLeft(selectedCheckSheet.version, 3)}})" ba-panel-class="with-scroll" id="listDetail" style="display: none;"><div include-with-scope="app/pages/checklist/listDetail.html"></div></div></div></div><div ng-if="$root.mngKbn == \'9\'&& !$root.isMoblie" class="row"><div class="col-md-12" id="fileList" ba-panel="" ba-panel-title="\u30D5\u30A1\u30A4\u30EB\u4E00\u89A7" style="padding-left: 0;display: none;" ba-panel-class="with-scroll"><div ng-include="\'app/pages/checklist/fileList.html\'"></div></div></div><div ng-if="$root.mngKbn == \'9\'&& !$root.isMoblie" class="row" id="systemP" style="display: none;"><div class="col-md-6" style="padding-left: 0;"><div ba-panel="" ba-panel-title="\u30B7\u30B9\u30C6\u30E0\u60C5\u5831\u8A2D\u5B9A" ba-panel-class="with-scroll"><div include-with-scope="app/pages/project/passwordRule.html"></div></div></div></div><div ng-if="!$root.isMoblie" class="row"><div class="col-md-12" style="padding-left: 0; display: none;" id="alreadyUser"><div ba-panel="" ba-panel-title="\u6280\u8853\u8005\u4E00\u89A7" ba-panel-class="with-scroll"><div include-with-scope="app/pages/project/addUserList.html"></div></div></div></div><div ng-if="!$root.isMoblie" class="row"><div class="col-md-12" style="padding-left: 0; display: none;" id="allUser"><div ba-panel="" ba-panel-title="\u5168\u6280\u8853\u8005\u4E00\u89A7" ba-panel-class="with-scroll"><div include-with-scope="app/pages/project/allUser.html"></div></div></div></div><div class="row" ng-if="$root.mngKbn == \'9\'&& !$root.isMoblie"><div class="col-md-6"><div class="row"><div class="col-md-12" style="padding-left: 0;" id="logo"><div ba-panel="" ba-panel-title="\u30ED\u30B4\u5909\u66F4" ba-panel-class="with-scroll"><div include-with-scope="app/pages/project/logo.html"></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="\u5229\u7528\u5BB9\u91CF\u5C65\u6B74" ba-panel-class="with-scroll"><div include-with-scope="app/pages/project/planHistory.html"></div></div></div></div><div class="row" ng-if="$root.mngKbn == \'9\'&& !$root.isMoblie"><div class="col-md-12" style="padding-left: 0;"><div ba-panel="" ba-panel-title="\u30B7\u30B9\u30C6\u30E0\u7BA1\u7406\u8005\u304B\u3089\u306E\u304A\u77E5\u3089\u305B" ba-panel-class="with-scroll"><div class="row" style="margin-bottom: 30px; margin-left: 0px"><span style="font-size: 20px;">\u30B7\u30B9\u30C6\u30E0\u7BA1\u7406\u8005\u304B\u3089\u306E\u304A\u77E5\u3089\u305B\u4E00\u89A7</span><table style="font-size: 20px;margin-top: 10px; border-collapse: separate; border-spacing: 10px;"><tr ng-repeat="item in kcmeNewsList"><td>{{$index+1}}</td><td style="width: 100px;" ng-if="item.type == \'2\'"><span style="margin-right: 5px;padding: 2px 4px;border-radius: 13px; text-align: center; background-color: #ffaf0d;color: #fff;" class="ng-scope">\u30EA\u30EA\u30FC\u30B9</span></td><td style="width: 100px;" ng-if="item.type == \'1\'"><span style="margin-right: 5px;padding: 2px 4px;border-radius: 13px; text-align: center; background-color: #ffaf0d;color: #fff;" class="ng-scope">\u304A\u77E5\u3089\u305B</span></td><td>{{item.news}}</td><td><button class="btn btn-danger" ng-click="deleteKcmeNews(item.id)">\u524A\u9664</button></td></tr></table></div><div style="text-align: center;"><p style="text-align: left;"><label class="radio-inline custom-radio nowrap"><input type="radio" name="newsType" id="newsType1" value="1" ng-model="ctrlScope.kcmeNewsType"> <span>\u304A\u77E5\u3089\u305B</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="newsType" id="newsType2" value="2" ng-model="ctrlScope.kcmeNewsType"> <span>\u30EA\u30EA\u30FC\u30B9</span></label></p><textarea style="height: 200px;" class="form-control" ng-model="ctrlScope.kcmeNews"></textarea> <button style="margin-top: 5px;" class="btn btn-info" ng-click="createKcmeNews()">\u767B\u9332</button></div></div></div></div></div>');
$templateCache.put('app/pages/project/userDetail.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u6280\u8853\u8005\u60C5\u5831</h4></div><div class="modal-body"><div style="background-color:rgba(232, 86, 86, 0.85);" class="alert bg-danger" id="showdiv" ng-if="error">{{errCd + ":" + errMsg}}</div><form name="myForm"><div class="form-group"><label>\u6280\u8853\u8005ID</label><br><h4 style="margin-left: 5px;">{{userInfo.userId}}</h4></div><div class="form-group"><label for="userName">\u6280\u8853\u8005\u540D</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <input type="text" class="form-control" id="userName" name="userName" placeholder="\u6280\u8853\u8005\u540D" ng-model="userInfo.userName" required="" ng-maxlength="128"> <span style="color:red" ng-if="myForm.userName.$error.required && (myForm.userName.$dirty)">\u6280\u8853\u8005\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span> <span style="color:red" ng-if="myForm.userName.$error.maxlength && (myForm.userName.$dirty)">128\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="password">\u30D1\u30B9\u30EF\u30FC\u30C9</label> <input type="password" class="form-control" id="password" name="password" placeholder="\u30D1\u30B9\u30EF\u30FC\u30C9" ng-model="userInfo.password"> <span style="color:red" ng-if="myForm.password.$invalid && (myForm.password.$dirty)">\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="passwordConfirm">\u30D1\u30B9\u30EF\u30FC\u30C9\u78BA\u8A8D</label> <input type="password" class="form-control" id="passwordConfirm" name="passwordConfirm" placeholder="\u30D1\u30B9\u30EF\u30FC\u30C9\u78BA\u8A8D" ng-model="userInfo.passwordConfirm" pw-check="password"> <span style="color:red" ng-if="(myForm.passwordConfirm.$error.required) && (myForm.passwordConfirm.$dirty)">\u30D1\u30B9\u30EF\u30FC\u30C9\u78BA\u8A8D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span> <span style="color:red" ng-if="(myForm.passwordConfirm.$error.pwmatch) && (myForm.passwordConfirm.$dirty)">\u30D1\u30B9\u30EF\u30FC\u30C9\u3068\u30D1\u30B9\u30EF\u30FC\u30C9\u78BA\u8A8D\u304C\u7570\u306A\u3063\u3066\u3044\u307E\u3059\u3002</span></div><div class="form-group"><label>\u6240\u5C5E\u4F1A\u793E</label><select class="form-control selectpicker" selectpicker="" ng-model="userInfo.companySelected" ng-options="item as item.fName for item in companyList"></select></div><div class="form-group"><label for="orgName">\u6240\u5C5E\u7D44\u7E54</label> <input type="text" class="form-control" id="orgName" name="orgName" placeholder="\u6240\u5C5E\u7D44\u7E54" ng-model="userInfo.organization" ng-maxlength="128"> <span style="color:red" ng-if="myForm.orgName.$error.maxlength && (myForm.orgName.$dirty)">128\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="tel">\u96FB\u8A71\u756A\u53F7</label> <input type="text" class="form-control" id="tel" name="tel" placeholder="\u96FB\u8A71\u756A\u53F7" ng-model="userInfo.tel" ng-maxlength="20"> <span style="color:red" ng-if="myForm.tel.$error.maxlength && (myForm.tel.$dirty)">20\u6841\u6570\u4EE5\u5185\u306E\u6570\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="email">\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9</label> <input type="text" class="form-control" id="email" name="email" placeholder="\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9" ng-model="userInfo.mailAdd" ng-maxlength="128" ng-pattern="/^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/"> <span style="color:red" ng-if="myForm.email.$invalid && (myForm.email.$dirty)">128\u6841\u4EE5\u5185\u306E\u6709\u52B9\u7684\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userOrder == \'1\'"><label for="address">\u4F4F\u6240</label> <input type="text" class="form-control" id="address" name="address" placeholder="\u4F4F\u6240" ng-model="userInfo.address" ng-maxlength="256"> <span style="color:red" ng-if="myForm.address.$invalid && (myForm.address.$dirty)">256\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userOrder == \'1\'"><label for="lat">\u7DEF\u5EA6</label> <input type="text" class="form-control" id="lat" name="lat" placeholder="\u7DEF\u5EA6" ng-model="userInfo.lat" ng-maxlength="32"> <span style="color:red" ng-if="myForm.lat.$invalid && (myForm.lat.$dirty)">32\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userOrder == \'1\'"><label for="lng">\u7D4C\u5EA6</label> <input type="text" class="form-control" id="lng" name="lng" placeholder="\u7D4C\u5EA6" ng-model="userInfo.lng" ng-maxlength="32"> <span style="color:red" ng-if="myForm.lng.$invalid && (myForm.lng.$dirty)">32\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userInfo.mngFlag == \'3\'"><label>\u6A29\u9650</label> <span class="form-control">\u62E0\u70B9\u7BA1\u7406\u8005</span></div><div class="form-group" ng-if="userInfo.mngFlag == \'9\'"><label>\u6A29\u9650</label> <span class="form-control">\u30B7\u30B9\u30C6\u30E0\u7BA1\u7406\u8005</span></div><div class="form-group" ng-if="userInfo.mngFlag != \'3\' && userInfo.mngFlag != \'9\'"><label>\u6A29\u9650</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label><select class="form-control selectpicker" selectpicker="" ng-model="userInfo.rollSelected" ng-options="item as item.label for item in rollList"></select></div><div class="form-group"><label for="group">\u6240\u5C5E\u30B0\u30EB\u30FC\u30D7</label><ui-select id="group" multiple="" ng-model="selectedGroups.selected" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="\u6240\u5C5E\u30B0\u30EB\u30FC\u30D7">{{$item.groupName}}</ui-select-match><ui-select-choices repeat="selectedGroups in groupList | filter: $select.search">{{selectedGroups.groupName}}</ui-select-choices></ui-select></div><div class="form-group"><label for="status">\u30A2\u30AB\u30A6\u30F3\u30C8\u30ED\u30C3\u30AF</label><div class="input-demo radio-demo row" name="status"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" ng-model="userInfo.accountLock" value="0"> <span>\u6B63\u5E38</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" ng-model="userInfo.accountLock" value="1"> <span>\u30ED\u30C3\u30AF\u4E2D</span></label></div></div></div></form></div><div class="modal-footer"><button type="button" ng-disabled="!myForm.$valid" class="btn btn-info" ng-click="modifyUser(myForm)">\u4FDD\u5B58</button> <button ng-if="userInfo.mngFlag != \'3\' && userInfo.mngFlag != \'9\'" type="button" class="btn btn-danger" ng-click="removeUser(userInfo.userId, true);$dismiss()">\u89E3\u9664</button></div></div>');
$templateCache.put('app/pages/project/userList.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="userData" st-safe-src="userList" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th class="table-id" st-sort="no" st-sort-default="obverse">#</th><th st-sort="userId">\u6280\u8853\u8005ID</th><th st-sort="userName">\u6280\u8853\u8005\u540D</th><th st-sort="mngFlag">\u6A29\u9650</th><th st-sort="comName">\u6240\u5C5E\u4F1A\u793E</th><th st-sort="organization">\u6240\u5C5E\u7D44\u7E54</th><th st-sort="mailAdd">\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9</th><th>\u64CD\u4F5C</th></tr><tr><th></th><th><select st-search="userId" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userId\'" value="{{item.userId}}">{{item.userId}}</option></select></th><th><select st-search="userName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userName\'" value="{{item.userName}}">{{item.userName}}</option></select></th><th><select st-search="mngFlagName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'mngFlagName\'" value="{{item.mngFlagName}}">{{item.mngFlagName}}</option></select></th><th><select st-search="comName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'comName\'" value="{{item.comName}}">{{item.comName}}</option></select></th><th><select st-search="organization" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'organization\'" value="{{item.organization}}">{{item.organization}}</option></select></th><th><select st-search="mailAdd" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'mailAdd\'" value="{{item.mailAdd}}">{{item.mailAdd}}</option></select></th><th></th></tr></thead><tbody><tr ng-repeat="item in userData"><td class="table-id">{{$index +1 }}</td><td style="white-space: nowrap">{{item.userId}}</td><td style="white-space: nowrap"><a href="javascript:;" ng-click="showUserDetail(item);">{{item.userName}}</a></td><td style="white-space: nowrap">{{item.mngFlagName}}</td><td style="white-space: nowrap">{{item.comName}}</td><td style="white-space: nowrap">{{item.organization}}</td><td style="white-space: nowrap">{{item.mailAdd}}</td><td style="white-space: nowrap"><button ng-if="item.mngFlag != \'3\' && item.mngFlag != \'9\'" class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser(item.userId, false)">\u89E3\u9664</button></td></tr></tbody><tfoot><tr><td colspan="8" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/user/newUser.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u6280\u8853\u8005\u767B\u9332</h4></div><div class="modal-body"><div style="background-color:rgba(232, 86, 86, 0.85);" class="alert bg-danger" id="showdiv" ng-if="error">{{errCd + ":" + errMsg}}</div><form name="myForm"><div class="form-group"><label for="userId">\u6280\u8853\u8005ID</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <input type="text" class="form-control" id="userId" name="userId" placeholder="\u6280\u8853\u8005ID" ng-model="userId" required="" ng-maxlength="32" ng-pattern="/^[a-zA-Z0-9]{1,32}$/"> <span style="color:red" ng-if="myForm.userId.$invalid && (myForm.userId.$dirty)">32\u6841\u4EE5\u5185\u306E\u534A\u89D2\u82F1\u5B57\u3001\u6570\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="userName">\u6280\u8853\u8005\u540D</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <input type="text" class="form-control" id="userName" name="userName" placeholder="\u6280\u8853\u8005\u540D" ng-model="userName" required="" ng-maxlength="128"> <span style="color:red" ng-if="myForm.userName.$error.required && (myForm.userName.$dirty)">\u6280\u8853\u8005\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span> <span style="color:red" ng-if="myForm.userName.$error.maxlength && (myForm.userName.$dirty)">128\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="password">\u30D1\u30B9\u30EF\u30FC\u30C9</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <input type="password" class="form-control" id="password" name="password" placeholder="\u30D1\u30B9\u30EF\u30FC\u30C9" ng-model="password" required="" autocomplete="new-password"> <span style="color:red" ng-if="myForm.password.$invalid && (myForm.password.$dirty)">\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="passwordConfirm">\u30D1\u30B9\u30EF\u30FC\u30C9\u78BA\u8A8D</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <input type="password" class="form-control" id="passwordConfirm" name="passwordConfirm" placeholder="\u30D1\u30B9\u30EF\u30FC\u30C9\u78BA\u8A8D" ng-model="passwordConfirm" required="" pw-check="password"> <span style="color:red" ng-if="(myForm.passwordConfirm.$error.required) && (myForm.passwordConfirm.$dirty)">\u30D1\u30B9\u30EF\u30FC\u30C9\u78BA\u8A8D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span> <span style="color:red" ng-if="(myForm.passwordConfirm.$error.pwmatch) && (myForm.passwordConfirm.$dirty)">\u30D1\u30B9\u30EF\u30FC\u30C9\u3068\u30D1\u30B9\u30EF\u30FC\u30C9\u78BA\u8A8D\u304C\u7570\u306A\u3063\u3066\u3044\u307E\u3059\u3002</span></div><div class="form-group"><label>\u6240\u5C5E\u4F1A\u793E</label><select class="form-control selectpicker" selectpicker="" ng-model="companySelected" ng-options="item as item.fName for item in companyList"></select></div><div class="form-group"><label for="orgName">\u6240\u5C5E\u7D44\u7E54</label> <input type="text" class="form-control" id="orgName" name="orgName" placeholder="\u6240\u5C5E\u7D44\u7E54" ng-model="orgName" ng-maxlength="128"> <span style="color:red" ng-if="myForm.orgName.$error.maxlength && (myForm.orgName.$dirty)">128\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="tel">\u96FB\u8A71\u756A\u53F7</label> <input type="text" class="form-control" id="tel" name="tel" placeholder="\u96FB\u8A71\u756A\u53F7" ng-model="tel" ng-maxlength="20"> <span style="color:red" ng-if="myForm.tel.$error.maxlength && (myForm.tel.$dirty)">20\u6841\u6570\u4EE5\u5185\u306E\u6570\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="email">\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9</label> <input type="text" class="form-control" id="email" name="email" placeholder="\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9" ng-model="email" ng-maxlength="128" ng-pattern="/^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/"> <span style="color:red" ng-if="myForm.email.$invalid && (myForm.email.$dirty)">128\u6841\u4EE5\u5185\u306E\u6709\u52B9\u7684\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="address">\u4F4F\u6240</label> <input type="text" class="form-control" id="address" name="address" placeholder="\u4F4F\u6240" ng-model="address" ng-maxlength="256"> <span style="color:red" ng-if="myForm.address.$invalid && (myForm.address.$dirty)">256\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userOrder == \'1\'"><label for="lat">\u7DEF\u5EA6</label> <input type="text" class="form-control" id="lat" name="lat" placeholder="\u7DEF\u5EA6" ng-model="lat" ng-maxlength="32"> <span style="color:red" ng-if="myForm.lat.$invalid && (myForm.lat.$dirty)">32\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userOrder == \'1\'"><label for="lng">\u7D4C\u5EA6</label> <input type="text" class="form-control" id="lng" name="lng" placeholder="\u7D4C\u5EA6" ng-model="lng" ng-maxlength="32"> <span style="color:red" ng-if="myForm.lng.$invalid && (myForm.lng.$dirty)">32\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label>\u6A29\u9650</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label><select class="form-control selectpicker" selectpicker="" ng-model="rollSelected" ng-options="item as item.label for item in rollList"></select></div><div class="form-group"><label for="group">\u6240\u5C5E\u30B0\u30EB\u30FC\u30D7</label><ui-select id="group" multiple="" ng-model="selectedGroups.selected" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="\u6240\u5C5E\u30B0\u30EB\u30FC\u30D7">{{$item.groupName}}</ui-select-match><ui-select-choices repeat="selectedGroups in groupList | filter: $select.search">{{selectedGroups.groupName}}</ui-select-choices></ui-select></div></form></div><div class="modal-footer"><button type="button" ng-disabled="!myForm.$valid" class="btn btn-info" ng-click="addUser(myForm)">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/user/user.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\u6280\u8853\u8005\u4E00\u89A7" ba-panel-class="with-scroll"><div include-with-scope="app/pages/user/userList.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="\u30B0\u30EB\u30FC\u30D7\u4E00\u89A7" ba-panel-class="with-scroll"><div include-with-scope="app/pages/user/group/group.html"></div></div></div></div></div>');
$templateCache.put('app/pages/user/userDetail.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u6280\u8853\u8005\u60C5\u5831</h4></div><div class="modal-body"><div style="background-color:rgba(232, 86, 86, 0.85);" class="alert bg-danger" id="showdiv" ng-if="error">{{errCd + ":" + errMsg}}</div><form name="myForm"><div class="form-group"><label>\u6280\u8853\u8005ID</label><br><h4 style="margin-left: 5px;">{{userInfo.userId}}</h4></div><div class="form-group"><label for="userName">\u6280\u8853\u8005\u540D</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <input type="text" class="form-control" id="userName" name="userName" placeholder="\u6280\u8853\u8005\u540D" ng-model="userInfo.userName" required="" ng-maxlength="128"> <span style="color:red" ng-if="myForm.userName.$error.required && (myForm.userName.$dirty)">\u6280\u8853\u8005\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span> <span style="color:red" ng-if="myForm.userName.$error.maxlength && (myForm.userName.$dirty)">128\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="password">\u30D1\u30B9\u30EF\u30FC\u30C9</label> <input type="password" class="form-control" id="password" name="password" placeholder="\u30D1\u30B9\u30EF\u30FC\u30C9" ng-model="userInfo.password" autocomplete="new-password"> <span style="color:red" ng-if="myForm.password.$invalid && (myForm.password.$dirty)">\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="passwordConfirm">\u30D1\u30B9\u30EF\u30FC\u30C9\u78BA\u8A8D</label> <input type="password" class="form-control" id="passwordConfirm" name="passwordConfirm" placeholder="\u30D1\u30B9\u30EF\u30FC\u30C9\u78BA\u8A8D" ng-model="userInfo.passwordConfirm" pw-check="password"> <span style="color:red" ng-if="(myForm.passwordConfirm.$error.required) && (myForm.passwordConfirm.$dirty)">\u30D1\u30B9\u30EF\u30FC\u30C9\u78BA\u8A8D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span> <span style="color:red" ng-if="(myForm.passwordConfirm.$error.pwmatch) && (myForm.passwordConfirm.$dirty)">\u30D1\u30B9\u30EF\u30FC\u30C9\u3068\u30D1\u30B9\u30EF\u30FC\u30C9\u78BA\u8A8D\u304C\u7570\u306A\u3063\u3066\u3044\u307E\u3059\u3002</span></div><div class="form-group"><label>\u6240\u5C5E\u4F1A\u793E</label><select class="form-control selectpicker" selectpicker="" ng-model="userInfo.companySelected" ng-options="item as item.fName for item in companyList"></select></div><div class="form-group"><label for="orgName">\u6240\u5C5E\u7D44\u7E54</label> <input type="text" class="form-control" id="orgName" name="orgName" placeholder="\u6240\u5C5E\u7D44\u7E54" ng-model="userInfo.organization" ng-maxlength="128"> <span style="color:red" ng-if="myForm.orgName.$error.maxlength && (myForm.orgName.$dirty)">128\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="tel">\u96FB\u8A71\u756A\u53F7</label> <input type="text" class="form-control" id="tel" name="tel" placeholder="\u96FB\u8A71\u756A\u53F7" ng-model="userInfo.tel" ng-maxlength="20"> <span style="color:red" ng-if="myForm.tel.$error.maxlength && (myForm.tel.$dirty)">20\u6841\u6570\u4EE5\u5185\u306E\u6570\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="email">\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9</label> <input type="text" class="form-control" id="email" name="email" placeholder="\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9" ng-model="userInfo.mailAdd" ng-maxlength="128" ng-pattern="/^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/"> <span style="color:red" ng-if="myForm.email.$invalid && (myForm.email.$dirty)">128\u6841\u4EE5\u5185\u306E\u6709\u52B9\u7684\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="address">\u4F4F\u6240</label> <input type="text" class="form-control" id="address" name="address" placeholder="\u4F4F\u6240" ng-model="userInfo.address" ng-maxlength="256"> <span style="color:red" ng-if="myForm.address.$invalid && (myForm.address.$dirty)">256\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userOrder == \'1\'"><label for="lat">\u7DEF\u5EA6</label> <input type="text" class="form-control" id="lat" name="lat" placeholder="\u7DEF\u5EA6" ng-model="userInfo.lat" ng-maxlength="32"> <span style="color:red" ng-if="myForm.lat.$invalid && (myForm.lat.$dirty)">32\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userOrder == \'1\'"><label for="lng">\u7D4C\u5EA6</label> <input type="text" class="form-control" id="lng" name="lng" placeholder="\u7D4C\u5EA6" ng-model="userInfo.lng" ng-maxlength="32"> <span style="color:red" ng-if="myForm.lng.$invalid && (myForm.lng.$dirty)">32\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userInfo.mngFlag == \'3\'"><label>\u6A29\u9650</label> <span class="form-control">\u62E0\u70B9\u7BA1\u7406\u8005</span></div><div class="form-group" ng-if="userInfo.mngFlag == \'9\'"><label>\u6A29\u9650</label> <span class="form-control">\u30B7\u30B9\u30C6\u30E0\u7BA1\u7406\u8005</span></div><div class="form-group" ng-if="userInfo.mngFlag != \'3\' && userInfo.mngFlag != \'9\'"><label>\u6A29\u9650</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label><select class="form-control selectpicker" selectpicker="" ng-model="userInfo.rollSelected" ng-options="item as item.label for item in rollList"></select></div><div class="form-group"><label for="group">\u6240\u5C5E\u30B0\u30EB\u30FC\u30D7</label><ui-select id="group" multiple="" ng-model="selectedGroups.selected" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="\u6240\u5C5E\u30B0\u30EB\u30FC\u30D7">{{$item.groupName}}</ui-select-match><ui-select-choices repeat="selectedGroups in groupList | filter: $select.search">{{selectedGroups.groupName}}</ui-select-choices></ui-select></div><div class="form-group"><label for="status">\u30A2\u30AB\u30A6\u30F3\u30C8\u30ED\u30C3\u30AF</label><div class="input-demo radio-demo row" name="status"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" ng-model="userInfo.accountLock" value="0"> <span>\u6B63\u5E38</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" ng-model="userInfo.accountLock" value="1"> <span>\u30ED\u30C3\u30AF\u4E2D</span></label></div></div></div></form></div><div class="modal-footer"><button type="button" ng-disabled="!myForm.$valid" class="btn btn-info" ng-click="modifyUser(myForm)">\u4FDD\u5B58</button> <button ng-if="userInfo.mngFlag != \'3\' && userInfo.mngFlag != \'9\'" type="button" class="btn btn-danger" ng-click="removeUser(userInfo.userId, true);">\u524A\u9664</button></div></div>');
$templateCache.put('app/pages/user/userList.html','<div class="horizontal-scroll"><div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info" ng-click="showUserCreate()">\u65B0\u898F</button></div><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="userData" st-safe-src="userList" st-filtered-collection="stFilteredCollection"><thead><tr><td><div style="position: absolute; top: 75px; right: 20px;"><a class="btn btn-warning" style="background: #209e91; border-color: #209e91;" st-export-csv-sjis="">\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a> <button type="file" ngf-select="uploadFiles($file)" class="btn btn-info" accept=".csv, text/csv" ngf-max-size="10MB">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div></td></tr><tr class="sortable"><th class="table-id">#</th><th st-sort="userId" st-sort-default="obverse">\u6280\u8853\u8005ID</th><th st-sort="userName">\u6280\u8853\u8005\u540D</th><th st-sort="mngFlag">\u6A29\u9650</th><th st-sort="groupName">\u6240\u5C5E\u30B0\u30EB\u30FC\u30D7</th><th st-sort="comName">\u6240\u5C5E\u4F1A\u793E</th><th st-sort="organization">\u6240\u5C5E\u7D44\u7E54</th><th st-sort="tel">\u96FB\u8A71\u756A\u53F7</th><th st-sort="mailAdd">\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9</th><th st-sort="address">\u4F4F\u6240</th><th st-sort="accountLockStr">\u30A2\u30AB\u30A6\u30F3\u30C8\u30ED\u30C3\u30AF</th><th st-sort="lastLoginTime">\u6700\u7D42\u30ED\u30B0\u30A4\u30F3\u65E5\u6642</th><th>\u64CD\u4F5C</th></tr><tr><th></th><th><select st-search="userId" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userId\'" value="{{item.userId}}">{{item.userId}}</option></select></th><th><select st-search="userName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userName\'" value="{{item.userName}}">{{item.userName}}</option></select></th><th><select st-search="mngFlagName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'mngFlagName\'" value="{{item.mngFlagName}}">{{item.mngFlagName}}</option></select></th><th><select st-search="groupName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'groupName\'" value="{{item.groupName}}">{{item.groupName}}</option></select></th><th><select st-search="comName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'comName\'" value="{{item.comName}}">{{item.comName}}</option></select></th><th><select st-search="organization" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'organization\'" value="{{item.organization}}">{{item.organization}}</option></select></th><th><select st-search="tel" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'tel\'" value="{{item.tel}}">{{item.tel}}</option></select></th><th><select st-search="mailAdd" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'mailAdd\'" value="{{item.mailAdd}}">{{item.mailAdd}}</option></select></th><th><select st-search="address" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'address\'" value="{{item.address}}">{{item.address}}</option></select></th><th><select st-search="accountLockStr" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'accountLockStr\'" value="{{item.accountLockStr}}">{{item.accountLockStr}}</option></select></th><th><select st-search="lastLoginTime" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'lastLoginTime\'" value="{{item.lastLoginTime}}">{{item.lastLoginTime}}</option></select></th><th></th></tr></thead><tbody><tr ng-repeat="item in userData"><td class="table-id" ng-dblclick="showUserDetail(item);">{{$index + 1}}</td><td style="white-space: nowrap" ng-dblclick="showUserDetail(item);">{{item.userId}}</td><td style="white-space: nowrap"><a href="javascript:;" ng-click="showUserDetail(item);">{{item.userName}}</a></td><td style="white-space: nowrap" ng-dblclick="showUserDetail(item);">{{item.mngFlagName}}</td><td style="white-space: nowrap" ng-dblclick="showUserDetail(item);">{{item.groupName}}</td><td style="white-space: nowrap" ng-dblclick="showUserDetail(item);">{{item.comName}}</td><td style="white-space: nowrap" ng-dblclick="showUserDetail(item);">{{item.organization}}</td><td style="white-space: nowrap" ng-dblclick="showUserDetail(item);">{{item.tel}}</td><td style="white-space: nowrap" ng-dblclick="showUserDetail(item);">{{item.mailAdd}}</td><td style="white-space: nowrap" ng-dblclick="showUserDetail(item);">{{item.address}}</td><td style="white-space: nowrap" ng-dblclick="showUserDetail(item);">{{item.accountLockStr}}</td><td style="white-space: nowrap" ng-dblclick="showUserDetail(item);">{{item.lastLoginTime}}</td><td><button ng-if="item.mngFlag != \'3\' && item.mngFlag != \'9\'" type="button" class="status-button btn btn-xs btn-danger" ng-click="removeUser(item.userId, false);">\u524A\u9664</button></td></tr></tbody><tfoot><tr><td colspan="15" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/checklist/checklistContent/checklistContent.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input ng-disabled="!transparent" type="text" value="" class="form-control task-todo form-control-padding" placeholder="\u30C1\u30A7\u30C3\u30AF\u9805\u76EE\u306E\u8FFD\u52A0" ng-model="newTodoText" maxlength="256"> <i ng-click="addToDoItem()" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="todoList"><li style="padding: 2px; height: 45px;" class="list" ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.checklistId}}"><table class="checklist-table"><tr><td style="width:3%"><span class="cut-with-dots">{{ item.sort }}</span></td><td style="width:17%"><span style="white-space: nowrap;width:100%" class="cut-with-dots" e-style="width:100%" editable-text="item.checklistName" e-placeholder="\u30C1\u30A7\u30C3\u30AF\u9805\u76EE" e-name="checklistTitle{{ item.checklistId }}">{{item.checklistName}}</span></td><td style="width:60%"><span style="white-space: nowrap;width:100%" class="cut-with-dots" e-style="width:100%" editable-textarea="item.checklistContent" e-placeholder="\u30C1\u30A7\u30C3\u30AF\u5185\u5BB9\uFF08URL\u3092\u542B\u3081\u308B\u969B\u306F\u3001URL\u3092\u201D[[\u201D\u3068\u201D]]\u201D\u3067\u56F2\u3093\u3067\u4E0B\u3055\u3044\u3002\uFF09" e-name="checklistContent{{ item.checklistId }}">{{item.checklistContent}}</span></td><td style="width:8%"><label class="checkbox-inline custom-checkbox nowrap"><input id="downloadFlg{{$index}}" ng-checked="{{item.downloadFlg}}" type="checkbox" value="1" name="testCheckBox"> <span class="cut-with-dots" style="color: #666666;">\u51FA\u529B</span></label></td><td style="width:7%; text-align: right;"><button type="button" ng-class="{\'show-button\': transparent}" class="status-button btn btn-xs btn-info item-button" ng-click="showDetail(item)">\u8A73\u7D30</button></td><td style="width:7%; text-align: right;"><button type="button" ng-class="{\'show-button\': transparent}" class="status-button btn btn-xs btn-danger item-button" ng-click="removeChecklist($index,item.checklistId)">\u524A\u9664</button></td></tr></table></li></ul></div>');
$templateCache.put('app/pages/checklist/checklistDetail/checklistDetail.html','<div class="modal-content" style="width:1030px"><link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">{{checklistName}}</h4></div><div class="modal-body text-left"><div style="margin-bottom: 20px;">{{checklistContent}}</div><div class="task-todo-container transparent"><input type="text" value="" class="form-control task-todo form-control-padding" placeholder="\u30C1\u30A7\u30C3\u30AF\u8A73\u7D30\u9805\u76EE\u306E\u8FFD\u52A0" ng-model="newTodoText" maxlength="128"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:3%; text-align: center;"><span class="cut-with-dots">#</span></td><td style="width:12%; text-align: center;"><span class="cut-with-dots">\u30C1\u30A7\u30C3\u30AF\u8A73\u7D30\u9805\u76EE</span></td><td style="width:18%; text-align: center;"><span class="cut-with-dots">\u88DC\u8DB3</span></td><td style="width:13%; text-align: center;"><span class="cut-with-dots">\u5165\u529B\u65B9\u5F0F</span></td><td style="width:11%; text-align: center;"><span class="cut-with-dots">\u9078\u629E\u5024<button style="margin-left: 10px; type=" button"="" class="btn btn-xs btn-info" ng-click="showCreateUserReource()">\u8FFD\u52A0</button></span></td><td style="width:4%;"><span class="cut-with-dots">\u5FC5\u9808</span></td><td style="width:10%; text-align: right;" ng-show="showLimitCol"></td><td style="width:3.3%; text-align: right;"></td><td style="width:5%; text-align: right;"></td></tr></table></div><ul class="todo-list" ui-sortable="sortableOptions" ng-model="checkDetailList"><li class="list" ng-repeat="item in checkDetailList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px 12px;"><table class="checklist-table"><tr><td style="width:3%"><span class="cut-with-dots">{{ item.no }}</span></td><td style="width:12%"><input type="text" value="{{::item.title}}" class="form-control" placeholder="\u30C1\u30A7\u30C3\u30AF\u8A73\u7D30\u9805\u76EE" id="title{{$index}}" maxlength="128"></td><td style="width:18%"><input type="text" value="{{::item.content}}" class="form-control" placeholder="\u88DC\u8DB3" id="content{{$index}}" maxlength="500"></td><td style="width:13%"><select class="form-control selectpicker" selectpicker="" ng-model="inputTypeConf[$index]" ng-options="item as item.label for item in $root.inputTypeItems" ng-change="inputTypeConfChange($index)" id="inputType{{$index}}" ng-click="saveCheckDetail();"></select></td><td style="width:11%"><select id="itemMast{{$index}}" class="form-control selectpicker" selectpicker="" ng-model="itemMasterConf[$index]" ng-options="item as item.label for item in chioseItemMaster" ng-change="itemMasterConfChange($index)" ng-disabled="inputTypeConf[$index].value != 3 && inputTypeConf[$index].value != 4 && inputTypeConf[$index].value != 5"></select></td><td style="width:4%;text-align: center;"><label class="checkbox-inline custom-checkbox nowrap"><input id="mustFlg{{$index}}" ng-checked="{{item.mustFlg}}" type="checkbox" value="1" name="testCheckBox"> <span class="cut-with-dots" style="color: #666666;"></span></label></td><td style="width:10%; text-align: right;" ng-show="showLimitCol"><input type="text" value="{{::item.unit}}" class="form-control" placeholder="\u5358\u4F4D" id="unit{{$index}}" maxlength="32" ng-show="inputTypeConf[$index].value == 12 && item.id != 0" style="width:55px;display: inline;"> <button type="button" class="status-button btn btn-xs btn-info" ng-click="showLimit(item)" ng-show="inputTypeConf[$index].value == 12 && item.id != 0" style="width:45px">\u7BC4\u56F2</button></td><td style="width:3.3%; text-align: right;"><button type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button></td><td style="width:5%; text-align: right;"><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeDetail($index,item.id);">\u524A\u9664</button></td></tr></table></li></ul></div></div><div class="modal-footer"><button type="button" class="btn btn-info" click-and-disable="saveCheckDetail();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/checklist/checklistFile/addFileInDetail.html','<div class="modal-content" style="width: 750px;"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u95A2\u9023\u30D5\u30A1\u30A4\u30EB</h4></div><div class="modal-body text-left"><div>{{checklistContent}}</div><div ng-show="!readonly" style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info btn-sm" ng-click="openUploadDialogInDetail(item)">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="fileListCopy" st-safe-src="fileList" st-filtered-collection="stFilteredCollection" st-set-filter="customFilter"><thead><tr class="sortable"><th style="text-align:left" st-sort="fileName">\u30D5\u30A1\u30A4\u30EB\u540D</th><th st-sort="size">\u30B5\u30A4\u30BA</th><th st-sort="userName">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u8005</th><th st-sort="updateTime">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u65E5\u6642</th><th ng-show="!readonly">\u64CD\u4F5C</th></tr><tr><th><select st-search="fileName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fileName\'" value="{{item.fileName}}">{{item.fileName}}</option></select></th><th><select st-search="size" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'size\'" value="{{item.size}}">{{item.size}}</option></select></th><th><select st-search="userName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userName\'" value="{{item.userName}}">{{item.userName}}</option></select></th><th><select st-search="updateTime" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'updateTime\'" value="{{item.updateTime}}">{{item.updateTime}}</option></select></th><th ng-show="!readonly"></th></tr></thead><tbody><tr ng-repeat="item in fileListCopy"><td style="white-space: nowrap; width: 30%" class="table-id"><a href="javascript:;" ng-click="downLoadFile(item);">{{item.fileName}}</a> <button ng-show="isImg(item.fileName)" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="previewImage(item)"><i class="material-icons">open_in_new</i></button></td><td style="white-space: nowrap; text-align:right; width: 10%">{{ $root.getFileSize(item.size) }}</td><td style="white-space: nowrap; width: 20%">{{ item.userName }}</td><td style="white-space: nowrap; width: 20%">{{ item.updateTime }}</td><td ng-show="!readonly" style="white-space: nowrap"><button class="editable-table-button btn btn-xs btn-danger" ng-click="delDetailFile(item)">\u524A\u9664</button></td></tr></tbody><tfoot><tr><td colspan="14" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/checklist/checklistFile/addFileInDetailSp.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u95A2\u9023\u30D5\u30A1\u30A4\u30EB</h4></div><div class="modal-body text-left"><div class="horizontal-scroll" ng-if="fileList.length > 0" style="border-top: 1px solid rgba(0, 0, 0, 0.12);margin-top:10px;"><table class="table" st-table="fileListCopy" st-safe-src="fileList" st-filtered-collection="stFilteredCollection" st-set-filter="customFilter"><thead><tr class="sortable"><th style="text-align:left" st-sort="fileName">\u30D5\u30A1\u30A4\u30EB\u540D</th></tr><tr><th><select st-search="fileName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fileName\'" value="{{item.fileName}}">{{item.fileName}}</option></select></th></tr></thead><tbody><tr ng-repeat="item in fileListCopy"><td style="white-space: nowrap; width: 30%" class="table-id"><a href="javascript:;" ng-click="downLoadFile(item);">{{item.fileName}}</a> <button ng-show="isImg(item.fileName)" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="previewImage(item)"><i class="material-icons">open_in_new</i></button></td></tr></tbody><tfoot><tr><td colspan="14" class="text-left"></td></tr></tfoot></table></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/checklist/checklistLimit/checklistLimit.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u7570\u5E38\u5024\u7BC4\u56F2\u8A2D\u5B9A</h4></div><div class="modal-body text-left"><div>{{checklistContent}}</div><div class="task-todo-container transparent"><h5>\u7570\u5E38\u5024\u306E\u7BC4\u56F2\u8A2D\u5B9A\u304C\u884C\u3048\u307E\u3059\u3002</h5><h5>\u30C1\u30A7\u30C3\u30AF\u6642\u306B\u6307\u5B9A\u306E\u6761\u4EF6\u3092\u6E80\u305F\u3057\u305F\u5834\u5408\u3001\u5165\u529B\u6B04\u306E\u80CC\u666F\u304C\u8D64\u8272\u306B\u306A\u308A\u307E\u3059\u3002</h5><div style="padding-left: 20px;padding-bottom: 10px;"><span class="cut-with-dots">\u6761\u4EF6</span></div><div style="margin-bottom: 5px;"><table class="checklist-table"><tr><td style="width:7%"><input disabled="" type="text" value="{{detailName}}" class="form-control" maxlength="128"></td><td style="width:7% ; text-align: center;"><select class="form-control selectpicker" selectpicker="" ng-model="condition" ng-options="item as item.label for item in conditionList"></select></td><td style="width:7%"><input type="number" value="" class="form-control" placeholder="\u5024\u5165\u529B" ng-model="numberValue" maxlength="256" pattern="-?[0-9]+([\\.,][0-9]+)?" inputmode="numeric"></td><td style="width:5%; text-align: left;" ng-show="isTwoConditon"><button type="button" class="btn btn-danger" ng-click="removeLimit();">\u524A\u9664</button></td></tr><tr><td style="width:7%; text-align: right; padding-top: 20px; padding-bottom: 25px;"><button class="btn btn-info" ng-click="addDetail()" ng-show="!isTwoConditon">\u8FFD\u52A0</button></td><td style="width:7% ; text-align: center;" ng-show="isTwoConditon"><select class="form-control selectpicker" selectpicker="" ng-model="condition2" ng-options="item as item.label for item in conditionList"></select></td><td style="width:7%; padding-top: 20px; padding-bottom: 25px;" ng-show="isTwoConditon"><input type="number" value="" class="form-control" placeholder="\u5024\u5165\u529B" ng-model="numberValue2" maxlength="256" pattern="-?[0-9]+([\\.,][0-9]+)?" inputmode="numeric"></td><td style="width:5%; text-align: left;" ng-show="isTwoConditon"><button type="button" class="btn btn-danger" ng-click="removeLimit2();">\u524A\u9664</button></td></tr></table><table ng-show="isTwoConditon"><tr><td style="width: 15%; padding-bottom: 20px; padding-top: 10px;"><div><p><label class="radio-inline custom-radio nowrap"><input type="radio" name="logicRadio" id="logicRadio0" value="1" ng-model="logicRadio"> <span>\u3059\u3079\u3066\u306E\u6761\u4EF6\u3092\u6E80\u305F\u3059</span></label> <label class="radio-inline custom-radio nowrap"><input type="radio" name="logicRadio" id="logicRadio1" value="2" ng-model="logicRadio"> <span>\u3044\u305A\u308C\u304B\u306E\u6761\u4EF6\u3092\u6E80\u305F\u3059</span></label></p></div></td></tr></table><div class="modal-footer"><button type="button" class="btn btn-info" click-and-disable="saveCheckLimit();">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div></div></div></div>');
$templateCache.put('app/pages/checkreport/sp/checkListFileListSp.html','<div class="horizontal-scroll" ng-if="checkListFileList.length > 0" style="border-top: 1px solid rgba(0, 0, 0, 0.12);margin-top:10px;"><table class="table" st-table="fileListCopy" st-safe-src="checkListFileList" st-set-filter="customFilter" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th style="text-align:left" st-sort="fileName">\u30D5\u30A1\u30A4\u30EB\u540D</th></tr><tr><th><select st-search="fileName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fileName\'" value="{{item.fileName}}">{{item.fileName}}</option></select></th></tr></thead><tbody><tr ng-repeat="item in fileListCopy"><td style="white-space: nowrap; width: 30%" class="table-id"><a href="javascript:;" ng-click="downLoadFile(item);">{{item.fileName}}</a> <button ng-show="isImg(item.fileName)" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="previewImage(item)"><i class="material-icons">open_in_new</i></button></td></tr></tbody><tfoot><tr><td colspan="14" class="text-left"></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/checkreport/sp/checkreportCreaterSp.html','<div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5BFE\u8C61\u5DE5\u4E8B\uFF1A <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button style="margin-left: 10px; type=" button"="" class="btn btn-xs btn-info" ng-click="showCreateTarget()">\u8FFD\u52A0</button></label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.target" ng-change="changeTarget()" ng-options="item as item.targetNameId for item in targetList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u533A\u5206\uFF1A <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.first" ng-change="changeFirst()" ng-options="item as item.label for item in firstList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5927\u9805\u76EE\uFF1A <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.second" ng-disabled="secondDisable" ng-change="changeSecond()" ng-options="item as item.label for item in secondList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u4E2D\u9805\u76EE\uFF1A <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.third" ng-disabled="thirdDisable" ng-change="changeThird()" ng-options="item as item.label for item in thirdList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5C0F\u9805\u76EE\uFF1A <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.fourth" ng-disabled="fourthDisable" ng-options="item as item.label for item in fourthList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u30B9\u30C6\u30FC\u30BF\u30B9\uFF1A</label><br><span style="padding-left: 10px;">{{ $root.getStatusShowName(\'01\') }}</span></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u958B\u59CB\u65E5(\u4E88\u5B9A)\uFF1A</label><p class="input-group" style="margin: 0;border-collapse: collapse;" ng-controller="datepickerpopupCtrl"><input ng-model="ctrl.startScheduledDate" type="text" placeholder="" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5B8C\u4E86\u65E5(\u4E88\u5B9A)\uFF1A</label><p class="input-group" style="margin: 0;border-collapse: collapse;" ng-controller="datepickerpopupCtrl"><input ng-model="ctrl.endScheduledDate" type="text" placeholder="" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u7BA1\u7406\u6280\u8853\u8005\uFF1A</label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.requestUser" ng-options="item as item.userNameId for item in userList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u6307\u793A\u30B0\u30EB\u30FC\u30D7\uFF1A</label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.requestGroup" ng-options="item as item.groupNameId for item in groupList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u62C5\u5F53\u6280\u8853\u8005\uFF1A</label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.responseUser" ng-options="item as item.userNameId for item in userList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u62C5\u5F53\u6280\u8853\u8005\u30B0\u30EB\u30FC\u30D7\uFF1A</label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.responseGroup" ng-options="item as item.groupNameId for item in groupList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7\uFF1A</label><ui-select multiple="" ng-model="readingGroups.selected" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="">{{$item.groupNameId}}</ui-select-match><ui-select-choices repeat="readingGroups in groupList | filter: $select.search">{{readingGroups.groupNameId}}</ui-select-choices></ui-select></div><div class="form-group" ng-if="showStatusDetail"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{statusDetailItemName}}\uFF1A <label ng-if="mustStatusDetail" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.statusDetailOb" ng-options="item as item.label for item in statusDetailList"></select></div><div class="form-group" ng-if="showKbn2"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn2ItemName}}\uFF1A <label ng-if="mustKbn2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select></div><div class="form-group" ng-if="showKbn3"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn3ItemName}}\uFF1A <label ng-if="mustKbn3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select></div><div class="form-group" ng-if="showKbn4"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn4ItemName}}\uFF1A <label ng-if="mustKbn4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select></div><div class="form-group" ng-if="showKbn5"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn5ItemName}}\uFF1A <label ng-if="mustKbn5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></div><div class="form-group" ng-if="showItem1"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item1ItemName}}\uFF1A <label ng-if="mustItem1" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item1" maxlength="256"></div><div class="form-group" ng-if="showItem2"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item2ItemName}}\uFF1A <label ng-if="mustItem2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item2" maxlength="256"></div><div class="form-group" ng-if="showItem3"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item3ItemName}}\uFF1A <label ng-if="mustItem3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item3" maxlength="256"></div><div class="form-group" ng-if="showItem4"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item4ItemName}}\uFF1A <label ng-if="mustItem4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item4" maxlength="256"></div><div class="form-group" ng-if="showItem5"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item5ItemName}}\uFF1A <label ng-if="mustItem5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item5" maxlength="256"></div><div class="form-group" style="text-align: center;"><button type="button" class="btn btn-info" click-and-disable="createTicketSp()">\u767B\u9332</button> <button type="button" class="btn btn-danger" ng-click="closeCreateTicketSp()">\u53D6\u6D88</button></div>');
$templateCache.put('app/pages/checkreport/sp/checkreportDetailSp.html','<script src="https://cdnjs.cloudflare.com/ajax/libs/jqueryui-touch-punch/0.2.3/jquery.ui.touch-punch.min.js"></script><div style="text-align: center; margin-bottom: 15px;"><div class="btn-group"><button style="font-weight: bold;" type="button" class="btn btn-default" ng-click="showTicketInfoSp()"><span>\uFF81\uFF6A\uFF6F\uFF78\uFF7C\uFF70\uFF84&nbsp;</span></button> <button style="font-weight: bold;" type="button" class="btn btn-default" ng-click="showCheckListSp()"><span>\u30C1\u30A7\u30C3\u30AF</span></button> <button style="font-weight: bold;" type="button" class="btn btn-default" ng-click="showHistorySp()"><span>\u30B3\u30E1\u30F3\u30C8</span></button> <button style="font-weight: bold;" type="button" class="btn btn-default" ng-click="showTargetInfoSp()"><span>\u5BFE\u8C61\u5DE5\u4E8B</span></button></div></div><div class="col-md-12" style="padding :0;"><div ng-if="statusOb.value == \'03\' || statusOb.value == \'04\' || statusOb.value == \'05\'" class="alert bg-info" style="text-align: center; margin-bottom: 0px;padding:10px 0px 2px; background: #5bc0de;"><span class="checkreport-msg" style="font-size: 22px;">{{statusOb.label}}</span></div><div ng-if="statusOb.value == \'01\' || statusOb.value == \'02\' || statusOb.value == \'99\'" class="alert bg-danger" style="text-align: center; margin-bottom: 0px;padding:10px 0px 2px; background: #e85656;"><span class="checkreport-msg" style="font-size: 22px;">{{statusOb.label}}</span></div><div class="progress" style="height:10px;margin-top: 2px;" ng-if="complete != 100"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="66" aria-valuemin="0" aria-valuemax="100" style="width: {{complete}}%"><span class="sr-only">{{complete}}% \u5B8C\u6210</span></div></div><div class="progress" style="height:10px;margin-top: 2px;" ng-if="complete == 100"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="66" aria-valuemin="0" aria-valuemax="100" style="width: 100%"><span class="sr-only">100% \u5B8C\u6210</span></div></div><div class="unit_title"><button ng-disabled="complete != 100 || isVisitor" type="button" ng-if="(statusOb.value == \'01\' || statusOb.value == \'02\' || statusOb.value == \'99\') && complete != 100" style="box-shadow :0 0 0 4px #eeeeee, 0 0 0 8px #fff, 0 0 18px rgba(0, 0, 0, 0.8)">\u30C1\u30A7\u30C3\u30AF\u5B8C\u4E86</button> <button type="button" ng-click="reportComp();" ng-if="( statusOb.value == \'01\' || statusOb.value == \'02\' || statusOb.value == \'99\') && complete == 100 && isResponser">\u30C1\u30A7\u30C3\u30AF\u5B8C\u4E86</button> <button ng-disabled="isVisitor" type="button" ng-if="statusOb.value == \'03\' && isVisitor" style="box-shadow :0 0 0 4px #eeeeee, 0 0 0 8px #fff, 0 0 18px rgba(0, 0, 0, 0.8)">\u5F15\u623B\u3057</button> <button type="button" ng-click="reportReturn();" ng-if="statusOb.value == \'03\' && isEditer && isResponser">\u5F15\u623B\u3057</button><dl><dt>{{targetIdItemName}}\uFF1A</dt><dd>{{ticket.targetIdShow}}</dd><dt>{{targetNameItemName}}\uFF1A</dt><dd>{{ticket.targetName}}</dd><dt>\u958B\u59CB\u65E5\uFF1A</dt><dd>{{ticket.startDate}}</dd></dl></div><div class="unit_pager"><button style="width:85px; white-space: nowrap;" type="button" ng-click="getCheckreportDetailSp(prefDetailId, false);"><span class="cut-with-dots">{{prefDetailId}}.{{prefCheckListOb.checklistName}}</span></button><p><span>{{detailId}}</span>/<span>{{checkresultList.length}}</span></p><button style="width:85px; white-space: nowrap;" type="button" ng-click="getCheckreportDetailSp(nextDetailId, false);"><span class="cut-with-dots">{{nextDetailId}}.{{nextCheckListOb.checklistName}}</span></button></div><div class="unit_edit" ng-if="checkListOb.checkResult != \'3\' && checkListOb.checkResult != \'\' && checkListOb.checkResult != null"><h3 class="success" style="display: inline-flex;"><span class="cut-with-dots" style="width:85%; white-space: nowrap;">{{detailId}}\uFF0E{{checkListOb.checklistName}}</span><small>\u5165\u529B\u6E08</small></h3><p ng-bind-html="checkListOb.checklistContent"></p></div><div class="unit_edit" ng-if="! (checkListOb.checkResult != \'3\' && checkListOb.checkResult != \'\' && checkListOb.checkResult != null)"><h3 class="alart" style="display: inline-flex;"><span class="cut-with-dots" style="width:85%; white-space: nowrap;">{{detailId}}\uFF0E{{checkListOb.checklistName}}</span><small>\u672A\u5165\u529B</small></h3><p ng-bind-html="checkListOb.checklistContent"></p></div><div ng-repeat="item in resultDetailList" ng-init="outerIndex = $index"><div class="form-group" ng-if="item.inputTypeId == 1" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <input ng-disabled="isVisitor || notEditable" type="text" class="form-control" ng-model="result[outerIndex].value" maxlength="512"></div><div class="form-group" ng-if="item.inputTypeId == 2" ng-controller="datepickerpopupCtrl" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <input ng-disabled="isVisitor || notEditable" ng-model="result[outerIndex].value" type="text" placeholder="YYYY/MM/DD" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"></div><div class="form-group" ng-if="item.inputTypeId == 3" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><select ng-disabled="isVisitor || notEditable" class="form-control selectpicker" selectpicker="" ng-model="result[outerIndex].value" ng-options="item1 as item1.label for item1 in userResource{{item.resultDetailId}}"></select></div><div class="form-group" ng-if="item.inputTypeId == 4" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><p class="input-group"><label class="radio-inline custom-radio nowrap" ng-repeat="item2 in userResource[outerIndex]"><input ng-disabled="isVisitor || notEditable" type="radio" value="{{item2.value}}" ng-model="result[outerIndex].value"> <span>{{item2.label}}</span></label></p></div><div class="form-group" ng-if="item.inputTypeId == 5" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><p class="input-group"><label class="checkbox-inline custom-checkbox nowrap" ng-repeat="item6 in userResource[outerIndex]"><input ng-disabled="isVisitor || notEditable" ng-checked="chBoxResult[outerIndex][$index] == item6.value" type="checkbox" ng-true-value="{{item6.value}}" ng-false-value="0" ng-model="chBoxResult[outerIndex][$index]"> <span>{{item6.label}}</span></label></p></div><div class="form-group" ng-if="item.inputTypeId == 6" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <textarea ng-disabled="isVisitor || notEditable" class="form-control" ng-model="result[outerIndex].value" maxlength="512"></textarea></div><div class="form-group" ng-if="item.inputTypeId == 7" style="margin-bottom: 30px;"><label id="imgLabel{{item.resultDetailId}}" style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><div id="slider{{item.resultDetailId}}" class="flexslider" style="position: relative; height: 100%;text-align: center; background: #eee;border-radius: 6px;margin: 0;"><ul class="slides"><li ng-repeat="item3 in dynamicImgArray(item.resultDetailId)"><div><img ng-src="{{item3.url}}" alt="" title=""> <button ng-if="isEditer && !notEditable" type="button" ng-click="deleteFile(item3.fileId, item.resultDetailId, \'Image\')"><i class="material-icons" style="margin-right: 2px;">delete_forever</i>\u524A\u9664</button> <textarea ng-if="isEditer && !notEditable" name="content" cols="50" rows="5" style="left: 9px; bottom: 10px; width: 100%; margin-bottom: 22px;" ng-model="item3.imgComm" ng-disabled="! isEditer" placeholder="\u30B3\u30E1\u30F3\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"></textarea> <button ng-if="isEditer && !notEditable" type="button" ng-click="saveImgCom(item3.fileId, item3.imgComm)" style="top:auto; color: #fff; background: #2dacd1; border-color: #2dacd1;bottom: 0px;">\u30B3\u30E1\u30F3\u30C8\u4FDD\u5B58</button></div></li></ul></div><br><button ng-if="isEditer && !notEditable" type="button" class="btn btn-info btn-sm" ng-click="openUploadImg(item.resultDetailId)">\u5199\u771F\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button> <button ng-if="isEditer && !notEditable && hasImgArrayList(item.resultDetailId)" type="button" class="btn btn-info btn-sm" ng-click="openImgOrder(item.resultDetailId);">\u4E26\u3079\u66FF\u3048</button></div><div class="form-group" ng-if="item.inputTypeId == 8" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><table class="table" style="border-top: 1px solid rgba(0, 0, 0, 0.12); border-collapse:separate; border-spacing:0px 10px;" ng-repeat="item4 in dynamicArray(item.resultDetailId)"><tr><td style="border:none">No.{{$index+1}}</td></tr><tr><td style="border:none">{{item4.fileName}}</td></tr><tr><td style="border:none; width: 350px;"><video style="width: 100%;" controls="" ng-src="{{item4.url}}" preload="auto" webkit-playsinline="" playsinline=""></video></td></tr><tr><td style="border:none"><button ng-if="isEditer && !notEditable" type="button" ng-click="deleteFile(item4.id, item.resultDetailId, \'Radio\')" class="btn btn-danger editable-table-button btn-xs">\u524A\u9664</button></td></tr></table><br><button ng-if="isEditer && !notEditable" type="button" class="btn btn-info btn-sm" ng-click="openUploadRadio(item.resultDetailId)">\u97F3\u58F0\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="form-group" ng-if="item.inputTypeId == 9" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><table class="table" style="border-top: 1px solid rgba(0, 0, 0, 0.12); border-collapse:separate; border-spacing:0px 10px;" ng-repeat="item5 in dynamicArray(item.resultDetailId)"><tr><td style="border:none; vertical-align: middle;">No.{{$index+1}}</td></tr><tr><td style="border:none; vertical-align: middle;">{{item5.fileName}}</td></tr><tr><td style="border:none; width: 350px;"><video style="width: 100%;" controls="" ng-src="{{item5.url}}" type="video/mp4" preload="auto" webkit-playsinline="" playsinline=""></video></td></tr><tr><td style="border:none; vertical-align: middle;"><button ng-if="isEditer && !notEditable" type="button" ng-click="deleteFile(item5.id, item.resultDetailId, \'Radio\')" class="btn btn-danger editable-table-button btn-xs">\u524A\u9664</button></td></tr></table><br><button ng-if="isEditer && !notEditable" type="button" class="btn btn-info btn-sm" ng-click="openUploadVideo(item.resultDetailId)">\u52D5\u753B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="form-group" ng-if="item.inputTypeId == 10" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><div style="text-align: center;"><button ng-if="isEditer && !notEditable" ng-show="signable{{item.resultDetailId}} && signFlg{{item.resultDetailId}}" type="button" class="btn btn-info" ng-click="showSignPc(item.resultDetailId)">\u624B\u66F8\u3059\u308B</button> <button ng-if="isEditer && !notEditable" ng-show="! signable{{item.resultDetailId}}" type="button" class="btn btn-danger" ng-click="deleteSign(item.resultDetailId)">\u524A\u9664</button><div ng-show="signable{{item.resultDetailId}}" id="signature{{item.resultDetailId}}" style="height: 202px;border: 1px solid #ccc;margin: 10px 20px;"></div><button ng-show="!signFlg{{item.resultDetailId}}" type="button" class="btn btn-info" ng-click="saveSignPc(item.resultDetailId)" id="signOK{{item.resultDetailId}}">\u78BA\u5B9A</button> <button ng-show="!signFlg{{item.resultDetailId}}" type="button" class="btn btn-danger" ng-click="resetSignPc(item.resultDetailId)" id="signReset{{item.resultDetailId}}">\u30EA\u30BB\u30C3\u30C8</button><div ng-show="! signable{{item.resultDetailId}}" style="margin:20px"><img style="width: 100%;" ng-src="{{getSignUrl(item.resultDetailId)}}" alt="" title=""></div></div></div><div class="form-group" ng-if="item.inputTypeId == 11" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <input ng-disabled="isVisitor" ng-show="!camera{{item.resultDetailId}}" type="text" class="form-control" ng-model="result[outerIndex].value"><div ng-show="camera{{item.resultDetailId}}" style="text-align: center;"><blockquote data-mode="click2play" data-width="100%" data-height="478" class="ricoh-theta-tour-image" ng-show="cameraT{{item.resultDetailId}}"><a href="{{result[outerIndex].value}}"></a></blockquote><blockquote data-mode="click2play" data-width="100%" data-height="478" class="ricoh-theta-spherical-image" ng-show="! cameraT{{item.resultDetailId}}"><a href="{{result[outerIndex].value}}"></a></blockquote><script async="" src="https://smartbee.theta360.biz/widgets.js" charset="utf-8"></script><button ng-if="isEditer && !notEditable" type="button" class="btn btn-danger" ng-click="delete360Camera(item.resultDetailId)" style="margin-top: 5px;">\u524A\u9664</button></div></div><div class="form-group" ng-if="item.inputTypeId == 12" style="margin-bottom: 30px;"><label ng-if="item.unit == \'\' || item.unit ==null" style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-if="item.unit != \'\' && item.unit !=null" style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}({{item.unit}})</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button> <input ng-disabled="isVisitor || notEditable" type="number" class="form-control" ng-model="result[outerIndex].value" pattern="-?[0-9]+([\\.,][0-9]+)?" inputmode="numeric" ng-blur="checkLimit(item.checkDetailId, outerIndex, true)" ng-style="{\'background-color\':errorStyle[outerIndex]}"></div><div class="form-group" ng-if="item.inputTypeId == 13" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" id="ex{{item.resultDetailId}}" ng-click="bubble.open = true"><i class="ion-help" aria-hidden="true"></i></button><bubble ng-if="bubble.open" for="ex{{item.resultDetailId}}" close="bubble.open=false" align="top right">{{item.checkDetailContent}}</bubble><button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><table class="table table-striped" st-table="fileData" st-safe-src="dynamicArray(item.resultDetailId)"><thead><tr><td class="text-left"></td></tr></thead><tbody><tr ng-repeat="item13 in fileData" style="border: 1px solid rgba(0, 0, 0, 0.12);"><td style="padding-right: 8px !important;line-height: 30px;"><table style="width: 100%;"><tr><td style="text-align: left;padding-top: 5px;"><a href="javascript:;" ng-click="downLoadFile(item13);">{{item13.fileName}}</a></td></tr><tr><td style="text-align: center;"><button ng-if="isEditer && !notEditable" type="button" ng-click="deleteFile(item13.id, item.resultDetailId, \'File\')" class="btn btn-danger editable-table-button btn-xs">\u524A\u9664</button></td></tr></table></td></tr></tbody><tfoot><tr><td class="text-left"></td></tr></tfoot></table><br><button ng-if="isEditer && !notEditable" type="button" class="btn btn-info btn-sm" ng-click="openUploadFile(item.resultDetailId)">\u30D5\u30A1\u30A4\u30EB\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div><div class="form-group" ng-if="item.inputTypeId == 14" style="margin-bottom: 30px;"><label style="font-size: 18px; font-weight: 400; color:#666666;">{{outerIndex}}.{{item.checkDetailName}}</label> <label ng-show="item.mustFlg == \'1\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <button ng-show="item.checkDetailContent != \'\' && item.checkDetailContent != null" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="showCheckDetailContent(item.resultDetailId)"><i class="ion-help" aria-hidden="true"></i></button> <button ng-show="item.checkDetailIdInFile != 0" type="button" class="file-button btn btn-xs btn-info" ng-click="showAddFileInDetail(item)"><i class="material-icons">description</i></button><div style="display: flex;"><div ng-disabled="isVisitor || notEditable" uib-timepicker="" ng-model="result[outerIndex].value" hour-step="1" minute-step="1" show-meridian="false"></div><button style="margin: auto 0; margin-left: 10px;" type="button" class="btn btn-info" ng-click="setNowTime(outerIndex);" ng-if="isEditer && !notEditable">\u73FE\u5728\u6642\u523B</button> <button style="margin: auto 0; margin-left: 10px;" type="button" class="btn btn-danger" ng-click="clearTime(outerIndex);" ng-if="isEditer && !notEditable">\u30AF\u30EA\u30A2</button></div></div></div><div ng-if="showResult != \'1\'" class="form-group" style="text-align: center; border:1px solid rgba(0, 0, 0, 0.12);"><label style="font-size: 18px; font-weight: 400; color:#666666; padding-top: 15px;">\u30C1\u30A7\u30C3\u30AF\u7D50\u679C</label><p class="input-group"><label class="radio-inline custom-radio nowrap"><input ng-disabled="isVisitor || notEditable" type="radio" name="finalCheck" value="1" ng-model="result[0].value"> <span>\u6B63\u5E38</span></label> <label class="radio-inline custom-radio nowrap"><input ng-disabled="isVisitor || notEditable" type="radio" name="finalCheck" value="2" ng-model="result[0].value"> <span>\u7570\u5E38</span></label> <label class="radio-inline custom-radio nowrap"><input ng-disabled="isVisitor || notEditable" type="radio" name="finalCheck" value="3" ng-model="result[0].value"> <span>\u4FDD\u7559</span></label> <label class="radio-inline custom-radio nowrap"><input ng-disabled="isVisitor || notEditable" type="radio" name="finalCheck" value="4" ng-model="result[0].value"> <span>\u5BFE\u8C61\u5916</span></label></p></div><div style="text-align: center; padding-top: 10px;"><button ng-if="isEditer && !notEditable" type="button" class="btn btn-info" ng-click="saveResult(true)">\u4FDD\u5B58</button></div><div style="text-align: center; padding-top: 10px;"><button ng-if="isEditer && !notEditable" type="button" class="btn btn-info" ng-click="temSaveResult(true)">\u4E00\u6642\u4FDD\u5B58</button></div><div class="unit_pager" style="padding-bottom: 40px;"><button style="width:85px; white-space: nowrap;" type="button" ng-click="getCheckreportDetailSp(prefDetailId, false);"><span class="cut-with-dots">{{prefDetailId}}.{{prefCheckListOb.checklistName}}</span></button><p><span>{{detailId}}</span>/<span>{{checkresultList.length}}</span></p><button style="width:85px; white-space: nowrap;" type="button" ng-click="getCheckreportDetailSp(nextDetailId, false);"><span class="cut-with-dots">{{nextDetailId}}.{{nextCheckListOb.checklistName}}</span></button></div></div>');
$templateCache.put('app/pages/checkreport/sp/checkreportHistorySp.html','<div class="modal-content" style="margin: 66px 0px 0px;"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30B3\u30E1\u30F3\u30C8</h4></div><div class="modal-body text-left" style="text-align: left;"><uib-accordion><uib-accordion-group heading="\u30B3\u30E1\u30F3\u30C8\u3092\u5165\u529B\u3059\u308B" panel-class="panel-info bootstrap-panel accordion-panel" style="text-align: center;"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'strikeThrough\',\'ul\', \'ol\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\', \'quote\',\'undo\',\'redo\', \'fontColor\']]"></text-angular-toolbar><text-angular style="text-align: left;" name="htmlcontent" ta-target-toolbars="toolbarMain" ng-model="content"></text-angular><div style="text-align: center;"><button class="btn btn-info" type="button" ng-click="saveComment()" style="margin-top: 5px;">\u4FDD\u5B58</button></div></uib-accordion-group></uib-accordion><table style="width:100%; margin-bottom: 20px;" ng-repeat="item in statusHistoryList"><tr style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"><td style="width:7%;">{{$index+1}}</td><td colspan="2" style="width:95%; font-weight: bold; padding-bottom: 5px;">{{item.statusName}}</td></tr><tr><td></td><td style="padding-top: 5px;">{{item.userName}}</td><td rowspan="2" style="padding-top: 5px;"><button ng-if="item.type == \'2\' && item.userId == loginUserId" style="text-align: right;" class="btn btn-danger" type="button" ng-click="deleteComment(item.id)">\u524A\u9664</button></td></tr><tr><td></td><td>{{item.updateTime}}</td></tr><tr><td></td><td colspan="2" ng-bind-html="item.comment"></td></tr></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/checkreport/sp/checkreportListSp.html','<div class="horizontal-scroll"><div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info" ng-click="showCheckreportList()">\u30EA\u30ED\u30FC\u30C9</button> <button type="button" class="btn btn-info" ng-click="showCheckreportCreateSp()">\u65B0\u898F</button></div><table style="border-collapse: separate; border-spacing: 0px 5px; width: 90%; margin: 0 auto;" ng-if="showCondition"><tr><td rowspan="3" style="width: 30%;">\u958B\u59CB\u65E5(\u4E88\u5B9A):</td><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-disabled="isVisitor" ng-model="ctrl.sScheduledDateS" type="text" placeholder="FROM" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td></tr><tr><td colspan="2">\uFF5E</td></tr><tr><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-disabled="isVisitor" ng-model="ctrl.sScheduledDateE" type="text" placeholder="TO" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td></tr><tr><td rowspan="6">\u30B9\u30C6\u30FC\u30BF\u30B9:</td><td><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="01" ng-model="ctrl.status01"> <span>{{ $root.getStatusShowName(\'01\') }}</span></label></td></tr><tr><td><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="02" ng-model="ctrl.status02"> <span>{{ $root.getStatusShowName(\'02\') }}</span></label></td></tr><tr><td><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="03" ng-model="ctrl.status03"> <span>{{ $root.getStatusShowName(\'03\') }}</span></label></td></tr><tr><td><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="04" ng-model="ctrl.status04"> <span>{{ $root.getStatusShowName(\'04\') }}</span></label></td></tr><tr><td><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="05" ng-model="ctrl.status05"> <span>{{ $root.getStatusShowName(\'05\') }}</span></label></td></tr><tr><td><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="99" ng-model="ctrl.status99"> <span>{{ $root.getStatusShowName(\'99\') }}</span></label></td></tr><tr><td>{{targetIdItemName}}:</td><td><input type="text" class="form-control" ng-model="ctrl.targetIdCondi"></td></tr><tr><td>{{targetNameItemName}}:</td><td><input type="text" class="form-control" ng-model="ctrl.targetNameCondi"></td></tr><tr><td>\u30C1\u30A7\u30C3\u30AF:</td><td><input type="text" class="form-control" ng-model="ctrl.checkSheetCondi"></td></tr><tr><td>\u62C5\u5F53\u6280\u8853\u8005:</td><td><input type="text" class="form-control" ng-model="ctrl.responseUserCondi"></td></tr><tr><td colspan="2" style="text-align: center;"><button style="padding-right:10px" type="button" class="btn btn-primary" ng-click="getCheckreportListSp2()">\u691C\u7D22</button> <button type="button" class="btn btn-danger" ng-click="clearConditionSp()">\u30AF\u30EA\u30A2</button></td></tr></table><table class="table table-striped" st-table="reportData" st-safe-src="checkreportList" style="word-break:break-all;"><thead><tr><td colspan="4" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></thead><tbody><tr style="background: none;"><td colspan="4"><span>\u5408\u8A08\uFF1A &nbsp; {{checkreportList.length}} &nbsp;\u4EF6</span></td></tr><tr ng-repeat="item in reportData" ng-click="showCheckreportDetailSpWindow(item);" style="border: 1px solid rgba(0, 0, 0, 0.12);"><td ng-if="item.statusId == \'01\' || item.statusId == \'02\' || item.statusId == \'99\'" style="width: 5%;background: #e85656;">&nbsp;</td><td ng-if="!(item.statusId == \'01\' || item.statusId == \'02\' || item.statusId == \'99\')" style="width: 5%;background: #5bc0de;">&nbsp;</td><td style="padding-right: 8px !important;line-height: 30px;"><table style="width: 100%;"><tr><td style="text-align: left;">{{ $root.padLeft(item.id, 8) }}</td><td style="text-align: right; width: 50%;">{{item.statusName}}</td></tr><tr><td colspan="2" style="font-weight: bold;text-align: left; font-size: 20px;">{{item.targetName}}</td></tr><tr><td colspan="2" style="text-align: left;">{{item.startScheduledDate}}&nbsp;&nbsp;\uFF5E&nbsp;&nbsp;{{item.endScheduledDate}}</td></tr><tr><td style="text-align: left;">{{item.checksheetName}}</td><td style="text-align: right; width: 50%;">{{item.responseUserName}}</td></tr></table></td></tr></tbody><tfoot><tr><td colspan="4" class="text-left"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="10"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/checkreport/sp/checkreportResultListSp.html','<div class="modal-content" style="margin: 66px 0px 0px;"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u4F5C\u696D</h4></div><div class="modal-body text-left"><h5>{{ticket.checksheetName}}</h5><h6 ng-if="ticket.frequency != \'\' && ticket.frequency != null">{{ticket.frequency}}</h6><ul class="dropdownSp"><li ng-repeat="item in checkresultList"><button type="button" ng-click="getCheckreportDetailSp($index+1, false);$dismiss()" class="success" ng-if="item.checkResult != \'3\' && item.checkResult != \'\' && item.checkResult != null"><span style="overflow: hidden; width: 94%; display: inline-block;text-overflow: ellipsis;">{{$index+1}}\uFF0E{{item.checklistName}}</span></button> <button type="button" ng-click="getCheckreportDetailSp($index+1, false);$dismiss()" class="alart" ng-if="item.checkResult == \'3\' || item.checkResult == \'\' || item.checkResult == null"><span style="overflow: hidden; width: 94%; display: inline-block;text-overflow: ellipsis;">{{$index+1}}\uFF0E{{item.checklistName}}</span></button></li></ul><uib-accordion ng-if="checkListFileList.length > 0"><uib-accordion-group heading="\u95A2\u9023\u30D5\u30A1\u30A4\u30EB" panel-class="panel-info bootstrap-panel accordion-panel" style="text-align: center;" is-open="true"><div ng-include="\'app/pages/checkreport/sp/checkListFileListSp.html\'"></div></uib-accordion-group></uib-accordion></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/checkreport/sp/checkreportSp.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="sp-panel" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u8A73\u7D30\uFF08ID\uFF1A{{$root.padLeft(reportId, 8)}}\uFF09" id="checkreportDetailSp" style="display: block; padding :0;"><div ng-include="\'app/pages/checkreport/sp/checkreportDetailSp.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="sp-panel" ba-panel-title="\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u65B0\u898F" id="checkreportCreaterSp" style="display: none; padding :0;"><div ng-include="\'app/pages/checkreport/sp/checkreportCreaterSp.html\'"></div></div></div></div>');
$templateCache.put('app/pages/checkreport/sp/checkreportTargetFileListSp.html','<div class="horizontal-scroll" ng-if="targetFileList.length > 0" style="border-top: 1px solid rgba(0, 0, 0, 0.12);margin-top:10px;"><table class="table" st-table="fileListCopy" st-safe-src="targetFileList" st-set-filter="customFilter" st-filtered-collection="stFilteredCollection"><thead><tr class="sortable"><th style="text-align:left" st-sort="fileName">\u30D5\u30A1\u30A4\u30EB\u540D</th></tr><tr><th><select st-search="fileName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'fileName\'" value="{{item.fileName}}">{{item.fileName}}</option></select></th></tr></thead><tbody><tr ng-repeat="item in fileListCopy"><td style="white-space: nowrap; width: 30%" class="table-id"><a href="javascript:;" ng-click="downLoadFile(item);">{{item.fileName}}</a> <button ng-show="isImg(item.fileName)" class="editable-table-button btn btn-xs" style="background-color: white;border:Gainsboro solid thin;width: 40px; color:#d45a00" ng-click="previewImage(item)"><i class="material-icons">open_in_new</i></button></td></tr></tbody><tfoot><tr><td colspan="14" class="text-left"></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/checkreport/sp/checkreportTargetInfoSp.html','<div class="modal-content" style="margin: 66px 0px 0px;"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u5DE5\u4E8B\u60C5\u5831</h4></div><div class="modal-body text-left"><table style="width:100%; margin-bottom: 10px;"><tr ng-repeat="targetItem in itemNameList"><th style="width:30%;">{{targetItem.showName}}\uFF1A</th><td style="width:70%;" ng-show="targetItem.fieldName != \'region\' && targetItem.fieldName != \'prefCd\' && targetItem.fieldName != \'first\' && targetItem.fieldName != \'second\' && targetItem.fieldName != \'third\'">{{ selectedTarget[targetItem.fieldName] }}</td><td style="width:70%;" ng-show="targetItem.fieldName == \'first\'">{{ selectedTarget.firstName }}</td><td style="width:70%;" ng-show="targetItem.fieldName == \'second\'">{{ selectedTarget.secondName }}</td><td style="width:70%;" ng-show="targetItem.fieldName == \'third\'">{{ selectedTarget.thirdName }}</td><td style="width:70%;" ng-show="targetItem.fieldName == \'prefCd\'">{{ selectedTar.pref.label }}</td><td style="width:70%;" ng-show="targetItem.fieldName == \'region\'">{{ selectedTar.reg.label }}</td></tr></table><uib-accordion ng-if="targetFileList.length > 0"><uib-accordion-group heading="\u95A2\u9023\u30D5\u30A1\u30A4\u30EB" panel-class="panel-info bootstrap-panel accordion-panel" style="text-align: center;" is-open="true"><div ng-include="\'app/pages/checkreport/sp/checkreportTargetFileListSp.html\'"></div></uib-accordion-group></uib-accordion></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/checkreport/sp/checkreportTicketInfoSp.html','<div class="modal-content" style="margin: 66px 0px 0px;"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u60C5\u5831</h4></div><div class="modal-body text-left" id="ticketShow" style="display: block;"><div class="form-group" style="padding-top: 30px;"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5BFE\u8C61\u5DE5\u4E8B\uFF1A <span style="padding-left: 10px;">{{ ticket.targetName }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u533A\u5206\uFF1A <span style="padding-left: 10px;">{{ ticket.first }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5927\u9805\u76EE\uFF1A <span style="padding-left: 10px;">{{ ticket.second }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u4E2D\u9805\u76EE\uFF1A <span style="padding-left: 10px;">{{ ticket.third }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5C0F\u9805\u76EE\uFF1A <span style="padding-left: 10px;">{{ ticket.fourth }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u30B9\u30C6\u30FC\u30BF\u30B9\uFF1A <span style="padding-left: 10px;">{{ ticket.statusName }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u958B\u59CB\u65E5(\u4E88\u5B9A)\uFF1A <span style="padding-left: 10px;">{{ ticket.startScheduledDate }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5B8C\u4E86\u65E5(\u4E88\u5B9A)\uFF1A <span style="padding-left: 10px;">{{ ticket.endScheduledDate }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u958B\u59CB\u65E5(\u5B9F\u7E3E)\uFF1A <span style="padding-left: 10px;">{{ ticket.startDate }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5B8C\u4E86\u65E5(\u5B9F\u7E3E)\uFF1A <span style="padding-left: 10px;">{{ ticket.endDate }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u7BA1\u7406\u6280\u8853\u8005\uFF1A <span style="padding-left: 10px;"><a href="javascript:;" ng-click="showUserInfo(ticket.requestUserId);">{{ ticket.requestUserName }}</a></span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u7BA1\u7406\u6280\u8853\u30B0\u30EB\u30FC\u30D7\uFF1A <span style="padding-left: 10px;">{{ ticket.requestGroupName }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u62C5\u5F53\u6280\u8853\u8005\uFF1A <span style="padding-left: 10px;"><a href="javascript:;" ng-click="showUserInfo(ticket.responseUserId);">{{ ticket.responseUserName }}</a></span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u62C5\u5F53\u6280\u8853\u8005\u30B0\u30EB\u30FC\u30D7\uFF1A <span style="padding-left: 10px;">{{ ticket.responseGroupName }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7\uFF1A <span style="padding-left: 10px;">{{ ticket.readingGroupName }}</span></label></div><div class="form-group" ng-if="parentTicket == \'1\'"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u89AA\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\uFF1A <span style="padding-left: 10px;"><a href="javascript:;" ng-click="showCheckreportDetailSpWindow(ticket.parentId);$dismiss();">{{ $root.padLeft(ticket.parentId, 8) }}</a></span></label></div><div class="form-group" ng-if="showStatusDetail"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{statusDetailItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.statusDetail }}</span></label></div><div class="form-group" ng-if="showKbn2"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn2ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.kbn2 }}</span></label></div><div class="form-group" ng-if="showKbn3"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn3ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.kbn3 }}</span></label></div><div class="form-group" ng-if="showKbn4"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn4ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.kbn4 }}</span></label></div><div class="form-group" ng-if="showKbn5"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn5ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.kbn5 }}</span></label></div><div class="form-group" ng-if="showItem1"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item1ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.item1 }}</span></label></div><div class="form-group" ng-if="showItem2"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item2ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.item2 }}</span></label></div><div class="form-group" ng-if="showItem3"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item3ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.item3 }}</span></label></div><div class="form-group" ng-if="showItem4"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item4ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.item4 }}</span></label></div><div class="form-group" ng-if="showItem5"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item5ItemName}}\uFF1A <span style="padding-left: 10px;">{{ ticket.item5 }}</span></label></div><div id="subTickets" ng-if="subTicketList.length > 0 && parentTicket == \'1\'" style="border-top: 1px solid rgba(0, 0, 0, 0.12);"><h4 class="grid-h ng-scope" style="margin-bottom: 10px; margin-top: 20px;">\u30B5\u30D6\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8</h4><table class="table" style="border: none;" st-table="subTicketData" st-safe-src="subTicketList"><tr ng-repeat="item in subTicketData"><td style="border: none; text-align: left; width: 40%;"><a href="javascript:;" ng-click="showCheckreportDetailSpWindow(item.id);$dismiss();">{{$root.padLeft(item.id, 8)}}</a></td><td style="border: none; width: 30%;">{{item.statusName}}</td><td style="border: none; width: 30%;">{{item.responseUserName}}</td></tr></table></div></div><div class="modal-footer" id="ticketShowFooter" style="display: block;"><div style="position: absolute; top: 63px; left: 5px;"><button ng-if="isEditer && (ticket.statusId == \'01\' || ticket.statusId == \'02\' || ticket.statusId == \'99\')" type="button" class="btn btn-info" ng-click="offLineTicket()">\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</button></div><div style="position: absolute; top: 63px; right: 5px;"><button ng-if="isEditer" type="button" class="btn btn-info" ng-click="copyTicketSp()">\u30B3\u30D4\u30FC</button> <button ng-if="isEditer" type="button" class="btn btn-primary" ng-click="showTicketEditor()">\u7DE8\u96C6</button></div></div><div class="modal-body text-left" id="ticketEditor" style="display: none;"><div class="form-group" style="padding-top: 30px;"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5BFE\u8C61\u5DE5\u4E8B\uFF1A</label><br><span style="padding-left: 10px;">{{ ticket.targetName }}</span></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u533A\u5206\uFF1A <span style="padding-left: 10px;">{{ ticket.first }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5927\u9805\u76EE\uFF1A <span style="padding-left: 10px;">{{ ticket.second }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u4E2D\u9805\u76EE\uFF1A <span style="padding-left: 10px;">{{ ticket.third }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5C0F\u9805\u76EE\uFF1A <span style="padding-left: 10px;">{{ ticket.fourth }}</span></label></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u30B9\u30C6\u30FC\u30BF\u30B9\uFF1A</label><br><span style="padding-left: 10px;">{{ ticket.statusName }}</span></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u958B\u59CB\u65E5(\u4E88\u5B9A)\uFF1A</label><p class="input-group" style="margin: 0;border-collapse: collapse;" ng-controller="datepickerpopupCtrl"><input ng-disabled="isVisitor" ng-model="ctrl.startScheduledDate" type="text" placeholder="" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5B8C\u4E86\u65E5(\u4E88\u5B9A)\uFF1A</label><p class="input-group" style="margin: 0;border-collapse: collapse;" ng-controller="datepickerpopupCtrl"><input ng-disabled="isVisitor" ng-model="ctrl.endScheduledDate" type="text" placeholder="" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u958B\u59CB\u65E5(\u5B9F\u7E3E)\uFF1A</label><br><span style="padding-left: 10px;">{{ ticket.startDate }}</span></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u5B8C\u4E86\u65E5(\u5B9F\u7E3E)\uFF1A</label><br><span style="padding-left: 10px;">{{ ticket.endDate }}</span></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u6307\u793A\u8005\uFF1A</label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.requestUser" ng-options="item as item.userNameId for item in userList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u6307\u793A\u30B0\u30EB\u30FC\u30D7\uFF1A</label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.requestGroup" ng-options="item as item.groupNameId for item in groupList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u62C5\u5F53\u6280\u8853\u8005\uFF1A</label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.responseUser" ng-options="item as item.userNameId for item in userList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u62C5\u5F53\u6280\u8853\u8005\u30B0\u30EB\u30FC\u30D7\uFF1A</label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.responseGroup" ng-options="item as item.groupNameId for item in groupList"></select></div><div class="form-group"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u95B2\u89A7\u30B0\u30EB\u30FC\u30D7\uFF1A</label><ui-select multiple="" ng-model="readingGroups.selected" ng-disabled="isVisitor" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="">{{$item.groupNameId}}</ui-select-match><ui-select-choices repeat="readingGroups in groupList | filter: $select.search">{{readingGroups.groupNameId}}</ui-select-choices></ui-select></div><div class="form-group" ng-if="parentTicket == \'1\'"><label style="font-size: 14px; font-weight: 400; color:#666666;">\u89AA\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\uFF1A</label><br><span style="padding-left: 10px;"><a href="javascript:;" ng-click="showCheckreportDetailSpWindow(ticket.parentId);$dismiss();">{{ $root.padLeft(ticket.parentId, 8) }}</a></span></div><div class="form-group" ng-if="showStatusDetail"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{statusDetailItemName}}\uFF1A <label ng-if="mustStatusDetail" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.statusDetailOb" ng-options="item as item.label for item in statusDetailList"></select></div><div class="form-group" ng-if="showKbn2"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn2ItemName}}\uFF1A <label ng-if="mustKbn2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select></div><div class="form-group" ng-if="showKbn3"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn3ItemName}}\uFF1A <label ng-if="mustKbn3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select></div><div class="form-group" ng-if="showKbn4"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn4ItemName}}\uFF1A <label ng-if="mustKbn4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select></div><div class="form-group" ng-if="showKbn5"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{kbn5ItemName}}\uFF1A <label ng-if="mustKbn5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label><select class="form-control selectpicker with-search" data-live-search="true" title="" ng-disabled="isVisitor" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></div><div class="form-group" ng-if="showItem1"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item1ItemName}}\uFF1A <label ng-if="mustItem1" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item1" maxlength="256" ng-disabled="isVisitor"></div><div class="form-group" ng-if="showItem2"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item2ItemName}}\uFF1A <label ng-if="mustItem2" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item2" maxlength="256" ng-disabled="isVisitor"></div><div class="form-group" ng-if="showItem3"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item3ItemName}}\uFF1A <label ng-if="mustItem3" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item3" maxlength="256" ng-disabled="isVisitor"></div><div class="form-group" ng-if="showItem4"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item4ItemName}}\uFF1A <label ng-if="mustItem4" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item4" maxlength="256" ng-disabled="isVisitor"></div><div class="form-group" ng-if="showItem5"><label style="font-size: 14px; font-weight: 400; color:#666666;">{{item5ItemName}}\uFF1A <label ng-if="mustItem5" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></label> <input type="text" class="form-control" ng-model="ctrl.item5" maxlength="256" ng-disabled="isVisitor"></div><div id="subTickets" ng-if="subTicketList.length > 0 && parentTicket == \'1\'" style="border-top: 1px solid rgba(0, 0, 0, 0.12);"><h4 class="grid-h ng-scope" style="margin-bottom: 10px; margin-top: 20px;">\u30B5\u30D6\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8</h4><table class="table" style="border: none;" st-table="subTicketData" st-safe-src="subTicketList"><tr ng-repeat="item in subTicketData"><td style="border: none; text-align: left; width: 40%;"><a href="javascript:;" ng-click="showCheckreportDetailSpWindow(item.id);$dismiss();">{{$root.padLeft(item.id, 8)}}</a></td><td style="border: none; width: 30%;">{{item.statusName}}</td><td style="border: none; width: 30%;">{{item.responseUserName}}</td></tr></table></div></div><div class="modal-footer" id="ticketEditorFooter" style="display: none;"><button ng-if="isEditer" type="button" class="btn btn-info" ng-click="modifyTicketSp()">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button><div style="position: absolute; top: 63px; left: 5px;" ng-if="(mngFlg == \'1\' || mngFlg ==\'2\' ) && (ticket.statusId == \'03\' || ticket.statusId == \'04\' || ticket.statusId == \'05\')"><button ng-if="ticket.statusId == \'03\'" type="button" class="btn btn-primary" ng-click="modifyStatus(\'04\')">\u627F\u8A8D</button> <button ng-if="mngFlg ==\'2\' && ticket.statusId == \'04\' && finalApproval ==\'1\'" type="button" class="btn btn-primary" ng-click="modifyStatus(\'05\')">\u6700\u7D42\u627F\u8A8D</button> <button type="button" class="btn btn-primary" ng-click="modifyStatus(\'99\')">\u5DEE\u623B\u3057</button></div><div style="position: absolute; top: 63px; right: 5px;"><button ng-if="isEditer && !notEditable && parentTicket == \'1\'" type="button" class="btn btn-info" ng-click="showCheckreportCreateSp(ticket.id, ticket.targetId);$dismiss();">\u30B5\u30D6\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8</button> <button ng-if="isRequester" type="button" class="btn btn-danger" ng-click="CheckreportDeleteSp();">\u524A\u9664</button></div></div></div>');
$templateCache.put('app/pages/checkreport/sp/imgOrderSp.html','<div class="modal-content"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u5199\u771F\u306E\u4E26\u3079\u66FF\u3048</h4></div><div class="modal-body text-left"><h5>\u5199\u771F\u3092\u9577\u62BC\u3057\u3057\u3001\u4E0A\u4E0B\u306B\u30B9\u30EF\u30A4\u30D7\u3059\u308B\u3053\u3068\u3067\u4E26\u3079\u66FF\u3048\u3089\u308C\u307E\u3059\u3002</h5><ul class="todo-list" ui-sortable="sortableOptions" ng-model="imgOrderList"><li class="list" ng-repeat="item in imgOrderList" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false" id="id{{::item.no}}" style="padding: 3px; height: initial;"><table class="checklist-table"><tr><td style="width:30px"><span class="cut-with-dots">{{ item.no }}</span></td><td><img ng-src="{{item.url}}" alt="" title="" style="width:100%"></td></tr></table></li></ul></div><div class="modal-footer"><button type="button" class="btn btn-info" click-and-disable="saveImgOrder()">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/checkreport/sp/newCheckTargetSp.html','<div class="modal-content" style="margin: 66px 0px 0px;"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u5DE5\u4E8B\u60C5\u5831</h4></div><div class="modal-body text-left"><table class="table table-bordered" style="border: none; border-collapse:separate; border-spacing:0px 10px;"><tbody><tr ng-repeat="targetItem in itemNameList"><th style="width:25%">{{targetItem.showName}}\uFF1A <label ng-if="targetItem.fieldName == \'targetName\' || targetItem.isShow == \'3\'" style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label></th><td style="border: none; width:35%"><input ng-show="targetItem.fieldName != \'kbn1\' && targetItem.fieldName != \'kbn2\' && targetItem.fieldName != \'kbn3\' && targetItem.fieldName != \'kbn4\' && targetItem.fieldName != \'kbn5\' && targetItem.fieldName != \'first\' && targetItem.fieldName != \'second\' && targetItem.fieldName != \'third\'" type="text" class="form-control" id="{{targetItem.fieldName}}"><select ng-show="targetItem.fieldName == \'first\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.first" ng-disabled="firstDisable" ng-change="changeFirst()" ng-options="item as item.label for item in firstList"></select><select ng-show="targetItem.fieldName == \'second\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.second" ng-disabled="secondDisable" ng-change="changeSecond()" ng-options="item as item.label for item in secondList"></select><select ng-show="targetItem.fieldName == \'third\'" class="form-control selectpicker" selectpicker="" ng-model="ctrl.third" ng-disabled="thirdDisable" ng-options="item as item.label for item in thirdList"></select><select ng-show="targetItem.fieldName == \'kbn1\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn1Ob" ng-options="item as item.label for item in kbn1List"></select><select ng-show="targetItem.fieldName == \'kbn2\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn2Ob" ng-options="item as item.label for item in kbn2List"></select><select ng-show="targetItem.fieldName == \'kbn3\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn3Ob" ng-options="item as item.label for item in kbn3List"></select><select ng-show="targetItem.fieldName == \'kbn4\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn4Ob" ng-options="item as item.label for item in kbn4List"></select><select ng-show="targetItem.fieldName == \'kbn5\'" class="form-control selectpicker with-search" data-live-search="true" title="" selectpicker="" ng-model="ctrl.kbn5Ob" ng-options="item as item.label for item in kbn5List"></select></td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="createCheckTarget()">\u4FDD\u5B58</button></div></div>');
$templateCache.put('app/pages/checkreport/sp/userInfoSp.html','<div class="modal-content" style="margin: 66px 0px 0px;"><div class="modal-header bg-warning"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u6280\u8853\u8005\u60C5\u5831</h4></div><div class="modal-body"><form name="myForm"><div class="form-group"><label>\u6280\u8853\u8005ID</label><br><h4 style="margin-left: 5px;">{{userInfo.userId}}</h4></div><div class="form-group"><label for="userName">\u6280\u8853\u8005\u540D</label><br><h4 style="margin-left: 5px;">{{userInfo.userName}}</h4></div><div class="form-group"><label>\u6240\u5C5E\u4F1A\u793E</label><br><h4 style="margin-left: 5px;">{{userInfo.comName}}</h4></div><div class="form-group"><label for="orgName">\u6240\u5C5E\u7D44\u7E54</label><br><h4 style="margin-left: 5px;">{{userInfo.organization}}</h4></div><div class="form-group"><label for="tel">\u96FB\u8A71\u756A\u53F7</label><br><h4 style="margin-left: 5px;" ng-if="userInfo.tel != \'\' && userInfo.tel != null"><a href="tel:{{userInfo.tel}}">{{userInfo.tel}}</a></h4><h4 style="margin-left: 5px;" ng-if="userInfo.tel == \'\' || userInfo.tel == null"></h4></div><div class="form-group"><label for="email">\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9</label><br><h4 style="margin-left: 5px;" ng-if="userInfo.mailAdd != \'\' && userInfo.mailAdd != null"><a href="mailto:{{userInfo.mailAdd}}">{{userInfo.mailAdd}}</a></h4><h4 style="margin-left: 5px;" ng-if="userInfo.mailAdd == \'\' || userInfo.mailAdd == null"></h4></div><div class="form-group"><label>\u6A29\u9650</label><br><h4 style="margin-left: 5px;">{{userInfo.mngFlagName}}</h4></div><div class="form-group"><label for="group">\u6240\u5C5E\u30B0\u30EB\u30FC\u30D7</label><br><h4 style="margin-left: 5px;">{{userInfo.groupName}}</h4></div><div class="form-group"><label for="status">\u30A2\u30AB\u30A6\u30F3\u30C8\u30ED\u30C3\u30AF</label><br><h4 style="margin-left: 5px;">{{userInfo.accountLockStr}}</h4></div></form></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">\u9589\u3058\u308B</button></div></div>');
$templateCache.put('app/pages/home/commentShow/commentShow.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( \'sp_logo\'| profilePicture)}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span><br><span class="author">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8ID\uFF1A<a href="">00000007</a></span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/home/trafficChart/trafficChart.html','<div style="padding-bottom: 20px;"><table style="border-collapse: separate; border-spacing: 0px 5px;"><tr><td style="width: 95px;">\u5B8C\u4E86\u65E5(\u4E88\u5B9A)\uFF1A</td><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-change="getTicketNum()" ng-model="ctrl.eScheduledDateS" type="text" placeholder="FROM" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td><td>&nbsp;&nbsp;\uFF5E&nbsp;&nbsp;</td><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-change="getTicketNum()" ng-model="ctrl.eScheduledDateE" type="text" placeholder="TO" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td></tr></table><table><tr><td style="width: 70px;">\u30B0\u30EB\u30FC\u30D7\uFF1A</td><td style="border: none;width: 130px;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.responseGroup" ng-change="changeResponseGroup()" ng-options="item as item.groupName for item in groupList"></select></td><td ng-if="! (mngKbn == \'0\' && adminMng != \'1\')" style="width: 70px; padding-left: 10px;">\u6280\u8853\u8005\uFF1A</td><td ng-if="! (mngKbn == \'0\' && adminMng != \'1\')" style="border: none;width: 130px;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.responseUser" ng-change="changeResponseUser()" ng-options="item as item.userName for item in userList"></select></td></tr></table><table style="border-collapse: separate; border-spacing: 0px 5px;" ng-if="showFist"><tr><td>{{targetFirstItemName}}\uFF1A</td><td style="border: none;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.first" ng-disabled="firstDisable" ng-change="changeFirst()" ng-options="item as item.label for item in firstList"></select></td></tr><tr><td ng-if="showSecond">{{targetSecondItemName}}\uFF1A</td><td style="border: none;" ng-if="showSecond"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.second" ng-disabled="secondDisable" ng-change="changeSecond()" ng-options="item as item.label for item in secondList"></select></td></tr><tr><td ng-if="showThird">{{targetThirdItemName}}\uFF1A</td><td style="border: none;" ng-if="showThird"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.third" ng-disabled="thirdDisable" ng-change="changeThird()" ng-options="item as item.label for item in thirdList"></select></td></tr></table></div><div class="channels-block"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder" id="canvas-holder"><canvas id="chart-area"></canvas><div class="traffic-text"><span style="font-size: 28px;padding-top: 10px;" id="allNum"></span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p ng-if="pList[i] != 0"><a href="javascript:;" ng-click="showTicket(id[i])">{{::label}}</a><span class="channel-number">{{pList[i]}}%</span></p><p ng-if="pList[i] == 0">{{::label}}<span class="channel-number">{{pList[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/home/trafficChart/trafficChartSp.html','<div style="padding-bottom: 20px;"><table style="border-collapse: separate; border-spacing: 0px 5px;"><tr><td rowspan="3" style="width: 35%;">\u5B8C\u4E86\u65E5(\u4E88\u5B9A)\uFF1A</td><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-change="getTicketNum()" ng-model="ctrl.eScheduledDateS" type="text" placeholder="FROM" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td></tr><tr><td colspan="2">\uFF5E</td></tr><tr><td style="border: none;" ng-controller="datepickerpopupCtrl"><p class="input-group" style="margin: 0;border-collapse: collapse;"><input ng-change="getTicketNum()" ng-model="ctrl.eScheduledDateE" type="text" placeholder="TO" ng-focus="open()" ng-click="open()" class="form-control" uib-datepicker-popup="yyyy/MM/dd" datepicker-options="options" is-open="opened" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="open()"><i class="material-icons">calendar_today</i></button></span></p></td></tr><tr><td>\u30B0\u30EB\u30FC\u30D7\uFF1A</td><td style="border: none;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.responseGroup" ng-change="changeResponseGroup()" ng-options="item as item.groupName for item in groupList"></select></td></tr><tr ng-if="! (mngKbn == \'0\' && adminMng != \'1\')"><td>\u6280\u8853\u8005\uFF1A</td><td style="border: none;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.responseUser" ng-change="changeResponseUser()" ng-options="item as item.userName for item in userList"></select></td></tr><tr ng-if="showFist"><td>{{targetFirstItemName}}\uFF1A</td><td style="border: none;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.first" ng-disabled="firstDisable" ng-change="changeFirst()" ng-options="item as item.label for item in firstList"></select></td></tr><tr ng-if="showSecond"><td>{{targetSecondItemName}}\uFF1A</td><td style="border: none;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.second" ng-disabled="secondDisable" ng-change="changeSecond()" ng-options="item as item.label for item in secondList"></select></td></tr><tr ng-if="showThird"><td>{{targetThirdItemName}}\uFF1A</td><td style="border: none;"><select class="form-control selectpicker" selectpicker="" ng-model="ctrl.third" ng-disabled="thirdDisable" ng-change="changeThird()" ng-options="item as item.label for item in thirdList"></select></td></tr></table></div><div class="channels-block"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder" id="canvas-holder"><canvas id="chart-area" width="200" height="200"></canvas><div class="traffic-text"><span style="font-size: 28px;padding-top: 10px;" id="allNum"></span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p ng-if="pList[i] != 0"><a href="javascript:;" ng-click="showTicket(id[i])">{{::label}}</a><span class="channel-number">{{pList[i]}}%</span></p><p ng-if="pList[i] == 0">{{::label}}<span class="channel-number">{{pList[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/user/group/group.html','<div style="position: absolute; top: 5px; right: 20px;"><button type="button" class="btn btn-info" ng-click="showCreateGroup()">\u65B0\u898F</button></div><div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [20,50,100,200]"></select></label></div><table class="table" st-table="groupListCopy" st-safe-src="groupList" st-filtered-collection="stFilteredCollection"><thead><tr><td><div style="position: absolute; top: 75px; right: 20px;"><a class="btn btn-warning" ng-click="downloadGroup()" style="background: #209e91; border-color: #209e91;">\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a> <button type="file" ngf-select="uploadGroup($file)" class="btn btn-info" accept=".csv, text/csv" ngf-max-size="10MB">\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</button></div></td></tr><tr class="sortable"><th style="width: 2%" class="table-id">#</th><th style="width: 10%" st-sort="groupIdShow">\u30B0\u30EB\u30FC\u30D7ID</th><th style="width: 10%" st-sort="groupName">\u30B0\u30EB\u30FC\u30D7\u540D</th><th style="width: 30%" st-sort="userName">\u542B\u3080\u6280\u8853\u8005</th><th style="width: 10%" st-sort="address" ng-if="userOrder == \'1\'">\u4F4F\u6240</th><th style="width: 5%" st-sort="lat" ng-if="userOrder == \'1\'">\u7DEF\u5EA6</th><th style="width: 5%" st-sort="lng" ng-if="userOrder == \'1\'">\u7D4C\u5EA6</th><th style="width: 8%">\u64CD\u4F5C</th></tr><tr><th></th><th><select st-search="groupIdShow" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'groupIdShow\'" value="{{item.groupIdShow}}">{{item.groupIdShow}}</option></select></th><th><select st-search="groupName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'groupName\'" value="{{item.groupName}}">{{item.groupName}}</option></select></th><th><select st-search="userName" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'userName\'" value="{{item.userName}}">{{item.userName}}</option></select></th><th ng-if="userOrder == \'1\'"><select st-search="address" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'address\'" value="{{item.address}}">{{item.address}}</option></select></th><th ng-if="userOrder == \'1\'"><select st-search="lat" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'lat\'" value="{{item.lat}}">{{item.lat}}</option></select></th><th ng-if="userOrder == \'1\'"><select st-search="lng" class="form-control"><option value="">\u5168\u3066</option><option ng-repeat="item in stFilteredCollection | unique:\'lng\'" value="{{item.lng}}">{{item.lng}}</option></select></th><th></th></tr></thead><tbody><tr ng-repeat="item in groupListCopy"><td class="table-id" ng-dblclick="showModifyGroup(item)">{{$index + 1}}</td><td ng-dblclick="showModifyGroup(item)">{{item.groupIdShow}}</td><td style="white-space: nowrap; text-decoration: underline !important;"><a href="javascript:;" ng-click="showModifyGroup(item)">{{ item.groupName }}</a></td><td ng-dblclick="showModifyGroup(item)">{{item.userName}}</td><td ng-if="userOrder == \'1\'" ng-dblclick="showModifyGroup(item)">{{item.address}}</td><td ng-if="userOrder == \'1\'" ng-dblclick="showModifyGroup(item)">{{item.lat}}</td><td ng-if="userOrder == \'1\'" ng-dblclick="showModifyGroup(item)">{{item.lng}}</td><td><button type="button" class="status-button btn btn-xs btn-danger" ng-click="removeGroup(item.groupId);">\u524A\u9664</button></td></tr></tbody><tfoot><tr><td colspan="12" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/user/group/groupStatus.html','<div class="modal-content"><div class="modal-header bg-warning" style="background-color:#ffaf0d;"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u8A73\u7D30\u8A2D\u5B9A</h4></div><div class="modal-body"><table><tr><td>\u8868\u793A\u3059\u308B\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u306E\u30B9\u30C6\u30FC\u30BF\u30B9\uFF1A</td></tr><tr><td style="padding-top: 5px;"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="01" ng-model="ctrl.status01"> <span>{{ $root.getStatusShowName(\'01\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="02" ng-model="ctrl.status02"> <span>{{ $root.getStatusShowName(\'02\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="03" ng-model="ctrl.status03"> <span>{{ $root.getStatusShowName(\'03\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="04" ng-model="ctrl.status04"> <span>{{ $root.getStatusShowName(\'04\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="05" ng-model="ctrl.status05"> <span>{{ $root.getStatusShowName(\'05\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="99" ng-model="ctrl.status99"> <span>{{ $root.getStatusShowName(\'99\') }}</span></label></td></tr></table></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="saveGroupStatus()">\u4FDD\u5B58</button></div></div>');
$templateCache.put('app/pages/user/group/modifyGroup.html','<div class="modal-content"><div class="modal-header bg-warning" style="background-color:#ffaf0d;"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30B0\u30EB\u30FC\u30D7\u7DE8\u96C6</h4></div><div class="modal-body"><div style="background-color: rgba(232, 86, 86, 0.85); color:white" class="alert bg-danger" id="showdiv" ng-if="error">{{errCd + ":" + errMsg}}</div><form name="myForm" novalidate=""><div class="form-group"><label for="groupIdShow">\u30B0\u30EB\u30FC\u30D7ID</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <input type="text" class="form-control" id="groupIdShow" name="groupIdShow" placeholder="\u30B0\u30EB\u30FC\u30D7ID" ng-model="currentGroup.groupIdShow" required="" ng-maxlength="32" ng-pattern="/^[a-zA-Z0-9]{1,32}$/"> <span style="color:red" ng-if="myForm.groupIdShow.$invalid && (myForm.groupIdShow.$dirty)">32\u6841\u4EE5\u5185\u306E\u534A\u89D2\u82F1\u5B57\u3001\u6570\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="groupName">\u30B0\u30EB\u30FC\u30D7\u540D</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <input type="text" class="form-control" id="groupName" name="groupName" placeholder="\u30B0\u30EB\u30FC\u30D7\u540D" ng-model="currentGroup.groupName" required="" ng-maxlength="50" ng-pattern="/^[\uFF01\u201D\uFF03\uFF04\uFF05\uFF06\u2019\uFF08\uFF09\uFF0A\uFF0B\uFF0C\uFF0D\uFF0E\uFF0F\uFF1A\uFF1B\uFF1C\uFF1D\uFF1E\uFF1F\uFF20\uFF3B\uFFE5\uFF3D\uFF3E\uFF3F\u2018\uFF5B\uFF5C\uFF5D\uFFE3\u3001\u3002\u30FB\u309B\u309C\xB4\uFF40\xA8\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF3C\uFF5E\u301C\u2225\u2026\u2025\u201C\u3014\u3015\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3010\u3011\xB1\xD7\xF7\u2260\u2266\u2267\u221E\u2234\u2642\u2640\xB0\u2032\u2033\u2103\uFFE0\uFFE1\xA7\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A0-9a-zA-Z\u3041-\u3093\u30A1-\u30F6\u4E00-\u9FA0\u3005\u30FC\\x20 ]{1,50}$/"> <span style="color: red" ng-if="myForm.groupName.$error.pattern && (myForm.groupName.$dirty)">\u6F22\u5B57\u3001\u3072\u3089\u304C\u306A\u3001\u30AB\u30BF\u30AB\u30CA\u3001\u30B9\u30DA\u30FC\u30B9\u3001\u534A\u89D2\u6570\u5B57\u3001\u534A\u89D2\u82F1\u5B57\u306E\u307F\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span> <span style="color: red" ng-if="myForm.groupName.$error.required && (myForm.groupName.$dirty)">\u30B0\u30EB\u30FC\u30D7\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span> <span style="color: red" ng-if="myForm.groupName.$error.maxlength && (myForm.groupName.$dirty)">50\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userOrder == \'1\'"><label for="address">\u4F4F\u6240</label> <input type="text" class="form-control" id="address" name="address" placeholder="\u4F4F\u6240" ng-model="currentGroup.address" ng-maxlength="256"> <span style="color:red" ng-if="myForm.address.$invalid && (myForm.address.$dirty)">256\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userOrder == \'1\'"><label for="lat">\u7DEF\u5EA6</label> <input type="text" class="form-control" id="lat" name="lat" placeholder="\u7DEF\u5EA6" ng-model="currentGroup.lat" ng-maxlength="32"> <span style="color:red" ng-if="myForm.lat.$invalid && (myForm.lat.$dirty)">32\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userOrder == \'1\'"><label for="lng">\u7D4C\u5EA6</label> <input type="text" class="form-control" id="lng" name="lng" placeholder="\u7D4C\u5EA6" ng-model="currentGroup.lng" ng-maxlength="32"> <span style="color:red" ng-if="myForm.lng.$invalid && (myForm.lng.$dirty)">32\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="user">\u542B\u3080\u6280\u8853\u8005</label><ui-select id="user" multiple="" ng-model="selectedUsers.selected" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="Group Select">{{$item.userName + "(" + $item.userId + ")"}}</ui-select-match><ui-select-choices repeat="selectedUsers in userList | filter: $select.search">{{selectedUsers.userName + "(" + selectedUsers.userId + ")"}}</ui-select-choices></ui-select></div></form><div style="text-align: center;"><a href="javascript:;" ng-click="showDetailSetting();">\u8A73\u7D30\u8A2D\u5B9A&nbsp; <i ng-if="! showGroupDetail" class="ion-arrow-down-b"></i> <i ng-if="showGroupDetail" class="ion-arrow-up-b"></i></a></div><div class="form-group" ng-if="showGroupDetail"><label for="lat">\u8868\u793A\u3059\u308B\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u306E\u30B9\u30C6\u30FC\u30BF\u30B9</label><p class="input-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="01" ng-model="ctrl.status01"> <span>{{ $root.getStatusShowName(\'01\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="02" ng-model="ctrl.status02"> <span>{{ $root.getStatusShowName(\'02\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="03" ng-model="ctrl.status03"> <span>{{ $root.getStatusShowName(\'03\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="04" ng-model="ctrl.status04"> <span>{{ $root.getStatusShowName(\'04\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="05" ng-model="ctrl.status05"> <span>{{ $root.getStatusShowName(\'05\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="99" ng-model="ctrl.status99"> <span>{{ $root.getStatusShowName(\'99\') }}</span></label></p></div></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="modifyGroup(myForm)" ng-disabled="!myForm.$valid">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/user/group/newGroup.html','<div class="modal-content"><div class="modal-header bg-warning" style="background-color:#ffaf0d;"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u30B0\u30EB\u30FC\u30D7\u767B\u9332</h4></div><div class="modal-body"><div style="background-color: rgba(232, 86, 86, 0.85); color:white" class="alert bg-danger" id="showdiv" ng-if="error">{{errCd + ":" + errMsg}}</div><form name="myForm" novalidate=""><div class="form-group"><label for="groupId">\u30B0\u30EB\u30FC\u30D7ID</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <input type="text" class="form-control" id="groupId" name="groupId" placeholder="\u30B0\u30EB\u30FC\u30D7ID" ng-model="groupId" required="" ng-maxlength="32" ng-pattern="/^[a-zA-Z0-9]{1,32}$/"> <span style="color:red" ng-if="myForm.groupId.$invalid && (myForm.groupId.$dirty)">32\u6841\u4EE5\u5185\u306E\u534A\u89D2\u82F1\u5B57\u3001\u6570\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="groupName">\u30B0\u30EB\u30FC\u30D7\u540D</label> <label style="line-height: 1.8;font-weight: 400;color: #FFF;background: #ffaf0d;text-align: center;vertical-align: 1px;display: inline-block;width: 50px;">\u5FC5\u9808</label> <input type="text" class="form-control" id="groupName" name="groupName" placeholder="\u30B0\u30EB\u30FC\u30D7\u540D" ng-model="groupName" required="" ng-maxlength="128" ng-pattern="/^[\uFF01\u201D\uFF03\uFF04\uFF05\uFF06\u2019\uFF08\uFF09\uFF0A\uFF0B\uFF0C\uFF0D\uFF0E\uFF0F\uFF1A\uFF1B\uFF1C\uFF1D\uFF1E\uFF1F\uFF20\uFF3B\uFFE5\uFF3D\uFF3E\uFF3F\u2018\uFF5B\uFF5C\uFF5D\uFFE3\u3001\u3002\u30FB\u309B\u309C\xB4\uFF40\xA8\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF3C\uFF5E\u301C\u2225\u2026\u2025\u201C\u3014\u3015\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3010\u3011\xB1\xD7\xF7\u2260\u2266\u2267\u221E\u2234\u2642\u2640\xB0\u2032\u2033\u2103\uFFE0\uFFE1\xA7\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A0-9a-zA-Z\u3041-\u3093\u30A1-\u30F6\u4E00-\u9FA0\u3005\u30FC\\x20 ]{1,50}$/"> <span style="color: red" ng-if="myForm.groupName.$error.pattern && (myForm.groupName.$dirty)">\u6F22\u5B57\u3001\u3072\u3089\u304C\u306A\u3001\u30AB\u30BF\u30AB\u30CA\u3001\u30B9\u30DA\u30FC\u30B9\u3001\u534A\u89D2\u6570\u5B57\u3001\u534A\u89D2\u82F1\u5B57\u306E\u307F\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span> <span style="color: red" ng-if="myForm.groupName.$error.required && (myForm.groupName.$dirty)">\u30B0\u30EB\u30FC\u30D7\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span> <span style="color: red" ng-if="myForm.groupName.$error.maxlength && (myForm.groupName.$dirty)">128\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userOrder == \'1\'"><label for="address">\u4F4F\u6240</label> <input type="text" class="form-control" id="address" name="address" placeholder="\u4F4F\u6240" ng-model="address" ng-maxlength="256"> <span style="color:red" ng-if="myForm.address.$invalid && (myForm.address.$dirty)">256\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userOrder == \'1\'"><label for="lat">\u7DEF\u5EA6</label> <input type="text" class="form-control" id="lat" name="lat" placeholder="\u7DEF\u5EA6" ng-model="lat" ng-maxlength="32"> <span style="color:red" ng-if="myForm.lat.$invalid && (myForm.lat.$dirty)">32\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group" ng-if="userOrder == \'1\'"><label for="lng">\u7D4C\u5EA6</label> <input type="text" class="form-control" id="lng" name="lng" placeholder="\u7D4C\u5EA6" ng-model="lng" ng-maxlength="32"> <span style="color:red" ng-if="myForm.lng.$invalid && (myForm.lng.$dirty)">32\u6841\u6570\u4EE5\u5185\u306E\u6587\u5B57\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002</span></div><div class="form-group"><label for="user">\u542B\u3080\u6280\u8853\u8005</label><ui-select id="user" multiple="" ng-model="selectedUsers.selected" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="\u542B\u3080\u6280\u8853\u8005">{{$item.userName + "(" + $item.userId + ")"}}</ui-select-match><ui-select-choices repeat="selectedUsers in userList | filter: $select.search">{{selectedUsers.userName + "(" + selectedUsers.userId + ")"}}</ui-select-choices></ui-select></div></form><div style="text-align: center;"><a href="javascript:;" ng-click="showDetailSetting();">\u8A73\u7D30\u8A2D\u5B9A&nbsp; <i ng-if="! showGroupDetail" class="ion-arrow-down-b"></i> <i ng-if="showGroupDetail" class="ion-arrow-up-b"></i></a></div><div class="form-group" ng-if="showGroupDetail"><label for="lat">\u8868\u793A\u3059\u308B\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u306E\u30B9\u30C6\u30FC\u30BF\u30B9</label><p class="input-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="01" ng-model="ctrl.status01"> <span>{{ $root.getStatusShowName(\'01\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="02" ng-model="ctrl.status02"> <span>{{ $root.getStatusShowName(\'02\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="03" ng-model="ctrl.status03"> <span>{{ $root.getStatusShowName(\'03\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="04" ng-model="ctrl.status04"> <span>{{ $root.getStatusShowName(\'04\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="05" ng-model="ctrl.status05"> <span>{{ $root.getStatusShowName(\'05\') }}</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" value="99" ng-model="ctrl.status99"> <span>{{ $root.getStatusShowName(\'99\') }}</span></label></p></div></div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="saveNewGroup(myForm)" ng-disabled="!myForm.$valid">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="material-icons back-top" id="backTop" title="Back to Top" style="font-size: 50px !important;">keyboard_arrow_up</i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar-sp.html','<aside style="top: 50px;" class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && $root.isMoblie && item.stateRef == \'offline\'" ng-show="$root.offTicketSize > 0" class="al-sidebar-list-link-old"><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span><br><span style="padding-left: 34px;">{{ ::item.oldTitle }}({{$root.offTicketSize}})</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::!item.subMenu && $root.isMoblie && item.stateRef == \'back\'" ng-show="$root.isOnLine" class="al-sidebar-list-link" ng-click="gotoProject();"><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span></a><a ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-show="$root.isOnLine" ng-if="::!item.subMenu && ($root.isMoblie && item.stateRef != \'back\' && item.stateRef != \'password\' && item.stateRef != \'offline\') && (item.oldTitle == \'\' || item.oldTitle == null)" class="al-sidebar-list-link"><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span></a> <a ui-state="item.stateRef || \'\'" ng-show="!$root.isOnLine" ng-if="::!item.subMenu && ($root.isMoblie && item.stateRef != \'offline\') && item.stateRef != \'password\' && (item.oldTitle == \'\' || item.oldTitle == null)" class="al-sidebar-list-link" ng-href=""><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span></a> <a ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-show="$root.isOnLine" ng-if="::!item.subMenu && ($root.isMoblie && item.stateRef != \'back\' && item.stateRef != \'password\' && item.stateRef != \'offline\') && !(item.oldTitle == \'\' || item.oldTitle == null)" class="al-sidebar-list-link-old"><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span><br><span style="padding-left: 34px;">{{ ::item.oldTitle }}</span></a> <a ui-state="item.stateRef || \'\'" ng-show="!$root.isOnLine" ng-if="::!item.subMenu && ($root.isMoblie && item.stateRef != \'offline\') && item.stateRef != \'password\' && !(item.oldTitle == \'\' || item.oldTitle == null)" class="al-sidebar-list-link-old" ng-href=""><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span><br><span style="padding-left: 34px;">{{ ::item.oldTitle }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside style="top: 60px;" class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::!item.subMenu && !$root.isMoblie && item.stateRef == \'back\'" class="al-sidebar-list-link" ng-click="gotoProject();"><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && !$root.isMoblie && item.stateRef != \'back\' && item.stateRef != \'password\' && (item.oldTitle == \'\' || item.oldTitle == null)" class="al-sidebar-list-link" ng-click="clearTargetId();"><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span></a> <a ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && $root.isMoblie && (item.oldTitle == \'\' || item.oldTitle == null) && item.stateRef != \'password\'" class="al-sidebar-list-link"><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && !$root.isMoblie && item.stateRef != \'back\' && item.stateRef != \'offline\' && !(item.oldTitle == \'\' || item.oldTitle == null) && item.stateRef != \'password\'" class="al-sidebar-list-link-old" ng-click="clearTargetId();"><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span><br><span style="padding-left: 34px;">{{ ::item.oldTitle }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-show="$root.offTicketSize > 0" ng-if="::!item.subMenu && !$root.isMoblie && item.stateRef == \'offline\'" class="al-sidebar-list-link-old" ng-click="clearTargetId();"><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span><br><span style="padding-left: 34px;">{{ ::item.oldTitle }} ({{$root.offTicketSize}})</span></a> <a ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu && $root.isMoblie && !(item.oldTitle == \'\' || item.oldTitle == null) && item.stateRef != \'password\'" class="al-sidebar-list-link-old"><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span><br><span style="padding-left: 34px;">{{ ::item.oldTitle }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="material-icons">{{ ::item.icon }}</i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/commonDialog/ConfirmDialogWithYesNo.html','<div class="modal-content"><div class="modal-header bg-warning"><span ng-if="flg != 3">\u78BA\u8A8D</span> <span ng-if="flg == 3">\u30AA\u30D5\u30E9\u30A4\u30F3\u72B6\u614B\u3067\u3059</span></div><div class="modal-body text-left"><div>{{message}}</div><form style="display:inline-block;" ng-if="flg == 2"><table style="width: 100%;margin-top: 10px;"><tr><td style="min-width: 88px;"><span>\u62C5\u5F53\u6280\u8853\u8005\uFF1A</span></td><td style="min-width: 250px;"><ui-select multiple="" ng-model="userNames.selected" ng-disabled="false" search-enabled="true" append-to-body="false" class="form-control"><ui-select-match placeholder="">{{$item}}</ui-select-match><ui-select-choices repeat="userNames in userNameList | filter: $select.search">{{userNames}}</ui-select-choices></ui-select></td></tr></table></form></div><div class="modal-footer" id="confirm_button"><button type="button" class="btn btn-info" ng-click="doYes();" ng-if="flg != 3">&nbsp;OK&nbsp;</button> <button type="button" class="btn btn-info" ng-click="doYes();" ng-if="flg == 3">\u79FB\u52D5\u3059\u308B</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()" ng-if="flg != 3">\u53D6\u6D88</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()" ng-if="flg == 3">\u30DA\u30FC\u30B8\u306B\u3068\u3069\u307E\u308B</button><form name="sendReportFlag" style="display:inline-block;" ng-if="flg == 1"><label class="custom-checkbox" ng-if="ticket.statusId != \'03\' && isResponser" style="display:relative;margin-left:5px;margin-top:8px;"><input name="reportSend" type="checkbox" value="send" id="reportSend" checked=""> <span>\u901A\u77E5\u30E1\u30FC\u30EB\u306B\u5831\u544A\u66F8\u3092\u6DFB\u4ED8\u3059\u308B</span></label></form><form name="todayFlag" style="display:inline-block;" ng-if="flg == 2"><label class="custom-checkbox" style="display:relative;margin-left:5px;margin-top:8px;"><input name="today" type="checkbox" value="send" id="today" checked=""> <span>\u5F53\u65E5\u306E\u30C1\u30A7\u30C3\u30AF\u3092\u542B\u3080</span></label></form></div></div>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div ng-if="!$root.isMoblie && $root.isProject" class="content-top clearfix" style="margin-left: -15px;"><div ng-if="$root.hasKcmeNews && ($root.isHome || $root.isProject)" style="border: 8px solid #FFF; background: #FFF; margin-bottom: 20px; margin-top: -26px; color: #d45a00; font-weight: bold; border-radius: 5px; box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.25);"><div ng-repeat="item in $root.kcmeNews" style="padding-right: 10px;font-size: 16px;display: -webkit-box;margin: 2px 0px;"><span ng-if="item.type == \'1\'" style="margin-right: 5px;padding: 2px 4px;font-size: 12px; border-radius: 13px; text-align: center; background-color: #ffaf0d;color: #fff;">\u304A\u77E5\u3089\u305B</span> <span ng-if="item.type == \'2\'" style="margin-right: 5px;padding: 2px 4px;font-size: 12px; border-radius: 13px; text-align: center; background-color: #ffaf0d;color: #fff;">\u30EA\u30EA\u30FC\u30B9</span><div ng-bind-html="item.news" style="padding: 2px 0px; max-width: 95%;"></div></div><button type="button" class="close" ng-click="$root.closeKcmeNews()" aria-label="Close" style="color: #d45a00; position: absolute;top: 62px;right: 40px;"><i class="material-icons" style="font-size: 13px;">close</i></button></div></div><div ng-if="!$root.isMoblie && $root.isHome" class="content-top clearfix"><div ng-if="$root.hasKcmeNews && ($root.isHome || $root.isProject)" style="border: 8px solid #FFF; background: #FFF; margin-bottom: 20px; margin-top: -26px; color: #d45a00; font-weight: bold; border-radius: 5px; box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.25);"><div ng-repeat="item in $root.kcmeNews" style="padding-right: 10px;font-size: 16px;display: -webkit-box;margin: 2px 0px;"><span ng-if="item.type == \'1\'" style="margin-right: 5px;padding: 2px 4px;font-size: 12px; border-radius: 13px; text-align: center; background-color: #ffaf0d;color: #fff;">\u304A\u77E5\u3089\u305B</span> <span ng-if="item.type == \'2\'" style="margin-right: 5px;padding: 2px 4px;font-size: 12px; border-radius: 13px; text-align: center; background-color: #ffaf0d;color: #fff;">\u30EA\u30EA\u30FC\u30B9</span><div ng-bind-html="item.news" style="padding: 2px 0px; max-width: 95%;"></div></div><button type="button" class="close" ng-click="$root.closeKcmeNews()" aria-label="Close" style="color: #d45a00; position: absolute;top: 62px;right: 40px;"><i class="material-icons" style="font-size: 13px;">close</i></button></div></div><div ng-if="$root.isMoblie && $root.isProject" class="content-top-sp clearfix" style="margin-left: -15px;"><div ng-if="$root.hasKcmeNews && ($root.isHome || $root.isProject)" style="border: 8px solid #FFF; background: #FFF; margin-top: -15px; color: #d45a00; font-weight: bold; opacity:0.9; border-radius: 5px; box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.25);"><div ng-repeat="item in $root.kcmeNews" style="padding-right: 10px;font-size: 16px;display: -webkit-box;margin: 2px 0px;"><span ng-if="item.type == \'1\'" style="margin-right: 5px;padding: 2px 4px;font-size: 12px; border-radius: 13px; text-align: center; background-color: #ffaf0d;color: #fff;">\u304A\u77E5\u3089\u305B</span> <span ng-if="item.type == \'2\'" style="margin-right: 5px;padding: 2px 4px;font-size: 12px; border-radius: 13px; text-align: center; background-color: #ffaf0d;color: #fff;">\u30EA\u30EA\u30FC\u30B9</span><div ng-bind-html="item.news" style="padding: 2px 0px; max-width: 85%;"></div></div><button type="button" class="close" ng-click="$root.closeKcmeNews()" aria-label="Close" style="color: #d45a00; position: absolute;top: 50px;right: 32px;"><i class="material-icons" style="font-size: 13px;">close</i></button></div></div><div ng-if="$root.isMoblie && $root.isHome" class="content-top-sp clearfix"><div ng-if="$root.hasKcmeNews && ($root.isHome || $root.isProject)" style="border: 8px solid #FFF; background: #FFF; margin-top: -15px; color: #d45a00; font-weight: bold; opacity:0.9; border-radius: 5px; box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.25);"><div ng-repeat="item in $root.kcmeNews" style="padding-right: 10px;font-size: 16px;display: -webkit-box;margin: 2px 0px;"><span ng-if="item.type == \'1\'" style="margin-right: 5px;padding: 2px 4px;font-size: 12px; border-radius: 13px; text-align: center; background-color: #ffaf0d;color: #fff;">\u304A\u77E5\u3089\u305B</span> <span ng-if="item.type == \'2\'" style="margin-right: 5px;padding: 2px 4px;font-size: 12px; border-radius: 13px; text-align: center; background-color: #ffaf0d;color: #fff;">\u30EA\u30EA\u30FC\u30B9</span><div ng-bind-html="item.news" style="padding: 2px 0px; max-width: 85%;"></div></div><button type="button" class="close" ng-click="$root.closeKcmeNews()" aria-label="Close" style="color: #d45a00; position: absolute;top: 50px;right: 32px;"><i class="material-icons" style="font-size: 13px;">close</i></button></div></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown="" is-open="isOpenComment"><a href="javascript:;" ng-click="getCommentList();" uib-dropdown-toggle=""><i class="material-icons">notifications_none</i> <span ng-if="unConfirmNum != 0 && unConfirmNum <= 99">{{unConfirmNum}}</span><span ng-if="unConfirmNum != 0 && unConfirmNum > 99">...</span><div class="notification-ring" ng-if="unConfirmNum != 0"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu" style="max-height: 700px;overflow: scroll;"><i class="dropdown-arr"></i><div class="header clearfix"><strong>\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u306E\u6700\u8FD1\u30B3\u30E1\u30F3\u30C8</strong></div><div class="msg-list" ng-if="commentList.length == 0"><div class="msg-area"><div style="padding-left: 11px;">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u306E\u6700\u8FD1\u30B3\u30E1\u30F3\u30C8\u304C\u3042\u308A\u307E\u305B\u3093\u3002</div><span></span></div></div><div class="msg-list" ng-if="commentList.length != 0"><a href="javascript:;" ng-click="showComment(msg);" class="clearfix" ng-repeat="msg in commentList"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (msg.userFileId | profilePicture) )}}"></div><div class="msg-area"><strong>{{ msg.userName }}</strong> <strong style="font-weight: initial;float: right;">{{$root.padLeft(msg.ticketId, 8)}}</strong><div ng-bind-html="msg.comment"></div><strong style="font-weight: initial;float: left;">{{ $root. changeTimestampToStr( msg.createTime ) }}</strong> <strong style="font-weight: initial;float: right; font-style: italic;">{{ $root. fromNow( msg.createTime ) }}</strong></div></a></div><div class="header clearfix"><strong>\u672A\u78BA\u8A8D\u304A\u77E5\u3089\u305B</strong></div><div class="msg-list" ng-if="newsList.length == 0"><div class="msg-area"><div style="padding-left: 11px;">\u672A\u78BA\u8A8D\u304A\u77E5\u3089\u305B\u304C\u3042\u308A\u307E\u305B\u3093\u3002</div><span></span></div></div><div class="msg-list" ng-if="newsList.length != 0"><a href="javascript:;" ng-click="showNews(msg);" class="clearfix" ng-repeat="msg in newsList"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (msg.userFileId | profilePicture) )}}"></div><div class="msg-area"><strong>{{ msg.userName }}</strong> <strong style="font-weight: initial;float: right;"></strong><div ng-bind-html="msg.title"></div><strong style="font-weight: initial;float: left;">{{ $root. changeTimestampToStr( msg.createTime ) }}</strong> <strong style="font-weight: initial;float: right; font-style: italic;">{{ $root. fromNow( msg.createTime ) }}</strong></div></a></div><div class="header clearfix"><strong>\u672A\u78BA\u8A8D\u5171\u6709\u30C7\u30FC\u30BF</strong></div><div class="msg-list" ng-if="unConfirmNumDocument == 0"><div class="msg-area"><div style="padding-left: 11px;">\u672A\u78BA\u8A8D\u5171\u6709\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093\u3002</div><span></span></div></div><div class="msg-list" ng-if="unConfirmNumDocument != 0"><a href="javascript:;" ng-click="showDocument();" class="clearfix"><div class="msg-area"><div style="padding-left: 11px;">\u672A\u78BA\u8A8D\u306E\u5171\u6709\u30C7\u30FC\u30BF{{unConfirmNumDocument}}\u4EF6\u304C\u3042\u308A\u307E\u3059\u3002</div><span></span></div></a></div></div></li></ul>');
$templateCache.put('app/theme/components/msgCenter/msgCenterSp.html','<ul class="al-msg-center-sp clearfix"><li uib-dropdown="" is-open="isOpenComment"><a href="javascript:;" ng-click="getCommentList();" uib-dropdown-toggle=""><i class="material-icons">notifications_none</i><span ng-if="unConfirmNum != 0 && unConfirmNum <= 99">{{unConfirmNum}}</span><span ng-if="unConfirmNum != 0 && unConfirmNum > 99">...</span><div class="notification-ring" ng-if="unConfirmNum != 0"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu-sp" style="max-height: 500px;overflow: scroll;"><i class="dropdown-arr"></i><div class="header clearfix"><strong>\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u306E\u6700\u8FD1\u30B3\u30E1\u30F3\u30C8</strong></div><div class="msg-list" ng-if="commentList.length == 0"><div class="msg-area"><div style="padding-left: 11px;">\u30C1\u30A7\u30C3\u30AF\u30B7\u30FC\u30C8\u306E\u6700\u8FD1\u30B3\u30E1\u30F3\u30C8\u304C\u3042\u308A\u307E\u305B\u3093\u3002</div><span></span></div></div><div class="msg-list" ng-if="commentList.length != 0"><a href="javascript:;" ng-click="showComment(msg);" class="clearfix" ng-repeat="msg in commentList"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (msg.userFileId | profilePicture) )}}"></div><div class="msg-area"><strong>{{ msg.userName }}</strong> <strong style="font-weight: initial;float: right;">{{$root.padLeft(msg.ticketId, 8)}}</strong><div ng-bind-html="msg.comment"></div><strong style="font-weight: initial;float: left;">{{ $root. changeTimestampToStr( msg.createTime ) }}</strong> <strong style="font-weight: initial;float: right; font-style: italic;">{{ $root. fromNow( msg.createTime ) }}</strong></div></a></div><div class="header clearfix"><strong>\u672A\u78BA\u8A8D\u304A\u77E5\u3089\u305B</strong></div><div class="msg-list" ng-if="newsList.length == 0"><div class="msg-area"><div style="padding-left: 11px;">\u672A\u78BA\u8A8D\u304A\u77E5\u3089\u305B\u304C\u3042\u308A\u307E\u305B\u3093\u3002</div><span></span></div></div><div class="msg-list" ng-if="newsList.length != 0"><a href="javascript:;" ng-click="showNews(msg);" class="clearfix" ng-repeat="msg in newsList"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (msg.userFileId | profilePicture) )}}"></div><div class="msg-area"><strong>{{ msg.userName }}</strong> <strong style="font-weight: initial;float: right;"></strong><div ng-bind-html="msg.title"></div><strong style="font-weight: initial;float: left;">{{ $root. changeTimestampToStr( msg.createTime ) }}</strong> <strong style="font-weight: initial;float: right; font-style: italic;">{{ $root. fromNow( msg.createTime ) }}</strong></div></a></div><div class="header clearfix"><strong>\u672A\u78BA\u8A8D\u5171\u6709\u30C7\u30FC\u30BF</strong></div><div class="msg-list" ng-if="unConfirmNumDocument == 0"><div class="msg-area"><div style="padding-left: 11px;">\u672A\u78BA\u8A8D\u5171\u6709\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093\u3002</div><span></span></div></div><div class="msg-list" ng-if="unConfirmNumDocument != 0"><a href="javascript:;" ng-click="showDocument();" class="clearfix"><div style="padding-left: 11px;">\u672A\u78BA\u8A8D\u306E\u5171\u6709\u30C7\u30FC\u30BF{{unConfirmNumDocument}}\u4EF6\u304C\u3042\u308A\u307E\u3059\u3002</div><span></span></a></div></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div ng-if="!$root.isMoblie" class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}" style="height: 60px;"><a href="" ng-if="$root.projectId != \'\'" class="collapse-menu-link" ba-sidebar-toggle-menu=""><i class="material-icons">menu</i></a> <a ng-if="$root.projectId != \'\'" href="#/home" class="al-logo clearfix"><img ng-src="assets/img/work_style_logo1.png" alt="SmartBee" style="width: 180px;"></a> <img ng-if="$root.projectId == \'\'" ng-src="assets/img/work_style_logo1.png" alt="SmartBee" style="width: 180px; padding-top: 8px;"><div ng-if="$root.projectId != \'\' && $root.headerImg == \'\'" style="color: #ffffff; position: absolute; right: 150px; top: 15px; text-align: right;">\u696D\u52D9\u540D\uFF1A<span>{{$root.projectName}}</span><br>\u3088\u3046\u3053\u305D\u3001<span id="loginUserN">{{userName}}</span>\u3055\u3093</div><div ng-if="$root.projectId == \'\' && $root.headerImg == \'\'" style="color: #ffffff; position: absolute; right: 150px; top: 23px;">\u3088\u3046\u3053\u305D\u3001<span id="loginUserN">{{userName}}</span>\u3055\u3093</div><div ng-if="$root.projectId != \'\' && $root.headerImg != \'\'" style="color: #ffffff; position: absolute; right: 300px; top: 15px; text-align: right;">\u696D\u52D9\u540D\uFF1A<span>{{$root.projectName}}</span><br>\u3088\u3046\u3053\u305D\u3001<span id="loginUserN">{{userName}}</span>\u3055\u3093</div><div ng-if="$root.projectId == \'\' && $root.headerImg != \'\'" style="color: #ffffff; position: absolute; right: 300px; top: 23px;">\u3088\u3046\u3053\u305D\u3001<span id="loginUserN">{{userName}}</span>\u3055\u3093</div><div class="user-profile clearfix" ng-if="$root.headerImg == \'\'"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{$root.loginUserImg}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li ng-if="$root.projectId != \'\'"><a href="#/password"><i class="material-icons">account_circle</i>\u30A2\u30AB\u30A6\u30F3\u30C8</a></li><li><a href="" class="signout" ng-click="logOut()"><i class="material-icons">power_settings_new</i>Sign out</a></li></ul></div><msg-center ng-if="$root.projectId != \'\'"></msg-center></div><div class="user-profile clearfix" ng-if="$root.headerImg != \'\'" style="margin-right: 160px;"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{$root.loginUserImg}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li ng-if="$root.projectId != \'\'"><a href="#/password"><i class="material-icons">account_circle</i>\u30A2\u30AB\u30A6\u30F3\u30C8</a></li><li><a href="" class="signout" ng-click="logOut()"><i class="material-icons">power_settings_new</i>Sign out</a></li></ul></div><msg-center ng-if="$root.projectId != \'\'"></msg-center></div><img ng-if="$root.headerImg != \'\'" ng-src="{{$root.headerImg}}" alt="SmartBee" style="width: 180px; padding-top: 8px; position: absolute; right: 1px;"></div><div ng-if="$root.isMoblie" class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}" style="height: 50px;"><a href="" ng-if="$root.projectId != \'\'" class="collapse-menu-link" ba-sidebar-toggle-menu="" style="line-height: 30px;"><i class="material-icons">menu</i></a><div><msg-center ng-if="$root.projectId != \'\'"></msg-center><div ng-if="$root.projectId != \'\'" class="user-profile clearfix" style="margin-top: 3px; margin-right: -110px;"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{$root.loginUserImg}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li ng-if="$root.projectId != \'\'"><a href="#/password"><i class="material-icons">account_circle</i>\u30A2\u30AB\u30A6\u30F3\u30C8</a></li><li><a href="" class="signout" ng-click="logOut()"><i class="material-icons">power_settings_new</i>Sign out</a></li></ul></div></div><div ng-if="$root.projectId == \'\'" class="user-profile clearfix" style="margin-top: 3px;"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><img ng-src="{{$root.loginUserImg}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="" class="signout" ng-click="logOut()"><i class="material-icons">power_settings_new</i>Sign out</a></li></ul></div></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="80" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');}]);